// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Variables
   ========================================================================== */
/* Bootstrap Variables
   ========================================================================== */
/* Variables
   ========================================================================== */
/* Bootstrap Core
   ========================================================================== */
/*! normalize.css v3.0.1 | MIT License | git.io/normalize */
/* @import url(../../bower_components/select2/select2.css);
@import url(../../bower_components/spectrum/spectrum.css);
@import url(../../bower_components/seiyria-bootstrap-slider/dist/css/bootstrap-slider.css); */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%; }

body {
  margin: 0; }

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block; }

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline; }

audio:not([controls]) {
  display: none;
  height: 0; }

[hidden],
template {
  display: none; }

a {
  background: transparent; }

a:active,
a:hover {
  outline: 0; }

abbr[title] {
  border-bottom: 1px dotted; }

b,
strong {
  font-weight: bold; }

dfn {
  font-style: italic; }

h1 {
  font-size: 2em;
  margin: 0.67em 0; }

mark {
  background: #ff0;
  color: #000; }

small {
  font-size: 80%; }

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sup {
  top: -0.5em; }

sub {
  bottom: -0.25em; }

img {
  border: 0; }

svg:not(:root) {
  overflow: hidden; }

figure {
  margin: 1em 40px; }

hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0; }

pre {
  overflow: auto; }

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em; }

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0; }

button {
  overflow: visible; }

button,
select {
  text-transform: none; }

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer; }

button[disabled],
html input[disabled] {
  cursor: default; }

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0; }

input {
  line-height: normal; }

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0; }

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto; }

input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box; }

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }

legend {
  border: 0;
  padding: 0; }

textarea {
  overflow: auto; }

optgroup {
  font-weight: bold; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

td,
th {
  padding: 0; }

@media print {
  * {
    text-shadow: none !important;
    color: #000 !important;
    background: transparent !important;
    box-shadow: none !important; }
  a,
  a:visited {
    text-decoration: underline; }
  a[href]:after {
    content: " (" attr(href) ")"; }
  abbr[title]:after {
    content: " (" attr(title) ")"; }
  a[href^="javascript:"]:after,
  a[href^="#"]:after {
    content: ""; }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid; }
  thead {
    display: table-header-group; }
  tr,
  img {
    page-break-inside: avoid; }
  img {
    max-width: 100% !important; }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }
  h2,
  h3 {
    page-break-after: avoid; }
  select {
    background: #fff !important; }
  .navbar {
    display: none; }
  .table td, .table-2 td,
  .table th, .table-2 th {
    background-color: #fff !important; }
  .btn > .caret, .icon-nav label > .caret,
  .dropup > .btn > .caret, .icon-nav
  .dropup > label > .caret {
    border-top-color: #000 !important; }
  .label {
    border: 1px solid #000; }
  .table, .table-2 {
    border-collapse: collapse !important; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important; } }

@font-face {
  font-family: 'Glyphicons Halflings';
  src: url("../fonts/glyphicons-halflings-regular.eot");
  src: url("../fonts/glyphicons-halflings-regular.eot?#iefix") format("embedded-opentype"), url("../fonts/glyphicons-halflings-regular.woff") format("woff"), url("../fonts/glyphicons-halflings-regular.ttf") format("truetype"), url("../fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular") format("svg"); }

.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.glyphicon-asterisk:before {
  content: "\\2a"; }

.glyphicon-plus:before {
  content: "\\2b"; }

.glyphicon-euro:before {
  content: "\\20ac"; }

.glyphicon-minus:before {
  content: "\\2212"; }

.glyphicon-cloud:before {
  content: "\\2601"; }

.glyphicon-envelope:before {
  content: "\\2709"; }

.glyphicon-pencil:before {
  content: "\\270f"; }

.glyphicon-glass:before {
  content: "\\e001"; }

.glyphicon-music:before {
  content: "\\e002"; }

.glyphicon-search:before {
  content: "\\e003"; }

.glyphicon-heart:before {
  content: "\\e005"; }

.glyphicon-star:before {
  content: "\\e006"; }

.glyphicon-star-empty:before {
  content: "\\e007"; }

.glyphicon-user:before {
  content: "\\e008"; }

.glyphicon-film:before {
  content: "\\e009"; }

.glyphicon-th-large:before {
  content: "\\e010"; }

.glyphicon-th:before {
  content: "\\e011"; }

.glyphicon-th-list:before {
  content: "\\e012"; }

.glyphicon-ok:before {
  content: "\\e013"; }

.glyphicon-remove:before {
  content: "\\e014"; }

.glyphicon-zoom-in:before {
  content: "\\e015"; }

.glyphicon-zoom-out:before {
  content: "\\e016"; }

.glyphicon-off:before {
  content: "\\e017"; }

.glyphicon-signal:before {
  content: "\\e018"; }

.glyphicon-cog:before {
  content: "\\e019"; }

.glyphicon-trash:before {
  content: "\\e020"; }

.glyphicon-home:before {
  content: "\\e021"; }

.glyphicon-file:before {
  content: "\\e022"; }

.glyphicon-time:before {
  content: "\\e023"; }

.glyphicon-road:before {
  content: "\\e024"; }

.glyphicon-download-alt:before {
  content: "\\e025"; }

.glyphicon-download:before {
  content: "\\e026"; }

.glyphicon-upload:before {
  content: "\\e027"; }

.glyphicon-inbox:before {
  content: "\\e028"; }

.glyphicon-play-circle:before {
  content: "\\e029"; }

.glyphicon-repeat:before {
  content: "\\e030"; }

.glyphicon-refresh:before {
  content: "\\e031"; }

.glyphicon-list-alt:before {
  content: "\\e032"; }

.glyphicon-lock:before {
  content: "\\e033"; }

.glyphicon-flag:before {
  content: "\\e034"; }

.glyphicon-headphones:before {
  content: "\\e035"; }

.glyphicon-volume-off:before {
  content: "\\e036"; }

.glyphicon-volume-down:before {
  content: "\\e037"; }

.glyphicon-volume-up:before {
  content: "\\e038"; }

.glyphicon-qrcode:before {
  content: "\\e039"; }

.glyphicon-barcode:before {
  content: "\\e040"; }

.glyphicon-tag:before {
  content: "\\e041"; }

.glyphicon-tags:before {
  content: "\\e042"; }

.glyphicon-book:before {
  content: "\\e043"; }

.glyphicon-bookmark:before {
  content: "\\e044"; }

.glyphicon-print:before {
  content: "\\e045"; }

.glyphicon-camera:before {
  content: "\\e046"; }

.glyphicon-font:before {
  content: "\\e047"; }

.glyphicon-bold:before {
  content: "\\e048"; }

.glyphicon-italic:before {
  content: "\\e049"; }

.glyphicon-text-height:before {
  content: "\\e050"; }

.glyphicon-text-width:before {
  content: "\\e051"; }

.glyphicon-align-left:before {
  content: "\\e052"; }

.glyphicon-align-center:before {
  content: "\\e053"; }

.glyphicon-align-right:before {
  content: "\\e054"; }

.glyphicon-align-justify:before {
  content: "\\e055"; }

.glyphicon-list:before {
  content: "\\e056"; }

.glyphicon-indent-left:before {
  content: "\\e057"; }

.glyphicon-indent-right:before {
  content: "\\e058"; }

.glyphicon-facetime-video:before {
  content: "\\e059"; }

.glyphicon-picture:before {
  content: "\\e060"; }

.glyphicon-map-marker:before {
  content: "\\e062"; }

.glyphicon-adjust:before {
  content: "\\e063"; }

.glyphicon-tint:before {
  content: "\\e064"; }

.glyphicon-edit:before {
  content: "\\e065"; }

.glyphicon-share:before {
  content: "\\e066"; }

.glyphicon-check:before {
  content: "\\e067"; }

.glyphicon-move:before {
  content: "\\e068"; }

.glyphicon-step-backward:before {
  content: "\\e069"; }

.glyphicon-fast-backward:before {
  content: "\\e070"; }

.glyphicon-backward:before {
  content: "\\e071"; }

.glyphicon-play:before {
  content: "\\e072"; }

.glyphicon-pause:before {
  content: "\\e073"; }

.glyphicon-stop:before {
  content: "\\e074"; }

.glyphicon-forward:before {
  content: "\\e075"; }

.glyphicon-fast-forward:before {
  content: "\\e076"; }

.glyphicon-step-forward:before {
  content: "\\e077"; }

.glyphicon-eject:before {
  content: "\\e078"; }

.glyphicon-chevron-left:before {
  content: "\\e079"; }

.glyphicon-chevron-right:before {
  content: "\\e080"; }

.glyphicon-plus-sign:before {
  content: "\\e081"; }

.glyphicon-minus-sign:before {
  content: "\\e082"; }

.glyphicon-remove-sign:before {
  content: "\\e083"; }

.glyphicon-ok-sign:before {
  content: "\\e084"; }

.glyphicon-question-sign:before {
  content: "\\e085"; }

.glyphicon-info-sign:before {
  content: "\\e086"; }

.glyphicon-screenshot:before {
  content: "\\e087"; }

.glyphicon-remove-circle:before {
  content: "\\e088"; }

.glyphicon-ok-circle:before {
  content: "\\e089"; }

.glyphicon-ban-circle:before {
  content: "\\e090"; }

.glyphicon-arrow-left:before {
  content: "\\e091"; }

.glyphicon-arrow-right:before {
  content: "\\e092"; }

.glyphicon-arrow-up:before {
  content: "\\e093"; }

.glyphicon-arrow-down:before {
  content: "\\e094"; }

.glyphicon-share-alt:before {
  content: "\\e095"; }

.glyphicon-resize-full:before {
  content: "\\e096"; }

.glyphicon-resize-small:before {
  content: "\\e097"; }

.glyphicon-exclamation-sign:before {
  content: "\\e101"; }

.glyphicon-gift:before {
  content: "\\e102"; }

.glyphicon-leaf:before {
  content: "\\e103"; }

.glyphicon-fire:before {
  content: "\\e104"; }

.glyphicon-eye-open:before {
  content: "\\e105"; }

.glyphicon-eye-close:before {
  content: "\\e106"; }

.glyphicon-warning-sign:before {
  content: "\\e107"; }

.glyphicon-plane:before {
  content: "\\e108"; }

.glyphicon-calendar:before {
  content: "\\e109"; }

.glyphicon-random:before {
  content: "\\e110"; }

.glyphicon-comment:before {
  content: "\\e111"; }

.glyphicon-magnet:before {
  content: "\\e112"; }

.glyphicon-chevron-up:before {
  content: "\\e113"; }

.glyphicon-chevron-down:before {
  content: "\\e114"; }

.glyphicon-retweet:before {
  content: "\\e115"; }

.glyphicon-shopping-cart:before {
  content: "\\e116"; }

.glyphicon-folder-close:before {
  content: "\\e117"; }

.glyphicon-folder-open:before {
  content: "\\e118"; }

.glyphicon-resize-vertical:before {
  content: "\\e119"; }

.glyphicon-resize-horizontal:before {
  content: "\\e120"; }

.glyphicon-hdd:before {
  content: "\\e121"; }

.glyphicon-bullhorn:before {
  content: "\\e122"; }

.glyphicon-bell:before {
  content: "\\e123"; }

.glyphicon-certificate:before {
  content: "\\e124"; }

.glyphicon-thumbs-up:before {
  content: "\\e125"; }

.glyphicon-thumbs-down:before {
  content: "\\e126"; }

.glyphicon-hand-right:before {
  content: "\\e127"; }

.glyphicon-hand-left:before {
  content: "\\e128"; }

.glyphicon-hand-up:before {
  content: "\\e129"; }

.glyphicon-hand-down:before {
  content: "\\e130"; }

.glyphicon-circle-arrow-right:before {
  content: "\\e131"; }

.glyphicon-circle-arrow-left:before {
  content: "\\e132"; }

.glyphicon-circle-arrow-up:before {
  content: "\\e133"; }

.glyphicon-circle-arrow-down:before {
  content: "\\e134"; }

.glyphicon-globe:before {
  content: "\\e135"; }

.glyphicon-wrench:before {
  content: "\\e136"; }

.glyphicon-tasks:before {
  content: "\\e137"; }

.glyphicon-filter:before {
  content: "\\e138"; }

.glyphicon-briefcase:before {
  content: "\\e139"; }

.glyphicon-fullscreen:before {
  content: "\\e140"; }

.glyphicon-dashboard:before {
  content: "\\e141"; }

.glyphicon-paperclip:before {
  content: "\\e142"; }

.glyphicon-heart-empty:before {
  content: "\\e143"; }

.glyphicon-link:before {
  content: "\\e144"; }

.glyphicon-phone:before {
  content: "\\e145"; }

.glyphicon-pushpin:before {
  content: "\\e146"; }

.glyphicon-usd:before {
  content: "\\e148"; }

.glyphicon-gbp:before {
  content: "\\e149"; }

.glyphicon-sort:before {
  content: "\\e150"; }

.glyphicon-sort-by-alphabet:before {
  content: "\\e151"; }

.glyphicon-sort-by-alphabet-alt:before {
  content: "\\e152"; }

.glyphicon-sort-by-order:before {
  content: "\\e153"; }

.glyphicon-sort-by-order-alt:before {
  content: "\\e154"; }

.glyphicon-sort-by-attributes:before {
  content: "\\e155"; }

.glyphicon-sort-by-attributes-alt:before {
  content: "\\e156"; }

.glyphicon-unchecked:before {
  content: "\\e157"; }

.glyphicon-expand:before {
  content: "\\e158"; }

.glyphicon-collapse-down:before {
  content: "\\e159"; }

.glyphicon-collapse-up:before {
  content: "\\e160"; }

.glyphicon-log-in:before {
  content: "\\e161"; }

.glyphicon-flash:before {
  content: "\\e162"; }

.glyphicon-log-out:before {
  content: "\\e163"; }

.glyphicon-new-window:before {
  content: "\\e164"; }

.glyphicon-record:before {
  content: "\\e165"; }

.glyphicon-save:before {
  content: "\\e166"; }

.glyphicon-open:before {
  content: "\\e167"; }

.glyphicon-saved:before {
  content: "\\e168"; }

.glyphicon-import:before {
  content: "\\e169"; }

.glyphicon-export:before {
  content: "\\e170"; }

.glyphicon-send:before {
  content: "\\e171"; }

.glyphicon-floppy-disk:before {
  content: "\\e172"; }

.glyphicon-floppy-saved:before {
  content: "\\e173"; }

.glyphicon-floppy-remove:before {
  content: "\\e174"; }

.glyphicon-floppy-save:before {
  content: "\\e175"; }

.glyphicon-floppy-open:before {
  content: "\\e176"; }

.glyphicon-credit-card:before {
  content: "\\e177"; }

.glyphicon-transfer:before {
  content: "\\e178"; }

.glyphicon-cutlery:before {
  content: "\\e179"; }

.glyphicon-header:before {
  content: "\\e180"; }

.glyphicon-compressed:before {
  content: "\\e181"; }

.glyphicon-earphone:before {
  content: "\\e182"; }

.glyphicon-phone-alt:before {
  content: "\\e183"; }

.glyphicon-tower:before {
  content: "\\e184"; }

.glyphicon-stats:before {
  content: "\\e185"; }

.glyphicon-sd-video:before {
  content: "\\e186"; }

.glyphicon-hd-video:before {
  content: "\\e187"; }

.glyphicon-subtitles:before {
  content: "\\e188"; }

.glyphicon-sound-stereo:before {
  content: "\\e189"; }

.glyphicon-sound-dolby:before {
  content: "\\e190"; }

.glyphicon-sound-5-1:before {
  content: "\\e191"; }

.glyphicon-sound-6-1:before {
  content: "\\e192"; }

.glyphicon-sound-7-1:before {
  content: "\\e193"; }

.glyphicon-copyright-mark:before {
  content: "\\e194"; }

.glyphicon-registration-mark:before {
  content: "\\e195"; }

.glyphicon-cloud-download:before {
  content: "\\e197"; }

.glyphicon-cloud-upload:before {
  content: "\\e198"; }

.glyphicon-tree-conifer:before {
  content: "\\e199"; }

.glyphicon-tree-deciduous:before {
  content: "\\e200"; }

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box; }

*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box; }

html {
  font-size: 10px;
  -webkit-tap-highlight-color: transparent; }

body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857;
  color: #020621;
  background-color: #F7F7F9; }

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

a {
  color: #0081BA;
  text-decoration: none; }
  a:hover, a:focus {
    color: #005e87;
    text-decoration: underline; }
  a:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px; }

figure {
  margin: 0; }

img {
  vertical-align: middle; }

.img-responsive {
  display: block;
  width: 100% \\9;
  max-width: 100%;
  height: auto; }

.img-rounded {
  border-radius: 6px; }

.img-thumbnail {
  padding: 0;
  line-height: 1.42857;
  background-color: #F7F7F9;
  border: 1px solid #ddd;
  border-radius: 0;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  display: inline-block;
  width: 100% \\9;
  max-width: 100%;
  height: auto; }

.img-circle {
  border-radius: 50%; }

hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #e6e6e6; }

.sr-only, .file-picker input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit; }
  h1 small,
  h1 .small, h2 small,
  h2 .small, h3 small,
  h3 .small, h4 small,
  h4 .small, h5 small,
  h5 .small, h6 small,
  h6 .small,
  .h1 small,
  .h1 .small, .h2 small,
  .h2 .small, .h3 small,
  .h3 .small, .h4 small,
  .h4 .small, .h5 small,
  .h5 .small, .h6 small,
  .h6 .small {
    font-weight: normal;
    line-height: 1;
    color: #777777; }

h1, .h1,
h2, .h2,
h3, .h3 {
  margin-top: 20px;
  margin-bottom: 10px; }
  h1 small,
  h1 .small, .h1 small,
  .h1 .small,
  h2 small,
  h2 .small, .h2 small,
  .h2 .small,
  h3 small,
  h3 .small, .h3 small,
  .h3 .small {
    font-size: 65%; }

h4, .h4,
h5, .h5,
h6, .h6 {
  margin-top: 10px;
  margin-bottom: 10px; }
  h4 small,
  h4 .small, .h4 small,
  .h4 .small,
  h5 small,
  h5 .small, .h5 small,
  .h5 .small,
  h6 small,
  h6 .small, .h6 small,
  .h6 .small {
    font-size: 75%; }

h1, .h1 {
  font-size: 33px; }

h2, .h2 {
  font-size: 29px; }

h3, .h3 {
  font-size: 22px; }

h4, .h4 {
  font-size: 16px; }

h5, .h5 {
  font-size: 14px; }

h6, .h6 {
  font-size: 12px; }

p {
  margin: 0 0 10px; }

.lead, .post h2 + p {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4; }
  @media (min-width: 768px) {
    .lead, .post h2 + p {
      font-size: 21px; } }

small,
.small {
  font-size: 85%; }

cite {
  font-style: normal; }

mark,
.mark {
  background-color: #fcf8e3;
  padding: .2em; }

.text-left {
  text-align: left; }

.text-right {
  text-align: right; }

.text-center {
  text-align: center; }

.text-justify {
  text-align: justify; }

.text-nowrap {
  white-space: nowrap; }

.text-lowercase {
  text-transform: lowercase; }

.text-uppercase {
  text-transform: uppercase; }

.text-capitalize {
  text-transform: capitalize; }

.text-muted {
  color: #777777; }

.text-primary {
  color: #0081BA; }

a.text-primary:hover {
  color: #005e87; }

.text-success {
  color: #4ab767; }

a.text-success:hover {
  color: #3b9352; }

.text-info {
  color: #31708f; }

a.text-info:hover {
  color: #245269; }

.text-warning {
  color: #8a6d3b; }

a.text-warning:hover {
  color: #66512c; }

.text-danger {
  color: #c0392b; }

a.text-danger:hover {
  color: #962d22; }

.bg-primary {
  color: #fff; }

.bg-primary {
  background-color: #0081BA; }

a.bg-primary:hover {
  background-color: #005e87; }

.bg-success {
  background-color: #dff0d8; }

a.bg-success:hover {
  background-color: #c1e2b3; }

.bg-info {
  background-color: #d9edf7; }

a.bg-info:hover {
  background-color: #afd9ee; }

.bg-warning {
  background-color: #fcf8e3; }

a.bg-warning:hover {
  background-color: #f7ecb5; }

.bg-danger, .entries p:first-child {
  background-color: #f2dede; }

a.bg-danger:hover {
  background-color: #e4b9b9; }

.page-header {
  padding-bottom: 9px;
  margin: 40px 0 20px;
  border-bottom: 1px solid #d5d5d5; }

ul,
ol {
  margin-top: 0;
  margin-bottom: 10px; }
  ul ul,
  ul ol,
  ol ul,
  ol ol {
    margin-bottom: 0; }

.list-unstyled, .list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline {
  margin-left: -5px; }
  .list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px; }

dl {
  margin-top: 0;
  margin-bottom: 20px; }

dt,
dd {
  line-height: 1.42857; }

dt {
  font-weight: bold; }

dd {
  margin-left: 0; }

.dl-horizontal dd:before, .dl-horizontal dd:after {
  content: " ";
  display: table; }

.dl-horizontal dd:after {
  clear: both; }

@media (min-width: 768px) {
  .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .dl-horizontal dd {
    margin-left: 180px; } }

abbr[title],
abbr[data-original-title] {
  cursor: help;
  border-bottom: 1px dotted #777777; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  font-size: 17.5px;
  border-left: 5px solid #d5d5d5; }
  blockquote p:last-child,
  blockquote ul:last-child,
  blockquote ol:last-child {
    margin-bottom: 0; }
  blockquote footer,
  blockquote small,
  blockquote .small {
    display: block;
    font-size: 80%;
    line-height: 1.42857;
    color: #777777; }
    blockquote footer:before,
    blockquote small:before,
    blockquote .small:before {
      content: '\\2014 \\00A0'; }

.blockquote-reverse,
blockquote.pull-right {
  padding-right: 15px;
  padding-left: 0;
  border-right: 5px solid #d5d5d5;
  border-left: 0;
  text-align: right; }
  .blockquote-reverse footer:before,
  .blockquote-reverse small:before,
  .blockquote-reverse .small:before,
  blockquote.pull-right footer:before,
  blockquote.pull-right small:before,
  blockquote.pull-right .small:before {
    content: ''; }
  .blockquote-reverse footer:after,
  .blockquote-reverse small:after,
  .blockquote-reverse .small:after,
  blockquote.pull-right footer:after,
  blockquote.pull-right small:after,
  blockquote.pull-right .small:after {
    content: '\\00A0 \\2014'; }

blockquote:before,
blockquote:after {
  content: ""; }

address {
  margin-bottom: 20px;
  font-style: normal;
  line-height: 1.42857; }

code,
kbd,
pre,
samp {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace; }

code {
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 4px; }

kbd {
  padding: 2px 4px;
  font-size: 90%;
  color: #fff;
  background-color: #333;
  border-radius: 2px;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25); }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    box-shadow: none; }

pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857;
  word-break: break-all;
  word-wrap: break-word;
  color: #020621;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px; }
  pre code {
    padding: 0;
    font-size: inherit;
    color: inherit;
    white-space: pre-wrap;
    background-color: transparent;
    border-radius: 0; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 7.5px;
  padding-right: 7.5px; }
  .container:before, .container:after {
    content: " ";
    display: table; }
  .container:after {
    clear: both; }
  @media (min-width: 768px) {
    .container {
      width: 735px; } }
  @media (min-width: 992px) {
    .container {
      width: 955px; } }
  @media (min-width: 1200px) {
    .container {
      width: 1155px; } }

.container-fluid {
  margin-right: auto;
  margin-left: auto;
  padding-left: 7.5px;
  padding-right: 7.5px; }
  .container-fluid:before, .container-fluid:after {
    content: " ";
    display: table; }
  .container-fluid:after {
    clear: both; }

.row, .support-app .ticket-list-table .title-row, .support-app .ticket-list-table .ticket {
  margin-left: -7.5px;
  margin-right: -7.5px; }
  .row:before, .support-app .ticket-list-table .title-row:before, .support-app .ticket-list-table .ticket:before, .row:after, .support-app .ticket-list-table .title-row:after, .support-app .ticket-list-table .ticket:after {
    content: " ";
    display: table; }
  .row:after, .support-app .ticket-list-table .title-row:after, .support-app .ticket-list-table .ticket:after {
    clear: both; }

.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 7.5px;
  padding-right: 7.5px; }

.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
  float: left; }

.col-xs-1 {
  width: 8.33333%; }

.col-xs-2 {
  width: 16.66667%; }

.col-xs-3 {
  width: 25%; }

.col-xs-4 {
  width: 33.33333%; }

.col-xs-5 {
  width: 41.66667%; }

.col-xs-6 {
  width: 50%; }

.col-xs-7 {
  width: 58.33333%; }

.col-xs-8 {
  width: 66.66667%; }

.col-xs-9 {
  width: 75%; }

.col-xs-10 {
  width: 83.33333%; }

.col-xs-11 {
  width: 91.66667%; }

.col-xs-12 {
  width: 100%; }

.col-xs-pull-0 {
  right: auto; }

.col-xs-pull-1 {
  right: 8.33333%; }

.col-xs-pull-2 {
  right: 16.66667%; }

.col-xs-pull-3 {
  right: 25%; }

.col-xs-pull-4 {
  right: 33.33333%; }

.col-xs-pull-5 {
  right: 41.66667%; }

.col-xs-pull-6 {
  right: 50%; }

.col-xs-pull-7 {
  right: 58.33333%; }

.col-xs-pull-8 {
  right: 66.66667%; }

.col-xs-pull-9 {
  right: 75%; }

.col-xs-pull-10 {
  right: 83.33333%; }

.col-xs-pull-11 {
  right: 91.66667%; }

.col-xs-pull-12 {
  right: 100%; }

.col-xs-push-0 {
  left: auto; }

.col-xs-push-1 {
  left: 8.33333%; }

.col-xs-push-2 {
  left: 16.66667%; }

.col-xs-push-3 {
  left: 25%; }

.col-xs-push-4 {
  left: 33.33333%; }

.col-xs-push-5 {
  left: 41.66667%; }

.col-xs-push-6 {
  left: 50%; }

.col-xs-push-7 {
  left: 58.33333%; }

.col-xs-push-8 {
  left: 66.66667%; }

.col-xs-push-9 {
  left: 75%; }

.col-xs-push-10 {
  left: 83.33333%; }

.col-xs-push-11 {
  left: 91.66667%; }

.col-xs-push-12 {
  left: 100%; }

.col-xs-offset-0 {
  margin-left: 0%; }

.col-xs-offset-1 {
  margin-left: 8.33333%; }

.col-xs-offset-2 {
  margin-left: 16.66667%; }

.col-xs-offset-3 {
  margin-left: 25%; }

.col-xs-offset-4 {
  margin-left: 33.33333%; }

.col-xs-offset-5 {
  margin-left: 41.66667%; }

.col-xs-offset-6 {
  margin-left: 50%; }

.col-xs-offset-7 {
  margin-left: 58.33333%; }

.col-xs-offset-8 {
  margin-left: 66.66667%; }

.col-xs-offset-9 {
  margin-left: 75%; }

.col-xs-offset-10 {
  margin-left: 83.33333%; }

.col-xs-offset-11 {
  margin-left: 91.66667%; }

.col-xs-offset-12 {
  margin-left: 100%; }

@media (min-width: 768px) {
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
    float: left; }
  .col-sm-1 {
    width: 8.33333%; }
  .col-sm-2 {
    width: 16.66667%; }
  .col-sm-3 {
    width: 25%; }
  .col-sm-4 {
    width: 33.33333%; }
  .col-sm-5 {
    width: 41.66667%; }
  .col-sm-6 {
    width: 50%; }
  .col-sm-7 {
    width: 58.33333%; }
  .col-sm-8 {
    width: 66.66667%; }
  .col-sm-9 {
    width: 75%; }
  .col-sm-10 {
    width: 83.33333%; }
  .col-sm-11 {
    width: 91.66667%; }
  .col-sm-12 {
    width: 100%; }
  .col-sm-pull-0 {
    right: auto; }
  .col-sm-pull-1 {
    right: 8.33333%; }
  .col-sm-pull-2 {
    right: 16.66667%; }
  .col-sm-pull-3 {
    right: 25%; }
  .col-sm-pull-4 {
    right: 33.33333%; }
  .col-sm-pull-5 {
    right: 41.66667%; }
  .col-sm-pull-6 {
    right: 50%; }
  .col-sm-pull-7 {
    right: 58.33333%; }
  .col-sm-pull-8 {
    right: 66.66667%; }
  .col-sm-pull-9 {
    right: 75%; }
  .col-sm-pull-10 {
    right: 83.33333%; }
  .col-sm-pull-11 {
    right: 91.66667%; }
  .col-sm-pull-12 {
    right: 100%; }
  .col-sm-push-0 {
    left: auto; }
  .col-sm-push-1 {
    left: 8.33333%; }
  .col-sm-push-2 {
    left: 16.66667%; }
  .col-sm-push-3 {
    left: 25%; }
  .col-sm-push-4 {
    left: 33.33333%; }
  .col-sm-push-5 {
    left: 41.66667%; }
  .col-sm-push-6 {
    left: 50%; }
  .col-sm-push-7 {
    left: 58.33333%; }
  .col-sm-push-8 {
    left: 66.66667%; }
  .col-sm-push-9 {
    left: 75%; }
  .col-sm-push-10 {
    left: 83.33333%; }
  .col-sm-push-11 {
    left: 91.66667%; }
  .col-sm-push-12 {
    left: 100%; }
  .col-sm-offset-0 {
    margin-left: 0%; }
  .col-sm-offset-1 {
    margin-left: 8.33333%; }
  .col-sm-offset-2 {
    margin-left: 16.66667%; }
  .col-sm-offset-3 {
    margin-left: 25%; }
  .col-sm-offset-4 {
    margin-left: 33.33333%; }
  .col-sm-offset-5 {
    margin-left: 41.66667%; }
  .col-sm-offset-6 {
    margin-left: 50%; }
  .col-sm-offset-7 {
    margin-left: 58.33333%; }
  .col-sm-offset-8 {
    margin-left: 66.66667%; }
  .col-sm-offset-9 {
    margin-left: 75%; }
  .col-sm-offset-10 {
    margin-left: 83.33333%; }
  .col-sm-offset-11 {
    margin-left: 91.66667%; }
  .col-sm-offset-12 {
    margin-left: 100%; } }

@media (min-width: 992px) {
  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
    float: left; }
  .col-md-1 {
    width: 8.33333%; }
  .col-md-2 {
    width: 16.66667%; }
  .col-md-3 {
    width: 25%; }
  .col-md-4 {
    width: 33.33333%; }
  .col-md-5 {
    width: 41.66667%; }
  .col-md-6 {
    width: 50%; }
  .col-md-7 {
    width: 58.33333%; }
  .col-md-8 {
    width: 66.66667%; }
  .col-md-9 {
    width: 75%; }
  .col-md-10 {
    width: 83.33333%; }
  .col-md-11 {
    width: 91.66667%; }
  .col-md-12 {
    width: 100%; }
  .col-md-pull-0 {
    right: auto; }
  .col-md-pull-1 {
    right: 8.33333%; }
  .col-md-pull-2 {
    right: 16.66667%; }
  .col-md-pull-3 {
    right: 25%; }
  .col-md-pull-4 {
    right: 33.33333%; }
  .col-md-pull-5 {
    right: 41.66667%; }
  .col-md-pull-6 {
    right: 50%; }
  .col-md-pull-7 {
    right: 58.33333%; }
  .col-md-pull-8 {
    right: 66.66667%; }
  .col-md-pull-9 {
    right: 75%; }
  .col-md-pull-10 {
    right: 83.33333%; }
  .col-md-pull-11 {
    right: 91.66667%; }
  .col-md-pull-12 {
    right: 100%; }
  .col-md-push-0 {
    left: auto; }
  .col-md-push-1 {
    left: 8.33333%; }
  .col-md-push-2 {
    left: 16.66667%; }
  .col-md-push-3 {
    left: 25%; }
  .col-md-push-4 {
    left: 33.33333%; }
  .col-md-push-5 {
    left: 41.66667%; }
  .col-md-push-6 {
    left: 50%; }
  .col-md-push-7 {
    left: 58.33333%; }
  .col-md-push-8 {
    left: 66.66667%; }
  .col-md-push-9 {
    left: 75%; }
  .col-md-push-10 {
    left: 83.33333%; }
  .col-md-push-11 {
    left: 91.66667%; }
  .col-md-push-12 {
    left: 100%; }
  .col-md-offset-0 {
    margin-left: 0%; }
  .col-md-offset-1 {
    margin-left: 8.33333%; }
  .col-md-offset-2 {
    margin-left: 16.66667%; }
  .col-md-offset-3 {
    margin-left: 25%; }
  .col-md-offset-4 {
    margin-left: 33.33333%; }
  .col-md-offset-5 {
    margin-left: 41.66667%; }
  .col-md-offset-6 {
    margin-left: 50%; }
  .col-md-offset-7 {
    margin-left: 58.33333%; }
  .col-md-offset-8 {
    margin-left: 66.66667%; }
  .col-md-offset-9 {
    margin-left: 75%; }
  .col-md-offset-10 {
    margin-left: 83.33333%; }
  .col-md-offset-11 {
    margin-left: 91.66667%; }
  .col-md-offset-12 {
    margin-left: 100%; } }

@media (min-width: 1200px) {
  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
    float: left; }
  .col-lg-1 {
    width: 8.33333%; }
  .col-lg-2 {
    width: 16.66667%; }
  .col-lg-3 {
    width: 25%; }
  .col-lg-4 {
    width: 33.33333%; }
  .col-lg-5 {
    width: 41.66667%; }
  .col-lg-6 {
    width: 50%; }
  .col-lg-7 {
    width: 58.33333%; }
  .col-lg-8 {
    width: 66.66667%; }
  .col-lg-9 {
    width: 75%; }
  .col-lg-10 {
    width: 83.33333%; }
  .col-lg-11 {
    width: 91.66667%; }
  .col-lg-12 {
    width: 100%; }
  .col-lg-pull-0 {
    right: auto; }
  .col-lg-pull-1 {
    right: 8.33333%; }
  .col-lg-pull-2 {
    right: 16.66667%; }
  .col-lg-pull-3 {
    right: 25%; }
  .col-lg-pull-4 {
    right: 33.33333%; }
  .col-lg-pull-5 {
    right: 41.66667%; }
  .col-lg-pull-6 {
    right: 50%; }
  .col-lg-pull-7 {
    right: 58.33333%; }
  .col-lg-pull-8 {
    right: 66.66667%; }
  .col-lg-pull-9 {
    right: 75%; }
  .col-lg-pull-10 {
    right: 83.33333%; }
  .col-lg-pull-11 {
    right: 91.66667%; }
  .col-lg-pull-12 {
    right: 100%; }
  .col-lg-push-0 {
    left: auto; }
  .col-lg-push-1 {
    left: 8.33333%; }
  .col-lg-push-2 {
    left: 16.66667%; }
  .col-lg-push-3 {
    left: 25%; }
  .col-lg-push-4 {
    left: 33.33333%; }
  .col-lg-push-5 {
    left: 41.66667%; }
  .col-lg-push-6 {
    left: 50%; }
  .col-lg-push-7 {
    left: 58.33333%; }
  .col-lg-push-8 {
    left: 66.66667%; }
  .col-lg-push-9 {
    left: 75%; }
  .col-lg-push-10 {
    left: 83.33333%; }
  .col-lg-push-11 {
    left: 91.66667%; }
  .col-lg-push-12 {
    left: 100%; }
  .col-lg-offset-0 {
    margin-left: 0%; }
  .col-lg-offset-1 {
    margin-left: 8.33333%; }
  .col-lg-offset-2 {
    margin-left: 16.66667%; }
  .col-lg-offset-3 {
    margin-left: 25%; }
  .col-lg-offset-4 {
    margin-left: 33.33333%; }
  .col-lg-offset-5 {
    margin-left: 41.66667%; }
  .col-lg-offset-6 {
    margin-left: 50%; }
  .col-lg-offset-7 {
    margin-left: 58.33333%; }
  .col-lg-offset-8 {
    margin-left: 66.66667%; }
  .col-lg-offset-9 {
    margin-left: 75%; }
  .col-lg-offset-10 {
    margin-left: 83.33333%; }
  .col-lg-offset-11 {
    margin-left: 91.66667%; }
  .col-lg-offset-12 {
    margin-left: 100%; } }

table {
  background-color: transparent; }

th {
  text-align: left; }

.table, .table-2 {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px; }
  .table > thead > tr > th, .table-2 > thead > tr > th,
  .table > thead > tr > td, .table-2 > thead > tr > td,
  .table > tbody > tr > th, .table-2 > tbody > tr > th,
  .table > tbody > tr > td, .table-2 > tbody > tr > td,
  .table > tfoot > tr > th, .table-2 > tfoot > tr > th,
  .table > tfoot > tr > td, .table-2 > tfoot > tr > td {
    padding: 12px 8px;
    line-height: 1.42857;
    vertical-align: top;
    border-top: 1px solid #F1EEEA; }
  .table > thead > tr > th, .table-2 > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #F1EEEA; }
  .table > caption + thead > tr:first-child > th, .table-2 > caption + thead > tr:first-child > th,
  .table > caption + thead > tr:first-child > td, .table-2 > caption + thead > tr:first-child > td,
  .table > colgroup + thead > tr:first-child > th, .table-2 > colgroup + thead > tr:first-child > th,
  .table > colgroup + thead > tr:first-child > td, .table-2 > colgroup + thead > tr:first-child > td,
  .table > thead:first-child > tr:first-child > th, .table-2 > thead:first-child > tr:first-child > th,
  .table > thead:first-child > tr:first-child > td, .table-2 > thead:first-child > tr:first-child > td {
    border-top: 0; }
  .table > tbody + tbody, .table-2 > tbody + tbody {
    border-top: 2px solid #F1EEEA; }
  .table .table, .table-2 .table, .table .table-2, .table-2 .table-2 {
    background-color: #F7F7F9; }

.table-condensed > thead > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > tfoot > tr > td {
  padding: 5px; }

.table-bordered {
  border: 1px solid #F1EEEA; }
  .table-bordered > thead > tr > th,
  .table-bordered > thead > tr > td,
  .table-bordered > tbody > tr > th,
  .table-bordered > tbody > tr > td,
  .table-bordered > tfoot > tr > th,
  .table-bordered > tfoot > tr > td {
    border: 1px solid #F1EEEA; }
  .table-bordered > thead > tr > th,
  .table-bordered > thead > tr > td {
    border-bottom-width: 2px; }

.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #f9f9f9; }

.table-hover > tbody > tr:hover > td,
.table-hover > tbody > tr:hover > th {
  background-color: #f5f5f5; }

table col[class*="col-"] {
  position: static;
  float: none;
  display: table-column; }

table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  float: none;
  display: table-cell; }

.table > thead > tr > td.active, .table-2 > thead > tr > td.active,
.table > thead > tr > th.active, .table-2 > thead > tr > th.active,
.table > thead > tr.active > td, .table-2 > thead > tr.active > td,
.table > thead > tr.active > th, .table-2 > thead > tr.active > th,
.table > tbody > tr > td.active, .table-2 > tbody > tr > td.active,
.table > tbody > tr > th.active, .table-2 > tbody > tr > th.active,
.table > tbody > tr.active > td, .table-2 > tbody > tr.active > td,
.table > tbody > tr.active > th, .table-2 > tbody > tr.active > th,
.table > tfoot > tr > td.active, .table-2 > tfoot > tr > td.active,
.table > tfoot > tr > th.active, .table-2 > tfoot > tr > th.active,
.table > tfoot > tr.active > td, .table-2 > tfoot > tr.active > td,
.table > tfoot > tr.active > th, .table-2 > tfoot > tr.active > th {
  background-color: #f5f5f5; }

.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover,
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr.active:hover > th {
  background-color: #e8e8e8; }

.table > thead > tr > td.success, .table-2 > thead > tr > td.success,
.table > thead > tr > th.success, .table-2 > thead > tr > th.success,
.table > thead > tr.success > td, .table-2 > thead > tr.success > td,
.table > thead > tr.success > th, .table-2 > thead > tr.success > th,
.table > tbody > tr > td.success, .table-2 > tbody > tr > td.success,
.table > tbody > tr > th.success, .table-2 > tbody > tr > th.success,
.table > tbody > tr.success > td, .table-2 > tbody > tr.success > td,
.table > tbody > tr.success > th, .table-2 > tbody > tr.success > th,
.table > tfoot > tr > td.success, .table-2 > tfoot > tr > td.success,
.table > tfoot > tr > th.success, .table-2 > tfoot > tr > th.success,
.table > tfoot > tr.success > td, .table-2 > tfoot > tr.success > td,
.table > tfoot > tr.success > th, .table-2 > tfoot > tr.success > th {
  background-color: #dff0d8; }

.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6; }

.table > thead > tr > td.info, .table-2 > thead > tr > td.info,
.table > thead > tr > th.info, .table-2 > thead > tr > th.info,
.table > thead > tr.info > td, .table-2 > thead > tr.info > td,
.table > thead > tr.info > th, .table-2 > thead > tr.info > th,
.table > tbody > tr > td.info, .table-2 > tbody > tr > td.info,
.table > tbody > tr > th.info, .table-2 > tbody > tr > th.info,
.table > tbody > tr.info > td, .table-2 > tbody > tr.info > td,
.table > tbody > tr.info > th, .table-2 > tbody > tr.info > th,
.table > tfoot > tr > td.info, .table-2 > tfoot > tr > td.info,
.table > tfoot > tr > th.info, .table-2 > tfoot > tr > th.info,
.table > tfoot > tr.info > td, .table-2 > tfoot > tr.info > td,
.table > tfoot > tr.info > th, .table-2 > tfoot > tr.info > th {
  background-color: #d9edf7; }

.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover,
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr.info:hover > th {
  background-color: #c4e3f3; }

.table > thead > tr > td.warning, .table-2 > thead > tr > td.warning,
.table > thead > tr > th.warning, .table-2 > thead > tr > th.warning,
.table > thead > tr.warning > td, .table-2 > thead > tr.warning > td,
.table > thead > tr.warning > th, .table-2 > thead > tr.warning > th,
.table > tbody > tr > td.warning, .table-2 > tbody > tr > td.warning,
.table > tbody > tr > th.warning, .table-2 > tbody > tr > th.warning,
.table > tbody > tr.warning > td, .table-2 > tbody > tr.warning > td,
.table > tbody > tr.warning > th, .table-2 > tbody > tr.warning > th,
.table > tfoot > tr > td.warning, .table-2 > tfoot > tr > td.warning,
.table > tfoot > tr > th.warning, .table-2 > tfoot > tr > th.warning,
.table > tfoot > tr.warning > td, .table-2 > tfoot > tr.warning > td,
.table > tfoot > tr.warning > th, .table-2 > tfoot > tr.warning > th {
  background-color: #fcf8e3; }

.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc; }

.table > thead > tr > td.danger, .table-2 > thead > tr > td.danger,
.table > thead > tr > th.danger, .table-2 > thead > tr > th.danger,
.table > thead > tr.danger > td, .table-2 > thead > tr.danger > td,
.table > thead > tr.danger > th, .table-2 > thead > tr.danger > th,
.table > tbody > tr > td.danger, .table-2 > tbody > tr > td.danger,
.table > tbody > tr > th.danger, .table-2 > tbody > tr > th.danger,
.table > tbody > tr.danger > td, .table-2 > tbody > tr.danger > td,
.table > tbody > tr.danger > th, .table-2 > tbody > tr.danger > th,
.table > tfoot > tr > td.danger, .table-2 > tfoot > tr > td.danger,
.table > tfoot > tr > th.danger, .table-2 > tfoot > tr > th.danger,
.table > tfoot > tr.danger > td, .table-2 > tfoot > tr.danger > td,
.table > tfoot > tr.danger > th, .table-2 > tfoot > tr.danger > th {
  background-color: #f2dede; }

.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc; }

@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    overflow-x: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #F1EEEA;
    -webkit-overflow-scrolling: touch; }
    .table-responsive > .table, .table-responsive > .table-2 {
      margin-bottom: 0; }
      .table-responsive > .table > thead > tr > th, .table-responsive > .table-2 > thead > tr > th,
      .table-responsive > .table > thead > tr > td,
      .table-responsive > .table-2 > thead > tr > td,
      .table-responsive > .table > tbody > tr > th,
      .table-responsive > .table-2 > tbody > tr > th,
      .table-responsive > .table > tbody > tr > td,
      .table-responsive > .table-2 > tbody > tr > td,
      .table-responsive > .table > tfoot > tr > th,
      .table-responsive > .table-2 > tfoot > tr > th,
      .table-responsive > .table > tfoot > tr > td,
      .table-responsive > .table-2 > tfoot > tr > td {
        white-space: nowrap; }
    .table-responsive > .table-bordered {
      border: 0; }
      .table-responsive > .table-bordered > thead > tr > th:first-child,
      .table-responsive > .table-bordered > thead > tr > td:first-child,
      .table-responsive > .table-bordered > tbody > tr > th:first-child,
      .table-responsive > .table-bordered > tbody > tr > td:first-child,
      .table-responsive > .table-bordered > tfoot > tr > th:first-child,
      .table-responsive > .table-bordered > tfoot > tr > td:first-child {
        border-left: 0; }
      .table-responsive > .table-bordered > thead > tr > th:last-child,
      .table-responsive > .table-bordered > thead > tr > td:last-child,
      .table-responsive > .table-bordered > tbody > tr > th:last-child,
      .table-responsive > .table-bordered > tbody > tr > td:last-child,
      .table-responsive > .table-bordered > tfoot > tr > th:last-child,
      .table-responsive > .table-bordered > tfoot > tr > td:last-child {
        border-right: 0; }
      .table-responsive > .table-bordered > tbody > tr:last-child > th,
      .table-responsive > .table-bordered > tbody > tr:last-child > td,
      .table-responsive > .table-bordered > tfoot > tr:last-child > th,
      .table-responsive > .table-bordered > tfoot > tr:last-child > td {
        border-bottom: 0; } }

fieldset {
  padding: 0;
  margin: 0;
  border: 0;
  min-width: 0; }

legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
  font-size: 21px;
  line-height: inherit;
  color: #020621;
  border: 0;
  border-bottom: 1px solid #e5e5e5; }

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold; }

input[type="search"] {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box; }

input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal; }

input[type="file"] {
  display: block; }

input[type="range"] {
  display: block;
  width: 100%; }

select[multiple],
select[size] {
  height: auto; }

input[type="file"]:focus,
input[type="radio"]:focus,
input[type="checkbox"]:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px; }

output {
  display: block;
  padding-top: 7px;
  font-size: 14px;
  line-height: 1.42857;
  color: #5b5b5b; }

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857;
  color: #5b5b5b;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #dad7d4;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s; }
  .form-control:focus {
    border-color: #30a7fc;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(48, 167, 252, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(48, 167, 252, 0.6); }
  .form-control::-moz-placeholder {
    color: #777777;
    opacity: 1; }
  .form-control:-ms-input-placeholder {
    color: #777777; }
  .form-control::-webkit-input-placeholder {
    color: #777777; }
  .form-control[disabled], .form-control[readonly],
  fieldset[disabled] .form-control {
    cursor: not-allowed;
    background-color: #d5d5d5;
    opacity: 1; }

textarea.form-control {
  height: auto; }

input[type="search"] {
  -webkit-appearance: none; }

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  line-height: 34px;
  line-height: 1.42857 \\0; }
  input[type="date"].input-sm, .form-horizontal .form-group-sm input[type="date"].form-control, .input-group-sm > input[type="date"].form-control,
  .input-group-sm > input[type="date"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="date"].btn,
  input[type="time"].input-sm,
  .form-horizontal .form-group-sm input[type="time"].form-control,
  .input-group-sm > input[type="time"].form-control,
  .input-group-sm > input[type="time"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="time"].btn,
  input[type="datetime-local"].input-sm,
  .form-horizontal .form-group-sm input[type="datetime-local"].form-control,
  .input-group-sm > input[type="datetime-local"].form-control,
  .input-group-sm > input[type="datetime-local"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="datetime-local"].btn,
  input[type="month"].input-sm,
  .form-horizontal .form-group-sm input[type="month"].form-control,
  .input-group-sm > input[type="month"].form-control,
  .input-group-sm > input[type="month"].input-group-addon,
  .input-group-sm > .input-group-btn > input[type="month"].btn {
    line-height: 30px; }
  input[type="date"].input-lg, .form-horizontal .form-group-lg input[type="date"].form-control, .input-group-lg > input[type="date"].form-control,
  .input-group-lg > input[type="date"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="date"].btn,
  input[type="time"].input-lg,
  .form-horizontal .form-group-lg input[type="time"].form-control,
  .input-group-lg > input[type="time"].form-control,
  .input-group-lg > input[type="time"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="time"].btn,
  input[type="datetime-local"].input-lg,
  .form-horizontal .form-group-lg input[type="datetime-local"].form-control,
  .input-group-lg > input[type="datetime-local"].form-control,
  .input-group-lg > input[type="datetime-local"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="datetime-local"].btn,
  input[type="month"].input-lg,
  .form-horizontal .form-group-lg input[type="month"].form-control,
  .input-group-lg > input[type="month"].form-control,
  .input-group-lg > input[type="month"].input-group-addon,
  .input-group-lg > .input-group-btn > input[type="month"].btn {
    line-height: 46px; }

.form-group {
  margin-bottom: 15px; }

.radio,
.checkbox {
  position: relative;
  display: block;
  min-height: 20px;
  margin-top: 10px;
  margin-bottom: 10px; }
  .radio label,
  .checkbox label {
    padding-left: 20px;
    margin-bottom: 0;
    font-weight: normal;
    cursor: pointer; }

.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  position: absolute;
  margin-left: -20px;
  margin-top: 4px \\9; }

.radio + .radio,
.checkbox + .checkbox {
  margin-top: -5px; }

.radio-inline,
.checkbox-inline {
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  vertical-align: middle;
  font-weight: normal;
  cursor: pointer; }

.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
  margin-left: 10px; }

input[type="radio"][disabled], input[type="radio"].disabled,
fieldset[disabled] input[type="radio"],
input[type="checkbox"][disabled],
input[type="checkbox"].disabled,
fieldset[disabled]
input[type="checkbox"] {
  cursor: not-allowed; }

.radio-inline.disabled,
fieldset[disabled] .radio-inline,
.checkbox-inline.disabled,
fieldset[disabled]
.checkbox-inline {
  cursor: not-allowed; }

.radio.disabled label,
fieldset[disabled] .radio label,
.checkbox.disabled label,
fieldset[disabled]
.checkbox label {
  cursor: not-allowed; }

.form-control-static {
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0; }
  .form-control-static.input-lg, .form-horizontal .form-group-lg .form-control-static.form-control, .input-group-lg > .form-control-static.form-control,
  .input-group-lg > .form-control-static.input-group-addon,
  .input-group-lg > .input-group-btn > .form-control-static.btn, .icon-nav
  .input-group-lg > .input-group-btn > label.form-control-static, .form-control-static.input-sm, .form-horizontal .form-group-sm .form-control-static.form-control, .input-group-sm > .form-control-static.form-control,
  .input-group-sm > .form-control-static.input-group-addon,
  .input-group-sm > .input-group-btn > .form-control-static.btn, .icon-nav
  .input-group-sm > .input-group-btn > label.form-control-static {
    padding-left: 0;
    padding-right: 0; }

.input-sm, .form-horizontal .form-group-sm .form-control, .input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn, .icon-nav
.input-group-sm > .input-group-btn > label {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px; }

select.input-sm, .form-horizontal .form-group-sm select.form-control, .input-group-sm > select.form-control,
.input-group-sm > select.input-group-addon,
.input-group-sm > .input-group-btn > select.btn {
  height: 30px;
  line-height: 30px; }

textarea.input-sm, .form-horizontal .form-group-sm textarea.form-control, .input-group-sm > textarea.form-control,
.input-group-sm > textarea.input-group-addon,
.input-group-sm > .input-group-btn > textarea.btn,
select[multiple].input-sm,
.form-horizontal .form-group-sm select[multiple].form-control,
.input-group-sm > select[multiple].form-control,
.input-group-sm > select[multiple].input-group-addon,
.input-group-sm > .input-group-btn > select[multiple].btn {
  height: auto; }

.input-lg, .form-horizontal .form-group-lg .form-control, .input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn, .icon-nav
.input-group-lg > .input-group-btn > label {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px; }

select.input-lg, .form-horizontal .form-group-lg select.form-control, .input-group-lg > select.form-control,
.input-group-lg > select.input-group-addon,
.input-group-lg > .input-group-btn > select.btn {
  height: 46px;
  line-height: 46px; }

textarea.input-lg, .form-horizontal .form-group-lg textarea.form-control, .input-group-lg > textarea.form-control,
.input-group-lg > textarea.input-group-addon,
.input-group-lg > .input-group-btn > textarea.btn,
select[multiple].input-lg,
.form-horizontal .form-group-lg select[multiple].form-control,
.input-group-lg > select[multiple].form-control,
.input-group-lg > select[multiple].input-group-addon,
.input-group-lg > .input-group-btn > select[multiple].btn {
  height: auto; }

.has-feedback {
  position: relative; }
  .has-feedback .form-control {
    padding-right: 42.5px; }

.form-control-feedback {
  position: absolute;
  top: 25px;
  right: 0;
  z-index: 2;
  display: block;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center; }

.input-lg + .form-control-feedback, .form-horizontal .form-group-lg .form-control + .form-control-feedback, .input-group-lg > .form-control + .form-control-feedback,
.input-group-lg > .input-group-addon + .form-control-feedback,
.input-group-lg > .input-group-btn > .btn + .form-control-feedback, .icon-nav
.input-group-lg > .input-group-btn > label + .form-control-feedback {
  width: 46px;
  height: 46px;
  line-height: 46px; }

.input-sm + .form-control-feedback, .form-horizontal .form-group-sm .form-control + .form-control-feedback, .input-group-sm > .form-control + .form-control-feedback,
.input-group-sm > .input-group-addon + .form-control-feedback,
.input-group-sm > .input-group-btn > .btn + .form-control-feedback, .icon-nav
.input-group-sm > .input-group-btn > label + .form-control-feedback {
  width: 30px;
  height: 30px;
  line-height: 30px; }

.has-success .help-block,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline {
  color: #4ab767; }

.has-success .form-control {
  border-color: #4ab767;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .has-success .form-control:focus {
    border-color: #3b9352;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #93d4a4;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #93d4a4; }

.has-success .input-group-addon {
  color: #4ab767;
  border-color: #4ab767;
  background-color: #dff0d8; }

.has-success .form-control-feedback {
  color: #4ab767; }

.has-warning .help-block,
.has-warning .control-label,
.has-warning .radio,
.has-warning .checkbox,
.has-warning .radio-inline,
.has-warning .checkbox-inline {
  color: #8a6d3b; }

.has-warning .form-control {
  border-color: #8a6d3b;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .has-warning .form-control:focus {
    border-color: #66512c;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b; }

.has-warning .input-group-addon {
  color: #8a6d3b;
  border-color: #8a6d3b;
  background-color: #fcf8e3; }

.has-warning .form-control-feedback {
  color: #8a6d3b; }

.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline {
  color: #c0392b; }

.has-error .form-control {
  border-color: #c0392b;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .has-error .form-control:focus {
    border-color: #962d22;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #df7c72;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #df7c72; }

.has-error .input-group-addon {
  color: #c0392b;
  border-color: #c0392b;
  background-color: #f2dede; }

.has-error .form-control-feedback {
  color: #c0392b; }

.has-feedback label.sr-only ~ .form-control-feedback {
  top: 0; }

.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #091c99; }

@media (min-width: 768px) {
  .form-inline .form-group, .navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle; }
  .form-inline .form-control, .navbar-form .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle; }
  .form-inline .input-group, .navbar-form .input-group {
    display: inline-table;
    vertical-align: middle; }
    .form-inline .input-group .input-group-addon, .navbar-form .input-group .input-group-addon,
    .form-inline .input-group .input-group-btn, .navbar-form .input-group .input-group-btn,
    .form-inline .input-group .form-control, .navbar-form .input-group .form-control {
      width: auto; }
  .form-inline .input-group > .form-control, .navbar-form .input-group > .form-control {
    width: 100%; }
  .form-inline .control-label, .navbar-form .control-label {
    margin-bottom: 0;
    vertical-align: middle; }
  .form-inline .radio, .navbar-form .radio,
  .form-inline .checkbox, .navbar-form .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle; }
    .form-inline .radio label, .navbar-form .radio label,
    .form-inline .checkbox label, .navbar-form .checkbox label {
      padding-left: 0; }
  .form-inline .radio input[type="radio"], .navbar-form .radio input[type="radio"],
  .form-inline .checkbox input[type="checkbox"], .navbar-form .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0; }
  .form-inline .has-feedback .form-control-feedback, .navbar-form .has-feedback .form-control-feedback {
    top: 0; } }

.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 7px; }

.form-horizontal .radio,
.form-horizontal .checkbox {
  min-height: 27px; }

.form-horizontal .form-group {
  margin-left: -7.5px;
  margin-right: -7.5px; }
  .form-horizontal .form-group:before, .form-horizontal .form-group:after {
    content: " ";
    display: table; }
  .form-horizontal .form-group:after {
    clear: both; }

@media (min-width: 768px) {
  .form-horizontal .control-label {
    text-align: right;
    margin-bottom: 0;
    padding-top: 7px; } }

.form-horizontal .has-feedback .form-control-feedback {
  top: 0;
  right: 7.5px; }

@media (min-width: 768px) {
  .form-horizontal .form-group-lg .control-label {
    padding-top: 14.3px; } }

@media (min-width: 768px) {
  .form-horizontal .form-group-sm .control-label {
    padding-top: 6px; } }

.btn, .icon-nav label {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }
  .btn:focus, .icon-nav label:focus, .btn:active:focus, .icon-nav label:active:focus, .btn.active:focus, .icon-nav label.active:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px; }
  .btn:hover, .icon-nav label:hover, .btn:focus, .icon-nav label:focus {
    color: #333;
    text-decoration: none; }
  .btn:active, .icon-nav label:active, .btn.active, .icon-nav label.active {
    outline: 0;
    background-image: none;
    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
  .btn.disabled, .icon-nav label.disabled, .btn[disabled], .icon-nav label[disabled],
  fieldset[disabled] .btn,
  fieldset[disabled] .icon-nav label, .icon-nav
  fieldset[disabled] label {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.65;
    filter: alpha(opacity=65);
    -webkit-box-shadow: none;
    box-shadow: none; }

.btn-default, .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {
  color: #333;
  background-color: #e8e8e8;
  border-color: #CCC; }
  .btn-default:hover, .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .icon-nav label:hover, .icon-nav .timeline .dropdown-menu li label:hover, .btn-default:focus, .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li .icon-nav label:focus, .icon-nav .timeline .dropdown-menu li label:focus, .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,
  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li
  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav
  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li
  .open > label.dropdown-toggle {
    color: #333;
    background-color: #cfcfcf;
    border-color: #adadad; }
  .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,
  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li
  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav
  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li
  .open > label.dropdown-toggle {
    background-image: none; }
  .btn-default.disabled, .timeline .dropdown-menu li .disabled.btn, .timeline .dropdown-menu li .icon-nav label.disabled, .icon-nav .timeline .dropdown-menu li label.disabled, .btn-default.disabled:hover, .timeline .dropdown-menu li .disabled.btn:hover, .timeline .dropdown-menu li .icon-nav label.disabled:hover, .icon-nav .timeline .dropdown-menu li label.disabled:hover, .btn-default.disabled:focus, .timeline .dropdown-menu li .disabled.btn:focus, .timeline .dropdown-menu li .icon-nav label.disabled:focus, .icon-nav .timeline .dropdown-menu li label.disabled:focus, .btn-default.disabled:active, .timeline .dropdown-menu li .disabled.btn:active, .timeline .dropdown-menu li .icon-nav label.disabled:active, .icon-nav .timeline .dropdown-menu li label.disabled:active, .btn-default.disabled.active, .timeline .dropdown-menu li .disabled.active.btn, .timeline .dropdown-menu li .icon-nav label.disabled.active, .icon-nav .timeline .dropdown-menu li label.disabled.active, .btn-default[disabled], .timeline .dropdown-menu li [disabled].btn, .timeline .dropdown-menu li .icon-nav label[disabled], .icon-nav .timeline .dropdown-menu li label[disabled], .btn-default[disabled]:hover, .timeline .dropdown-menu li [disabled].btn:hover, .timeline .dropdown-menu li .icon-nav label[disabled]:hover, .icon-nav .timeline .dropdown-menu li label[disabled]:hover, .btn-default[disabled]:focus, .timeline .dropdown-menu li [disabled].btn:focus, .timeline .dropdown-menu li .icon-nav label[disabled]:focus, .icon-nav .timeline .dropdown-menu li label[disabled]:focus, .btn-default[disabled]:active, .timeline .dropdown-menu li [disabled].btn:active, .timeline .dropdown-menu li .icon-nav label[disabled]:active, .icon-nav .timeline .dropdown-menu li label[disabled]:active, .btn-default[disabled].active, .timeline .dropdown-menu li [disabled].active.btn, .timeline .dropdown-menu li .icon-nav label[disabled].active, .icon-nav .timeline .dropdown-menu li label[disabled].active,
  fieldset[disabled] .btn-default,
  fieldset[disabled] .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li
  fieldset[disabled] .btn,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label,
  fieldset[disabled] .btn-default:hover,
  fieldset[disabled] .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li
  fieldset[disabled] .btn:hover,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:hover,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:hover,
  fieldset[disabled] .btn-default:focus,
  fieldset[disabled] .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li
  fieldset[disabled] .btn:focus,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:focus,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:focus,
  fieldset[disabled] .btn-default:active,
  fieldset[disabled] .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li
  fieldset[disabled] .btn:active,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:active,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:active,
  fieldset[disabled] .btn-default.active,
  fieldset[disabled] .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li
  fieldset[disabled] .active.btn,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label.active,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label.active {
    background-color: #e8e8e8;
    border-color: #CCC; }
  .btn-default .badge, .timeline .dropdown-menu li .btn .badge, .timeline .dropdown-menu li .icon-nav label .badge, .icon-nav .timeline .dropdown-menu li label .badge {
    color: #e8e8e8;
    background-color: #333; }

.btn-primary {
  color: #fff;
  background-color: #0081BA;
  border-color: #444; }
  .btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active,
  .open > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #005e87;
    border-color: #252525; }
  .btn-primary:active, .btn-primary.active,
  .open > .btn-primary.dropdown-toggle {
    background-image: none; }
  .btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled]:active, .btn-primary[disabled].active,
  fieldset[disabled] .btn-primary,
  fieldset[disabled] .btn-primary:hover,
  fieldset[disabled] .btn-primary:focus,
  fieldset[disabled] .btn-primary:active,
  fieldset[disabled] .btn-primary.active {
    background-color: #0081BA;
    border-color: #444; }
  .btn-primary .badge {
    color: #0081BA;
    background-color: #fff; }

.btn-success, .btn-sign-in, .modal-dialog .sign-in,
.modal-dialog .sign-in:hover {
  color: #fff;
  background-color: #4ab767;
  border-color: #4ab767; }
  .btn-success:hover, .btn-sign-in:hover, .modal-dialog .sign-in:hover, .btn-success:focus, .btn-sign-in:focus, .modal-dialog .sign-in:focus, .btn-success:active, .btn-sign-in:active, .modal-dialog .sign-in:active, .btn-success.active, .active.btn-sign-in, .modal-dialog .active.sign-in,
  .open > .btn-success.dropdown-toggle,
  .open > .dropdown-toggle.btn-sign-in, .modal-dialog
  .open > .dropdown-toggle.sign-in {
    color: #fff;
    background-color: #3b9352;
    border-color: #388c4e; }
  .btn-success:active, .btn-sign-in:active, .modal-dialog .sign-in:active, .btn-success.active, .active.btn-sign-in, .modal-dialog .active.sign-in,
  .open > .btn-success.dropdown-toggle,
  .open > .dropdown-toggle.btn-sign-in, .modal-dialog
  .open > .dropdown-toggle.sign-in {
    background-image: none; }
  .btn-success.disabled, .disabled.btn-sign-in, .modal-dialog .disabled.sign-in, .btn-success.disabled:hover, .disabled.btn-sign-in:hover, .modal-dialog .disabled.sign-in:hover, .btn-success.disabled:focus, .disabled.btn-sign-in:focus, .modal-dialog .disabled.sign-in:focus, .btn-success.disabled:active, .disabled.btn-sign-in:active, .modal-dialog .disabled.sign-in:active, .btn-success.disabled.active, .disabled.active.btn-sign-in, .modal-dialog .disabled.active.sign-in, .btn-success[disabled], [disabled].btn-sign-in, .modal-dialog [disabled].sign-in, .btn-success[disabled]:hover, [disabled].btn-sign-in:hover, .modal-dialog [disabled].sign-in:hover, .btn-success[disabled]:focus, [disabled].btn-sign-in:focus, .modal-dialog [disabled].sign-in:focus, .btn-success[disabled]:active, [disabled].btn-sign-in:active, .modal-dialog [disabled].sign-in:active, .btn-success[disabled].active, [disabled].active.btn-sign-in, .modal-dialog [disabled].active.sign-in,
  fieldset[disabled] .btn-success,
  fieldset[disabled] .btn-sign-in,
  fieldset[disabled] .modal-dialog .sign-in, .modal-dialog
  fieldset[disabled] .sign-in,
  fieldset[disabled] .btn-success:hover,
  fieldset[disabled] .btn-sign-in:hover,
  fieldset[disabled] .modal-dialog .sign-in:hover, .modal-dialog
  fieldset[disabled] .sign-in:hover,
  fieldset[disabled] .btn-success:focus,
  fieldset[disabled] .btn-sign-in:focus,
  fieldset[disabled] .modal-dialog .sign-in:focus, .modal-dialog
  fieldset[disabled] .sign-in:focus,
  fieldset[disabled] .btn-success:active,
  fieldset[disabled] .btn-sign-in:active,
  fieldset[disabled] .modal-dialog .sign-in:active, .modal-dialog
  fieldset[disabled] .sign-in:active,
  fieldset[disabled] .btn-success.active,
  fieldset[disabled] .active.btn-sign-in,
  fieldset[disabled] .modal-dialog .active.sign-in, .modal-dialog
  fieldset[disabled] .active.sign-in {
    background-color: #4ab767;
    border-color: #4ab767; }
  .btn-success .badge, .btn-sign-in .badge, .modal-dialog .sign-in .badge {
    color: #4ab767;
    background-color: #fff; }

.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da; }
  .btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active,
  .open > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #31b0d5;
    border-color: #269abc; }
  .btn-info:active, .btn-info.active,
  .open > .btn-info.dropdown-toggle {
    background-image: none; }
  .btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled]:active, .btn-info[disabled].active,
  fieldset[disabled] .btn-info,
  fieldset[disabled] .btn-info:hover,
  fieldset[disabled] .btn-info:focus,
  fieldset[disabled] .btn-info:active,
  fieldset[disabled] .btn-info.active {
    background-color: #5bc0de;
    border-color: #46b8da; }
  .btn-info .badge {
    color: #5bc0de;
    background-color: #fff; }

.btn-warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236; }
  .btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active,
  .open > .btn-warning.dropdown-toggle {
    color: #fff;
    background-color: #ec971f;
    border-color: #d58512; }
  .btn-warning:active, .btn-warning.active,
  .open > .btn-warning.dropdown-toggle {
    background-image: none; }
  .btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled]:active, .btn-warning[disabled].active,
  fieldset[disabled] .btn-warning,
  fieldset[disabled] .btn-warning:hover,
  fieldset[disabled] .btn-warning:focus,
  fieldset[disabled] .btn-warning:active,
  fieldset[disabled] .btn-warning.active {
    background-color: #f0ad4e;
    border-color: #eea236; }
  .btn-warning .badge {
    color: #f0ad4e;
    background-color: #fff; }

.btn-danger {
  color: #fff;
  background-color: #d65548;
  border-color: #81261d; }
  .btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active,
  .open > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #c0392b;
    border-color: #4f1812; }
  .btn-danger:active, .btn-danger.active,
  .open > .btn-danger.dropdown-toggle {
    background-image: none; }
  .btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled]:active, .btn-danger[disabled].active,
  fieldset[disabled] .btn-danger,
  fieldset[disabled] .btn-danger:hover,
  fieldset[disabled] .btn-danger:focus,
  fieldset[disabled] .btn-danger:active,
  fieldset[disabled] .btn-danger.active {
    background-color: #d65548;
    border-color: #81261d; }
  .btn-danger .badge {
    color: #d65548;
    background-color: #fff; }

.btn-link {
  color: #0081BA;
  font-weight: normal;
  cursor: pointer;
  border-radius: 0; }
  .btn-link, .btn-link:active, .btn-link[disabled],
  fieldset[disabled] .btn-link {
    background-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none; }
  .btn-link, .btn-link:hover, .btn-link:focus, .btn-link:active {
    border-color: transparent; }
  .btn-link:hover, .btn-link:focus {
    color: #005e87;
    text-decoration: underline;
    background-color: transparent; }
  .btn-link[disabled]:hover, .btn-link[disabled]:focus,
  fieldset[disabled] .btn-link:hover,
  fieldset[disabled] .btn-link:focus {
    color: #777777;
    text-decoration: none; }

.btn-lg, .btn-group-lg > .btn, .icon-nav .btn-group-lg > label {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px; }

.btn-sm, .btn-group-sm > .btn, .icon-nav .btn-group-sm > label, .btn-github {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px; }

.btn-xs, .btn-group-xs > .btn, .icon-nav .btn-group-xs > label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px; }

.btn-block {
  display: block;
  width: 100%; }

.btn-block + .btn-block {
  margin-top: 5px; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear; }
  .fade.in {
    opacity: 1; }

.collapse {
  display: none; }
  .collapse.in {
    display: block; }

tr.collapse.in {
  display: table-row; }

tbody.collapse.in {
  display: table-row-group; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  -webkit-transition: height 0.35s ease;
  -o-transition: height 0.35s ease;
  transition: height 0.35s ease; }

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px solid;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent; }

.dropdown {
  position: relative; }

.dropdown-toggle:focus {
  outline: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box; }
  .dropdown-menu.pull-right {
    right: 0;
    left: auto; }
  .dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5; }
  .dropdown-menu > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857;
    color: #0081BA;
    white-space: nowrap; }

.dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
  text-decoration: none;
  color: #006fa1;
  background-color: #f5f5f5; }

.dropdown-menu > .active > a, .dropdown-menu > .active > a:hover, .dropdown-menu > .active > a:focus {
  color: #5b5b5b;
  text-decoration: none;
  outline: 0;
  background-color: #0081BA; }

.dropdown-menu > .disabled > a, .dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {
  color: #777777; }

.dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {
  text-decoration: none;
  background-color: transparent;
  background-image: none;
  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
  cursor: not-allowed; }

.open > .dropdown-menu {
  display: block; }

.open > a {
  outline: 0; }

.dropdown-menu-right {
  left: auto;
  right: 0; }

.dropdown-menu-left {
  left: 0;
  right: auto; }

.dropdown-header {
  display: block;
  padding: 3px 20px;
  font-size: 12px;
  line-height: 1.42857;
  color: #020621;
  white-space: nowrap; }

.dropdown-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 990; }

.pull-right > .dropdown-menu {
  right: 0;
  left: auto; }

.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  border-top: 0;
  border-bottom: 4px solid;
  content: ""; }

.dropup .dropdown-menu,
.navbar-fixed-bottom .dropdown .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 1px; }

@media (min-width: 768px) {
  .navbar-right .dropdown-menu {
    right: 0;
    left: auto; }
  .navbar-right .dropdown-menu-left {
    left: 0;
    right: auto; } }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle; }
  .btn-group > .btn, .icon-nav .btn-group > label,
  .btn-group-vertical > .btn, .icon-nav
  .btn-group-vertical > label {
    position: relative;
    float: left; }
    .btn-group > .btn:hover, .icon-nav .btn-group > label:hover, .btn-group > .btn:focus, .icon-nav .btn-group > label:focus, .btn-group > .btn:active, .icon-nav .btn-group > label:active, .btn-group > .btn.active, .icon-nav .btn-group > label.active,
    .btn-group-vertical > .btn:hover, .icon-nav
    .btn-group-vertical > label:hover,
    .btn-group-vertical > .btn:focus, .icon-nav
    .btn-group-vertical > label:focus,
    .btn-group-vertical > .btn:active, .icon-nav
    .btn-group-vertical > label:active,
    .btn-group-vertical > .btn.active, .icon-nav
    .btn-group-vertical > label.active {
      z-index: 2; }
    .btn-group > .btn:focus, .icon-nav .btn-group > label:focus,
    .btn-group-vertical > .btn:focus, .icon-nav
    .btn-group-vertical > label:focus {
      outline: 0; }

.btn-group .btn + .btn, .btn-group .icon-nav label + .btn, .icon-nav .btn-group label + .btn, .btn-group .icon-nav .btn + label, .icon-nav .btn-group .btn + label, .btn-group .icon-nav label + label, .icon-nav .btn-group label + label,
.btn-group .btn + .btn-group,
.btn-group .icon-nav label + .btn-group, .icon-nav
.btn-group label + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .icon-nav .btn-group + label, .icon-nav
.btn-group .btn-group + label,
.btn-group .btn-group + .btn-group {
  margin-left: -1px; }

.btn-toolbar {
  margin-left: -5px; }
  .btn-toolbar:before, .btn-toolbar:after {
    content: " ";
    display: table; }
  .btn-toolbar:after {
    clear: both; }
  .btn-toolbar .btn-group,
  .btn-toolbar .input-group {
    float: left; }
  .btn-toolbar > .btn, .icon-nav .btn-toolbar > label,
  .btn-toolbar > .btn-group,
  .btn-toolbar > .input-group {
    margin-left: 5px; }

.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle), .icon-nav .btn-group > label:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0; }

.btn-group > .btn:first-child, .icon-nav .btn-group > label:first-child {
  margin-left: 0; }
  .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle), .icon-nav .btn-group > label:first-child:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0; }

.btn-group > .btn:last-child:not(:first-child), .icon-nav .btn-group > label:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0; }

.btn-group > .btn-group {
  float: left; }

.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn, .icon-nav .btn-group > .btn-group:not(:first-child):not(:last-child) > label {
  border-radius: 0; }

.btn-group > .btn-group:first-child > .btn:last-child, .icon-nav .btn-group > .btn-group:first-child > label:last-child,
.btn-group > .btn-group:first-child > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0; }

.btn-group > .btn-group:last-child > .btn:first-child, .icon-nav .btn-group > .btn-group:last-child > label:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0; }

.btn-group .dropdown-toggle:active,
.btn-group.open .dropdown-toggle {
  outline: 0; }

.btn-group > .btn + .dropdown-toggle, .icon-nav .btn-group > label + .dropdown-toggle {
  padding-left: 8px;
  padding-right: 8px; }

.btn-group > .btn-lg + .dropdown-toggle, .btn-group-lg.btn-group > .btn + .dropdown-toggle, .icon-nav .btn-group-lg.btn-group > label + .dropdown-toggle {
  padding-left: 12px;
  padding-right: 12px; }

.btn-group.open .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
  .btn-group.open .dropdown-toggle.btn-link {
    -webkit-box-shadow: none;
    box-shadow: none; }

.btn .caret, .icon-nav label .caret {
  margin-left: 0; }

.btn-lg .caret, .btn-group-lg > .btn .caret, .icon-nav .btn-group-lg > label .caret {
  border-width: 5px 5px 0;
  border-bottom-width: 0; }

.dropup .btn-lg .caret, .dropup .btn-group-lg > .btn .caret, .dropup .icon-nav .btn-group-lg > label .caret, .icon-nav .dropup .btn-group-lg > label .caret {
  border-width: 0 5px 5px; }

.btn-group-vertical > .btn, .icon-nav .btn-group-vertical > label,
.btn-group-vertical > .btn-group,
.btn-group-vertical > .btn-group > .btn, .icon-nav
.btn-group-vertical > .btn-group > label {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%; }

.btn-group-vertical > .btn-group:before, .btn-group-vertical > .btn-group:after {
  content: " ";
  display: table; }

.btn-group-vertical > .btn-group:after {
  clear: both; }

.btn-group-vertical > .btn-group > .btn, .icon-nav .btn-group-vertical > .btn-group > label {
  float: none; }

.btn-group-vertical > .btn + .btn, .icon-nav .btn-group-vertical > label + .btn, .icon-nav .btn-group-vertical > .btn + label, .icon-nav .btn-group-vertical > label + label,
.btn-group-vertical > .btn + .btn-group, .icon-nav
.btn-group-vertical > label + .btn-group,
.btn-group-vertical > .btn-group + .btn, .icon-nav
.btn-group-vertical > .btn-group + label,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0; }

.btn-group-vertical > .btn:not(:first-child):not(:last-child), .icon-nav .btn-group-vertical > label:not(:first-child):not(:last-child) {
  border-radius: 0; }

.btn-group-vertical > .btn:first-child:not(:last-child), .icon-nav .btn-group-vertical > label:first-child:not(:last-child) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.btn-group-vertical > .btn:last-child:not(:first-child), .icon-nav .btn-group-vertical > label:last-child:not(:first-child) {
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
  border-top-left-radius: 0; }

.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn, .icon-nav .btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > label {
  border-radius: 0; }

.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child, .icon-nav .btn-group-vertical > .btn-group:first-child:not(:last-child) > label:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child, .icon-nav .btn-group-vertical > .btn-group:last-child:not(:first-child) > label:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0; }

.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate; }
  .btn-group-justified > .btn, .icon-nav .btn-group-justified > label,
  .btn-group-justified > .btn-group {
    float: none;
    display: table-cell;
    width: 1%; }
  .btn-group-justified > .btn-group .btn, .btn-group-justified > .btn-group .icon-nav label, .icon-nav .btn-group-justified > .btn-group label {
    width: 100%; }
  .btn-group-justified > .btn-group .dropdown-menu {
    left: auto; }

[data-toggle="buttons"] > .btn > input[type="radio"], .icon-nav [data-toggle="buttons"] > label > input[type="radio"],
[data-toggle="buttons"] > .btn > input[type="checkbox"], .icon-nav
[data-toggle="buttons"] > label > input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
  filter: alpha(opacity=0); }

.input-group {
  position: relative;
  display: table;
  border-collapse: separate; }
  .input-group[class*="col-"] {
    float: none;
    padding-left: 0;
    padding-right: 0; }
  .input-group .form-control {
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0; }

.input-group-addon,
.input-group-btn,
.input-group .form-control {
  display: table-cell; }
  .input-group-addon:not(:first-child):not(:last-child),
  .input-group-btn:not(:first-child):not(:last-child),
  .input-group .form-control:not(:first-child):not(:last-child) {
    border-radius: 0; }

.input-group-addon,
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle; }

.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  color: #5b5b5b;
  text-align: center;
  background-color: #d5d5d5;
  border: 1px solid #dad7d4;
  border-radius: 4px; }
  .input-group-addon.input-sm, .form-horizontal .form-group-sm .input-group-addon.form-control,
  .input-group-sm > .input-group-addon,
  .input-group-sm > .input-group-btn > .input-group-addon.btn, .icon-nav
  .input-group-sm > .input-group-btn > label.input-group-addon {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 2px; }
  .input-group-addon.input-lg, .form-horizontal .form-group-lg .input-group-addon.form-control,
  .input-group-lg > .input-group-addon,
  .input-group-lg > .input-group-btn > .input-group-addon.btn, .icon-nav
  .input-group-lg > .input-group-btn > label.input-group-addon {
    padding: 10px 16px;
    font-size: 18px;
    border-radius: 6px; }
  .input-group-addon input[type="radio"],
  .input-group-addon input[type="checkbox"] {
    margin-top: 0; }

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .btn, .icon-nav
.input-group-btn:first-child > label,
.input-group-btn:first-child > .btn-group > .btn, .icon-nav
.input-group-btn:first-child > .btn-group > label,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle), .icon-nav
.input-group-btn:last-child > label:not(:last-child):not(.dropdown-toggle),
.input-group-btn:last-child > .btn-group:not(:last-child) > .btn, .icon-nav
.input-group-btn:last-child > .btn-group:not(:last-child) > label {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0; }

.input-group-addon:first-child {
  border-right: 0; }

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .btn, .icon-nav
.input-group-btn:last-child > label,
.input-group-btn:last-child > .btn-group > .btn, .icon-nav
.input-group-btn:last-child > .btn-group > label,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child), .icon-nav
.input-group-btn:first-child > label:not(:first-child),
.input-group-btn:first-child > .btn-group:not(:first-child) > .btn, .icon-nav
.input-group-btn:first-child > .btn-group:not(:first-child) > label {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0; }

.input-group-addon:last-child {
  border-left: 0; }

.input-group-btn {
  position: relative;
  font-size: 0;
  white-space: nowrap; }
  .input-group-btn > .btn, .icon-nav .input-group-btn > label {
    position: relative; }
    .input-group-btn > .btn + .btn, .icon-nav .input-group-btn > label + .btn, .icon-nav .input-group-btn > .btn + label, .icon-nav .input-group-btn > label + label {
      margin-left: -1px; }
    .input-group-btn > .btn:hover, .icon-nav .input-group-btn > label:hover, .input-group-btn > .btn:focus, .icon-nav .input-group-btn > label:focus, .input-group-btn > .btn:active, .icon-nav .input-group-btn > label:active {
      z-index: 2; }
  .input-group-btn:first-child > .btn, .icon-nav .input-group-btn:first-child > label,
  .input-group-btn:first-child > .btn-group {
    margin-right: -1px; }
  .input-group-btn:last-child > .btn, .icon-nav .input-group-btn:last-child > label,
  .input-group-btn:last-child > .btn-group {
    margin-left: -1px; }

.nav {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none; }
  .nav:before, .nav:after {
    content: " ";
    display: table; }
  .nav:after {
    clear: both; }
  .nav > li {
    position: relative;
    display: block; }
    .nav > li > a {
      position: relative;
      display: block;
      padding: 10px 15px; }
      .nav > li > a:hover, .nav > li > a:focus {
        text-decoration: none;
        background-color: #d5d5d5; }
    .nav > li.disabled > a {
      color: #777777; }
      .nav > li.disabled > a:hover, .nav > li.disabled > a:focus {
        color: #777777;
        text-decoration: none;
        background-color: transparent;
        cursor: not-allowed; }
  .nav .open > a, .nav .open > a:hover, .nav .open > a:focus {
    background-color: #d5d5d5;
    border-color: #0081BA; }
  .nav .nav-divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5; }
  .nav > li > a > img {
    max-width: none; }

.nav-tabs {
  border-bottom: 1px solid #ddd; }
  .nav-tabs > li {
    float: left;
    margin-bottom: -1px; }
    .nav-tabs > li > a {
      margin-right: 2px;
      line-height: 1.42857;
      border: 1px solid transparent;
      border-radius: 4px 4px 0 0; }
      .nav-tabs > li > a:hover {
        border-color: #d5d5d5 #d5d5d5 #ddd; }
    .nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
      color: #5b5b5b;
      background-color: #F7F7F9;
      border: 1px solid #ddd;
      border-bottom-color: transparent;
      cursor: default; }

.nav-pills > li {
  float: left; }
  .nav-pills > li > a {
    border-radius: 4px; }
  .nav-pills > li + li {
    margin-left: 2px; }
  .nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {
    color: #5b5b5b;
    background-color: #0081BA; }

.nav-stacked > li {
  float: none; }
  .nav-stacked > li + li {
    margin-top: 2px;
    margin-left: 0; }

.nav-justified, .nav-tabs.nav-justified {
  width: 100%; }
  .nav-justified > li, .nav-tabs.nav-justified > li {
    float: none; }
    .nav-justified > li > a, .nav-tabs.nav-justified > li > a {
      text-align: center;
      margin-bottom: 5px; }
  .nav-justified > .dropdown .dropdown-menu {
    top: auto;
    left: auto; }
  @media (min-width: 768px) {
    .nav-justified > li, .nav-tabs.nav-justified > li {
      display: table-cell;
      width: 1%; }
      .nav-justified > li > a, .nav-tabs.nav-justified > li > a {
        margin-bottom: 0; } }

.nav-tabs-justified, .nav-tabs.nav-justified {
  border-bottom: 0; }
  .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {
    margin-right: 0;
    border-radius: 4px; }
  .nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,
  .nav-tabs-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:hover,
  .nav-tabs-justified > .active > a:focus, .nav-tabs.nav-justified > .active > a:focus {
    border: 1px solid #ddd; }
  @media (min-width: 768px) {
    .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {
      border-bottom: 1px solid #ddd;
      border-radius: 4px 4px 0 0; }
    .nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,
    .nav-tabs-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:hover,
    .nav-tabs-justified > .active > a:focus, .nav-tabs.nav-justified > .active > a:focus {
      border-bottom-color: #F7F7F9; } }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-right-radius: 0;
  border-top-left-radius: 0; }

.navbar {
  position: relative;
  min-height: 50px;
  margin-bottom: 20px;
  border: 1px solid transparent; }
  .navbar:before, .navbar:after {
    content: " ";
    display: table; }
  .navbar:after {
    clear: both; }
  @media (min-width: 768px) {
    .navbar {
      border-radius: 4px; } }

.navbar-header:before, .navbar-header:after {
  content: " ";
  display: table; }

.navbar-header:after {
  clear: both; }

@media (min-width: 768px) {
  .navbar-header {
    float: left; } }

.navbar-collapse {
  overflow-x: visible;
  padding-right: 7px;
  padding-left: 7px;
  border-top: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  -webkit-overflow-scrolling: touch; }
  .navbar-collapse:before, .navbar-collapse:after {
    content: " ";
    display: table; }
  .navbar-collapse:after {
    clear: both; }
  .navbar-collapse.in {
    overflow-y: auto; }
  @media (min-width: 768px) {
    .navbar-collapse {
      width: auto;
      border-top: 0;
      box-shadow: none; }
      .navbar-collapse.collapse {
        display: block !important;
        height: auto !important;
        padding-bottom: 0;
        overflow: visible !important; }
      .navbar-collapse.in {
        overflow-y: visible; }
      .navbar-fixed-top .navbar-collapse,
      .navbar-static-top .navbar-collapse,
      .navbar-fixed-bottom .navbar-collapse {
        padding-left: 0;
        padding-right: 0; } }

.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: 340px; }
  @media (max-width: 480px) and (orientation: landscape) {
    .navbar-fixed-top .navbar-collapse,
    .navbar-fixed-bottom .navbar-collapse {
      max-height: 200px; } }

.container > .navbar-header,
.container > .navbar-collapse,
.container-fluid > .navbar-header,
.container-fluid > .navbar-collapse {
  margin-right: -7px;
  margin-left: -7px; }
  @media (min-width: 768px) {
    .container > .navbar-header,
    .container > .navbar-collapse,
    .container-fluid > .navbar-header,
    .container-fluid > .navbar-collapse {
      margin-right: 0;
      margin-left: 0; } }

.navbar-static-top {
  z-index: 1000;
  border-width: 0 0 1px; }
  @media (min-width: 768px) {
    .navbar-static-top {
      border-radius: 0; } }

.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0); }
  @media (min-width: 768px) {
    .navbar-fixed-top,
    .navbar-fixed-bottom {
      border-radius: 0; } }

.navbar-fixed-top {
  top: 0;
  border-width: 0 0 1px; }

.navbar-fixed-bottom {
  bottom: 0;
  margin-bottom: 0;
  border-width: 1px 0 0; }

.navbar-brand {
  float: left;
  padding: 15px 7px;
  font-size: 18px;
  line-height: 20px;
  height: 50px; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }
  @media (min-width: 768px) {
    .navbar > .container .navbar-brand,
    .navbar > .container-fluid .navbar-brand {
      margin-left: -7px; } }

.navbar-toggle {
  position: relative;
  float: right;
  margin-right: 7px;
  padding: 9px 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px; }
  .navbar-toggle:focus {
    outline: 0; }
  .navbar-toggle .icon-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px; }
  .navbar-toggle .icon-bar + .icon-bar {
    margin-top: 4px; }
  @media (min-width: 768px) {
    .navbar-toggle {
      display: none; } }

.navbar-nav {
  margin: 7.5px -7px; }
  .navbar-nav > li > a {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 20px; }
  @media (max-width: 767px) {
    .navbar-nav .open .dropdown-menu {
      position: static;
      float: none;
      width: auto;
      margin-top: 0;
      background-color: transparent;
      border: 0;
      box-shadow: none; }
      .navbar-nav .open .dropdown-menu > li > a,
      .navbar-nav .open .dropdown-menu .dropdown-header {
        padding: 5px 15px 5px 25px; }
      .navbar-nav .open .dropdown-menu > li > a {
        line-height: 20px; }
        .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-nav .open .dropdown-menu > li > a:focus {
          background-image: none; } }
  @media (min-width: 768px) {
    .navbar-nav {
      float: left;
      margin: 0; }
      .navbar-nav > li {
        float: left; }
        .navbar-nav > li > a {
          padding-top: 15px;
          padding-bottom: 15px; }
      .navbar-nav.navbar-right:last-child {
        margin-right: -7px; } }

@media (min-width: 768px) {
  .navbar-left {
    float: left !important; }
  .navbar-right {
    float: right !important; } }

.navbar-form {
  margin-left: -7px;
  margin-right: -7px;
  padding: 10px 7px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  margin-top: 8px;
  margin-bottom: 8px; }
  @media (max-width: 767px) {
    .navbar-form .form-group {
      margin-bottom: 5px; } }
  @media (min-width: 768px) {
    .navbar-form {
      width: auto;
      border: 0;
      margin-left: 0;
      margin-right: 0;
      padding-top: 0;
      padding-bottom: 0;
      -webkit-box-shadow: none;
      box-shadow: none; }
      .navbar-form.navbar-right:last-child {
        margin-right: -7px; } }

.navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0; }

.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.navbar-btn, .navbar .navbar-nav > li button {
  margin-top: 8px;
  margin-bottom: 8px; }
  .navbar-btn.btn-sm, .btn-group-sm > .navbar-btn.btn, .navbar .navbar-nav > li .btn-group-sm > button.btn, .icon-nav .btn-group-sm > label.navbar-btn, .navbar-btn.btn-github, .navbar .navbar-nav > li button.btn-github, .navbar .navbar-nav > li button.btn-sm {
    margin-top: 10px;
    margin-bottom: 10px; }
  .navbar-btn.btn-xs, .btn-group-xs > .navbar-btn.btn, .navbar .navbar-nav > li .btn-group-xs > button.btn, .icon-nav .btn-group-xs > label.navbar-btn, .navbar .navbar-nav > li button.btn-xs {
    margin-top: 14px;
    margin-bottom: 14px; }

.navbar-text {
  margin-top: 15px;
  margin-bottom: 15px; }
  @media (min-width: 768px) {
    .navbar-text {
      float: left;
      margin-left: 7px;
      margin-right: 7px; }
      .navbar-text.navbar-right:last-child {
        margin-right: 0; } }

.navbar-default {
  background-color: #fff;
  border-color: #e5e5e5; }
  .navbar-default .navbar-brand {
    color: #020621; }
    .navbar-default .navbar-brand:hover, .navbar-default .navbar-brand:focus {
      color: black;
      background-color: transparent; }
  .navbar-default .navbar-text {
    color: #777; }
  .navbar-default .navbar-nav > li > a {
    color: #020621; }
    .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {
      color: #020621;
      background-color: #f4f4f4; }
  .navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {
    color: #020621;
    background-color: #2d60ad; }
  .navbar-default .navbar-nav > .disabled > a, .navbar-default .navbar-nav > .disabled > a:hover, .navbar-default .navbar-nav > .disabled > a:focus {
    color: #ccc;
    background-color: transparent; }
  .navbar-default .navbar-toggle {
    border-color: #ddd; }
    .navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus {
      background-color: #ddd; }
    .navbar-default .navbar-toggle .icon-bar {
      background-color: #888; }
  .navbar-default .navbar-collapse,
  .navbar-default .navbar-form {
    border-color: #e5e5e5; }
  .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:hover, .navbar-default .navbar-nav > .open > a:focus {
    background-color: #2d60ad;
    color: #020621; }
  @media (max-width: 767px) {
    .navbar-default .navbar-nav .open .dropdown-menu > li > a {
      color: #020621; }
      .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
        color: #020621;
        background-color: #f4f4f4; }
    .navbar-default .navbar-nav .open .dropdown-menu > .active > a, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
      color: #020621;
      background-color: #2d60ad; }
    .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {
      color: #ccc;
      background-color: transparent; } }
  .navbar-default .navbar-link {
    color: #020621; }
    .navbar-default .navbar-link:hover {
      color: #020621; }
  .navbar-default .btn-link {
    color: #020621; }
    .navbar-default .btn-link:hover, .navbar-default .btn-link:focus {
      color: #020621; }
    .navbar-default .btn-link[disabled]:hover, .navbar-default .btn-link[disabled]:focus,
    fieldset[disabled] .navbar-default .btn-link:hover,
    fieldset[disabled] .navbar-default .btn-link:focus {
      color: #ccc; }

.navbar-inverse {
  background-color: #222;
  border-color: #090909; }
  .navbar-inverse .navbar-brand {
    color: #777777; }
    .navbar-inverse .navbar-brand:hover, .navbar-inverse .navbar-brand:focus {
      color: #fff;
      background-color: transparent; }
  .navbar-inverse .navbar-text {
    color: #777777; }
  .navbar-inverse .navbar-nav > li > a {
    color: #777777; }
    .navbar-inverse .navbar-nav > li > a:hover, .navbar-inverse .navbar-nav > li > a:focus {
      color: #fff;
      background-color: transparent; }
  .navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover, .navbar-inverse .navbar-nav > .active > a:focus {
    color: #fff;
    background-color: #080808; }
  .navbar-inverse .navbar-nav > .disabled > a, .navbar-inverse .navbar-nav > .disabled > a:hover, .navbar-inverse .navbar-nav > .disabled > a:focus {
    color: #444;
    background-color: transparent; }
  .navbar-inverse .navbar-toggle {
    border-color: #333; }
    .navbar-inverse .navbar-toggle:hover, .navbar-inverse .navbar-toggle:focus {
      background-color: #333; }
    .navbar-inverse .navbar-toggle .icon-bar {
      background-color: #fff; }
  .navbar-inverse .navbar-collapse,
  .navbar-inverse .navbar-form {
    border-color: #101010; }
  .navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus {
    background-color: #080808;
    color: #fff; }
  @media (max-width: 767px) {
    .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
      border-color: #090909; }
    .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
      background-color: #090909; }
    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
      color: #777777; }
      .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
        color: #fff;
        background-color: transparent; }
    .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
      color: #fff;
      background-color: #080808; }
    .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
      color: #444;
      background-color: transparent; } }
  .navbar-inverse .navbar-link {
    color: #777777; }
    .navbar-inverse .navbar-link:hover {
      color: #fff; }
  .navbar-inverse .btn-link {
    color: #777777; }
    .navbar-inverse .btn-link:hover, .navbar-inverse .btn-link:focus {
      color: #fff; }
    .navbar-inverse .btn-link[disabled]:hover, .navbar-inverse .btn-link[disabled]:focus,
    fieldset[disabled] .navbar-inverse .btn-link:hover,
    fieldset[disabled] .navbar-inverse .btn-link:focus {
      color: #444; }

.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 20px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 4px; }
  .breadcrumb > li {
    display: inline-block; }
    .breadcrumb > li + li:before {
      content: "/ ";
      padding: 0 5px;
      color: #ccc; }
  .breadcrumb > .active {
    color: #777777; }

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px; }
  .pagination > li {
    display: inline; }
    .pagination > li > a,
    .pagination > li > span {
      position: relative;
      float: left;
      padding: 6px 12px;
      line-height: 1.42857;
      text-decoration: none;
      color: #0081BA;
      background-color: #fff;
      border: 1px solid #ddd;
      margin-left: -1px; }
    .pagination > li:first-child > a,
    .pagination > li:first-child > span {
      margin-left: 0;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px; }
    .pagination > li:last-child > a,
    .pagination > li:last-child > span {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px; }
  .pagination > li > a:hover, .pagination > li > a:focus,
  .pagination > li > span:hover,
  .pagination > li > span:focus {
    color: #005e87;
    background-color: #d5d5d5;
    border-color: #ddd; }
  .pagination > .active > a, .pagination > .active > a:hover, .pagination > .active > a:focus,
  .pagination > .active > span,
  .pagination > .active > span:hover,
  .pagination > .active > span:focus {
    z-index: 2;
    color: #fff;
    background-color: #0081BA;
    border-color: #0081BA;
    cursor: default; }
  .pagination > .disabled > span,
  .pagination > .disabled > span:hover,
  .pagination > .disabled > span:focus,
  .pagination > .disabled > a,
  .pagination > .disabled > a:hover,
  .pagination > .disabled > a:focus {
    color: #777777;
    background-color: #fff;
    border-color: #ddd;
    cursor: not-allowed; }

.pagination-lg > li > a,
.pagination-lg > li > span {
  padding: 10px 16px;
  font-size: 18px; }

.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px; }

.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px; }

.pagination-sm > li > a,
.pagination-sm > li > span {
  padding: 5px 10px;
  font-size: 12px; }

.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px; }

.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px; }

.pager {
  padding-left: 0;
  margin: 20px 0;
  list-style: none;
  text-align: center; }
  .pager:before, .pager:after {
    content: " ";
    display: table; }
  .pager:after {
    clear: both; }
  .pager li {
    display: inline; }
    .pager li > a,
    .pager li > span {
      display: inline-block;
      padding: 5px 14px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 15px; }
    .pager li > a:hover,
    .pager li > a:focus {
      text-decoration: none;
      background-color: #d5d5d5; }
  .pager .next > a,
  .pager .next > span {
    float: right; }
  .pager .previous > a,
  .pager .previous > span {
    float: left; }
  .pager .disabled > a,
  .pager .disabled > a:hover,
  .pager .disabled > a:focus,
  .pager .disabled > span {
    color: #777777;
    background-color: #fff;
    cursor: not-allowed; }

.label {
  display: inline;
  padding: .2em .6em .3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25em; }
  .label:empty {
    display: none; }
  .btn .label, .icon-nav label .label {
    position: relative;
    top: -1px; }

a.label:hover, a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer; }

.label-default {
  background-color: #777777; }
  .label-default[href]:hover, .label-default[href]:focus {
    background-color: #5e5e5e; }

.label-primary {
  background-color: #0081BA; }
  .label-primary[href]:hover, .label-primary[href]:focus {
    background-color: #005e87; }

.label-success {
  background-color: #4ab767; }
  .label-success[href]:hover, .label-success[href]:focus {
    background-color: #3b9352; }

.label-info {
  background-color: #5bc0de; }
  .label-info[href]:hover, .label-info[href]:focus {
    background-color: #31b0d5; }

.label-warning {
  background-color: #f0ad4e; }
  .label-warning[href]:hover, .label-warning[href]:focus {
    background-color: #ec971f; }

.label-danger {
  background-color: #c0392b; }
  .label-danger[href]:hover, .label-danger[href]:focus {
    background-color: #962d22; }

.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: #777777;
  border-radius: 10px; }
  .badge:empty {
    display: none; }
  .btn .badge, .icon-nav label .badge {
    position: relative;
    top: -1px; }
  .btn-xs .badge, .btn-group-xs > .btn .badge, .icon-nav .btn-group-xs > label .badge {
    top: 0;
    padding: 1px 5px; }
  a.list-group-item.active > .badge,
  .nav-pills > .active > a > .badge {
    color: #0081BA;
    background-color: #fff; }
  .nav-pills > li > a > .badge {
    margin-left: 3px; }

a.badge:hover, a.badge:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer; }

.jumbotron, .paid-on-board {
  padding: 30px;
  margin-bottom: 30px;
  color: inherit;
  background-color: #d5d5d5; }
  .jumbotron h1, .paid-on-board h1,
  .jumbotron .h1, .paid-on-board .h1 {
    color: inherit; }
  .jumbotron p, .paid-on-board p {
    margin-bottom: 15px;
    font-size: 21px;
    font-weight: 200; }
  .jumbotron > hr, .paid-on-board > hr {
    border-top-color: #bbbbbb; }
  .container .jumbotron, .container .paid-on-board {
    border-radius: 6px; }
  .jumbotron .container, .paid-on-board .container {
    max-width: 100%; }
  @media screen and (min-width: 768px) {
    .jumbotron, .paid-on-board {
      padding-top: 48px;
      padding-bottom: 48px; }
      .container .jumbotron, .container .paid-on-board {
        padding-left: 60px;
        padding-right: 60px; }
      .jumbotron h1, .paid-on-board h1,
      .jumbotron .h1, .paid-on-board .h1 {
        font-size: 63px; } }

.thumbnail {
  display: block;
  padding: 0;
  margin-bottom: 20px;
  line-height: 1.42857;
  background-color: #F7F7F9;
  border: 1px solid #ddd;
  border-radius: 0;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out; }
  .thumbnail > img,
  .thumbnail a > img {
    display: block;
    width: 100% \\9;
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto; }
  .thumbnail .caption {
    padding: 9px;
    color: #020621; }

a.thumbnail:hover,
a.thumbnail:focus,
a.thumbnail.active {
  border-color: #0081BA; }

.alert, .support-app .support-time {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px; }
  .alert h4, .support-app .support-time h4 {
    margin-top: 0;
    color: inherit; }
  .alert .alert-link, .support-app .support-time .alert-link {
    font-weight: bold; }
  .alert > p, .support-app .support-time > p,
  .alert > ul, .support-app .support-time > ul {
    margin-bottom: 0; }
  .alert > p + p, .support-app .support-time > p + p {
    margin-top: 5px; }

.alert-dismissable,
.alert-dismissible {
  padding-right: 35px; }
  .alert-dismissable .close,
  .alert-dismissible .close {
    position: relative;
    top: -2px;
    right: -21px;
    color: inherit; }

.alert-success {
  background-color: #dff0d8;
  border-color: #d6e9c6;
  color: #4ab767; }
  .alert-success hr {
    border-top-color: #c9e2b3; }
  .alert-success .alert-link {
    color: #3b9352; }

.alert-info {
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f; }
  .alert-info hr {
    border-top-color: #a6e1ec; }
  .alert-info .alert-link {
    color: #245269; }

.alert-warning {
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #333; }
  .alert-warning hr {
    border-top-color: #f7e1b5; }
  .alert-warning .alert-link {
    color: #1a1a1a; }

.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #333; }
  .alert-danger hr {
    border-top-color: #e4b9c0; }
  .alert-danger .alert-link {
    color: #1a1a1a; }

@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0; }
  to {
    background-position: 0 0; } }

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0; }
  to {
    background-position: 0 0; } }

.progress {
  overflow: hidden;
  height: 20px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1); }

.progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #0081BA;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 0.6s ease;
  -o-transition: width 0.6s ease;
  transition: width 0.6s ease; }

.progress-striped .progress-bar,
.progress-bar-striped {
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 40px 40px; }

.progress.active .progress-bar,
.progress-bar.active {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  -o-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite; }

.progress-bar[aria-valuenow="1"], .progress-bar[aria-valuenow="2"] {
  min-width: 30px; }

.progress-bar[aria-valuenow="0"] {
  color: #777777;
  min-width: 30px;
  background-color: transparent;
  background-image: none;
  box-shadow: none; }

.progress-bar-success {
  background-color: #4ab767; }
  .progress-striped .progress-bar-success {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }

.progress-bar-info {
  background-color: #5bc0de; }
  .progress-striped .progress-bar-info {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }

.progress-bar-warning {
  background-color: #f0ad4e; }
  .progress-striped .progress-bar-warning {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }

.progress-bar-danger {
  background-color: #c0392b; }
  .progress-striped .progress-bar-danger {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }

.media,
.media-body {
  overflow: hidden;
  zoom: 1; }

.media,
.media .media {
  margin-top: 15px; }

.media:first-child {
  margin-top: 0; }

.media-object {
  display: block; }

.media-heading {
  margin: 0 0 5px; }

.media > .pull-left {
  margin-right: 10px; }

.media > .pull-right {
  margin-left: 10px; }

.media-list {
  padding-left: 0;
  list-style: none; }

.list-group {
  margin-bottom: 20px;
  padding-left: 0; }

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd; }
  .list-group-item:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px; }
  .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px; }
  .list-group-item > .badge {
    float: right; }
  .list-group-item > .badge + .badge {
    margin-right: 5px; }

a.list-group-item {
  color: #555; }
  a.list-group-item .list-group-item-heading {
    color: #333; }
  a.list-group-item:hover, a.list-group-item:focus {
    text-decoration: none;
    color: #555;
    background-color: #f5f5f5; }

.list-group-item.disabled, .list-group-item.disabled:hover, .list-group-item.disabled:focus {
  background-color: #d5d5d5;
  color: #777777; }
  .list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading {
    color: inherit; }
  .list-group-item.disabled .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text {
    color: #777777; }

.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
  z-index: 2;
  color: #5b5b5b;
  background-color: #428bca;
  border-color: #428bca; }
  .list-group-item.active .list-group-item-heading,
  .list-group-item.active .list-group-item-heading > small,
  .list-group-item.active .list-group-item-heading > .small, .list-group-item.active:hover .list-group-item-heading,
  .list-group-item.active:hover .list-group-item-heading > small,
  .list-group-item.active:hover .list-group-item-heading > .small, .list-group-item.active:focus .list-group-item-heading,
  .list-group-item.active:focus .list-group-item-heading > small,
  .list-group-item.active:focus .list-group-item-heading > .small {
    color: inherit; }
  .list-group-item.active .list-group-item-text, .list-group-item.active:hover .list-group-item-text, .list-group-item.active:focus .list-group-item-text {
    color: #e1edf7; }

.list-group-item-success {
  color: #4ab767;
  background-color: #dff0d8; }

a.list-group-item-success {
  color: #4ab767; }
  a.list-group-item-success .list-group-item-heading {
    color: inherit; }
  a.list-group-item-success:hover, a.list-group-item-success:focus {
    color: #4ab767;
    background-color: #d0e9c6; }
  a.list-group-item-success.active, a.list-group-item-success.active:hover, a.list-group-item-success.active:focus {
    color: #fff;
    background-color: #4ab767;
    border-color: #4ab767; }

.list-group-item-info {
  color: #31708f;
  background-color: #d9edf7; }

a.list-group-item-info {
  color: #31708f; }
  a.list-group-item-info .list-group-item-heading {
    color: inherit; }
  a.list-group-item-info:hover, a.list-group-item-info:focus {
    color: #31708f;
    background-color: #c4e3f3; }
  a.list-group-item-info.active, a.list-group-item-info.active:hover, a.list-group-item-info.active:focus {
    color: #fff;
    background-color: #31708f;
    border-color: #31708f; }

.list-group-item-warning {
  color: #8a6d3b;
  background-color: #fcf8e3; }

a.list-group-item-warning {
  color: #8a6d3b; }
  a.list-group-item-warning .list-group-item-heading {
    color: inherit; }
  a.list-group-item-warning:hover, a.list-group-item-warning:focus {
    color: #8a6d3b;
    background-color: #faf2cc; }
  a.list-group-item-warning.active, a.list-group-item-warning.active:hover, a.list-group-item-warning.active:focus {
    color: #fff;
    background-color: #8a6d3b;
    border-color: #8a6d3b; }

.list-group-item-danger {
  color: #c0392b;
  background-color: #f2dede; }

a.list-group-item-danger {
  color: #c0392b; }
  a.list-group-item-danger .list-group-item-heading {
    color: inherit; }
  a.list-group-item-danger:hover, a.list-group-item-danger:focus {
    color: #c0392b;
    background-color: #ebcccc; }
  a.list-group-item-danger.active, a.list-group-item-danger.active:hover, a.list-group-item-danger.active:focus {
    color: #fff;
    background-color: #c0392b;
    border-color: #c0392b; }

.list-group-item-heading {
  margin-top: 0;
  margin-bottom: 5px; }

.list-group-item-text {
  margin-bottom: 0;
  line-height: 1.3; }

.panel, .content-box, .select-subcompany-modal .list-group, .content-box-editable, .card, #appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); }

.panel-body, .content-box-body {
  padding: 15px; }
  .panel-body:before, .content-box-body:before, .panel-body:after, .content-box-body:after {
    content: " ";
    display: table; }
  .panel-body:after, .content-box-body:after {
    clear: both; }

.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px; }
  .panel-heading > .dropdown .dropdown-toggle {
    color: inherit; }

.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit; }
  .panel-title > a {
    color: inherit; }

.panel-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px; }

.panel > .list-group, .content-box > .list-group, .select-subcompany-modal .list-group > .list-group, .content-box-editable > .list-group, .card > .list-group, #appLauncherContainer .scrollable-list > .list-group, #appLauncherContainer .template-grid > .list-group {
  margin-bottom: 0; }
  .panel > .list-group .list-group-item, .content-box > .list-group .list-group-item, .select-subcompany-modal .list-group > .list-group .list-group-item, .content-box-editable > .list-group .list-group-item, .card > .list-group .list-group-item, #appLauncherContainer .scrollable-list > .list-group .list-group-item, #appLauncherContainer .template-grid > .list-group .list-group-item {
    border-width: 1px 0;
    border-radius: 0; }
  .panel > .list-group:first-child .list-group-item:first-child, .content-box > .list-group:first-child .list-group-item:first-child, .select-subcompany-modal .list-group > .list-group:first-child .list-group-item:first-child, .content-box-editable > .list-group:first-child .list-group-item:first-child, .card > .list-group:first-child .list-group-item:first-child, #appLauncherContainer .scrollable-list > .list-group:first-child .list-group-item:first-child, #appLauncherContainer .template-grid > .list-group:first-child .list-group-item:first-child {
    border-top: 0;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px; }
  .panel > .list-group:last-child .list-group-item:last-child, .content-box > .list-group:last-child .list-group-item:last-child, .select-subcompany-modal .list-group > .list-group:last-child .list-group-item:last-child, .content-box-editable > .list-group:last-child .list-group-item:last-child, .card > .list-group:last-child .list-group-item:last-child, #appLauncherContainer .scrollable-list > .list-group:last-child .list-group-item:last-child, #appLauncherContainer .template-grid > .list-group:last-child .list-group-item:last-child {
    border-bottom: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px; }

.panel-heading + .list-group .list-group-item:first-child {
  border-top-width: 0; }

.list-group + .panel-footer {
  border-top-width: 0; }

.panel > .table, .content-box > .table, .select-subcompany-modal .list-group > .table, .content-box-editable > .table, .card > .table, #appLauncherContainer .scrollable-list > .table, #appLauncherContainer .template-grid > .table, .panel > .table-2, .content-box > .table-2, .select-subcompany-modal .list-group > .table-2, .content-box-editable > .table-2, .card > .table-2, #appLauncherContainer .scrollable-list > .table-2, #appLauncherContainer .template-grid > .table-2,
.panel > .table-responsive > .table, .content-box > .table-responsive > .table, .select-subcompany-modal .list-group > .table-responsive > .table, .content-box-editable > .table-responsive > .table, .card > .table-responsive > .table, #appLauncherContainer .scrollable-list > .table-responsive > .table, #appLauncherContainer .template-grid > .table-responsive > .table,
.panel > .table-responsive > .table-2, .content-box > .table-responsive > .table-2, .select-subcompany-modal .list-group > .table-responsive > .table-2, .content-box-editable > .table-responsive > .table-2, .card > .table-responsive > .table-2, #appLauncherContainer .scrollable-list > .table-responsive > .table-2, #appLauncherContainer .template-grid > .table-responsive > .table-2,
.panel > .panel-collapse > .table, .content-box > .panel-collapse > .table, .select-subcompany-modal .list-group > .panel-collapse > .table, .content-box-editable > .panel-collapse > .table, .card > .panel-collapse > .table, #appLauncherContainer .scrollable-list > .panel-collapse > .table, #appLauncherContainer .template-grid > .panel-collapse > .table,
.panel > .panel-collapse > .table-2, .content-box > .panel-collapse > .table-2, .select-subcompany-modal .list-group > .panel-collapse > .table-2, .content-box-editable > .panel-collapse > .table-2, .card > .panel-collapse > .table-2, #appLauncherContainer .scrollable-list > .panel-collapse > .table-2, #appLauncherContainer .template-grid > .panel-collapse > .table-2 {
  margin-bottom: 0; }

.panel > .table:first-child, .content-box > .table:first-child, .select-subcompany-modal .list-group > .table:first-child, .content-box-editable > .table:first-child, .card > .table:first-child, #appLauncherContainer .scrollable-list > .table:first-child, #appLauncherContainer .template-grid > .table:first-child, .panel > .table-2:first-child, .content-box > .table-2:first-child, .select-subcompany-modal .list-group > .table-2:first-child, .content-box-editable > .table-2:first-child, .card > .table-2:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child, #appLauncherContainer .template-grid > .table-2:first-child,
.panel > .table-responsive:first-child > .table:first-child, .content-box > .table-responsive:first-child > .table:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child, .card > .table-responsive:first-child > .table:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child,
.panel > .table-responsive:first-child > .table-2:first-child, .content-box > .table-responsive:first-child > .table-2:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child, .card > .table-responsive:first-child > .table-2:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child {
  border-top-right-radius: 3px;
  border-top-left-radius: 3px; }
  .panel > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child td:first-child, .card > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child td:first-child, .panel > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child td:first-child,
  .panel > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child th:first-child, .card > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child th:first-child,
  .panel > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child th:first-child,
  .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child td:first-child,
  .panel > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child td:first-child,
  .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child th:first-child,
  .panel > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child th:first-child,
  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,
  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child,
  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,
  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child,
  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,
  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child,
  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child,
  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child {
    border-top-left-radius: 3px; }
  .panel > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child td:last-child, .card > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child td:last-child, .panel > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child td:last-child,
  .panel > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child th:last-child, .card > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child th:last-child,
  .panel > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child th:last-child,
  .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child td:last-child,
  .panel > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child td:last-child,
  .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child th:last-child,
  .panel > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child th:last-child,
  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,
  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child,
  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,
  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child,
  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,
  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child,
  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child,
  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child {
    border-top-right-radius: 3px; }

.panel > .table:last-child, .content-box > .table:last-child, .select-subcompany-modal .list-group > .table:last-child, .content-box-editable > .table:last-child, .card > .table:last-child, #appLauncherContainer .scrollable-list > .table:last-child, #appLauncherContainer .template-grid > .table:last-child, .panel > .table-2:last-child, .content-box > .table-2:last-child, .select-subcompany-modal .list-group > .table-2:last-child, .content-box-editable > .table-2:last-child, .card > .table-2:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child, #appLauncherContainer .template-grid > .table-2:last-child,
.panel > .table-responsive:last-child > .table:last-child, .content-box > .table-responsive:last-child > .table:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child, .card > .table-responsive:last-child > .table:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child,
.panel > .table-responsive:last-child > .table-2:last-child, .content-box > .table-responsive:last-child > .table-2:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child, .card > .table-responsive:last-child > .table-2:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px; }
  .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child td:first-child, .panel > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child td:first-child,
  .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child th:first-child,
  .panel > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child th:first-child,
  .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
  .panel > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child,
  .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
  .panel > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child,
  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child,
  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child,
  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child,
  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child {
    border-bottom-left-radius: 3px; }
  .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child td:last-child, .panel > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child td:last-child,
  .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child th:last-child,
  .panel > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child th:last-child,
  .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
  .panel > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child,
  .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
  .panel > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child,
  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child,
  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child,
  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child,
  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child {
    border-bottom-right-radius: 3px; }

.panel > .panel-body + .table, .content-box > .panel-body + .table, .select-subcompany-modal .list-group > .panel-body + .table, .content-box-editable > .panel-body + .table, .card > .panel-body + .table, #appLauncherContainer .scrollable-list > .panel-body + .table, #appLauncherContainer .template-grid > .panel-body + .table, .panel > .content-box-body + .table, .content-box > .content-box-body + .table, .select-subcompany-modal .list-group > .content-box-body + .table, .content-box-editable > .content-box-body + .table, .card > .content-box-body + .table, #appLauncherContainer .scrollable-list > .content-box-body + .table, #appLauncherContainer .template-grid > .content-box-body + .table, .panel > .panel-body + .table-2, .content-box > .panel-body + .table-2, .select-subcompany-modal .list-group > .panel-body + .table-2, .content-box-editable > .panel-body + .table-2, .card > .panel-body + .table-2, #appLauncherContainer .scrollable-list > .panel-body + .table-2, #appLauncherContainer .template-grid > .panel-body + .table-2, .panel > .content-box-body + .table-2, .content-box > .content-box-body + .table-2, .select-subcompany-modal .list-group > .content-box-body + .table-2, .content-box-editable > .content-box-body + .table-2, .card > .content-box-body + .table-2, #appLauncherContainer .scrollable-list > .content-box-body + .table-2, #appLauncherContainer .template-grid > .content-box-body + .table-2,
.panel > .panel-body + .table-responsive, .content-box > .panel-body + .table-responsive, .select-subcompany-modal .list-group > .panel-body + .table-responsive, .content-box-editable > .panel-body + .table-responsive, .card > .panel-body + .table-responsive, #appLauncherContainer .scrollable-list > .panel-body + .table-responsive, #appLauncherContainer .template-grid > .panel-body + .table-responsive,
.panel > .content-box-body + .table-responsive, .content-box > .content-box-body + .table-responsive, .select-subcompany-modal .list-group > .content-box-body + .table-responsive, .content-box-editable > .content-box-body + .table-responsive, .card > .content-box-body + .table-responsive, #appLauncherContainer .scrollable-list > .content-box-body + .table-responsive, #appLauncherContainer .template-grid > .content-box-body + .table-responsive {
  border-top: 1px solid #F1EEEA; }

.panel > .table > tbody:first-child > tr:first-child th, .content-box > .table > tbody:first-child > tr:first-child th, .select-subcompany-modal .list-group > .table > tbody:first-child > tr:first-child th, .content-box-editable > .table > tbody:first-child > tr:first-child th, .card > .table > tbody:first-child > tr:first-child th, #appLauncherContainer .scrollable-list > .table > tbody:first-child > tr:first-child th, #appLauncherContainer .template-grid > .table > tbody:first-child > tr:first-child th, .panel > .table-2 > tbody:first-child > tr:first-child th, .content-box > .table-2 > tbody:first-child > tr:first-child th, .select-subcompany-modal .list-group > .table-2 > tbody:first-child > tr:first-child th, .content-box-editable > .table-2 > tbody:first-child > tr:first-child th, .card > .table-2 > tbody:first-child > tr:first-child th, #appLauncherContainer .scrollable-list > .table-2 > tbody:first-child > tr:first-child th, #appLauncherContainer .template-grid > .table-2 > tbody:first-child > tr:first-child th,
.panel > .table > tbody:first-child > tr:first-child td, .content-box > .table > tbody:first-child > tr:first-child td, .select-subcompany-modal .list-group > .table > tbody:first-child > tr:first-child td, .content-box-editable > .table > tbody:first-child > tr:first-child td, .card > .table > tbody:first-child > tr:first-child td, #appLauncherContainer .scrollable-list > .table > tbody:first-child > tr:first-child td, #appLauncherContainer .template-grid > .table > tbody:first-child > tr:first-child td,
.panel > .table-2 > tbody:first-child > tr:first-child td, .content-box > .table-2 > tbody:first-child > tr:first-child td, .select-subcompany-modal .list-group > .table-2 > tbody:first-child > tr:first-child td, .content-box-editable > .table-2 > tbody:first-child > tr:first-child td, .card > .table-2 > tbody:first-child > tr:first-child td, #appLauncherContainer .scrollable-list > .table-2 > tbody:first-child > tr:first-child td, #appLauncherContainer .template-grid > .table-2 > tbody:first-child > tr:first-child td {
  border-top: 0; }

.panel > .table-bordered, .content-box > .table-bordered, .select-subcompany-modal .list-group > .table-bordered, .content-box-editable > .table-bordered, .card > .table-bordered, #appLauncherContainer .scrollable-list > .table-bordered, #appLauncherContainer .template-grid > .table-bordered,
.panel > .table-responsive > .table-bordered, .content-box > .table-responsive > .table-bordered, .select-subcompany-modal .list-group > .table-responsive > .table-bordered, .content-box-editable > .table-responsive > .table-bordered, .card > .table-responsive > .table-bordered, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered, #appLauncherContainer .template-grid > .table-responsive > .table-bordered {
  border: 0; }
  .panel > .table-bordered > thead > tr > th:first-child, .content-box > .table-bordered > thead > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > th:first-child, .content-box-editable > .table-bordered > thead > tr > th:first-child, .card > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > th:first-child,
  .panel > .table-bordered > thead > tr > td:first-child, .content-box > .table-bordered > thead > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > td:first-child, .content-box-editable > .table-bordered > thead > tr > td:first-child, .card > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > td:first-child,
  .panel > .table-bordered > tbody > tr > th:first-child, .content-box > .table-bordered > tbody > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > th:first-child, .content-box-editable > .table-bordered > tbody > tr > th:first-child, .card > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > th:first-child,
  .panel > .table-bordered > tbody > tr > td:first-child, .content-box > .table-bordered > tbody > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > td:first-child, .content-box-editable > .table-bordered > tbody > tr > td:first-child, .card > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > td:first-child,
  .panel > .table-bordered > tfoot > tr > th:first-child, .content-box > .table-bordered > tfoot > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > th:first-child, .content-box-editable > .table-bordered > tfoot > tr > th:first-child, .card > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > th:first-child,
  .panel > .table-bordered > tfoot > tr > td:first-child, .content-box > .table-bordered > tfoot > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > td:first-child, .content-box-editable > .table-bordered > tfoot > tr > td:first-child, .card > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > td:first-child,
  .panel > .table-responsive > .table-bordered > thead > tr > th:first-child, .content-box > .table-responsive > .table-bordered > thead > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > th:first-child, .card > .table-responsive > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > th:first-child,
  .panel > .table-responsive > .table-bordered > thead > tr > td:first-child, .content-box > .table-responsive > .table-bordered > thead > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > td:first-child, .card > .table-responsive > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > td:first-child,
  .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child, .content-box > .table-responsive > .table-bordered > tbody > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > th:first-child, .card > .table-responsive > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child, .content-box > .table-responsive > .table-bordered > tbody > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > td:first-child, .card > .table-responsive > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .card > .table-responsive > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .card > .table-responsive > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0; }
  .panel > .table-bordered > thead > tr > th:last-child, .content-box > .table-bordered > thead > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > th:last-child, .content-box-editable > .table-bordered > thead > tr > th:last-child, .card > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > th:last-child,
  .panel > .table-bordered > thead > tr > td:last-child, .content-box > .table-bordered > thead > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > td:last-child, .content-box-editable > .table-bordered > thead > tr > td:last-child, .card > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > td:last-child,
  .panel > .table-bordered > tbody > tr > th:last-child, .content-box > .table-bordered > tbody > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > th:last-child, .content-box-editable > .table-bordered > tbody > tr > th:last-child, .card > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > th:last-child,
  .panel > .table-bordered > tbody > tr > td:last-child, .content-box > .table-bordered > tbody > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > td:last-child, .content-box-editable > .table-bordered > tbody > tr > td:last-child, .card > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > td:last-child,
  .panel > .table-bordered > tfoot > tr > th:last-child, .content-box > .table-bordered > tfoot > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > th:last-child, .content-box-editable > .table-bordered > tfoot > tr > th:last-child, .card > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > th:last-child,
  .panel > .table-bordered > tfoot > tr > td:last-child, .content-box > .table-bordered > tfoot > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > td:last-child, .content-box-editable > .table-bordered > tfoot > tr > td:last-child, .card > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > td:last-child,
  .panel > .table-responsive > .table-bordered > thead > tr > th:last-child, .content-box > .table-responsive > .table-bordered > thead > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > th:last-child, .card > .table-responsive > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > th:last-child,
  .panel > .table-responsive > .table-bordered > thead > tr > td:last-child, .content-box > .table-responsive > .table-bordered > thead > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > td:last-child, .card > .table-responsive > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > td:last-child,
  .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child, .content-box > .table-responsive > .table-bordered > tbody > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > th:last-child, .card > .table-responsive > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child, .content-box > .table-responsive > .table-bordered > tbody > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > td:last-child, .card > .table-responsive > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .card > .table-responsive > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .card > .table-responsive > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0; }
  .panel > .table-bordered > thead > tr:first-child > td, .content-box > .table-bordered > thead > tr:first-child > td, .select-subcompany-modal .list-group > .table-bordered > thead > tr:first-child > td, .content-box-editable > .table-bordered > thead > tr:first-child > td, .card > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .template-grid > .table-bordered > thead > tr:first-child > td,
  .panel > .table-bordered > thead > tr:first-child > th, .content-box > .table-bordered > thead > tr:first-child > th, .select-subcompany-modal .list-group > .table-bordered > thead > tr:first-child > th, .content-box-editable > .table-bordered > thead > tr:first-child > th, .card > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .template-grid > .table-bordered > thead > tr:first-child > th,
  .panel > .table-bordered > tbody > tr:first-child > td, .content-box > .table-bordered > tbody > tr:first-child > td, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:first-child > td, .content-box-editable > .table-bordered > tbody > tr:first-child > td, .card > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:first-child > td,
  .panel > .table-bordered > tbody > tr:first-child > th, .content-box > .table-bordered > tbody > tr:first-child > th, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:first-child > th, .content-box-editable > .table-bordered > tbody > tr:first-child > th, .card > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:first-child > th,
  .panel > .table-responsive > .table-bordered > thead > tr:first-child > td, .content-box > .table-responsive > .table-bordered > thead > tr:first-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr:first-child > td, .content-box-editable > .table-responsive > .table-bordered > thead > tr:first-child > td, .card > .table-responsive > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr:first-child > td,
  .panel > .table-responsive > .table-bordered > thead > tr:first-child > th, .content-box > .table-responsive > .table-bordered > thead > tr:first-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr:first-child > th, .content-box-editable > .table-responsive > .table-bordered > thead > tr:first-child > th, .card > .table-responsive > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr:first-child > th,
  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > td, .content-box > .table-responsive > .table-bordered > tbody > tr:first-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:first-child > td, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:first-child > td, .card > .table-responsive > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:first-child > td,
  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > th, .content-box > .table-responsive > .table-bordered > tbody > tr:first-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:first-child > th, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:first-child > th, .card > .table-responsive > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:first-child > th {
    border-bottom: 0; }
  .panel > .table-bordered > tbody > tr:last-child > td, .content-box > .table-bordered > tbody > tr:last-child > td, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:last-child > td, .content-box-editable > .table-bordered > tbody > tr:last-child > td, .card > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:last-child > td,
  .panel > .table-bordered > tbody > tr:last-child > th, .content-box > .table-bordered > tbody > tr:last-child > th, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:last-child > th, .content-box-editable > .table-bordered > tbody > tr:last-child > th, .card > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:last-child > th,
  .panel > .table-bordered > tfoot > tr:last-child > td, .content-box > .table-bordered > tfoot > tr:last-child > td, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr:last-child > td, .content-box-editable > .table-bordered > tfoot > tr:last-child > td, .card > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr:last-child > td,
  .panel > .table-bordered > tfoot > tr:last-child > th, .content-box > .table-bordered > tfoot > tr:last-child > th, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr:last-child > th, .content-box-editable > .table-bordered > tfoot > tr:last-child > th, .card > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr:last-child > th,
  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > td, .content-box > .table-responsive > .table-bordered > tbody > tr:last-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:last-child > td, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:last-child > td, .card > .table-responsive > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > th, .content-box > .table-responsive > .table-bordered > tbody > tr:last-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:last-child > th, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:last-child > th, .card > .table-responsive > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .content-box > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .card > .table-responsive > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr:last-child > td,
  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .content-box > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .card > .table-responsive > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr:last-child > th {
    border-bottom: 0; }

.panel > .table-responsive, .content-box > .table-responsive, .select-subcompany-modal .list-group > .table-responsive, .content-box-editable > .table-responsive, .card > .table-responsive, #appLauncherContainer .scrollable-list > .table-responsive, #appLauncherContainer .template-grid > .table-responsive {
  border: 0;
  margin-bottom: 0; }

.panel-group {
  margin-bottom: 20px; }
  .panel-group .panel, .panel-group .content-box, .panel-group .select-subcompany-modal .list-group, .select-subcompany-modal .panel-group .list-group, .panel-group .content-box-editable, .panel-group .card, .panel-group #appLauncherContainer .scrollable-list, #appLauncherContainer .panel-group .scrollable-list, .panel-group #appLauncherContainer .template-grid, #appLauncherContainer .panel-group .template-grid {
    margin-bottom: 0;
    border-radius: 4px; }
    .panel-group .panel + .panel, .panel-group .content-box + .panel, .panel-group .select-subcompany-modal .list-group + .panel, .select-subcompany-modal .panel-group .list-group + .panel, .panel-group .content-box-editable + .panel, .panel-group .card + .panel, .panel-group #appLauncherContainer .scrollable-list + .panel, #appLauncherContainer .panel-group .scrollable-list + .panel, .panel-group #appLauncherContainer .template-grid + .panel, #appLauncherContainer .panel-group .template-grid + .panel, .panel-group .panel + .content-box, .panel-group .content-box + .content-box, .panel-group .select-subcompany-modal .list-group + .content-box, .select-subcompany-modal .panel-group .list-group + .content-box, .panel-group .content-box-editable + .content-box, .panel-group .card + .content-box, .panel-group #appLauncherContainer .scrollable-list + .content-box, #appLauncherContainer .panel-group .scrollable-list + .content-box, .panel-group #appLauncherContainer .template-grid + .content-box, #appLauncherContainer .panel-group .template-grid + .content-box, .panel-group .select-subcompany-modal .panel + .list-group, .select-subcompany-modal .panel-group .panel + .list-group, .panel-group .select-subcompany-modal .content-box + .list-group, .select-subcompany-modal .panel-group .content-box + .list-group, .panel-group .select-subcompany-modal .list-group + .list-group, .select-subcompany-modal .panel-group .list-group + .list-group, .panel-group .select-subcompany-modal .content-box-editable + .list-group, .select-subcompany-modal .panel-group .content-box-editable + .list-group, .panel-group .select-subcompany-modal .card + .list-group, .select-subcompany-modal .panel-group .card + .list-group, .panel-group #appLauncherContainer .select-subcompany-modal .scrollable-list + .list-group, .select-subcompany-modal .panel-group #appLauncherContainer .scrollable-list + .list-group, #appLauncherContainer .panel-group .select-subcompany-modal .scrollable-list + .list-group, .select-subcompany-modal #appLauncherContainer .panel-group .scrollable-list + .list-group, .panel-group #appLauncherContainer .select-subcompany-modal .template-grid + .list-group, .select-subcompany-modal .panel-group #appLauncherContainer .template-grid + .list-group, #appLauncherContainer .panel-group .select-subcompany-modal .template-grid + .list-group, .select-subcompany-modal #appLauncherContainer .panel-group .template-grid + .list-group, .panel-group .panel + .content-box-editable, .panel-group .content-box + .content-box-editable, .panel-group .select-subcompany-modal .list-group + .content-box-editable, .select-subcompany-modal .panel-group .list-group + .content-box-editable, .panel-group .content-box-editable + .content-box-editable, .panel-group .card + .content-box-editable, .panel-group #appLauncherContainer .scrollable-list + .content-box-editable, #appLauncherContainer .panel-group .scrollable-list + .content-box-editable, .panel-group #appLauncherContainer .template-grid + .content-box-editable, #appLauncherContainer .panel-group .template-grid + .content-box-editable, .panel-group .panel + .card, .panel-group .content-box + .card, .panel-group .select-subcompany-modal .list-group + .card, .select-subcompany-modal .panel-group .list-group + .card, .panel-group .content-box-editable + .card, .panel-group .card + .card, .panel-group #appLauncherContainer .scrollable-list + .card, #appLauncherContainer .panel-group .scrollable-list + .card, .panel-group #appLauncherContainer .template-grid + .card, #appLauncherContainer .panel-group .template-grid + .card, .panel-group #appLauncherContainer .panel + .scrollable-list, #appLauncherContainer .panel-group .panel + .scrollable-list, .panel-group #appLauncherContainer .content-box + .scrollable-list, #appLauncherContainer .panel-group .content-box + .scrollable-list, .panel-group .select-subcompany-modal #appLauncherContainer .list-group + .scrollable-list, #appLauncherContainer .panel-group .select-subcompany-modal .list-group + .scrollable-list, .select-subcompany-modal .panel-group #appLauncherContainer .list-group + .scrollable-list, #appLauncherContainer .select-subcompany-modal .panel-group .list-group + .scrollable-list, .panel-group #appLauncherContainer .content-box-editable + .scrollable-list, #appLauncherContainer .panel-group .content-box-editable + .scrollable-list, .panel-group #appLauncherContainer .card + .scrollable-list, #appLauncherContainer .panel-group .card + .scrollable-list, .panel-group #appLauncherContainer .scrollable-list + .scrollable-list, #appLauncherContainer .panel-group .scrollable-list + .scrollable-list, .panel-group #appLauncherContainer .template-grid + .scrollable-list, #appLauncherContainer .panel-group .template-grid + .scrollable-list, .panel-group #appLauncherContainer .panel + .template-grid, #appLauncherContainer .panel-group .panel + .template-grid, .panel-group #appLauncherContainer .content-box + .template-grid, #appLauncherContainer .panel-group .content-box + .template-grid, .panel-group .select-subcompany-modal #appLauncherContainer .list-group + .template-grid, #appLauncherContainer .panel-group .select-subcompany-modal .list-group + .template-grid, .select-subcompany-modal .panel-group #appLauncherContainer .list-group + .template-grid, #appLauncherContainer .select-subcompany-modal .panel-group .list-group + .template-grid, .panel-group #appLauncherContainer .content-box-editable + .template-grid, #appLauncherContainer .panel-group .content-box-editable + .template-grid, .panel-group #appLauncherContainer .card + .template-grid, #appLauncherContainer .panel-group .card + .template-grid, .panel-group #appLauncherContainer .scrollable-list + .template-grid, #appLauncherContainer .panel-group .scrollable-list + .template-grid, .panel-group #appLauncherContainer .template-grid + .template-grid, #appLauncherContainer .panel-group .template-grid + .template-grid {
      margin-top: 5px; }
  .panel-group .panel-heading {
    border-bottom: 0; }
    .panel-group .panel-heading + .panel-collapse > .panel-body, .panel-group .panel-heading + .panel-collapse > .content-box-body {
      border-top: 1px solid #ddd; }
  .panel-group .panel-footer {
    border-top: 0; }
    .panel-group .panel-footer + .panel-collapse .panel-body, .panel-group .panel-footer + .panel-collapse .content-box-body {
      border-bottom: 1px solid #ddd; }

.panel-default, .content-box, .select-subcompany-modal .list-group, .content-box-editable, .card, #appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {
  border-color: #ddd; }
  .panel-default > .panel-heading, .content-box > .panel-heading, .select-subcompany-modal .list-group > .panel-heading, .content-box-editable > .panel-heading, .card > .panel-heading, #appLauncherContainer .scrollable-list > .panel-heading, #appLauncherContainer .template-grid > .panel-heading {
    color: #020621;
    background-color: #fff;
    border-color: #ddd; }
    .panel-default > .panel-heading + .panel-collapse > .panel-body, .content-box > .panel-heading + .panel-collapse > .panel-body, .select-subcompany-modal .list-group > .panel-heading + .panel-collapse > .panel-body, .content-box-editable > .panel-heading + .panel-collapse > .panel-body, .card > .panel-heading + .panel-collapse > .panel-body, #appLauncherContainer .scrollable-list > .panel-heading + .panel-collapse > .panel-body, #appLauncherContainer .template-grid > .panel-heading + .panel-collapse > .panel-body, .panel-default > .panel-heading + .panel-collapse > .content-box-body, .content-box > .panel-heading + .panel-collapse > .content-box-body, .select-subcompany-modal .list-group > .panel-heading + .panel-collapse > .content-box-body, .content-box-editable > .panel-heading + .panel-collapse > .content-box-body, .card > .panel-heading + .panel-collapse > .content-box-body, #appLauncherContainer .scrollable-list > .panel-heading + .panel-collapse > .content-box-body, #appLauncherContainer .template-grid > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #ddd; }
    .panel-default > .panel-heading .badge, .content-box > .panel-heading .badge, .select-subcompany-modal .list-group > .panel-heading .badge, .content-box-editable > .panel-heading .badge, .card > .panel-heading .badge, #appLauncherContainer .scrollable-list > .panel-heading .badge, #appLauncherContainer .template-grid > .panel-heading .badge {
      color: #fff;
      background-color: #020621; }
  .panel-default > .panel-footer + .panel-collapse > .panel-body, .content-box > .panel-footer + .panel-collapse > .panel-body, .select-subcompany-modal .list-group > .panel-footer + .panel-collapse > .panel-body, .content-box-editable > .panel-footer + .panel-collapse > .panel-body, .card > .panel-footer + .panel-collapse > .panel-body, #appLauncherContainer .scrollable-list > .panel-footer + .panel-collapse > .panel-body, #appLauncherContainer .template-grid > .panel-footer + .panel-collapse > .panel-body, .panel-default > .panel-footer + .panel-collapse > .content-box-body, .content-box > .panel-footer + .panel-collapse > .content-box-body, .select-subcompany-modal .list-group > .panel-footer + .panel-collapse > .content-box-body, .content-box-editable > .panel-footer + .panel-collapse > .content-box-body, .card > .panel-footer + .panel-collapse > .content-box-body, #appLauncherContainer .scrollable-list > .panel-footer + .panel-collapse > .content-box-body, #appLauncherContainer .template-grid > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #ddd; }

.panel-primary {
  border-color: #428bca; }
  .panel-primary > .panel-heading {
    color: #fff;
    background-color: #428bca;
    border-color: #428bca; }
    .panel-primary > .panel-heading + .panel-collapse > .panel-body, .panel-primary > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #428bca; }
    .panel-primary > .panel-heading .badge {
      color: #428bca;
      background-color: #fff; }
  .panel-primary > .panel-footer + .panel-collapse > .panel-body, .panel-primary > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #428bca; }

.panel-success {
  border-color: #d6e9c6; }
  .panel-success > .panel-heading {
    color: #4ab767;
    background-color: #dff0d8;
    border-color: #d6e9c6; }
    .panel-success > .panel-heading + .panel-collapse > .panel-body, .panel-success > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #d6e9c6; }
    .panel-success > .panel-heading .badge {
      color: #dff0d8;
      background-color: #4ab767; }
  .panel-success > .panel-footer + .panel-collapse > .panel-body, .panel-success > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #d6e9c6; }

.panel-info {
  border-color: #bce8f1; }
  .panel-info > .panel-heading {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1; }
    .panel-info > .panel-heading + .panel-collapse > .panel-body, .panel-info > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #bce8f1; }
    .panel-info > .panel-heading .badge {
      color: #d9edf7;
      background-color: #31708f; }
  .panel-info > .panel-footer + .panel-collapse > .panel-body, .panel-info > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #bce8f1; }

.panel-warning {
  border-color: #faebcc; }
  .panel-warning > .panel-heading {
    color: #8a6d3b;
    background-color: #fcf8e3;
    border-color: #faebcc; }
    .panel-warning > .panel-heading + .panel-collapse > .panel-body, .panel-warning > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #faebcc; }
    .panel-warning > .panel-heading .badge {
      color: #fcf8e3;
      background-color: #8a6d3b; }
  .panel-warning > .panel-footer + .panel-collapse > .panel-body, .panel-warning > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #faebcc; }

.panel-danger {
  border-color: #ebccd1; }
  .panel-danger > .panel-heading {
    color: #c0392b;
    background-color: #f2dede;
    border-color: #ebccd1; }
    .panel-danger > .panel-heading + .panel-collapse > .panel-body, .panel-danger > .panel-heading + .panel-collapse > .content-box-body {
      border-top-color: #ebccd1; }
    .panel-danger > .panel-heading .badge {
      color: #f2dede;
      background-color: #c0392b; }
  .panel-danger > .panel-footer + .panel-collapse > .panel-body, .panel-danger > .panel-footer + .panel-collapse > .content-box-body {
    border-bottom-color: #ebccd1; }

.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    border: 0; }
  .embed-responsive.embed-responsive-16by9 {
    padding-bottom: 56.25%; }
  .embed-responsive.embed-responsive-4by3 {
    padding-bottom: 75%; }

.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05); }
  .well blockquote {
    border-color: #ddd;
    border-color: rgba(0, 0, 0, 0.15); }

.well-lg {
  padding: 24px;
  border-radius: 6px; }

.well-sm {
  padding: 9px;
  border-radius: 2px; }

.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  filter: alpha(opacity=20); }
  .close:hover, .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.5;
    filter: alpha(opacity=50); }

button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none; }

.modal-open {
  overflow: hidden; }

.modal {
  display: none;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0; }
  .modal.fade .modal-dialog {
    -webkit-transform: translate3d(0, -25%, 0);
    transform: translate3d(0, -25%, 0);
    -webkit-transition: -webkit-transform 0.3s ease-out;
    -moz-transition: -moz-transform 0.3s ease-out;
    -o-transition: -o-transform 0.3s ease-out;
    transition: transform 0.3s ease-out; }
  .modal.in .modal-dialog {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 10px; }

.modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  outline: 0; }

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #fff; }
  .modal-backdrop.fade {
    opacity: 0;
    filter: alpha(opacity=0); }
  .modal-backdrop.in {
    opacity: 0.7;
    filter: alpha(opacity=70); }

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
  min-height: 16.42857px; }

.modal-header .close {
  margin-top: -2px; }

.modal-title {
  margin: 0;
  line-height: 1.42857; }

.modal-body {
  position: relative;
  padding: 15px; }

.modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5; }
  .modal-footer:before, .modal-footer:after {
    content: " ";
    display: table; }
  .modal-footer:after {
    clear: both; }
  .modal-footer .btn + .btn, .modal-footer .icon-nav label + .btn, .icon-nav .modal-footer label + .btn, .modal-footer .icon-nav .btn + label, .icon-nav .modal-footer .btn + label, .modal-footer .icon-nav label + label, .icon-nav .modal-footer label + label {
    margin-left: 5px;
    margin-bottom: 0; }
  .modal-footer .btn-group .btn + .btn, .modal-footer .btn-group .icon-nav label + .btn, .icon-nav .modal-footer .btn-group label + .btn, .modal-footer .btn-group .icon-nav .btn + label, .icon-nav .modal-footer .btn-group .btn + label, .modal-footer .btn-group .icon-nav label + label, .icon-nav .modal-footer .btn-group label + label {
    margin-left: -1px; }
  .modal-footer .btn-block + .btn-block {
    margin-left: 0; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 768px) {
  .modal-dialog {
    width: 900px;
    margin: 30px auto; }
  .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }
  .modal-sm {
    width: 300px; } }

@media (min-width: 992px) {
  .modal-lg {
    width: 1200px; } }

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0;
  filter: alpha(opacity=0); }
  .tooltip.in {
    opacity: 0.9;
    filter: alpha(opacity=90); }
  .tooltip.top {
    margin-top: -3px;
    padding: 5px 0; }
  .tooltip.right {
    margin-left: 3px;
    padding: 0 5px; }
  .tooltip.bottom {
    margin-top: 3px;
    padding: 5px 0; }
  .tooltip.left {
    margin-left: -3px;
    padding: 0 5px; }

.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #000;
  border-radius: 4px; }

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid; }

.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000; }

.tooltip.top-left .tooltip-arrow {
  bottom: 0;
  left: 5px;
  border-width: 5px 5px 0;
  border-top-color: #000; }

.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  right: 5px;
  border-width: 5px 5px 0;
  border-top-color: #000; }

.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000; }

.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000; }

.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000; }

.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  left: 5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000; }

.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  right: 5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000; }

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  max-width: 276px;
  padding: 1px;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  white-space: normal; }
  .popover.top {
    margin-top: -10px; }
  .popover.right {
    margin-left: 10px; }
  .popover.bottom {
    margin-top: 10px; }
  .popover.left {
    margin-left: -10px; }

.popover-title {
  margin: 0;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0; }

.popover-content {
  padding: 9px 14px; }

.popover > .arrow, .popover > .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid; }

.popover > .arrow {
  border-width: 11px; }

.popover > .arrow:after {
  border-width: 10px;
  content: ""; }

.popover.top > .arrow {
  left: 50%;
  margin-left: -11px;
  border-bottom-width: 0;
  border-top-color: #999999;
  border-top-color: rgba(0, 0, 0, 0.25);
  bottom: -11px; }
  .popover.top > .arrow:after {
    content: " ";
    bottom: 1px;
    margin-left: -10px;
    border-bottom-width: 0;
    border-top-color: #fff; }

.popover.right > .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-left-width: 0;
  border-right-color: #999999;
  border-right-color: rgba(0, 0, 0, 0.25); }
  .popover.right > .arrow:after {
    content: " ";
    left: 1px;
    bottom: -10px;
    border-left-width: 0;
    border-right-color: #fff; }

.popover.bottom > .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px; }
  .popover.bottom > .arrow:after {
    content: " ";
    top: 1px;
    margin-left: -10px;
    border-top-width: 0;
    border-bottom-color: #fff; }

.popover.left > .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999999;
  border-left-color: rgba(0, 0, 0, 0.25); }
  .popover.left > .arrow:after {
    content: " ";
    right: 1px;
    border-right-width: 0;
    border-left-color: #fff;
    bottom: -10px; }

.carousel {
  position: relative; }

.carousel-inner {
  position: relative;
  overflow: hidden;
  width: 100%; }
  .carousel-inner > .item {
    display: none;
    position: relative;
    -webkit-transition: 0.6s ease-in-out left;
    -o-transition: 0.6s ease-in-out left;
    transition: 0.6s ease-in-out left; }
    .carousel-inner > .item > img,
    .carousel-inner > .item > a > img {
      display: block;
      width: 100% \\9;
      max-width: 100%;
      height: auto;
      line-height: 1; }
  .carousel-inner > .active,
  .carousel-inner > .next,
  .carousel-inner > .prev {
    display: block; }
  .carousel-inner > .active {
    left: 0; }
  .carousel-inner > .next,
  .carousel-inner > .prev {
    position: absolute;
    top: 0;
    width: 100%; }
  .carousel-inner > .next {
    left: 100%; }
  .carousel-inner > .prev {
    left: -100%; }
  .carousel-inner > .next.left,
  .carousel-inner > .prev.right {
    left: 0; }
  .carousel-inner > .active.left {
    left: -100%; }
  .carousel-inner > .active.right {
    left: 100%; }

.carousel-control {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 15%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6); }
  .carousel-control.left {
    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1); }
  .carousel-control.right {
    left: auto;
    right: 0;
    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1); }
  .carousel-control:hover, .carousel-control:focus {
    outline: 0;
    color: #fff;
    text-decoration: none;
    opacity: 0.9;
    filter: alpha(opacity=90); }
  .carousel-control .icon-prev,
  .carousel-control .icon-next,
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .glyphicon-chevron-right {
    position: absolute;
    top: 50%;
    z-index: 5;
    display: inline-block; }
  .carousel-control .icon-prev,
  .carousel-control .glyphicon-chevron-left {
    left: 50%;
    margin-left: -10px; }
  .carousel-control .icon-next,
  .carousel-control .glyphicon-chevron-right {
    right: 50%;
    margin-right: -10px; }
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    font-family: serif; }
  .carousel-control .icon-prev:before {
    content: '\\2039'; }
  .carousel-control .icon-next:before {
    content: '\\203a'; }

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 15;
  width: 60%;
  margin-left: -30%;
  padding-left: 0;
  list-style: none;
  text-align: center; }
  .carousel-indicators li {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 1px;
    text-indent: -999px;
    border: 1px solid #fff;
    border-radius: 10px;
    cursor: pointer;
    background-color: #000 \\9;
    background-color: transparent; }
  .carousel-indicators .active {
    margin: 0;
    width: 12px;
    height: 12px;
    background-color: #fff; }

.carousel-caption {
  position: absolute;
  left: 15%;
  right: 15%;
  bottom: 20px;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6); }
  .carousel-caption .btn, .carousel-caption .icon-nav label, .icon-nav .carousel-caption label {
    text-shadow: none; }

@media screen and (min-width: 768px) {
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 30px;
    height: 30px;
    margin-top: -15px;
    font-size: 30px; }
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .icon-prev {
    margin-left: -15px; }
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-next {
    margin-right: -15px; }
  .carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px; }
  .carousel-indicators {
    bottom: 20px; } }

.clearfix:before, .clearfix:after {
  content: " ";
  display: table; }

.clearfix:after {
  clear: both; }

.center-block {
  display: block;
  margin-left: auto;
  margin-right: auto; }

.pull-right {
  float: right !important; }

.pull-left {
  float: left !important; }

.hide {
  display: none !important; }

.show {
  display: block !important; }

.invisible {
  visibility: hidden; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.hidden {
  display: none !important;
  visibility: hidden !important; }

.affix {
  position: fixed;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0); }

@-ms-viewport {
  width: device-width; }

.visible-xs, .visible-sm, .visible-md, .visible-lg {
  display: none !important; }

.visible-xs-block,
.visible-xs-inline,
.visible-xs-inline-block,
.visible-sm-block,
.visible-sm-inline,
.visible-sm-inline-block,
.visible-md-block,
.visible-md-inline,
.visible-md-inline-block,
.visible-lg-block,
.visible-lg-inline,
.visible-lg-inline-block {
  display: none !important; }

@media (max-width: 767px) {
  .visible-xs {
    display: block !important; }
  table.visible-xs {
    display: table; }
  tr.visible-xs {
    display: table-row !important; }
  th.visible-xs,
  td.visible-xs {
    display: table-cell !important; } }

@media (max-width: 767px) {
  .visible-xs-block {
    display: block !important; } }

@media (max-width: 767px) {
  .visible-xs-inline {
    display: inline !important; } }

@media (max-width: 767px) {
  .visible-xs-inline-block {
    display: inline-block !important; } }

@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm {
    display: block !important; }
  table.visible-sm {
    display: table; }
  tr.visible-sm {
    display: table-row !important; }
  th.visible-sm,
  td.visible-sm {
    display: table-cell !important; } }

@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-block {
    display: block !important; } }

@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline {
    display: inline !important; } }

@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline-block {
    display: inline-block !important; } }

@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md {
    display: block !important; }
  table.visible-md {
    display: table; }
  tr.visible-md {
    display: table-row !important; }
  th.visible-md,
  td.visible-md {
    display: table-cell !important; } }

@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-block {
    display: block !important; } }

@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline {
    display: inline !important; } }

@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline-block {
    display: inline-block !important; } }

@media (min-width: 1200px) {
  .visible-lg {
    display: block !important; }
  table.visible-lg {
    display: table; }
  tr.visible-lg {
    display: table-row !important; }
  th.visible-lg,
  td.visible-lg {
    display: table-cell !important; } }

@media (min-width: 1200px) {
  .visible-lg-block {
    display: block !important; } }

@media (min-width: 1200px) {
  .visible-lg-inline {
    display: inline !important; } }

@media (min-width: 1200px) {
  .visible-lg-inline-block {
    display: inline-block !important; } }

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important; } }

@media (min-width: 768px) and (max-width: 991px) {
  .hidden-sm {
    display: none !important; } }

@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-md {
    display: none !important; } }

@media (min-width: 1200px) {
  .hidden-lg {
    display: none !important; } }

.visible-print {
  display: none !important; }

@media print {
  .visible-print {
    display: block !important; }
  table.visible-print {
    display: table; }
  tr.visible-print {
    display: table-row !important; }
  th.visible-print,
  td.visible-print {
    display: table-cell !important; } }

.visible-print-block {
  display: none !important; }
  @media print {
    .visible-print-block {
      display: block !important; } }

.visible-print-inline {
  display: none !important; }
  @media print {
    .visible-print-inline {
      display: inline !important; } }

.visible-print-inline-block {
  display: none !important; }
  @media print {
    .visible-print-inline-block {
      display: inline-block !important; } }

@media print {
  .hidden-print {
    display: none !important; } }

/* FontAwesome
   ========================================================================== */
/*!
 *  Font Awesome 4.1.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: 'FontAwesome';
  src: url("../fonts/fontawesome-webfont.eot?v=4.1.0");
  src: url("../fonts/fontawesome-webfont.eot?#iefix&v=4.1.0") format("embedded-opentype"), url("../fonts/fontawesome-webfont.woff?v=4.1.0") format("woff"), url("../fonts/fontawesome-webfont.ttf?v=4.1.0") format("truetype"), url("../fonts/fontawesome-webfont.svg?v=4.1.0#fontawesomeregular") format("svg");
  font-weight: normal;
  font-style: normal; }

.fa {
  display: inline-block;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -15%; }

.fa-2x {
  font-size: 2em; }

.fa-3x {
  font-size: 3em; }

.fa-4x {
  font-size: 4em; }

.fa-5x {
  font-size: 5em; }

.fa-fw {
  width: 1.28571em;
  text-align: center; }

.fa-ul {
  padding-left: 0;
  margin-left: 2.14286em;
  list-style-type: none; }
  .fa-ul > li {
    position: relative; }

.fa-li {
  position: absolute;
  left: -2.14286em;
  width: 2.14286em;
  top: 0.14286em;
  text-align: center; }
  .fa-li.fa-lg {
    left: -1.85714em; }

.fa-border {
  padding: .2em .25em .15em;
  border: solid 0.08em #eee;
  border-radius: .1em; }

.pull-right {
  float: right; }

.pull-left {
  float: left; }

.fa.pull-left {
  margin-right: .3em; }

.fa.pull-right {
  margin-left: .3em; }

.fa-spin {
  -webkit-animation: spin 2s infinite linear;
  -moz-animation: spin 2s infinite linear;
  -o-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear; }

@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg); }
  100% {
    -moz-transform: rotate(359deg); } }

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(359deg); } }

@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg); }
  100% {
    -o-transform: rotate(359deg); } }

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg); } }

.fa-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg); }

.fa-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg); }

.fa-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg); }

.fa-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  -webkit-transform: scale(-1, 1);
  -moz-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  transform: scale(-1, 1); }

.fa-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  -webkit-transform: scale(1, -1);
  -moz-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  transform: scale(1, -1); }

.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle; }

.fa-stack-1x, .fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center; }

.fa-stack-1x {
  line-height: inherit; }

.fa-stack-2x {
  font-size: 2em; }

.fa-inverse {
  color: #fff; }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: ""; }

.fa-music:before {
  content: ""; }

.fa-search:before {
  content: ""; }

.fa-envelope-o:before {
  content: ""; }

.fa-heart:before {
  content: ""; }

.fa-star:before {
  content: ""; }

.fa-star-o:before {
  content: ""; }

.fa-user:before {
  content: ""; }

.fa-film:before {
  content: ""; }

.fa-th-large:before {
  content: ""; }

.fa-th:before {
  content: ""; }

.fa-th-list:before {
  content: ""; }

.fa-check:before {
  content: ""; }

.fa-times:before {
  content: ""; }

.fa-search-plus:before {
  content: ""; }

.fa-search-minus:before {
  content: ""; }

.fa-power-off:before {
  content: ""; }

.fa-signal:before {
  content: ""; }

.fa-gear:before,
.fa-cog:before {
  content: ""; }

.fa-trash-o:before {
  content: ""; }

.fa-home:before {
  content: ""; }

.fa-file-o:before {
  content: ""; }

.fa-clock-o:before {
  content: ""; }

.fa-road:before {
  content: ""; }

.fa-download:before {
  content: ""; }

.fa-arrow-circle-o-down:before {
  content: ""; }

.fa-arrow-circle-o-up:before {
  content: ""; }

.fa-inbox:before {
  content: ""; }

.fa-play-circle-o:before {
  content: ""; }

.fa-rotate-right:before,
.fa-repeat:before {
  content: ""; }

.fa-refresh:before {
  content: ""; }

.fa-list-alt:before {
  content: ""; }

.fa-lock:before {
  content: ""; }

.fa-flag:before {
  content: ""; }

.fa-headphones:before {
  content: ""; }

.fa-volume-off:before {
  content: ""; }

.fa-volume-down:before {
  content: ""; }

.fa-volume-up:before {
  content: ""; }

.fa-qrcode:before {
  content: ""; }

.fa-barcode:before {
  content: ""; }

.fa-tag:before {
  content: ""; }

.fa-tags:before {
  content: ""; }

.fa-book:before {
  content: ""; }

.fa-bookmark:before {
  content: ""; }

.fa-print:before {
  content: ""; }

.fa-camera:before {
  content: ""; }

.fa-font:before {
  content: ""; }

.fa-bold:before {
  content: ""; }

.fa-italic:before {
  content: ""; }

.fa-text-height:before {
  content: ""; }

.fa-text-width:before {
  content: ""; }

.fa-align-left:before {
  content: ""; }

.fa-align-center:before {
  content: ""; }

.fa-align-right:before {
  content: ""; }

.fa-align-justify:before {
  content: ""; }

.fa-list:before {
  content: ""; }

.fa-dedent:before,
.fa-outdent:before {
  content: ""; }

.fa-indent:before {
  content: ""; }

.fa-video-camera:before {
  content: ""; }

.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: ""; }

.fa-pencil:before {
  content: ""; }

.fa-map-marker:before {
  content: ""; }

.fa-adjust:before {
  content: ""; }

.fa-tint:before {
  content: ""; }

.fa-edit:before,
.fa-pencil-square-o:before {
  content: ""; }

.fa-share-square-o:before {
  content: ""; }

.fa-check-square-o:before {
  content: ""; }

.fa-arrows:before {
  content: ""; }

.fa-step-backward:before {
  content: ""; }

.fa-fast-backward:before {
  content: ""; }

.fa-backward:before {
  content: ""; }

.fa-play:before {
  content: ""; }

.fa-pause:before {
  content: ""; }

.fa-stop:before {
  content: ""; }

.fa-forward:before {
  content: ""; }

.fa-fast-forward:before {
  content: ""; }

.fa-step-forward:before {
  content: ""; }

.fa-eject:before {
  content: ""; }

.fa-chevron-left:before {
  content: ""; }

.fa-chevron-right:before {
  content: ""; }

.fa-plus-circle:before {
  content: ""; }

.fa-minus-circle:before {
  content: ""; }

.fa-times-circle:before {
  content: ""; }

.fa-check-circle:before {
  content: ""; }

.fa-question-circle:before {
  content: ""; }

.fa-info-circle:before {
  content: ""; }

.fa-crosshairs:before {
  content: ""; }

.fa-times-circle-o:before {
  content: ""; }

.fa-check-circle-o:before {
  content: ""; }

.fa-ban:before {
  content: ""; }

.fa-arrow-left:before {
  content: ""; }

.fa-arrow-right:before {
  content: ""; }

.fa-arrow-up:before {
  content: ""; }

.fa-arrow-down:before {
  content: ""; }

.fa-mail-forward:before,
.fa-share:before {
  content: ""; }

.fa-expand:before {
  content: ""; }

.fa-compress:before {
  content: ""; }

.fa-plus:before {
  content: ""; }

.fa-minus:before {
  content: ""; }

.fa-asterisk:before {
  content: ""; }

.fa-exclamation-circle:before {
  content: ""; }

.fa-gift:before {
  content: ""; }

.fa-leaf:before {
  content: ""; }

.fa-fire:before {
  content: ""; }

.fa-eye:before {
  content: ""; }

.fa-eye-slash:before {
  content: ""; }

.fa-warning:before,
.fa-exclamation-triangle:before {
  content: ""; }

.fa-plane:before {
  content: ""; }

.fa-calendar:before {
  content: ""; }

.fa-random:before {
  content: ""; }

.fa-comment:before {
  content: ""; }

.fa-magnet:before {
  content: ""; }

.fa-chevron-up:before {
  content: ""; }

.fa-chevron-down:before {
  content: ""; }

.fa-retweet:before {
  content: ""; }

.fa-shopping-cart:before {
  content: ""; }

.fa-folder:before {
  content: ""; }

.fa-folder-open:before {
  content: ""; }

.fa-arrows-v:before {
  content: ""; }

.fa-arrows-h:before {
  content: ""; }

.fa-bar-chart-o:before {
  content: ""; }

.fa-twitter-square:before {
  content: ""; }

.fa-facebook-square:before {
  content: ""; }

.fa-camera-retro:before {
  content: ""; }

.fa-key:before {
  content: ""; }

.fa-gears:before,
.fa-cogs:before {
  content: ""; }

.fa-comments:before {
  content: ""; }

.fa-thumbs-o-up:before {
  content: ""; }

.fa-thumbs-o-down:before {
  content: ""; }

.fa-star-half:before {
  content: ""; }

.fa-heart-o:before {
  content: ""; }

.fa-sign-out:before {
  content: ""; }

.fa-linkedin-square:before {
  content: ""; }

.fa-thumb-tack:before {
  content: ""; }

.fa-external-link:before {
  content: ""; }

.fa-sign-in:before {
  content: ""; }

.fa-trophy:before {
  content: ""; }

.fa-github-square:before {
  content: ""; }

.fa-upload:before {
  content: ""; }

.fa-lemon-o:before {
  content: ""; }

.fa-phone:before {
  content: ""; }

.fa-square-o:before {
  content: ""; }

.fa-bookmark-o:before {
  content: ""; }

.fa-phone-square:before {
  content: ""; }

.fa-twitter:before {
  content: ""; }

.fa-facebook:before {
  content: ""; }

.fa-github:before {
  content: ""; }

.fa-unlock:before {
  content: ""; }

.fa-credit-card:before {
  content: ""; }

.fa-rss:before {
  content: ""; }

.fa-hdd-o:before {
  content: ""; }

.fa-bullhorn:before {
  content: ""; }

.fa-bell:before {
  content: ""; }

.fa-certificate:before {
  content: ""; }

.fa-hand-o-right:before {
  content: ""; }

.fa-hand-o-left:before {
  content: ""; }

.fa-hand-o-up:before {
  content: ""; }

.fa-hand-o-down:before {
  content: ""; }

.fa-arrow-circle-left:before {
  content: ""; }

.fa-arrow-circle-right:before {
  content: ""; }

.fa-arrow-circle-up:before {
  content: ""; }

.fa-arrow-circle-down:before {
  content: ""; }

.fa-globe:before {
  content: ""; }

.fa-wrench:before {
  content: ""; }

.fa-tasks:before {
  content: ""; }

.fa-filter:before {
  content: ""; }

.fa-briefcase:before {
  content: ""; }

.fa-arrows-alt:before {
  content: ""; }

.fa-group:before,
.fa-users:before {
  content: ""; }

.fa-chain:before,
.fa-link:before {
  content: ""; }

.fa-cloud:before {
  content: ""; }

.fa-flask:before {
  content: ""; }

.fa-cut:before,
.fa-scissors:before {
  content: ""; }

.fa-copy:before,
.fa-files-o:before {
  content: ""; }

.fa-paperclip:before {
  content: ""; }

.fa-save:before,
.fa-floppy-o:before {
  content: ""; }

.fa-square:before {
  content: ""; }

.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: ""; }

.fa-list-ul:before {
  content: ""; }

.fa-list-ol:before {
  content: ""; }

.fa-strikethrough:before {
  content: ""; }

.fa-underline:before {
  content: ""; }

.fa-table:before {
  content: ""; }

.fa-magic:before {
  content: ""; }

.fa-truck:before {
  content: ""; }

.fa-pinterest:before {
  content: ""; }

.fa-pinterest-square:before {
  content: ""; }

.fa-google-plus-square:before {
  content: ""; }

.fa-google-plus:before {
  content: ""; }

.fa-money:before {
  content: ""; }

.fa-caret-down:before {
  content: ""; }

.fa-caret-up:before {
  content: ""; }

.fa-caret-left:before {
  content: ""; }

.fa-caret-right:before {
  content: ""; }

.fa-columns:before {
  content: ""; }

.fa-unsorted:before,
.fa-sort:before {
  content: ""; }

.fa-sort-down:before,
.fa-sort-desc:before {
  content: ""; }

.fa-sort-up:before,
.fa-sort-asc:before {
  content: ""; }

.fa-envelope:before {
  content: ""; }

.fa-linkedin:before {
  content: ""; }

.fa-rotate-left:before,
.fa-undo:before {
  content: ""; }

.fa-legal:before,
.fa-gavel:before {
  content: ""; }

.fa-dashboard:before,
.fa-tachometer:before {
  content: ""; }

.fa-comment-o:before {
  content: ""; }

.fa-comments-o:before {
  content: ""; }

.fa-flash:before,
.fa-bolt:before {
  content: ""; }

.fa-sitemap:before {
  content: ""; }

.fa-umbrella:before {
  content: ""; }

.fa-paste:before,
.fa-clipboard:before {
  content: ""; }

.fa-lightbulb-o:before {
  content: ""; }

.fa-exchange:before {
  content: ""; }

.fa-cloud-download:before {
  content: ""; }

.fa-cloud-upload:before {
  content: ""; }

.fa-user-md:before {
  content: ""; }

.fa-stethoscope:before {
  content: ""; }

.fa-suitcase:before {
  content: ""; }

.fa-bell-o:before {
  content: ""; }

.fa-coffee:before {
  content: ""; }

.fa-cutlery:before {
  content: ""; }

.fa-file-text-o:before {
  content: ""; }

.fa-building-o:before {
  content: ""; }

.fa-hospital-o:before {
  content: ""; }

.fa-ambulance:before {
  content: ""; }

.fa-medkit:before {
  content: ""; }

.fa-fighter-jet:before {
  content: ""; }

.fa-beer:before {
  content: ""; }

.fa-h-square:before {
  content: ""; }

.fa-plus-square:before {
  content: ""; }

.fa-angle-double-left:before {
  content: ""; }

.fa-angle-double-right:before {
  content: ""; }

.fa-angle-double-up:before {
  content: ""; }

.fa-angle-double-down:before {
  content: ""; }

.fa-angle-left:before {
  content: ""; }

.fa-angle-right:before {
  content: ""; }

.fa-angle-up:before {
  content: ""; }

.fa-angle-down:before {
  content: ""; }

.fa-desktop:before {
  content: ""; }

.fa-laptop:before {
  content: ""; }

.fa-tablet:before {
  content: ""; }

.fa-mobile-phone:before,
.fa-mobile:before {
  content: ""; }

.fa-circle-o:before {
  content: ""; }

.fa-quote-left:before {
  content: ""; }

.fa-quote-right:before {
  content: ""; }

.fa-spinner:before {
  content: ""; }

.fa-circle:before {
  content: ""; }

.fa-mail-reply:before,
.fa-reply:before {
  content: ""; }

.fa-github-alt:before {
  content: ""; }

.fa-folder-o:before {
  content: ""; }

.fa-folder-open-o:before {
  content: ""; }

.fa-smile-o:before {
  content: ""; }

.fa-frown-o:before {
  content: ""; }

.fa-meh-o:before {
  content: ""; }

.fa-gamepad:before {
  content: ""; }

.fa-keyboard-o:before {
  content: ""; }

.fa-flag-o:before {
  content: ""; }

.fa-flag-checkered:before {
  content: ""; }

.fa-terminal:before {
  content: ""; }

.fa-code:before {
  content: ""; }

.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: ""; }

.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: ""; }

.fa-location-arrow:before {
  content: ""; }

.fa-crop:before {
  content: ""; }

.fa-code-fork:before {
  content: ""; }

.fa-unlink:before,
.fa-chain-broken:before {
  content: ""; }

.fa-question:before {
  content: ""; }

.fa-info:before {
  content: ""; }

.fa-exclamation:before {
  content: ""; }

.fa-superscript:before {
  content: ""; }

.fa-subscript:before {
  content: ""; }

.fa-eraser:before {
  content: ""; }

.fa-puzzle-piece:before {
  content: ""; }

.fa-microphone:before {
  content: ""; }

.fa-microphone-slash:before {
  content: ""; }

.fa-shield:before {
  content: ""; }

.fa-calendar-o:before {
  content: ""; }

.fa-fire-extinguisher:before {
  content: ""; }

.fa-rocket:before {
  content: ""; }

.fa-maxcdn:before {
  content: ""; }

.fa-chevron-circle-left:before {
  content: ""; }

.fa-chevron-circle-right:before {
  content: ""; }

.fa-chevron-circle-up:before {
  content: ""; }

.fa-chevron-circle-down:before {
  content: ""; }

.fa-html5:before {
  content: ""; }

.fa-css3:before {
  content: ""; }

.fa-anchor:before {
  content: ""; }

.fa-unlock-alt:before {
  content: ""; }

.fa-bullseye:before {
  content: ""; }

.fa-ellipsis-h:before {
  content: ""; }

.fa-ellipsis-v:before {
  content: ""; }

.fa-rss-square:before {
  content: ""; }

.fa-play-circle:before {
  content: ""; }

.fa-ticket:before {
  content: ""; }

.fa-minus-square:before {
  content: ""; }

.fa-minus-square-o:before {
  content: ""; }

.fa-level-up:before {
  content: ""; }

.fa-level-down:before {
  content: ""; }

.fa-check-square:before {
  content: ""; }

.fa-pencil-square:before {
  content: ""; }

.fa-external-link-square:before {
  content: ""; }

.fa-share-square:before {
  content: ""; }

.fa-compass:before {
  content: ""; }

.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: ""; }

.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: ""; }

.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: ""; }

.fa-euro:before,
.fa-eur:before {
  content: ""; }

.fa-gbp:before {
  content: ""; }

.fa-dollar:before,
.fa-usd:before {
  content: ""; }

.fa-rupee:before,
.fa-inr:before {
  content: ""; }

.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: ""; }

.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: ""; }

.fa-won:before,
.fa-krw:before {
  content: ""; }

.fa-bitcoin:before,
.fa-btc:before {
  content: ""; }

.fa-file:before {
  content: ""; }

.fa-file-text:before {
  content: ""; }

.fa-sort-alpha-asc:before {
  content: ""; }

.fa-sort-alpha-desc:before {
  content: ""; }

.fa-sort-amount-asc:before {
  content: ""; }

.fa-sort-amount-desc:before {
  content: ""; }

.fa-sort-numeric-asc:before {
  content: ""; }

.fa-sort-numeric-desc:before {
  content: ""; }

.fa-thumbs-up:before {
  content: ""; }

.fa-thumbs-down:before {
  content: ""; }

.fa-youtube-square:before {
  content: ""; }

.fa-youtube:before {
  content: ""; }

.fa-xing:before {
  content: ""; }

.fa-xing-square:before {
  content: ""; }

.fa-youtube-play:before {
  content: ""; }

.fa-dropbox:before {
  content: ""; }

.fa-stack-overflow:before {
  content: ""; }

.fa-instagram:before {
  content: ""; }

.fa-flickr:before {
  content: ""; }

.fa-adn:before {
  content: ""; }

.fa-bitbucket:before {
  content: ""; }

.fa-bitbucket-square:before {
  content: ""; }

.fa-tumblr:before {
  content: ""; }

.fa-tumblr-square:before {
  content: ""; }

.fa-long-arrow-down:before {
  content: ""; }

.fa-long-arrow-up:before {
  content: ""; }

.fa-long-arrow-left:before {
  content: ""; }

.fa-long-arrow-right:before {
  content: ""; }

.fa-apple:before {
  content: ""; }

.fa-windows:before {
  content: ""; }

.fa-android:before {
  content: ""; }

.fa-linux:before {
  content: ""; }

.fa-dribbble:before {
  content: ""; }

.fa-skype:before {
  content: ""; }

.fa-foursquare:before {
  content: ""; }

.fa-trello:before {
  content: ""; }

.fa-female:before {
  content: ""; }

.fa-male:before {
  content: ""; }

.fa-gittip:before {
  content: ""; }

.fa-sun-o:before {
  content: ""; }

.fa-moon-o:before {
  content: ""; }

.fa-archive:before {
  content: ""; }

.fa-bug:before {
  content: ""; }

.fa-vk:before {
  content: ""; }

.fa-weibo:before {
  content: ""; }

.fa-renren:before {
  content: ""; }

.fa-pagelines:before {
  content: ""; }

.fa-stack-exchange:before {
  content: ""; }

.fa-arrow-circle-o-right:before {
  content: ""; }

.fa-arrow-circle-o-left:before {
  content: ""; }

.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: ""; }

.fa-dot-circle-o:before {
  content: ""; }

.fa-wheelchair:before {
  content: ""; }

.fa-vimeo-square:before {
  content: ""; }

.fa-turkish-lira:before,
.fa-try:before {
  content: ""; }

.fa-plus-square-o:before {
  content: ""; }

.fa-space-shuttle:before {
  content: ""; }

.fa-slack:before {
  content: ""; }

.fa-envelope-square:before {
  content: ""; }

.fa-wordpress:before {
  content: ""; }

.fa-openid:before {
  content: ""; }

.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: ""; }

.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: ""; }

.fa-yahoo:before {
  content: ""; }

.fa-google:before {
  content: ""; }

.fa-reddit:before {
  content: ""; }

.fa-reddit-square:before {
  content: ""; }

.fa-stumbleupon-circle:before {
  content: ""; }

.fa-stumbleupon:before {
  content: ""; }

.fa-delicious:before {
  content: ""; }

.fa-digg:before {
  content: ""; }

.fa-pied-piper-square:before,
.fa-pied-piper:before {
  content: ""; }

.fa-pied-piper-alt:before {
  content: ""; }

.fa-drupal:before {
  content: ""; }

.fa-joomla:before {
  content: ""; }

.fa-language:before {
  content: ""; }

.fa-fax:before {
  content: ""; }

.fa-building:before {
  content: ""; }

.fa-child:before {
  content: ""; }

.fa-paw:before {
  content: ""; }

.fa-spoon:before {
  content: ""; }

.fa-cube:before {
  content: ""; }

.fa-cubes:before {
  content: ""; }

.fa-behance:before {
  content: ""; }

.fa-behance-square:before {
  content: ""; }

.fa-steam:before {
  content: ""; }

.fa-steam-square:before {
  content: ""; }

.fa-recycle:before {
  content: ""; }

.fa-automobile:before,
.fa-car:before {
  content: ""; }

.fa-cab:before,
.fa-taxi:before {
  content: ""; }

.fa-tree:before {
  content: ""; }

.fa-spotify:before {
  content: ""; }

.fa-deviantart:before {
  content: ""; }

.fa-soundcloud:before {
  content: ""; }

.fa-database:before {
  content: ""; }

.fa-file-pdf-o:before {
  content: ""; }

.fa-file-word-o:before {
  content: ""; }

.fa-file-excel-o:before {
  content: ""; }

.fa-file-powerpoint-o:before {
  content: ""; }

.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: ""; }

.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: ""; }

.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: ""; }

.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: ""; }

.fa-file-code-o:before {
  content: ""; }

.fa-vine:before {
  content: ""; }

.fa-codepen:before {
  content: ""; }

.fa-jsfiddle:before {
  content: ""; }

.fa-life-bouy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: ""; }

.fa-circle-o-notch:before {
  content: ""; }

.fa-ra:before,
.fa-rebel:before {
  content: ""; }

.fa-ge:before,
.fa-empire:before {
  content: ""; }

.fa-git-square:before {
  content: ""; }

.fa-git:before {
  content: ""; }

.fa-hacker-news:before {
  content: ""; }

.fa-tencent-weibo:before {
  content: ""; }

.fa-qq:before {
  content: ""; }

.fa-wechat:before,
.fa-weixin:before {
  content: ""; }

.fa-send:before,
.fa-paper-plane:before {
  content: ""; }

.fa-send-o:before,
.fa-paper-plane-o:before {
  content: ""; }

.fa-history:before {
  content: ""; }

.fa-circle-thin:before {
  content: ""; }

.fa-header:before {
  content: ""; }

.fa-paragraph:before {
  content: ""; }

.fa-sliders:before {
  content: ""; }

.fa-share-alt:before {
  content: ""; }

.fa-share-alt-square:before {
  content: ""; }

.fa-bomb:before {
  content: ""; }

/* Bootstrap Overwrites
   ========================================================================== */
.alert-warning {
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #333; }
  .alert-warning hr {
    border-top-color: #f7e1b5; }
  .alert-warning .alert-link {
    color: #66512c; }

.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #333; }
  .alert-danger hr {
    border-top-color: #e4b9c0; }
  .alert-danger .alert-link {
    color: #843534; }

.alert-link {
  background-color: #F8FFD6;
  border-color: #E9F19C;
  color: #020621;
  display: block; }
  .alert-link hr {
    border-top-color: #e4ee86; }
  .alert-link .alert-link {
    color: #020621; }
  .alert-link h2 {
    margin-top: 0; }
  .alert-link:hover, .alert-link:active {
    color: #020621; }

.btn, .icon-nav label {
  outline: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  -webkit-font-smoothing: subpixel-antialiased; }

.btn-lg, .btn-group-lg > .btn, .icon-nav .btn-group-lg > label {
  font-size: 16px;
  font-weight: 400; }

.btn-hg,
.btn-group-hg > .btn, .icon-nav
.btn-group-hg > label {
  padding: 14px 24px;
  font-size: 18px;
  line-height: 1.33; }

.btn-default, .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {
  color: #333;
  background-color: #e8e8e8;
  border-color: #CCC; }
  .btn-default:hover, .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .icon-nav label:hover, .icon-nav .timeline .dropdown-menu li label:hover, .btn-default:focus, .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li .icon-nav label:focus, .icon-nav .timeline .dropdown-menu li label:focus, .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,
  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li
  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav
  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li
  .open > label.dropdown-toggle {
    color: #333;
    background-color: #dbdbdb;
    border-color: #adadad;
    outline: 0; }
  .btn-default.disabled, .timeline .dropdown-menu li .disabled.btn, .timeline .dropdown-menu li .icon-nav label.disabled, .icon-nav .timeline .dropdown-menu li label.disabled, .btn-default.disabled:hover, .timeline .dropdown-menu li .disabled.btn:hover, .timeline .dropdown-menu li .icon-nav label.disabled:hover, .icon-nav .timeline .dropdown-menu li label.disabled:hover, .btn-default.disabled:focus, .timeline .dropdown-menu li .disabled.btn:focus, .timeline .dropdown-menu li .icon-nav label.disabled:focus, .icon-nav .timeline .dropdown-menu li label.disabled:focus, .btn-default.disabled:active, .timeline .dropdown-menu li .disabled.btn:active, .timeline .dropdown-menu li .icon-nav label.disabled:active, .icon-nav .timeline .dropdown-menu li label.disabled:active, .btn-default.disabled.active, .timeline .dropdown-menu li .disabled.active.btn, .timeline .dropdown-menu li .icon-nav label.disabled.active, .icon-nav .timeline .dropdown-menu li label.disabled.active, .btn-default[disabled], .timeline .dropdown-menu li [disabled].btn, .timeline .dropdown-menu li .icon-nav label[disabled], .icon-nav .timeline .dropdown-menu li label[disabled], .btn-default[disabled]:hover, .timeline .dropdown-menu li [disabled].btn:hover, .timeline .dropdown-menu li .icon-nav label[disabled]:hover, .icon-nav .timeline .dropdown-menu li label[disabled]:hover, .btn-default[disabled]:focus, .timeline .dropdown-menu li [disabled].btn:focus, .timeline .dropdown-menu li .icon-nav label[disabled]:focus, .icon-nav .timeline .dropdown-menu li label[disabled]:focus, .btn-default[disabled]:active, .timeline .dropdown-menu li [disabled].btn:active, .timeline .dropdown-menu li .icon-nav label[disabled]:active, .icon-nav .timeline .dropdown-menu li label[disabled]:active, .btn-default[disabled].active, .timeline .dropdown-menu li [disabled].active.btn, .timeline .dropdown-menu li .icon-nav label[disabled].active, .icon-nav .timeline .dropdown-menu li label[disabled].active,
  fieldset[disabled] .btn-default,
  fieldset[disabled] .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li
  fieldset[disabled] .btn,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label,
  fieldset[disabled] .btn-default:hover,
  fieldset[disabled] .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li
  fieldset[disabled] .btn:hover,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:hover,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:hover,
  fieldset[disabled] .btn-default:focus,
  fieldset[disabled] .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li
  fieldset[disabled] .btn:focus,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:focus,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:focus,
  fieldset[disabled] .btn-default:active,
  fieldset[disabled] .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li
  fieldset[disabled] .btn:active,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label:active,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label:active,
  fieldset[disabled] .btn-default.active,
  fieldset[disabled] .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li
  fieldset[disabled] .active.btn,
  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav
  fieldset[disabled] label.active,
  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li
  fieldset[disabled] label.active {
    background-color: #e8e8e8;
    border-color: #d5d5d5; }
  .btn-default .fa:before, .timeline .dropdown-menu li .btn .fa:before, .timeline .dropdown-menu li .icon-nav label .fa:before, .icon-nav .timeline .dropdown-menu li label .fa:before {
    color: #4d4d4d; }

.btn-inverse {
  color: #fff;
  background-color: #262626;
  border-color: #555; }
  .btn-inverse:hover, .btn-inverse:focus, .btn-inverse:active, .btn-inverse.active,
  .open > .btn-inverse.dropdown-toggle {
    color: #fff;
    background-color: #1a1a1a;
    border-color: #363636;
    outline: 0; }
  .btn-inverse.disabled, .btn-inverse.disabled:hover, .btn-inverse.disabled:focus, .btn-inverse.disabled:active, .btn-inverse.disabled.active, .btn-inverse[disabled], .btn-inverse[disabled]:hover, .btn-inverse[disabled]:focus, .btn-inverse[disabled]:active, .btn-inverse[disabled].active,
  fieldset[disabled] .btn-inverse,
  fieldset[disabled] .btn-inverse:hover,
  fieldset[disabled] .btn-inverse:focus,
  fieldset[disabled] .btn-inverse:active,
  fieldset[disabled] .btn-inverse.active {
    background-color: #262626;
    border-color: #333333; }

.btn-primary {
  color: #fff;
  background-color: #4ab767;
  border-color: #4ab767; }
  .btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active,
  .open > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #42a65c;
    border-color: #388c4e;
    outline: 0; }
  .btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled]:active, .btn-primary[disabled].active,
  fieldset[disabled] .btn-primary,
  fieldset[disabled] .btn-primary:hover,
  fieldset[disabled] .btn-primary:focus,
  fieldset[disabled] .btn-primary:active,
  fieldset[disabled] .btn-primary.active {
    background-color: #4ab767;
    border-color: #5cbe76; }

.btn-google-auth {
  color: #555;
  background-color: #fff;
  border-color: #e8e8e8; }
  .btn-google-auth:hover, .btn-google-auth:focus, .btn-google-auth:active, .btn-google-auth.active,
  .open > .btn-google-auth.dropdown-toggle {
    color: #555;
    background-color: #f2f2f2;
    border-color: #c9c9c9;
    outline: 0; }
  .btn-google-auth.disabled, .btn-google-auth.disabled:hover, .btn-google-auth.disabled:focus, .btn-google-auth.disabled:active, .btn-google-auth.disabled.active, .btn-google-auth[disabled], .btn-google-auth[disabled]:hover, .btn-google-auth[disabled]:focus, .btn-google-auth[disabled]:active, .btn-google-auth[disabled].active,
  fieldset[disabled] .btn-google-auth,
  fieldset[disabled] .btn-google-auth:hover,
  fieldset[disabled] .btn-google-auth:focus,
  fieldset[disabled] .btn-google-auth:active,
  fieldset[disabled] .btn-google-auth.active {
    background-color: #fff;
    border-color: #e25d48; }

.btn-white {
  color: #3b9352;
  background-color: #fff;
  border-color: #fff; }
  .btn-white:hover, .btn-white:focus, .btn-white:active, .btn-white.active,
  .open > .btn-white.dropdown-toggle {
    color: #3b9352;
    background-color: #f2f2f2;
    border-color: #e0e0e0;
    outline: 0; }
  .btn-white.disabled, .btn-white.disabled:hover, .btn-white.disabled:focus, .btn-white.disabled:active, .btn-white.disabled.active, .btn-white[disabled], .btn-white[disabled]:hover, .btn-white[disabled]:focus, .btn-white[disabled]:active, .btn-white[disabled].active,
  fieldset[disabled] .btn-white,
  fieldset[disabled] .btn-white:hover,
  fieldset[disabled] .btn-white:focus,
  fieldset[disabled] .btn-white:active,
  fieldset[disabled] .btn-white.active {
    background-color: #fff;
    border-color: white; }

.btn-toggle {
  display: inline; }

pre {
  overflow: auto; }

.dropdown .dropdown-menu {
  top: 120%;
  left: auto;
  right: 0;
  padding: 0;
  overflow: hidden; }
  .dropdown .dropdown-menu > li > a {
    padding: 8px; }
  .dropdown .dropdown-menu .divider {
    height: 1px;
    margin: 0 0;
    overflow: hidden;
    background-color: #e5e5e5; }
  .dropdown .dropdown-menu ul {
    list-style: none;
    margin: 0;
    padding: 0; }

.dropdown > .dropdown-menu::before,
.dropdown > .dropdown-menu::after {
  position: absolute;
  display: inline-block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ccc;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: ''; }

.dropdown > .dropdown-menu::before {
  top: -7px;
  right: 9px; }

.dropdown > .dropdown-menu::before,
.dropdown > .dropdown-menu::after {
  top: -7px;
  right: 9px; }

.dropdown > .dropdown-menu::after {
  top: -6px;
  right: 10px;
  border-left-width: 6px;
  border-right-width: 6px;
  border-bottom-width: 6px;
  border-bottom-color: #fff; }

.dropdown .dropdown-menu > ul > li > a,
.dropdown .action-sheet > ul > li > a {
  color: #4d4d4d;
  display: block;
  padding: 10px;
  margin: 0; }

.dropdown .dropdown-menu > ul > li > a:hover,
.dropdown .dropdown-menu > ul > li > a:focus {
  background-color: rgba(150, 150, 150, 0.1);
  color: #0081BA; }

.dropdown .dropdown-menu > ul > li > a.old-app,
.dropdown .dropdown-menu > ul > li > a.old-app {
  background-color: #EEE;
  margin-right: 0; }

.dropdown .dropdown-menu > ul > li > a.old-app:focus,
.dropdown .dropdown-menu > ul > li > a.old-app:hover {
  color: #000;
  background-color: #DDD; }

.dropdown .dropdown-menu > ul > .active > a,
.dropdown .dropdown-menu > ul > .active > a:hover,
.dropdown .dropdown-menu > ul > .active > a:focus {
  background-color: #357ebd; }

.form-group {
  margin-bottom: 20px; }

.custom-addon .input-group-addon, .checkbox-addon .input-group-addon, .storage-group .input-group-addon {
  background: none;
  padding: 0 10px 0 10px;
  border: 0;
  vertical-align: top; }

.custom-addon .form-control, .checkbox-addon .form-control, .storage-group .form-control {
  border-bottom-right-radius: 4px !important;
  border-top-right-radius: 4px !important; }

.input-group-addon {
  border-radius: 4px; }

.form-inline .form-control-static, .navbar-form .form-control-static {
  display: inline-block; }

.form-control-static {
  vertical-align: middle;
  border-radius: 4px;
  padding: 7px 0; }

.control-label {
  line-height: 22px;
  font-weight: 600;
  color: #444; }

.control-label-secondary {
  font-weight: 400; }

.input-group > .form-control,
.input-group > .input-group-addon,
.input-group > .input-group-btn > .btn, .icon-nav
.input-group > .input-group-btn > label {
  height: 34px; }

.label-primary {
  background-color: #0081BA; }
  .label-primary[href]:hover, .label-primary[href]:focus {
    background-color: #3071a9; }

.label-success {
  background-color: #4ab767; }
  .label-success[href]:hover, .label-success[href]:focus {
    background-color: #449d44; }

.label-default {
  background: #f4f4f4;
  border: 1px solid #e6e6e6;
  color: #555; }

.label {
  font-size: 12px; }

.navbar {
  position: relative;
  z-index: 1000;
  padding: 0;
  border-radius: 0;
  border: none;
  min-height: 0;
  margin-bottom: 0; }
  .navbar .navbar-header {
    display: inline-block; }
  .navbar .navbar-nav {
    margin: 0; }
    .navbar .navbar-nav.navbar-left {
      float: left; }
    .navbar .navbar-nav.navbar-right {
      float: right;
      display: inline-block; }
    .navbar .navbar-nav .open .dropdown-menu > li > a:hover, .navbar .navbar-nav .open .dropdown-menu > li > a:focus {
      color: #0081BA; }
  .navbar.navbar-default {
    box-shadow: 0px 2px 10px 0 rgba(22, 22, 22, 0.05); }
    .navbar.navbar-default .navbar-nav .dropdown .dropdown-menu {
      border-radius: 4px; }
    .navbar.navbar-default .navbar-nav > li {
      display: inline-block;
      vertical-align: top; }
    .navbar.navbar-default .navbar-nav > li > a {
      border-radius: 4px;
      font-size: 13px; }
      .navbar.navbar-default .navbar-nav > li > a.selected {
        color: #444; }
    .navbar.navbar-default .navbar-nav > .open > a {
      background: #FFF; }
  .navbar .navbar-brand {
    height: 36px;
    min-width: 36px;
    margin-top: 8px;
    padding: 4px 8px; }
    .navbar .navbar-brand img {
      height: 100%; }

.navbar {
  /* Small Devices, Tablets */
  /* Medium Devices, Desktops */ }
  @media (max-width: 767px) {
    .navbar .navbar-nav .open .dropdown-menu {
      background-color: #FFF;
      position: absolute;
      border: 1px solid #CCC; } }
  @media (min-width: 992px) {
    .navbar {
      padding: 2px 0;
      margin-bottom: 0; }
      .navbar .navbar-brand {
        padding-top: 0; } }

.nav-tabs {
  border-bottom: 1px solid #ddd; }
  .nav-tabs > li > a {
    border-radius: 4px 4px 0 0; }

.nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {
  border-radius: 4px; }

@media (min-width: 768px) {
  .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {
    border-radius: 4px 4px 0 0; } }

.panel > .panel-heading, .content-box > .panel-heading, .select-subcompany-modal .list-group > .panel-heading, .content-box-editable > .panel-heading, .card > .panel-heading, #appLauncherContainer .scrollable-list > .panel-heading, #appLauncherContainer .template-grid > .panel-heading {
  position: relative;
  background: #f7f7f7;
  padding: 8px;
  border: none;
  border-left: 0; }

/* Deprecate
   ==========================================================================
   ==========================================================================
   ==========================================================================
   ==========================================================================
   ========================================================================== */
.panel-info {
  border: 1px solid #87daff; }
  .panel-info > .panel-heading .toolbar {
    text-align: right;
    margin-right: 30px;
    padding: 3px 0; }
    @media (max-width: 768px) {
      .panel-info > .panel-heading .toolbar {
        margin-right: 0;
        margin-top: 10px; }
        .panel-info > .panel-heading .toolbar .btn, .panel-info > .panel-heading .toolbar .icon-nav label, .icon-nav .panel-info > .panel-heading .toolbar label {
          display: block;
          width: 100%;
          margin-bottom: 4px; } }
  .panel-info > .panel-body, .panel-info > .content-box-body {
    border-left: 3px solid #87daff;
    background: #d4f2ff;
    padding: 15px; }
  .panel-info .table-2 tr > td:last-child {
    text-align: right; }

.upload-panel {
  overflow: hidden; }
  .upload-panel .content-box-body {
    border-left: 3px solid #d4d4d4; }
  .upload-panel .content-box-header {
    background: #f7f7f7;
    border-left: 3px solid #d4d4d4;
    padding: 10px 15px;
    color: #555;
    cursor: pointer;
    overflow: hidden; }
    .upload-panel .content-box-header p {
      float: left; }
    @media (max-width: 768px) {
      .upload-panel .content-box-header p {
        float: none; }
      .upload-panel .content-box-header .actions-block {
        text-align: left; } }
  .upload-panel p {
    overflow: hidden;
    margin: 5px 0 5px 0; }
    .upload-panel p a {
      text-transform: capitalize;
      float: right; }
  .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    vertical-align: top; }
    @media (max-width: 480px) {
      .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {
        width: 120px; } }
    @media (max-width: 768px) {
      .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {
        width: 180px; } }
  .upload-panel .actions-block {
    text-align: right; }
  .upload-panel .collapse-control {
    line-height: 28px;
    padding: 0 15px;
    margin-right: -15px;
    float: right; }

@media print {
  .hidden-print {
    display: none !important; }
  .visible-print {
    display: block !important; }
  table.visible-print {
    display: table; }
  th.visible-print, td.visible-print {
    display: table-cell !important; }
  tr.visible-print {
    display: table-row !important; } }

.tooltip-inner {
  border-radius: 4px; }

.form-control {
  box-shadow: none; }

/* ==========================================================================
   Modals
   ========================================================================== */
/**
 * Part of workaround for Bootstrap bug where content shifts when modal
 * is opened.
 *
 * https://github.com/twbs/bootstrap/issues/9855

 */
.modal {
  z-index: 9999; }

.modal-backdrop.in {
  z-index: 9001; }

.modal-content {
  padding: 0;
  background: #fcfcfc; }

.modal-open {
  overflow: auto; }

.close {
  font-size: 14px;
  margin-top: 0px;
  height: 55px;
  width: 55px; }

.modal-header {
  margin-bottom: 0;
  background: #f2f2f2;
  overflow: hidden;
  border-radius: 4px 4px 0 0; }

.modal-title {
  font-weight: 500;
  padding: 15px; }

.modal-title + .header-nav {
  margin-top: -5px; }

.modal-body {
  padding: 15px; }

.modal-header, .modal-footer {
  padding: 0; }

.modal-footer {
  padding: 0 15px 15px;
  border: 0;
  margin-top: 0; }
  .modal-footer input[type="checkbox"] {
    float: none; }

.modal-dialog.modal-lg {
  width: auto; }

/* Media queries
   ========================================================================== */
@media (max-width: 480px) {
  .modal-header .close {
    padding: 15px; }
  .modal-footer .btn-fixed-width {
    width: 96px; } }

@media (min-width: 768px) {
  .modal-dialog {
    width: 600px;
    margin: 30px auto; }
  .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }
  .modal-sm {
    width: 300px; } }

.breadcrumb {
  font-size: 12px;
  padding: 0;
  margin-bottom: 0px;
  overflow: hidden;
  white-space: nowrap;
  background: none; }
  .breadcrumb > li {
    vertical-align: top; }
    .breadcrumb > li a, .breadcrumb > li span {
      max-width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      vertical-align: top; }

@media only screen and (min-width: 768px) {
  .breadcrumb {
    padding: 10px 0;
    font-size: 16px; }
    .breadcrumb > li a, .breadcrumb > li span {
      max-width: 240px; } }

.storage-app .breadcrumb {
  font-size: 14px;
  padding: 7px 10px; }

/* Core
   ========================================================================== */
/* ==========================================================================
   Standard tags
   ========================================================================== */
html {
  height: 100%;
  -ms-overflow-style: scrollbar;
  overflow-y: scroll; }

body {
  min-height: 100%;
  overflow: auto; }

html,
body {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%; }

/**
* Start of workaround for Bootstrap bug where content shifts when modal
* is opened.

* https://github.com/twbs/bootstrap/issues/9855
*/
body.modal-open {
  overflow: hidden; }

a:focus, button:focus {
  outline: 0 !important;
  text-decoration: none !important; }

/* Resets */
ul {
  list-style: none;
  padding: 0; }

/* Company Users
   ========================================================================== */
.company-users .action-bar {
  margin-bottom: 10px; }
  .company-users .action-bar .sort > a {
    color: #333; }
  .company-users .action-bar .sort > a:not(:first-child) {
    margin-left: 15px; }

.company-users .edit {
  text-align: right; }

/* Payment Methods */
.payment-methods .list-group-item {
  padding: 10px 0; }

.payment-methods .expiry {
  color: #555; }

/* ==========================================================================
   Forms
   ========================================================================== */
/* Input field focus */
textarea, input, div, input:focus {
  outline: none; }

/* Turn off number input spinners in WebKit. */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; }

/* Close button
   ========================================================================== */
.close {
  opacity: 1; }
  .close .fa::before, .close .glyphicons::before {
    color: #555; }
  .close:hover .fa::before, .close:hover .glyphicons::before {
    color: #4d4d4d; }

/* Sticky buttons
   ========================================================================== */
.sticky-buttons {
  /* Positioning */
  z-index: 10;
  /* Display & Box Model */
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  /* Visual */
  background-color: #fff; }
  .sticky-buttons > button {
    /* Display & Box Model */
    margin-bottom: 10px; }
  .sticky-buttons > a[type="button"] {
    /* Display & Box Model */
    margin-bottom: 10px; }

/* Toggle buttons (http://www.bootstrap-switch.org/)
   ========================================================================== */
.has-switch {
  /* Visual */
  border-radius: 8px;
  border-color: #DDDDDD;
  /* Display & Box Model */
  min-width: 120px;
  margin-top: -1px; }
  .has-switch > div > label,
  .has-switch > div > span {
    /* Display & Box Model */
    padding-bottom: 7px;
    padding-top: 7px;
    /* Visual */
    font-size: 16px; }

/* ==========================================================================
   Footer
   ========================================================================== */
.footer {
  /* Display & Box Model */
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid 1px solid #ccc;
  /* Visual */
  background-color: #fff; }

.social-text {
  display: inline-block;
  margin-bottom: 10px; }

ul.social {
  display: inline-block; }
  ul.social li a {
    /* Display & Box Model */
    display: block;
    width: 24px;
    height: 24px;
    /* Visual */
    text-indent: -9999em;
    background: url("http://s3.amazonaws.com/Common-Test/css/images/social.png") 0 0 no-repeat; }
  ul.social li.twit a {
    background-position: -24px 0; }
  ul.social li.in a {
    background-position: -48px 0; }
  ul.social li.gplus a {
    background-position: -72px 0; }
  ul.social li.email a {
    background-position: -96px 0; }

.button-row {
  overflow: hidden;
  margin: 40px 0 40px; }

/* Media queries
   ========================================================================== */
@media (min-width: 768px) {
  .copyright {
    text-align: right; } }

/* Buttons
   ========================================================================== */
.button-badge {
  margin-right: -20px;
  float: right;
  margin-top: -10px;
  height: 20px;
  line-height: 20px;
  padding: 0 7px; }

.btn-remove .fa::before,
.btn-remove .glyphicons::before {
  color: #d9534f;
  font-size: 16px; }

.btn-all {
  background: #fff;
  border-color: #fff; }
  .btn-all .fa, .btn-all .glyphicons {
    margin-top: -5px; }

.btn-back:hover .fa-back,
.btn-back:hover .glyphicons-back {
  background: url("//s3.amazonaws.com/rise-common-test/images/glyphicons-back-active.png") center no-repeat; }

/* Sign In button */
.btn-sign-in .log_in, .modal-dialog .sign-in .log_in {
  color: #fff; }

.sign-in, .top-auth-button {
  background: none;
  height: 32px;
  line-height: 32px;
  padding: 0;
  border: 0;
  color: #777;
  font-weight: 500; }
  .sign-in:hover, .sign-in:active, .top-auth-button:hover, .top-auth-button:active {
    text-decoration: none;
    color: #0081BA; }

.top-auth-button img {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-left: 3px;
  vertical-align: top;
  margin-top: 2px; }

/* SVG CLASSES */
.btn svg, .icon-nav label svg {
  width: 20px;
  height: 20px;
  vertical-align: top; }

.btn-default svg, .timeline .dropdown-menu li .btn svg, .timeline .dropdown-menu li .icon-nav label svg, .icon-nav .timeline .dropdown-menu li label svg {
  margin-left: 5px; }

.btn svg path, .icon-nav label svg path {
  fill: #666; }

/* Horizontal rule
   ========================================================================== */
.hr-thick {
  border-top: 2px solid #cbcbcb; }

.hr-dashed {
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 2px dashed #cbcbcb; }

/* Other
   ========================================================================== */
.title {
  margin-top: 10px;
  margin-bottom: 0; }

.dropdown-title {
  color: #4d4d4d;
  font-weight: bold; }

.qty {
  width: 40px;
  height: 28px; }

.danger {
  color: #d9534f; }

.icon-left {
  margin-right: 10px; }

.icon-right {
  margin-left: 10px; }

.icon-sm-left {
  margin-right: 5px; }

.icon-sm-right {
  margin-left: 5px; }

.list-separator {
  border-bottom: 1px solid #eee;
  width: auto; }

.error {
  font-weight: bold; }

.checkbox-primary > label {
  font-weight: bold; }

.label-disabled {
  color: #e6e6e6; }

.add-padding {
  padding: 10px !important; }

.add-left {
  margin-left: 10px !important; }

.add-right {
  margin-right: 10px !important; }

.remove-bottom {
  margin-bottom: 0 !important; }

.small-bottom {
  margin-bottom: 3px !important; }

.half-bottom {
  margin-bottom: 10px !important; }

.add-bottom {
  margin-bottom: 20px !important; }

.add-bottom-double {
  margin-bottom: 40px !important; }

.remove-top {
  margin-top: 0 !important; }

.small-top {
  margin-top: 3px !important; }

.half-top {
  margin-top: 10px !important; }

.add-top {
  margin-top: 20px !important; }

.add-top-double {
  margin-top: 40px !important; }

.remove-radius {
  border-radius: 0 !important; }

.remove-margin {
  margin: 0 !important; }

.remove-padding {
  padding: 0 !important; }

.btn-google-drive,
.btn-google-drive:active .btn-google-drive.active {
  width: 30px;
  height: 30px;
  border: none !important;
  background-repeat: no-repeat;
  background-color: transparent !important;
  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive.png);
  background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive.png"); }
  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {
    .btn-google-drive,
    .btn-google-drive:active .btn-google-drive.active {
      background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive-2x.png");
      -webkit-background-size: 30px 30px; } }

.btn-widget-icon-link,
.btn-widget-icon-link:active .btn-widget-icon-link.active {
  width: 30px;
  height: 30px;
  border: none !important;
  background-repeat: no-repeat;
  background-color: transparent !important;
  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link.png);
  background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link.png"); }
  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {
    .btn-widget-icon-link,
    .btn-widget-icon-link:active .btn-widget-icon-link.active {
      background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link-2x.png");
      -webkit-background-size: 30px 30px; } }

.btn-widget-icon-storage,
.btn-widget-icon-storage:active .btn-widget-icon-storage.active {
  width: 30px;
  height: 30px;
  border: none !important;
  background-repeat: no-repeat;
  background-color: transparent !important;
  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage.png);
  background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage.png"); }
  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {
    .btn-widget-icon-storage,
    .btn-widget-icon-storage:active .btn-widget-icon-storage.active {
      background-image: url("http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage-2x.png");
      -webkit-background-size: 30px 30px; } }

/* STANDARD UTILITIES
All utilities have a prefix u_ added to them
*/
/* Line Height Utilities
   ==========================================================================
   To be used with forms and buttons
*/
/* For Normal Sized Buttons and Input Fields */
.u_lh-normal {
  line-height: 33px; }

/* Ellipsis Utilities
   ==========================================================================
   To be used with forms and buttons
*/
.u_ellipsis, .u_ellipsis-md, .u_ellipsis-lg, .navbar-default li.user-profile-dropdown .user-id span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

@media (max-width: 767px) {
  .u_ellipsis-md {
    width: 100px; } }

@media (min-width: 768px) {
  .u_ellipsis-md {
    max-width: 140px; } }

@media (min-width: 992px) {
  .u_ellipsis-md {
    max-width: 180px; } }

@media (min-width: 1200px) {
  .u_ellipsis-md {
    max-width: 240px; } }

@media (max-width: 767px) {
  .u_ellipsis-lg {
    width: 200px; } }

@media (min-width: 768px) {
  .u_ellipsis-lg {
    max-width: 260px; } }

@media (min-width: 992px) {
  .u_ellipsis-lg {
    max-width: 320px; } }

@media (min-width: 1200px) {
  .u_ellipsis-lg {
    max-width: 340px; } }

/* Styling Utilities
   ========================================================================== */
.u_bordered {
  border: 1px solid #d5d5d5;
  border-radius: 4px; }

/* Text Utilities
 */
.u_text-ellipsis, .ellipsis, .editor-playlist .editor-playlist-item .playlist-item-name span, .placeholder-item-name, .display-name span, .display-address span, .playlist-item-reference {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.u_icon-hover > i {
  opacity: 0; }

.u_icon-hover:hover > i {
  opacity: 1; }

/*
==========================================================================
==========================================================================
==========================================================================
DEPRECATE Old Utilities
   ========================================================================== */
.nowrap {
  white-space: nowrap; }

.clickable {
  cursor: pointer; }

.ahrefdisabled {
  color: #AAAAAA;
  cursor: default;
  pointer-events: none;
  text-decoration: none; }

.highlighted {
  background: #FFFFE0;
  text-transform: uppercase;
  font-weight: bold;
  display: inline-block; }

.empty-state .tag {
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%); }

.radio-vertical-align {
  display: inline-block; }

.radio-vertical-align input,
.radio-vertical-align label {
  display: inline-block;
  vertical-align: middle; }

.app-navigation svg {
  width: 24px;
  height: 24px;
  background: red; }

.app-navigation path:first-child {
  fill: #4AB767; }

.app-navigation path:last-child {
  fill: #2D60AD; }

.file-empty-state path {
  fill: #969595;
  opacity: .65; }

svg:hover path {
  fill: rgba(0, 0, 0, 0.7); }

path {
  fill: rgba(0, 0, 0, 0.4); }

.fa.icon-gray:before {
  color: #BBB; }

.fa.icon-red:before {
  color: #cf371f; }

.fa.icon-green:before {
  color: #4ab767; }

.fa.icon-white:before {
  color: #fff; }

.text-white {
  color: #FFF; }

.row.sm-gutter, .support-app .ticket-list-table .sm-gutter.title-row, .support-app .ticket-list-table .sm-gutter.ticket {
  margin-left: -4px;
  margin-right: -4px; }

.row.sm-gutter [class*='col-']:not(:first-child), .support-app .ticket-list-table .sm-gutter.title-row [class*='col-']:not(:first-child), .support-app .ticket-list-table .sm-gutter.ticket [class*='col-']:not(:first-child),
.row.sm-gutter [class*='col-']:not(:last-child), .support-app .ticket-list-table .sm-gutter.title-row [class*='col-']:not(:last-child), .support-app .ticket-list-table .sm-gutter.ticket [class*='col-']:not(:last-child) {
  padding-right: 4px;
  padding-left: 4px; }

.row.no-gutter, .support-app .ticket-list-table .no-gutter.title-row, .support-app .ticket-list-table .no-gutter.ticket {
  margin-left: 0px;
  margin-right: 0px; }

.row.no-gutter [class*='col-']:not(:first-child), .support-app .ticket-list-table .no-gutter.title-row [class*='col-']:not(:first-child), .support-app .ticket-list-table .no-gutter.ticket [class*='col-']:not(:first-child),
.row.no-gutter [class*='col-']:not(:last-child), .support-app .ticket-list-table .no-gutter.title-row [class*='col-']:not(:last-child), .support-app .ticket-list-table .no-gutter.ticket [class*='col-']:not(:last-child) {
  padding-right: 0px;
  padding-left: 0px; }

.padding-large {
  padding: 30px; }

.padding-large-horizontal {
  padding-left: 30px;
  padding-right: 30px; }

.padding-small-vertical {
  padding-top: 15px;
  padding-bottom: 15px; }

.img-icon {
  height: 24px;
  width: 24px;
  margin-top: -4px;
  margin-right: -4px;
  vertical-align: bottom;
  display: inline-block;
  margin-left: 5px;
  background-size: 100%; }
  .img-icon.img-icon-google-calendar {
    background-image: url("https://s3.amazonaws.com/Rise-Images/Icons/logo_calendar_32px.png"); }

/* Deprecate
 ==========================================================================
 ==========================================================================
 ==========================================================================
 ==========================================================================
 ========================================================================== */
@media (max-width: 768px) {
  .button-row .btn, .button-row .icon-nav label, .icon-nav .button-row label {
    display: block;
    width: 100%;
    margin-bottom: 10px; } }

/* ==========================================================================
   font awesome
   ========================================================================== */
.fa {
  padding: 0; }

.fa:before {
  position: relative;
  margin: 0; }

.fa-white::before {
  color: #fff; }

.fa-danger::before {
  color: #d9534f; }

.chevron-right::before {
  font-size: 16px; }

.fa-back {
  width: 24px;
  height: 24px;
  background: url("//s3.amazonaws.com/rise-common-test/images/glyphicons-back.png") center no-repeat; }

.fa.fa-grip-large {
  position: relative;
  left: -11px;
  top: 20px;
  color: #ddd; }
  .fa.fa-grip-large:before {
    content: "\\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142"; }

/* ==========================================================================
   Glyphicons
   ========================================================================== */
.glyphicon-box {
  /* Display & Box Model */
  min-width: 60px;
  padding: 3px 10px;
  /* Visual */
  font-size: 23px; }

.glyphicons {
  padding: 0; }

.glyphicons:before {
  position: relative;
  margin: 0; }

.glyphicons::before {
  color: #555; }

.glyphicon-danger::before {
  color: #d9534f; }

.chevron-right::before {
  font-size: 16px; }

.glyphicons-back {
  width: 24px;
  height: 24px;
  background: url("//s3.amazonaws.com/rise-common-test/images/glyphicons-back.png") center no-repeat; }

/* Media queries
   ========================================================================== */
@media (min-width: 768px) {
  .modal-dialog .sign-in {
    padding: 3px 10px;
    /* TODO: Make this a variable. */ }
  .stripe {
    margin-bottom: 0; } }

/* ==========================================================================
   Print Media Queries
   ========================================================================== */
@media print {
  /* Remove header when printing. */
  .navbar {
    display: none; } }

/* Animation */
.delayed {
  -webkit-animation-delay: 1s;
  animation-delay: 1s; }

.animated, #helpDropdownButton.add-notice {
  -webkit-animation-duration: 0.7s;
  animation-duration: 0.7s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both; }

.animated.infinite, .infinite#helpDropdownButton.add-notice {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite; }

.animated.hinge, .hinge#helpDropdownButton.add-notice {
  -webkit-animation-duration: 2s;
  animation-duration: 2s; }

@-webkit-keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }
  40%, 43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0); }
  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0); }
  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0); } }

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }
  40%, 43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0); }
  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0); }
  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0); } }

.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
  -webkit-transform-origin: center bottom;
  -ms-transform-origin: center bottom;
  transform-origin: center bottom; }

@-webkit-keyframes flash {
  0%, 50%, 100% {
    opacity: 1; }
  25%, 75% {
    opacity: 0; } }

@keyframes flash {
  0%, 50%, 100% {
    opacity: 1; }
  25%, 75% {
    opacity: 0; } }

.flash {
  -webkit-animation-name: flash;
  animation-name: flash; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse; }

@-webkit-keyframes rubberBand {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1); }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1); }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1); }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1); }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

@keyframes rubberBand {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1); }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1); }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1); }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1); }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

.rubberBand {
  -webkit-animation-name: rubberBand;
  animation-name: rubberBand; }

@-webkit-keyframes shake {
  0%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }
  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0); }
  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0); } }

@keyframes shake {
  0%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }
  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0); }
  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0); } }

.shake {
  -webkit-animation-name: shake;
  animation-name: shake; }

@-webkit-keyframes swing {
  20% {
    -webkit-transform: rotate3d(0, 0, 1, 15deg);
    transform: rotate3d(0, 0, 1, 15deg); }
  40% {
    -webkit-transform: rotate3d(0, 0, 1, -10deg);
    transform: rotate3d(0, 0, 1, -10deg); }
  60% {
    -webkit-transform: rotate3d(0, 0, 1, 5deg);
    transform: rotate3d(0, 0, 1, 5deg); }
  80% {
    -webkit-transform: rotate3d(0, 0, 1, -5deg);
    transform: rotate3d(0, 0, 1, -5deg); }
  100% {
    -webkit-transform: rotate3d(0, 0, 1, 0deg);
    transform: rotate3d(0, 0, 1, 0deg); } }

@keyframes swing {
  20% {
    -webkit-transform: rotate3d(0, 0, 1, 15deg);
    transform: rotate3d(0, 0, 1, 15deg); }
  40% {
    -webkit-transform: rotate3d(0, 0, 1, -10deg);
    transform: rotate3d(0, 0, 1, -10deg); }
  60% {
    -webkit-transform: rotate3d(0, 0, 1, 5deg);
    transform: rotate3d(0, 0, 1, 5deg); }
  80% {
    -webkit-transform: rotate3d(0, 0, 1, -5deg);
    transform: rotate3d(0, 0, 1, -5deg); }
  100% {
    -webkit-transform: rotate3d(0, 0, 1, 0deg);
    transform: rotate3d(0, 0, 1, 0deg); } }

.swing {
  -webkit-transform-origin: top center;
  -ms-transform-origin: top center;
  transform-origin: top center;
  -webkit-animation-name: swing;
  animation-name: swing; }

@-webkit-keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  10%, 20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg); }
  30%, 50%, 70%, 90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg); }
  40%, 60%, 80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

@keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); }
  10%, 20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg); }
  30%, 50%, 70%, 90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg); }
  40%, 60%, 80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg); }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

.tada {
  -webkit-animation-name: tada;
  animation-name: tada; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@-webkit-keyframes wobble {
  0% {
    -webkit-transform: none;
    transform: none; }
  15% {
    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg); }
  30% {
    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg); }
  45% {
    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg); }
  60% {
    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg); }
  75% {
    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg); }
  100% {
    -webkit-transform: none;
    transform: none; } }

@keyframes wobble {
  0% {
    -webkit-transform: none;
    transform: none; }
  15% {
    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg); }
  30% {
    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg); }
  45% {
    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg); }
  60% {
    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg); }
  75% {
    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg); }
  100% {
    -webkit-transform: none;
    transform: none; } }

.wobble {
  -webkit-animation-name: wobble;
  animation-name: wobble; }

@-webkit-keyframes bounceIn {
  0%, 20%, 40%, 60%, 80%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1); }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03); }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97); }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

@keyframes bounceIn {
  0%, 20%, 40%, 60%, 80%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1); }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03); }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97); }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1); } }

.bounceIn {
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
  -webkit-animation-duration: .75s;
  animation-duration: .75s; }

@-webkit-keyframes bounceInDown {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0); }
  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0); }
  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0); }
  100% {
    -webkit-transform: none;
    transform: none; } }

@keyframes bounceInDown {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0); }
  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0); }
  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0); }
  100% {
    -webkit-transform: none;
    transform: none; } }

.bounceInDown {
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown; }

@-webkit-keyframes bounceInLeft {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-3000px, 0, 0);
    transform: translate3d(-3000px, 0, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0); }
  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0); }
  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0); }
  100% {
    padding: 10px;
    opacity: 1;
    height: auto;
    background: transparent;
    -webkit-transform: none;
    transform: none; } }

@keyframes bounceInLeft {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-3000px, 0, 0);
    transform: translate3d(-3000px, 0, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0); }
  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0); }
  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0); }
  100% {
    -webkit-transform: none;
    transform: none; } }

.bounceInLeft {
  -webkit-animation-name: bounceInLeft;
  animation-name: bounceInLeft; }

@-webkit-keyframes bounceInRight {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0);
    transform: translate3d(3000px, 0, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0);
    transform: translate3d(-25px, 0, 0); }
  75% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0); }
  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0); }
  100% {
    -webkit-transform: none;
    transform: none; } }

@keyframes bounceInRight {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0);
    transform: translate3d(3000px, 0, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0);
    transform: translate3d(-25px, 0, 0); }
  75% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0); }
  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0); }
  100% {
    -webkit-transform: none;
    transform: none; } }

.bounceInRight {
  -webkit-animation-name: bounceInRight;
  animation-name: bounceInRight; }

@-webkit-keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0); }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0); }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0); }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); } }

@keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0); }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0); }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0); }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0); }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); } }

.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp; }

@-webkit-keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9); }
  50%, 55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); } }

@keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9); }
  50%, 55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); } }

.bounceOut {
  -webkit-animation-name: bounceOut;
  animation-name: bounceOut;
  -webkit-animation-duration: .75s;
  animation-duration: .75s; }

@-webkit-keyframes bounceOutDown {
  20% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0); }
  40%, 45% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); } }

@keyframes bounceOutDown {
  20% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0); }
  40%, 45% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); } }

.bounceOutDown {
  -webkit-animation-name: bounceOutDown;
  animation-name: bounceOutDown; }

@-webkit-keyframes bounceOutLeft {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); } }

@keyframes bounceOutLeft {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); } }

.bounceOutLeft {
  -webkit-animation-name: bounceOutLeft;
  animation-name: bounceOutLeft; }

@-webkit-keyframes bounceOutRight {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); } }

@keyframes bounceOutRight {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); } }

.bounceOutRight {
  -webkit-animation-name: bounceOutRight;
  animation-name: bounceOutRight; }

@-webkit-keyframes bounceOutUp {
  20% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0); }
  40%, 45% {
    opacity: 1;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); } }

@keyframes bounceOutUp {
  20% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0); }
  40%, 45% {
    opacity: 1;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0); }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); } }

.bounceOutUp {
  -webkit-animation-name: bounceOutUp;
  animation-name: bounceOutUp; }

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes fadeIn {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn; }

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown; }

@-webkit-keyframes fadeInDownBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInDownBig {
  -webkit-animation-name: fadeInDownBig;
  animation-name: fadeInDownBig; }

@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft; }

@-webkit-keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInLeftBig {
  -webkit-animation-name: fadeInLeftBig;
  animation-name: fadeInLeftBig; }

@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight; }

@-webkit-keyframes fadeInRightBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInRightBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInRightBig {
  -webkit-animation-name: fadeInRightBig;
  animation-name: fadeInRightBig; }

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp; }

@-webkit-keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.fadeInUpBig {
  -webkit-animation-name: fadeInUpBig;
  animation-name: fadeInUpBig; }

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1; }
  100% {
    opacity: 0; } }

@keyframes fadeOut {
  0% {
    opacity: 1; }
  100% {
    opacity: 0; } }

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut; }

@-webkit-keyframes fadeOutDown {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0); } }

@keyframes fadeOutDown {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0); } }

.fadeOutDown {
  -webkit-animation-name: fadeOutDown;
  animation-name: fadeOutDown; }

@-webkit-keyframes fadeOutDownBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); } }

@keyframes fadeOutDownBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0); } }

.fadeOutDownBig {
  -webkit-animation-name: fadeOutDownBig;
  animation-name: fadeOutDownBig; }

@-webkit-keyframes fadeOutLeft {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0); } }

@keyframes fadeOutLeft {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0); } }

.fadeOutLeft {
  -webkit-animation-name: fadeOutLeft;
  animation-name: fadeOutLeft; }

@-webkit-keyframes fadeOutLeftBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); } }

@keyframes fadeOutLeftBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0); } }

.fadeOutLeftBig {
  -webkit-animation-name: fadeOutLeftBig;
  animation-name: fadeOutLeftBig; }

@-webkit-keyframes fadeOutRight {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0); } }

@keyframes fadeOutRight {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0); } }

.fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight; }

@-webkit-keyframes fadeOutRightBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); } }

@keyframes fadeOutRightBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0); } }

.fadeOutRightBig {
  -webkit-animation-name: fadeOutRightBig;
  animation-name: fadeOutRightBig; }

@-webkit-keyframes fadeOutUp {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0); } }

@keyframes fadeOutUp {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0); } }

.fadeOutUp {
  -webkit-animation-name: fadeOutUp;
  animation-name: fadeOutUp; }

@-webkit-keyframes fadeOutUpBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); } }

@keyframes fadeOutUpBig {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0); } }

.fadeOutUpBig {
  -webkit-animation-name: fadeOutUpBig;
  animation-name: fadeOutUpBig; }

@-webkit-keyframes flip {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out; }
  40% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out; }
  50% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; }
  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; } }

@keyframes flip {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out; }
  40% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out; }
  50% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; }
  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in; } }

.animated.flip, .flip#helpDropdownButton.add-notice {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  -webkit-animation-name: flip;
  animation-name: flip; }

@-webkit-keyframes flipInX {
  0% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
    opacity: 0; }
  40% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in; }
  60% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1; }
  80% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); } }

@keyframes flipInX {
  0% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
    opacity: 0; }
  40% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in; }
  60% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1; }
  80% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); } }

.flipInX {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipInX;
  animation-name: flipInX; }

@-webkit-keyframes flipInY {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
    opacity: 0; }
  40% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in; }
  60% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1; }
  80% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg); }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); } }

@keyframes flipInY {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
    opacity: 0; }
  40% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    -webkit-transition-timing-function: ease-in;
    transition-timing-function: ease-in; }
  60% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1; }
  80% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg); }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); } }

.flipInY {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipInY;
  animation-name: flipInY; }

@-webkit-keyframes flipOutX {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); }
  30% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1; }
  100% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0; } }

@keyframes flipOutX {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); }
  30% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1; }
  100% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0; } }

.flipOutX {
  -webkit-animation-name: flipOutX;
  animation-name: flipOutX;
  -webkit-animation-duration: .75s;
  animation-duration: .75s;
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important; }

@-webkit-keyframes flipOutY {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); }
  30% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1; }
  100% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0; } }

@keyframes flipOutY {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px); }
  30% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1; }
  100% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0; } }

.flipOutY {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipOutY;
  animation-name: flipOutY;
  -webkit-animation-duration: .75s;
  animation-duration: .75s; }

@-webkit-keyframes lightSpeedIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0; }
  60% {
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    opacity: 1; }
  80% {
    -webkit-transform: skewX(-5deg);
    transform: skewX(-5deg);
    opacity: 1; }
  100% {
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes lightSpeedIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0; }
  60% {
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    opacity: 1; }
  80% {
    -webkit-transform: skewX(-5deg);
    transform: skewX(-5deg);
    opacity: 1; }
  100% {
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.lightSpeedIn {
  -webkit-animation-name: lightSpeedIn;
  animation-name: lightSpeedIn;
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out; }

@-webkit-keyframes lightSpeedOut {
  0% {
    opacity: 1; }
  100% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0; } }

@keyframes lightSpeedOut {
  0% {
    opacity: 1; }
  100% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0; } }

.lightSpeedOut {
  -webkit-animation-name: lightSpeedOut;
  animation-name: lightSpeedOut;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in; }

@-webkit-keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.rotateIn {
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn; }

@-webkit-keyframes rotateInDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes rotateInDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.rotateInDownLeft {
  -webkit-animation-name: rotateInDownLeft;
  animation-name: rotateInDownLeft; }

@-webkit-keyframes rotateInDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes rotateInDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.rotateInDownRight {
  -webkit-animation-name: rotateInDownRight;
  animation-name: rotateInDownRight; }

@-webkit-keyframes rotateInUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes rotateInUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.rotateInUpLeft {
  -webkit-animation-name: rotateInUpLeft;
  animation-name: rotateInUpLeft; }

@-webkit-keyframes rotateInUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, -90deg);
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

@keyframes rotateInUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, -90deg);
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: none;
    transform: none;
    opacity: 1; } }

.rotateInUpRight {
  -webkit-animation-name: rotateInUpRight;
  animation-name: rotateInUpRight; }

@-webkit-keyframes rotateOut {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    opacity: 1; }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, 200deg);
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0; } }

@keyframes rotateOut {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    opacity: 1; }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, 200deg);
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0; } }

.rotateOut {
  -webkit-animation-name: rotateOut;
  animation-name: rotateOut; }

@-webkit-keyframes rotateOutDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; } }

@keyframes rotateOutDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0; } }

.rotateOutDownLeft {
  -webkit-animation-name: rotateOutDownLeft;
  animation-name: rotateOutDownLeft; }

@-webkit-keyframes rotateOutDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; } }

@keyframes rotateOutDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; } }

.rotateOutDownRight {
  -webkit-animation-name: rotateOutDownRight;
  animation-name: rotateOutDownRight; }

@-webkit-keyframes rotateOutUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; } }

@keyframes rotateOutUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate3d(0, 0, 1, -45deg);
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0; } }

.rotateOutUpLeft {
  -webkit-animation-name: rotateOutUpLeft;
  animation-name: rotateOutUpLeft; }

@-webkit-keyframes rotateOutUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, 90deg);
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0; } }

@keyframes rotateOutUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1; }
  100% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate3d(0, 0, 1, 90deg);
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0; } }

.rotateOutUpRight {
  -webkit-animation-name: rotateOutUpRight;
  animation-name: rotateOutUpRight; }

@-webkit-keyframes hinge {
  0% {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out; }
  20%, 60% {
    -webkit-transform: rotate3d(0, 0, 1, 80deg);
    transform: rotate3d(0, 0, 1, 80deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out; }
  40%, 80% {
    -webkit-transform: rotate3d(0, 0, 1, 60deg);
    transform: rotate3d(0, 0, 1, 60deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    opacity: 1; }
  100% {
    -webkit-transform: translate3d(0, 700px, 0);
    transform: translate3d(0, 700px, 0);
    opacity: 0; } }

@keyframes hinge {
  0% {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out; }
  20%, 60% {
    -webkit-transform: rotate3d(0, 0, 1, 80deg);
    transform: rotate3d(0, 0, 1, 80deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out; }
  40%, 80% {
    -webkit-transform: rotate3d(0, 0, 1, 60deg);
    transform: rotate3d(0, 0, 1, 60deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    opacity: 1; }
  100% {
    -webkit-transform: translate3d(0, 700px, 0);
    transform: translate3d(0, 700px, 0);
    opacity: 0; } }

.hinge {
  -webkit-animation-name: hinge;
  animation-name: hinge; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@-webkit-keyframes rollIn {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

@keyframes rollIn {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg); }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none; } }

.rollIn {
  -webkit-animation-name: rollIn;
  animation-name: rollIn; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@-webkit-keyframes rollOut {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg); } }

@keyframes rollOut {
  0% {
    opacity: 1; }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg); } }

.rollOut {
  -webkit-animation-name: rollOut;
  animation-name: rollOut; }

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  50% {
    opacity: 1; } }

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  50% {
    opacity: 1; } }

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn; }

@-webkit-keyframes zoomInDown {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomInDown {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomInDown {
  -webkit-animation-name: zoomInDown;
  animation-name: zoomInDown; }

@-webkit-keyframes zoomInLeft {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomInLeft {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomInLeft {
  -webkit-animation-name: zoomInLeft;
  animation-name: zoomInLeft; }

@-webkit-keyframes zoomInRight {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomInRight {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomInRight {
  -webkit-animation-name: zoomInRight;
  animation-name: zoomInRight; }

@-webkit-keyframes zoomInUp {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomInUp {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomInUp {
  -webkit-animation-name: zoomInUp;
  animation-name: zoomInUp; }

@-webkit-keyframes zoomOut {
  0% {
    opacity: 1; }
  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  100% {
    opacity: 0; } }

@keyframes zoomOut {
  0% {
    opacity: 1; }
  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3); }
  100% {
    opacity: 0; } }

.zoomOut {
  -webkit-animation-name: zoomOut;
  animation-name: zoomOut; }

@-webkit-keyframes zoomOutDown {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomOutDown {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomOutDown {
  -webkit-animation-name: zoomOutDown;
  animation-name: zoomOutDown; }

@-webkit-keyframes zoomOutLeft {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    -webkit-transform-origin: left center;
    transform-origin: left center; } }

@keyframes zoomOutLeft {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    -webkit-transform-origin: left center;
    transform-origin: left center; } }

.zoomOutLeft {
  -webkit-animation-name: zoomOutLeft;
  animation-name: zoomOutLeft; }

@-webkit-keyframes zoomOutRight {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);
    transform: scale(0.1) translate3d(2000px, 0, 0);
    -webkit-transform-origin: right center;
    transform-origin: right center; } }

@keyframes zoomOutRight {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0); }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);
    transform: scale(0.1) translate3d(2000px, 0, 0);
    -webkit-transform-origin: right center;
    transform-origin: right center; } }

.zoomOutRight {
  -webkit-animation-name: zoomOutRight;
  animation-name: zoomOutRight; }

@-webkit-keyframes zoomOutUp {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

@keyframes zoomOutUp {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }

.zoomOutUp {
  -webkit-animation-name: zoomOutUp;
  animation-name: zoomOutUp; }

@-webkit-keyframes slideInDown {
  0% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0); } }

@keyframes slideInDown {
  0% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0); } }

.slideInDown {
  -webkit-animation-name: slideInDown;
  animation-name: slideInDown; }

@-webkit-keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0); } }

@keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0); } }

.slideInLeft {
  -webkit-animation-name: slideInLeft;
  animation-name: slideInLeft; }

@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0); } }

@keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0); } }

.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight; }

@-webkit-keyframes slideInUp {
  0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0); } }

@keyframes slideInUp {
  0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible; }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0); } }

.slideInUp {
  -webkit-animation-name: slideInUp;
  animation-name: slideInUp; }

@-webkit-keyframes slideOutDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateY(100%);
    transform: translateY(100%); } }

@keyframes slideOutDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateY(100%);
    transform: translateY(100%); } }

.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown; }

@-webkit-keyframes slideOutLeft {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%); } }

@keyframes slideOutLeft {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%); } }

.slideOutLeft {
  -webkit-animation-name: slideOutLeft;
  animation-name: slideOutLeft; }

@-webkit-keyframes slideOutRight {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateX(100%);
    transform: translateX(100%); } }

@keyframes slideOutRight {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateX(100%);
    transform: translateX(100%); } }

.slideOutRight {
  -webkit-animation-name: slideOutRight;
  animation-name: slideOutRight; }

@-webkit-keyframes slideOutUp {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%); } }

@keyframes slideOutUp {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0); }
  100% {
    visibility: hidden;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%); } }

.slideOutUp {
  -webkit-animation-name: slideOutUp;
  animation-name: slideOutUp; }

/* Display Layouts
   ========================================================================== */
.l_display-screenshot .panel, .l_display-screenshot .content-box, .l_display-screenshot .select-subcompany-modal .list-group, .select-subcompany-modal .l_display-screenshot .list-group, .l_display-screenshot .content-box-editable, .l_display-screenshot .card, .l_display-screenshot #appLauncherContainer .scrollable-list, #appLauncherContainer .l_display-screenshot .scrollable-list, .l_display-screenshot #appLauncherContainer .template-grid, #appLauncherContainer .l_display-screenshot .template-grid {
  min-height: 300px; }

/* UI-Components
   ========================================================================== */
.modal-custom > div {
  width: auto;
  display: table; }
  .modal-custom > div .modal-content p {
    display: inline-block;
    white-space: nowrap; }
  @media (max-width: 480px) {
    .modal-custom > div {
      display: block; }
      .modal-custom > div .modal-content p {
        white-space: normal; } }

.modal-dialog .sign-in,
.modal-dialog .sign-in:hover {
  float: left; }
  .modal-dialog .sign-in .fa::before, .modal-dialog .sign-in .glyphicons::before,
  .modal-dialog .sign-in:hover .fa::before,
  .modal-dialog .sign-in:hover .glyphicons::before {
    line-height: 30px; }

iframe.modal-dialog {
  border: none;
  margin: 0;
  width: 100%;
  height: calc(100vh - 140px);
  overflow: hidden; }

.modal-full {
  max-width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  overflow: hidden; }
  .modal-full .modal-dialog {
    max-width: 100%;
    height: 100vh;
    overflow: hidden;
    margin: 0; }

.storage-modal {
  padding: 15px; }

.product-preview-modal .modal-dialog {
  width: 70%;
  margin-top: 42px; }

/* ==========================================================================
   Alignment
   ========================================================================== */
/* Style the component */
.alignment .dropdown-menu {
  /* Display & Box Model */
  min-width: 145px;
  padding: 5px; }

.btn-alignment {
  /* Display & Box Model */
  min-width: 50px; }

/* ==========================================================================
   Font Picker
   ========================================================================== */
.font-picker .modal {
  margin-top: 40px; }

.font-picker-text {
  /* Display & Box Model */
  padding: 15px;
  /* Visual */
  text-align: left;
  background-color: #efefef;
  border-radius: 8px; }

.font-select-btn {
  width: 149px;
  height: 30px;
  position: relative; }
  .font-select-btn .bfh-selectbox-option {
    position: absolute;
    top: 4.5px;
    left: 3.5px; }
  .font-select-btn .selectbox-caret {
    float: right; }

/* ==========================================================================
   Font Style
   ========================================================================== */
a[data-wysihtml5-command=bold],
a[data-wysihtml5-command=italic],
a[data-wysihtml5-command=underline],
a[data-wysihtml5-command=bold]:hover,
a[data-wysihtml5-command=italic]:hover,
a[data-wysihtml5-command=underline]:hover {
  /* Display & Box Model */
  min-width: 50px;
  /* Visual */
  background-color: #fff;
  border-color: #ccc; }

a[data-wysihtml5-command=bold].active,
a[data-wysihtml5-command=italic].active,
a[data-wysihtml5-command=underline].active {
  /* Visual */
  -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: #d9d9d9;
  outline: 0; }

/* Font style classes */
.bold, a[data-wysihtml5-command=bold].btn {
  font-weight: bold; }

.italic, a[data-wysihtml5-command=italic].btn {
  font-style: italic; }

.underline, a[data-wysihtml5-command=underline].btn {
  text-decoration: underline; }

.navbar .navbar-nav > li > a.btn, .navbar .navbar-nav > li > a.company-buttons-icon-mobile {
  margin-top: 8px;
  margin-bottom: 0; }

.navbar .navbar-nav > li > a.btn-link:hover, .navbar .navbar-nav > li > a.btn-link:focus, .navbar .navbar-nav > li > a.btn-link:active, .navbar .navbar-nav > li > button.btn-link:hover, .navbar .navbar-nav > li > button.btn-link:focus, .navbar .navbar-nav > li > button.btn-link:active {
  color: gray; }

.navbar .navbar-brand .fa {
  padding: 8px; }

.navbar-default li.user-profile-dropdown {
  padding: 0;
  text-align: right; }
  .navbar-default li.user-profile-dropdown > a {
    padding: 8px;
    margin-top: 0; }
  .navbar-default li.user-profile-dropdown .user-id span {
    display: block;
    font-size: 13px;
    line-height: 18px; }
  .navbar-default li.user-profile-dropdown .user-id .username {
    line-height: 16px; }
  .navbar-default li.user-profile-dropdown .profile-pic {
    margin-left: 8px;
    margin-top: 4px;
    border-radius: 4px; }
    .navbar-default li.user-profile-dropdown .profile-pic img {
      height: 100%; }

.app-navigation ul > li > a {
  display: block; }
  .app-navigation ul > li > a .image {
    height: 16px;
    margin-right: 8px;
    float: left; }
    .app-navigation ul > li > a .image img {
      height: 100%; }

/* Small Devices, Tablets */
@media (max-width: 767px) {
  li.user-profile-dropdown > a {
    padding: 2px;
    margin-top: 8px; }
  li.user-profile-dropdown .user-id span {
    max-width: 100px; } }

/* Signup Modal
   ========================================================================== */
.signup-modal h1 {
  font-size: 44px;
  font-weight: 300;
  margin-top: 48px; }
  .signup-modal h1.text-muted {
    margin-top: 5px;
    font-size: 16px; }

.signup-offer {
  margin-top: 48px; }
  .signup-offer .widgets-offer li {
    background: #f2f2f2;
    display: inline-block;
    width: 85px;
    height: 85px;
    vertical-align: top;
    padding: 5px;
    border-radius: 4px; }
    .signup-offer .widgets-offer li img {
      width: 36px; }
    .signup-offer .widgets-offer li span {
      font-size: 12px;
      font-weight: 500;
      color: #666;
      display: block;
      line-height: 14px;
      margin-top: 5px; }

.registration-modal label {
  font-weight: 500;
  font-size: 15px; }
  .registration-modal label span {
    color: #666;
    font-weight: 400;
    font-size: 14px;
    margin-left: 5px; }

.registration-modal .checkbox label {
  font-size: 14px;
  color: #666;
  font-weight: 400; }

.signup-counters {
  text-align: center;
  margin-top: 24px;
  background: #f7f7f7;
  border-radius: 10px;
  padding: 10px; }
  .signup-counters .counter {
    margin-bottom: 16px; }
    .signup-counters .counter p {
      margin: 0;
      font-weight: 300;
      font-size: 28px;
      color: #4ab767; }
    .signup-counters .counter span {
      font-size: 12px;
      display: block;
      color: #999;
      font-weight: 500; }

/* Company Selector
   ========================================================================== */
.company-search {
  padding-top: 20px; }

/* Move Company
   ========================================================================== */
.move-company label {
  font-weight: normal; }

.move-company a {
  line-height: 34px; }

.move-company h3 {
  font-size: 16px; }

.move-company .to-company {
  margin-bottom: 20px; }

/* Company Settings
   ========================================================================== */
.company-settings .action-link {
  margin-left: 20px; }

.double-margin {
  margin-bottom: 40px !important; }

.sub-company-alert.test-company-alert {
  background-color: #c0392b; }

.sub-company-alert.test-company-alert + .sub-company-alert {
  margin-top: 0; }

.sub-company-alert {
  width: 100%;
  line-height: 20px;
  bottom: -24px;
  background-color: #e48f86;
  color: #000;
  padding: 0 20px;
  border-bottom: 1px solid #db695d;
  text-align: center;
  display: inline-block; }

.sub-company-alert .link-button {
  display: inline-block;
  font-weight: bold; }

.authorization-modal {
  text-align: center; }
  .authorization-modal .profile-img {
    width: 72px;
    height: 72px;
    -webkit-border-radius: 72px;
    -moz-border-radius: 72px;
    border-radius: 72px; }
  .authorization-modal p, .authorization-modal .btn, .authorization-modal .icon-nav label, .icon-nav .authorization-modal label {
    margin-top: 40px; }

.user-profile-dropdown .dropdown-toggle .user-id span {
  display: block;
  line-height: 16px;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }
  .user-profile-dropdown .dropdown-toggle .user-id span.pending-registration {
    line-height: 32px;
    display: none; }
  @media (max-width: 768px) {
    .user-profile-dropdown .dropdown-toggle .user-id span {
      width: 120px; } }

.user-profile-dropdown .dropdown-toggle .user-id strong {
  font-size: 12px;
  color: #999; }

.user-profile-dropdown .google-account {
  margin: 15px;
  line-height: 32px; }

.dropdown-header {
  color: #555;
  padding: 10px; }
  .dropdown-header.sub-company-header {
    background: #f8e4e2; }
  .dropdown-header p {
    line-height: 18px;
    margin: 0;
    font-size: 13px;
    overflow: hidden; }
    @media (max-width: 480px) {
      .dropdown-header p strong {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        max-width: 260px; }
      .dropdown-header p a {
        display: block;
        margin-top: 5px; }
      .dropdown-header p .text-muted {
        display: none; } }

.actions-nav > li > a .label {
  position: absolute;
  left: 60%;
  top: -2px;
  z-index: 1;
  padding: 4px 7px;
  font-size: 50%;
  vertical-align: middle; }

.actions-nav > li.shopping-cart > a .label {
  left: 75%; }

.actions-nav .dropdown .company-menu {
  right: -62px; }

.actions-nav .dropdown .company-menu::before {
  right: 80px; }

.actions-nav .dropdown .company-menu::after {
  right: 81px; }

.background-group .content-box, .background-group .select-subcompany-modal .list-group, .select-subcompany-modal .background-group .list-group, .background-group .content-box-editable, .background-group .card, .background-group #appLauncherContainer .scrollable-list, #appLauncherContainer .background-group .scrollable-list, .background-group #appLauncherContainer .template-grid, #appLauncherContainer .background-group .template-grid {
  height: 34px;
  overflow: hidden;
  width: 123px;
  float: right; }

.background-group .control-label, .settings-group .control-label {
  line-height: 34px;
  margin: 0;
  display: block; }

.background-group span {
  height: 33px;
  display: block;
  border-radius: 4px; }

.color-wheel, .color-wheel:hover {
  background: url("//s3.amazonaws.com/Rise-Images/UI/color_wheel.png") no-repeat center;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 0 4px 4px 0 !important;
  border-left: none; }

.image-placeholder {
  width: 123px;
  height: 123px;
  background: url("//s3.amazonaws.com/Rise-Images/UI/transp_bg.png") repeat;
  margin-right: 10px;
  border-radius: 4px;
  text-align: center;
  padding-top: 45px;
  font-size: 32px;
  border: 1px solid #CCC;
  line-height: 0px; }

.financial-selector .hero {
  text-align: center;
  padding-top: 20px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  height: 400px; }
  .financial-selector .hero h1 {
    color: #FFF;
    font-size: 24px;
    margin-bottom: 0;
    font-weight: 600; }
  .financial-selector .hero h3 {
    font-weight: 400;
    color: #CCC;
    font-size: 18px; }

.financial-selector.financial-selector--login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 80px;
  overflow: hidden;
  background-color: #666;
  background-image: url("https://s3.amazonaws.com/Rise-Images/financial-selector/stock.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-position: bottom;
  -webkit-transition: all 0.2s;
  transition: all 0.2s; }
  .financial-selector.financial-selector--login.is-email-login {
    background-color: #bcbcbc; }

.financial-selector__container {
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
  position: relative; }
  .financial-selector__container .panel-email-login {
    height: 400px; }
    .financial-selector__container .panel-email-login legend {
      padding: 10px; }
  .financial-selector__container.email-login-animation {
    -webkit-transform: translate(0, -400px); }
    .financial-selector__container.email-login-animation .hero {
      opacity: 0; }

@media (min-width: 1200px) {
  .financial-selector .hero h1 {
    font-size: 48px; }
  .financial-selector .hero h3 {
    font-size: 24px; } }

.drag-handle {
  background-image: url("https://s3.amazonaws.com/Rise-Images/UI/dot-pattern.png");
  width: 12px;
  height: 36px;
  float: left;
  margin-right: 10px; }

.bottom-save-block {
  background-color: #F7F7F9;
  border-top: 1px solid #d4d4d4;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 16px 0;
  z-index: 9999;
  box-shadow: 0px -4px 10px 0 rgba(22, 22, 22, 0.08); }

.is-hidden, .financial-selector__container .panel-email-login {
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
  opacity: 0; }

.is-visible, .financial-selector__container.email-login-animation .panel-email-login {
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
  opacity: 1; }

/* OLD STYLE */
.tag-manager .label {
  display: inline-block;
  margin: 5px;
  padding: 8px 9px; }

.tag-manager .tags {
  margin: 10px 0; }

.collapse-panel.panel-heading a.panel-heading:after {
  font-family: 'Glyphicons Halflings';
  content: "\\e114";
  float: left;
  color: grey; }

.collapse-panel.panel-heading a.panel-heading.collapsed:after {
  content: "\\e080"; }

.collapse-panel .remove-column-button {
  float: right;
  padding-top: 3.5px; }

.bfh-fontsizes {
  height: 30px; }

.font-setting .mce-edit-area {
  display: none; }

.font-setting .text-container {
  margin-top: 10px;
  padding: 15px;
  text-align: left;
  background-color: #efefef;
  border-radius: 8px; }

.refresh-spin {
  -webkit-animation: spin 2s infinite linear;
  -moz-animation: spin 2s infinite linear;
  -o-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear; }

@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg); }
  100% {
    -moz-transform: rotate(359deg); } }

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(359deg); } }

@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg); }
  100% {
    -o-transform: rotate(359deg); } }

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg); } }

.spinner-backdrop {
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75); }

.select2-container {
  width: 100%; }

.select2-container .select2-choice abbr {
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") right top no-repeat; }

.select2-container .select2-choice .select2-arrow b {
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 0 1px; }

.select2-search input {
  background: #fff url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 100% -22px;
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") no-repeat 100% -22px, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0; }

.select2-search-choice-close {
  background: url("http://s3.amazonaws.com/Rise-Images/UI/select2.png") right top no-repeat; }

/* Retina-ize icons */
@media only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (min-resolution: 2dppx) {
  .select2-search input,
  .select2-search-choice-close,
  .select2-container .select2-choice abbr,
  .select2-container .select2-choice .select2-arrow b {
    background-image: url("http://s3.amazonaws.com/Rise-Images/UI/select2x2.png") !important; } }

.off-canvas--nav {
  width: 350px;
  background-color: #fff;
  color: #000;
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 100%;
  -webkit-user-drag: none;
  z-index: 1051;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-transform: translate3d(-300px, 0, 0);
  -moz-transform: translate3d(-300px, 0, 0);
  -ms-transform: translate3d(-300px, 0, 0);
  -o-transform: translate3d(-300px, 0, 0);
  transform: translate3d(-300px, 0, 0);
  -webkit-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -moz-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -ms-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -o-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98); }
  .off-canvas--nav .off-canvas--nav-close {
    font-size: 24px;
    line-height: 40px; }
  .off-canvas--nav .nav-stacked > li + li {
    margin-top: 0px; }
  .off-canvas--nav .nav-stacked > li:first-child {
    padding: 10px 15px;
    border-bottom: 1px solid #e5e5e5; }
  .off-canvas--nav .nav-stacked > li a {
    border-radius: 0px;
    font-size: 16px;
    line-height: 40px; }
  .off-canvas--nav .nav-stacked > li i {
    line-height: 40px; }

.off-canvas--nav.is-off-canvas-opened {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2); }

.action-sheet {
  width: 100%;
  height: auto;
  max-height: 75%;
  background-color: #FFF;
  position: absolute;
  left: 0px;
  bottom: 0px;
  z-index: 1051;
  padding: 0;
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  -webkit-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -moz-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -ms-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  -o-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);
  transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98); }
  .action-sheet.is-action-sheet-opened {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); }
  .action-sheet ul {
    padding: 0;
    margin: 0; }
  .action-sheet.is-action-sheet-closed {
    display: none; }
  .action-sheet .menu-box {
    width: 50%; }
  .action-sheet li {
    list-style: none;
    display: list-item;
    margin: 0; }
    .action-sheet li > a {
      padding: 8px; }
    .action-sheet li.system-message {
      padding-bottom: 10px !important; }
    .action-sheet li:active {
      background-color: #d5d5d5; }
    .action-sheet li a.action {
      display: block;
      height: 40px !important;
      line-height: 40px !important;
      color: #020621 !important; }

li.dropdown-footer {
  padding: 8px 8px 0; }

li.dropdown-header {
  padding: 8px; }

#action-sheet-backdrop.modal-backdrop {
  display: none;
  background-color: #000;
  opacity: 0.5; }
  #action-sheet-backdrop.modal-backdrop.is-action-sheet-opened {
    display: block; }

.inverted-well {
  background-color: #fff;
  padding: 0 10px;
  border: 1px solid #e5e5e5; }

.system-message-list {
  overflow-y: scroll;
  min-width: 425px; }
  .system-message-list .system-message {
    padding: 22px; }

.distribution {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 100%;
  background-color: #fff; }
  .distribution .no-display {
    margin-left: 20px;
    font-style: italic; }
  .distribution .btn-new,
  .distribution .btn-new:hover,
  .distribution .btn-new:active {
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: #dddddd;
    background-repeat: repeat-x;
    background-image: -moz-linear-gradient(top, #fff 0%, #dddddd 100%);
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fff), color-stop(100%, #dddddd));
    background-image: -webkit-linear-gradient(top, #fff 0%, #dddddd 100%);
    background-image: -ms-linear-gradient(top, #fff 0%, #dddddd 100%);
    background-image: -o-linear-gradient(top, #fff 0%, #dddddd 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fff', endColorstr='#dddddd',GradientType=0 );
    background-image: linear-gradient(top, #fff 0%, #dddddd 100%); }
  .distribution .btn-link {
    color: #333; }
    .distribution .btn-link:hover, .distribution .btn-link:active {
      text-decoration: none !important;
      color: #333; }
  .distribution .company {
    margin-top: 20px; }
    .distribution .company:first-of-type {
      margin-top: 40px; }
    .distribution .company:not(:last-of-type) {
      border-bottom: 1px solid #ccc; }
  .distribution .list-unstyled, .distribution .list-inline {
    padding: 0 20px; }
    .distribution .list-unstyled span, .distribution .list-inline span {
      margin-left: 20px;
      line-height: 30px;
      color: #aaa;
      font-style: italic; }

/**
 * Slide Left-Right, and Right-Left, each with the reserve
 * --------------------------------------------------
 * NEW content slides IN from the RIGHT, OLD slides OUT to the LEFT
 * Reverse: NEW content slides IN from the LEFT, OLD slides OUT to the RIGHT
 */
.distribution-modal-container .modal-content {
  overflow-x: hidden; }

.slide-left-right {
  min-width: 100%;
  min-height: 383px; }

.slide-left-right > .ng-enter, .slide-left-right.ng-enter,
.slide-left-right > .ng-leave, .slide-left-right.ng-leave,
.slide-right-left.reverse > .ng-enter,
.slide-right-left.reverse.ng-enter,
.slide-right-left.reverse > .ng-leave,
.slide-right-left.reverse.ng-leave {
  -webkit-transition: all ease-in-out 250ms;
  -o-transition: all ease-in-out 250ms;
  transition: all ease-in-out 250ms;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; }

.slide-left-right > .ng-enter, .slide-left-right.ng-enter,
.slide-right-left.reverse > .ng-enter,
.slide-right-left.reverse.ng-enter {
  /* NEW content placed far RIGHT BEFORE it slides IN from the RIGHT */
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0); }

.slide-left-right > .ng-enter.ng-enter-active, .slide-left-right.ng-enter.ng-enter-active,
.slide-right-left.reverse > .ng-enter.ng-enter-active,
.slide-right-left.reverse.ng-enter.ng-enter-active {
  /* NEW content ACTIVELY sliding IN from the RIGHT */
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0); }

.slide-left-right > .ng-leave.ng-leave-active, .slide-left-right.ng-leave.ng-leave-active,
.slide-right-left.reverse > .ng-leave.ng-leave-active,
.slide-right-left.reverse.ng-leave.ng-leave-active {
  /* OLD content ACTIVELY sliding OUT to the LEFT */
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0); }

.slide-left-right.reverse > .ng-enter, .slide-left-right.reverse.ng-enter, .slide-left-right.reverse > .ng-leave, .slide-left-right.reverse.ng-leave,
.slide-right-left > .ng-enter,
.slide-right-left.ng-enter,
.slide-right-left > .ng-leave,
.slide-right-left.ng-leave {
  -webkit-transition: all ease-in-out 250ms;
  -o-transition: all ease-in-out 250ms;
  transition: all ease-in-out 250ms;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; }

.slide-left-right.reverse > .ng-enter, .slide-left-right.reverse.ng-enter,
.slide-right-left > .ng-enter,
.slide-right-left.ng-enter {
  /* NEW content placed far LEFT BEFORE it slides IN from the LEFT */
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0); }

.slide-left-right.reverse > .ng-enter.ng-enter-active, .slide-left-right.reverse.ng-enter.ng-enter-active,
.slide-right-left > .ng-enter.ng-enter-active,
.slide-right-left.ng-enter.ng-enter-active {
  /* NEW content ACTIVELY sliding IN from the LEFT */
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0); }

.slide-left-right.reverse > .ng-leave.ng-leave-active, .slide-left-right.reverse.ng-leave.ng-leave-active,
.slide-right-left > .ng-leave.ng-leave-active,
.slide-right-left.ng-leave.ng-leave-active {
  /* OLD content ACTIVELY sliding OUT to the RIGHT */
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0); }

.distribution-modal .list-group {
  margin-bottom: 40px; }

.distribution-modal .list-group-item {
  cursor: pointer; }

.distribution-modal .list-group-item-success {
  background-color: #4ab767;
  color: #fff;
  font-weight: bold;
  border-color: #3b9352;
  border-bottom: 0; }

.distribution-modal .list-group-company-selected {
  background-color: #ddd;
  border-color: #c4c4c4;
  font-weight: bold; }

.distribution-modal .list-group-company {
  background-color: #FCFCFC; }

.distribution-modal .list-group-item-secondary {
  background-color: #F6F6F6;
  border-top: 0;
  border-color: #c3c3c3; }

.distribution-modal .list-group-item-danger,
.distribution-modal .list-group-item-secondary,
.distribution-modal .list-group-item-success,
.distribution-modal .fa.fa-chevron-right {
  line-height: 40px; }

.distribution-modal .list-group-item-danger {
  background-color: #FFF8F5;
  border-color: #c3c3c3;
  border-bottom: 1px solid #c3c3c3;
  margin-bottom: 0;
  color: #c0392b; }
  .distribution-modal .list-group-item-danger .btn, .distribution-modal .list-group-item-danger .icon-nav label, .icon-nav .distribution-modal .list-group-item-danger label {
    border-radius: 2px;
    height: 40px; }
  .distribution-modal .list-group-item-danger .confirm-btn-group {
    float: right; }
  @media (max-width: 483px) {
    .distribution-modal .list-group-item-danger {
      line-height: 24px;
      height: 110px; } }
  @media (min-width: 484px) and (max-width: 580px) {
    .distribution-modal .list-group-item-danger {
      line-height: 30px;
      height: 100px; } }
  @media (max-width: 580px) {
    .distribution-modal .list-group-item-danger .confirm-btn-group {
      display: block;
      float: left;
      width: 100%;
      text-align: center; }
    .distribution-modal .list-group-item-danger .btn, .distribution-modal .list-group-item-danger .icon-nav label, .icon-nav .distribution-modal .list-group-item-danger label {
      width: 100px; } }

.app-header {
  margin-left: -7.5px;
  margin-right: -7.5px;
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px; }
  .app-header:before, .app-header:after {
    content: " ";
    display: table; }
  .app-header:after {
    clear: both; }
  .app-header .title-block {
    position: relative;
    min-height: 1px;
    padding-left: 7.5px;
    padding-right: 7.5px; }
    @media (min-width: 768px) {
      .app-header .title-block {
        float: left;
        width: 50%; } }
    .app-header .title-block h1 {
      display: inline-block;
      font-weight: 400;
      line-height: 43px;
      margin: 0 5px 0 0; }
  .app-header .global-actions {
    position: relative;
    min-height: 1px;
    padding-left: 7.5px;
    padding-right: 7.5px;
    text-align: right; }
    @media (min-width: 768px) {
      .app-header .global-actions {
        float: left;
        width: 50%; } }
    .app-header .global-actions .btn, .app-header .global-actions .icon-nav label, .icon-nav .app-header .global-actions label {
      margin-bottom: 0; }
    @media (max-width: 768px) {
      .app-header .global-actions {
        margin-top: 10px; }
        .app-header .global-actions .btn, .app-header .global-actions .icon-nav label, .icon-nav .app-header .global-actions label {
          width: 100%;
          margin: 0 0 5px;
          padding: 8px 0; } }

.toolbar {
  overflow: hidden;
  text-align: right;
  margin-top: 10px; }

.icon-nav {
  color: #555;
  line-height: 32px; }
  .icon-nav .btn-link {
    padding: 0;
    border-radius: 3px;
    min-width: 32px;
    height: 32px;
    vertical-align: top;
    color: #4d4d4d; }
    .icon-nav .btn-link:hover {
      background: #e6e6e6; }
    .icon-nav .btn-link:focus {
      outline: 0; }
    .icon-nav .btn-link .fa {
      font-size: 20px;
      line-height: 32px; }
      .icon-nav .btn-link .fa:before {
        color: #4d4d4d; }
    .icon-nav .btn-link .fa + .fa {
      margin-left: -4px;
      margin-top: 6px;
      font-size: 12px;
      vertical-align: top; }

.custom-icon {
  display: inline-block;
  background-size: 100%;
  width: 16px;
  height: 16px;
  vertical-align: middle; }

.file-picker {
  color: #777777;
  cursor: pointer; }
  .file-picker:hover .file-picker-icon {
    background-color: #FFF; }
  .file-picker .file-picker-icon {
    width: 32px;
    height: 32px;
    background-color: #ddd;
    border-radius: 16px;
    line-height: 32px;
    text-align: center;
    margin-left: 5px; }
  .file-picker :disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: .65; }

.empty-state {
  height: 300px;
  text-align: center;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  border-radius: 2px;
  background-color: #fff;
  color: #aaa; }
  .empty-state i:before {
    color: #aaa; }

.file-empty-state {
  font-size: 16px;
  padding-bottom: 66px;
  text-align: center;
  color: #333; }
  .file-empty-state .product-graphic {
    width: 64px;
    height: 64px;
    margin-top: 33px;
    text-align: center; }
    @media screen and (max-width: 768px) {
      .file-empty-state .product-graphic {
        margin-top: 44px; } }
    .file-empty-state .product-graphic svg-icon {
      margin-left: 0; }
      .file-empty-state .product-graphic svg-icon svg {
        width: 32px;
        height: 32px; }
  .file-empty-state .btn .fa-2x, .file-empty-state .icon-nav label .fa-2x, .icon-nav .file-empty-state label .fa-2x {
    font-size: 22px; }
  .file-empty-state .fa::before {
    color: #969595; }
  .file-empty-state svg {
    width: 70px;
    height: 40px;
    position: relative;
    top: 19px; }
    .file-empty-state svg path {
      fill: #444; }

/* Modal scrollable list
   ========================================================================== */
.scrollable-list, .template-grid {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 240px);
  min-height: 240px; }

.scrollable-list::-webkit-scrollbar, .template-grid::-webkit-scrollbar {
  -webkit-appearance: none; }

.scrollable-list::-webkit-scrollbar:vertical, .template-grid::-webkit-scrollbar:vertical {
  width: 11px; }

.scrollable-list::-webkit-scrollbar:horizontal, .template-grid::-webkit-scrollbar:horizontal {
  height: 11px; }

.scrollable-list::-webkit-scrollbar-thumb, .template-grid::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #f2f2f2;
  /* should match background, can't be transparent */
  background-color: rgba(50, 50, 50, 0.5); }

.scrollable-list::-webkit-scrollbar-track, .template-grid::-webkit-scrollbar-track {
  background-color: #f2f2f2;
  border-radius: 2px; }

/* List-Group
   ========================================================================== */
.editor-playlist .editor-playlist-item {
  overflow: hidden;
  background: #FFF;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-bottom: 5px;
  padding: 8px; }
  .editor-playlist .editor-playlist-item:hover {
    border: 1px solid #bcbcbc; }
  .editor-playlist .editor-playlist-item p,
  .editor-playlist .editor-playlist-item h4 {
    margin: 0;
    line-height: 22px; }
  .editor-playlist .editor-playlist-item .playlist-item-name span {
    font-weight: 500;
    display: inline-block;
    vertical-align: top;
    max-width: 125px; }
  .editor-playlist .editor-playlist-item .playlist-item-status {
    color: red !important;
    font-weight: 400;
    cursor: pointer; }
    .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status .btn, .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status .icon-nav label, .icon-nav .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status label {
      font-size: 10px; }

.editor-playlist .arrows {
  float: left;
  width: 24px;
  margin: 6px; }
  .editor-playlist .arrows .btn, .editor-playlist .arrows .icon-nav label, .icon-nav .editor-playlist .arrows label {
    margin: 0; }
    .editor-playlist .arrows .btn:first-child, .editor-playlist .arrows .icon-nav label:first-child, .icon-nav .editor-playlist .arrows label:first-child {
      border-radius: 3px 3px 0 0; }
    .editor-playlist .arrows .btn:last-child, .editor-playlist .arrows .icon-nav label:last-child, .icon-nav .editor-playlist .arrows label:last-child {
      border-radius: 0 0 3px 3px; }

.editor-playlist .list-grip {
  float: left;
  width: 25px;
  margin-right: 3px;
  background-color: white;
  height: 56px;
  display: inline-block;
  cursor: move;
  cursor: -webkit-grabbing; }
  .editor-playlist .list-grip .btn, .editor-playlist .list-grip .icon-nav label, .icon-nav .editor-playlist .list-grip label {
    margin: 0; }
    .editor-playlist .list-grip .btn:first-child, .editor-playlist .list-grip .icon-nav label:first-child, .icon-nav .editor-playlist .list-grip label:first-child {
      border-radius: 3px 3px 0 0; }
    .editor-playlist .list-grip .btn:last-child, .editor-playlist .list-grip .icon-nav label:last-child, .icon-nav .editor-playlist .list-grip label:last-child {
      border-radius: 0 0 3px 3px; }

.editor-playlist .actions {
  float: right;
  margin-right: 4px;
  margin-top: 1px;
  width: 58px; }
  .editor-playlist .actions .btn-default, .editor-playlist .actions .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .editor-playlist .actions .btn, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label {
    display: inline-block;
    margin-bottom: 3px;
    margin-top: 3px;
    width: 27px; }
    .editor-playlist .actions .btn-default:nth-child(1):hover, .editor-playlist .actions .timeline .dropdown-menu li .btn:nth-child(1):hover, .timeline .dropdown-menu li .editor-playlist .actions .btn:nth-child(1):hover, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label:nth-child(1):hover, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label:nth-child(1):hover, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label:nth-child(1):hover, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label:nth-child(1):hover {
      margin-right: 4px !important; }
    .editor-playlist .actions .btn-default:first-child, .editor-playlist .actions .timeline .dropdown-menu li .btn:first-child, .timeline .dropdown-menu li .editor-playlist .actions .btn:first-child, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label:first-child, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label:first-child, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label:first-child, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label:first-child {
      display: block;
      width: 100%;
      margin-bottom: 1px; }

/* List-Group
   ========================================================================== */
.list-group {
  margin-bottom: 0; }

.list-group-item {
  background-color: none;
  border: none;
  border-bottom: 1px solid #f2f2f2; }

/* Box list
   ========================================================================== */
.box-list-container {
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  overflow: hidden; }

.box-list {
  color: #333;
  margin-top: 0;
  padding: 15px; }
  .box-list:not(:last-child) {
    border-bottom: 1px solid #e5e5e5; }
  .box-list:hover, .box-list:active {
    background-color: #fafafa; }
  .box-list .title {
    margin: 0;
    line-height: 1.5; }
  .box-list p {
    font-size: 85%;
    line-height: 1.1;
    margin: 5px 0 0 0; }
  .box-list .meta {
    color: #777777; }
  .box-list .box-list-body {
    padding-right: 40px; }
  .box-list .box-list-aside {
    float: right; }

/* Grid List
   ========================================================================== */
.grid-list h4 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
  font-size: 16px;
  margin-bottom: 0;
  width: 100%; }

.grid-list .grid-list-image {
  background: #e6e6e6;
  max-width: 100%;
  height: 180px;
  text-align: center;
  font-size: 0;
  overflow: hidden;
  position: relative; }
  .grid-list .grid-list-image > * {
    display: inline-block;
    border: solid 2px #fff; }
  .grid-list .grid-list-image img {
    width: 100%;
    height: 100%;
    box-sizing: border-box; }

.grid-list .content-box, .grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .grid-list .list-group, .grid-list .content-box-editable, .grid-list .card, .grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .grid-list .scrollable-list, .grid-list #appLauncherContainer .template-grid, #appLauncherContainer .grid-list .template-grid {
  margin: 8px;
  padding: 8px;
  border: 1px solid #e6e6e6;
  -webkit-box-shadow: inset 0 -1px 0 #d5d1cb, 0 1px 4px rgba(113, 108, 102, 0.1), transparent 0 0 0;
  box-shadow: inset 0 -1px 0 #d5d1cb, 0 1px 4px rgba(113, 108, 102, 0.1), transparent 0 0 0;
  cursor: pointer;
  -o-transition: border .2s ease-out;
  -ms-transition: border .2s ease-out;
  -moz-transition: border .2s ease-out;
  -webkit-transition: border .2s ease-out;
  transition: border .2s ease-out; }
  .grid-list .content-box .product-pricing, .grid-list .select-subcompany-modal .list-group .product-pricing, .select-subcompany-modal .grid-list .list-group .product-pricing, .grid-list .content-box-editable .product-pricing, .grid-list .card .product-pricing, .grid-list #appLauncherContainer .scrollable-list .product-pricing, #appLauncherContainer .grid-list .scrollable-list .product-pricing, .grid-list #appLauncherContainer .template-grid .product-pricing, #appLauncherContainer .grid-list .template-grid .product-pricing {
    position: absolute;
    bottom: 0; }
    .grid-list .content-box .product-pricing span, .grid-list .select-subcompany-modal .list-group .product-pricing span, .select-subcompany-modal .grid-list .list-group .product-pricing span, .grid-list .content-box-editable .product-pricing span, .grid-list .card .product-pricing span, .grid-list #appLauncherContainer .scrollable-list .product-pricing span, #appLauncherContainer .grid-list .scrollable-list .product-pricing span, .grid-list #appLauncherContainer .template-grid .product-pricing span, #appLauncherContainer .grid-list .template-grid .product-pricing span {
      color: #3C7BDA;
      font-weight: bold; }
  .grid-list .content-box .info, .grid-list .select-subcompany-modal .list-group .info, .select-subcompany-modal .grid-list .list-group .info, .grid-list .content-box-editable .info, .grid-list .card .info, .grid-list #appLauncherContainer .scrollable-list .info, #appLauncherContainer .grid-list .scrollable-list .info, .grid-list #appLauncherContainer .template-grid .info, #appLauncherContainer .grid-list .template-grid .info {
    position: absolute;
    float: left;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: rgba(122, 122, 182, 0.7) url("../../../../img/info-icon.png") center no-repeat;
    -o-transition: opacity .2s ease-in;
    -ms-transition: opacity .2s ease-in;
    -moz-transition: opacity .2s ease-in;
    -webkit-transition: opacity .2s ease-in;
    transition: opacity .2s ease-in; }
  .grid-list .content-box:hover, .grid-list .select-subcompany-modal .list-group:hover, .select-subcompany-modal .grid-list .list-group:hover, .grid-list .content-box-editable:hover, .grid-list .card:hover, .grid-list #appLauncherContainer .scrollable-list:hover, #appLauncherContainer .grid-list .scrollable-list:hover, .grid-list #appLauncherContainer .template-grid:hover, #appLauncherContainer .grid-list .template-grid:hover {
    border: 1px solid #8E8E8E;
    box-shadow: inset 0 -1px 0 #9A9895, 2px 3px 6px rgba(113, 108, 102, 0.3), transparent 0 0 0; }
    .grid-list .content-box:hover .info, .grid-list .select-subcompany-modal .list-group:hover .info, .select-subcompany-modal .grid-list .list-group:hover .info, .grid-list .content-box-editable:hover .info, .grid-list .card:hover .info, .grid-list #appLauncherContainer .scrollable-list:hover .info, #appLauncherContainer .grid-list .scrollable-list:hover .info, .grid-list #appLauncherContainer .template-grid:hover .info, #appLauncherContainer .grid-list .template-grid:hover .info {
      opacity: 1; }

@media only screen and (max-width: 992px) {
  .grid-list .grid-list-image {
    height: 284px; } }

@media (max-width: 768px) {
  .grid-list .grid-list-image {
    height: 300px; }
  .grid-list h4 {
    font-size: 14px; }
  .grid-list .content-box, .grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .grid-list .list-group, .grid-list .content-box-editable, .grid-list .card, .grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .grid-list .scrollable-list, .grid-list #appLauncherContainer .template-grid, #appLauncherContainer .grid-list .template-grid {
    padding: 5px;
    margin: 5px; } }

.store.grid-list {
  /* Small devices  */
  /* Medium devices  */ }
  .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {
    min-height: 323px;
    position: static; }
  @media (min-width: 768px) {
    .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {
      min-height: 408px; } }
  @media (min-width: 992px) {
    .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {
      min-height: 363px; } }

.store-front.grid-list {
  /* Small devices  */
  /* Medium devices  */ }
  @media (min-width: 768px) {
    .store-front.grid-list .content-box, .store-front.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store-front.grid-list .list-group, .store-front.grid-list .content-box-editable, .store-front.grid-list .card, .store-front.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store-front.grid-list .scrollable-list, .store-front.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store-front.grid-list .template-grid {
      min-height: 405px; } }
  @media (min-width: 992px) {
    .store-front.grid-list .content-box, .store-front.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store-front.grid-list .list-group, .store-front.grid-list .content-box-editable, .store-front.grid-list .card, .store-front.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store-front.grid-list .scrollable-list, .store-front.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store-front.grid-list .template-grid {
      min-height: 290px; } }

.store.grid-list-text {
  color: #333; }

/* Standard Table
   ========================================================================== */
.table, .table-2 {
  width: 100%;
  font-size: 14px; }
  .table .table-header .table-header__row > .table-header__cell > a, .table-2 .table-header .table-header__row > .table-header__cell > a {
    color: #020621;
    display: block; }
  .table .table-header .table-header__row > .table-header__cell > span, .table-2 .table-header .table-header__row > .table-header__cell > span {
    display: block; }
  .table .table-body .table-body__row > .table-body__cell, .table-2 .table-body .table-body__row > .table-body__cell {
    vertical-align: middle; }
    .table .table-body .table-body__row > .table-body__cell > a, .table-2 .table-body .table-body__row > .table-body__cell > a {
      display: block; }
    .table .table-body .table-body__row > .table-body__cell > span, .table-2 .table-body .table-body__row > .table-body__cell > span {
      display: inline-block;
      vertical-align: middle; }
  .table.table--sortable .table-body .table-body__row > .table-body__cell, .table--sortable.table-2 .table-body .table-body__row > .table-body__cell {
    cursor: move; }
  .table.table--sortable .table-body .table-body__row:hover > .table-body__cell, .table--sortable.table-2 .table-body .table-body__row:hover > .table-body__cell {
    background: #f5f5f5; }
  .table.table--selector .table-body .table-body__row > .table-body__cell, .table--selector.table-2 .table-body .table-body__row > .table-body__cell {
    cursor: pointer; }
    .table.table--selector .table-body .table-body__row > .table-body__cell:first-child i, .table--selector.table-2 .table-body .table-body__row > .table-body__cell:first-child i {
      margin: 0 4px; }
  .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell {
    background: #4ab767;
    color: #FFF; }
    .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell a, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell a, .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .text-muted, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .text-muted, .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .text-green, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .text-green {
      color: #FFF; }
    .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .fa:before, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .fa:before {
      color: #FFF; }

/* Table Selector Icon
   ========================================================================== */
.selector-icon, .table.table--selector .table-body .table-body__row > .table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row > .table-body__cell:first-child:before {
  font-family: FontAwesome;
  font-size: 16px;
  content: '\\f096';
  height: 16px;
  display: inline-block;
  margin-right: 4px;
  margin-left: 4px;
  vertical-align: top; }
  .selector-icon.selector-icon--selected, .table.table--selector .table-body .table-body__row > .selector-icon--selected.table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row > .selector-icon--selected.table-body__cell:first-child:before, .table.table--selector .table-body .table-body__row--is-selected.table-body__row > .table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row--is-selected.table-body__row > .table-body__cell:first-child:before, .table.table--selector .table-body .table-body__row--is-selected > .selector-icon.table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row--is-selected > .selector-icon.table-body__cell:first-child:before {
    content: '\\f14a'; }

/* Deprecate
   ==========================================================================
   ==========================================================================
   ==========================================================================
   ==========================================================================
   ========================================================================== */
.table-2 thead tr > th {
  padding: 8px; }

.table-2 tbody tr:hover {
  cursor: pointer; }
  .table-2 tbody tr:hover a {
    color: #0081BA; }

.table-2 tbody tr > td {
  padding: 12px 8px; }
  .table-2 tbody tr > td > a {
    color: #4d4d4d; }
    .table-2 tbody tr > td > a:hover {
      text-decoration: none; }

.table-selector > thead > tr th label {
  margin: 0; }

.table-selector > thead > tr th input[type=checkbox] {
  display: none; }

.table-selector > thead > tr th input[type=checkbox] + label:before {
  font-family: FontAwesome;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  color: #d4d4d4;
  font-size: 16px;
  width: 16px;
  text-align: center;
  content: '\\f096'; }

.table-selector > thead > tr th input[type=checkbox]:checked + label:before {
  content: '\\f14a'; }

.table-selector > tbody > tr td {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  vertical-align: middle; }
  .table-selector > tbody > tr td:first-child:before {
    font-family: FontAwesome;
    font-style: normal;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    color: #d4d4d4;
    font-size: 16px;
    width: 16px;
    height: 18px;
    text-align: center; }

.table-selector > tbody > tr.disabled-row {
  background: #f5f5f5; }
  .table-selector > tbody > tr.disabled-row td, .table-selector > tbody > tr.disabled-row td a {
    cursor: not-allowed;
    color: #999; }
  .table-selector > tbody > tr.disabled-row:hover a {
    color: #999; }

.table-selector > tbody > tr.back-btn td:first-child:before {
  content: '\\f060' !important; }

.table-selector > tbody > tr.no-select-row td:first-child:before {
  content: '' !important; }

.table-selector > tbody > tr.active {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn; }
  .table-selector > tbody > tr.active:hover td {
    background: #5cbe76;
    color: #FFF; }
  .table-selector > tbody > tr.active td {
    background: #5cbe76;
    color: #FFF; }
    .table-selector > tbody > tr.active td a {
      color: #FFF; }
    .table-selector > tbody > tr.active td .text-muted {
      color: #FFF; }
    .table-selector > tbody > tr.active td .folder:before {
      color: #FFF; }
    .table-selector > tbody > tr.active td:first-child:before {
      color: #FFF; }

.table-selector.single-selector > tbody > tr td:first-child:before {
  content: '\\f096'; }

.table-selector.single-selector > tbody > tr.active td:first-child:before {
  content: '\\f192'; }

.table-selector.multiple-selector > tbody > tr td:first-child:before {
  content: '\\f096'; }

.table-selector.multiple-selector > tbody > tr.active td:first-child:before {
  content: '\\f14a'; }

.table-selector.multiple-selector > tbody > tr.info-row {
  background-color: #eee; }
  .table-selector.multiple-selector > tbody > tr.info-row td:first-child:before {
    content: initial; }

.table-2 > tbody > tr > td:first-child input {
  display: inline-block; }

.table-2 > tbody > tr > td:first-child span a {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden; }

tr.blocked-file > td {
  background: #f7f7f7;
  cursor: pointer;
  position: relative; }
  tr.blocked-file > td .callout {
    top: 45px;
    left: 0; }

/* DEPRECATE */
/* Presentation Selector */
.presentation-selector {
  margin-top: 20px;
  /* Styled the same as navbar-left. */ }
  .presentation-selector .selector-header {
    /* Positioning */
    float: left;
    /* Display & Box Model */
    width: 100%;
    padding: 5px 15px 5px 0;
    border-bottom: 1px solid #DDDDDD;
    margin: 0; }
    .presentation-selector .selector-header li {
      /* Positioning */
      float: left;
      /* Display & Box Model */
      display: block;
      margin-left: 5px; }
    .presentation-selector .selector-header a {
      /* Display & Box Model */
      display: block;
      padding: 3px 10px;
      border: 1px solid #fff;
      /* Visual */
      font-weight: bold;
      line-height: 32px;
      color: #555; }
    .presentation-selector .selector-header a:hover,
    .presentation-selector .selector-header .active > a,
    .presentation-selector .selector-header .active > a:hover,
    .presentation-selector .selector-header .active > a:focus {
      /* Display & Box Model */
      border: 1px solid #e6e6e6;
      /* Visual */
      color: #0081BA;
      background-color: #f2f2f2; }
    .presentation-selector .selector-header .close-button {
      float: right; }
    .presentation-selector .selector-header .close {
      line-height: 32px; }
  .presentation-selector .search {
    margin-bottom: 20px; }
  .presentation-selector .panel-body, .presentation-selector .content-box-body {
    clear: both; }

.jumbo-card {
  text-align: center;
  background-color: transparent;
  margin-bottom: 20px; }
  .jumbo-card h1 {
    font-size: 64px !important; }
  .jumbo-card .main-link {
    display: block;
    color: #020621;
    width: 50%;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    position: absolute;
    top: -30px;
    left: 25%;
    background-color: #4ab767;
    color: #fff;
    border-radius: 6px;
    box-shadow: inset 0 -4px 0 #42a65c; }
    .jumbo-card .main-link:hover, .jumbo-card .main-link:active {
      background-color: #3e9b56;
      box-shadow: inset 0 -4px 0 #388c4e; }
    .jumbo-card .main-link:active {
      box-shadow: none; }
    @media (max-width: 480px) {
      .jumbo-card .main-link {
        width: 75%;
        left: 12.5%; } }
  .jumbo-card .body {
    border-radius: 6px;
    background-color: #282828;
    margin-top: 120px;
    position: relative; }
    .jumbo-card .body .cover {
      background-image: url("http://placehold.it/1200x400");
      background-size: cover;
      background-position: center;
      height: 160px;
      width: 100%;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px; }
    .jumbo-card .body .details {
      padding: 20px;
      color: #fff; }
    .jumbo-card .body .section-link {
      margin-top: 20px;
      font-weight: bold;
      color: #fff;
      padding: 20px;
      text-align: center;
      overflow: hidden;
      min-height: 176px; }
      .jumbo-card .body .section-link svg {
        width: 100%;
        max-width: 64px; }
      .jumbo-card .body .section-link:not(:last-of-type) {
        border-right: 1px solid #454545; }
      @media (max-width: 992px) {
        .jumbo-card .body .section-link:not(:last-of-type) {
          border: none; } }

ul.tree,
ul.tree ul {
  margin: 0;
  padding: 0; }

ul.tree ul {
  margin-left: 10px;
  /* indentation */
  position: relative; }

ul.tree ul:before {
  content: "";
  display: block;
  width: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-left: 1px solid #d4d4d4; }

ul.tree li {
  margin: 0;
  padding: 0 15px;
  /* indentation + 2 */
  line-height: 30px;
  /* default list item \`line-height\` */
  position: relative; }
  ul.tree li a {
    color: #444;
    font-weight: 600;
    padding: 4px;
    border-radius: 2px; }
    ul.tree li a .fa:before {
      color: #d4d4d4;
      margin-right: 5px;
      font-size: 24px;
      vertical-align: middle; }
    ul.tree li a:hover {
      background: #dcf1e2; }

ul.tree ul li:before {
  content: "";
  display: block;
  width: 10px;
  /* same with indentation */
  height: 0;
  border-top: 1px solid #d4d4d4;
  position: absolute;
  top: 15px;
  left: 0; }

ul.tree ul li:last-child:before {
  background: white;
  /* same with body background */
  height: auto;
  top: 15px;
  /* (line-height/2) */
  bottom: 0; }

.folder-tabs {
  margin-bottom: 10px;
  font-size: 16px;
  border-bottom: 1px solid #d4d4d4; }
  .folder-tabs li {
    float: left;
    width: 33.3%;
    text-align: center; }
    .folder-tabs li a {
      border-bottom: 4px solid #FFF; }
    .folder-tabs li:hover a {
      border: none;
      background: none; }
    .folder-tabs li.active a {
      border: none;
      border-bottom: 4px solid #4ab767;
      color: #444;
      font-weight: 600; }

.slider-handle {
  background: #4ab767; }

.slider.slider-vertical .slider-handle.triangle {
  border-left-color: #4ab767; }

.slider.slider-horizontal .slider-handle.triangle {
  border-bottom-color: #4ab767; }

.store-status-2 {
  display: inline-block;
  border-radius: 3px;
  background: #FFF;
  padding: 0;
  height: 24px; }
  .store-status-2 .btn, .store-status-2 .icon-nav label, .icon-nav .store-status-2 label {
    margin: 0;
    vertical-align: top;
    height: 24px; }
  .store-status-2 h3 {
    margin: 0;
    padding: 0 8px;
    font-size: 13px;
    line-height: 23px;
    font-weight: normal;
    vertical-align: top;
    display: inline-block;
    color: #555; }
    .store-status-2 h3 .fa:before {
      color: #4ab767; }
    .store-status-2 h3.warning .fa:before {
      color: #e6bf00; }
    .store-status-2 h3.expired .fa:before {
      color: #e6e6e6; }
    .store-status-2 h3 a {
      color: #4ab767;
      font-weight: bold;
      margin-left: 3px; }

.input-url-addon {
  display: table-cell;
  vertical-align: middle;
  width: 1%;
  padding: 0 0 0 12px; }

.label-tag {
  background: #f2f2f2;
  color: #777;
  white-space: normal;
  font-size: 14px;
  display: inline-block;
  border: 1px solid #e6e6e6;
  padding: 2px 5px 2px 5px;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
  font-weight: 500; }
  .label-tag:hover {
    color: #555; }
  .label-tag .tag-name, .label-tag .tag-value {
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top; }
  .label-tag .tag-name {
    max-width: 80px;
    display: inline-block;
    padding: 0; }
    .label-tag .tag-name::before {
      content: ':';
      float: right;
      font-weight: bold;
      font-size: 13px;
      margin-left: 2px; }
  .label-tag .tag-value {
    max-width: 120px;
    display: inline-block;
    padding: 0;
    font-weight: bold;
    color: #4d4d4d; }
  @media (max-width: 480px) {
    .label-tag {
      font-size: 13px; }
      .label-tag .tag-name::before {
        line-height: 18px; } }
  .label-tag.invalid {
    background-color: #f2dede;
    border-color: #ebccd1; }

.tag-selector {
  padding: 5px;
  margin-bottom: 10px; }
  .tag-selector .scrollable-content {
    white-space: normal; }
    .tag-selector .scrollable-content .label-tag {
      display: inline-block;
      margin-top: 5px;
      margin-right: 5px; }

.btn-remove {
  color: #555;
  padding: 0; }

.content-box-editable {
  min-height: 34px;
  padding: 0;
  position: relative;
  border: 1px solid #ccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .content-box-editable .input-group > .input-group-addon {
    height: 32px; }
  .content-box-editable > .edit-icon {
    position: absolute;
    top: 6px;
    right: 8px; }
  .content-box-editable .label-tag {
    margin-top: 3px;
    margin-left: 3px; }
  .content-box-editable .text-muted, .content-box-editable .text-placeholder {
    line-height: 24px;
    margin: 4px 0 0 0;
    padding: 0 12px;
    color: #777777;
    -webkit-font-smoothing: subpixel-antialiased; }

.content-box-filters {
  background: #fcfcfc;
  padding: 10px 10px 5px;
  margin-top: 5px; }

.select-tags {
  padding: 3px; }
  .select-tags .label {
    margin-right: 3px;
    margin-top: 3px; }

.content-box-disabled {
  pointer-events: none !important;
  background: #e6e6e6 !important; }

.timeline .control-label {
  font-weight: 500; }

.timeline .dropdown-menu {
  padding: 5px; }
  .timeline .dropdown-menu li {
    overflow: hidden;
    padding: 5px !important; }
    .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {
      margin: 0; }
  .timeline .dropdown-menu * {
    outline: 0; }
    .timeline .dropdown-menu *:focus {
      outline: 0; }
  .timeline .dropdown-menu table {
    border-collapse: separate;
    border-spacing: 1px; }
    .timeline .dropdown-menu table thead tr:last-child th {
      font-weight: 400;
      padding: 5px 0; }
    .timeline .dropdown-menu table tbody .btn, .timeline .dropdown-menu table tbody .icon-nav label, .icon-nav .timeline .dropdown-menu table tbody label {
      border: none;
      border-radius: 0; }

.recurrence-option .form-control {
  margin: 0 5px;
  display: inline-block; }

.recurrence-option .control-label {
  display: inline-block; }

.recurrence-option fieldset {
  display: inline-block; }

.recurrence-option select {
  width: 90px;
  display: inline-block; }

.recurrence-option .input-short {
  width: 40px; }

.recurrence-option .text-danger {
  margin-top: 15px; }

.recurrence-option .timelineWeekdays .control-label {
  display: block; }

.time-picker .btn-link {
  padding: 0;
  line-height: 12px;
  font-size: 12px; }
  .time-picker .btn-link span {
    line-height: normal; }

.time-picker .form-control {
  margin: 0; }

.time-picker .btn, .time-picker .icon-nav label, .icon-nav .time-picker label {
  margin-left: 5px; }

.colorpicker-swatch {
  border: 1px solid #CCC;
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  background: url("http://192.254.220.36/~rvi/mockups/images/mini-pattern.png"); }

.colorpicker-swatch span {
  height: 22px;
  width: 42px;
  display: block; }

.btn-colorpicker {
  padding: 4px 12px 4px 4px; }

.filters {
  margin-top: 20px;
  margin-right: 20px;
  text-align: center; }
  .filters .btn-default, .filters .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .filters .btn, .filters .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .filters label, .filters .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .filters label {
    width: 140px !important;
    margin-top: 7px;
    border: 0;
    border-bottom: 3px solid #eaeaea;
    border-radius: 0;
    background-color: #FCFCFC;
    float: none; }
  .filters .btn-default.active, .filters .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .filters .active.btn, .filters .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav .filters label.active, .filters .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li .filters label.active {
    color: #3b9351;
    border-bottom: 3px solid #52cc70;
    background-color: #FCFCFC;
    box-shadow: none; }
  .filters .btn-default:active, .filters .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .filters .btn:active, .filters .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav .filters label:active, .filters .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li .filters label:active,
  .filters .btn-default:focus,
  .filters .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li
  .filters .btn:focus,
  .filters .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav
  .filters label:focus,
  .filters .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li
  .filters label:focus {
    outline: 0;
    box-shadow: none; }
  .filters .btn-default:hover, .filters .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .filters .btn:hover, .filters .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav .filters label:hover, .filters .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li .filters label:hover {
    background-color: #eee; }
  .filters.container {
    text-align: center;
    padding-left: 0;
    margin-bottom: 8px;
    width: 1157px; }

.mobile-filters {
  display: none; }
  .mobile-filters .btn, .mobile-filters .icon-nav label, .icon-nav .mobile-filters label {
    width: 100% !important;
    margin-top: 10px; }

.store-selector .btn-default, .store-selector .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .store-selector .btn, .store-selector .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .store-selector label, .store-selector .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .store-selector label {
  width: 100% !important;
  padding: 20px 0; }

.store-selector .btn-default:active, .store-selector .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .store-selector .btn:active, .store-selector .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav .store-selector label:active, .store-selector .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li .store-selector label:active {
  box-shadow: none; }

.store-selector .btn-default.active, .store-selector .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .store-selector .active.btn, .store-selector .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav .store-selector label.active, .store-selector .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li .store-selector label.active {
  color: #3b9351;
  border: 1px solid #52cc70;
  box-shadow: none; }

.store-selector .btn-default.active span::before, .store-selector .timeline .dropdown-menu li .active.btn span::before, .timeline .dropdown-menu li .store-selector .active.btn span::before, .store-selector .timeline .dropdown-menu li .icon-nav label.active span::before, .timeline .dropdown-menu li .icon-nav .store-selector label.active span::before, .store-selector .icon-nav .timeline .dropdown-menu li label.active span::before, .icon-nav .timeline .dropdown-menu li .store-selector label.active span::before {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  content: '✔';
  background: url("") no-repeat; }

/*MOBILE BREAKPOINTS */
@media screen and (max-width: 768px) {
  .filters {
    display: none; }
  .mobile-filters {
    display: block; } }

/*LINE BREAK FIX*/
@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .filters .btn-default, .filters .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .filters .btn, .filters .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .filters label, .filters .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .filters label {
    width: 118px !important;
    padding: 6px 0; } }

/*EXPANDED THE PRODUCT CONTAINER ON TABLET AND BELOW */
@media only screen and (max-width: 768px) {
  .product-container {
    width: 100%; } }

.subscription-status {
  font-size: 15px;
  width: 100%;
  margin-bottom: 11px;
  padding: 6px 7px;
  text-align: center; }
  .subscription-status > span {
    position: relative;
    top: 2px; }
  .subscription-status .btn span, .subscription-status .icon-nav label span, .icon-nav .subscription-status label span {
    position: relative;
    top: 0; }
  .subscription-status.trial {
    color: green;
    border: 1px solid #4ab767;
    background: white; }
    .subscription-status.trial .btn-white {
      margin-left: 12px; }
  .subscription-status.cancelled, .subscription-status.expired, .subscription-status.suspended {
    color: #d20606;
    border: 1px solid #d20606;
    background: white; }
    .subscription-status.cancelled .btn-white, .subscription-status.expired .btn-white, .subscription-status.suspended .btn-white {
      margin-left: 12px;
      color: #d20606;
      background-color: #fff; }

.file-selector .subscription-status {
  text-align: left; }
  .file-selector .subscription-status.trial, .file-selector .subscription-status.cancelled, .file-selector .subscription-status.expired, .file-selector .subscription-status.suspended {
    border: none; }

.file-selector .clear-selection span {
  position: absolute;
  top: 8px;
  right: 13px;
  z-index: 3;
  cursor: pointer;
  width: 17px;
  text-align: center;
  display: block;
  height: 17px; }

.pt-media-list li {
  height: 107px;
  width: 107px;
  display: inline-block;
  text-align: center;
  overflow: hidden;
  position: relative;
  margin-left: 4px;
  border: 1px solid #ddd;
  -o-transition: border .2s ease-out;
  -ms-transition: border .2s ease-out;
  -moz-transition: border .2s ease-out;
  -webkit-transition: border .2s ease-out;
  transition: border .2s ease-out; }

.selected-border {
  border: 5px solid #4ab767 !important; }

.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none; }

.pt-media-list img {
  width: 100%;
  height: 100%; }

.pt-media-list img.disabled {
  opacity: .4;
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  cursor: not-allowed; }

.pt-media-list li:hover {
  border-color: #4ab767; }

.pt-media-list li .checkbox {
  position: absolute;
  top: 6px;
  left: 10px;
  margin-right: 10px;
  color: #d4d4d4;
  font-size: 16px;
  width: 16px;
  vertical-align: middle;
  text-align: center;
  font-family: FontAwesome;
  cursor: pointer; }

.pt-media-list li span {
  position: absolute;
  bottom: 6px;
  left: 50%; }

.pt-media-list li.folder,
.pt-media-list li.placeholder-item {
  background-color: #fff; }

.pt-media-list li.folder {
  cursor: pointer; }

.pt-media-list li.folder-extended {
  width: 329px; }
  .pt-media-list li.folder-extended span.image-folder-info {
    top: 21px !important; }

.pt-media-list li.folder img {
  width: 98px;
  height: 98px;
  float: left; }

.pt-media-list li.folder span,
.pt-media-list li.disabled-item span,
.pt-media-list li.single-item span,
.pt-media-list li.placeholder-item span {
  position: absolute;
  bottom: 8px;
  left: 0;
  width: 91px;
  text-align: center;
  line-height: 15px;
  font-size: 14px; }
  .pt-media-list li.folder span:first-child,
  .pt-media-list li.disabled-item span:first-child,
  .pt-media-list li.single-item span:first-child,
  .pt-media-list li.placeholder-item span:first-child {
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px;
    border: 1px solid red; }
  .pt-media-list li.folder span.ellipsis, .pt-media-list li.folder .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder span, .pt-media-list li.folder span.placeholder-item-name, .pt-media-list li.folder .display-name span, .display-name .pt-media-list li.folder span, .pt-media-list li.folder .display-address span, .display-address .pt-media-list li.folder span, .pt-media-list li.folder span.playlist-item-reference,
  .pt-media-list li.disabled-item span.ellipsis,
  .pt-media-list li.disabled-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name
  .pt-media-list li.disabled-item span,
  .pt-media-list li.disabled-item span.placeholder-item-name,
  .pt-media-list li.disabled-item .display-name span, .display-name
  .pt-media-list li.disabled-item span,
  .pt-media-list li.disabled-item .display-address span, .display-address
  .pt-media-list li.disabled-item span,
  .pt-media-list li.disabled-item span.playlist-item-reference,
  .pt-media-list li.single-item span.ellipsis,
  .pt-media-list li.single-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name
  .pt-media-list li.single-item span,
  .pt-media-list li.single-item span.placeholder-item-name,
  .pt-media-list li.single-item .display-name span, .display-name
  .pt-media-list li.single-item span,
  .pt-media-list li.single-item .display-address span, .display-address
  .pt-media-list li.single-item span,
  .pt-media-list li.single-item span.playlist-item-reference,
  .pt-media-list li.placeholder-item span.ellipsis,
  .pt-media-list li.placeholder-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name
  .pt-media-list li.placeholder-item span,
  .pt-media-list li.placeholder-item span.placeholder-item-name,
  .pt-media-list li.placeholder-item .display-name span, .display-name
  .pt-media-list li.placeholder-item span,
  .pt-media-list li.placeholder-item .display-address span, .display-address
  .pt-media-list li.placeholder-item span,
  .pt-media-list li.placeholder-item span.playlist-item-reference {
    width: 87%;
    margin-left: 7px;
    font-size: 11px; }

.pt-media-list li.folder span.ellipsis, .pt-media-list li.folder .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder span, .pt-media-list li.folder span.placeholder-item-name, .pt-media-list li.folder .display-name span, .display-name .pt-media-list li.folder span, .pt-media-list li.folder .display-address span, .display-address .pt-media-list li.folder span, .pt-media-list li.folder span.playlist-item-reference {
  font-size: 11px; }

.pt-media-list li.folder-extended span.ellipsis, .pt-media-list li.folder-extended .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended span.placeholder-item-name, .pt-media-list li.folder-extended .display-name span, .display-name .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended .display-address span, .display-address .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended span.playlist-item-reference {
  width: 29%; }

.pt-media-list li.folder span.image-folder-info {
  position: absolute;
  left: 105px;
  top: 25px;
  line-height: 13px;
  font-size: 11px;
  width: 170px; }

.pt-media-list li.placeholder-item svg {
  width: 38px;
  height: 38px;
  margin-top: 19px;
  position: relative;
  top: 6px; }
  .pt-media-list li.placeholder-item svg path {
    fill: #4ab767; }

.pt-media-list li.disabled-item {
  cursor: not-allowed; }
  .pt-media-list li.disabled-item svg {
    width: 38px;
    height: 38px;
    margin-top: 19px;
    position: relative;
    top: 6px; }
  .pt-media-list li.disabled-item path {
    fill: #ddd; }

.pt-media-list li.folder svg {
  width: 38px;
  height: 38px;
  margin-top: 19px;
  position: relative;
  top: 6px; }
  .pt-media-list li.folder svg path {
    fill: #4ab767; }

.pt-media-list li.folder-extended svg {
  float: left;
  margin-left: 30px;
  top: 3px; }

.btn-upload {
  background: #f2f2f2;
  color: #555; }

.btn-upload span {
  display: block;
  font-weight: 500;
  font-size: 16px; }

.btn-upload i {
  margin-top: 20px;
  font-size: 28px; }

#storageSelectorModal .btn-group, .storage-app .btn-group {
  display: inline; }

.google-drive-picker {
  display: inline-block; }
  .google-drive-picker img {
    height: 16px; }

/* -- FLUID GRID STYLES -- */
.template-grid {
  padding: 15px 0px 5px 15px;
  margin-bottom: 5px;
  border: none;
  max-height: calc(100vh - 320px); }

.template-grid li {
  display: inline-block;
  box-shadow: 0 2px 5px 0 rgba(80, 80, 80, 0.1), 0 2px 10px 0 rgba(80, 80, 80, 0.1);
  background: #eee;
  margin-right: 22px;
  width: 22.5%;
  padding-top: calc(12.7% + 64px);
  /* Used instead of height to give elements fluid, width-based height */
  margin-bottom: 2.5%;
  position: relative; }
  .template-grid li > .template-image {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    text-decoration: none !important; }
  .template-grid li .show-details {
    display: none;
    font-family: FontAwesome;
    width: 100%;
    height: calc(100% - 64px);
    position: absolute;
    background: rgba(50, 50, 50, 0.8);
    font-size: 24px;
    color: #FFF;
    font-weight: 800;
    top: 0;
    z-index: 1000; }
    .template-grid li .show-details:before {
      content: '\\f002';
      display: block;
      text-align: center;
      color: #FFF;
      line-height: 150px; }
  .template-grid li:hover .show-details {
    display: block; }

.template-grid:after {
  content: '';
  display: inline-block;
  width: 100%; }

.template-grid .placeholder {
  padding: 0; }

/* 2 COL */
@media (max-width: 996px) {
  .template-grid li {
    width: 48%;
    padding-top: calc(26.4% + 64px);
    margin-bottom: 4%;
    margin-right: 5px; } }

/* SINGLE COL */
@media (max-width: 768px) {
  .template-grid li {
    width: 100%;
    padding-top: calc(55.2% + 64px);
    margin-bottom: 5%;
    margin-right: 0; } }

.blank-template .template-image {
  color: #999; }

.blank-template a {
  color: #4ab767; }

.blank-template p {
  text-align: center;
  height: 100%;
  padding-top: 26%;
  background: #FFF;
  font-size: 24px; }
  .blank-template p span {
    display: block; }

.blank-template:hover:before {
  display: none !important; }

.template-info {
  background: #FFF;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 15px;
  color: #555;
  text-align: left; }
  .template-info h3 {
    margin: 0 0 8px;
    font-size: 14px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .template-info p {
    margin: 0;
    font-size: 12px;
    color: #999;
    line-height: 10px; }

.suggest-template {
  text-align: left; }
  .suggest-template .template-image {
    padding: 0 20px;
    display: block;
    background: #4ab767;
    color: #FFF; }
    .suggest-template .template-image a {
      color: #FFF; }
  .suggest-template h3 {
    margin: 0 0 5px 0;
    padding-top: 26%;
    color: #FFF;
    font-size: 21px; }
  .suggest-template p {
    margin: 0; }
  .suggest-template:hover:before {
    display: none !important; }

.template-pricing {
  color: #666;
  line-height: 30px;
  margin-bottom: 10px;
  font-size: 16px; }
  .template-pricing span {
    display: inline-block;
    vertical-align: bottom;
    font-size: 32px;
    font-weight: 800;
    color: #222;
    margin-right: 4px; }

#intercom-launcher {
  list-style: none;
  position: fixed;
  z-index: 1;
  right: 0;
  top: 130px;
  width: 134px;
  padding: 8px 5px;
  border: 3px solid #fff;
  border-right: none;
  -moz-border-radius: 10px 0 0 10px;
  -webkit-border-radius: 10px 0 0 10px;
  border-radius: 10px 0 0 10px;
  -moz-box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);
  -webkit-box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);
  cursor: pointer; }

#intercom-container .intercom-launcher-button {
  position: absolute !important;
  bottom: 7px !important;
  right: 10px !important;
  background-color: #79807B !important;
  border: none !important;
  box-shadow: none !important;
  float: right !important; }

#intercom-container .intercom-launcher {
  position: fixed;
  bottom: 0 !important;
  right: 0 !important;
  background: #79807B !important;
  top: 40% !important;
  color: white !important;
  width: 60px !important;
  height: 45px !important; }

#intercom-container .intercom-launcher-preview {
  position: absolute;
  bottom: 0;
  right: 67px;
  max-width: 205px;
  padding: 10px;
  color: white;
  border-radius: 0;
  background: none;
  cursor: pointer;
  width: 205px; }

#intercom-container .intercom-launcher-badge {
  top: 4px !important;
  right: 3px !important; }

#intercom-container .intercom-launcher-inactive.intercom-launcher-maximized {
  opacity: 1 !important;
  visibility: visible !important; }

#intercom-container .intercom-launcher-inactive {
  visibility: hidden !important; }

#intercom-container .intercom-launcher-preview:after {
  background-color: #79807B; }

#intercom-container .intercom-launcher-preview {
  box-shadow: none; }

#intercom-container .intercom-launcher-preview .intercom-comment-body {
  line-height: 16px; }

#intercom-container .intercom-launcher-preview {
  position: absolute;
  bottom: 2px;
  right: 60px;
  max-width: 240px;
  padding: 8px;
  color: white;
  border-radius: 0;
  background: none;
  cursor: pointer; }

.editor-playlist .editor-playlist-item {
  box-shadow: 0 2px 2px rgba(40, 40, 40, 0.1); }
  .editor-playlist .editor-playlist-item .playlist-item-name span {
    max-width: 100px; }

.btn-group-justified a span {
  font-size: 13px;
  display: block;
  text-align: center;
  line-height: 15px; }

.btn-group-justified a svg {
  height: 33px;
  width: 30px;
  margin-right: 2px; }
  .btn-group-justified a svg path {
    fill: #333; }

.playlist-item-thumbnail {
  overflow: hidden;
  height: 44px;
  width: 44px;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  float: left;
  margin-right: 10px; }

.playlist-item-thumbnail img {
  width: 100%; }

.playlist-item-duration {
  color: green; }

.name-container {
  margin-top: 6px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center; }
  .name-container span {
    vertical-align: middle; }
  .name-container p:first-child {
    cursor: pointer; }
    .name-container p:first-child span:first-child {
      width: 16px;
      height: 16px;
      display: inline-block; }
    .name-container p:first-child span:last-child {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 125px;
      display: inline-block;
      line-height: 16px; }
  .name-container p:last-child {
    position: relative;
    top: -7px; }
  .name-container svg path {
    fill: #0081BA; }
  .name-container p span {
    color: #0081BA; }
    .name-container p span:hover {
      text-decoration: underline; }

.ph-playlist {
  margin-top: 10px; }
  .ph-playlist .editor-playlist {
    height: calc(100vh - 360px);
    max-height: calc(100vh - 250px); }
    .ph-playlist .editor-playlist .editor-playlist-item {
      padding: 3px !important; }

.cta-tooltip .tooltip-inner {
  color: #4ab767;
  background: #fff;
  padding: 9px;
  border: 1px solid #4ab767;
  font-weight: bold; }

.cta-tooltip .tooltip-arrow {
  border-bottom-color: #4ab767 !important; }

/* Sections/Views
   ========================================================================== */
/* ==========================================================================
   Widgets
   ========================================================================== */
/* Legacy, supporting old widgets */
.widget-overlay {
  /* Positioning */
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* Visual */
  background: rgba(255, 255, 255, 0.7); }

/* Legacy, supporting old widgets */
.widget-wrapper {
  /* Positioning */
  z-index: 2;
  /* Display & Box Model */
  height: 90%;
  padding-bottom: 100px;
  margin: 40px auto 0;
  overflow: auto; }
  .widget-wrapper > .modal-header {
    padding-left: 0;
    padding-right: 0; }

/* Widget Settings */
/* Size for Storage Icon */
.storage-selector-icon {
  height: 14px; }

/* Storage Input Field*/
.clear-file:not(:first-child):not(:last-child) {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: none; }

.preview-file {
  padding: 0;
  padding-left: 10px;
  background: transparent;
  border: none; }

/* Storage Subscription Status */
.storage-status {
  text-align: left;
  border: none !important;
  background-color: transparent !important; }

.widget {
  height: 100%; }
  .widget .overlay {
    /* Positioning */
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0; }
  .widget .settings {
    /* Positioning */
    position: relative;
    /* Display & Box Model */
    height: 100%; }
  .widget .settings-center {
    /* Positioning */
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /* Display & Box Model */
    width: 100%;
    max-height: 90%;
    overflow: auto;
    margin: auto;
    padding: 15px; }
  .widget .wrapper {
    /* Positioning */
    z-index: 1000;
    /* Display & Box Model */
    height: 99%;
    padding-bottom: 25px;
    margin: 0 auto;
    overflow: auto; }
    .widget .wrapper > .modal-header {
      padding-left: 0;
      padding-right: 0; }
  .widget .section {
    /* Display & Box Model */
    padding: 10px;
    margin-bottom: 30px;
    /* Visual */
    border: 1px solid #DDDDDD;
    border-radius: 6px; }
    .widget .section > h5:first-of-type {
      margin-top: -17px;
      color: #0081BA; }

.date-range * {
  display: inline-block;
  margin-right: 4px; }

.date-range .form-control {
  width: 80px; }

.storage-modal {
  /* ==========================================================================
     Buttons
     ========================================================================== */
  /* ==========================================================================
     Uploader
     ========================================================================== */
  /* ==========================================================================
  Thumbnail View
  ========================================================================== */
  /**
   * Single-column layout at mobile resolutions.
   */
  /* Clearfix */
  /* Media queries
  ========================================================================== */
  /**
   * Three-column layout at tablet resolutions.
   */
  /**
   * Six-column layout at desktop resolutions.
   */ }
  .storage-modal .scrollable-list, .storage-modal .template-grid {
    max-height: calc(100vh - 140px); }
  .storage-modal .selector-header {
    margin-bottom: 10px;
    margin-top: 15px;
    overflow: hidden; }
    .storage-modal .selector-header p {
      line-height: 16px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      vertical-align: middle; }
      .storage-modal .selector-header p:first-child {
        display: block; }
  .storage-modal .commands {
    position: relative; }
  .storage-modal .storage-used-info {
    font-size: 10px;
    text-align: right;
    float: right; }
  .storage-modal .current-folder-icon .fa::before {
    color: #4ab767; }
  .storage-modal #store-modal .overlay {
    z-index: 2;
    background-color: #ffffff; }
  .storage-modal .inline-progress {
    margin-bottom: 0px; }
  .storage-modal .inline-cancel {
    float: right;
    width: auto;
    padding-left: 10px;
    text-align: center;
    cursor: pointer; }
  .storage-modal tbody tr:first-child td {
    border-top: none; }
  .storage-modal .panel table, .storage-modal .content-box table, .storage-modal .select-subcompany-modal .list-group table, .select-subcompany-modal .storage-modal .list-group table, .storage-modal .content-box-editable table, .storage-modal .card table, .storage-modal #appLauncherContainer .scrollable-list table, #appLauncherContainer .storage-modal .scrollable-list table, .storage-modal #appLauncherContainer .template-grid table, #appLauncherContainer .storage-modal .template-grid table {
    margin-bottom: 0px !important; }
  .storage-modal .panel-heading {
    cursor: pointer; }
  .storage-modal .thumbnails {
    display: none;
    cursor: pointer; }
  .storage-modal .thumbnails:after {
    clear: both;
    display: block;
    content: ""; }
  .storage-modal .thumbnail {
    border: none; }
  .storage-modal .thumbnail .caption {
    font-size: 12px;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden; }
  .storage-modal .thumbnail:hover, .storage-modal .thumbnail.active {
    background-color: #f5f5f5; }
  .storage-modal .thumbnail.active:hover {
    background-color: #e8e8e8; }
  @media (min-width: 768px) {
    .storage-modal .thumbnail {
      /* Positioning */
      float: left;
      /* Display & Box Model */
      width: 33.33333%;
      padding-left: 5px;
      padding-right: 5px; }
    .storage-modal .thumbnail:nth-child(3n+1) {
      clear: left; } }
  @media (min-width: 992px) {
    .storage-modal .thumbnail {
      width: 16.66667%; }
    .storage-modal .thumbnail:nth-child(3n+1) {
      clear: none; }
    .storage-modal .thumbnail:nth-child(6n) {
      padding-right: 0; }
    .storage-modal .thumbnail:nth-child(6n+1) {
      /* Positioning */
      clear: left;
      /* Display & Box Model */
      padding-left: 0; } }
  .storage-modal .current-folder {
    line-height: 43px; }
  .storage-modal .form-group {
    margin-bottom: 10px; }
  .storage-modal .non-clickable-file {
    cursor: default;
    text-decoration: none; }

tr.blocked-file {
  position: relative; }
  tr.blocked-file > td {
    background: #f7f7f7;
    cursor: pointer;
    position: relative; }
    tr.blocked-file > td .callout {
      top: 35px;
      left: 10px; }

.storage-selector-backdrop {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #e7e7e7;
  opacity: 0.9; }

.storage-selector-iframe {
  width: 90%;
  height: 500px;
  position: absolute;
  top: 20%;
  left: 5%;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.5);
  border-style: ridge;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 5px;
  background-color: #f4f4f4; }

.storage-selector-iframe-full {
  width: 100%;
  max-height: 100%;
  position: absolute;
  border: 0px;
  padding: 0px 0px 50px;
  margin-top: 0;
  overflow: auto; }
  @media (max-width: 768px) {
    .storage-selector-iframe-full {
      position: relative;
      padding: 0px; } }

.table.filetable td, .filetable.table-2 td {
  max-width: 200px;
  /* Customise it accordingly */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  color: #888; }

.table.filetable .check-col, .filetable.table-2 .check-col, .table-2 .check-col {
  width: 30px; }

.table.filetable .type-col, .filetable.table-2 .type-col, .table-2 .type-col {
  width: 130px; }

.table.filetable .filesize-col, .filetable.table-2 .filesize-col, .table-2 .filesize-col {
  width: 130px; }

.table.filetable .datemod-col, .filetable.table-2 .datemod-col, .table-2 .datemod-col {
  width: 180px; }

.table.filetable input, .filetable.table-2 input {
  margin: 0; }

.table.filetable .copy-url, .filetable.table-2 .copy-url {
  width: 1px; }
  .table.filetable .copy-url .btn-link, .filetable.table-2 .copy-url .btn-link {
    padding: 0;
    font-size: 16px; }

.table.filetable .file-name a, .filetable.table-2 .file-name a {
  color: #444; }
  .table.filetable .file-name a .fa::before, .filetable.table-2 .file-name a .fa::before {
    margin-right: 5px;
    font-size: 20px;
    vertical-align: middle;
    color: #d4d4d4; }

.table.filetable .file-name.folder-type a .fa-folder::before, .filetable.table-2 .file-name.folder-type a .fa-folder::before {
  color: #4ab767; }

.support-app {
  /* Ticket List Table (desktop) */
  /* Media Style Ticket List (mobile) */
  /* Ticket Details View */
  /* Comments */
  /* Post Comment Box */
  /* Tickets Table Stack View */ }
  .support-app .support-time {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border-top-width: 0px;
    margin-top: -20px;
    margin-bottom: 40px;
    text-align: center;
    color: #555; }
    .support-app .support-time.alert-warning {
      border-color: #FAEBCC; }
    .support-app .support-time.alert-success {
      border-color: #D6E9C6; }
    .support-app .support-time .text-danger {
      color: #c0392b; }
    .support-app .support-time .divider {
      margin: 0 5px; }
  .support-app h2 {
    margin-top: 0px !important; }
  .support-app .ticket-description {
    white-space: pre-line;
    line-height: 20px; }
  .support-app .ticket-attachments {
    margin: 20px 0;
    line-height: 20px; }
    .support-app .ticket-attachments a {
      display: block; }
  .support-app .ticket-list-table {
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #ccc;
    font-weight: bold;
    margin-bottom: 40px; }
    .support-app .ticket-list-table .no-tickets {
      min-height: 200px;
      text-align: center;
      line-height: 200px;
      color: #aaa; }
    .support-app .ticket-list-table .text-muted {
      color: #aaa; }
    .support-app .ticket-list-table .text-success {
      color: #4ab767; }
    .support-app .ticket-list-table .text-primary {
      color: #5bc0de; }
    .support-app .ticket-list-table .text-danger {
      color: #c0392b; }
    .support-app .ticket-list-table .text-warning {
      color: #f0ad4e; }
    .support-app .ticket-list-table .title-row {
      font-size: 12px;
      margin: 0;
      border-bottom: 1px solid #ccc;
      padding: 0;
      line-height: 40px;
      font-weight: bold;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none; }
    .support-app .ticket-list-table .ticket {
      margin: 0;
      line-height: 66px; }
      .support-app .ticket-list-table .ticket a {
        color: #020621; }
      .support-app .ticket-list-table .ticket:not(:last-child) {
        border-bottom: 1px solid #eee; }
      .support-app .ticket-list-table .ticket * {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; }
  .support-app .ticket-list-mobile {
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #ccc;
    padding: 0 10px; }
    .support-app .ticket-list-mobile .ticket.media {
      margin-top: 0;
      color: #333;
      cursor: pointer; }
    .support-app .ticket-list-mobile .ticket .label {
      width: 60px; }
    .support-app .ticket-list-mobile .ticket h5 {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 40px; }
    .support-app .ticket-list-mobile .ticket .ticket-item {
      padding: 15px 0; }
    .support-app .ticket-list-mobile .ticket:not(:last-child) .ticket-item {
      border-bottom: 1px solid #ccc; }
  .support-app .ticket {
    margin-bottom: 40px;
    width: 100%;
    height: 66px;
    position: relative; }
    .support-app .ticket .status-tag {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      line-height: 64px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      margin-right: 10px;
      background-color: #888; }
      .support-app .ticket .status-tag.solved {
        background-color: #5CB85C; }
      .support-app .ticket .status-tag.open {
        background-color: #D9534F; }
      .support-app .ticket .status-tag.pending {
        background-color: #5BC0DE; }
      .support-app .ticket .status-tag.new {
        background-color: #f0ad4e; }
    .support-app .ticket .ticket-heading h4 {
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      margin: 0;
      line-height: 64px;
      height: 64px; }
      .support-app .ticket .ticket-heading h4 .ticket-id {
        margin-right: 4px; }
      .support-app .ticket .ticket-heading h4 small {
        display: block; }
    .support-app .ticket .meta {
      height: 64px;
      width: 64px;
      text-align: right;
      line-height: 64px; }
  .support-app .panel-footer {
    padding: 0;
    border-top: none; }
    .support-app .panel-footer .ticket-attachments {
      margin: 0;
      padding: 10px;
      border-top: 1px solid #ddd; }
  .support-app .panel-body, .support-app .content-box-body {
    background-color: #eee;
    border-radius: 4px; }
    .support-app .panel-body p, .support-app .content-box-body p {
      margin-bottom: 0; }
  .support-app .panel-body.rise-vision-support, .support-app .rise-vision-support.content-box-body {
    background-color: #FFF; }
  .support-app .chat-head {
    width: 32px;
    height: 32px; }
  .support-app .comments-list {
    margin-bottom: 200px; }
    .support-app .comments-list h4 {
      margin-bottom: 30px; }
  .support-app .comment {
    margin-bottom: 10px; }
  .support-app .comment .user {
    margin-bottom: 5px; }
  .support-app .comment-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    /* Set the fixed height of the footer here */
    background-color: #fff; }
  .support-app .comment-box .ticket-button .dropdown-toggle {
    color: #FFF;
    background-color: #45B864;
    border-color: #3c9f57;
    border-radius: 0px; }
  @media (max-width: 768px) {
    .support-app .table-stack > tbody > tr {
      display: block;
      position: relative; }
    .support-app .table-stack > tbody > tr:hover > td:before {
      color: #0081BA; }
    .support-app .table-stack > tbody > tr > td {
      padding: 5px 10px; }
      .support-app .table-stack > tbody > tr > td.ticket-subject {
        padding: 10px 80px 0 10px; }
      .support-app .table-stack > tbody > tr > td.ticket-id {
        display: none; }
      .support-app .table-stack > tbody > tr > td.ticket-status {
        text-align: right;
        position: absolute;
        width: 80px;
        right: 0;
        top: 5px; }
      .support-app .table-stack > tbody > tr > td.ticket-requester {
        margin-left: 0;
        padding-left: 0; }
        .support-app .table-stack > tbody > tr > td.ticket-requester:before {
          content: attr(data-th) " ";
          float: left;
          margin-right: 5px; }
      .support-app .table-stack > tbody > tr > td.ticket-date {
        width: auto;
        padding-right: 5px; } }

.alerts-app h2 {
  margin-top: 0px !important; }

.alerts-app .alerts-list {
  color: #333;
  margin-top: 0;
  padding: 0 10px; }
  .alerts-app .alerts-list:not(:last-child) {
    border-bottom: 1px solid #e5e5e5; }
  .alerts-app .alerts-list h5 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 40px; }
  .alerts-app .alerts-list .media-body {
    padding: 15px 0; }

.storage-full .table-2 .folder:before,
.storage-full .table-2 .file:before,
.storage-modal .table-2 .folder:before,
.storage-modal .table-2 .file:before {
  font-family: FontAwesome; }

.storage-full .table-2 .back-btn .folder:before,
.storage-modal .table-2 .back-btn .folder:before {
  content: '\\f07c';
  color: #4ab767; }

.storage-full .table-2 .folder:before,
.storage-modal .table-2 .folder:before {
  content: '\\f07b';
  color: #4ab767;
  margin-right: 10px; }

.storage-full .table-2 .file:before,
.storage-modal .table-2 .file:before {
  content: '\\f15b';
  color: #d4d4d4; }

.storage-full .table-2 .sub-folder,
.storage-modal .table-2 .sub-folder {
  margin-left: 22px;
  position: relative; }
  .storage-full .table-2 .sub-folder:after,
  .storage-modal .table-2 .sub-folder:after {
    content: '';
    width: 15px;
    height: 6px;
    display: block;
    position: absolute;
    top: 4px;
    left: -20px;
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc; }

.storage-full .notifications,
.storage-modal .notifications {
  margin: 0px 5px; }

.storage-full .toolbar,
.storage-modal .toolbar {
  margin: 10px 0; }

.storage-full .rotating-text,
.storage-modal .rotating-text {
  color: #777;
  margin-left: 5px; }

.storage-full .scrollable-list, .storage-full .template-grid {
  padding: 4px;
  max-height: calc(100vh - 300px);
  width: 100%; }

#store-modal-frame {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%; }

.paid-on-board {
  text-align: center;
  background-color: transparent; }
  .paid-on-board h1 {
    font-size: 64px !important; }
  .paid-on-board .store-link {
    display: block;
    color: #020621;
    width: 50%;
    font-size: 20px;
    cursor: pointer;
    position: absolute;
    top: -60px;
    left: 25%; }
    @media (max-width: 480px) {
      .paid-on-board .store-link {
        width: 75%;
        left: 12.5%;
        font-size: 12px;
        top: -40px; } }
    .paid-on-board .store-link .rate {
      height: 60px;
      line-height: 58px;
      background-color: #fff;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc; }
      @media (max-width: 480px) {
        .paid-on-board .store-link .rate {
          height: 40px;
          line-height: 40px; } }
    .paid-on-board .store-link .subscribe {
      height: 60px;
      line-height: 60px;
      background-color: #4ab767;
      color: #fff;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      box-shadow: inset 0 -4px 0 #42a65c; }
      @media (max-width: 480px) {
        .paid-on-board .store-link .subscribe {
          height: 40px;
          line-height: 40px; } }
  .paid-on-board .about {
    border-radius: 6px;
    background-color: #424242;
    margin-top: 120px;
    position: relative; }
    .paid-on-board .about .cover {
      background-image: url("/images/support-ob-bg.png");
      background-size: cover;
      background-position: center;
      height: 160px;
      width: 100%;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px; }
    .paid-on-board .about .tab-buttons {
      width: 50%;
      margin: -20px auto 0 auto;
      background-color: #fff;
      line-height: 40px;
      border-radius: 20px;
      font-weight: bold;
      color: #ccc; }
      @media (max-width: 480px) {
        .paid-on-board .about .tab-buttons {
          font-size: 12px;
          width: 75%; } }
      .paid-on-board .about .tab-buttons .tab-title {
        display: inline-block;
        width: 50%;
        text-align: center;
        cursor: pointer; }
        .paid-on-board .about .tab-buttons .tab-title:last-child {
          border-left: 1px solid #ccc; }
        .paid-on-board .about .tab-buttons .tab-title.active {
          color: #020621; }
    .paid-on-board .about .details {
      padding: 40px;
      color: #fff; }
      .paid-on-board .about .details p {
        margin-bottom: 30px; }
        .paid-on-board .about .details p:last-child {
          margin-bottom: 0px; }
      .paid-on-board .about .details .more {
        color: #4ab767;
        font-weight: bold;
        cursor: pointer; }

.workspace {
  -webkit-transition: all 0.2s;
  /* Safari 3.1 to 6.0 */
  transition: all 0.2s;
  position: relative;
  background: #d4d4d4; }
  .workspace .workspace-toolbar {
    width: calc(100% - 12px);
    white-space: nowrap;
    position: absolute;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.9);
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    padding: 8px 10px;
    -webkit-transition: all .25s;
    transition: all .25s; }
    .workspace .workspace-toolbar #previewButton {
      margin-left: 10px; }
    .workspace .workspace-toolbar #addPlaceholderButton {
      width: calc((290px - 20px));
      margin-right: 10px; }
    .workspace .workspace-toolbar > h4 {
      position: absolute;
      left: 14px;
      top: -5px; }
    .workspace .workspace-toolbar .presentation-name {
      display: inline-block;
      line-height: 32px;
      font-size: 18px;
      font-weight: 400;
      vertical-align: top;
      margin: 0;
      max-width: calc(100% - 700px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis; }
      @media (max-width: 768px) {
        .workspace .workspace-toolbar .presentation-name {
          max-width: 200px; } }
    @media (max-width: 768px) {
      .workspace .workspace-toolbar {
        width: 100%;
        overflow: hidden;
        left: 0;
        top: 0; } }
    @media (max-width: 920px) {
      .workspace .workspace-toolbar #addPlaceholderButton {
        width: 100%;
        display: block;
        float: none;
        margin: 8px 0; } }
  .workspace .workspace-sidebar {
    padding: 8px 0;
    position: absolute;
    top: 49px;
    height: calc(100vh - 140px);
    width: 290px;
    overflow: hidden;
    background-color: #f7f7f7;
    -webkit-transition: all 0.5s;
    /* Safari 3.1 to 6.0 */
    transition: all 0.5s;
    border-right: 1px solid #e6e6e6; }
    .workspace .workspace-sidebar .scrollable-list, .workspace .workspace-sidebar .template-grid {
      min-height: 45px;
      max-height: calc(100vh - 150px);
      font-size: 13px; }
    .workspace .workspace-sidebar #listWithHandle.scrollable-list, .workspace .workspace-sidebar #listWithHandle.template-grid {
      max-height: calc(100vh - 290px); }
    .workspace .workspace-sidebar .editor-playlist {
      border: none; }
      .workspace .workspace-sidebar .editor-playlist .editor-playlist-item:last-child {
        margin-bottom: 20px; }
    @media (max-width: 992px) {
      .workspace .workspace-sidebar {
        height: calc(100vh - 185px); } }
    @media (max-width: 768px) {
      .workspace .workspace-sidebar {
        width: 100%;
        position: relative;
        z-index: 80;
        top: 133px; }
        .workspace .workspace-sidebar .scrollable-list, .workspace .workspace-sidebar .template-grid {
          max-height: calc(100vh - 420px); } }
    .workspace .workspace-sidebar h4 {
      line-height: 33px;
      margin-bottom: 8px;
      margin-top: 0; }
    .workspace .workspace-sidebar .workspace-sidebar-content {
      width: calc((290px * 2));
      /* Total width of panels */ }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar .workspace-sidebar-content {
          width: 100%; } }
    .workspace .workspace-sidebar .table-playlist-items tbody > tr > td {
      height: 56px; }
    .workspace .workspace-sidebar .ph-list,
    .workspace .workspace-sidebar .ph-properties {
      width: 290px;
      padding: 0 10px;
      -webkit-transition: all 0.5s;
      /* Safari 3.1 to 6.0 */
      transition: all 0.5s; }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar .ph-list,
        .workspace .workspace-sidebar .ph-properties {
          width: 100vw; } }
    .workspace .workspace-sidebar .ph-list .editor-playlist {
      height: calc(100vh - 210px);
      max-height: calc(100vh - 240px); }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar .ph-list .editor-playlist {
          margin-right: 0;
          max-height: calc(100vh - 300px); } }
    @media (max-width: 768px) {
      .workspace .workspace-sidebar .ph-settings .scrollable-list, .workspace .workspace-sidebar .ph-settings .template-grid {
        max-height: calc(100vh - 350px) !important; } }
    .workspace .workspace-sidebar .ph-properties {
      float: right;
      opacity: 0; }
      .workspace .workspace-sidebar .ph-properties .scrollable-list, .workspace .workspace-sidebar .ph-properties .template-grid {
        max-height: calc(100vh - 240px); }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar .ph-properties {
          -webkit-transform: translateX(0);
          /* Safari */
          transform: translateX(0);
          float: none;
          display: none; }
          .workspace .workspace-sidebar .ph-properties .scrollable-list, .workspace .workspace-sidebar .ph-properties .template-grid {
            max-height: calc(100vh - 430px); } }
    .workspace .workspace-sidebar.show-ph-properties .ph-list {
      -webkit-transform: translateX(-290px);
      /* Safari */
      transform: translateX(-290px); }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar.show-ph-properties .ph-list {
          -webkit-transform: translateX(0);
          /* Safari */
          transform: translateX(0);
          display: none; } }
    .workspace .workspace-sidebar.show-ph-properties .ph-properties {
      opacity: 1;
      -webkit-transform: translateX(-290px);
      /* Safari */
      transform: translateX(-290px); }
      @media (max-width: 768px) {
        .workspace .workspace-sidebar.show-ph-properties .ph-properties {
          -webkit-transform: translateX(0);
          /* Safari */
          transform: translateX(0);
          display: block; } }
  .workspace .workspace-board {
    background-color: #FFF;
    overflow-x: scroll;
    overflow-y: scroll;
    height: calc(100vh - 105px);
    position: relative;
    z-index: 80;
    margin-left: 290px;
    -webkit-transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    /* Safari 3.1 to 6.0 */
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
    @media (max-width: 992px) {
      .workspace .workspace-board {
        height: calc(100vh - 125px); } }
    @media (max-width: 768px) {
      .workspace .workspace-board {
        position: absolute;
        top: 55px;
        left: 0;
        margin-left: 0;
        width: 100%;
        z-index: 40; } }
  .workspace.hide-sidebar .workspace-toolbar {
    width: calc(100% - 11px);
    left: 0;
    padding-left: 11px; }
  .workspace.hide-sidebar .workspace-sidebar {
    -webkit-transform: translateX(-290px);
    /* Safari */
    transform: translateX(-290px); }
  .workspace.hide-sidebar .workspace-board {
    margin-left: 0; }
  @media (max-width: 768px) {
    .workspace.hide-sidebar .workspace-toolbar {
      width: 100%; }
    .workspace.hide-sidebar .workspace-sidebar {
      -webkit-transform: translateX(-100%);
      /* Safari */
      transform: translateX(-100%); } }

.active-banner-mode .workspace-board {
  height: calc(100vh - 125px); }

.active-banner-mode-double .workspace-board {
  height: calc(100vh - 150px); }

.placeholder-item-name {
  width: 180px;
  font-weight: 500;
  line-height: 24px; }
  .placeholder-item-name:hover {
    color: #0081BA; }

@media (max-width: 992px) {
  .editor-footer .save-status {
    display: block;
    width: 100%; }
  .editor-footer #deleteButton {
    margin-top: 20px; } }

@media (max-width: 768px) {
  .editor-footer {
    position: static;
    bottom: -66px;
    z-index: 100; } }

.ph-block {
  position: absolute;
  border: 1px solid #fff;
  cursor: pointer;
  -webkit-box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15);
  box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15); }
  .ph-block .icon-nav {
    position: absolute;
    top: 50%; }
  .ph-block img {
    width: 100%; }
  .ph-block:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid rgba(0, 0, 0, 0.5); }
  .ph-block:after {
    -webkit-transition: all 1s;
    /* Safari 3.1 to 6.0 */
    transition: all 1s;
    background-color: rgba(20, 20, 20, 0.5);
    content: 'Edit';
    color: #FFF;
    line-height: 40px;
    text-align: center;
    height: 40px;
    bottom: 0;
    left: 0;
    width: 100%;
    position: absolute;
    opacity: 0; }
  .ph-block:hover {
    border-color: #4ab767; }
    .ph-block:hover:after {
      opacity: 1; }
  .ph-block .ph-name {
    position: absolute;
    left: 3px;
    top: 3px;
    z-index: 9999;
    line-height: 30px;
    color: #FFF;
    display: inline-block;
    padding: 0 10px;
    border-radius: 5px;
    font-weight: 600;
    background: rgba(50, 50, 50, 0.35);
    text-shadow: -1px -1px 0 #555, 1px -1px 0 #555, -1px 1px 0 #555, 1px 1px 0 #555; }
  .ph-block.edit-mode {
    -webkit-box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65);
    -moz-box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65);
    box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65); }
    .ph-block.edit-mode:after {
      opacity: 1;
      content: 'Editing'; }

.cm-s-twilight.CodeMirror {
  position: relative;
  height: 100%;
  padding-top: 50px; }

.CodeMirror-hscrollbar::-webkit-scrollbar {
  -webkit-appearance: none; }

.CodeMirror-hscrollbar::-webkit-scrollbar:horizontal {
  height: 11px; }

.CodeMirror-hscrollbar::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #555;
  /* should match background, can't be transparent */
  background-color: rgba(30, 30, 30, 0.8); }

.CodeMirror-hscrollbar::-webkit-scrollbar-track {
  background-color: #555;
  border-radius: 2px; }

.CodeMirror-vscrollbar::-webkit-scrollbar {
  -webkit-appearance: none; }

.CodeMirror-vscrollbar::-webkit-scrollbar:vertical {
  width: 11px; }

.CodeMirror-vscrollbar::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #555;
  /* should match background, can't be transparent */
  background-color: rgba(30, 30, 30, 0.8); }

.CodeMirror-vscrollbar::-webkit-scrollbar-track {
  background-color: #555;
  border-radius: 2px; }

.ph-transform .input-group .form-control {
  padding-left: 4px;
  padding-right: 4px; }

.ph-transform .input-group .input-group-addon {
  padding: 0 4px;
  font-size: 11px; }
  .ph-transform .input-group .input-group-addon:first-child {
    width: 50px; }
  .ph-transform .input-group .input-group-addon:last-child {
    font-size: 11px; }

.editor-footer {
  border-top: 1px solid #CCC;
  position: relative;
  background: #FFF; }
  .editor-footer .footer-content {
    padding: 8px 0; }
  @media (max-width: 768px) {
    .editor-footer {
      z-index: 100; }
      .editor-footer .footer-content .btn, .editor-footer .footer-content .icon-nav label, .icon-nav .editor-footer .footer-content label {
        padding: 5px; }
        .editor-footer .footer-content .btn .fa, .editor-footer .footer-content .icon-nav label .fa, .icon-nav .editor-footer .footer-content label .fa {
          margin-left: 2px; } }

.artboard-presentation {
  position: absolute;
  width: 80%; }
  .artboard-presentation .n-resize {
    position: absolute;
    top: -3px;
    left: 0px;
    width: 100%;
    height: 5px;
    cursor: n-resize; }
  .artboard-presentation .e-resize {
    position: absolute;
    top: 0px;
    left: calc(100% - 2px);
    width: 5px;
    height: 100%;
    cursor: w-resize; }
  .artboard-presentation .s-resize {
    position: absolute;
    top: calc(100% - 2px);
    left: 0px;
    width: 100%;
    height: 5px;
    cursor: s-resize; }
  .artboard-presentation .w-resize {
    position: absolute;
    top: 0px;
    left: -3px;
    width: 5px;
    height: 100%;
    cursor: e-resize; }
  .artboard-presentation .nw-resize {
    position: absolute;
    top: -3px;
    left: -3px;
    width: 7px;
    height: 7px;
    cursor: nw-resize; }
  .artboard-presentation .ne-resize {
    position: absolute;
    top: -3px;
    left: calc(100% - 4px);
    width: 7px;
    height: 7px;
    cursor: ne-resize; }
  .artboard-presentation .se-resize {
    position: absolute;
    top: calc(100% - 4px);
    left: calc(100% - 4px);
    width: 7px;
    height: 7px;
    cursor: se-resize; }
  .artboard-presentation .sw-resize {
    position: absolute;
    top: calc(100% - 4px);
    left: -3px;
    width: 7px;
    height: 7px;
    cursor: sw-resize; }

.html-editor {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 80;
  background: #FFF;
  height: 100%;
  width: 100%;
  padding-top: 0px; }
  .html-editor pre {
    border: 0;
    background: #222;
    color: #4ab767;
    margin: 0;
    padding-top: 60px;
    font-size: 14px;
    -webkit-text-stroke: 0.25px; }

.workspace-sidebar::-webkit-scrollbar,
.workspace-board::-webkit-scrollbar {
  -webkit-appearance: none; }

.workspace-sidebar::-webkit-scrollbar:vertical,
.workspace-board::-webkit-scrollbar:vertical {
  width: 11px; }

.workspace-sidebar::-webkit-scrollbar:horizontal,
.workspace-board::-webkit-scrollbar:horizontal {
  height: 11px; }

.workspace-sidebar::-webkit-scrollbar-thumb,
.workspace-board::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #f2f2f2;
  /* should match background, can't be transparent */
  background-color: rgba(50, 50, 50, 0.5); }

.workspace-sidebar::-webkit-scrollbar-track,
.workspace-board::-webkit-scrollbar-track {
  background-color: #e6e6e6;
  border-radius: 2px; }

#artboard {
  -webkit-box-shadow: 0 0 0 10000px #d4d4d4;
  -moz-box-shadow: 0 0 0 10000px #d4d4d4;
  box-shadow: 0 0 0 10000px #d4d4d4;
  border: 12px solid #d4d4d4;
  border-top-width: 60px; }

.active-banner {
  padding-bottom: 0 !important; }

.background-color-picker-input .dropdown-menu:before, .background-color-picker-input .dropdown-menu:after {
  width: 10px !important; }

.background-color-picker-input .close-colorpicker {
  display: none !important; }

.workspace-sidebar-content .image-placeholder {
  width: auto;
  height: 128px; }

.ph-item-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2); }
  .ph-item-icon:before {
    font-family: FontAwesome;
    content: '\\f009';
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.4);
    top: 50%;
    left: 50%;
    margin-left: -30px;
    margin-top: -30px;
    position: absolute;
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    color: rgba(255, 255, 255, 0.6); }
  .ph-item-icon.ph-video-item:before {
    content: '\\f03d'; }

/* Display Settings
   ========================================================================== */
/* Display Status Circle
   ========================================================================== */
/* Deprecate
 +   ==========================================================================
 +   ==========================================================================
 +   ==========================================================================
 +   ==========================================================================
 +   ========================================================================== */
.display-name span {
  max-width: 240px;
  display: inline-block;
  vertical-align: middle; }

.display-address span {
  max-width: 320px;
  display: inline-block;
  vertical-align: middle; }

.offline:before {
  color: #e74c3c; }

.notinstalled:before {
  color: #444; }

.online:before {
  color: #4ab767; }

/* ==========================================================================
   Store Navigation
   ========================================================================== */
.scrollfix {
  overflow-x: hidden;
  height: 100%; }

.navbar-store {
  padding-top: 0;
  padding-bottom: 0; }
  .navbar-store .rise-logo {
    margin-top: 5px; }
  .navbar-store .navbar-left,
  .navbar-store .navbar-right {
    margin-top: 6px; }

.inner-box {
  position: relative;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 5px;
  padding: 22px; }
  .inner-box.no-padding {
    padding: 0; }

body.in-rva-iframe {
  height: 100%;
  overflow-x: hidden; }
  body.in-rva-iframe .navbar-store .store-logo {
    width: 50px;
    margin-top: 2px;
    float: left; }
  body.in-rva-iframe .navbar-store h1 {
    margin-top: 7px;
    margin-left: 12px;
    margin-bottom: 5px;
    float: left;
    color: #333;
    font-size: 28px; }
  body.in-rva-iframe .navbar-store .close-iframe {
    margin: 3px 5px;
    cursor: pointer; }

.bottom-border {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc; }

.print-only {
  display: none; }

.navbar-right > li > a.shopping-cart-button {
  font-size: 24px;
  display: block;
  margin-left: 0; }
  .navbar-right > li > a.shopping-cart-button .fa-shopping-cart {
    line-height: 33px;
    display: block;
    padding: 0 10px; }

/* ==========================================================================
   Products
   ========================================================================== */
/* Search Products
   ========================================================================== */
.form-product-search {
  margin-bottom: 0; }

/* ==========================================================================
   Product Details, Order
   ========================================================================== */
.product-info,
.order-info,
.subscription-info {
  /* Display & Box Model */
  padding: 20px;
  border: solid 1px #ddd;
  /* Visual */
  background: #fff;
  border-radius: 5px;
  min-height: 400px;
  position: relative; }
  .product-info .info-row,
  .order-info .info-row,
  .subscription-info .info-row {
    margin-top: 20px; }
  .product-info h3.experimental,
  .product-info h3.inactive,
  .order-info h3.experimental,
  .order-info h3.inactive,
  .subscription-info h3.experimental,
  .subscription-info h3.inactive {
    color: red;
    margin-bottom: 0px;
    text-transform: uppercase; }
  .product-info .qty-message,
  .order-info .qty-message,
  .subscription-info .qty-message {
    font-style: italic; }
  .product-info .text-red,
  .order-info .text-red,
  .subscription-info .text-red {
    color: red; }

.product-header {
  margin-bottom: 10px; }

.product-vendor {
  font-weight: bold; }

.product-trial {
  color: #45b864; }

.product-expired {
  color: red; }

.price-disabled {
  color: #ccc; }

/* Quantity */
.product-qty li {
  display: inline-block;
  margin-right: 8px;
  line-height: 28px;
  vertical-align: top; }

/* Cart buttons */
.cart-buttons {
  margin-top: 20px; }

.cart-buttons .btn, .cart-buttons .icon-nav label, .icon-nav .cart-buttons label {
  margin: 5px 0;
  min-width: 160px; }

.order-cancel-success {
  font-weight: bold; }

.hr-dashed {
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 2px dashed #cbcbcb; }

/* Media queries
   ========================================================================== */
@media (min-width: 768px) {
  .product-info {
    padding: 40px; }
  .cart-buttons li {
    /* Positioning */
    float: left;
    /* Display & Box Model */
    margin-left: 3%; }
  .cart-buttons li:first-child {
    margin-left: 0; } }

/* ==========================================================================
   Product Details
   ========================================================================== */
.product-details .grid-container {
  max-width: 1004px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 10px;
  padding-left: 24px; }

.product-details .grid-container:after {
  display: table;
  clear: both;
  content: ''; }

.product-details h3 {
  margin: 22px 0 11px 0; }

.product-details .product-name {
  margin-top: 33px; }

.product-details .purchase-form__button button.btn-primary {
  width: 100%;
  margin-bottom: 5px; }

.product-details .purchase-form__button button.btn-default, .product-details .purchase-form__button .timeline .dropdown-menu li button.btn, .timeline .dropdown-menu li .product-details .purchase-form__button button.btn {
  width: 100%;
  margin-bottom: 5px; }

.product-details .purchase-form__button button.btn-link {
  font-size: 14px;
  width: 100%;
  margin-bottom: 5px; }

.product-details .purchase-form__button button i {
  margin-right: 5px; }

.product-details .t-heading.-size-xxl {
  font-size: 51px; }

.product-details .meta-attributes {
  color: #999; }

.product-details .meta-attributes tr td {
  font-size: 14px;
  padding-bottom: 15px;
  vertical-align: top; }

.product-details .meta-attributes tr:last-child td {
  padding-bottom: 0; }

.product-details .meta-attributes a {
  color: #2d60ad; }

.product-details .meta-attributes a:hover {
  color: #00719b; }

.product-details .meta-attributes__attr-name {
  font-weight: bold;
  padding-right: 10px;
  color: #444; }
  .product-details .meta-attributes__attr-name a {
    font-weight: normal; }

.product-details .meta-attributes__attr-tags {
  position: relative;
  display: table-cell;
  overflow: hidden;
  max-width: 185px;
  padding-right: 9px; }

.product-details .meta-attributes__attr-tags:before {
  position: absolute;
  z-index: 10;
  top: 1px;
  right: 0;
  width: 10%;
  height: 100%;
  content: '';
  background: -webkit-gradient(linear, left top, right top, from(rgba(251, 251, 251, 0)), color-stop(90%, rgba(251, 251, 251, 0.8)), to(#fbfbfb));
  background: -webkit-linear-gradient(left, rgba(251, 251, 251, 0), rgba(251, 251, 251, 0.8) 90%, #fbfbfb 100%);
  background: linear-gradient(to right, rgba(251, 251, 251, 0), rgba(251, 251, 251, 0.8) 90%, #fbfbfb 100%); }

.product-details .ie9 .meta-attributes__attr-tags {
  white-space: normal; }

.product-details .box {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e1e8ed;
  background-color: #fbfbfb; }
  .product-details .box.no-outline {
    border: 0; }

.product-details .t-body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.product-details .t-price {
  font-weight: bold;
  line-height: 1;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.product-details .t-price::first-letter {
  font-size: .7em;
  font-weight: normal;
  line-height: 1.25em;
  margin-right: .05em;
  vertical-align: top; }

@-moz-document url-prefix() {
  .product-details .t-price::first-letter {
    float: left; } }

.product-details .t-currency {
  font-size: 12px;
  position: relative;
  top: -27px;
  left: -8px; }

.product-details .t-unit {
  font-size: 14px;
  color: #333; }

@media screen and (max-width: 660px) {
  .product-details .mobile-filters {
    position: relative;
    top: 20px; }
    .product-details .mobile-filters button i {
      margin-right: 5px; } }

.owl-item a img {
  width: 94% !important;
  height: 332px !important; }

/*
 *  Core Owl Carousel CSS File
 *  v1.3.3
 */
.owl-carousel {
  position: relative;
  display: none;
  width: 100%; }
  .owl-carousel .owl-wrapper {
    position: relative;
    display: none; }
    .owl-carousel .owl-wrapper:after {
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
      height: 0;
      content: '.'; }
  .owl-carousel .owl-wrapper-outer {
    position: relative;
    overflow: hidden;
    width: 94%; }
    .owl-carousel .owl-wrapper-outer.autoHeight {
      transition: height 500ms ease-in-out; }
  .owl-carousel .owl-item {
    float: left; }

.owl-controls {
  user-select: none; }
  .owl-controls .owl-page {
    cursor: pointer; }
  .owl-controls .owl-buttons div {
    cursor: pointer; }

/* fix */
.owl-carousel .owl-wrapper,
.owl-carousel .owl-item {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden; }

/*
*   Owl Theming
*/
.wrapper-with-margin {
  margin: 0 50px; }

.owl-theme .owl-controls {
  margin-top: 10px;
  text-align: center; }
  .owl-theme .owl-controls .owl-buttons div {
    font-size: 27px;
    font-weight: bold;
    position: absolute;
    display: inline-block;
    zoom: 1;
    margin: -2px;
    padding: 41px 8px 50px 7px;
    transition: .5s;
    opacity: .3;
    border: 1px solid #f4f4f4;
    border-radius: 3px;
    filter: Alpha(Opacity=30); }
    .owl-theme .owl-controls .owl-buttons div .fa::before {
      opacity: .6;
      color: black;
      filter: Alpha(Opacity=60); }
    .owl-theme .owl-controls .owl-buttons div:hover {
      opacity: .6;
      border: 1px solid #4ab767;
      filter: Alpha(Opacity=60); }
  .owl-theme .owl-controls .owl-buttons .owl-prev {
    top: 111px;
    left: -37px; }
  .owl-theme .owl-controls .owl-buttons .owl-next {
    top: 111px;
    right: 0; }
  .owl-theme .owl-controls.clickable .owl-buttons div:hover {
    text-decoration: none;
    opacity: 1;
    filter: Alpha(Opacity=100); }
  .owl-theme .owl-controls.clickable .owl-page:hover span {
    opacity: 1;
    filter: Alpha(Opacity=100); }
  .owl-theme .owl-controls .owl-page {
    display: inline-block;
    zoom: 1;
    *display: inline; }
    .owl-theme .owl-controls .owl-page span {
      display: block;
      width: 12px;
      height: 12px;
      margin: 5px 7px;
      opacity: .5;
      border-radius: 20px;
      background: #869791;
      filter: Alpha(Opacity=50); }
      .owl-theme .owl-controls .owl-page span.owl-numbers {
        font-size: 12px;
        width: auto;
        height: auto;
        padding: 2px 10px;
        color: white;
        border-radius: 30px; }
    .owl-theme .owl-controls .owl-page.active span {
      opacity: 1;
      filter: Alpha(Opacity=100); }

.owl-item.loading {
  min-height: 150px;
  background: url(AjaxLoader.gif) no-repeat center center; }

#product-slideshow .owl-item {
  height: 332px !important; }
  #product-slideshow .owl-item > div {
    font-size: 32px;
    margin: 3px;
    padding: 50px 0;
    text-align: center;
    color: white;
    border: 1px white;
    background: #42bdc2; }
    #product-slideshow .owl-item > div img {
      display: block;
      width: 100%;
      height: auto;
      margin-bottom: 4px;
      border-radius: 3px; }

@media only screen and (max-width: 624px) {
  .owl-theme .owl-controls .owl-buttons .owl-next {
    right: -13px; } }

/*
* Magnific Popup CSS
*/
button.mfp-close, button.mfp-arrow {
  z-index: 1046;
  display: block;
  overflow: visible;
  padding: 0;
  cursor: pointer;
  border: 0;
  outline: none;
  background: transparent;
  box-shadow: none; }

.mfp-image-holder .mfp-close, .mfp-iframe-holder .mfp-close {
  right: -6px;
  width: 100%;
  padding-right: 6px;
  text-align: right;
  color: white; }

.mfp-arrow:before, .mfp-arrow:after, .mfp-arrow .mfp-b, .mfp-arrow .mfp-a {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0;
  height: 0;
  margin-top: 35px;
  margin-left: 35px;
  content: '';
  border: medium inset transparent; }

.mfp-arrow:after, .mfp-arrow .mfp-a {
  top: 8px;
  border-top-width: 13px;
  border-bottom-width: 13px; }

.mfp-arrow:before, .mfp-arrow .mfp-b {
  opacity: .7;
  border-top-width: 21px;
  border-bottom-width: 21px; }

.mfp-bg {
  position: fixed;
  z-index: 1042;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  opacity: .8;
  background: #0b0b0b;
  filter: alpha(opacity=80); }

.mfp-wrap {
  position: fixed;
  z-index: 1043;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none !important; }

.mfp-container {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 8px;
  text-align: center; }
  .mfp-container:before {
    display: inline-block;
    height: 100%;
    content: '';
    vertical-align: middle; }

.mfp-content {
  position: relative;
  z-index: 1045;
  display: inline-block;
  margin: 0 auto;
  text-align: left;
  vertical-align: middle; }

.mfp-ajax-cur {
  cursor: progress; }

.mfp-zoom-out-cur {
  cursor: zoom-out; }
  .mfp-zoom-out-cur .mfp-image-holder .mfp-close {
    cursor: zoom-out; }

.mfp-zoom {
  cursor: pointer;
  cursor: zoom-in; }

.mfp-close {
  font-family: Arial, Baskerville, monospace;
  font-size: 28px;
  font-style: normal;
  line-height: 44px;
  position: absolute;
  top: 0;
  right: 0;
  width: 44px;
  height: 44px;
  padding: 0 0 18px 10px;
  user-select: none;
  text-align: center;
  text-decoration: none;
  opacity: .65;
  color: white;
  filter: alpha(opacity=65); }
  .mfp-close:hover {
    opacity: 1;
    filter: alpha(opacity=100); }
  .mfp-close:focus {
    opacity: 1;
    filter: alpha(opacity=100); }
  .mfp-close:active {
    top: 1px; }

.mfp-arrow {
  user-select: none;
  position: absolute;
  opacity: 0.65;
  filter: alpha(opacity=65);
  margin: 0;
  top: 50%;
  margin-top: -55px;
  padding: 0;
  width: 90px;
  height: 110px; }
  .mfp-arrow:active {
    margin-top: -54px; }
  .mfp-arrow:hover {
    opacity: 1;
    filter: alpha(opacity=100); }
  .mfp-arrow:focus {
    opacity: 1;
    filter: alpha(opacity=100); }

.mfp-preloader {
  user-select: none;
  color: #ccc;
  position: absolute;
  top: 50%;
  width: auto;
  text-align: center;
  margin-top: -0.8em;
  left: 8px;
  right: 8px;
  z-index: 1044; }
  .mfp-preloader a {
    color: #ccc; }
    .mfp-preloader a:hover {
      color: white; }

.mfp-counter {
  user-select: none;
  position: absolute;
  top: 0;
  right: 0;
  color: #ccc;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap; }

.mfp-hide {
  display: none !important; }

button::-moz-focus-inner {
  padding: 0;
  border: 0; }

.mfp-image-holder .mfp-content {
  max-width: 100%; }

.mfp-iframe-holder {
  padding-top: 40px;
  padding-bottom: 40px; }
  .mfp-iframe-holder .mfp-close {
    top: -40px; }
  .mfp-iframe-holder .mfp-content {
    line-height: 0;
    width: 100%;
    max-width: 900px; }

.mfp-arrow-left {
  left: 0; }
  .mfp-arrow-left:after {
    border-right: 17px solid white;
    margin-left: 31px; }
  .mfp-arrow-left .mfp-a {
    border-right: 17px solid white;
    margin-left: 31px; }
  .mfp-arrow-left:before {
    margin-left: 25px;
    border-right: 27px solid #3f3f3f; }
  .mfp-arrow-left .mfp-b {
    margin-left: 25px;
    border-right: 27px solid #3f3f3f; }

.mfp-arrow-right {
  right: 0; }
  .mfp-arrow-right:after {
    border-left: 17px solid white;
    margin-left: 39px; }
  .mfp-arrow-right .mfp-a {
    border-left: 17px solid white;
    margin-left: 39px; }
  .mfp-arrow-right:before {
    border-left: 27px solid #3f3f3f; }
  .mfp-arrow-right .mfp-b {
    border-left: 27px solid #3f3f3f; }

.mfp-iframe-scaler {
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%; }
  .mfp-iframe-scaler iframe {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: black; }

.mfp-figure {
  line-height: 0; }
  .mfp-figure:after {
    content: '';
    position: absolute;
    left: 0;
    top: 40px;
    bottom: 40px;
    display: block;
    right: 0;
    width: auto;
    height: auto;
    z-index: -1;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #444; }
  .mfp-figure small {
    color: #bdbdbd;
    display: block;
    font-size: 12px;
    line-height: 14px; }
  .mfp-figure figure {
    margin: 0; }

.mfp-bottom-bar {
  margin-top: -36px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  cursor: auto; }

.mfp-title {
  text-align: left;
  line-height: 18px;
  color: #f3f3f3;
  word-wrap: break-word;
  padding-right: 36px; }

@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {
  .mfp-img-mobile .mfp-image-holder {
    padding-left: 0;
    padding-right: 0; }
  .mfp-img-mobile .mfp-figure:after {
    top: 0;
    bottom: 0; }
  .mfp-img-mobile .mfp-figure small {
    display: inline;
    margin-left: 5px; }
  .mfp-img-mobile .mfp-bottom-bar {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    margin: 0;
    top: auto;
    padding: 3px 5px;
    position: fixed;
    box-sizing: border-box; }
    .mfp-img-mobile .mfp-bottom-bar:empty {
      padding: 0; }
  .mfp-img-mobile .mfp-counter {
    right: 5px;
    top: 3px; }
  .mfp-img-mobile .mfp-close {
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    text-align: center;
    padding: 0; }
  .mfp-img-mobile img.mfp-img {
    padding: 0; } }

@media all and (max-width: 900px) {
  .mfp-arrow {
    transform: scale(0.75); }
  .mfp-arrow-left {
    transform-origin: 0; }
  .mfp-arrow-right {
    transform-origin: 100%; }
  .mfp-container {
    padding-left: 6px;
    padding-right: 6px; } }

.mfp-ie7 .mfp-img {
  padding: 0; }

.mfp-ie7 .mfp-bottom-bar {
  width: 600px;
  left: 50%;
  margin-left: -300px;
  margin-top: 5px;
  padding-bottom: 5px; }

.mfp-ie7 .mfp-container {
  padding: 0; }

.mfp-ie7 .mfp-content {
  padding-top: 44px; }

.mfp-ie7 .mfp-close {
  top: 0;
  right: 0;
  padding-top: 0; }

.mfp-align-top .mfp-container:before {
  display: none; }

.mfp-inline-holder .mfp-content {
  width: 100%;
  cursor: auto; }

.mfp-ajax-holder .mfp-content {
  width: 100%;
  cursor: auto; }

.mfp-auto-cursor .mfp-content {
  cursor: auto; }

.mfp-loading.mfp-figure {
  display: none; }

.mfp-s-ready .mfp-preloader {
  display: none; }

.mfp-s-error .mfp-content {
  display: none; }

.mfp-close-btn-in .mfp-close {
  color: white; }

img.mfp-img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  box-sizing: border-box;
  padding: 40px 0;
  margin: 0 auto; }

.mfp-gallery .mfp-image-holder .mfp-figure {
  cursor: pointer; }

/*CUSTOM*/
a.mfp-iframe:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 94%;
  height: 100%;
  content: '';
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, 0.2) url(../img/play.svg) no-repeat 54% center;
  background-size: 40%; }

a.mfp-iframe:hover:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 94%;
  height: 100%;
  content: '';
  cursor: pointer;
  -webkit-animation: zoomIn .4s;
  -moz-animation: zoomIn .4s;
  -ms-animation: zoomIn .4s;
  -o-animation: zoomIn .4s;
  animation: zoomIn .4s;
  color: #fff;
  background: rgba(0, 0, 0, 0.2) url(../img/play.svg) no-repeat 54% center;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards; }

@-webkit-keyframes zoomIn {
  from {
    background-size: 40%; }
  to {
    background-size: 60%; } }

@-moz-keyframes zoomIn {
  from {
    background-size: 40%; }
  to {
    background-size: 60%; } }

@-ms-keyframes zoomIn {
  from {
    background-size: 40%; }
  to {
    background-size: 60%; } }

@-o-keyframes zoomIn {
  from {
    background-size: 40%; }
  to {
    background-size: 60%; } }

@keyframes zoomIn {
  from {
    background-size: 40%; }
  to {
    background-size: 60%; } }

/* NailThumb Plugin
 *
 */
.nailthumb-container {
  width: auto;
  height: auto;
  margin: 0 0 11px;
  padding: 0px;
  overflow: hidden;
  position: relative;
  text-align: left; }

.nailthumb-container img.nailthumb-image {
  margin: 0px;
  padding: 0px;
  max-width: none;
  text-align: left;
  float: left; }

.nailthumb-container span.nailthumb-title {
  background: none repeat scroll 0 0 rgba(0, 0, 0, 0.5);
  bottom: 0;
  color: White;
  display: block;
  font-size: 9px;
  height: 20px;
  left: 0;
  margin-top: 2px;
  line-height: 20px;
  position: relative;
  text-align: center;
  width: 100%;
  overflow: hidden;
  float: left; }

.nailthumb-container span.nailthumb-title .nailthumb-title-scroller {
  padding-left: 2px; }

.nailthumb-container img {
  max-width: none;
  text-align: left; }

@media only screen and (max-width: 992px) {
  .nailthumb-image {
    width: 670px !important; } }

@media only screen and (max-width: 768px) {
  .nailthumb-image {
    width: 621px !important;
    height: 416px !important; } }

@media only screen and (max-width: 468px) {
  .nailthumb-image {
    width: 294px !important;
    height: 343px !important; } }

/* ==========================================================================
   Shopping Cart
   ========================================================================== */
/* Bill To & Ship To
   ========================================================================== */
.shopping-cart .bill-to,
.shopping-cart .ship-to {
  margin-top: 6px;
  margin-bottom: 0; }

.shopping-cart .cart-empty,
.shopping-cart .payment-confirmed {
  margin-top: 6px; }

.shopping-cart .cart-empty-content,
.shopping-cart .payment-confirmed-content {
  border-top: 1px solid #CCCCCC;
  padding: 20px 0px 10px 0px; }

.shopping-cart .address-icons {
  margin-bottom: 0;
  margin-top: 4px; }
  .shopping-cart .address-icons li {
    /* Positioning */
    float: left;
    /* Display & Box Model */
    margin-left: 5px;
    margin-top: 1px; }
    .shopping-cart .address-icons li span {
      position: relative;
      top: -3px;
      margin: 0px 10px; }

.shopping-cart .address {
  padding: 10px 17px;
  border-top: 1px solid #cbcbcb;
  margin-top: 5px;
  margin-bottom: 3px; }

.shopping-cart .row.title, .shopping-cart .support-app .ticket-list-table .title.title-row, .support-app .ticket-list-table .shopping-cart .title.title-row, .shopping-cart .support-app .ticket-list-table .title.ticket, .support-app .ticket-list-table .shopping-cart .title.ticket {
  padding: 0 17px; }

.shopping-cart .title {
  margin-top: 0;
  margin-bottom: 0; }

.shopping-cart .terms {
  font-size: 90%; }

.shopping-cart .alert, .shopping-cart .support-app .support-time, .support-app .shopping-cart .support-time {
  margin: 0;
  padding: 10px 17px;
  border-radius: 0;
  cursor: pointer; }

.shopping-cart .alert.ship-to-restriction, .shopping-cart .support-app .ship-to-restriction.support-time, .support-app .shopping-cart .ship-to-restriction.support-time {
  margin-top: 0px; }
  .shopping-cart .alert.ship-to-restriction h5, .shopping-cart .support-app .ship-to-restriction.support-time h5, .support-app .shopping-cart .ship-to-restriction.support-time h5 {
    margin-top: 0; }

.shopping-cart .subscriptions .btn, .shopping-cart .subscriptions .icon-nav label, .icon-nav .shopping-cart .subscriptions label,
.shopping-cart .purchases .buttons .btn,
.shopping-cart .purchases .buttons .icon-nav label, .icon-nav
.shopping-cart .purchases .buttons label {
  width: 204px;
  margin-top: 4px; }

/* Purchases
   ========================================================================== */
.product-qty {
  margin-bottom: 0; }

.subtotals {
  margin-bottom: 0; }
  .subtotals tbody tr td {
    text-align: right; }

.order-total {
  /* Display & Box Model */
  display: block;
  /* Visual */
  font-size: 18px;
  font-weight: bold;
  line-height: 35px;
  text-align: right; }

.order-currency {
  /* Display & Box Model */
  display: block;
  /* Visual */
  font-size: 14px;
  text-align: right; }

/* ==========================================================================
   Account
   ========================================================================== */
.account .title {
  margin-top: 6px;
  margin-bottom: 0; }

.account .date {
  /* Display & Box Model */
  margin-top: 6px;
  /* Visual */
  font-size: 16px;
  font-style: italic; }

/* ==========================================================================
   Subscription Confirmation & Purchase Invoice
   ========================================================================== */
.subscription-confirmation .header,
.purchase-invoice .header {
  margin-bottom: 20px; }

.subscription-confirmation .header-details,
.purchase-invoice .header-details {
  margin-top: 20px;
  text-align: right; }

.subscription-confirmation .title,
.purchase-invoice .title {
  font-weight: bold;
  font-size: 18px; }

.subscription-confirmation .bill-to,
.subscription-confirmation .ship-to,
.purchase-invoice .bill-to,
.purchase-invoice .ship-to {
  /* Display & Box Model */
  margin-top: 20px;
  /* Visual */
  font-weight: bold; }

.subscription-confirmation .company-address,
.purchase-invoice .company-address {
  text-align: center;
  font-style: italic;
  font-size: 85%; }

.purchase-invoice .paid,
.purchase-invoice .overdue,
.purchase-invoice .status,
.purchase-invoice .total {
  font-size: 18px;
  font-weight: bold; }

.purchase-invoice .paid {
  color: #4ab767; }

.purchase-invoice .overdue {
  color: red; }

.purchase-invoice .display-name {
  padding-left: 10px;
  font-style: italic; }

.purchase-invoice .product-name {
  padding-left: 25px; }

.purchase-invoice table.invoice-due-summary {
  width: 100%;
  text-align: right; }
  .purchase-invoice table.invoice-due-summary td {
    width: 50%; }
  .purchase-invoice table.invoice-due-summary .currency-code {
    text-transform: uppercase; }
  .purchase-invoice table.invoice-due-summary .paid-with-label,
  .purchase-invoice table.invoice-due-summary .paid-with,
  .purchase-invoice table.invoice-due-summary .currency-code-label,
  .purchase-invoice table.invoice-due-summary .currency-code {
    font-style: italic; }

/* Media queries
   ========================================================================== */
@media (min-width: 768px) {
  .subscription-confirmation,
  .purchase-invoice {
    padding-left: 100px;
    padding-right: 100px; }
    .subscription-confirmation .header-details,
    .purchase-invoice .header-details {
      /* Display & Box Model */
      margin-top: 0; } }

/* ==========================================================================
   Address Editor Modal
   ========================================================================== */
.address-editor div.checkbox.persist-changes {
  float: left; }

.address-editor td.addr-label {
  max-width: 33%;
  text-align: right;
  padding-left: 10px; }

.address-editor td.addr-value {
  padding-left: 10px;
  font-weight: bold; }

.address-editor p.validation-notice {
  font-size: 13px;
  color: #094F76;
  line-height: 14px; }

.address-editor .alert-info .form-group {
  margin-bottom: 0; }

.address-editor .alert-info + .row, .address-editor .support-app .ticket-list-table .alert-info + .title-row, .support-app .ticket-list-table .address-editor .alert-info + .title-row, .address-editor .support-app .ticket-list-table .alert-info + .ticket, .support-app .ticket-list-table .address-editor .alert-info + .ticket {
  margin-right: 5px; }

/* ==========================================================================
   Custom Classes
   ========================================================================== */
.payment-modal-form {
  min-height: 400px; }

.clear-both {
  clear: both; }

.checkbox.checkbox-label-left input[type=checkbox] {
  position: relative;
  margin-left: 0; }

.checkbox.checkbox-label-left label {
  padding-left: 0; }

.required-asterisk {
  color: red; }

.btn.btn-form-control, .icon-nav label.btn-form-control {
  width: 100%;
  border-radius: 4px; }
  .btn.btn-form-control span, .icon-nav label.btn-form-control span {
    float: left; }
  .btn.btn-form-control span.caret, .icon-nav label.btn-form-control span.caret {
    float: right;
    margin-top: 8px; }

.drop-down-menu-full-width {
  width: 100%; }
  .drop-down-menu-full-width li {
    text-align: left; }

.no-js-backdrop {
  background-color: #FFFFFF;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100000;
  position: absolute; }
  .no-js-backdrop .no-js-message {
    margin: 20px 0; }

.pointer {
  cursor: pointer; }

.page-banner {
  margin-bottom: 0px; }

.alert-default {
  background-color: #f4f4f4;
  border: 1px solid #CCC; }

.img-preloader {
  width: 94% !important;
  height: 332px !important;
  background-color: #DDD;
  background: url("../img/loader.gif") no-repeat center center; }

.item-description {
  margin-top: 22px; }

.store-icon,
.icon-medium {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 10px;
  background: #555; }
  .store-icon img,
  .icon-medium img {
    width: 100%; }

.checkout-icon {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 10px;
  float: left; }
  .checkout-icon img {
    width: 100%; }

.store-block {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 15px;
  margin: 0 -15px 20px; }
  .store-block .store-icon {
    float: left;
    margin-right: 10px; }
  .store-block .description {
    margin-top: 5px; }
    .store-block .description p {
      margin: 0;
      line-height: 20px;
      display: block; }
      @media (max-width: 768px) {
        .store-block .description p {
          text-overflow: ellipsis;
          width: 180px;
          overflow: hidden; } }

.modal-header .store-block {
  margin: 0 0 10px;
  border-bottom: 0;
  height: 40px; }
  .modal-header .store-block .store-icon {
    height: 40px;
    width: 40px; }
  .modal-header .store-block .description {
    margin: 0; }
    @media (max-width: 480px) {
      .modal-header .store-block .description p {
        text-overflow: ellipsis;
        width: 100px;
        white-space: nowrap;
        overflow: hidden; } }

.tax-notice {
  font-size: 11px; }

.table-2 .store-block {
  margin-top: 0;
  border: none; }
  .table-2 .store-block .store-icon {
    width: 40px;
    height: 40px; }

.text-green {
  color: #4AB767; }

.text-error {
  color: #cf371f; }

.help-links {
  line-height: 20px; }
  .help-links span,
  .help-links a {
    display: inline-block; }
  @media (max-width: 768px) {
    .help-links {
      display: block;
      float: none !important;
      width: 100%;
      text-align: left;
      line-height: normal;
      margin-bottom: 10px; } }

.cards-wrap {
  display: table;
  width: 100%;
  border-collapse: separate; }
  .cards-wrap .card {
    vertical-align: top;
    display: table-cell;
    width: 50%; }
    .cards-wrap .card.card-price {
      width: 31%; }
  .cards-wrap .divider {
    width: 1%;
    display: table-cell; }
  @media (max-width: 768px) {
    .cards-wrap {
      display: block; }
      .cards-wrap .card {
        display: block;
        width: auto; }
        .cards-wrap .card.card-price {
          width: auto; }
      .cards-wrap .divider {
        display: none; } }

.card {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.23); }
  .card .card-body {
    padding: 15px; }
  .card .card-footer {
    padding: 0 15px 15px; }

.card-price h3 {
  margin: 0 0 10px;
  font-weight: 500; }

.card-price p {
  color: #777; }

.callout {
  padding: 15px;
  border-radius: 3px;
  width: 100%;
  z-index: 8000;
  position: absolute;
  left: 0;
  color: #444;
  opacity: .9;
  -webkit-box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75); }
  .callout.callout-green {
    background: #e3f7e8;
    border: 1px solid #47b767; }
    .callout.callout-green .arrow:before {
      border-bottom: 10px solid #e3f7e8; }
    .callout.callout-green .arrow:after {
      border-bottom: 12px solid #47b767; }
  .callout.callout-red {
    background: #ffece8;
    border: 1px solid red; }
    .callout.callout-red .arrow:before {
      border-bottom: 10px solid #ffece8; }
    .callout.callout-red .arrow:after {
      border-bottom: 12px solid #cf371f; }
  .callout .arrow {
    width: 40px;
    position: absolute;
    display: block;
    top: 0; }
  .callout .arrow:before {
    position: absolute;
    top: -10px;
    right: 10px;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    z-index: 2; }
  .callout .arrow:after {
    position: absolute;
    top: -12px;
    right: 8px;
    content: '';
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    z-index: 1; }

.callout-green {
  color: #47b767;
  font-weight: bold;
  max-width: 280px;
  text-align: center;
  font-size: 24px;
  right: 0;
  left: auto; }

.checkout-logos {
  height: 75px;
  text-align: left; }
  .checkout-logos .stripe img {
    height: 26px;
    margin-top: 3px; }
  .checkout-logos .seals img {
    height: 70px; }
  @media (max-width: 320px) {
    .checkout-logos .seals img {
      height: 50px; }
    .checkout-logos .stripe img {
      height: 18px; } }

.table-checkout tbody > tr > td {
  margin-right: 0; }
  .table-checkout tbody > tr > td.checkout-detail {
    font-weight: bold; }
  .table-checkout tbody > tr > td.checkout-item {
    color: #555; }
  .table-checkout tbody > tr > td.checkout-qty input {
    width: 33px;
    padding: 0;
    text-align: center;
    display: inline-block; }
  .table-checkout tbody > tr > td.checkout-qty button {
    padding: 0;
    font-size: 12px; }
  .table-checkout tbody > tr > td.checkout-coupon label {
    padding-right: 10px; }
  .table-checkout tbody > tr > td.checkout-coupon .form-group {
    margin: 0; }
  .table-checkout tbody > tr > td.checkout-coupon input {
    width: 165px;
    display: inline-block; }
  .table-checkout tbody > tr > td.checkout-coupon button {
    width: 70px; }
  .table-checkout tbody > tr > td .control-label {
    color: #777; }

@media (max-width: 768px) {
  .table-checkout tbody tr > td {
    font-size: 13px; }
    .table-checkout tbody tr > td:before {
      content: attr(data-td) " ";
      font-weight: bold; }
    .table-checkout tbody tr > td.checkout-item {
      width: 70%; }
      .table-checkout tbody tr > td.checkout-item p {
        width: 120px;
        overflow: hidden;
        white-space: nowrap; }
    .table-checkout tbody tr > td.checkout-qty {
      width: 30%;
      text-align: right;
      padding-left: 0; }
    .table-checkout tbody tr > td.checkout-total {
      text-align: right;
      width: 30%;
      float: right; }
    .table-checkout tbody tr > td.checkout-value {
      text-align: right;
      width: 30%; }
    .table-checkout tbody tr > td.checkout-detail {
      text-align: right;
      width: 70%;
      font-weight: bold; }
    .table-checkout tbody tr > td.checkout-plan {
      width: 50%;
      text-align: right; }
    .table-checkout tbody tr > td.checkout-price {
      width: 20%; }
    .table-checkout tbody tr > td.checkout-coupon {
      display: block; }
      .table-checkout tbody tr > td.checkout-coupon .form-group {
        margin-bottom: 5px; }
      .table-checkout tbody tr > td.checkout-coupon input {
        display: inline-block;
        float: left;
        width: 70%; }
      .table-checkout tbody tr > td.checkout-coupon button {
        display: inline-block; }
      .table-checkout tbody tr > td.checkout-coupon label {
        display: block;
        margin: 0;
        text-align: left; } }
  @media (max-width: 768px) and (max-width: 320px) {
    .table-checkout tbody tr > td.checkout-item {
      width: 80%;
      padding-right: 0; }
      .table-checkout tbody tr > td.checkout-item p {
        width: 100px;
        overflow: hidden;
        white-space: nowrap; }
    .table-checkout tbody tr > td.checkout-qty {
      width: 20%; }
      .table-checkout tbody tr > td.checkout-qty button {
        width: 32px; }
    .table-checkout tbody tr > td.checkout-coupon button {
      width: 60px; } }

.product-graphic {
  width: 96px;
  height: 96px;
  margin: 30px auto 0; }

.product-intro {
  text-align: center;
  max-width: 600px;
  margin: 30px auto 30px; }
  .product-intro h1 {
    font-weight: 500;
    margin-bottom: 15px; }
  .product-intro strong {
    font-weight: 500; }
  .product-intro .lead, .product-intro .post h2 + p, .post .product-intro h2 + p {
    font-size: 18px;
    margin-bottom: 8px; }
  .product-intro .text-muted {
    margin-top: 30px; }
  .product-intro .btn, .product-intro .icon-nav label, .icon-nav .product-intro label {
    margin-top: 30px; }

.storage-modal .product-graphic {
  width: 54px;
  height: 54px;
  margin: 0 auto; }

.storage-modal .product-intro {
  margin: 0 auto; }

.storage-modal .text-muted {
  margin-top: 5px; }

.modal-dialog {
  max-width: 1140px;
  margin: 10px auto; }

.modal-content {
  margin: 0 10px; }

.table-2 .store-block {
  margin-bottom: 0; }

.table-2 .description {
  margin-top: 0; }

.total-row {
  padding: 10px;
  border-bottom: 1px solid #e6e6e6;
  text-align: right; }
  .total-row.rowEnter {
    padding: 0 10px;
    opacity: 0;
    height: 0;
    background: #cf371f; }
  .total-row .total {
    width: 200px;
    margin-right: 10px;
    display: inline-block; }
  .total-row .total-value {
    display: inline-block;
    width: 100px; }

.couponEntry {
  margin: 0 10px; }
  .couponEntry .alert, .couponEntry .support-app .support-time, .support-app .couponEntry .support-time {
    margin-bottom: 10px;
    padding: 5px 15px;
    text-align: center; }
    .couponEntry .alert span, .couponEntry .support-app .support-time span, .support-app .couponEntry .support-time span {
      display: inline; }
  .couponEntry input {
    display: inline-block;
    width: 150px; }

.couponStart .col-md-12 {
  text-align: right; }

.page-header.blog-header {
  padding-top: 48px; }

.article {
  margin-bottom: 48px; }
  .article .headline {
    margin-top: 16px;
    margin-bottom: 8px; }
    .article .headline a {
      color: #4d4d4d; }
  .article .metadata {
    margin-bottom: 32px; }
  .article .read-time {
    float: right; }
  .article .article-label {
    margin-top: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    background-color: #5cbe76;
    color: #FFF;
    padding: 0 10px;
    display: inline-block; }
  .article .article-content p {
    line-height: 1.9; }
  .article .article-content img {
    max-width: 100%;
    height: auto;
    margin: 32px 0; }
  .article .image {
    max-height: 300px;
    border-radius: 6px 6px 6px 0;
    margin-top: 16px;
    overflow: hidden; }
    .article .image img {
      width: 100%; }
  .article .comment-count {
    display: block;
    line-height: 34px; }
  .article .blog-footer {
    overflow: hidden;
    margin-top: 32px; }
  .article .blog-icons {
    border: 1px solid #CCC;
    display: block;
    border-radius: 20px;
    padding: 0 10px; }
    .article .blog-icons .btn, .article .blog-icons .icon-nav label, .icon-nav .article .blog-icons label {
      font-size: 16px;
      padding: 4px;
      opacity: 0.7; }
      .article .blog-icons .btn:hover, .article .blog-icons .icon-nav label:hover, .icon-nav .article .blog-icons label:hover {
        opacity: 1; }
      .article .blog-icons .btn span, .article .blog-icons .icon-nav label span, .icon-nav .article .blog-icons label span {
        margin: 0 10px; }
      .article .blog-icons .btn .fa, .article .blog-icons .icon-nav label .fa, .icon-nav .article .blog-icons label .fa {
        width: 20px; }
  .article .tags li {
    display: inline-block;
    vertical-align: top; }
    .article .tags li a {
      color: #555;
      background-color: #e6e6e6;
      padding: 2px 8px;
      font-size: 13px;
      border-radius: 10px; }

.blog-sidebar {
  -webkit-transition: all 0.1s;
  /* Safari 3.1 to 6.0 */
  transition: all 0.1s; }
  .blog-sidebar .content-box, .blog-sidebar .select-subcompany-modal .list-group, .select-subcompany-modal .blog-sidebar .list-group, .blog-sidebar .content-box-editable, .blog-sidebar .card, .blog-sidebar #appLauncherContainer .scrollable-list, #appLauncherContainer .blog-sidebar .scrollable-list, .blog-sidebar #appLauncherContainer .template-grid, #appLauncherContainer .blog-sidebar .template-grid {
    padding: 32px; }

.subscribed-thanks {
  font-weight: 600;
  -webkit-animation-delay: .75s;
  animation-delay: .75s; }

.header-search {
  max-width: 200px; }

.playlist-item-reference {
  max-width: 320px;
  line-height: 24px; }

#appLauncherContainer h3 {
  margin-top: 0;
  line-height: 30px;
  display: block; }
  #appLauncherContainer h3 a {
    color: #444; }
    #appLauncherContainer h3 a:hover {
      color: #0081BA; }

#appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {
  padding: 0;
  height: auto; }

#appLauncherContainer .list {
  height: calc(100vh - 290px);
  margin-top: 1px; }
  #appLauncherContainer .list.help-active {
    height: calc(100vh - 977px); }
  @media (max-width: 768px) {
    #appLauncherContainer .list {
      height: auto; } }
  #appLauncherContainer .list .list-item {
    border-bottom: 1px solid #f2f2f2;
    padding: 4px 12px; }
    #appLauncherContainer .list .list-item h4 {
      font-weight: 500;
      font-size: 14px;
      color: #555;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 260px; }
      @media (max-width: 992px) {
        #appLauncherContainer .list .list-item h4 {
          width: 180px; } }
    #appLauncherContainer .list .list-item:last-child {
      border-bottom: none; }
    #appLauncherContainer .list .list-item:hover h4 {
      color: #0081BA; }

.launcher-background {
  position: absolute;
  z-index: 40;
  top: 0;
  left: 0;
  background: #FFF;
  border-bottom: 1px solid #e4e4e4;
  height: 400px;
  width: 100%;
  background-size: cover; }

.video-box {
  border: 1px solid #e6e6e6;
  background: #FFF;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.13); }
  .video-box > img:first-child {
    width: 100%; }

.create-presentation-cta {
  position: relative;
  z-index: 100;
  margin-top: 48px;
  margin-bottom: 40px;
  padding: 76px 40px;
  background: #FFF;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.13); }
  .create-presentation-cta h1 {
    font-size: 42px;
    margin-top: 0; }
  .create-presentation-cta h3 {
    font-weight: 300;
    margin-bottom: 16px 0 32px; }
    .create-presentation-cta h3 span {
      font-weight: 500; }
  .create-presentation-cta img {
    max-width: 700px;
    margin: 0 auto;
    width: 100%; }
  .create-presentation-cta .btn, .create-presentation-cta .icon-nav label, .icon-nav .create-presentation-cta label {
    font-size: 24px;
    font-weight: 300; }

.priority-trial-cta {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  border-radius: 4px 0 0 0;
  background-color: #dcf1e2;
  color: #2c6f3e; }
  .priority-trial-cta .content-box-body {
    padding: 18px; }
  .priority-trial-cta h3 {
    margin-top: 0;
    margin-bottom: 4px;
    margin-left: 120px; }
  .priority-trial-cta p {
    font-size: 16px;
    margin-bottom: 16px;
    margin-left: 120px; }
  .priority-trial-cta img {
    width: 90px;
    padding: 16px 10px 10px 10px; }
  .priority-trial-cta .btn, .priority-trial-cta .icon-nav label, .icon-nav .priority-trial-cta label {
    display: block;
    margin-left: 120px; }

#helpDropdownButton.add-notice {
  -webkit-animation-iteration-count: 3;
  animation-iteration-count: 3;
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-delay: 1s;
  animation-delay: 1s; }

.apps-launcher {
  text-align: center;
  font-size: 18px; }
  .apps-launcher .apps-launcher-tour {
    padding: 64px 32px; }
    .apps-launcher .apps-launcher-tour .content-box, .apps-launcher .apps-launcher-tour .select-subcompany-modal .list-group, .select-subcompany-modal .apps-launcher .apps-launcher-tour .list-group, .apps-launcher .apps-launcher-tour .content-box-editable, .apps-launcher .apps-launcher-tour .card, .apps-launcher .apps-launcher-tour #appLauncherContainer .scrollable-list, #appLauncherContainer .apps-launcher .apps-launcher-tour .scrollable-list, .apps-launcher .apps-launcher-tour #appLauncherContainer .template-grid, #appLauncherContainer .apps-launcher .apps-launcher-tour .template-grid {
      overflow: hidden;
      margin: 2px;
      -webkit-box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1);
      -moz-box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1);
      box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1); }
    .apps-launcher .apps-launcher-tour .headline h2 {
      font-weight: 300;
      font-size: 36px; }
    .apps-launcher .apps-launcher-tour .image {
      background: #E9FFED;
      padding: 16px 48px; }
      .apps-launcher .apps-launcher-tour .image img {
        margin: 0 auto; }

.app-launcher {
  line-height: 1.6; }

.app-launcher-header {
  padding: 48px 0; }
  .app-launcher-header h1 {
    margin: 0; }

.app-launcher-block {
  padding: 0; }
  .app-launcher-block .btn-primary {
    width: 200px; }
  .app-launcher-block .app-launcher-block-header h2 {
    display: inline-block;
    margin-right: 10px;
    margin-top: 8px; }

.template-filters {
  text-align: center;
  padding: 10px 0; }
  .template-filters ul > li {
    display: inline-block; }
    .template-filters ul > li span {
      padding: 4px 10px;
      display: block;
      color: #666;
      cursor: pointer;
      border-radius: 3px;
      text-transform: uppercase;
      font-size: 13px; }
      .template-filters ul > li span:hover {
        color: #0081BA; }
    .template-filters ul > li.active span {
      font-weight: 800;
      background: #e6e6e6; }
    .template-filters ul > li.more-templates span {
      font-weight: 800; }

.app-launcher-login {
  padding-top: 64px;
  background: url("https://s3.amazonaws.com/Rise-Images/UI/triangles.svg");
  background-size: cover;
  height: 100vh; }
  .app-launcher-login h1 {
    margin-top: 0; }
  .app-launcher-login .content-box, .app-launcher-login .select-subcompany-modal .list-group, .select-subcompany-modal .app-launcher-login .list-group, .app-launcher-login .content-box-editable, .app-launcher-login .card, .app-launcher-login #appLauncherContainer .scrollable-list, #appLauncherContainer .app-launcher-login .scrollable-list, .app-launcher-login #appLauncherContainer .template-grid, #appLauncherContainer .app-launcher-login .template-grid {
    padding: 32px; }
  .app-launcher-login .rise-logo {
    text-align: center;
    border-right: 1px solid #CCC;
    padding: 110px 0; }
    .app-launcher-login .rise-logo img {
      width: 150px; }
    @media (max-width: 768px) {
      .app-launcher-login .rise-logo {
        border-right: none;
        text-align: left;
        padding: 0; }
        .app-launcher-login .rise-logo img {
          width: 100px; } }

.post {
  line-height: 1.6;
  padding-bottom: 120px;
  font-size: 15px; }
  .post .post-title {
    margin-bottom: 32px;
    margin-top: 0;
    font-weight: 300;
    font-size: 44px; }
  .post p {
    margin-bottom: 16px; }
    .post p + h3 {
      margin-top: 32px; }
  .post h2 + p {
    padding-bottom: 24px;
    border-bottom: 1px solid #f2f2f2; }
  .post h4 {
    margin-bottom: 8px;
    font-size: 15px;
    font-weight: 800;
    color: #333; }

.entries p:first-child {
  padding: 10px;
  border-radius: 4px; }

.entries article {
  padding: 0; }

.entries a {
  display: block;
  padding: 8px;
  border-bottom: 1px solid #d4d4d4; }
  .entries a:hover {
    background: #f5f5f5; }
    .entries a:hover h4 {
      color: #0081BA; }
  .entries a h4 {
    color: #555; }
`, "",{"version":3,"sources":["webpack://./legacy_modules/rv-common-style/dist/css/rise.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;+EAC+E;AAC/E;+EAC+E;AAC/E;+EAC+E;AAC/E;+EAC+E;AAC/E,2DAA2D;AAC3D;;6FAE6F;AAC7F;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B,EAAE;;AAElC;EACE,SAAS,EAAE;;AAEb;;;;;;;;;;;;EAYE,cAAc,EAAE;;AAElB;;;;EAIE,qBAAqB;EACrB,wBAAwB,EAAE;;AAE5B;EACE,aAAa;EACb,SAAS,EAAE;;AAEb;;EAEE,aAAa,EAAE;;AAEjB;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,UAAU,EAAE;;AAEd;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB,EAAE;;AAE5B;EACE,WAAW,EAAE;;AAEf;EACE,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,SAAS,EAAE;;AAEb;EACE,cAAc,EAAE;;AAElB;;;;EAIE,iCAAiC;EACjC,cAAc,EAAE;;AAElB;;;;;EAKE,cAAc;EACd,aAAa;EACb,SAAS,EAAE;;AAEb;EACE,iBAAiB,EAAE;;AAErB;;EAEE,oBAAoB,EAAE;;AAExB;;;;EAIE,0BAA0B;EAC1B,eAAe,EAAE;;AAEnB;;EAEE,eAAe,EAAE;;AAEnB;;EAEE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,mBAAmB,EAAE;;AAEvB;;EAEE,sBAAsB;EACtB,UAAU,EAAE;;AAEd;;EAEE,YAAY,EAAE;;AAEhB;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;;EAEE,wBAAwB,EAAE;;AAE5B;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B,EAAE;;AAElC;EACE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,iBAAiB,EAAE;;AAErB;;EAEE,UAAU,EAAE;;AAEd;EACE;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B,EAAE;EAC/B;;IAEE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,6BAA6B,EAAE;EACjC;;IAEE,WAAW,EAAE;EACf;;IAEE,sBAAsB;IACtB,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;;;IAGE,UAAU;IACV,SAAS,EAAE;EACb;;IAEE,uBAAuB,EAAE;EAC3B;IACE,2BAA2B,EAAE;EAC/B;IACE,aAAa,EAAE;EACjB;;IAEE,iCAAiC,EAAE;EACrC;;;IAGE,iCAAiC,EAAE;EACrC;IACE,sBAAsB,EAAE;EAC1B;IACE,oCAAoC,EAAE;EACxC;;IAEE,iCAAiC,EAAE,EAAE;;AAEzC;EACE,mCAAmC;EACnC,qDAAqD;EACrD,2TAA2T,EAAE;;AAE/T;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB,EAAE;;AAE1B;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB,EAAE;;AAE1B;EACE,eAAe;EACf,wCAAwC,EAAE;;AAE5C;EACE,2DAA2D;EAC3D,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,0BAA0B,EAAE;EAC9B;IACE,oBAAoB;IACpB,0CAA0C;IAC1C,oBAAoB,EAAE;;AAE1B;EACE,SAAS,EAAE;;AAEb;EACE,sBAAsB,EAAE;;AAE1B;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,kBAAkB,EAAE;;AAEtB;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;EACnC,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,6BAA6B,EAAE;;AAEjC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,SAAS,EAAE;;AAEb;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,UAAU,EAAE;;AAEd;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAE;EAChB;;;;;;;;;;;;;;IAcE,mBAAmB;IACnB,cAAc;IACd,cAAc,EAAE;;AAEpB;;;EAGE,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;;;;;;;;;IASE,cAAc,EAAE;;AAEpB;;;EAGE,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;;;;;;;;;IASE,cAAc,EAAE;;AAEpB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,eAAe,EAAE,EAAE;;AAEzB;;EAEE,cAAc,EAAE;;AAElB;EACE,kBAAkB,EAAE;;AAEtB;;EAEE,yBAAyB;EACzB,aAAa,EAAE;;AAEjB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,0BAA0B,EAAE;;AAE9B;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC,EAAE;;AAEpC;;EAEE,aAAa;EACb,mBAAmB,EAAE;EACrB;;;;IAIE,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;EACnB;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB,EAAE;;AAExB;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;;EAEE,oBAAoB,EAAE;;AAExB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,kBAAkB,EAAE,EAAE;;AAE1B;;EAEE,YAAY;EACZ,iCAAiC,EAAE;;AAErC;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B,EAAE;EAChC;;;IAGE,gBAAgB,EAAE;EACpB;;;IAGE,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,cAAc,EAAE;IAChB;;;MAGE,sBAAsB,EAAE;;AAE9B;;EAEE,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,iBAAiB,EAAE;EACnB;;;;;;IAME,WAAW,EAAE;EACf;;;;;;IAME,sBAAsB,EAAE;;AAE5B;;EAEE,WAAW,EAAE;;AAEf;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;;;;EAIE,8DAA8D,EAAE;;AAElE;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C,EAAE;EAChD;IACE,UAAU;IACV,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB,EAAE;EACpB;IACE,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE;MACE,YAAY,EAAE,EAAE;EACpB;IACE;MACE,YAAY,EAAE,EAAE;EACpB;IACE;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;;AAEjB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,WAAW,EAAE;;AAEf;EACE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW,EAAE;;AAEf;EACE,UAAU,EAAE;;AAEd;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,eAAe,EAAE;;AAEnB;EACE,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,iBAAiB,EAAE;;AAErB;EACE;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,UAAU,EAAE;EACd;IACE,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,UAAU,EAAE;EACd;IACE,eAAe,EAAE;EACnB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,UAAU,EAAE;EACd;IACE,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,UAAU,EAAE;EACd;IACE,eAAe,EAAE;EACnB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,UAAU,EAAE;EACd;IACE,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,UAAU,EAAE;EACd;IACE,eAAe,EAAE;EACnB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE,6BAA6B,EAAE;;AAEjC;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB,EAAE;EACrB;;;;;;IAME,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B,EAAE;EACjC;IACE,sBAAsB;IACtB,gCAAgC,EAAE;EACpC;;;;;;IAME,aAAa,EAAE;EACjB;IACE,6BAA6B,EAAE;EACjC;IACE,yBAAyB,EAAE;;AAE/B;;;;;;EAME,YAAY,EAAE;;AAEhB;EACE,yBAAyB,EAAE;EAC3B;;;;;;IAME,yBAAyB,EAAE;EAC7B;;IAEE,wBAAwB,EAAE;;AAE9B;;EAEE,yBAAyB,EAAE;;AAE7B;;EAEE,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB,EAAE;;AAEzB;;EAEE,gBAAgB;EAChB,WAAW;EACX,mBAAmB,EAAE;;AAEvB;;;;;;;;;;;;EAYE,yBAAyB,EAAE;;AAE7B;;;;;EAKE,yBAAyB,EAAE;;AAE7B;;;;;;;;;;;;EAYE,yBAAyB,EAAE;;AAE7B;;;;;EAKE,yBAAyB,EAAE;;AAE7B;;;;;;;;;;;;EAYE,yBAAyB,EAAE;;AAE7B;;;;;EAKE,yBAAyB,EAAE;;AAE7B;;;;;;;;;;;;EAYE,yBAAyB,EAAE;;AAE7B;;;;;EAKE,yBAAyB,EAAE;;AAE7B;;;;;;;;;;;;EAYE,yBAAyB,EAAE;;AAE7B;;;;;EAKE,yBAAyB,EAAE;;AAE7B;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,yBAAyB;IACzB,iCAAiC,EAAE;IACnC;MACE,gBAAgB,EAAE;MAClB;;;;;;;;;;;QAWE,mBAAmB,EAAE;IACzB;MACE,SAAS,EAAE;MACX;;;;;;QAME,cAAc,EAAE;MAClB;;;;;;QAME,eAAe,EAAE;MACnB;;;;QAIE,gBAAgB,EAAE,EAAE;;AAE5B;EACE,UAAU;EACV,SAAS;EACT,SAAS;EACT,YAAY,EAAE;;AAEhB;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gCAAgC,EAAE;;AAEpC;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB,EAAE;;AAE1B;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,WAAW,EAAE;;AAEf;;EAEE,YAAY,EAAE;;AAEhB;;;EAGE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB,EAAE;;AAExB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;EACxD,gDAAgD;EAChD,gFAAgF;EAChF,2EAA2E;EAC3E,wEAAwE,EAAE;EAC1E;IACE,qBAAqB;IACrB,UAAU;IACV,yFAAyF;IACzF,iFAAiF,EAAE;EACrF;IACE,cAAc;IACd,UAAU,EAAE;EACd;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;;IAEE,mBAAmB;IACnB,yBAAyB;IACzB,UAAU,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,wBAAwB,EAAE;;AAE5B;;;;EAIE,iBAAiB;EACjB,uBAAuB,EAAE;EACzB;;;;;;;;;;;;;;;;;;IAkBE,iBAAiB,EAAE;EACrB;;;;;;;;;;;;;;;;;;IAkBE,iBAAiB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;;IAEE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe,EAAE;;AAErB;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;;EAEE,gBAAgB,EAAE;;AAEpB;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe,EAAE;;AAEnB;;EAEE,aAAa;EACb,iBAAiB,EAAE;;AAErB;;;;;;EAME,mBAAmB,EAAE;;AAEvB;;;;;EAKE,mBAAmB,EAAE;;AAEvB;;;;;EAKE,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB,EAAE;EAClB;;;;;;;IAOE,eAAe;IACf,gBAAgB,EAAE;;AAEtB;;;;EAIE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;;;EAGE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;;;;;;;;EAQE,YAAY,EAAE;;AAEhB;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;;;EAGE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;;;;;;;;EAQE,YAAY,EAAE;;AAEhB;EACE,kBAAkB,EAAE;EACpB;IACE,qBAAqB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;;;;EAIE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE;;AAErB;;;;EAIE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE;;AAErB;;;;;;EAME,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,wDAAwD;EACxD,gDAAgD,EAAE;EAClD;IACE,qBAAqB;IACrB,yEAAyE;IACzE,iEAAiE,EAAE;;AAEvE;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;;;;;;EAME,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,wDAAwD;EACxD,gDAAgD,EAAE;EAClD;IACE,qBAAqB;IACrB,yEAAyE;IACzE,iEAAiE,EAAE;;AAEvE;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;;;;;;EAME,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,wDAAwD;EACxD,gDAAgD,EAAE;EAClD;IACE,qBAAqB;IACrB,yEAAyE;IACzE,iEAAiE,EAAE;;AAEvE;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;EACE,MAAM,EAAE;;AAEV;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE;;AAElB;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB,EAAE;EAC1B;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB,EAAE;EAC1B;IACE,qBAAqB;IACrB,sBAAsB,EAAE;IACxB;;;MAGE,WAAW,EAAE;EACjB;IACE,WAAW,EAAE;EACf;IACE,gBAAgB;IAChB,sBAAsB,EAAE;EAC1B;;IAEE,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,sBAAsB,EAAE;IACxB;;MAEE,eAAe,EAAE;EACrB;;IAEE,kBAAkB;IAClB,cAAc,EAAE;EAClB;IACE,MAAM,EAAE,EAAE;;AAEd;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;;EAEE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;;AAEjB;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB,EAAE,EAAE;;AAExB;EACE,MAAM;EACN,YAAY,EAAE;;AAEhB;EACE;IACE,mBAAmB,EAAE,EAAE;;AAE3B;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,oBAAoB;IACpB,0CAA0C;IAC1C,oBAAoB,EAAE;EACxB;IACE,WAAW;IACX,qBAAqB,EAAE;EACzB;IACE,UAAU;IACV,sBAAsB;IACtB,wDAAwD;IACxD,gDAAgD,EAAE;EACpD;;;;IAIE,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB,EAAE;;AAEtB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;;;;IAKE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;;;;IAKE,sBAAsB,EAAE;EAC1B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoCE,yBAAyB;IACzB,kBAAkB,EAAE;EACtB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,sBAAsB,EAAE;EAC1B;;;;;;IAME,yBAAyB;IACzB,kBAAkB,EAAE;EACtB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;;;IAIE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;;;IAIE,sBAAsB,EAAE;EAC1B;;;;;;;;;;;;;;;;;;;;;IAqBE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,sBAAsB,EAAE;EAC1B;;;;;;IAME,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,sBAAsB,EAAE;EAC1B;;;;;;IAME,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,sBAAsB,EAAE;EAC1B;;;;;;IAME,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,sBAAsB,EAAE;;AAE5B;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAE;EAClB;;IAEE,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB,EAAE;EACpB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,0BAA0B;IAC1B,6BAA6B,EAAE;EACjC;;;IAGE,cAAc;IACd,qBAAqB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,WAAW,EAAE;;AAEf;EACE,eAAe,EAAE;;AAEnB;;;EAGE,WAAW,EAAE;;AAEf;EACE,UAAU;EACV,wCAAwC;EACxC,mCAAmC;EACnC,gCAAgC,EAAE;EAClC;IACE,UAAU,EAAE;;AAEhB;EACE,aAAa,EAAE;EACf;IACE,cAAc,EAAE;;AAEpB;EACE,kBAAkB,EAAE;;AAEtB;EACE,wBAAwB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;EAChC,6BAA6B,EAAE;;AAEjC;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC;EACE,kBAAkB,EAAE;;AAEtB;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,mDAAmD;EACnD,2CAA2C;EAC3C,4BAA4B,EAAE;EAC9B;IACE,QAAQ;IACR,UAAU,EAAE;EACd;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,mBAAmB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,mEAAmE;EACnE,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,UAAU;EACV,QAAQ,EAAE;;AAEZ;EACE,OAAO;EACP,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;EACN,YAAY,EAAE;;AAEhB;EACE,QAAQ;EACR,UAAU,EAAE;;AAEd;;EAEE,aAAa;EACb,wBAAwB;EACxB,WAAW,EAAE;;AAEf;;EAEE,SAAS;EACT,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE;IACE,QAAQ;IACR,UAAU,EAAE;EACd;IACE,OAAO;IACP,WAAW,EAAE,EAAE;;AAEnB;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB,EAAE;EACxB;;;IAGE,kBAAkB;IAClB,WAAW,EAAE;IACb;;;;;;;;;MASE,UAAU,EAAE;IACd;;;MAGE,UAAU,EAAE;;AAElB;;;;;;;;EAQE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;EACnB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;;IAEE,WAAW,EAAE;EACf;;;IAGE,gBAAgB,EAAE;;AAEtB;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;EAChB;IACE,6BAA6B;IAC7B,0BAA0B,EAAE;;AAEhC;;EAEE,4BAA4B;EAC5B,yBAAyB,EAAE;;AAE7B;EACE,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,6BAA6B;EAC7B,0BAA0B,EAAE;;AAE9B;EACE,4BAA4B;EAC5B,yBAAyB,EAAE;;AAE7B;;EAEE,UAAU,EAAE;;AAEd;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,wDAAwD;EACxD,gDAAgD,EAAE;EAClD;IACE,wBAAwB;IACxB,gBAAgB,EAAE;;AAEtB;EACE,cAAc,EAAE;;AAElB;EACE,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE;;AAE3B;;;;EAIE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;;;;;;EAME,gBAAgB;EAChB,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B,EAAE;;AAEhC;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,6BAA6B;EAC7B,4BAA4B,EAAE;;AAEhC;EACE,0BAA0B;EAC1B,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB,EAAE;EAC3B;;IAEE,WAAW;IACX,mBAAmB;IACnB,SAAS,EAAE;EACb;IACE,WAAW,EAAE;EACf;IACE,UAAU,EAAE;;AAEhB;;;EAGE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,wBAAwB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB,EAAE;;AAEtB;;;EAGE,mBAAmB,EAAE;EACrB;;;IAGE,gBAAgB,EAAE;;AAEtB;;EAEE,SAAS;EACT,mBAAmB;EACnB,sBAAsB,EAAE;;AAE1B;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;;;IAIE,iBAAiB;IACjB,eAAe;IACf,kBAAkB,EAAE;EACtB;;;;IAIE,kBAAkB;IAClB,eAAe;IACf,kBAAkB,EAAE;EACtB;;IAEE,aAAa,EAAE;;AAEnB;;;;;;;;;;;EAWE,6BAA6B;EAC7B,0BAA0B,EAAE;;AAE9B;EACE,eAAe,EAAE;;AAEnB;;;;;;;;;;;EAWE,4BAA4B;EAC5B,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE,kBAAkB,EAAE;IACpB;MACE,iBAAiB,EAAE;IACrB;MACE,UAAU,EAAE;EAChB;;IAEE,kBAAkB,EAAE;EACtB;;IAEE,iBAAiB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,kBAAkB;IAClB,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,cAAc;MACd,kBAAkB,EAAE;MACpB;QACE,qBAAqB;QACrB,yBAAyB,EAAE;IAC/B;MACE,cAAc,EAAE;MAChB;QACE,cAAc;QACd,qBAAqB;QACrB,6BAA6B;QAC7B,mBAAmB,EAAE;EAC3B;IACE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB,EAAE;EAC7B;IACE,eAAe,EAAE;;AAErB;EACE,6BAA6B,EAAE;EAC/B;IACE,WAAW;IACX,mBAAmB,EAAE;IACrB;MACE,iBAAiB;MACjB,oBAAoB;MACpB,6BAA6B;MAC7B,0BAA0B,EAAE;MAC5B;QACE,kCAAkC,EAAE;IACxC;MACE,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,gCAAgC;MAChC,eAAe,EAAE;;AAEvB;EACE,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;EACtB;IACE,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,WAAW,EAAE;EACb;IACE,eAAe;IACf,cAAc,EAAE;;AAEpB;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;IACb;MACE,kBAAkB;MAClB,kBAAkB,EAAE;EACxB;IACE,SAAS;IACT,UAAU,EAAE;EACd;IACE;MACE,mBAAmB;MACnB,SAAS,EAAE;MACX;QACE,gBAAgB,EAAE,EAAE;;AAE5B;EACE,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,kBAAkB,EAAE;EACtB;;;IAGE,sBAAsB,EAAE;EAC1B;IACE;MACE,6BAA6B;MAC7B,0BAA0B,EAAE;IAC9B;;;MAGE,4BAA4B,EAAE,EAAE;;AAEtC;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B,EAAE;EAC/B;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE;MACE,kBAAkB,EAAE,EAAE;;AAE5B;EACE,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,kDAAkD;EAClD,iCAAiC,EAAE;EACnC;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,gBAAgB,EAAE;EACpB;IACE;MACE,WAAW;MACX,aAAa;MACb,gBAAgB,EAAE;MAClB;QACE,yBAAyB;QACzB,uBAAuB;QACvB,iBAAiB;QACjB,4BAA4B,EAAE;MAChC;QACE,mBAAmB,EAAE;MACvB;;;QAGE,eAAe;QACf,gBAAgB,EAAE,EAAE;;AAE5B;;EAEE,iBAAiB,EAAE;EACnB;IACE;;MAEE,iBAAiB,EAAE,EAAE;;AAE3B;;;;EAIE,kBAAkB;EAClB,iBAAiB,EAAE;EACnB;IACE;;;;MAIE,eAAe;MACf,cAAc,EAAE,EAAE;;AAExB;EACE,aAAa;EACb,qBAAqB,EAAE;EACvB;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;;EAEE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,aAAa;EACb,uCAAuC;EACvC,+BAA+B,EAAE;EACjC;IACE;;MAEE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,MAAM;EACN,qBAAqB,EAAE;;AAEzB;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY,EAAE;EACd;IACE,qBAAqB,EAAE;EACzB;IACE;;MAEE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB,EAAE;EACtB;IACE,eAAe,EAAE;EACnB;IACE;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE,kBAAkB,EAAE;EACpB;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB,EAAE;EACrB;IACE;MACE,gBAAgB;MAChB,WAAW;MACX,WAAW;MACX,aAAa;MACb,6BAA6B;MAC7B,SAAS;MACT,gBAAgB,EAAE;MAClB;;QAEE,0BAA0B,EAAE;MAC9B;QACE,iBAAiB,EAAE;QACnB;UACE,sBAAsB,EAAE,EAAE;EAClC;IACE;MACE,WAAW;MACX,SAAS,EAAE;MACX;QACE,WAAW,EAAE;QACb;UACE,iBAAiB;UACjB,oBAAoB,EAAE;MAC1B;QACE,kBAAkB,EAAE,EAAE;;AAE9B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,uBAAuB,EAAE,EAAE;;AAE/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,oCAAoC;EACpC,4FAA4F;EAC5F,oFAAoF;EACpF,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE;MACE,kBAAkB,EAAE,EAAE;EAC1B;IACE;MACE,WAAW;MACX,SAAS;MACT,cAAc;MACd,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,wBAAwB;MACxB,gBAAgB,EAAE;MAClB;QACE,kBAAkB,EAAE,EAAE;;AAE9B;EACE,aAAa;EACb,0BAA0B;EAC1B,yBAAyB,EAAE;;AAE7B;EACE,6BAA6B;EAC7B,4BAA4B,EAAE;;AAEhC;EACE,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;IACE,gBAAgB;IAChB,mBAAmB,EAAE;;AAEzB;EACE,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE;MACE,WAAW;MACX,gBAAgB;MAChB,iBAAiB,EAAE;MACnB;QACE,eAAe,EAAE,EAAE;;AAE3B;EACE,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,cAAc,EAAE;IAChB;MACE,YAAY;MACZ,6BAA6B,EAAE;EACnC;IACE,WAAW,EAAE;EACf;IACE,cAAc,EAAE;IAChB;MACE,cAAc;MACd,yBAAyB,EAAE;EAC/B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,6BAA6B,EAAE;EACjC;IACE,kBAAkB,EAAE;IACpB;MACE,sBAAsB,EAAE;IAC1B;MACE,sBAAsB,EAAE;EAC5B;;IAEE,qBAAqB,EAAE;EACzB;IACE,yBAAyB;IACzB,cAAc,EAAE;EAClB;IACE;MACE,cAAc,EAAE;MAChB;QACE,cAAc;QACd,yBAAyB,EAAE;IAC/B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,WAAW;MACX,6BAA6B,EAAE,EAAE;EACrC;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;IAClB;;;MAGE,WAAW,EAAE;;AAEnB;EACE,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,cAAc,EAAE;IAChB;MACE,WAAW;MACX,6BAA6B,EAAE;EACnC;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;IAChB;MACE,WAAW;MACX,6BAA6B,EAAE;EACnC;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,6BAA6B,EAAE;EACjC;IACE,kBAAkB,EAAE;IACpB;MACE,sBAAsB,EAAE;IAC1B;MACE,sBAAsB,EAAE;EAC5B;;IAEE,qBAAqB,EAAE;EACzB;IACE,yBAAyB;IACzB,WAAW,EAAE;EACf;IACE;MACE,qBAAqB,EAAE;IACzB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc,EAAE;MAChB;QACE,WAAW;QACX,6BAA6B,EAAE;IACnC;MACE,WAAW;MACX,yBAAyB,EAAE;IAC7B;MACE,WAAW;MACX,6BAA6B,EAAE,EAAE;EACrC;IACE,cAAc,EAAE;IAChB;MACE,WAAW,EAAE;EACjB;IACE,cAAc,EAAE;IAChB;MACE,WAAW,EAAE;IACf;;;MAGE,WAAW,EAAE;;AAEnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;IACE,qBAAqB,EAAE;IACvB;MACE,aAAa;MACb,cAAc;MACd,WAAW,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,eAAe,EAAE;IACjB;;MAEE,kBAAkB;MAClB,WAAW;MACX,iBAAiB;MACjB,oBAAoB;MACpB,qBAAqB;MACrB,cAAc;MACd,sBAAsB;MACtB,sBAAsB;MACtB,iBAAiB,EAAE;IACrB;;MAEE,cAAc;MACd,8BAA8B;MAC9B,2BAA2B,EAAE;IAC/B;;MAEE,+BAA+B;MAC/B,4BAA4B,EAAE;EAClC;;;IAGE,cAAc;IACd,yBAAyB;IACzB,kBAAkB,EAAE;EACtB;;;;IAIE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,eAAe,EAAE;EACnB;;;;;;IAME,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB,EAAE;;AAEzB;;EAEE,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;;EAEE,8BAA8B;EAC9B,2BAA2B,EAAE;;AAE/B;;EAEE,+BAA+B;EAC/B,4BAA4B,EAAE;;AAEhC;;EAEE,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;;EAEE,8BAA8B;EAC9B,2BAA2B,EAAE;;AAE/B;;EAEE,+BAA+B;EAC/B,4BAA4B,EAAE;;AAEhC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;IACjB;;MAEE,qBAAqB;MACrB,iBAAiB;MACjB,sBAAsB;MACtB,sBAAsB;MACtB,mBAAmB,EAAE;IACvB;;MAEE,qBAAqB;MACrB,yBAAyB,EAAE;EAC/B;;IAEE,YAAY,EAAE;EAChB;;IAEE,WAAW,EAAE;EACf;;;;IAIE,cAAc;IACd,sBAAsB;IACtB,mBAAmB,EAAE;;AAEzB;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB,EAAE;EACtB;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,SAAS,EAAE;;AAEf;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB,EAAE;EACrB;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,SAAS,EAAE;EACb;IACE,MAAM;IACN,gBAAgB,EAAE;EACpB;;IAEE,cAAc;IACd,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;;AAEtB;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;EAC3B;;IAEE,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,yBAAyB,EAAE;EAC7B;IACE,kBAAkB,EAAE;EACtB;IACE,eAAe,EAAE;EACnB;IACE;MACE,iBAAiB;MACjB,oBAAoB,EAAE;MACtB;QACE,kBAAkB;QAClB,mBAAmB,EAAE;MACvB;;QAEE,eAAe,EAAE,EAAE;;AAE3B;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;EACnC,gCAAgC,EAAE;EAClC;;IAEE,cAAc;IACd,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;;AAEpB;;;EAGE,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB,EAAE;EACpB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,iBAAiB,EAAE;EACrB;;IAEE,gBAAgB,EAAE;EACpB;IACE,eAAe,EAAE;;AAErB;;EAEE,mBAAmB,EAAE;EACrB;;IAEE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc,EAAE;EAChB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc,EAAE;EAChB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAE;EACb;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAE;EACb;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sDAAsD;EACtD,8CAA8C,EAAE;;AAElD;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sDAAsD;EACtD,8CAA8C;EAC9C,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B,EAAE;;AAE/B;;EAEE,6MAA6M;EAC7M,wMAAwM;EACxM,qMAAqM;EACrM,0BAA0B,EAAE;;AAE9B;;EAEE,0DAA0D;EAC1D,qDAAqD;EACrD,kDAAkD,EAAE;;AAEtD;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,yBAAyB,EAAE;EAC3B;IACE,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM,EAAE;;AAE3M;EACE,yBAAyB,EAAE;EAC3B;IACE,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM,EAAE;;AAE3M;EACE,yBAAyB,EAAE;EAC3B;IACE,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM,EAAE;;AAE3M;EACE,yBAAyB,EAAE;EAC3B;IACE,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM,EAAE;;AAE3M;;EAEE,gBAAgB;EAChB,OAAO,EAAE;;AAEX;;EAEE,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB,EAAE;EACxB;IACE,4BAA4B;IAC5B,2BAA2B,EAAE;EAC/B;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B,EAAE;EAClC;IACE,YAAY,EAAE;EAChB;IACE,iBAAiB,EAAE;;AAEvB;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,WAAW;IACX,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB;EACzB,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;;;;;;IAOE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,aAAa;EACb,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC,EAAE;;AAE7C;EACE,aAAa,EAAE;EACf;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;;AAEpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B,EAAE;;AAElC;EACE,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,gBAAgB,EAAE;EACpB;IACE,aAAa;IACb,4BAA4B;IAC5B,2BAA2B,EAAE;EAC/B;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B,EAAE;;AAEpC;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;;;;;EAKE,gBAAgB,EAAE;;AAEpB;;;EAGE,4BAA4B;EAC5B,2BAA2B,EAAE;EAC7B;;;;;;;;;;;;;;;IAeE,2BAA2B,EAAE;EAC/B;;;;;;;;;;;;;;;IAeE,4BAA4B,EAAE;;AAElC;;;EAGE,+BAA+B;EAC/B,8BAA8B,EAAE;EAChC;;;;;;;;;;;;;;;IAeE,8BAA8B,EAAE;EAClC;;;;;;;;;;;;;;;IAeE,+BAA+B,EAAE;;AAErC;;;EAGE,6BAA6B,EAAE;;AAEjC;;;EAGE,aAAa,EAAE;;AAEjB;;EAEE,SAAS,EAAE;EACX;;;;;;;;;;;;IAYE,cAAc,EAAE;EAClB;;;;;;;;;;;;IAYE,eAAe,EAAE;EACnB;;;;;;;;IAQE,gBAAgB,EAAE;EACpB;;;;;;;;IAQE,gBAAgB,EAAE;;AAEtB;EACE,SAAS;EACT,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB,EAAE;EACrB;IACE,gBAAgB;IAChB,kBAAkB,EAAE;IACpB;MACE,eAAe,EAAE;EACrB;IACE,gBAAgB,EAAE;IAClB;MACE,0BAA0B,EAAE;EAChC;IACE,aAAa,EAAE;IACf;MACE,6BAA6B,EAAE;;AAErC;EACE,kBAAkB,EAAE;EACpB;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB,EAAE;IACpB;MACE,sBAAsB,EAAE;IAC1B;MACE,WAAW;MACX,yBAAyB,EAAE;EAC/B;IACE,yBAAyB,EAAE;;AAE/B;EACE,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,sBAAsB,EAAE;EAC5B;IACE,4BAA4B,EAAE;;AAElC;EACE,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,yBAAyB,EAAE;EAC/B;IACE,4BAA4B,EAAE;;AAElC;EACE,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,yBAAyB,EAAE;EAC/B;IACE,4BAA4B,EAAE;;AAElC;EACE,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,yBAAyB,EAAE;EAC/B;IACE,4BAA4B,EAAE;;AAElC;EACE,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,yBAAyB,EAAE;EAC/B;IACE,4BAA4B,EAAE;;AAElC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE;EAClB;;;;IAIE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;IACX,SAAS,EAAE;EACb;IACE,sBAAsB,EAAE;EAC1B;IACE,mBAAmB,EAAE;;AAEzB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uDAAuD;EACvD,+CAA+C,EAAE;EACjD;IACE,kBAAkB;IAClB,iCAAiC,EAAE;;AAEvC;EACE,aAAa;EACb,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,yBAAyB,EAAE;;AAE/B;EACE,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,wBAAwB,EAAE;;AAE5B;EACE,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,iCAAiC;EACjC,UAAU,EAAE;EACZ;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,mDAAmD;IACnD,6CAA6C;IAC7C,yCAAyC;IACzC,mCAAmC,EAAE;EACvC;IACE,uCAAuC;IACvC,+BAA+B,EAAE;;AAErC;EACE,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;EACxC,4BAA4B;EAC5B,UAAU,EAAE;;AAEd;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,UAAU;IACV,wBAAwB,EAAE;EAC5B;IACE,YAAY;IACZ,yBAAyB,EAAE;;AAE/B;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,SAAS;EACT,oBAAoB,EAAE;;AAExB;EACE,kBAAkB;EAClB,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B,EAAE;EAC/B;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,gBAAgB;IAChB,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,cAAc,EAAE;;AAEpB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE;IACE,YAAY;IACZ,iBAAiB,EAAE;EACrB;IACE,iDAAiD;IACjD,yCAAyC,EAAE;EAC7C;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,aAAa,EAAE,EAAE;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,wBAAwB,EAAE;EAC1B;IACE,YAAY;IACZ,yBAAyB,EAAE;EAC7B;IACE,gBAAgB;IAChB,cAAc,EAAE;EAClB;IACE,gBAAgB;IAChB,cAAc,EAAE;EAClB;IACE,eAAe;IACf,cAAc,EAAE;EAClB;IACE,iBAAiB;IACjB,cAAc,EAAE;;AAEpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,mBAAmB,EAAE;;AAEvB;EACE,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB,EAAE;;AAE5B;EACE,QAAQ;EACR,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB,EAAE;;AAE3B;EACE,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB,EAAE;;AAE7B;EACE,MAAM;EACN,SAAS;EACT,uBAAuB;EACvB,yBAAyB,EAAE;;AAE7B;EACE,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;EACzC,mBAAmB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,kBAAkB,EAAE;;AAExB;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B,EAAE;;AAE9B;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW,EAAE;;AAEf;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,aAAa,EAAE;EACf;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB,EAAE;;AAE5B;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,uCAAuC,EAAE;EACzC;IACE,YAAY;IACZ,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,wBAAwB,EAAE;;AAE9B;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;EACxC,UAAU,EAAE;EACZ;IACE,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB,EAAE;;AAE/B;EACE,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC,EAAE;EACxC;IACE,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,uBAAuB;IACvB,aAAa,EAAE;;AAEnB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE;EACb;IACE,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,oCAAoC;IACpC,iCAAiC,EAAE;IACnC;;MAEE,cAAc;MACd,cAAc;MACd,eAAe;MACf,YAAY;MACZ,cAAc,EAAE;EACpB;;;IAGE,cAAc,EAAE;EAClB;IACE,OAAO,EAAE;EACX;;IAEE,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE;EACf;IACE,UAAU,EAAE;EACd;IACE,WAAW,EAAE;EACf;;IAEE,OAAO,EAAE;EACX;IACE,WAAW,EAAE;EACf;IACE,UAAU,EAAE;;AAEhB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yCAAyC,EAAE;EAC3C;IACE,kGAAkG;IAClG,6FAA6F;IAC7F,8FAA8F;IAC9F,2BAA2B;IAC3B,sHAAsH,EAAE;EAC1H;IACE,UAAU;IACV,QAAQ;IACR,kGAAkG;IAClG,6FAA6F;IAC7F,8FAA8F;IAC9F,2BAA2B;IAC3B,sHAAsH,EAAE;EAC1H;IACE,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,yBAAyB,EAAE;EAC7B;;;;IAIE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qBAAqB,EAAE;EACzB;;IAEE,SAAS;IACT,kBAAkB,EAAE;EACtB;;IAEE,UAAU;IACV,mBAAmB,EAAE;EACvB;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB,EAAE;EACtB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6BAA6B,EAAE;EACjC;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,yCAAyC,EAAE;EAC3C;IACE,iBAAiB,EAAE;;AAEvB;EACE;;;;IAIE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe,EAAE;EACnB;;IAEE,kBAAkB,EAAE;EACtB;;IAEE,mBAAmB,EAAE;EACvB;IACE,SAAS;IACT,UAAU;IACV,oBAAoB,EAAE;EACxB;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB,EAAE;;AAE1B;EACE,wBAAwB,EAAE;;AAE5B;EACE,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAE;;AAEb;EACE,wBAAwB;EACxB,6BAA6B,EAAE;;AAEjC;EACE,eAAe;EACf,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;EACE,mBAAmB,EAAE;;AAEvB;EACE,wBAAwB,EAAE;;AAE5B;;;;;;;;;;;;EAYE,wBAAwB,EAAE;;AAE5B;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE,wBAAwB,EAAE;;AAE5B;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE,EAAE;;AAEtC;EACE,wBAAwB,EAAE;EAC1B;IACE;MACE,yBAAyB,EAAE,EAAE;;AAEnC;EACE,wBAAwB,EAAE;EAC1B;IACE;MACE,0BAA0B,EAAE,EAAE;;AAEpC;EACE,wBAAwB,EAAE;EAC1B;IACE;MACE,gCAAgC,EAAE,EAAE;;AAE1C;EACE;IACE,wBAAwB,EAAE,EAAE;;AAEhC;+EAC+E;AAC/E;;;EAGE;AACF;+BAC+B;AAC/B;EACE,0BAA0B;EAC1B,oDAAoD;EACpD,8SAA8S;EAC9S,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,kBAAkB,EAAE;;AAExB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB,EAAE;;AAEvB;EACE,YAAY,EAAE;;AAEhB;EACE,WAAW,EAAE;;AAEf;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC,EAAE;;AAEtC;EACE;IACE,4BAA4B,EAAE;EAChC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,+BAA+B,EAAE;EACnC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,+BAA+B;IAC/B,uBAAuB,EAAE;EAC3B;IACE,iCAAiC;IACjC,yBAAyB,EAAE,EAAE;;AAEjC;EACE,gEAAgE;EAChE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB,EAAE;;AAE5B;EACE,gEAAgE;EAChE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB,EAAE;;AAE7B;EACE,gEAAgE;EAChE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB,EAAE;;AAE7B;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB,EAAE;;AAE3B;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;mEACmE;AACnE;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;;;EAIE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;;EAGE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;;;EAIE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;+EAC+E;AAC/E;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAE;EACb;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAE;EACb;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,cAAc,EAAE;EAChB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;EACpB,4CAA4C,EAAE;;AAEhD;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;;;EAGE,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;;;;IAKE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,UAAU,EAAE;EACd;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoCE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;;AAEpB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,UAAU,EAAE;EACd;;;;;;IAME,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,UAAU,EAAE;EACd;;;;;;IAME,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,UAAU,EAAE;EACd;;;;;;IAME,sBAAsB;IACtB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB,EAAE;EACpB;;IAEE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,UAAU,EAAE;EACd;;;;;;IAME,sBAAsB;IACtB,mBAAmB,EAAE;;AAEzB;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,UAAU;EACV,gBAAgB,EAAE;EAClB;IACE,YAAY,EAAE;EAChB;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,yBAAyB,EAAE;EAC7B;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU,EAAE;;AAEhB;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,uCAAuC;EACvC,WAAW,EAAE;;AAEf;EACE,SAAS;EACT,UAAU,EAAE;;AAEd;;EAEE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;;EAEE,cAAc;EACd,cAAc;EACd,aAAa;EACb,SAAS,EAAE;;AAEb;;EAEE,0CAA0C;EAC1C,cAAc,EAAE;;AAElB;;EAEE,sBAAsB;EACtB,eAAe,EAAE;;AAEnB;;EAEE,WAAW;EACX,sBAAsB,EAAE;;AAE1B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,mBAAmB,EAAE;;AAEvB;EACE,0CAA0C;EAC1C,uCAAuC,EAAE;;AAE3C;EACE,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAE;;AAElB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;;AAEpB;;;;EAIE,YAAY,EAAE;;AAEhB;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW,EAAE;;AAEf;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,SAAS,EAAE;IACX;MACE,WAAW,EAAE;IACf;MACE,YAAY;MACZ,qBAAqB,EAAE;IACzB;MACE,cAAc,EAAE;EACpB;IACE,iDAAiD,EAAE;IACnD;MACE,kBAAkB,EAAE;IACtB;MACE,qBAAqB;MACrB,mBAAmB,EAAE;IACvB;MACE,kBAAkB;MAClB,eAAe,EAAE;MACjB;QACE,WAAW,EAAE;IACjB;MACE,gBAAgB,EAAE;EACtB;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB,EAAE;IAClB;MACE,YAAY,EAAE;;AAEpB;EACE,2BAA2B;EAC3B,6BAA6B,EAAE;EAC/B;IACE;MACE,sBAAsB;MACtB,kBAAkB;MAClB,sBAAsB,EAAE,EAAE;EAC9B;IACE;MACE,cAAc;MACd,gBAAgB,EAAE;MAClB;QACE,cAAc,EAAE,EAAE;;AAE1B;EACE,6BAA6B,EAAE;EAC/B;IACE,0BAA0B,EAAE;;AAEhC;EACE,kBAAkB,EAAE;;AAEtB;EACE;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc,EAAE;;AAElB;;;;;+EAK+E;AAC/E;EACE,yBAAyB,EAAE;EAC3B;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAE;IAChB;MACE;QACE,eAAe;QACf,gBAAgB,EAAE;QAClB;UACE,cAAc;UACd,WAAW;UACX,kBAAkB,EAAE,EAAE;EAC9B;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa,EAAE;EACjB;IACE,iBAAiB,EAAE;;AAEvB;EACE,gBAAgB,EAAE;EAClB;IACE,8BAA8B,EAAE;EAClC;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB,EAAE;IAClB;MACE,WAAW,EAAE;IACf;MACE;QACE,WAAW,EAAE;MACf;QACE,gBAAgB,EAAE,EAAE;EAC1B;IACE,gBAAgB;IAChB,mBAAmB,EAAE;IACrB;MACE,0BAA0B;MAC1B,YAAY,EAAE;EAClB;IACE,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB,EAAE;IACrB;MACE;QACE,YAAY,EAAE,EAAE;IACpB;MACE;QACE,YAAY,EAAE,EAAE;EACtB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY,EAAE;;AAElB;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,8BAA8B,EAAE;EAClC;IACE,6BAA6B,EAAE,EAAE;;AAErC;EACE,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB,EAAE;;AAEpB;;+EAE+E;AAC/E;;;;;;EAME;AACF;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU;EACV,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B,EAAE;;AAE9B;EACE,gBAAgB;EAChB,aAAa,EAAE;;AAEjB;EACE,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU,EAAE;;AAEd;EACE,oBAAoB;EACpB,SAAS;EACT,aAAa,EAAE;EACf;IACE,WAAW,EAAE;;AAEjB;EACE,WAAW,EAAE;;AAEf;+EAC+E;AAC/E;EACE;IACE,aAAa,EAAE;EACjB;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,YAAY;IACZ,iBAAiB,EAAE;EACrB;IACE,iDAAiD;IACjD,yCAAyC,EAAE;EAC7C;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB,EAAE;EAClB;IACE,mBAAmB,EAAE;IACrB;MACE,gBAAgB;MAChB,uBAAuB;MACvB,gBAAgB;MAChB,qBAAqB;MACrB,mBAAmB,EAAE;;AAE3B;EACE;IACE,eAAe;IACf,eAAe,EAAE;IACjB;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,eAAe;EACf,iBAAiB,EAAE;;AAErB;+EAC+E;AAC/E;;+EAE+E;AAC/E;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,cAAc,EAAE;;AAElB;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,8BAA8B,EAAE;;AAElC;;;;;CAKC;AACD;EACE,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB;EACrB,gCAAgC,EAAE;;AAEpC,WAAW;AACX;EACE,gBAAgB;EAChB,UAAU,EAAE;;AAEd;+EAC+E;AAC/E;EACE,mBAAmB,EAAE;EACrB;IACE,WAAW,EAAE;EACf;IACE,iBAAiB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB,oBAAoB;AACpB;EACE,eAAe,EAAE;;AAEnB;EACE,WAAW,EAAE;;AAEf;;+EAE+E;AAC/E,sBAAsB;AACtB;EACE,aAAa,EAAE;;AAEjB,8CAA8C;AAC9C;;EAEE,wBAAwB;EACxB,SAAS,EAAE;;AAEb;+EAC+E;AAC/E;EACE,UAAU,EAAE;EACZ;IACE,WAAW,EAAE;EACf;IACE,cAAc,EAAE;;AAEpB;+EAC+E;AAC/E;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,sBAAsB,EAAE;EACxB;IACE,wBAAwB;IACxB,mBAAmB,EAAE;EACvB;IACE,wBAAwB;IACxB,mBAAmB,EAAE;;AAEzB;+EAC+E;AAC/E;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;;IAEE,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe,EAAE;;AAErB;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;EACX,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB,EAAE;EACvB;IACE,wBAAwB;IACxB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,0FAA0F,EAAE;EAC9F;IACE,4BAA4B,EAAE;EAChC;IACE,4BAA4B,EAAE;EAChC;IACE,4BAA4B,EAAE;EAChC;IACE,4BAA4B,EAAE;;AAElC;EACE,gBAAgB;EAChB,mBAAmB,EAAE;;AAEvB;+EAC+E;AAC/E;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;+EAC+E;AAC/E;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc,EAAE;;AAElB;;EAEE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;;EAEE,yGAAyG,EAAE;;AAE7G,mBAAmB;AACnB;EACE,WAAW,EAAE;;AAEf;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE,qBAAqB;IACrB,cAAc,EAAE;;AAEpB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe,EAAE;;AAEnB,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB,EAAE;;AAEpB;EACE,UAAU,EAAE;;AAEd;+EAC+E;AAC/E;EACE,6BAA6B,EAAE;;AAEjC;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B,EAAE;;AAElC;+EAC+E;AAC/E;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,gBAAgB,EAAE;;AAEpB;EACE,6BAA6B;EAC7B,WAAW,EAAE;;AAEf;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,wBAAwB,EAAE;;AAE5B;EACE,4BAA4B,EAAE;;AAEhC;EACE,6BAA6B,EAAE;;AAEjC;EACE,2BAA2B,EAAE;;AAE/B;EACE,6BAA6B,EAAE;;AAEjC;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,wBAAwB,EAAE;;AAE5B;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,oBAAoB,EAAE;;AAExB;EACE,qBAAqB,EAAE;;AAEzB;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;EACxC,sFAAsF;EACtF,wFAAwF,EAAE;EAC1F;IACE;;MAEE,2FAA2F;MAC3F,kCAAkC,EAAE,EAAE;;AAE5C;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;EACxC,qFAAqF;EACrF,uFAAuF,EAAE;EACzF;IACE;;MAEE,0FAA0F;MAC1F,kCAAkC,EAAE,EAAE;;AAE5C;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;EACxC,wFAAwF;EACxF,0FAA0F,EAAE;EAC5F;IACE;;MAEE,6FAA6F;MAC7F,kCAAkC,EAAE,EAAE;;AAE5C;;CAEC;AACD;;;CAGC;AACD,8CAA8C;AAC9C;EACE,iBAAiB,EAAE;;AAErB;;;CAGC;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;+EAC+E;AAC/E;EACE,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE;AACF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,UAAU,EAAE;;AAEd;EACE,UAAU,EAAE;;AAEd;;;;;+EAK+E;AAC/E;EACE,mBAAmB,EAAE;;AAEvB;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qBAAqB,EAAE;;AAEzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B,EAAE;;AAE/B;EACE,qBAAqB,EAAE;;AAEzB;;EAEE,qBAAqB;EACrB,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,YAAY,EAAE;;AAEhB;EACE,wBAAwB,EAAE;;AAE5B;EACE,wBAAwB,EAAE;;AAE5B;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;;EAEE,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,gBAAgB;EAChB,iBAAiB,EAAE;;AAErB;;EAEE,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB;EACjB,oBAAoB,EAAE;;AAExB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB,EAAE;EACvB;IACE,0FAA0F,EAAE;;AAEhG;;;;;6EAK6E;AAC7E;EACE;IACE,cAAc;IACd,WAAW;IACX,mBAAmB,EAAE,EAAE;;AAE3B;;+EAE+E;AAC/E;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,SAAS,EAAE;;AAEb;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,WAAW;EACX,YAAY;EACZ,kGAAkG,EAAE;;AAEtG;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW,EAAE;EACb;IACE,gHAAgH,EAAE;;AAEtH;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,SAAS,EAAE;;AAEb;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,WAAW;EACX,YAAY;EACZ,kGAAkG,EAAE;;AAEtG;+EAC+E;AAC/E;EACE;IACE,iBAAiB;IACjB,gCAAgC,EAAE;EACpC;IACE,gBAAgB,EAAE,EAAE;;AAExB;;+EAE+E;AAC/E;EACE,iCAAiC;EACjC;IACE,aAAa,EAAE,EAAE;;AAErB,cAAc;AACd;EACE,2BAA2B;EAC3B,mBAAmB,EAAE;;AAEvB;EACE,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB,EAAE;;AAE7B;EACE,2CAA2C;EAC3C,mCAAmC,EAAE;;AAEvC;EACE,8BAA8B;EAC9B,sBAAsB,EAAE;;AAE1B;EACE;IACE,uEAAuE;IACvE,+DAA+D;IAC/D,uCAAuC;IACvC,+BAA+B,EAAE;EACnC;IACE,0EAA0E;IAC1E,kEAAkE;IAClE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0EAA0E;IAC1E,kEAAkE;IAClE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,uEAAuE;IACvE,+DAA+D;IAC/D,uCAAuC;IACvC,+BAA+B,EAAE;EACnC;IACE,0EAA0E;IAC1E,kEAAkE;IAClE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0EAA0E;IAC1E,kEAAkE;IAClE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B,EAAE;;AAEnC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB,6EAA6E;AAC7E;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,uCAAuC;IACvC,+BAA+B,EAAE;EACnC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,uCAAuC;IACvC,+BAA+B,EAAE;EACnC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB;EACE;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,mCAAmC;IACnC,2BAA2B,EAAE;EAC/B;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,4BAA4B;EAC5B,oBAAoB,EAAE;;AAExB,6EAA6E;AAC7E;EACE;IACE,uBAAuB;IACvB,eAAe,EAAE;EACnB;IACE,mEAAmE;IACnE,2DAA2D,EAAE;EAC/D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,mEAAmE;IACnE,2DAA2D,EAAE;EAC/D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,uBAAuB;IACvB,eAAe,EAAE;EACnB;IACE,mEAAmE;IACnE,2DAA2D,EAAE;EAC/D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,mEAAmE;IACnE,2DAA2D,EAAE;EAC/D;IACE,iEAAiE;IACjE,yDAAyD,EAAE;EAC7D;IACE,kEAAkE;IAClE,0DAA0D,EAAE;EAC9D;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,8BAA8B;EAC9B,sBAAsB,EAAE;;AAE1B;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,uCAAuC;IACvC,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,uCAAuC;IACvC,+BAA+B,EAAE,EAAE;;AAEvC;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE,EAAE;;AAEzC;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE,sCAAsC;EACtC,8BAA8B,EAAE;;AAElC;EACE;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE;IACE,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,8BAA8B;EAC9B,sBAAsB,EAAE;;AAE1B;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE;EACzC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,sCAAsC;EACtC,8BAA8B,EAAE;;AAElC;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE;EACxC;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE,sCAAsC;EACtC,8BAA8B,EAAE;;AAElC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE,EAAE;;AAE3C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE,EAAE;;AAE3C;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE,sCAAsC;EACtC,8BAA8B,EAAE;;AAElC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC,EAAE,EAAE;;AAE5C;EACE,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE,EAAE;;AAE3C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC,EAAE,EAAE;;AAE3C;EACE,iCAAiC;EACjC,yBAAyB,EAAE;;AAE7B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC,EAAE,EAAE;;AAE7C;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,gEAAgE;IAChE,wDAAwD;IACxD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yFAAyF;IACzF,iFAAiF;IACjF,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yFAAyF;IACzF,iFAAiF;IACjF,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE;IACE,gEAAgE;IAChE,wDAAwD;IACxD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yFAAyF;IACzF,iFAAiF;IACjF,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,yFAAyF;IACzF,iFAAiF;IACjF,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,0CAA0C;IAC1C,kCAAkC,EAAE;EACtC;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,0CAA0C;IAC1C,kCAAkC,EAAE,EAAE;;AAE1C;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB,EAAE;;AAExB;EACE;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD,EAAE;EAC1D;IACE,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD,EAAE;EAC1D;IACE,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;EACE;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD,EAAE;EAC1D;IACE,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,2CAA2C;IAC3C,mCAAmC,EAAE;EACvC;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD,EAAE;EAC1D;IACE,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;EACE;IACE,qCAAqC;IACrC,6BAA6B,EAAE;EACjC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B,EAAE;EACjC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE,EAAE;;AAElB;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;EAChC,wBAAwB;EACxB,+CAA+C;EAC/C,uCAAuC,EAAE;;AAE3C;EACE;IACE,qCAAqC;IACrC,6BAA6B,EAAE;EACjC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B,EAAE;EACjC;IACE,+DAA+D;IAC/D,uDAAuD;IACvD,UAAU,EAAE;EACd;IACE,8DAA8D;IAC9D,sDAAsD;IACtD,UAAU,EAAE,EAAE;;AAElB;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,wDAAwD;IACxD,gDAAgD;IAChD,UAAU,EAAE;EACd;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU,EAAE;EACd;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU,EAAE;EACd;IACE,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,wDAAwD;IACxD,gDAAgD;IAChD,UAAU,EAAE;EACd;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU,EAAE;EACd;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU,EAAE;EACd;IACE,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,2CAA2C;EAC3C,mCAAmC,EAAE;;AAEvC;EACE;IACE,UAAU,EAAE;EACd;IACE,uDAAuD;IACvD,+CAA+C;IAC/C,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,uDAAuD;IACvD,+CAA+C;IAC/C,UAAU,EAAE,EAAE;;AAElB;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,0CAA0C;EAC1C,kCAAkC,EAAE;;AAEtC;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,6CAA6C;IAC7C,qCAAqC;IACrC,UAAU,EAAE;EACd;IACE,gCAAgC;IAChC,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,6CAA6C;IAC7C,qCAAqC;IACrC,UAAU,EAAE;EACd;IACE,gCAAgC;IAChC,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,wCAAwC;EACxC,gCAAgC,EAAE;;AAEpC;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,yCAAyC;EACzC,iCAAiC,EAAE;;AAErC;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,sCAAsC;EACtC,8BAA8B,EAAE;;AAElC;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,UAAU,EAAE,EAAE;;AAElB;EACE,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,UAAU,EAAE;EACd;IACE,gCAAgC;IAChC,wBAAwB;IACxB,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,UAAU,EAAE;EACd;IACE,gCAAgC;IAChC,wBAAwB;IACxB,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE,iCAAiC;EACjC,yBAAyB,EAAE;;AAE7B;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE,yCAAyC;EACzC,iCAAiC,EAAE;;AAErC;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE,0CAA0C;EAC1C,kCAAkC,EAAE;;AAEtC;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU,EAAE;EACd;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,4CAA4C;IAC5C,oCAAoC;IACpC,UAAU,EAAE,EAAE;;AAElB;EACE,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU,EAAE;EACd;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE,wCAAwC;EACxC,gCAAgC,EAAE;;AAEpC;EACE;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC,EAAE;EAC1C;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC,EAAE;EAC1C;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;IACtC,UAAU,EAAE;EACd;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC,EAAE;EAC1C;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC,EAAE;EAC1C;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;IACtC,UAAU,EAAE;EACd;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU,EAAE,EAAE;;AAElB;EACE,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB,6EAA6E;AAC7E;EACE;IACE,UAAU;IACV,sEAAsE;IACtE,8DAA8D,EAAE;EAClE;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,sEAAsE;IACtE,8DAA8D,EAAE;EAClE;IACE,UAAU;IACV,uBAAuB;IACvB,eAAe,EAAE,EAAE;;AAEvB;EACE,8BAA8B;EAC9B,sBAAsB,EAAE;;AAE1B,6EAA6E;AAC7E;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D,EAAE,EAAE;;AAEpE;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D,EAAE,EAAE;;AAEpE;EACE,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;EACE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,8BAA8B;EAC9B,sBAAsB,EAAE;;AAE1B;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,gCAAgC;EAChC,wBAAwB,EAAE;;AAE5B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC,EAAE;EACrC;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,+BAA+B;EAC/B,uBAAuB,EAAE;;AAE3B;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,wDAAwD;IACxD,gDAAgD;IAChD,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D,EAAE;EACnE;IACE,UAAU;IACV,wDAAwD;IACxD,gDAAgD;IAChD,qCAAqC;IACrC,6BAA6B,EAAE,EAAE;;AAErC;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE,EAAE;EACpE;IACE,UAAU;IACV,uDAAuD;IACvD,+CAA+C;IAC/C,sCAAsC;IACtC,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE,EAAE;EACpE;IACE,UAAU;IACV,uDAAuD;IACvD,+CAA+C;IAC/C,sCAAsC;IACtC,8BAA8B,EAAE,EAAE;;AAEtC;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,yEAAyE;IACzE,iEAAiE,EAAE;EACrE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D,EAAE,EAAE;;AAEtE;EACE,iCAAiC;EACjC,yBAAyB,EAAE;;AAE7B;EACE;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE;IACE,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB,EAAE;EACvB;IACE,gCAAgC;IAChC,wBAAwB,EAAE,EAAE;;AAEhC;EACE,iCAAiC;EACjC,yBAAyB,EAAE;;AAE7B;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B,EAAE,EAAE;;AAEpC;EACE,oCAAoC;EACpC,4BAA4B,EAAE;;AAEhC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,mCAAmC;IACnC,2BAA2B,EAAE,EAAE;;AAEnC;EACE,qCAAqC;EACrC,6BAA6B,EAAE;;AAEjC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,gCAAgC;IAChC,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B,EAAE,EAAE;;AAEpC;EACE,kCAAkC;EAClC,0BAA0B,EAAE;;AAE9B;+EAC+E;AAC/E;EACE,iBAAiB,EAAE;;AAErB;+EAC+E;AAC/E;EACE,WAAW;EACX,cAAc,EAAE;EAChB;IACE,qBAAqB;IACrB,mBAAmB,EAAE;EACvB;IACE;MACE,cAAc,EAAE;MAChB;QACE,mBAAmB,EAAE,EAAE;;AAE/B;;EAEE,WAAW,EAAE;EACb;;;IAGE,iBAAiB,EAAE;;AAEvB;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,gBAAgB,EAAE;;AAEpB;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,SAAS,EAAE;;AAEf;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU;EACV,gBAAgB,EAAE;;AAEpB;;+EAE+E;AAC/E,wBAAwB;AACxB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY,EAAE;;AAEhB;EACE,wBAAwB;EACxB,eAAe,EAAE;;AAEnB;;+EAE+E;AAC/E;EACE,gBAAgB,EAAE;;AAEpB;EACE,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW,EAAE;EACf;IACE,YAAY,EAAE;;AAElB;;+EAE+E;AAC/E;;;;;;EAME,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;;;EAGE,WAAW;EACX,sFAAsF;EACtF,mFAAmF;EACnF,8EAA8E;EAC9E,yBAAyB;EACzB,UAAU,EAAE;;AAEd,uBAAuB;AACvB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;;AAEtB;EACE,0BAA0B,EAAE;;AAE9B;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,UAAU;EACV,iBAAiB,EAAE;EACnB;IACE,YAAY;IACZ,aAAa,EAAE;EACjB;IACE,cAAc;IACd,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB,EAAE;IACpB;MACE,YAAY,EAAE;;AAEpB;EACE,cAAc,EAAE;EAChB;IACE,YAAY;IACZ,iBAAiB;IACjB,WAAW,EAAE;IACb;MACE,YAAY,EAAE;;AAEpB,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE,EAAE;;AAExB;+EAC+E;AAC/E;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,eAAe,EAAE;;AAErB;EACE,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB,EAAE;IACpB;MACE,WAAW,EAAE;IACf;MACE,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,cAAc;MACd,iBAAiB;MACjB,eAAe,EAAE;;AAEvB;EACE,gBAAgB;EAChB,eAAe,EAAE;EACjB;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa,EAAE;EACf;IACE,mBAAmB,EAAE;IACrB;MACE,SAAS;MACT,gBAAgB;MAChB,eAAe;MACf,cAAc,EAAE;IAClB;MACE,eAAe;MACf,cAAc;MACd,WAAW;MACX,gBAAgB,EAAE;;AAExB;+EAC+E;AAC/E;EACE,iBAAiB,EAAE;;AAErB;+EAC+E;AAC/E;EACE,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;;AAEvB;+EAC+E;AAC/E;EACE,iBAAiB,EAAE;;AAErB;EACE,8BAA8B,EAAE;;AAElC;EACE,yBAAyB,EAAE;;AAE7B;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB,EAAE;EACvB;IACE,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAE;EACzB;IACE,iBAAiB;IACjB,aAAa,EAAE;EACjB;IACE;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE,eAAe;EACf,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,aAAa,EAAE;EACf;IACE,mBAAmB,EAAE;EACvB;IACE,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,gBAAgB,EAAE;IAClB;MACE;QACE,uBAAuB;QACvB,cAAc;QACd,gBAAgB;QAChB,gBAAgB,EAAE;MACpB;QACE,cAAc;QACd,eAAe,EAAE;MACnB;QACE,aAAa,EAAE,EAAE;;AAEzB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,sBAAsB,EAAE;;AAE1B;EACE,SAAS,EAAE;;AAEb;EACE,YAAY,EAAE;;AAEhB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY,EAAE;;AAEhB;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc,EAAE;;AAElB;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,qFAAqF;EACrF,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB,EAAE;;AAErB;EACE,YAAY;EACZ,aAAa;EACb,yEAAyE;EACzE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,aAAa,EAAE;EACf;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAE;EACpB;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe,EAAE;;AAErB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0FAA0F;EAC1F,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB,EAAE;EACtB;IACE,yBAAyB,EAAE;;AAE/B;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB,EAAE;EACpB;IACE,aAAa,EAAE;IACf;MACE,aAAa,EAAE;EACnB;IACE,uCAAuC,EAAE;IACzC;MACE,UAAU,EAAE;;AAElB;EACE;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE,EAAE;;AAEvB;EACE,gFAAgF;EAChF,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;EACb,kDAAkD,EAAE;;AAEtD;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,UAAU,EAAE;;AAEd;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,UAAU,EAAE;;AAEd,cAAc;AACd;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC,EAAE;;AAEtC;EACE;IACE,4BAA4B,EAAE;EAChC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,+BAA+B,EAAE;EACnC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,+BAA+B;IAC/B,uBAAuB,EAAE;EAC3B;IACE,iCAAiC;IACjC,yBAAyB,EAAE,EAAE;;AAEjC;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qCAAqC,EAAE;;AAEzC;EACE,WAAW,EAAE;;AAEf;EACE,yFAAyF,EAAE;;AAE7F;EACE,qFAAqF,EAAE;;AAEzF;EACE,+FAA+F;EAC/F,2LAA2L;EAC3L,sJAAsJ;EACtJ,mJAAmJ;EACnJ,8IAA8I,EAAE;;AAElJ;EACE,yFAAyF,EAAE;;AAE7F,qBAAqB;AACrB;EACE;;;;IAIE,wFAAwF,EAAE,EAAE;;AAEhG;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,0CAA0C;EAC1C,4CAA4C;EAC5C,yCAAyC;EACzC,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;EACpC,iEAAiE;EACjE,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,yDAAyD,EAAE;EAC3D;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;;AAEvB;EACE,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,8CAA8C;EAC9C,sCAAsC,EAAE;;AAE1C;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,UAAU;EACV,8CAA8C;EAC9C,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;EAClC,iEAAiE;EACjE,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,yDAAyD,EAAE;EAC3D;IACE,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B,EAAE;EACnC;IACE,UAAU;IACV,SAAS,EAAE;EACb;IACE,aAAa,EAAE;EACjB;IACE,UAAU,EAAE;EACd;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS,EAAE;IACX;MACE,YAAY,EAAE;IAChB;MACE,+BAA+B,EAAE;IACnC;MACE,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,uBAAuB;MACvB,4BAA4B;MAC5B,yBAAyB,EAAE;;AAEjC;EACE,kBAAkB,EAAE;;AAEtB;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE;EACd;IACE,cAAc,EAAE;;AAEpB;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,gBAAgB,EAAE;EAClB;IACE,aAAa,EAAE;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE;EACxB;IACE,iBAAiB;IACjB,kBAAkB,EAAE;EACtB;;;IAGE,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,kEAAkE;IAClE,kHAAkH;IAClH,qEAAqE;IACrE,iEAAiE;IACjE,gEAAgE;IAChE,gHAAgH;IAChH,6DAA6D,EAAE;EACjE;IACE,WAAW,EAAE;IACb;MACE,gCAAgC;MAChC,WAAW,EAAE;EACjB;IACE,gBAAgB,EAAE;IAClB;MACE,gBAAgB,EAAE;IACpB;MACE,6BAA6B,EAAE;EACnC;IACE,eAAe,EAAE;IACjB;MACE,iBAAiB;MACjB,iBAAiB;MACjB,WAAW;MACX,kBAAkB,EAAE;;AAE1B;;;;;EAKE;AACF;EACE,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,iBAAiB,EAAE;;AAErB;;;;;;EAME,yCAAyC;EACzC,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO,EAAE;;AAEX;;;EAGE,oEAAoE;EACpE,0CAA0C;EAC1C,kCAAkC,EAAE;;AAEtC;;;EAGE,mDAAmD;EACnD,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;;;EAGE,iDAAiD;EACjD,2CAA2C;EAC3C,mCAAmC,EAAE;;AAEvC;;;;;EAKE,yCAAyC;EACzC,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO,EAAE;;AAEX;;;EAGE,kEAAkE;EAClE,2CAA2C;EAC3C,mCAAmC,EAAE;;AAEvC;;;EAGE,kDAAkD;EAClD,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;;;EAGE,kDAAkD;EAClD,0CAA0C;EAC1C,kCAAkC,EAAE;;AAEtC;EACE,mBAAmB,EAAE;;AAEvB;EACE,eAAe,EAAE;;AAEnB;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB,EAAE;;AAErB;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB,EAAE;;AAEzB;;;;EAIE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc,EAAE;EAChB;IACE,kBAAkB;IAClB,YAAY,EAAE;EAChB;IACE,YAAY,EAAE;EAChB;IACE;MACE,iBAAiB;MACjB,aAAa,EAAE,EAAE;EACrB;IACE;MACE,iBAAiB;MACjB,aAAa,EAAE,EAAE;EACrB;IACE;MACE,cAAc;MACd,WAAW;MACX,WAAW;MACX,kBAAkB,EAAE;IACtB;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB,EAAE;EACtB;IACE,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAoB,EAAE;IACtB;MACE;QACE,WAAW;QACX,UAAU,EAAE,EAAE;IAClB;MACE,qBAAqB;MACrB,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB,EAAE;EACvB;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB,EAAE;IACnB;MACE;QACE,WAAW;QACX,UAAU,EAAE,EAAE;IAClB;MACE,gBAAgB,EAAE;IACpB;MACE;QACE,gBAAgB,EAAE;QAClB;UACE,WAAW;UACX,eAAe;UACf,cAAc,EAAE,EAAE;;AAE5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,iBAAiB,EAAE;EACnB;IACE,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc,EAAE;IAChB;MACE,mBAAmB,EAAE;IACvB;MACE,UAAU,EAAE;IACd;MACE,eAAe;MACf,iBAAiB,EAAE;MACnB;QACE,cAAc,EAAE;IACpB;MACE,iBAAiB;MACjB,eAAe;MACf,eAAe;MACf,mBAAmB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE;;AAE1B;EACE,cAAc;EACd,eAAe,EAAE;EACjB;IACE,sBAAsB,EAAE;EAC1B;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,YAAY,EAAE;;AAElB;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW,EAAE;EACb;IACE,WAAW,EAAE;;AAEjB;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,WAAW,EAAE;EACb;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB,EAAE;IACpB;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE,cAAc,EAAE;MAChB;QACE,WAAW;QACX,YAAY,EAAE;EACpB;IACE,eAAe,EAAE;EACnB;IACE,cAAc,EAAE;EAClB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS,EAAE;IACX;MACE,UAAU,EAAE;;AAElB;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB,EAAE;;AAErB;EACE,wBAAwB,EAAE;;AAE5B;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kDAAkD;EAClD,uCAAuC,EAAE;;AAE3C;EACE,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;+EAC+E;AAC/E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY,EAAE;EACd;IACE,yBAAyB,EAAE;EAC7B;;IAEE,SAAS;IACT,iBAAiB,EAAE;EACrB;IACE,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB,EAAE;EACpB;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe,EAAE;IACjB;MACE,eAAe,EAAE;;AAEvB;EACE,WAAW;EACX,WAAW;EACX,WAAW,EAAE;EACb;IACE,SAAS,EAAE;IACX;MACE,0BAA0B,EAAE;IAC9B;MACE,0BAA0B,EAAE;;AAElC;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,wBAAwB,EAAE;EAC1B;IACE,SAAS,EAAE;IACX;MACE,0BAA0B,EAAE;IAC9B;MACE,0BAA0B,EAAE;;AAElC;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW,EAAE;EACb;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,WAAW,EAAE;IACb;MACE,4BAA4B,EAAE;IAChC;MACE,cAAc;MACd,WAAW;MACX,kBAAkB,EAAE;;AAE1B;+EAC+E;AAC/E;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,YAAY;EACZ,gCAAgC,EAAE;;AAEpC;+EAC+E;AAC/E;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,aAAa;EACb,aAAa,EAAE;EACf;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,SAAS;IACT,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB,EAAE;EACrB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,YAAY,EAAE;;AAElB;+EAC+E;AAC/E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,qBAAqB;IACrB,sBAAsB,EAAE;EAC1B;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB,EAAE;;AAE5B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iGAAiG;EACjG,yFAAyF;EACzF,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B,EAAE;EACjC;IACE,kBAAkB;IAClB,SAAS,EAAE;IACX;MACE,cAAc;MACd,iBAAiB,EAAE;EACvB;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0FAA0F;IAC1F,kCAAkC;IAClC,mCAAmC;IACnC,oCAAoC;IACpC,uCAAuC;IACvC,+BAA+B,EAAE;EACnC;IACE,yBAAyB;IACzB,2FAA2F,EAAE;IAC7F;MACE,UAAU,EAAE;;AAElB;EACE;IACE,aAAa,EAAE,EAAE;;AAErB;EACE;IACE,aAAa,EAAE;EACjB;IACE,eAAe,EAAE;EACnB;IACE,YAAY;IACZ,WAAW,EAAE,EAAE;;AAEnB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE,iBAAiB;IACjB,gBAAgB,EAAE;EACpB;IACE;MACE,iBAAiB,EAAE,EAAE;EACzB;IACE;MACE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,mBAAmB;EACnB,oBAAoB,EAAE;EACtB;IACE;MACE,iBAAiB,EAAE,EAAE;EACzB;IACE;MACE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,WAAW,EAAE;;AAEf;+EAC+E;AAC/E;EACE,WAAW;EACX,eAAe,EAAE;EACjB;IACE,cAAc;IACd,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,sBAAsB,EAAE;IACxB;MACE,cAAc,EAAE;IAClB;MACE,qBAAqB;MACrB,sBAAsB,EAAE;EAC5B;IACE,YAAY,EAAE;EAChB;IACE,mBAAmB,EAAE;EACvB;IACE,eAAe,EAAE;IACjB;MACE,aAAa,EAAE;EACnB;IACE,mBAAmB;IACnB,WAAW,EAAE;IACb;MACE,WAAW,EAAE;IACf;MACE,WAAW,EAAE;;AAEnB;+EAC+E;AAC/E;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,gBAAgB,EAAE;;AAEtB;;;;;+EAK+E;AAC/E;EACE,YAAY,EAAE;;AAEhB;EACE,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,iBAAiB,EAAE;EACnB;IACE,cAAc,EAAE;IAChB;MACE,qBAAqB,EAAE;;AAE7B;EACE,SAAS,EAAE;;AAEb;EACE,aAAa,EAAE;;AAEjB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,sBAAsB,EAAE;EACxB;IACE,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE;;AAExB;EACE,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,WAAW,EAAE;;AAEjB;EACE,2BAA2B,EAAE;;AAE/B;EACE,sBAAsB,EAAE;;AAE1B;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB,EAAE;EACxB;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,mBAAmB;IACnB,WAAW,EAAE;IACb;MACE,WAAW,EAAE;IACf;MACE,WAAW,EAAE;IACf;MACE,WAAW,EAAE;IACf;MACE,WAAW,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;EACxB;IACE,gBAAgB,EAAE;;AAEtB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,SAAS;IACT,OAAO,EAAE;;AAEb,cAAc;AACd,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,oCAAoC,EAAE;EACtC;IACE,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,WAAW;IACX,uBAAuB;IACvB,gCAAgC;IAChC,SAAS,EAAE;IACX;MACE,gBAAgB;MAChB,WAAW;MACX,wBAAwB;MACxB,cAAc;MACd,gBAAgB,EAAE;IACpB;MACE,wBAAwB;MACxB,cAAc;MACd,iBAAiB;MACjB,sBAAsB;MACtB,WAAW;MACX,iBAAiB;MACjB,iBAAiB;MACjB,WAAW,EAAE;IACf;;;;MAIE,wBAAwB;MACxB,yBAAyB;MACzB,WAAW;MACX,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,YAAY,EAAE;IAChB;MACE,iBAAiB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB,EAAE;EACrB;IACE,0BAA0B,EAAE;EAC9B;IACE,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kCAAkC,EAAE;IACpC;MACE,yBAAyB;MACzB,kCAAkC,EAAE;IACtC;MACE,gBAAgB,EAAE;IACpB;MACE;QACE,UAAU;QACV,WAAW,EAAE,EAAE;EACrB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB,EAAE;IACpB;MACE,qDAAqD;MACrD,sBAAsB;MACtB,2BAA2B;MAC3B,aAAa;MACb,WAAW;MACX,4BAA4B;MAC5B,2BAA2B,EAAE;IAC/B;MACE,aAAa;MACb,WAAW,EAAE;IACf;MACE,gBAAgB;MAChB,iBAAiB;MACjB,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE;MACnB;QACE,WAAW;QACX,eAAe,EAAE;MACnB;QACE,+BAA+B,EAAE;MACnC;QACE;UACE,YAAY,EAAE,EAAE;;AAE1B;;EAEE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,8BAA8B,EAAE;;AAElC;EACE,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB,EAAE;IACpB;MACE,cAAc;MACd,iBAAiB;MACjB,eAAe;MACf,sBAAsB,EAAE;IAC1B;MACE,mBAAmB,EAAE;;AAE3B;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,OAAO,EAAE;;AAEX;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,SAAS,EAAE;;AAEb;EACE,mBAAmB;EACnB,eAAe;EACf,gCAAgC,EAAE;EAClC;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE;IACpB;MACE,6BAA6B,EAAE;IACjC;MACE,YAAY;MACZ,gBAAgB,EAAE;IACpB;MACE,YAAY;MACZ,gCAAgC;MAChC,WAAW;MACX,gBAAgB,EAAE;;AAExB;EACE,mBAAmB,EAAE;;AAEvB;EACE,0BAA0B,EAAE;;AAE9B;EACE,4BAA4B,EAAE;;AAEhC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,YAAY,EAAE;EACd;IACE,SAAS;IACT,mBAAmB;IACnB,YAAY,EAAE;EAChB;IACE,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW,EAAE;IACb;MACE,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,cAAc;MACd,iBAAiB;MACjB,gBAAgB,EAAE;;AAExB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,eAAe;IACf,qBAAqB;IACrB,UAAU,EAAE;IACZ;MACE,YAAY;MACZ,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gBAAgB,EAAE;EACtB;IACE,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,cAAc,EAAE;EAClB;IACE;MACE,eAAe,EAAE;MACjB;QACE,iBAAiB,EAAE,EAAE;EAC3B;IACE,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE,mBAAmB,EAAE;IACrB;MACE,qBAAqB;MACrB,eAAe;MACf,iBAAiB,EAAE;;AAEzB;EACE,WAAW;EACX,UAAU,EAAE;;AAEd;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,wDAAwD;EACxD,gDAAgD,EAAE;EAClD;IACE,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU,EAAE;EACd;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,4CAA4C,EAAE;;AAElD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;EACd;IACE,iBAAiB;IACjB,eAAe,EAAE;;AAErB;EACE,+BAA+B;EAC/B,8BAA8B,EAAE;;AAElC;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE;EACd;IACE,gBAAgB;IAChB,uBAAuB,EAAE;IACzB;MACE,SAAS,EAAE;EACf;IACE,UAAU,EAAE;IACZ;MACE,UAAU,EAAE;EAChB;IACE,yBAAyB;IACzB,mBAAmB,EAAE;IACrB;MACE,gBAAgB;MAChB,cAAc,EAAE;IAClB;MACE,YAAY;MACZ,gBAAgB,EAAE;;AAExB;EACE,aAAa;EACb,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,qBAAqB,EAAE;;AAEzB;EACE,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe,EAAE;EACjB;IACE,mBAAmB,EAAE;;AAEzB;EACE,SAAS,EAAE;;AAEb;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,6EAA6E,EAAE;;AAEjF;EACE,YAAY;EACZ,WAAW;EACX,cAAc,EAAE;;AAElB;EACE,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IACzB,WAAW,EAAE;EACf;IACE,cAAc;IACd,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB,EAAE;EACpB;;;;;;;;IAQE,UAAU;IACV,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa,EAAE;;AAEnB;EACE,aAAa,EAAE;EACf;IACE,sBAAsB;IACtB,gBAAgB,EAAE;;AAEtB;EACE,sBAAsB;EACtB,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,6BAA6B,EAAE;;AAEjC,sBAAsB;AACtB;EACE;IACE,aAAa,EAAE;EACjB;IACE,cAAc,EAAE,EAAE;;AAEtB,iBAAiB;AACjB;EACE;IACE,uBAAuB;IACvB,cAAc,EAAE,EAAE;;AAEtB,sDAAsD;AACtD;EACE;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,QAAQ,EAAE;EACZ;IACE,kBAAkB;IAClB,MAAM,EAAE;EACV;IACE,YAAY;IACZ,yBAAyB;IACzB,iBAAiB,EAAE;IACnB;MACE,iBAAiB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,iBAAiB,EAAE;IACnB;MACE,iBAAiB;MACjB,cAAc;MACd,sBAAsB,EAAE;;AAE9B;EACE,gBAAgB,EAAE;EAClB;IACE,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B,EAAE;;AAEnC;EACE,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAE;;AAEb;;EAEE,sBAAsB,EAAE;;AAE1B;EACE,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;EACd;IACE,oBAAoB,EAAE;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,WAAW,EAAE;;AAEf;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE;EACjB;;;;IAIE,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,qBAAqB,EAAE;EACzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BE,UAAU;IACV,gBAAgB;IAChB,eAAe,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ,EAAE;EACV;IACE,aAAa,EAAE;;AAEnB;EACE,mBAAmB,EAAE;EACrB;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ,EAAE;EACZ;IACE,UAAU,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ,EAAE;EACV;IACE,aAAa,EAAE;;AAEnB;EACE,WAAW;EACX,iBAAiB;EACjB,QAAQ,EAAE;;AAEZ;EACE,mBAAmB;EACnB,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,qBAAqB,EAAE;EACvB;IACE,YAAY,EAAE;;AAElB,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,+BAA+B,EAAE;;AAEnC;EACE,qBAAqB;EACrB,iFAAiF;EACjF,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,kBAAkB,EAAE;EACpB;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gCAAgC,EAAE;EACpC;IACE,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,aAAa,EAAE;IACf;MACE,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,kBAAkB,EAAE;EACxB;IACE,cAAc,EAAE;;AAEpB;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW,EAAE;;AAEf;EACE,UAAU,EAAE;;AAEd,UAAU;AACV;EACE;IACE,UAAU;IACV,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB,EAAE,EAAE;;AAEzB,eAAe;AACf;EACE;IACE,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe,EAAE,EAAE;;AAEvB;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,wBAAwB,EAAE;;AAE5B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,iBAAiB,EAAE;;AAEvB;EACE,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,wBAAwB,EAAE;;AAE9B;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAE;EACjB;IACE,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;EAC5B,2CAA2C;EAC3C,8CAA8C;EAC9C,sCAAsC;EACtC,eAAe,EAAE;;AAEnB;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB,EAAE;;AAE3B;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,mBAAmB;EACnB,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,8BAA8B,EAAE;;AAElC;EACE,6BAA6B,EAAE;;AAEjC;EACE,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,2CAA2C,EAAE;EAC7C;IACE,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB,EAAE;EACnB;IACE,UAAU,EAAE;;AAEhB;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,eAAe,EAAE;IACjB;MACE,WAAW;MACX,YAAY;MACZ,qBAAqB,EAAE;IACzB;MACE,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,qBAAqB;MACrB,iBAAiB,EAAE;EACvB;IACE,kBAAkB;IAClB,SAAS,EAAE;EACb;IACE,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;IAChB;MACE,0BAA0B,EAAE;;AAElC;EACE,gBAAgB,EAAE;EAClB;IACE,2BAA2B;IAC3B,+BAA+B,EAAE;IACjC;MACE,uBAAuB,EAAE;;AAE/B;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB,EAAE;;AAErB;EACE,uCAAuC,EAAE;;AAE3C;+EAC+E;AAC/E;;+EAE+E;AAC/E,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,oCAAoC,EAAE;;AAExC,mCAAmC;AACnC;EACE,gBAAgB;EAChB,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc,EAAE;EAChB;IACE,eAAe;IACf,gBAAgB,EAAE;;AAEtB,oBAAoB;AACpB,0BAA0B;AAC1B;EACE,YAAY,EAAE;;AAEhB,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB,EAAE;;AAErB;EACE,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,YAAY,EAAE;;AAEhB,gCAAgC;AAChC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC,EAAE;;AAE5C;EACE,YAAY,EAAE;EACd;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU,EAAE;EACd;IACE,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,YAAY,EAAE;EAChB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa,EAAE;EACjB;IACE,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,cAAc,EAAE;IAChB;MACE,eAAe;MACf,gBAAgB,EAAE;EACtB;IACE,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kBAAkB,EAAE;IACpB;MACE,iBAAiB;MACjB,cAAc,EAAE;;AAEtB;EACE,qBAAqB;EACrB,iBAAiB,EAAE;;AAErB;EACE,WAAW,EAAE;;AAEf;EACE;;iFAE+E;EAC/E;;iFAE+E;EAC/E;;8EAE4E;EAC5E;;IAEE;EACF,aAAa;EACb;8EAC4E;EAC5E;;IAEE;EACF;;IAEE,EAAE;EACJ;IACE,+BAA+B,EAAE;EACnC;IACE,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB,EAAE;IAClB;MACE,iBAAiB;MACjB,SAAS;MACT,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,sBAAsB,EAAE;MACxB;QACE,cAAc,EAAE;EACtB;IACE,kBAAkB,EAAE;EACtB;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,UAAU;IACV,yBAAyB,EAAE;EAC7B;IACE,kBAAkB,EAAE;EACtB;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,6BAA6B,EAAE;EACjC;IACE,eAAe,EAAE;EACnB;IACE,aAAa;IACb,eAAe,EAAE;EACnB;IACE,WAAW;IACX,cAAc;IACd,WAAW,EAAE;EACf;IACE,YAAY,EAAE;EAChB;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB,EAAE;EACpB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE;MACE,gBAAgB;MAChB,WAAW;MACX,wBAAwB;MACxB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB,EAAE;IACtB;MACE,WAAW,EAAE,EAAE;EACnB;IACE;MACE,gBAAgB,EAAE;IACpB;MACE,WAAW,EAAE;IACf;MACE,gBAAgB,EAAE;IACpB;MACE,gBAAgB;MAChB,WAAW;MACX,wBAAwB;MACxB,eAAe,EAAE,EAAE;EACvB;IACE,iBAAiB,EAAE;EACrB;IACE,mBAAmB,EAAE;EACvB;IACE,eAAe;IACf,qBAAqB,EAAE;;AAE3B;EACE,kBAAkB,EAAE;EACpB;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB,EAAE;IACpB;MACE,SAAS;MACT,UAAU,EAAE;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY,EAAE;;AAEhB;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,yBAAyB,EAAE;;AAE7B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,cAAc,EAAE;EAChB;IACE;MACE,kBAAkB;MAClB,YAAY,EAAE,EAAE;;AAEtB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,SAAS,EAAE;;AAEb;EACE,UAAU,EAAE;EACZ;IACE,UAAU;IACV,eAAe,EAAE;;AAErB;EACE,WAAW,EAAE;EACb;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,cAAc,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,qBAAqB;EACrB,6BAA6B,EAAE;EAC/B;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW,EAAE;IACb;MACE,qBAAqB,EAAE;IACzB;MACE,qBAAqB,EAAE;IACzB;MACE,cAAc,EAAE;IAClB;MACE,aAAa,EAAE;EACnB;IACE,0BAA0B,EAAE;EAC9B;IACE,qBAAqB;IACrB,iBAAiB,EAAE;EACrB;IACE,cAAc;IACd,iBAAiB,EAAE;IACnB;MACE,cAAc,EAAE;EACpB;IACE,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB,EAAE;IACrB;MACE,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,WAAW,EAAE;IACf;MACE,WAAW,EAAE;IACf;MACE,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,eAAe;MACf,SAAS;MACT,6BAA6B;MAC7B,UAAU;MACV,iBAAiB;MACjB,iBAAiB;MACjB,eAAe;MACf,yBAAyB;MACzB,sBAAsB;MACtB,qBAAqB;MACrB,iBAAiB,EAAE;IACrB;MACE,SAAS;MACT,iBAAiB,EAAE;MACnB;QACE,cAAc,EAAE;MAClB;QACE,6BAA6B,EAAE;MACjC;QACE,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB,EAAE;EAC/B;IACE,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe,EAAE;IACjB;MACE,aAAa;MACb,WAAW;MACX,eAAe,EAAE;IACnB;MACE,WAAW,EAAE;IACf;MACE,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB,EAAE;IACvB;MACE,eAAe,EAAE;IACnB;MACE,6BAA6B,EAAE;EACnC;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE;IACpB;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,sBAAsB,EAAE;MACxB;QACE,yBAAyB,EAAE;MAC7B;QACE,yBAAyB,EAAE;MAC7B;QACE,yBAAyB,EAAE;MAC7B;QACE,yBAAyB,EAAE;IAC/B;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,SAAS;MACT,iBAAiB;MACjB,YAAY,EAAE;MACd;QACE,iBAAiB,EAAE;MACrB;QACE,cAAc,EAAE;IACpB;MACE,YAAY;MACZ,WAAW;MACX,iBAAiB;MACjB,iBAAiB,EAAE;EACvB;IACE,UAAU;IACV,gBAAgB,EAAE;IAClB;MACE,SAAS;MACT,aAAa;MACb,0BAA0B,EAAE;EAChC;IACE,sBAAsB;IACtB,kBAAkB,EAAE;IACpB;MACE,gBAAgB,EAAE;EACtB;IACE,sBAAsB,EAAE;EAC1B;IACE,WAAW;IACX,YAAY,EAAE;EAChB;IACE,oBAAoB,EAAE;IACtB;MACE,mBAAmB,EAAE;EACzB;IACE,mBAAmB,EAAE;EACvB;IACE,kBAAkB,EAAE;EACtB;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,4CAA4C;IAC5C,sBAAsB,EAAE;EAC1B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB,EAAE;EACtB;IACE;MACE,cAAc;MACd,kBAAkB,EAAE;IACtB;MACE,cAAc,EAAE;IAClB;MACE,iBAAiB,EAAE;MACnB;QACE,yBAAyB,EAAE;MAC7B;QACE,aAAa,EAAE;MACjB;QACE,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,QAAQ,EAAE;MACZ;QACE,cAAc;QACd,eAAe,EAAE;QACjB;UACE,0BAA0B;UAC1B,WAAW;UACX,iBAAiB,EAAE;MACvB;QACE,WAAW;QACX,kBAAkB,EAAE,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,WAAW;EACX,aAAa;EACb,eAAe,EAAE;EACjB;IACE,gCAAgC,EAAE;EACpC;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,eAAe,EAAE;;AAErB;;;;EAIE,wBAAwB,EAAE;;AAE5B;;EAEE,gBAAgB;EAChB,cAAc,EAAE;;AAElB;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAE;;AAEtB;;EAEE,gBAAgB;EAChB,cAAc,EAAE;;AAElB;;EAEE,iBAAiB;EACjB,kBAAkB,EAAE;EACpB;;IAEE,WAAW;IACX,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,6BAA6B;IAC7B,2BAA2B,EAAE;;AAEjC;;EAEE,eAAe,EAAE;;AAEnB;;EAEE,cAAc,EAAE;;AAElB;;EAEE,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,+BAA+B;EAC/B,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,6BAA6B,EAAE;EAC/B;IACE,0BAA0B,EAAE;EAC9B;IACE,cAAc;IACd,cAAc;IACd,UAAU;IACV,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS,EAAE;IACX;MACE;QACE,UAAU;QACV,WAAW;QACX,eAAe;QACf,UAAU,EAAE,EAAE;IAClB;MACE,YAAY;MACZ,iBAAiB;MACjB,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MAC3B,0BAA0B;MAC1B,2BAA2B;MAC3B,4BAA4B,EAAE;MAC9B;QACE;UACE,YAAY;UACZ,iBAAiB,EAAE,EAAE;IAC3B;MACE,YAAY;MACZ,iBAAiB;MACjB,yBAAyB;MACzB,WAAW;MACX,+BAA+B;MAC/B,8BAA8B;MAC9B,kCAAkC,EAAE;MACpC;QACE;UACE,YAAY;UACZ,iBAAiB,EAAE,EAAE;EAC7B;IACE,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB,EAAE;IACpB;MACE,kDAAkD;MAClD,sBAAsB;MACtB,2BAA2B;MAC3B,aAAa;MACb,WAAW;MACX,4BAA4B;MAC5B,2BAA2B,EAAE;IAC/B;MACE,UAAU;MACV,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,mBAAmB;MACnB,iBAAiB;MACjB,WAAW,EAAE;MACb;QACE;UACE,eAAe;UACf,UAAU,EAAE,EAAE;MAClB;QACE,qBAAqB;QACrB,UAAU;QACV,kBAAkB;QAClB,eAAe,EAAE;QACjB;UACE,2BAA2B,EAAE;QAC/B;UACE,cAAc,EAAE;IACtB;MACE,aAAa;MACb,WAAW,EAAE;MACb;QACE,mBAAmB,EAAE;QACrB;UACE,kBAAkB,EAAE;MACxB;QACE,cAAc;QACd,iBAAiB;QACjB,eAAe,EAAE;;AAEzB;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB,EAAE;EACrB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,gCAAgC;IAChC,6BAA6B;IAC7B,iBAAiB;IACjB,4BAA4B;IAC5B,oBAAoB,EAAE;IACtB;MACE,iBAAiB,EAAE;IACrB;MACE,2BAA2B;MAC3B,kBAAkB,EAAE;IACtB;MACE,kBAAkB;MAClB,UAAU;MACV,SAAS,EAAE;IACb;MACE,qBAAqB;MACrB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,SAAS;MACT,6BAA6B;MAC7B,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB,EAAE;MACzB;QACE;UACE,gBAAgB,EAAE,EAAE;IAC1B;MACE;QACE,WAAW;QACX,gBAAgB;QAChB,OAAO;QACP,MAAM,EAAE,EAAE;IACd;MACE;QACE,WAAW;QACX,cAAc;QACd,WAAW;QACX,aAAa,EAAE,EAAE;EACvB;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,oBAAoB;IACpB,+BAA+B,EAAE;IACjC;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,eAAe,EAAE;IACnB;MACE,+BAA+B,EAAE;IACnC;MACE,YAAY,EAAE;MACd;QACE,mBAAmB,EAAE;IACzB;MACE;QACE,2BAA2B,EAAE,EAAE;IACnC;MACE;QACE,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,UAAU,EAAE;QACZ;UACE,+BAA+B,EAAE,EAAE;IACzC;MACE,iBAAiB;MACjB,kBAAkB;MAClB,aAAa,EAAE;IACjB;MACE,wBAAwB;MACxB,0BAA0B,EAAE;MAC5B;QACE;UACE,WAAW,EAAE,EAAE;IACrB;MACE,YAAY,EAAE;IAChB;;MAEE,YAAY;MACZ,eAAe;MACf,4BAA4B;MAC5B,sBAAsB;MACtB,oBAAoB,EAAE;MACtB;QACE;;UAEE,YAAY,EAAE,EAAE;IACtB;MACE,2BAA2B;MAC3B,+BAA+B,EAAE;MACjC;QACE;UACE,eAAe;UACf,+BAA+B,EAAE,EAAE;IACzC;MACE;QACE,0CAA0C,EAAE,EAAE;IAClD;MACE,YAAY;MACZ,UAAU,EAAE;MACZ;QACE,+BAA+B,EAAE;MACnC;QACE;UACE,gCAAgC;UAChC,WAAW;UACX,wBAAwB;UACxB,WAAW;UACX,aAAa,EAAE;UACf;YACE,+BAA+B,EAAE,EAAE;IAC3C;MACE,qCAAqC;MACrC,WAAW;MACX,6BAA6B,EAAE;MAC/B;QACE;UACE,gCAAgC;UAChC,WAAW;UACX,wBAAwB;UACxB,aAAa,EAAE,EAAE;IACvB;MACE,UAAU;MACV,qCAAqC;MACrC,WAAW;MACX,6BAA6B,EAAE;MAC/B;QACE;UACE,gCAAgC;UAChC,WAAW;UACX,wBAAwB;UACxB,cAAc,EAAE,EAAE;EAC1B;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,oEAAoE;IACpE,sBAAsB;IACtB,4DAA4D,EAAE;IAC9D;MACE;QACE,2BAA2B,EAAE,EAAE;IACnC;MACE;QACE,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,cAAc;QACd,WAAW;QACX,WAAW,EAAE,EAAE;EACrB;IACE,wBAAwB;IACxB,OAAO;IACP,kBAAkB,EAAE;EACtB;IACE,qCAAqC;IACrC,WAAW;IACX,6BAA6B,EAAE;EACjC;IACE,cAAc,EAAE;EAClB;IACE;MACE,WAAW,EAAE;IACf;MACE,oCAAoC;MACpC,WAAW;MACX,4BAA4B,EAAE,EAAE;;AAEtC;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB,EAAE;EACnB;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,cAAc;IACd,WAAW,EAAE;EACf;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY,EAAE,EAAE;;AAEpB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,8DAA8D;EAC9D,2DAA2D;EAC3D,sDAAsD,EAAE;EACxD;IACE,kBAAkB;IAClB,QAAQ,EAAE;EACZ;IACE,WAAW,EAAE;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE;EACxC;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,UAAU,EAAE;EACd;IACE,qBAAqB,EAAE;IACvB;MACE,UAAU,EAAE;EAChB;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,+EAA+E,EAAE;EACnF;IACE,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD,EAAE;IACrD;MACE,UAAU;MACV,kBAAkB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,wBAAwB,EAAE;;AAE5B;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,uCAAuC,EAAE;;AAE3C;EACE,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,wBAAwB,EAAE;;AAE5B;EACE,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,uCAAuC,EAAE;;AAE3C;EACE,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,eAAe,EAAE;EACjB;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;;AAErB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE;MACE,YAAY,EAAE;MACd;QACE,YAAY,EAAE;QACd;UACE,gBAAgB,EAAE,EAAE;;AAE9B;EACE,kBAAkB;EAClB,UAAU,EAAE;EACZ;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,iBAAiB,EAAE;EACrB;IACE,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,iBAAiB,EAAE;EACrB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,iBAAiB,EAAE;EACrB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,UAAU;IACV,WAAW;IACX,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,2BAA2B,EAAE;;AAEjC;;EAEE,wBAAwB,EAAE;;AAE5B;;EAEE,WAAW,EAAE;;AAEf;;EAEE,YAAY,EAAE;;AAEhB;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kDAAkD;EAClD,uCAAuC,EAAE;;AAE3C;;EAEE,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,0BAA0B;EAC1B,sBAAsB,EAAE;;AAE1B;EACE,4BAA4B,EAAE;;AAEhC;EACE,sBAAsB,EAAE;;AAE1B;EACE,wBAAwB,EAAE;;AAE5B;EACE,WAAW;EACX,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B,EAAE;EAChC;IACE,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,+BAA+B,EAAE;EACnC;IACE,gBAAgB,EAAE;;AAEtB;+EAC+E;AAC/E;+EAC+E;AAC/E;;;;;iFAKiF;AACjF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB,EAAE;;AAE1B;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,YAAY,EAAE;;AAEhB;EACE,cAAc;EACd,iBAAiB,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;;IAEE,eAAe,EAAE;;AAErB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,EAAE;EACf;IACE,UAAU,EAAE;;AAEhB;EACE,YAAY;EACZ,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,eAAe;IACf,WAAW,EAAE;EACf;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe,EAAE;EACnB;IACE,eAAe;IACf,eAAe,EAAE;;AAErB;EACE,oBAAoB;EACpB,6BAA6B,EAAE;;AAEjC;EACE,aAAa,EAAE;;AAEjB;EACE,eAAe;EACf,cAAc;EACd,cAAc,EAAE;EAChB;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe,EAAE;;AAErB;;+EAE+E;AAC/E;+EAC+E;AAC/E;EACE,gBAAgB,EAAE;;AAEpB;;+EAE+E;AAC/E;;;EAGE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB,EAAE;EACpB;;;IAGE,gBAAgB,EAAE;EACpB;;;;;;IAME,UAAU;IACV,kBAAkB;IAClB,yBAAyB,EAAE;EAC7B;;;IAGE,kBAAkB,EAAE;EACtB;;;IAGE,UAAU,EAAE;;AAEhB;EACE,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,WAAW,EAAE;;AAEf,aAAa;AACb;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB,iBAAiB;AACjB;EACE,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B,EAAE;;AAElC;+EAC+E;AAC/E;EACE;IACE,aAAa,EAAE;EACjB;IACE,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,eAAe,EAAE;EACnB;IACE,cAAc,EAAE,EAAE;;AAEtB;;+EAE+E;AAC/E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAE;;AAEf;EACE,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,WAAW,EAAE;;AAEf;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW,EAAE;EACb;IACE,mBAAmB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,+IAA+I;EAC/I,6GAA6G;EAC7G,yGAAyG,EAAE;;AAE7G;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB,EAAE;EAC3B;IACE,SAAS,EAAE;;AAEf;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAE;;AAEvB;EACE;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU,EAAE;;AAEd;EACE,eAAe;EACf,WAAW,EAAE;;AAEf;EACE;IACE,kBAAkB;IAClB,SAAS,EAAE;IACX;MACE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,qBAAqB;EACrB,wBAAwB,EAAE;;AAE5B;;;EAGE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE;EACb;IACE,kBAAkB;IAClB,aAAa,EAAE;IACf;MACE,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,YAAY,EAAE;EAClB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU,EAAE;IACZ;MACE,oCAAoC,EAAE;EAC1C;IACE,WAAW,EAAE;;AAEjB;EACE,iBAAiB,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;;AAErB,QAAQ;AACR;;EAEE,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B,EAAE;;AAEnC;;CAEC;AACD;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB,EAAE;IAC3B;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAE;IAC7B;MACE,WAAW;MACX,yBAAyB;MACzB,yBAAyB,EAAE;EAC/B;IACE,UAAU;IACV,WAAW,EAAE;EACf;IACE,UAAU;IACV,QAAQ,EAAE;EACZ;IACE,qBAAqB;IACrB,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,qBAAqB;IACrB,OAAO;KACP,eAAgB,EAAE;IAClB;MACE,cAAc;MACd,WAAW;MACX,YAAY;MACZ,eAAe;MACf,WAAW;MACX,mBAAmB;MACnB,mBAAmB;MACnB,yBAAyB,EAAE;MAC3B;QACE,eAAe;QACf,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,YAAY;QACZ,mBAAmB,EAAE;IACzB;MACE,UAAU;MACV,0BAA0B,EAAE;;AAElC;EACE,iBAAiB;EACjB,uDAAuD,EAAE;;AAE3D;EACE,wBAAwB,EAAE;EAC1B;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB,EAAE;IACrB;MACE,cAAc;MACd,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,kBAAkB,EAAE;;AAE1B;EACE;IACE,YAAY,EAAE,EAAE;;AAEpB;;CAEC;AACD;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gCAAgC,EAAE;;AAEpC;EACE,QAAQ;EACR,sBAAsB;EACtB,yBAAyB,EAAE;;AAE7B;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB,EAAE;;AAE7B;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB,EAAE;;AAE7B;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,sBAAsB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;EAClB;IACE,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,eAAe,EAAE;;AAEnB;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,yBAAyB,EAAE;EAC3B;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,QAAQ,EAAE;;AAEd;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,aAAa,EAAE;EACf;IACE,iBAAiB,EAAE;EACrB;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,UAAU;IACV,0BAA0B,EAAE;;AAEhC;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa,EAAE;EACf;IACE,WAAW,EAAE;IACb;MACE,YAAY,EAAE;;AAEpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,wBAAwB,EAAE;;AAE5B;EACE,UAAU;EACV,SAAS,EAAE;;AAEb;EACE,eAAe,EAAE;;AAEnB;EACE,iBAAiB;EACjB,oBAAoB,EAAE;EACtB;IACE,UAAU,EAAE;EACd;IACE,cAAc;IACd,WAAW;IACX,gBAAgB,EAAE;;AAEtB;EACE,OAAO,EAAE;EACT;IACE,8BAA8B;IAC9B,iBAAiB,EAAE;EACrB;IACE,8BAA8B;IAC9B,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,gCAAgC,EAAE;EACpC;IACE,iBAAiB;IACjB,gCAAgC,EAAE;;AAEtC;EACE,QAAQ,EAAE;EACV;IACE,6BAA6B;IAC7B,iBAAiB,EAAE;EACrB;IACE,6BAA6B;IAC7B,iBAAiB,EAAE;EACrB;IACE,+BAA+B,EAAE;EACnC;IACE,+BAA+B,EAAE;;AAErC;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,iBAAiB,EAAE;;AAEvB;EACE,cAAc,EAAE;EAChB;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,SAAS,EAAE;;AAEf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,MAAM;IACN,SAAS,EAAE;EACb;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,8BAA8B;IAC9B,SAAS;IACT,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAE;IACxB;MACE,UAAU,EAAE;EAChB;IACE,UAAU;IACV,QAAQ,EAAE;EACZ;IACE,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,mBAAmB,EAAE;EACvB;IACE,sBAAsB,EAAE;EAC1B;IACE,iBAAiB;IACjB,kBAAkB,EAAE,EAAE;;AAE1B;EACE,UAAU,EAAE;;AAEd;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB,EAAE;;AAEvB;EACE,UAAU,EAAE;;AAEd;EACE,iBAAiB,EAAE;;AAErB;EACE,MAAM;EACN,QAAQ;EACR,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB,SAAS;AACT;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,wEAAwE;EACxE,oBAAoB,EAAE;;AAExB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,wEAAwE;EACxE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B,EAAE;;AAEjC;EACE;IACE,oBAAoB,EAAE;EACxB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;EACE;IACE,oBAAoB,EAAE;EACxB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;EACE;IACE,oBAAoB,EAAE;EACxB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;EACE;IACE,oBAAoB,EAAE;EACxB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;EACE;IACE,oBAAoB,EAAE;EACxB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;;EAEE;AACF;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,qDAAqD;EACrD,SAAS;EACT,YAAY;EACZ,cAAc;EACd,cAAc;EACd,YAAY;EACZ,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE;IACE,uBAAuB,EAAE,EAAE;;AAE/B;EACE;IACE,uBAAuB;IACvB,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,uBAAuB;IACvB,wBAAwB,EAAE,EAAE;;AAEhC;;+EAE+E;AAC/E;+EAC+E;AAC/E;;EAEE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;;EAEE,eAAe,EAAE;;AAEnB;;EAEE,6BAA6B;EAC7B,0BAA0B,EAAE;;AAE9B;EACE,gBAAgB;EAChB,eAAe,EAAE;EACjB;IACE,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,eAAe,EAAE;IACjB;MACE,kBAAkB;MAClB,SAAS;MACT,gBAAgB,EAAE;;AAExB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB,EAAE;;AAEtB;EACE,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;EACjB;IACE,aAAa,EAAE;;AAEnB;;;;EAIE,YAAY;EACZ,eAAe,EAAE;;AAEnB;+EAC+E;AAC/E;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;EAClB;IACE,iBAAiB,EAAE;;AAEvB;EACE,wBAAwB;EACxB,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB,EAAE;;AAErB;EACE,wBAAwB;EACxB,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB,EAAE;;AAErB;;+EAE+E;AAC/E;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE;;AAEtB;;+EAE+E;AAC/E;;EAEE,mBAAmB,EAAE;;AAEvB;;EAEE,gBAAgB;EAChB,iBAAiB,EAAE;;AAErB;;EAEE,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;;;;EAIE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,iBAAiB,EAAE;;AAErB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EAAE;;AAElB;;;;EAIE,eAAe;EACf,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,iBAAiB,EAAE;EACnB;IACE,UAAU,EAAE;EACd;IACE,yBAAyB,EAAE;EAC7B;;;;IAIE,kBAAkB,EAAE;;AAExB;+EAC+E;AAC/E;EACE;;IAEE,mBAAmB;IACnB,oBAAoB,EAAE;IACtB;;MAEE,wBAAwB;MACxB,aAAa,EAAE,EAAE;;AAEvB;;+EAE+E;AAC/E;EACE,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;;+EAE+E;AAC/E;EACE,iBAAiB,EAAE;;AAErB;EACE,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,WAAW;EACX,kBAAkB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,YAAY;IACZ,eAAe,EAAE;;AAErB;EACE,WAAW,EAAE;EACb;IACE,gBAAgB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,cAAc,EAAE;;AAEpB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,4DAA4D,EAAE;;AAEhE;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB,EAAE;EAClB;;IAEE,WAAW,EAAE;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW,EAAE;EACb;IACE,WAAW,EAAE;;AAEjB;EACE,gCAAgC;EAChC,eAAe;EACf,oBAAoB,EAAE;EACtB;IACE,WAAW;IACX,kBAAkB,EAAE;EACtB;IACE,eAAe,EAAE;IACjB;MACE,SAAS;MACT,iBAAiB;MACjB,cAAc,EAAE;MAChB;QACE;UACE,uBAAuB;UACvB,YAAY;UACZ,gBAAgB,EAAE,EAAE;;AAE9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY,EAAE;EACd;IACE,YAAY;IACZ,WAAW,EAAE;EACf;IACE,SAAS,EAAE;IACX;MACE;QACE,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB,EAAE,EAAE;;AAE5B;EACE,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,YAAY,EAAE;EACd;IACE,WAAW;IACX,YAAY,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;EACnB;;IAEE,qBAAqB,EAAE;EACzB;IACE;MACE,cAAc;MACd,sBAAsB;MACtB,WAAW;MACX,gBAAgB;MAChB,mBAAmB;MACnB,mBAAmB,EAAE,EAAE;;AAE7B;EACE,cAAc;EACd,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,mBAAmB;IACnB,mBAAmB;IACnB,UAAU,EAAE;IACZ;MACE,UAAU,EAAE;EAChB;IACE,SAAS;IACT,mBAAmB,EAAE;EACvB;IACE;MACE,cAAc,EAAE;MAChB;QACE,cAAc;QACd,WAAW,EAAE;QACb;UACE,WAAW,EAAE;MACjB;QACE,aAAa,EAAE,EAAE;;AAEzB;EACE,yCAAyC,EAAE;EAC3C;IACE,aAAa,EAAE;EACjB;IACE,oBAAoB,EAAE;;AAE1B;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,WAAW,EAAE;;AAEf;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,yDAAyD;EACzD,sDAAsD;EACtD,iDAAiD,EAAE;EACnD;IACE,mBAAmB;IACnB,yBAAyB,EAAE;IAC3B;MACE,iCAAiC,EAAE;IACrC;MACE,iCAAiC,EAAE;EACvC;IACE,mBAAmB;IACnB,qBAAqB,EAAE;IACvB;MACE,iCAAiC,EAAE;IACrC;MACE,iCAAiC,EAAE;EACvC;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,MAAM,EAAE;EACV;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,UAAU,EAAE;EACd;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,UAAU,EAAE;;AAEhB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,UAAU,EAAE;;AAEd;EACE,YAAY;EACZ,gBAAgB,EAAE;EAClB;IACE,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,YAAY,EAAE;EAChB;IACE;MACE,YAAY,EAAE;IAChB;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE,eAAe,EAAE;EACjB;IACE,iBAAiB,EAAE;EACrB;IACE,WAAW,EAAE;EACf;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,qBAAqB,EAAE;EACzB;IACE,UAAU;IACV,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;EACvB;IACE,SAAS,EAAE;EACb;IACE,YAAY;IACZ,qBAAqB,EAAE;EACzB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;;AAEjB;EACE;IACE,eAAe,EAAE;IACjB;MACE,0BAA0B;MAC1B,iBAAiB,EAAE;IACrB;MACE,UAAU,EAAE;MACZ;QACE,YAAY;QACZ,gBAAgB;QAChB,mBAAmB,EAAE;IACzB;MACE,UAAU;MACV,iBAAiB;MACjB,eAAe,EAAE;IACnB;MACE,iBAAiB;MACjB,UAAU;MACV,YAAY,EAAE;IAChB;MACE,iBAAiB;MACjB,UAAU,EAAE;IACd;MACE,iBAAiB;MACjB,UAAU;MACV,iBAAiB,EAAE;IACrB;MACE,UAAU;MACV,iBAAiB,EAAE;IACrB;MACE,UAAU,EAAE;IACd;MACE,cAAc,EAAE;MAChB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,WAAW;QACX,UAAU,EAAE;MACd;QACE,qBAAqB,EAAE;MACzB;QACE,cAAc;QACd,SAAS;QACT,gBAAgB,EAAE,EAAE;EAC1B;IACE;MACE,UAAU;MACV,gBAAgB,EAAE;MAClB;QACE,YAAY;QACZ,gBAAgB;QAChB,mBAAmB,EAAE;IACzB;MACE,UAAU,EAAE;MACZ;QACE,WAAW,EAAE;IACjB;MACE,WAAW,EAAE,EAAE;;AAErB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB,EAAE;EACxB;IACE,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;IACE,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,kBAAkB,EAAE;EACtB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,iBAAiB;EACjB,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB,EAAE;EACnB;IACE,eAAe;IACf,UAAU;IACV,SAAS;IACT,mBAAmB,EAAE;EACvB;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAqB,EAAE;EACzB;IACE,qBAAqB;IACrB,YAAY,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB,EAAE;IACpB;MACE,eAAe,EAAE;EACrB;IACE,qBAAqB;IACrB,YAAY,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,mBAAmB,EAAE;EACrB;IACE,gBAAgB;IAChB,kBAAkB,EAAE;IACpB;MACE,cAAc,EAAE;EACpB;IACE,mBAAmB,EAAE;EACvB;IACE,YAAY,EAAE;EAChB;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,qBAAqB,EAAE;EACzB;IACE,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB,EAAE;IAClB;MACE,WAAW,EAAE;EACjB;IACE,cAAc;IACd,iBAAiB,EAAE;EACrB;IACE,gBAAgB;IAChB,gBAAgB,EAAE;EACpB;IACE,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,eAAe,EAAE;IACjB;MACE,eAAe;MACf,YAAY;MACZ,YAAY,EAAE;MACd;QACE,UAAU,EAAE;MACd;QACE,cAAc,EAAE;MAClB;QACE,WAAW,EAAE;EACnB;IACE,qBAAqB;IACrB,mBAAmB,EAAE;IACrB;MACE,WAAW;MACX,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;MACf,mBAAmB,EAAE;;AAE3B;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB,EAAE;EACtB;IACE,aAAa,EAAE;;AAEnB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB;EAChB,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc,EAAE;EAChB;IACE,WAAW,EAAE;IACb;MACE,cAAc,EAAE;;AAEtB;EACE,UAAU;EACV,YAAY,EAAE;;AAEhB;EACE,2BAA2B;EAC3B,eAAe,EAAE;EACjB;IACE,2BAA2B,EAAE;EAC/B;IACE;MACE,YAAY,EAAE,EAAE;EACpB;IACE,gCAAgC;IAChC,iBAAiB,EAAE;IACnB;MACE,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,YAAY,EAAE;MACd;QACE;UACE,YAAY,EAAE,EAAE;IACtB;MACE,mBAAmB,EAAE;IACvB;MACE,cAAc,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0EAA0E,EAAE;EAC5E;IACE,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0EAA0E,EAAE;EAC5E;IACE,eAAe;IACf,aAAa,EAAE;EACjB;IACE,gBAAgB;IAChB,0BAA0B,EAAE;IAC5B;MACE,gBAAgB,EAAE;EACtB;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW,EAAE;EACf;IACE,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,cAAc,EAAE;EAChB;IACE,aAAa,EAAE;EACjB;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB,EAAE;EACtB;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,4BAA4B,EAAE;EAChC;IACE,cAAc;IACd,kBAAkB,EAAE;;AAExB;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,eAAe,EAAE;EACjB;IACE,kBAAkB,EAAE;IACpB;MACE,gBAAgB;MAChB,WAAW;MACX,mDAAmD;MACnD,gDAAgD;MAChD,2CAA2C,EAAE;IAC/C;MACE,gBAAgB;MAChB,eAAe,EAAE;IACnB;MACE,mBAAmB;MACnB,kBAAkB,EAAE;MACpB;QACE,cAAc,EAAE;;AAExB;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;EACjB;IACE,SAAS,EAAE;;AAEf;EACE,UAAU,EAAE;EACZ;IACE,YAAY,EAAE;EAChB;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe,EAAE;;AAErB;EACE,kBAAkB;EAClB,eAAe,EAAE;EACjB;IACE,qBAAqB,EAAE;IACvB;MACE,iBAAiB;MACjB,cAAc;MACd,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,yBAAyB;MACzB,eAAe,EAAE;MACjB;QACE,cAAc,EAAE;IACpB;MACE,gBAAgB;MAChB,mBAAmB,EAAE;IACvB;MACE,gBAAgB,EAAE;;AAExB;EACE,iBAAiB;EACjB,wEAAwE;EACxE,sBAAsB;EACtB,aAAa,EAAE;EACf;IACE,aAAa,EAAE;EACjB;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB,EAAE;IAClB;MACE,YAAY,EAAE;IAChB;MACE;QACE,kBAAkB;QAClB,gBAAgB;QAChB,UAAU,EAAE;QACZ;UACE,YAAY,EAAE,EAAE;;AAE1B;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe,EAAE;EACjB;IACE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;IACrB;MACE,gBAAgB,EAAE;EACtB;IACE,oBAAoB;IACpB,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW,EAAE;;AAEjB;EACE,aAAa;EACb,kBAAkB,EAAE;;AAEtB;EACE,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC,EAAE;EAClC;IACE,mBAAmB,EAAE;IACrB;MACE,cAAc,EAAE;EACpB;IACE,WAAW,EAAE","sourcesContent":["@charset \"UTF-8\";\n/* Variables\n   ========================================================================== */\n/* Bootstrap Variables\n   ========================================================================== */\n/* Variables\n   ========================================================================== */\n/* Bootstrap Core\n   ========================================================================== */\n/*! normalize.css v3.0.1 | MIT License | git.io/normalize */\n/* @import url(../../bower_components/select2/select2.css);\n@import url(../../bower_components/spectrum/spectrum.css);\n@import url(../../bower_components/seiyria-bootstrap-slider/dist/css/bootstrap-slider.css); */\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%; }\n\nbody {\n  margin: 0; }\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection,\nsummary {\n  display: block; }\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\n\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n\n[hidden],\ntemplate {\n  display: none; }\n\na {\n  background: transparent; }\n\na:active,\na:hover {\n  outline: 0; }\n\nabbr[title] {\n  border-bottom: 1px dotted; }\n\nb,\nstrong {\n  font-weight: bold; }\n\ndfn {\n  font-style: italic; }\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\n\nmark {\n  background: #ff0;\n  color: #000; }\n\nsmall {\n  font-size: 80%; }\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\n\nsup {\n  top: -0.5em; }\n\nsub {\n  bottom: -0.25em; }\n\nimg {\n  border: 0; }\n\nsvg:not(:root) {\n  overflow: hidden; }\n\nfigure {\n  margin: 1em 40px; }\n\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0; }\n\npre {\n  overflow: auto; }\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em; }\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0; }\n\nbutton {\n  overflow: visible; }\n\nbutton,\nselect {\n  text-transform: none; }\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default; }\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\n\ninput {\n  line-height: normal; }\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0; }\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box; }\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\n\nlegend {\n  border: 0;\n  padding: 0; }\n\ntextarea {\n  overflow: auto; }\n\noptgroup {\n  font-weight: bold; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd,\nth {\n  padding: 0; }\n\n@media print {\n  * {\n    text-shadow: none !important;\n    color: #000 !important;\n    background: transparent !important;\n    box-shadow: none !important; }\n  a,\n  a:visited {\n    text-decoration: underline; }\n  a[href]:after {\n    content: \" (\" attr(href) \")\"; }\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\"; }\n  a[href^=\"javascript:\"]:after,\n  a[href^=\"#\"]:after {\n    content: \"\"; }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid; }\n  thead {\n    display: table-header-group; }\n  tr,\n  img {\n    page-break-inside: avoid; }\n  img {\n    max-width: 100% !important; }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3; }\n  h2,\n  h3 {\n    page-break-after: avoid; }\n  select {\n    background: #fff !important; }\n  .navbar {\n    display: none; }\n  .table td, .table-2 td,\n  .table th, .table-2 th {\n    background-color: #fff !important; }\n  .btn > .caret, .icon-nav label > .caret,\n  .dropup > .btn > .caret, .icon-nav\n  .dropup > label > .caret {\n    border-top-color: #000 !important; }\n  .label {\n    border: 1px solid #000; }\n  .table, .table-2 {\n    border-collapse: collapse !important; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important; } }\n\n@font-face {\n  font-family: 'Glyphicons Halflings';\n  src: url(\"../fonts/glyphicons-halflings-regular.eot\");\n  src: url(\"../fonts/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/glyphicons-halflings-regular.woff\") format(\"woff\"), url(\"../fonts/glyphicons-halflings-regular.ttf\") format(\"truetype\"), url(\"../fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\"); }\n\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.glyphicon-asterisk:before {\n  content: \"\\2a\"; }\n\n.glyphicon-plus:before {\n  content: \"\\2b\"; }\n\n.glyphicon-euro:before {\n  content: \"\\20ac\"; }\n\n.glyphicon-minus:before {\n  content: \"\\2212\"; }\n\n.glyphicon-cloud:before {\n  content: \"\\2601\"; }\n\n.glyphicon-envelope:before {\n  content: \"\\2709\"; }\n\n.glyphicon-pencil:before {\n  content: \"\\270f\"; }\n\n.glyphicon-glass:before {\n  content: \"\\e001\"; }\n\n.glyphicon-music:before {\n  content: \"\\e002\"; }\n\n.glyphicon-search:before {\n  content: \"\\e003\"; }\n\n.glyphicon-heart:before {\n  content: \"\\e005\"; }\n\n.glyphicon-star:before {\n  content: \"\\e006\"; }\n\n.glyphicon-star-empty:before {\n  content: \"\\e007\"; }\n\n.glyphicon-user:before {\n  content: \"\\e008\"; }\n\n.glyphicon-film:before {\n  content: \"\\e009\"; }\n\n.glyphicon-th-large:before {\n  content: \"\\e010\"; }\n\n.glyphicon-th:before {\n  content: \"\\e011\"; }\n\n.glyphicon-th-list:before {\n  content: \"\\e012\"; }\n\n.glyphicon-ok:before {\n  content: \"\\e013\"; }\n\n.glyphicon-remove:before {\n  content: \"\\e014\"; }\n\n.glyphicon-zoom-in:before {\n  content: \"\\e015\"; }\n\n.glyphicon-zoom-out:before {\n  content: \"\\e016\"; }\n\n.glyphicon-off:before {\n  content: \"\\e017\"; }\n\n.glyphicon-signal:before {\n  content: \"\\e018\"; }\n\n.glyphicon-cog:before {\n  content: \"\\e019\"; }\n\n.glyphicon-trash:before {\n  content: \"\\e020\"; }\n\n.glyphicon-home:before {\n  content: \"\\e021\"; }\n\n.glyphicon-file:before {\n  content: \"\\e022\"; }\n\n.glyphicon-time:before {\n  content: \"\\e023\"; }\n\n.glyphicon-road:before {\n  content: \"\\e024\"; }\n\n.glyphicon-download-alt:before {\n  content: \"\\e025\"; }\n\n.glyphicon-download:before {\n  content: \"\\e026\"; }\n\n.glyphicon-upload:before {\n  content: \"\\e027\"; }\n\n.glyphicon-inbox:before {\n  content: \"\\e028\"; }\n\n.glyphicon-play-circle:before {\n  content: \"\\e029\"; }\n\n.glyphicon-repeat:before {\n  content: \"\\e030\"; }\n\n.glyphicon-refresh:before {\n  content: \"\\e031\"; }\n\n.glyphicon-list-alt:before {\n  content: \"\\e032\"; }\n\n.glyphicon-lock:before {\n  content: \"\\e033\"; }\n\n.glyphicon-flag:before {\n  content: \"\\e034\"; }\n\n.glyphicon-headphones:before {\n  content: \"\\e035\"; }\n\n.glyphicon-volume-off:before {\n  content: \"\\e036\"; }\n\n.glyphicon-volume-down:before {\n  content: \"\\e037\"; }\n\n.glyphicon-volume-up:before {\n  content: \"\\e038\"; }\n\n.glyphicon-qrcode:before {\n  content: \"\\e039\"; }\n\n.glyphicon-barcode:before {\n  content: \"\\e040\"; }\n\n.glyphicon-tag:before {\n  content: \"\\e041\"; }\n\n.glyphicon-tags:before {\n  content: \"\\e042\"; }\n\n.glyphicon-book:before {\n  content: \"\\e043\"; }\n\n.glyphicon-bookmark:before {\n  content: \"\\e044\"; }\n\n.glyphicon-print:before {\n  content: \"\\e045\"; }\n\n.glyphicon-camera:before {\n  content: \"\\e046\"; }\n\n.glyphicon-font:before {\n  content: \"\\e047\"; }\n\n.glyphicon-bold:before {\n  content: \"\\e048\"; }\n\n.glyphicon-italic:before {\n  content: \"\\e049\"; }\n\n.glyphicon-text-height:before {\n  content: \"\\e050\"; }\n\n.glyphicon-text-width:before {\n  content: \"\\e051\"; }\n\n.glyphicon-align-left:before {\n  content: \"\\e052\"; }\n\n.glyphicon-align-center:before {\n  content: \"\\e053\"; }\n\n.glyphicon-align-right:before {\n  content: \"\\e054\"; }\n\n.glyphicon-align-justify:before {\n  content: \"\\e055\"; }\n\n.glyphicon-list:before {\n  content: \"\\e056\"; }\n\n.glyphicon-indent-left:before {\n  content: \"\\e057\"; }\n\n.glyphicon-indent-right:before {\n  content: \"\\e058\"; }\n\n.glyphicon-facetime-video:before {\n  content: \"\\e059\"; }\n\n.glyphicon-picture:before {\n  content: \"\\e060\"; }\n\n.glyphicon-map-marker:before {\n  content: \"\\e062\"; }\n\n.glyphicon-adjust:before {\n  content: \"\\e063\"; }\n\n.glyphicon-tint:before {\n  content: \"\\e064\"; }\n\n.glyphicon-edit:before {\n  content: \"\\e065\"; }\n\n.glyphicon-share:before {\n  content: \"\\e066\"; }\n\n.glyphicon-check:before {\n  content: \"\\e067\"; }\n\n.glyphicon-move:before {\n  content: \"\\e068\"; }\n\n.glyphicon-step-backward:before {\n  content: \"\\e069\"; }\n\n.glyphicon-fast-backward:before {\n  content: \"\\e070\"; }\n\n.glyphicon-backward:before {\n  content: \"\\e071\"; }\n\n.glyphicon-play:before {\n  content: \"\\e072\"; }\n\n.glyphicon-pause:before {\n  content: \"\\e073\"; }\n\n.glyphicon-stop:before {\n  content: \"\\e074\"; }\n\n.glyphicon-forward:before {\n  content: \"\\e075\"; }\n\n.glyphicon-fast-forward:before {\n  content: \"\\e076\"; }\n\n.glyphicon-step-forward:before {\n  content: \"\\e077\"; }\n\n.glyphicon-eject:before {\n  content: \"\\e078\"; }\n\n.glyphicon-chevron-left:before {\n  content: \"\\e079\"; }\n\n.glyphicon-chevron-right:before {\n  content: \"\\e080\"; }\n\n.glyphicon-plus-sign:before {\n  content: \"\\e081\"; }\n\n.glyphicon-minus-sign:before {\n  content: \"\\e082\"; }\n\n.glyphicon-remove-sign:before {\n  content: \"\\e083\"; }\n\n.glyphicon-ok-sign:before {\n  content: \"\\e084\"; }\n\n.glyphicon-question-sign:before {\n  content: \"\\e085\"; }\n\n.glyphicon-info-sign:before {\n  content: \"\\e086\"; }\n\n.glyphicon-screenshot:before {\n  content: \"\\e087\"; }\n\n.glyphicon-remove-circle:before {\n  content: \"\\e088\"; }\n\n.glyphicon-ok-circle:before {\n  content: \"\\e089\"; }\n\n.glyphicon-ban-circle:before {\n  content: \"\\e090\"; }\n\n.glyphicon-arrow-left:before {\n  content: \"\\e091\"; }\n\n.glyphicon-arrow-right:before {\n  content: \"\\e092\"; }\n\n.glyphicon-arrow-up:before {\n  content: \"\\e093\"; }\n\n.glyphicon-arrow-down:before {\n  content: \"\\e094\"; }\n\n.glyphicon-share-alt:before {\n  content: \"\\e095\"; }\n\n.glyphicon-resize-full:before {\n  content: \"\\e096\"; }\n\n.glyphicon-resize-small:before {\n  content: \"\\e097\"; }\n\n.glyphicon-exclamation-sign:before {\n  content: \"\\e101\"; }\n\n.glyphicon-gift:before {\n  content: \"\\e102\"; }\n\n.glyphicon-leaf:before {\n  content: \"\\e103\"; }\n\n.glyphicon-fire:before {\n  content: \"\\e104\"; }\n\n.glyphicon-eye-open:before {\n  content: \"\\e105\"; }\n\n.glyphicon-eye-close:before {\n  content: \"\\e106\"; }\n\n.glyphicon-warning-sign:before {\n  content: \"\\e107\"; }\n\n.glyphicon-plane:before {\n  content: \"\\e108\"; }\n\n.glyphicon-calendar:before {\n  content: \"\\e109\"; }\n\n.glyphicon-random:before {\n  content: \"\\e110\"; }\n\n.glyphicon-comment:before {\n  content: \"\\e111\"; }\n\n.glyphicon-magnet:before {\n  content: \"\\e112\"; }\n\n.glyphicon-chevron-up:before {\n  content: \"\\e113\"; }\n\n.glyphicon-chevron-down:before {\n  content: \"\\e114\"; }\n\n.glyphicon-retweet:before {\n  content: \"\\e115\"; }\n\n.glyphicon-shopping-cart:before {\n  content: \"\\e116\"; }\n\n.glyphicon-folder-close:before {\n  content: \"\\e117\"; }\n\n.glyphicon-folder-open:before {\n  content: \"\\e118\"; }\n\n.glyphicon-resize-vertical:before {\n  content: \"\\e119\"; }\n\n.glyphicon-resize-horizontal:before {\n  content: \"\\e120\"; }\n\n.glyphicon-hdd:before {\n  content: \"\\e121\"; }\n\n.glyphicon-bullhorn:before {\n  content: \"\\e122\"; }\n\n.glyphicon-bell:before {\n  content: \"\\e123\"; }\n\n.glyphicon-certificate:before {\n  content: \"\\e124\"; }\n\n.glyphicon-thumbs-up:before {\n  content: \"\\e125\"; }\n\n.glyphicon-thumbs-down:before {\n  content: \"\\e126\"; }\n\n.glyphicon-hand-right:before {\n  content: \"\\e127\"; }\n\n.glyphicon-hand-left:before {\n  content: \"\\e128\"; }\n\n.glyphicon-hand-up:before {\n  content: \"\\e129\"; }\n\n.glyphicon-hand-down:before {\n  content: \"\\e130\"; }\n\n.glyphicon-circle-arrow-right:before {\n  content: \"\\e131\"; }\n\n.glyphicon-circle-arrow-left:before {\n  content: \"\\e132\"; }\n\n.glyphicon-circle-arrow-up:before {\n  content: \"\\e133\"; }\n\n.glyphicon-circle-arrow-down:before {\n  content: \"\\e134\"; }\n\n.glyphicon-globe:before {\n  content: \"\\e135\"; }\n\n.glyphicon-wrench:before {\n  content: \"\\e136\"; }\n\n.glyphicon-tasks:before {\n  content: \"\\e137\"; }\n\n.glyphicon-filter:before {\n  content: \"\\e138\"; }\n\n.glyphicon-briefcase:before {\n  content: \"\\e139\"; }\n\n.glyphicon-fullscreen:before {\n  content: \"\\e140\"; }\n\n.glyphicon-dashboard:before {\n  content: \"\\e141\"; }\n\n.glyphicon-paperclip:before {\n  content: \"\\e142\"; }\n\n.glyphicon-heart-empty:before {\n  content: \"\\e143\"; }\n\n.glyphicon-link:before {\n  content: \"\\e144\"; }\n\n.glyphicon-phone:before {\n  content: \"\\e145\"; }\n\n.glyphicon-pushpin:before {\n  content: \"\\e146\"; }\n\n.glyphicon-usd:before {\n  content: \"\\e148\"; }\n\n.glyphicon-gbp:before {\n  content: \"\\e149\"; }\n\n.glyphicon-sort:before {\n  content: \"\\e150\"; }\n\n.glyphicon-sort-by-alphabet:before {\n  content: \"\\e151\"; }\n\n.glyphicon-sort-by-alphabet-alt:before {\n  content: \"\\e152\"; }\n\n.glyphicon-sort-by-order:before {\n  content: \"\\e153\"; }\n\n.glyphicon-sort-by-order-alt:before {\n  content: \"\\e154\"; }\n\n.glyphicon-sort-by-attributes:before {\n  content: \"\\e155\"; }\n\n.glyphicon-sort-by-attributes-alt:before {\n  content: \"\\e156\"; }\n\n.glyphicon-unchecked:before {\n  content: \"\\e157\"; }\n\n.glyphicon-expand:before {\n  content: \"\\e158\"; }\n\n.glyphicon-collapse-down:before {\n  content: \"\\e159\"; }\n\n.glyphicon-collapse-up:before {\n  content: \"\\e160\"; }\n\n.glyphicon-log-in:before {\n  content: \"\\e161\"; }\n\n.glyphicon-flash:before {\n  content: \"\\e162\"; }\n\n.glyphicon-log-out:before {\n  content: \"\\e163\"; }\n\n.glyphicon-new-window:before {\n  content: \"\\e164\"; }\n\n.glyphicon-record:before {\n  content: \"\\e165\"; }\n\n.glyphicon-save:before {\n  content: \"\\e166\"; }\n\n.glyphicon-open:before {\n  content: \"\\e167\"; }\n\n.glyphicon-saved:before {\n  content: \"\\e168\"; }\n\n.glyphicon-import:before {\n  content: \"\\e169\"; }\n\n.glyphicon-export:before {\n  content: \"\\e170\"; }\n\n.glyphicon-send:before {\n  content: \"\\e171\"; }\n\n.glyphicon-floppy-disk:before {\n  content: \"\\e172\"; }\n\n.glyphicon-floppy-saved:before {\n  content: \"\\e173\"; }\n\n.glyphicon-floppy-remove:before {\n  content: \"\\e174\"; }\n\n.glyphicon-floppy-save:before {\n  content: \"\\e175\"; }\n\n.glyphicon-floppy-open:before {\n  content: \"\\e176\"; }\n\n.glyphicon-credit-card:before {\n  content: \"\\e177\"; }\n\n.glyphicon-transfer:before {\n  content: \"\\e178\"; }\n\n.glyphicon-cutlery:before {\n  content: \"\\e179\"; }\n\n.glyphicon-header:before {\n  content: \"\\e180\"; }\n\n.glyphicon-compressed:before {\n  content: \"\\e181\"; }\n\n.glyphicon-earphone:before {\n  content: \"\\e182\"; }\n\n.glyphicon-phone-alt:before {\n  content: \"\\e183\"; }\n\n.glyphicon-tower:before {\n  content: \"\\e184\"; }\n\n.glyphicon-stats:before {\n  content: \"\\e185\"; }\n\n.glyphicon-sd-video:before {\n  content: \"\\e186\"; }\n\n.glyphicon-hd-video:before {\n  content: \"\\e187\"; }\n\n.glyphicon-subtitles:before {\n  content: \"\\e188\"; }\n\n.glyphicon-sound-stereo:before {\n  content: \"\\e189\"; }\n\n.glyphicon-sound-dolby:before {\n  content: \"\\e190\"; }\n\n.glyphicon-sound-5-1:before {\n  content: \"\\e191\"; }\n\n.glyphicon-sound-6-1:before {\n  content: \"\\e192\"; }\n\n.glyphicon-sound-7-1:before {\n  content: \"\\e193\"; }\n\n.glyphicon-copyright-mark:before {\n  content: \"\\e194\"; }\n\n.glyphicon-registration-mark:before {\n  content: \"\\e195\"; }\n\n.glyphicon-cloud-download:before {\n  content: \"\\e197\"; }\n\n.glyphicon-cloud-upload:before {\n  content: \"\\e198\"; }\n\n.glyphicon-tree-conifer:before {\n  content: \"\\e199\"; }\n\n.glyphicon-tree-deciduous:before {\n  content: \"\\e200\"; }\n\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: transparent; }\n\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #020621;\n  background-color: #F7F7F9; }\n\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\na {\n  color: #0081BA;\n  text-decoration: none; }\n  a:hover, a:focus {\n    color: #005e87;\n    text-decoration: underline; }\n  a:focus {\n    outline: thin dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\n\nfigure {\n  margin: 0; }\n\nimg {\n  vertical-align: middle; }\n\n.img-responsive {\n  display: block;\n  width: 100% \\9;\n  max-width: 100%;\n  height: auto; }\n\n.img-rounded {\n  border-radius: 6px; }\n\n.img-thumbnail {\n  padding: 0;\n  line-height: 1.42857;\n  background-color: #F7F7F9;\n  border: 1px solid #ddd;\n  border-radius: 0;\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  width: 100% \\9;\n  max-width: 100%;\n  height: auto; }\n\n.img-circle {\n  border-radius: 50%; }\n\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #e6e6e6; }\n\n.sr-only, .file-picker input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto; }\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: inherit; }\n  h1 small,\n  h1 .small, h2 small,\n  h2 .small, h3 small,\n  h3 .small, h4 small,\n  h4 .small, h5 small,\n  h5 .small, h6 small,\n  h6 .small,\n  .h1 small,\n  .h1 .small, .h2 small,\n  .h2 .small, .h3 small,\n  .h3 .small, .h4 small,\n  .h4 .small, .h5 small,\n  .h5 .small, .h6 small,\n  .h6 .small {\n    font-weight: normal;\n    line-height: 1;\n    color: #777777; }\n\nh1, .h1,\nh2, .h2,\nh3, .h3 {\n  margin-top: 20px;\n  margin-bottom: 10px; }\n  h1 small,\n  h1 .small, .h1 small,\n  .h1 .small,\n  h2 small,\n  h2 .small, .h2 small,\n  .h2 .small,\n  h3 small,\n  h3 .small, .h3 small,\n  .h3 .small {\n    font-size: 65%; }\n\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  h4 small,\n  h4 .small, .h4 small,\n  .h4 .small,\n  h5 small,\n  h5 .small, .h5 small,\n  .h5 .small,\n  h6 small,\n  h6 .small, .h6 small,\n  .h6 .small {\n    font-size: 75%; }\n\nh1, .h1 {\n  font-size: 33px; }\n\nh2, .h2 {\n  font-size: 29px; }\n\nh3, .h3 {\n  font-size: 22px; }\n\nh4, .h4 {\n  font-size: 16px; }\n\nh5, .h5 {\n  font-size: 14px; }\n\nh6, .h6 {\n  font-size: 12px; }\n\np {\n  margin: 0 0 10px; }\n\n.lead, .post h2 + p {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4; }\n  @media (min-width: 768px) {\n    .lead, .post h2 + p {\n      font-size: 21px; } }\n\nsmall,\n.small {\n  font-size: 85%; }\n\ncite {\n  font-style: normal; }\n\nmark,\n.mark {\n  background-color: #fcf8e3;\n  padding: .2em; }\n\n.text-left {\n  text-align: left; }\n\n.text-right {\n  text-align: right; }\n\n.text-center {\n  text-align: center; }\n\n.text-justify {\n  text-align: justify; }\n\n.text-nowrap {\n  white-space: nowrap; }\n\n.text-lowercase {\n  text-transform: lowercase; }\n\n.text-uppercase {\n  text-transform: uppercase; }\n\n.text-capitalize {\n  text-transform: capitalize; }\n\n.text-muted {\n  color: #777777; }\n\n.text-primary {\n  color: #0081BA; }\n\na.text-primary:hover {\n  color: #005e87; }\n\n.text-success {\n  color: #4ab767; }\n\na.text-success:hover {\n  color: #3b9352; }\n\n.text-info {\n  color: #31708f; }\n\na.text-info:hover {\n  color: #245269; }\n\n.text-warning {\n  color: #8a6d3b; }\n\na.text-warning:hover {\n  color: #66512c; }\n\n.text-danger {\n  color: #c0392b; }\n\na.text-danger:hover {\n  color: #962d22; }\n\n.bg-primary {\n  color: #fff; }\n\n.bg-primary {\n  background-color: #0081BA; }\n\na.bg-primary:hover {\n  background-color: #005e87; }\n\n.bg-success {\n  background-color: #dff0d8; }\n\na.bg-success:hover {\n  background-color: #c1e2b3; }\n\n.bg-info {\n  background-color: #d9edf7; }\n\na.bg-info:hover {\n  background-color: #afd9ee; }\n\n.bg-warning {\n  background-color: #fcf8e3; }\n\na.bg-warning:hover {\n  background-color: #f7ecb5; }\n\n.bg-danger, .entries p:first-child {\n  background-color: #f2dede; }\n\na.bg-danger:hover {\n  background-color: #e4b9b9; }\n\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #d5d5d5; }\n\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px; }\n  ul ul,\n  ul ol,\n  ol ul,\n  ol ol {\n    margin-bottom: 0; }\n\n.list-unstyled, .list-inline {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline {\n  margin-left: -5px; }\n  .list-inline > li {\n    display: inline-block;\n    padding-left: 5px;\n    padding-right: 5px; }\n\ndl {\n  margin-top: 0;\n  margin-bottom: 20px; }\n\ndt,\ndd {\n  line-height: 1.42857; }\n\ndt {\n  font-weight: bold; }\n\ndd {\n  margin-left: 0; }\n\n.dl-horizontal dd:before, .dl-horizontal dd:after {\n  content: \" \";\n  display: table; }\n\n.dl-horizontal dd:after {\n  clear: both; }\n\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .dl-horizontal dd {\n    margin-left: 180px; } }\n\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted #777777; }\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #d5d5d5; }\n  blockquote p:last-child,\n  blockquote ul:last-child,\n  blockquote ol:last-child {\n    margin-bottom: 0; }\n  blockquote footer,\n  blockquote small,\n  blockquote .small {\n    display: block;\n    font-size: 80%;\n    line-height: 1.42857;\n    color: #777777; }\n    blockquote footer:before,\n    blockquote small:before,\n    blockquote .small:before {\n      content: '\\2014 \\00A0'; }\n\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  border-right: 5px solid #d5d5d5;\n  border-left: 0;\n  text-align: right; }\n  .blockquote-reverse footer:before,\n  .blockquote-reverse small:before,\n  .blockquote-reverse .small:before,\n  blockquote.pull-right footer:before,\n  blockquote.pull-right small:before,\n  blockquote.pull-right .small:before {\n    content: ''; }\n  .blockquote-reverse footer:after,\n  .blockquote-reverse small:after,\n  .blockquote-reverse .small:after,\n  blockquote.pull-right footer:after,\n  blockquote.pull-right small:after,\n  blockquote.pull-right .small:after {\n    content: '\\00A0 \\2014'; }\n\nblockquote:before,\nblockquote:after {\n  content: \"\"; }\n\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857; }\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace; }\n\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px; }\n\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 2px;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25); }\n  kbd kbd {\n    padding: 0;\n    font-size: 100%;\n    box-shadow: none; }\n\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857;\n  word-break: break-all;\n  word-wrap: break-word;\n  color: #020621;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px; }\n  pre code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0; }\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n\n.container {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 7.5px;\n  padding-right: 7.5px; }\n  .container:before, .container:after {\n    content: \" \";\n    display: table; }\n  .container:after {\n    clear: both; }\n  @media (min-width: 768px) {\n    .container {\n      width: 735px; } }\n  @media (min-width: 992px) {\n    .container {\n      width: 955px; } }\n  @media (min-width: 1200px) {\n    .container {\n      width: 1155px; } }\n\n.container-fluid {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 7.5px;\n  padding-right: 7.5px; }\n  .container-fluid:before, .container-fluid:after {\n    content: \" \";\n    display: table; }\n  .container-fluid:after {\n    clear: both; }\n\n.row, .support-app .ticket-list-table .title-row, .support-app .ticket-list-table .ticket {\n  margin-left: -7.5px;\n  margin-right: -7.5px; }\n  .row:before, .support-app .ticket-list-table .title-row:before, .support-app .ticket-list-table .ticket:before, .row:after, .support-app .ticket-list-table .title-row:after, .support-app .ticket-list-table .ticket:after {\n    content: \" \";\n    display: table; }\n  .row:after, .support-app .ticket-list-table .title-row:after, .support-app .ticket-list-table .ticket:after {\n    clear: both; }\n\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-left: 7.5px;\n  padding-right: 7.5px; }\n\n.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\n  float: left; }\n\n.col-xs-1 {\n  width: 8.33333%; }\n\n.col-xs-2 {\n  width: 16.66667%; }\n\n.col-xs-3 {\n  width: 25%; }\n\n.col-xs-4 {\n  width: 33.33333%; }\n\n.col-xs-5 {\n  width: 41.66667%; }\n\n.col-xs-6 {\n  width: 50%; }\n\n.col-xs-7 {\n  width: 58.33333%; }\n\n.col-xs-8 {\n  width: 66.66667%; }\n\n.col-xs-9 {\n  width: 75%; }\n\n.col-xs-10 {\n  width: 83.33333%; }\n\n.col-xs-11 {\n  width: 91.66667%; }\n\n.col-xs-12 {\n  width: 100%; }\n\n.col-xs-pull-0 {\n  right: auto; }\n\n.col-xs-pull-1 {\n  right: 8.33333%; }\n\n.col-xs-pull-2 {\n  right: 16.66667%; }\n\n.col-xs-pull-3 {\n  right: 25%; }\n\n.col-xs-pull-4 {\n  right: 33.33333%; }\n\n.col-xs-pull-5 {\n  right: 41.66667%; }\n\n.col-xs-pull-6 {\n  right: 50%; }\n\n.col-xs-pull-7 {\n  right: 58.33333%; }\n\n.col-xs-pull-8 {\n  right: 66.66667%; }\n\n.col-xs-pull-9 {\n  right: 75%; }\n\n.col-xs-pull-10 {\n  right: 83.33333%; }\n\n.col-xs-pull-11 {\n  right: 91.66667%; }\n\n.col-xs-pull-12 {\n  right: 100%; }\n\n.col-xs-push-0 {\n  left: auto; }\n\n.col-xs-push-1 {\n  left: 8.33333%; }\n\n.col-xs-push-2 {\n  left: 16.66667%; }\n\n.col-xs-push-3 {\n  left: 25%; }\n\n.col-xs-push-4 {\n  left: 33.33333%; }\n\n.col-xs-push-5 {\n  left: 41.66667%; }\n\n.col-xs-push-6 {\n  left: 50%; }\n\n.col-xs-push-7 {\n  left: 58.33333%; }\n\n.col-xs-push-8 {\n  left: 66.66667%; }\n\n.col-xs-push-9 {\n  left: 75%; }\n\n.col-xs-push-10 {\n  left: 83.33333%; }\n\n.col-xs-push-11 {\n  left: 91.66667%; }\n\n.col-xs-push-12 {\n  left: 100%; }\n\n.col-xs-offset-0 {\n  margin-left: 0%; }\n\n.col-xs-offset-1 {\n  margin-left: 8.33333%; }\n\n.col-xs-offset-2 {\n  margin-left: 16.66667%; }\n\n.col-xs-offset-3 {\n  margin-left: 25%; }\n\n.col-xs-offset-4 {\n  margin-left: 33.33333%; }\n\n.col-xs-offset-5 {\n  margin-left: 41.66667%; }\n\n.col-xs-offset-6 {\n  margin-left: 50%; }\n\n.col-xs-offset-7 {\n  margin-left: 58.33333%; }\n\n.col-xs-offset-8 {\n  margin-left: 66.66667%; }\n\n.col-xs-offset-9 {\n  margin-left: 75%; }\n\n.col-xs-offset-10 {\n  margin-left: 83.33333%; }\n\n.col-xs-offset-11 {\n  margin-left: 91.66667%; }\n\n.col-xs-offset-12 {\n  margin-left: 100%; }\n\n@media (min-width: 768px) {\n  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\n    float: left; }\n  .col-sm-1 {\n    width: 8.33333%; }\n  .col-sm-2 {\n    width: 16.66667%; }\n  .col-sm-3 {\n    width: 25%; }\n  .col-sm-4 {\n    width: 33.33333%; }\n  .col-sm-5 {\n    width: 41.66667%; }\n  .col-sm-6 {\n    width: 50%; }\n  .col-sm-7 {\n    width: 58.33333%; }\n  .col-sm-8 {\n    width: 66.66667%; }\n  .col-sm-9 {\n    width: 75%; }\n  .col-sm-10 {\n    width: 83.33333%; }\n  .col-sm-11 {\n    width: 91.66667%; }\n  .col-sm-12 {\n    width: 100%; }\n  .col-sm-pull-0 {\n    right: auto; }\n  .col-sm-pull-1 {\n    right: 8.33333%; }\n  .col-sm-pull-2 {\n    right: 16.66667%; }\n  .col-sm-pull-3 {\n    right: 25%; }\n  .col-sm-pull-4 {\n    right: 33.33333%; }\n  .col-sm-pull-5 {\n    right: 41.66667%; }\n  .col-sm-pull-6 {\n    right: 50%; }\n  .col-sm-pull-7 {\n    right: 58.33333%; }\n  .col-sm-pull-8 {\n    right: 66.66667%; }\n  .col-sm-pull-9 {\n    right: 75%; }\n  .col-sm-pull-10 {\n    right: 83.33333%; }\n  .col-sm-pull-11 {\n    right: 91.66667%; }\n  .col-sm-pull-12 {\n    right: 100%; }\n  .col-sm-push-0 {\n    left: auto; }\n  .col-sm-push-1 {\n    left: 8.33333%; }\n  .col-sm-push-2 {\n    left: 16.66667%; }\n  .col-sm-push-3 {\n    left: 25%; }\n  .col-sm-push-4 {\n    left: 33.33333%; }\n  .col-sm-push-5 {\n    left: 41.66667%; }\n  .col-sm-push-6 {\n    left: 50%; }\n  .col-sm-push-7 {\n    left: 58.33333%; }\n  .col-sm-push-8 {\n    left: 66.66667%; }\n  .col-sm-push-9 {\n    left: 75%; }\n  .col-sm-push-10 {\n    left: 83.33333%; }\n  .col-sm-push-11 {\n    left: 91.66667%; }\n  .col-sm-push-12 {\n    left: 100%; }\n  .col-sm-offset-0 {\n    margin-left: 0%; }\n  .col-sm-offset-1 {\n    margin-left: 8.33333%; }\n  .col-sm-offset-2 {\n    margin-left: 16.66667%; }\n  .col-sm-offset-3 {\n    margin-left: 25%; }\n  .col-sm-offset-4 {\n    margin-left: 33.33333%; }\n  .col-sm-offset-5 {\n    margin-left: 41.66667%; }\n  .col-sm-offset-6 {\n    margin-left: 50%; }\n  .col-sm-offset-7 {\n    margin-left: 58.33333%; }\n  .col-sm-offset-8 {\n    margin-left: 66.66667%; }\n  .col-sm-offset-9 {\n    margin-left: 75%; }\n  .col-sm-offset-10 {\n    margin-left: 83.33333%; }\n  .col-sm-offset-11 {\n    margin-left: 91.66667%; }\n  .col-sm-offset-12 {\n    margin-left: 100%; } }\n\n@media (min-width: 992px) {\n  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\n    float: left; }\n  .col-md-1 {\n    width: 8.33333%; }\n  .col-md-2 {\n    width: 16.66667%; }\n  .col-md-3 {\n    width: 25%; }\n  .col-md-4 {\n    width: 33.33333%; }\n  .col-md-5 {\n    width: 41.66667%; }\n  .col-md-6 {\n    width: 50%; }\n  .col-md-7 {\n    width: 58.33333%; }\n  .col-md-8 {\n    width: 66.66667%; }\n  .col-md-9 {\n    width: 75%; }\n  .col-md-10 {\n    width: 83.33333%; }\n  .col-md-11 {\n    width: 91.66667%; }\n  .col-md-12 {\n    width: 100%; }\n  .col-md-pull-0 {\n    right: auto; }\n  .col-md-pull-1 {\n    right: 8.33333%; }\n  .col-md-pull-2 {\n    right: 16.66667%; }\n  .col-md-pull-3 {\n    right: 25%; }\n  .col-md-pull-4 {\n    right: 33.33333%; }\n  .col-md-pull-5 {\n    right: 41.66667%; }\n  .col-md-pull-6 {\n    right: 50%; }\n  .col-md-pull-7 {\n    right: 58.33333%; }\n  .col-md-pull-8 {\n    right: 66.66667%; }\n  .col-md-pull-9 {\n    right: 75%; }\n  .col-md-pull-10 {\n    right: 83.33333%; }\n  .col-md-pull-11 {\n    right: 91.66667%; }\n  .col-md-pull-12 {\n    right: 100%; }\n  .col-md-push-0 {\n    left: auto; }\n  .col-md-push-1 {\n    left: 8.33333%; }\n  .col-md-push-2 {\n    left: 16.66667%; }\n  .col-md-push-3 {\n    left: 25%; }\n  .col-md-push-4 {\n    left: 33.33333%; }\n  .col-md-push-5 {\n    left: 41.66667%; }\n  .col-md-push-6 {\n    left: 50%; }\n  .col-md-push-7 {\n    left: 58.33333%; }\n  .col-md-push-8 {\n    left: 66.66667%; }\n  .col-md-push-9 {\n    left: 75%; }\n  .col-md-push-10 {\n    left: 83.33333%; }\n  .col-md-push-11 {\n    left: 91.66667%; }\n  .col-md-push-12 {\n    left: 100%; }\n  .col-md-offset-0 {\n    margin-left: 0%; }\n  .col-md-offset-1 {\n    margin-left: 8.33333%; }\n  .col-md-offset-2 {\n    margin-left: 16.66667%; }\n  .col-md-offset-3 {\n    margin-left: 25%; }\n  .col-md-offset-4 {\n    margin-left: 33.33333%; }\n  .col-md-offset-5 {\n    margin-left: 41.66667%; }\n  .col-md-offset-6 {\n    margin-left: 50%; }\n  .col-md-offset-7 {\n    margin-left: 58.33333%; }\n  .col-md-offset-8 {\n    margin-left: 66.66667%; }\n  .col-md-offset-9 {\n    margin-left: 75%; }\n  .col-md-offset-10 {\n    margin-left: 83.33333%; }\n  .col-md-offset-11 {\n    margin-left: 91.66667%; }\n  .col-md-offset-12 {\n    margin-left: 100%; } }\n\n@media (min-width: 1200px) {\n  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\n    float: left; }\n  .col-lg-1 {\n    width: 8.33333%; }\n  .col-lg-2 {\n    width: 16.66667%; }\n  .col-lg-3 {\n    width: 25%; }\n  .col-lg-4 {\n    width: 33.33333%; }\n  .col-lg-5 {\n    width: 41.66667%; }\n  .col-lg-6 {\n    width: 50%; }\n  .col-lg-7 {\n    width: 58.33333%; }\n  .col-lg-8 {\n    width: 66.66667%; }\n  .col-lg-9 {\n    width: 75%; }\n  .col-lg-10 {\n    width: 83.33333%; }\n  .col-lg-11 {\n    width: 91.66667%; }\n  .col-lg-12 {\n    width: 100%; }\n  .col-lg-pull-0 {\n    right: auto; }\n  .col-lg-pull-1 {\n    right: 8.33333%; }\n  .col-lg-pull-2 {\n    right: 16.66667%; }\n  .col-lg-pull-3 {\n    right: 25%; }\n  .col-lg-pull-4 {\n    right: 33.33333%; }\n  .col-lg-pull-5 {\n    right: 41.66667%; }\n  .col-lg-pull-6 {\n    right: 50%; }\n  .col-lg-pull-7 {\n    right: 58.33333%; }\n  .col-lg-pull-8 {\n    right: 66.66667%; }\n  .col-lg-pull-9 {\n    right: 75%; }\n  .col-lg-pull-10 {\n    right: 83.33333%; }\n  .col-lg-pull-11 {\n    right: 91.66667%; }\n  .col-lg-pull-12 {\n    right: 100%; }\n  .col-lg-push-0 {\n    left: auto; }\n  .col-lg-push-1 {\n    left: 8.33333%; }\n  .col-lg-push-2 {\n    left: 16.66667%; }\n  .col-lg-push-3 {\n    left: 25%; }\n  .col-lg-push-4 {\n    left: 33.33333%; }\n  .col-lg-push-5 {\n    left: 41.66667%; }\n  .col-lg-push-6 {\n    left: 50%; }\n  .col-lg-push-7 {\n    left: 58.33333%; }\n  .col-lg-push-8 {\n    left: 66.66667%; }\n  .col-lg-push-9 {\n    left: 75%; }\n  .col-lg-push-10 {\n    left: 83.33333%; }\n  .col-lg-push-11 {\n    left: 91.66667%; }\n  .col-lg-push-12 {\n    left: 100%; }\n  .col-lg-offset-0 {\n    margin-left: 0%; }\n  .col-lg-offset-1 {\n    margin-left: 8.33333%; }\n  .col-lg-offset-2 {\n    margin-left: 16.66667%; }\n  .col-lg-offset-3 {\n    margin-left: 25%; }\n  .col-lg-offset-4 {\n    margin-left: 33.33333%; }\n  .col-lg-offset-5 {\n    margin-left: 41.66667%; }\n  .col-lg-offset-6 {\n    margin-left: 50%; }\n  .col-lg-offset-7 {\n    margin-left: 58.33333%; }\n  .col-lg-offset-8 {\n    margin-left: 66.66667%; }\n  .col-lg-offset-9 {\n    margin-left: 75%; }\n  .col-lg-offset-10 {\n    margin-left: 83.33333%; }\n  .col-lg-offset-11 {\n    margin-left: 91.66667%; }\n  .col-lg-offset-12 {\n    margin-left: 100%; } }\n\ntable {\n  background-color: transparent; }\n\nth {\n  text-align: left; }\n\n.table, .table-2 {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px; }\n  .table > thead > tr > th, .table-2 > thead > tr > th,\n  .table > thead > tr > td, .table-2 > thead > tr > td,\n  .table > tbody > tr > th, .table-2 > tbody > tr > th,\n  .table > tbody > tr > td, .table-2 > tbody > tr > td,\n  .table > tfoot > tr > th, .table-2 > tfoot > tr > th,\n  .table > tfoot > tr > td, .table-2 > tfoot > tr > td {\n    padding: 12px 8px;\n    line-height: 1.42857;\n    vertical-align: top;\n    border-top: 1px solid #F1EEEA; }\n  .table > thead > tr > th, .table-2 > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #F1EEEA; }\n  .table > caption + thead > tr:first-child > th, .table-2 > caption + thead > tr:first-child > th,\n  .table > caption + thead > tr:first-child > td, .table-2 > caption + thead > tr:first-child > td,\n  .table > colgroup + thead > tr:first-child > th, .table-2 > colgroup + thead > tr:first-child > th,\n  .table > colgroup + thead > tr:first-child > td, .table-2 > colgroup + thead > tr:first-child > td,\n  .table > thead:first-child > tr:first-child > th, .table-2 > thead:first-child > tr:first-child > th,\n  .table > thead:first-child > tr:first-child > td, .table-2 > thead:first-child > tr:first-child > td {\n    border-top: 0; }\n  .table > tbody + tbody, .table-2 > tbody + tbody {\n    border-top: 2px solid #F1EEEA; }\n  .table .table, .table-2 .table, .table .table-2, .table-2 .table-2 {\n    background-color: #F7F7F9; }\n\n.table-condensed > thead > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > tfoot > tr > td {\n  padding: 5px; }\n\n.table-bordered {\n  border: 1px solid #F1EEEA; }\n  .table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td,\n  .table-bordered > tbody > tr > th,\n  .table-bordered > tbody > tr > td,\n  .table-bordered > tfoot > tr > th,\n  .table-bordered > tfoot > tr > td {\n    border: 1px solid #F1EEEA; }\n  .table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td {\n    border-bottom-width: 2px; }\n\n.table-striped > tbody > tr:nth-child(odd) > td,\n.table-striped > tbody > tr:nth-child(odd) > th {\n  background-color: #f9f9f9; }\n\n.table-hover > tbody > tr:hover > td,\n.table-hover > tbody > tr:hover > th {\n  background-color: #f5f5f5; }\n\ntable col[class*=\"col-\"] {\n  position: static;\n  float: none;\n  display: table-column; }\n\ntable td[class*=\"col-\"],\ntable th[class*=\"col-\"] {\n  position: static;\n  float: none;\n  display: table-cell; }\n\n.table > thead > tr > td.active, .table-2 > thead > tr > td.active,\n.table > thead > tr > th.active, .table-2 > thead > tr > th.active,\n.table > thead > tr.active > td, .table-2 > thead > tr.active > td,\n.table > thead > tr.active > th, .table-2 > thead > tr.active > th,\n.table > tbody > tr > td.active, .table-2 > tbody > tr > td.active,\n.table > tbody > tr > th.active, .table-2 > tbody > tr > th.active,\n.table > tbody > tr.active > td, .table-2 > tbody > tr.active > td,\n.table > tbody > tr.active > th, .table-2 > tbody > tr.active > th,\n.table > tfoot > tr > td.active, .table-2 > tfoot > tr > td.active,\n.table > tfoot > tr > th.active, .table-2 > tfoot > tr > th.active,\n.table > tfoot > tr.active > td, .table-2 > tfoot > tr.active > td,\n.table > tfoot > tr.active > th, .table-2 > tfoot > tr.active > th {\n  background-color: #f5f5f5; }\n\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8; }\n\n.table > thead > tr > td.success, .table-2 > thead > tr > td.success,\n.table > thead > tr > th.success, .table-2 > thead > tr > th.success,\n.table > thead > tr.success > td, .table-2 > thead > tr.success > td,\n.table > thead > tr.success > th, .table-2 > thead > tr.success > th,\n.table > tbody > tr > td.success, .table-2 > tbody > tr > td.success,\n.table > tbody > tr > th.success, .table-2 > tbody > tr > th.success,\n.table > tbody > tr.success > td, .table-2 > tbody > tr.success > td,\n.table > tbody > tr.success > th, .table-2 > tbody > tr.success > th,\n.table > tfoot > tr > td.success, .table-2 > tfoot > tr > td.success,\n.table > tfoot > tr > th.success, .table-2 > tfoot > tr > th.success,\n.table > tfoot > tr.success > td, .table-2 > tfoot > tr.success > td,\n.table > tfoot > tr.success > th, .table-2 > tfoot > tr.success > th {\n  background-color: #dff0d8; }\n\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6; }\n\n.table > thead > tr > td.info, .table-2 > thead > tr > td.info,\n.table > thead > tr > th.info, .table-2 > thead > tr > th.info,\n.table > thead > tr.info > td, .table-2 > thead > tr.info > td,\n.table > thead > tr.info > th, .table-2 > thead > tr.info > th,\n.table > tbody > tr > td.info, .table-2 > tbody > tr > td.info,\n.table > tbody > tr > th.info, .table-2 > tbody > tr > th.info,\n.table > tbody > tr.info > td, .table-2 > tbody > tr.info > td,\n.table > tbody > tr.info > th, .table-2 > tbody > tr.info > th,\n.table > tfoot > tr > td.info, .table-2 > tfoot > tr > td.info,\n.table > tfoot > tr > th.info, .table-2 > tfoot > tr > th.info,\n.table > tfoot > tr.info > td, .table-2 > tfoot > tr.info > td,\n.table > tfoot > tr.info > th, .table-2 > tfoot > tr.info > th {\n  background-color: #d9edf7; }\n\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3; }\n\n.table > thead > tr > td.warning, .table-2 > thead > tr > td.warning,\n.table > thead > tr > th.warning, .table-2 > thead > tr > th.warning,\n.table > thead > tr.warning > td, .table-2 > thead > tr.warning > td,\n.table > thead > tr.warning > th, .table-2 > thead > tr.warning > th,\n.table > tbody > tr > td.warning, .table-2 > tbody > tr > td.warning,\n.table > tbody > tr > th.warning, .table-2 > tbody > tr > th.warning,\n.table > tbody > tr.warning > td, .table-2 > tbody > tr.warning > td,\n.table > tbody > tr.warning > th, .table-2 > tbody > tr.warning > th,\n.table > tfoot > tr > td.warning, .table-2 > tfoot > tr > td.warning,\n.table > tfoot > tr > th.warning, .table-2 > tfoot > tr > th.warning,\n.table > tfoot > tr.warning > td, .table-2 > tfoot > tr.warning > td,\n.table > tfoot > tr.warning > th, .table-2 > tfoot > tr.warning > th {\n  background-color: #fcf8e3; }\n\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc; }\n\n.table > thead > tr > td.danger, .table-2 > thead > tr > td.danger,\n.table > thead > tr > th.danger, .table-2 > thead > tr > th.danger,\n.table > thead > tr.danger > td, .table-2 > thead > tr.danger > td,\n.table > thead > tr.danger > th, .table-2 > thead > tr.danger > th,\n.table > tbody > tr > td.danger, .table-2 > tbody > tr > td.danger,\n.table > tbody > tr > th.danger, .table-2 > tbody > tr > th.danger,\n.table > tbody > tr.danger > td, .table-2 > tbody > tr.danger > td,\n.table > tbody > tr.danger > th, .table-2 > tbody > tr.danger > th,\n.table > tfoot > tr > td.danger, .table-2 > tfoot > tr > td.danger,\n.table > tfoot > tr > th.danger, .table-2 > tfoot > tr > th.danger,\n.table > tfoot > tr.danger > td, .table-2 > tfoot > tr.danger > td,\n.table > tfoot > tr.danger > th, .table-2 > tfoot > tr.danger > th {\n  background-color: #f2dede; }\n\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc; }\n\n@media screen and (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    overflow-x: auto;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #F1EEEA;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive > .table, .table-responsive > .table-2 {\n      margin-bottom: 0; }\n      .table-responsive > .table > thead > tr > th, .table-responsive > .table-2 > thead > tr > th,\n      .table-responsive > .table > thead > tr > td,\n      .table-responsive > .table-2 > thead > tr > td,\n      .table-responsive > .table > tbody > tr > th,\n      .table-responsive > .table-2 > tbody > tr > th,\n      .table-responsive > .table > tbody > tr > td,\n      .table-responsive > .table-2 > tbody > tr > td,\n      .table-responsive > .table > tfoot > tr > th,\n      .table-responsive > .table-2 > tfoot > tr > th,\n      .table-responsive > .table > tfoot > tr > td,\n      .table-responsive > .table-2 > tfoot > tr > td {\n        white-space: nowrap; }\n    .table-responsive > .table-bordered {\n      border: 0; }\n      .table-responsive > .table-bordered > thead > tr > th:first-child,\n      .table-responsive > .table-bordered > thead > tr > td:first-child,\n      .table-responsive > .table-bordered > tbody > tr > th:first-child,\n      .table-responsive > .table-bordered > tbody > tr > td:first-child,\n      .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n      .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n        border-left: 0; }\n      .table-responsive > .table-bordered > thead > tr > th:last-child,\n      .table-responsive > .table-bordered > thead > tr > td:last-child,\n      .table-responsive > .table-bordered > tbody > tr > th:last-child,\n      .table-responsive > .table-bordered > tbody > tr > td:last-child,\n      .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n      .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n        border-right: 0; }\n      .table-responsive > .table-bordered > tbody > tr:last-child > th,\n      .table-responsive > .table-bordered > tbody > tr:last-child > td,\n      .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n      .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n        border-bottom: 0; } }\n\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  min-width: 0; }\n\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #020621;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5; }\n\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold; }\n\ninput[type=\"search\"] {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal; }\n\ninput[type=\"file\"] {\n  display: block; }\n\ninput[type=\"range\"] {\n  display: block;\n  width: 100%; }\n\nselect[multiple],\nselect[size] {\n  height: auto; }\n\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px; }\n\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #5b5b5b; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #5b5b5b;\n  background-color: #FFF;\n  background-image: none;\n  border: 1px solid #dad7d4;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s; }\n  .form-control:focus {\n    border-color: #30a7fc;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(48, 167, 252, 0.6);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(48, 167, 252, 0.6); }\n  .form-control::-moz-placeholder {\n    color: #777777;\n    opacity: 1; }\n  .form-control:-ms-input-placeholder {\n    color: #777777; }\n  .form-control::-webkit-input-placeholder {\n    color: #777777; }\n  .form-control[disabled], .form-control[readonly],\n  fieldset[disabled] .form-control {\n    cursor: not-allowed;\n    background-color: #d5d5d5;\n    opacity: 1; }\n\ntextarea.form-control {\n  height: auto; }\n\ninput[type=\"search\"] {\n  -webkit-appearance: none; }\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  line-height: 34px;\n  line-height: 1.42857 \\0; }\n  input[type=\"date\"].input-sm, .form-horizontal .form-group-sm input[type=\"date\"].form-control, .input-group-sm > input[type=\"date\"].form-control,\n  .input-group-sm > input[type=\"date\"].input-group-addon,\n  .input-group-sm > .input-group-btn > input[type=\"date\"].btn,\n  input[type=\"time\"].input-sm,\n  .form-horizontal .form-group-sm input[type=\"time\"].form-control,\n  .input-group-sm > input[type=\"time\"].form-control,\n  .input-group-sm > input[type=\"time\"].input-group-addon,\n  .input-group-sm > .input-group-btn > input[type=\"time\"].btn,\n  input[type=\"datetime-local\"].input-sm,\n  .form-horizontal .form-group-sm input[type=\"datetime-local\"].form-control,\n  .input-group-sm > input[type=\"datetime-local\"].form-control,\n  .input-group-sm > input[type=\"datetime-local\"].input-group-addon,\n  .input-group-sm > .input-group-btn > input[type=\"datetime-local\"].btn,\n  input[type=\"month\"].input-sm,\n  .form-horizontal .form-group-sm input[type=\"month\"].form-control,\n  .input-group-sm > input[type=\"month\"].form-control,\n  .input-group-sm > input[type=\"month\"].input-group-addon,\n  .input-group-sm > .input-group-btn > input[type=\"month\"].btn {\n    line-height: 30px; }\n  input[type=\"date\"].input-lg, .form-horizontal .form-group-lg input[type=\"date\"].form-control, .input-group-lg > input[type=\"date\"].form-control,\n  .input-group-lg > input[type=\"date\"].input-group-addon,\n  .input-group-lg > .input-group-btn > input[type=\"date\"].btn,\n  input[type=\"time\"].input-lg,\n  .form-horizontal .form-group-lg input[type=\"time\"].form-control,\n  .input-group-lg > input[type=\"time\"].form-control,\n  .input-group-lg > input[type=\"time\"].input-group-addon,\n  .input-group-lg > .input-group-btn > input[type=\"time\"].btn,\n  input[type=\"datetime-local\"].input-lg,\n  .form-horizontal .form-group-lg input[type=\"datetime-local\"].form-control,\n  .input-group-lg > input[type=\"datetime-local\"].form-control,\n  .input-group-lg > input[type=\"datetime-local\"].input-group-addon,\n  .input-group-lg > .input-group-btn > input[type=\"datetime-local\"].btn,\n  input[type=\"month\"].input-lg,\n  .form-horizontal .form-group-lg input[type=\"month\"].form-control,\n  .input-group-lg > input[type=\"month\"].form-control,\n  .input-group-lg > input[type=\"month\"].input-group-addon,\n  .input-group-lg > .input-group-btn > input[type=\"month\"].btn {\n    line-height: 46px; }\n\n.form-group {\n  margin-bottom: 15px; }\n\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  min-height: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  .radio label,\n  .checkbox label {\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: normal;\n    cursor: pointer; }\n\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-left: -20px;\n  margin-top: 4px \\9; }\n\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px; }\n\n.radio-inline,\n.checkbox-inline {\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer; }\n\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px; }\n\ninput[type=\"radio\"][disabled], input[type=\"radio\"].disabled,\nfieldset[disabled] input[type=\"radio\"],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"checkbox\"].disabled,\nfieldset[disabled]\ninput[type=\"checkbox\"] {\n  cursor: not-allowed; }\n\n.radio-inline.disabled,\nfieldset[disabled] .radio-inline,\n.checkbox-inline.disabled,\nfieldset[disabled]\n.checkbox-inline {\n  cursor: not-allowed; }\n\n.radio.disabled label,\nfieldset[disabled] .radio label,\n.checkbox.disabled label,\nfieldset[disabled]\n.checkbox label {\n  cursor: not-allowed; }\n\n.form-control-static {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0; }\n  .form-control-static.input-lg, .form-horizontal .form-group-lg .form-control-static.form-control, .input-group-lg > .form-control-static.form-control,\n  .input-group-lg > .form-control-static.input-group-addon,\n  .input-group-lg > .input-group-btn > .form-control-static.btn, .icon-nav\n  .input-group-lg > .input-group-btn > label.form-control-static, .form-control-static.input-sm, .form-horizontal .form-group-sm .form-control-static.form-control, .input-group-sm > .form-control-static.form-control,\n  .input-group-sm > .form-control-static.input-group-addon,\n  .input-group-sm > .input-group-btn > .form-control-static.btn, .icon-nav\n  .input-group-sm > .input-group-btn > label.form-control-static {\n    padding-left: 0;\n    padding-right: 0; }\n\n.input-sm, .form-horizontal .form-group-sm .form-control, .input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn, .icon-nav\n.input-group-sm > .input-group-btn > label {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px; }\n\nselect.input-sm, .form-horizontal .form-group-sm select.form-control, .input-group-sm > select.form-control,\n.input-group-sm > select.input-group-addon,\n.input-group-sm > .input-group-btn > select.btn {\n  height: 30px;\n  line-height: 30px; }\n\ntextarea.input-sm, .form-horizontal .form-group-sm textarea.form-control, .input-group-sm > textarea.form-control,\n.input-group-sm > textarea.input-group-addon,\n.input-group-sm > .input-group-btn > textarea.btn,\nselect[multiple].input-sm,\n.form-horizontal .form-group-sm select[multiple].form-control,\n.input-group-sm > select[multiple].form-control,\n.input-group-sm > select[multiple].input-group-addon,\n.input-group-sm > .input-group-btn > select[multiple].btn {\n  height: auto; }\n\n.input-lg, .form-horizontal .form-group-lg .form-control, .input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn, .icon-nav\n.input-group-lg > .input-group-btn > label {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 6px; }\n\nselect.input-lg, .form-horizontal .form-group-lg select.form-control, .input-group-lg > select.form-control,\n.input-group-lg > select.input-group-addon,\n.input-group-lg > .input-group-btn > select.btn {\n  height: 46px;\n  line-height: 46px; }\n\ntextarea.input-lg, .form-horizontal .form-group-lg textarea.form-control, .input-group-lg > textarea.form-control,\n.input-group-lg > textarea.input-group-addon,\n.input-group-lg > .input-group-btn > textarea.btn,\nselect[multiple].input-lg,\n.form-horizontal .form-group-lg select[multiple].form-control,\n.input-group-lg > select[multiple].form-control,\n.input-group-lg > select[multiple].input-group-addon,\n.input-group-lg > .input-group-btn > select[multiple].btn {\n  height: auto; }\n\n.has-feedback {\n  position: relative; }\n  .has-feedback .form-control {\n    padding-right: 42.5px; }\n\n.form-control-feedback {\n  position: absolute;\n  top: 25px;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center; }\n\n.input-lg + .form-control-feedback, .form-horizontal .form-group-lg .form-control + .form-control-feedback, .input-group-lg > .form-control + .form-control-feedback,\n.input-group-lg > .input-group-addon + .form-control-feedback,\n.input-group-lg > .input-group-btn > .btn + .form-control-feedback, .icon-nav\n.input-group-lg > .input-group-btn > label + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px; }\n\n.input-sm + .form-control-feedback, .form-horizontal .form-group-sm .form-control + .form-control-feedback, .input-group-sm > .form-control + .form-control-feedback,\n.input-group-sm > .input-group-addon + .form-control-feedback,\n.input-group-sm > .input-group-btn > .btn + .form-control-feedback, .icon-nav\n.input-group-sm > .input-group-btn > label + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px; }\n\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline {\n  color: #4ab767; }\n\n.has-success .form-control {\n  border-color: #4ab767;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .has-success .form-control:focus {\n    border-color: #3b9352;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #93d4a4;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #93d4a4; }\n\n.has-success .input-group-addon {\n  color: #4ab767;\n  border-color: #4ab767;\n  background-color: #dff0d8; }\n\n.has-success .form-control-feedback {\n  color: #4ab767; }\n\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline {\n  color: #8a6d3b; }\n\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .has-warning .form-control:focus {\n    border-color: #66512c;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b; }\n\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  border-color: #8a6d3b;\n  background-color: #fcf8e3; }\n\n.has-warning .form-control-feedback {\n  color: #8a6d3b; }\n\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline {\n  color: #c0392b; }\n\n.has-error .form-control {\n  border-color: #c0392b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .has-error .form-control:focus {\n    border-color: #962d22;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #df7c72;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #df7c72; }\n\n.has-error .input-group-addon {\n  color: #c0392b;\n  border-color: #c0392b;\n  background-color: #f2dede; }\n\n.has-error .form-control-feedback {\n  color: #c0392b; }\n\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0; }\n\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #091c99; }\n\n@media (min-width: 768px) {\n  .form-inline .form-group, .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle; }\n  .form-inline .form-control, .navbar-form .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle; }\n  .form-inline .input-group, .navbar-form .input-group {\n    display: inline-table;\n    vertical-align: middle; }\n    .form-inline .input-group .input-group-addon, .navbar-form .input-group .input-group-addon,\n    .form-inline .input-group .input-group-btn, .navbar-form .input-group .input-group-btn,\n    .form-inline .input-group .form-control, .navbar-form .input-group .form-control {\n      width: auto; }\n  .form-inline .input-group > .form-control, .navbar-form .input-group > .form-control {\n    width: 100%; }\n  .form-inline .control-label, .navbar-form .control-label {\n    margin-bottom: 0;\n    vertical-align: middle; }\n  .form-inline .radio, .navbar-form .radio,\n  .form-inline .checkbox, .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle; }\n    .form-inline .radio label, .navbar-form .radio label,\n    .form-inline .checkbox label, .navbar-form .checkbox label {\n      padding-left: 0; }\n  .form-inline .radio input[type=\"radio\"], .navbar-form .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"], .navbar-form .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0; }\n  .form-inline .has-feedback .form-control-feedback, .navbar-form .has-feedback .form-control-feedback {\n    top: 0; } }\n\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 7px; }\n\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px; }\n\n.form-horizontal .form-group {\n  margin-left: -7.5px;\n  margin-right: -7.5px; }\n  .form-horizontal .form-group:before, .form-horizontal .form-group:after {\n    content: \" \";\n    display: table; }\n  .form-horizontal .form-group:after {\n    clear: both; }\n\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    text-align: right;\n    margin-bottom: 0;\n    padding-top: 7px; } }\n\n.form-horizontal .has-feedback .form-control-feedback {\n  top: 0;\n  right: 7.5px; }\n\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 14.3px; } }\n\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px; } }\n\n.btn, .icon-nav label {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .btn:focus, .icon-nav label:focus, .btn:active:focus, .icon-nav label:active:focus, .btn.active:focus, .icon-nav label.active:focus {\n    outline: thin dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\n  .btn:hover, .icon-nav label:hover, .btn:focus, .icon-nav label:focus {\n    color: #333;\n    text-decoration: none; }\n  .btn:active, .icon-nav label:active, .btn.active, .icon-nav label.active {\n    outline: 0;\n    background-image: none;\n    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n  .btn.disabled, .icon-nav label.disabled, .btn[disabled], .icon-nav label[disabled],\n  fieldset[disabled] .btn,\n  fieldset[disabled] .icon-nav label, .icon-nav\n  fieldset[disabled] label {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.65;\n    filter: alpha(opacity=65);\n    -webkit-box-shadow: none;\n    box-shadow: none; }\n\n.btn-default, .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {\n  color: #333;\n  background-color: #e8e8e8;\n  border-color: #CCC; }\n  .btn-default:hover, .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .icon-nav label:hover, .icon-nav .timeline .dropdown-menu li label:hover, .btn-default:focus, .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li .icon-nav label:focus, .icon-nav .timeline .dropdown-menu li label:focus, .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,\n  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li\n  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav\n  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li\n  .open > label.dropdown-toggle {\n    color: #333;\n    background-color: #cfcfcf;\n    border-color: #adadad; }\n  .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,\n  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li\n  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav\n  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li\n  .open > label.dropdown-toggle {\n    background-image: none; }\n  .btn-default.disabled, .timeline .dropdown-menu li .disabled.btn, .timeline .dropdown-menu li .icon-nav label.disabled, .icon-nav .timeline .dropdown-menu li label.disabled, .btn-default.disabled:hover, .timeline .dropdown-menu li .disabled.btn:hover, .timeline .dropdown-menu li .icon-nav label.disabled:hover, .icon-nav .timeline .dropdown-menu li label.disabled:hover, .btn-default.disabled:focus, .timeline .dropdown-menu li .disabled.btn:focus, .timeline .dropdown-menu li .icon-nav label.disabled:focus, .icon-nav .timeline .dropdown-menu li label.disabled:focus, .btn-default.disabled:active, .timeline .dropdown-menu li .disabled.btn:active, .timeline .dropdown-menu li .icon-nav label.disabled:active, .icon-nav .timeline .dropdown-menu li label.disabled:active, .btn-default.disabled.active, .timeline .dropdown-menu li .disabled.active.btn, .timeline .dropdown-menu li .icon-nav label.disabled.active, .icon-nav .timeline .dropdown-menu li label.disabled.active, .btn-default[disabled], .timeline .dropdown-menu li [disabled].btn, .timeline .dropdown-menu li .icon-nav label[disabled], .icon-nav .timeline .dropdown-menu li label[disabled], .btn-default[disabled]:hover, .timeline .dropdown-menu li [disabled].btn:hover, .timeline .dropdown-menu li .icon-nav label[disabled]:hover, .icon-nav .timeline .dropdown-menu li label[disabled]:hover, .btn-default[disabled]:focus, .timeline .dropdown-menu li [disabled].btn:focus, .timeline .dropdown-menu li .icon-nav label[disabled]:focus, .icon-nav .timeline .dropdown-menu li label[disabled]:focus, .btn-default[disabled]:active, .timeline .dropdown-menu li [disabled].btn:active, .timeline .dropdown-menu li .icon-nav label[disabled]:active, .icon-nav .timeline .dropdown-menu li label[disabled]:active, .btn-default[disabled].active, .timeline .dropdown-menu li [disabled].active.btn, .timeline .dropdown-menu li .icon-nav label[disabled].active, .icon-nav .timeline .dropdown-menu li label[disabled].active,\n  fieldset[disabled] .btn-default,\n  fieldset[disabled] .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li\n  fieldset[disabled] .btn,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label,\n  fieldset[disabled] .btn-default:hover,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:hover,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:hover,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:hover,\n  fieldset[disabled] .btn-default:focus,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:focus,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:focus,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:focus,\n  fieldset[disabled] .btn-default:active,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:active,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:active,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:active,\n  fieldset[disabled] .btn-default.active,\n  fieldset[disabled] .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li\n  fieldset[disabled] .active.btn,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label.active,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label.active {\n    background-color: #e8e8e8;\n    border-color: #CCC; }\n  .btn-default .badge, .timeline .dropdown-menu li .btn .badge, .timeline .dropdown-menu li .icon-nav label .badge, .icon-nav .timeline .dropdown-menu li label .badge {\n    color: #e8e8e8;\n    background-color: #333; }\n\n.btn-primary {\n  color: #fff;\n  background-color: #0081BA;\n  border-color: #444; }\n  .btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active,\n  .open > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #005e87;\n    border-color: #252525; }\n  .btn-primary:active, .btn-primary.active,\n  .open > .btn-primary.dropdown-toggle {\n    background-image: none; }\n  .btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled]:active, .btn-primary[disabled].active,\n  fieldset[disabled] .btn-primary,\n  fieldset[disabled] .btn-primary:hover,\n  fieldset[disabled] .btn-primary:focus,\n  fieldset[disabled] .btn-primary:active,\n  fieldset[disabled] .btn-primary.active {\n    background-color: #0081BA;\n    border-color: #444; }\n  .btn-primary .badge {\n    color: #0081BA;\n    background-color: #fff; }\n\n.btn-success, .btn-sign-in, .modal-dialog .sign-in,\n.modal-dialog .sign-in:hover {\n  color: #fff;\n  background-color: #4ab767;\n  border-color: #4ab767; }\n  .btn-success:hover, .btn-sign-in:hover, .modal-dialog .sign-in:hover, .btn-success:focus, .btn-sign-in:focus, .modal-dialog .sign-in:focus, .btn-success:active, .btn-sign-in:active, .modal-dialog .sign-in:active, .btn-success.active, .active.btn-sign-in, .modal-dialog .active.sign-in,\n  .open > .btn-success.dropdown-toggle,\n  .open > .dropdown-toggle.btn-sign-in, .modal-dialog\n  .open > .dropdown-toggle.sign-in {\n    color: #fff;\n    background-color: #3b9352;\n    border-color: #388c4e; }\n  .btn-success:active, .btn-sign-in:active, .modal-dialog .sign-in:active, .btn-success.active, .active.btn-sign-in, .modal-dialog .active.sign-in,\n  .open > .btn-success.dropdown-toggle,\n  .open > .dropdown-toggle.btn-sign-in, .modal-dialog\n  .open > .dropdown-toggle.sign-in {\n    background-image: none; }\n  .btn-success.disabled, .disabled.btn-sign-in, .modal-dialog .disabled.sign-in, .btn-success.disabled:hover, .disabled.btn-sign-in:hover, .modal-dialog .disabled.sign-in:hover, .btn-success.disabled:focus, .disabled.btn-sign-in:focus, .modal-dialog .disabled.sign-in:focus, .btn-success.disabled:active, .disabled.btn-sign-in:active, .modal-dialog .disabled.sign-in:active, .btn-success.disabled.active, .disabled.active.btn-sign-in, .modal-dialog .disabled.active.sign-in, .btn-success[disabled], [disabled].btn-sign-in, .modal-dialog [disabled].sign-in, .btn-success[disabled]:hover, [disabled].btn-sign-in:hover, .modal-dialog [disabled].sign-in:hover, .btn-success[disabled]:focus, [disabled].btn-sign-in:focus, .modal-dialog [disabled].sign-in:focus, .btn-success[disabled]:active, [disabled].btn-sign-in:active, .modal-dialog [disabled].sign-in:active, .btn-success[disabled].active, [disabled].active.btn-sign-in, .modal-dialog [disabled].active.sign-in,\n  fieldset[disabled] .btn-success,\n  fieldset[disabled] .btn-sign-in,\n  fieldset[disabled] .modal-dialog .sign-in, .modal-dialog\n  fieldset[disabled] .sign-in,\n  fieldset[disabled] .btn-success:hover,\n  fieldset[disabled] .btn-sign-in:hover,\n  fieldset[disabled] .modal-dialog .sign-in:hover, .modal-dialog\n  fieldset[disabled] .sign-in:hover,\n  fieldset[disabled] .btn-success:focus,\n  fieldset[disabled] .btn-sign-in:focus,\n  fieldset[disabled] .modal-dialog .sign-in:focus, .modal-dialog\n  fieldset[disabled] .sign-in:focus,\n  fieldset[disabled] .btn-success:active,\n  fieldset[disabled] .btn-sign-in:active,\n  fieldset[disabled] .modal-dialog .sign-in:active, .modal-dialog\n  fieldset[disabled] .sign-in:active,\n  fieldset[disabled] .btn-success.active,\n  fieldset[disabled] .active.btn-sign-in,\n  fieldset[disabled] .modal-dialog .active.sign-in, .modal-dialog\n  fieldset[disabled] .active.sign-in {\n    background-color: #4ab767;\n    border-color: #4ab767; }\n  .btn-success .badge, .btn-sign-in .badge, .modal-dialog .sign-in .badge {\n    color: #4ab767;\n    background-color: #fff; }\n\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da; }\n  .btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active,\n  .open > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #269abc; }\n  .btn-info:active, .btn-info.active,\n  .open > .btn-info.dropdown-toggle {\n    background-image: none; }\n  .btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled]:active, .btn-info[disabled].active,\n  fieldset[disabled] .btn-info,\n  fieldset[disabled] .btn-info:hover,\n  fieldset[disabled] .btn-info:focus,\n  fieldset[disabled] .btn-info:active,\n  fieldset[disabled] .btn-info.active {\n    background-color: #5bc0de;\n    border-color: #46b8da; }\n  .btn-info .badge {\n    color: #5bc0de;\n    background-color: #fff; }\n\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236; }\n  .btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active,\n  .open > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #d58512; }\n  .btn-warning:active, .btn-warning.active,\n  .open > .btn-warning.dropdown-toggle {\n    background-image: none; }\n  .btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled]:active, .btn-warning[disabled].active,\n  fieldset[disabled] .btn-warning,\n  fieldset[disabled] .btn-warning:hover,\n  fieldset[disabled] .btn-warning:focus,\n  fieldset[disabled] .btn-warning:active,\n  fieldset[disabled] .btn-warning.active {\n    background-color: #f0ad4e;\n    border-color: #eea236; }\n  .btn-warning .badge {\n    color: #f0ad4e;\n    background-color: #fff; }\n\n.btn-danger {\n  color: #fff;\n  background-color: #d65548;\n  border-color: #81261d; }\n  .btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active,\n  .open > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #c0392b;\n    border-color: #4f1812; }\n  .btn-danger:active, .btn-danger.active,\n  .open > .btn-danger.dropdown-toggle {\n    background-image: none; }\n  .btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled]:active, .btn-danger[disabled].active,\n  fieldset[disabled] .btn-danger,\n  fieldset[disabled] .btn-danger:hover,\n  fieldset[disabled] .btn-danger:focus,\n  fieldset[disabled] .btn-danger:active,\n  fieldset[disabled] .btn-danger.active {\n    background-color: #d65548;\n    border-color: #81261d; }\n  .btn-danger .badge {\n    color: #d65548;\n    background-color: #fff; }\n\n.btn-link {\n  color: #0081BA;\n  font-weight: normal;\n  cursor: pointer;\n  border-radius: 0; }\n  .btn-link, .btn-link:active, .btn-link[disabled],\n  fieldset[disabled] .btn-link {\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none; }\n  .btn-link, .btn-link:hover, .btn-link:focus, .btn-link:active {\n    border-color: transparent; }\n  .btn-link:hover, .btn-link:focus {\n    color: #005e87;\n    text-decoration: underline;\n    background-color: transparent; }\n  .btn-link[disabled]:hover, .btn-link[disabled]:focus,\n  fieldset[disabled] .btn-link:hover,\n  fieldset[disabled] .btn-link:focus {\n    color: #777777;\n    text-decoration: none; }\n\n.btn-lg, .btn-group-lg > .btn, .icon-nav .btn-group-lg > label {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 6px; }\n\n.btn-sm, .btn-group-sm > .btn, .icon-nav .btn-group-sm > label, .btn-github {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px; }\n\n.btn-xs, .btn-group-xs > .btn, .icon-nav .btn-group-xs > label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px; }\n\n.btn-block {\n  display: block;\n  width: 100%; }\n\n.btn-block + .btn-block {\n  margin-top: 5px; }\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  -o-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear; }\n  .fade.in {\n    opacity: 1; }\n\n.collapse {\n  display: none; }\n  .collapse.in {\n    display: block; }\n\ntr.collapse.in {\n  display: table-row; }\n\ntbody.collapse.in {\n  display: table-row-group; }\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height 0.35s ease;\n  -o-transition: height 0.35s ease;\n  transition: height 0.35s ease; }\n\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px solid;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent; }\n\n.dropdown {\n  position: relative; }\n\n.dropdown-toggle:focus {\n  outline: 0; }\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  text-align: left;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box; }\n  .dropdown-menu.pull-right {\n    right: 0;\n    left: auto; }\n  .dropdown-menu .divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5; }\n  .dropdown-menu > li > a {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: normal;\n    line-height: 1.42857;\n    color: #0081BA;\n    white-space: nowrap; }\n\n.dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {\n  text-decoration: none;\n  color: #006fa1;\n  background-color: #f5f5f5; }\n\n.dropdown-menu > .active > a, .dropdown-menu > .active > a:hover, .dropdown-menu > .active > a:focus {\n  color: #5b5b5b;\n  text-decoration: none;\n  outline: 0;\n  background-color: #0081BA; }\n\n.dropdown-menu > .disabled > a, .dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {\n  color: #777777; }\n\n.dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n  cursor: not-allowed; }\n\n.open > .dropdown-menu {\n  display: block; }\n\n.open > a {\n  outline: 0; }\n\n.dropdown-menu-right {\n  left: auto;\n  right: 0; }\n\n.dropdown-menu-left {\n  left: 0;\n  right: auto; }\n\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857;\n  color: #020621;\n  white-space: nowrap; }\n\n.dropdown-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 990; }\n\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto; }\n\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  border-top: 0;\n  border-bottom: 4px solid;\n  content: \"\"; }\n\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 1px; }\n\n@media (min-width: 768px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto; }\n  .navbar-right .dropdown-menu-left {\n    left: 0;\n    right: auto; } }\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle; }\n  .btn-group > .btn, .icon-nav .btn-group > label,\n  .btn-group-vertical > .btn, .icon-nav\n  .btn-group-vertical > label {\n    position: relative;\n    float: left; }\n    .btn-group > .btn:hover, .icon-nav .btn-group > label:hover, .btn-group > .btn:focus, .icon-nav .btn-group > label:focus, .btn-group > .btn:active, .icon-nav .btn-group > label:active, .btn-group > .btn.active, .icon-nav .btn-group > label.active,\n    .btn-group-vertical > .btn:hover, .icon-nav\n    .btn-group-vertical > label:hover,\n    .btn-group-vertical > .btn:focus, .icon-nav\n    .btn-group-vertical > label:focus,\n    .btn-group-vertical > .btn:active, .icon-nav\n    .btn-group-vertical > label:active,\n    .btn-group-vertical > .btn.active, .icon-nav\n    .btn-group-vertical > label.active {\n      z-index: 2; }\n    .btn-group > .btn:focus, .icon-nav .btn-group > label:focus,\n    .btn-group-vertical > .btn:focus, .icon-nav\n    .btn-group-vertical > label:focus {\n      outline: 0; }\n\n.btn-group .btn + .btn, .btn-group .icon-nav label + .btn, .icon-nav .btn-group label + .btn, .btn-group .icon-nav .btn + label, .icon-nav .btn-group .btn + label, .btn-group .icon-nav label + label, .icon-nav .btn-group label + label,\n.btn-group .btn + .btn-group,\n.btn-group .icon-nav label + .btn-group, .icon-nav\n.btn-group label + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .icon-nav .btn-group + label, .icon-nav\n.btn-group .btn-group + label,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px; }\n\n.btn-toolbar {\n  margin-left: -5px; }\n  .btn-toolbar:before, .btn-toolbar:after {\n    content: \" \";\n    display: table; }\n  .btn-toolbar:after {\n    clear: both; }\n  .btn-toolbar .btn-group,\n  .btn-toolbar .input-group {\n    float: left; }\n  .btn-toolbar > .btn, .icon-nav .btn-toolbar > label,\n  .btn-toolbar > .btn-group,\n  .btn-toolbar > .input-group {\n    margin-left: 5px; }\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle), .icon-nav .btn-group > label:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0; }\n\n.btn-group > .btn:first-child, .icon-nav .btn-group > label:first-child {\n  margin-left: 0; }\n  .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle), .icon-nav .btn-group > label:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0; }\n\n.btn-group > .btn:last-child:not(:first-child), .icon-nav .btn-group > label:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0; }\n\n.btn-group > .btn-group {\n  float: left; }\n\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn, .icon-nav .btn-group > .btn-group:not(:first-child):not(:last-child) > label {\n  border-radius: 0; }\n\n.btn-group > .btn-group:first-child > .btn:last-child, .icon-nav .btn-group > .btn-group:first-child > label:last-child,\n.btn-group > .btn-group:first-child > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0; }\n\n.btn-group > .btn-group:last-child > .btn:first-child, .icon-nav .btn-group > .btn-group:last-child > label:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0; }\n\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0; }\n\n.btn-group > .btn + .dropdown-toggle, .icon-nav .btn-group > label + .dropdown-toggle {\n  padding-left: 8px;\n  padding-right: 8px; }\n\n.btn-group > .btn-lg + .dropdown-toggle, .btn-group-lg.btn-group > .btn + .dropdown-toggle, .icon-nav .btn-group-lg.btn-group > label + .dropdown-toggle {\n  padding-left: 12px;\n  padding-right: 12px; }\n\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n  .btn-group.open .dropdown-toggle.btn-link {\n    -webkit-box-shadow: none;\n    box-shadow: none; }\n\n.btn .caret, .icon-nav label .caret {\n  margin-left: 0; }\n\n.btn-lg .caret, .btn-group-lg > .btn .caret, .icon-nav .btn-group-lg > label .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0; }\n\n.dropup .btn-lg .caret, .dropup .btn-group-lg > .btn .caret, .dropup .icon-nav .btn-group-lg > label .caret, .icon-nav .dropup .btn-group-lg > label .caret {\n  border-width: 0 5px 5px; }\n\n.btn-group-vertical > .btn, .icon-nav .btn-group-vertical > label,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn, .icon-nav\n.btn-group-vertical > .btn-group > label {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%; }\n\n.btn-group-vertical > .btn-group:before, .btn-group-vertical > .btn-group:after {\n  content: \" \";\n  display: table; }\n\n.btn-group-vertical > .btn-group:after {\n  clear: both; }\n\n.btn-group-vertical > .btn-group > .btn, .icon-nav .btn-group-vertical > .btn-group > label {\n  float: none; }\n\n.btn-group-vertical > .btn + .btn, .icon-nav .btn-group-vertical > label + .btn, .icon-nav .btn-group-vertical > .btn + label, .icon-nav .btn-group-vertical > label + label,\n.btn-group-vertical > .btn + .btn-group, .icon-nav\n.btn-group-vertical > label + .btn-group,\n.btn-group-vertical > .btn-group + .btn, .icon-nav\n.btn-group-vertical > .btn-group + label,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0; }\n\n.btn-group-vertical > .btn:not(:first-child):not(:last-child), .icon-nav .btn-group-vertical > label:not(:first-child):not(:last-child) {\n  border-radius: 0; }\n\n.btn-group-vertical > .btn:first-child:not(:last-child), .icon-nav .btn-group-vertical > label:first-child:not(:last-child) {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.btn-group-vertical > .btn:last-child:not(:first-child), .icon-nav .btn-group-vertical > label:last-child:not(:first-child) {\n  border-bottom-left-radius: 4px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0; }\n\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn, .icon-nav .btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > label {\n  border-radius: 0; }\n\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child, .icon-nav .btn-group-vertical > .btn-group:first-child:not(:last-child) > label:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child, .icon-nav .btn-group-vertical > .btn-group:last-child:not(:first-child) > label:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0; }\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate; }\n  .btn-group-justified > .btn, .icon-nav .btn-group-justified > label,\n  .btn-group-justified > .btn-group {\n    float: none;\n    display: table-cell;\n    width: 1%; }\n  .btn-group-justified > .btn-group .btn, .btn-group-justified > .btn-group .icon-nav label, .icon-nav .btn-group-justified > .btn-group label {\n    width: 100%; }\n  .btn-group-justified > .btn-group .dropdown-menu {\n    left: auto; }\n\n[data-toggle=\"buttons\"] > .btn > input[type=\"radio\"], .icon-nav [data-toggle=\"buttons\"] > label > input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn > input[type=\"checkbox\"], .icon-nav\n[data-toggle=\"buttons\"] > label > input[type=\"checkbox\"] {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  filter: alpha(opacity=0); }\n\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate; }\n  .input-group[class*=\"col-\"] {\n    float: none;\n    padding-left: 0;\n    padding-right: 0; }\n  .input-group .form-control {\n    position: relative;\n    z-index: 2;\n    float: left;\n    width: 100%;\n    margin-bottom: 0; }\n\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell; }\n  .input-group-addon:not(:first-child):not(:last-child),\n  .input-group-btn:not(:first-child):not(:last-child),\n  .input-group .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0; }\n\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle; }\n\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #5b5b5b;\n  text-align: center;\n  background-color: #d5d5d5;\n  border: 1px solid #dad7d4;\n  border-radius: 4px; }\n  .input-group-addon.input-sm, .form-horizontal .form-group-sm .input-group-addon.form-control,\n  .input-group-sm > .input-group-addon,\n  .input-group-sm > .input-group-btn > .input-group-addon.btn, .icon-nav\n  .input-group-sm > .input-group-btn > label.input-group-addon {\n    padding: 5px 10px;\n    font-size: 12px;\n    border-radius: 2px; }\n  .input-group-addon.input-lg, .form-horizontal .form-group-lg .input-group-addon.form-control,\n  .input-group-lg > .input-group-addon,\n  .input-group-lg > .input-group-btn > .input-group-addon.btn, .icon-nav\n  .input-group-lg > .input-group-btn > label.input-group-addon {\n    padding: 10px 16px;\n    font-size: 18px;\n    border-radius: 6px; }\n  .input-group-addon input[type=\"radio\"],\n  .input-group-addon input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn, .icon-nav\n.input-group-btn:first-child > label,\n.input-group-btn:first-child > .btn-group > .btn, .icon-nav\n.input-group-btn:first-child > .btn-group > label,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle), .icon-nav\n.input-group-btn:last-child > label:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn, .icon-nav\n.input-group-btn:last-child > .btn-group:not(:last-child) > label {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0; }\n\n.input-group-addon:first-child {\n  border-right: 0; }\n\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn, .icon-nav\n.input-group-btn:last-child > label,\n.input-group-btn:last-child > .btn-group > .btn, .icon-nav\n.input-group-btn:last-child > .btn-group > label,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child), .icon-nav\n.input-group-btn:first-child > label:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn, .icon-nav\n.input-group-btn:first-child > .btn-group:not(:first-child) > label {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0; }\n\n.input-group-addon:last-child {\n  border-left: 0; }\n\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap; }\n  .input-group-btn > .btn, .icon-nav .input-group-btn > label {\n    position: relative; }\n    .input-group-btn > .btn + .btn, .icon-nav .input-group-btn > label + .btn, .icon-nav .input-group-btn > .btn + label, .icon-nav .input-group-btn > label + label {\n      margin-left: -1px; }\n    .input-group-btn > .btn:hover, .icon-nav .input-group-btn > label:hover, .input-group-btn > .btn:focus, .icon-nav .input-group-btn > label:focus, .input-group-btn > .btn:active, .icon-nav .input-group-btn > label:active {\n      z-index: 2; }\n  .input-group-btn:first-child > .btn, .icon-nav .input-group-btn:first-child > label,\n  .input-group-btn:first-child > .btn-group {\n    margin-right: -1px; }\n  .input-group-btn:last-child > .btn, .icon-nav .input-group-btn:last-child > label,\n  .input-group-btn:last-child > .btn-group {\n    margin-left: -1px; }\n\n.nav {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none; }\n  .nav:before, .nav:after {\n    content: \" \";\n    display: table; }\n  .nav:after {\n    clear: both; }\n  .nav > li {\n    position: relative;\n    display: block; }\n    .nav > li > a {\n      position: relative;\n      display: block;\n      padding: 10px 15px; }\n      .nav > li > a:hover, .nav > li > a:focus {\n        text-decoration: none;\n        background-color: #d5d5d5; }\n    .nav > li.disabled > a {\n      color: #777777; }\n      .nav > li.disabled > a:hover, .nav > li.disabled > a:focus {\n        color: #777777;\n        text-decoration: none;\n        background-color: transparent;\n        cursor: not-allowed; }\n  .nav .open > a, .nav .open > a:hover, .nav .open > a:focus {\n    background-color: #d5d5d5;\n    border-color: #0081BA; }\n  .nav .nav-divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5; }\n  .nav > li > a > img {\n    max-width: none; }\n\n.nav-tabs {\n  border-bottom: 1px solid #ddd; }\n  .nav-tabs > li {\n    float: left;\n    margin-bottom: -1px; }\n    .nav-tabs > li > a {\n      margin-right: 2px;\n      line-height: 1.42857;\n      border: 1px solid transparent;\n      border-radius: 4px 4px 0 0; }\n      .nav-tabs > li > a:hover {\n        border-color: #d5d5d5 #d5d5d5 #ddd; }\n    .nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\n      color: #5b5b5b;\n      background-color: #F7F7F9;\n      border: 1px solid #ddd;\n      border-bottom-color: transparent;\n      cursor: default; }\n\n.nav-pills > li {\n  float: left; }\n  .nav-pills > li > a {\n    border-radius: 4px; }\n  .nav-pills > li + li {\n    margin-left: 2px; }\n  .nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {\n    color: #5b5b5b;\n    background-color: #0081BA; }\n\n.nav-stacked > li {\n  float: none; }\n  .nav-stacked > li + li {\n    margin-top: 2px;\n    margin-left: 0; }\n\n.nav-justified, .nav-tabs.nav-justified {\n  width: 100%; }\n  .nav-justified > li, .nav-tabs.nav-justified > li {\n    float: none; }\n    .nav-justified > li > a, .nav-tabs.nav-justified > li > a {\n      text-align: center;\n      margin-bottom: 5px; }\n  .nav-justified > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto; }\n  @media (min-width: 768px) {\n    .nav-justified > li, .nav-tabs.nav-justified > li {\n      display: table-cell;\n      width: 1%; }\n      .nav-justified > li > a, .nav-tabs.nav-justified > li > a {\n        margin-bottom: 0; } }\n\n.nav-tabs-justified, .nav-tabs.nav-justified {\n  border-bottom: 0; }\n  .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n    margin-right: 0;\n    border-radius: 4px; }\n  .nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus, .nav-tabs.nav-justified > .active > a:focus {\n    border: 1px solid #ddd; }\n  @media (min-width: 768px) {\n    .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n      border-bottom: 1px solid #ddd;\n      border-radius: 4px 4px 0 0; }\n    .nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,\n    .nav-tabs-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:hover,\n    .nav-tabs-justified > .active > a:focus, .nav-tabs.nav-justified > .active > a:focus {\n      border-bottom-color: #F7F7F9; } }\n\n.tab-content > .tab-pane {\n  display: none; }\n\n.tab-content > .active {\n  display: block; }\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0; }\n\n.navbar {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent; }\n  .navbar:before, .navbar:after {\n    content: \" \";\n    display: table; }\n  .navbar:after {\n    clear: both; }\n  @media (min-width: 768px) {\n    .navbar {\n      border-radius: 4px; } }\n\n.navbar-header:before, .navbar-header:after {\n  content: \" \";\n  display: table; }\n\n.navbar-header:after {\n  clear: both; }\n\n@media (min-width: 768px) {\n  .navbar-header {\n    float: left; } }\n\n.navbar-collapse {\n  overflow-x: visible;\n  padding-right: 7px;\n  padding-left: 7px;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  -webkit-overflow-scrolling: touch; }\n  .navbar-collapse:before, .navbar-collapse:after {\n    content: \" \";\n    display: table; }\n  .navbar-collapse:after {\n    clear: both; }\n  .navbar-collapse.in {\n    overflow-y: auto; }\n  @media (min-width: 768px) {\n    .navbar-collapse {\n      width: auto;\n      border-top: 0;\n      box-shadow: none; }\n      .navbar-collapse.collapse {\n        display: block !important;\n        height: auto !important;\n        padding-bottom: 0;\n        overflow: visible !important; }\n      .navbar-collapse.in {\n        overflow-y: visible; }\n      .navbar-fixed-top .navbar-collapse,\n      .navbar-static-top .navbar-collapse,\n      .navbar-fixed-bottom .navbar-collapse {\n        padding-left: 0;\n        padding-right: 0; } }\n\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: 340px; }\n  @media (max-width: 480px) and (orientation: landscape) {\n    .navbar-fixed-top .navbar-collapse,\n    .navbar-fixed-bottom .navbar-collapse {\n      max-height: 200px; } }\n\n.container > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-header,\n.container-fluid > .navbar-collapse {\n  margin-right: -7px;\n  margin-left: -7px; }\n  @media (min-width: 768px) {\n    .container > .navbar-header,\n    .container > .navbar-collapse,\n    .container-fluid > .navbar-header,\n    .container-fluid > .navbar-collapse {\n      margin-right: 0;\n      margin-left: 0; } }\n\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px; }\n  @media (min-width: 768px) {\n    .navbar-static-top {\n      border-radius: 0; } }\n\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0); }\n  @media (min-width: 768px) {\n    .navbar-fixed-top,\n    .navbar-fixed-bottom {\n      border-radius: 0; } }\n\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px; }\n\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0; }\n\n.navbar-brand {\n  float: left;\n  padding: 15px 7px;\n  font-size: 18px;\n  line-height: 20px;\n  height: 50px; }\n  .navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none; }\n  @media (min-width: 768px) {\n    .navbar > .container .navbar-brand,\n    .navbar > .container-fluid .navbar-brand {\n      margin-left: -7px; } }\n\n.navbar-toggle {\n  position: relative;\n  float: right;\n  margin-right: 7px;\n  padding: 9px 10px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px; }\n  .navbar-toggle:focus {\n    outline: 0; }\n  .navbar-toggle .icon-bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px; }\n  .navbar-toggle .icon-bar + .icon-bar {\n    margin-top: 4px; }\n  @media (min-width: 768px) {\n    .navbar-toggle {\n      display: none; } }\n\n.navbar-nav {\n  margin: 7.5px -7px; }\n  .navbar-nav > li > a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: 20px; }\n  @media (max-width: 767px) {\n    .navbar-nav .open .dropdown-menu {\n      position: static;\n      float: none;\n      width: auto;\n      margin-top: 0;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none; }\n      .navbar-nav .open .dropdown-menu > li > a,\n      .navbar-nav .open .dropdown-menu .dropdown-header {\n        padding: 5px 15px 5px 25px; }\n      .navbar-nav .open .dropdown-menu > li > a {\n        line-height: 20px; }\n        .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-nav .open .dropdown-menu > li > a:focus {\n          background-image: none; } }\n  @media (min-width: 768px) {\n    .navbar-nav {\n      float: left;\n      margin: 0; }\n      .navbar-nav > li {\n        float: left; }\n        .navbar-nav > li > a {\n          padding-top: 15px;\n          padding-bottom: 15px; }\n      .navbar-nav.navbar-right:last-child {\n        margin-right: -7px; } }\n\n@media (min-width: 768px) {\n  .navbar-left {\n    float: left !important; }\n  .navbar-right {\n    float: right !important; } }\n\n.navbar-form {\n  margin-left: -7px;\n  margin-right: -7px;\n  padding: 10px 7px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  margin-top: 8px;\n  margin-bottom: 8px; }\n  @media (max-width: 767px) {\n    .navbar-form .form-group {\n      margin-bottom: 5px; } }\n  @media (min-width: 768px) {\n    .navbar-form {\n      width: auto;\n      border: 0;\n      margin-left: 0;\n      margin-right: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n      -webkit-box-shadow: none;\n      box-shadow: none; }\n      .navbar-form.navbar-right:last-child {\n        margin-right: -7px; } }\n\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0; }\n\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.navbar-btn, .navbar .navbar-nav > li button {\n  margin-top: 8px;\n  margin-bottom: 8px; }\n  .navbar-btn.btn-sm, .btn-group-sm > .navbar-btn.btn, .navbar .navbar-nav > li .btn-group-sm > button.btn, .icon-nav .btn-group-sm > label.navbar-btn, .navbar-btn.btn-github, .navbar .navbar-nav > li button.btn-github, .navbar .navbar-nav > li button.btn-sm {\n    margin-top: 10px;\n    margin-bottom: 10px; }\n  .navbar-btn.btn-xs, .btn-group-xs > .navbar-btn.btn, .navbar .navbar-nav > li .btn-group-xs > button.btn, .icon-nav .btn-group-xs > label.navbar-btn, .navbar .navbar-nav > li button.btn-xs {\n    margin-top: 14px;\n    margin-bottom: 14px; }\n\n.navbar-text {\n  margin-top: 15px;\n  margin-bottom: 15px; }\n  @media (min-width: 768px) {\n    .navbar-text {\n      float: left;\n      margin-left: 7px;\n      margin-right: 7px; }\n      .navbar-text.navbar-right:last-child {\n        margin-right: 0; } }\n\n.navbar-default {\n  background-color: #fff;\n  border-color: #e5e5e5; }\n  .navbar-default .navbar-brand {\n    color: #020621; }\n    .navbar-default .navbar-brand:hover, .navbar-default .navbar-brand:focus {\n      color: black;\n      background-color: transparent; }\n  .navbar-default .navbar-text {\n    color: #777; }\n  .navbar-default .navbar-nav > li > a {\n    color: #020621; }\n    .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {\n      color: #020621;\n      background-color: #f4f4f4; }\n  .navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {\n    color: #020621;\n    background-color: #2d60ad; }\n  .navbar-default .navbar-nav > .disabled > a, .navbar-default .navbar-nav > .disabled > a:hover, .navbar-default .navbar-nav > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent; }\n  .navbar-default .navbar-toggle {\n    border-color: #ddd; }\n    .navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus {\n      background-color: #ddd; }\n    .navbar-default .navbar-toggle .icon-bar {\n      background-color: #888; }\n  .navbar-default .navbar-collapse,\n  .navbar-default .navbar-form {\n    border-color: #e5e5e5; }\n  .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:hover, .navbar-default .navbar-nav > .open > a:focus {\n    background-color: #2d60ad;\n    color: #020621; }\n  @media (max-width: 767px) {\n    .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n      color: #020621; }\n      .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n        color: #020621;\n        background-color: #f4f4f4; }\n    .navbar-default .navbar-nav .open .dropdown-menu > .active > a, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n      color: #020621;\n      background-color: #2d60ad; }\n    .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n      color: #ccc;\n      background-color: transparent; } }\n  .navbar-default .navbar-link {\n    color: #020621; }\n    .navbar-default .navbar-link:hover {\n      color: #020621; }\n  .navbar-default .btn-link {\n    color: #020621; }\n    .navbar-default .btn-link:hover, .navbar-default .btn-link:focus {\n      color: #020621; }\n    .navbar-default .btn-link[disabled]:hover, .navbar-default .btn-link[disabled]:focus,\n    fieldset[disabled] .navbar-default .btn-link:hover,\n    fieldset[disabled] .navbar-default .btn-link:focus {\n      color: #ccc; }\n\n.navbar-inverse {\n  background-color: #222;\n  border-color: #090909; }\n  .navbar-inverse .navbar-brand {\n    color: #777777; }\n    .navbar-inverse .navbar-brand:hover, .navbar-inverse .navbar-brand:focus {\n      color: #fff;\n      background-color: transparent; }\n  .navbar-inverse .navbar-text {\n    color: #777777; }\n  .navbar-inverse .navbar-nav > li > a {\n    color: #777777; }\n    .navbar-inverse .navbar-nav > li > a:hover, .navbar-inverse .navbar-nav > li > a:focus {\n      color: #fff;\n      background-color: transparent; }\n  .navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover, .navbar-inverse .navbar-nav > .active > a:focus {\n    color: #fff;\n    background-color: #080808; }\n  .navbar-inverse .navbar-nav > .disabled > a, .navbar-inverse .navbar-nav > .disabled > a:hover, .navbar-inverse .navbar-nav > .disabled > a:focus {\n    color: #444;\n    background-color: transparent; }\n  .navbar-inverse .navbar-toggle {\n    border-color: #333; }\n    .navbar-inverse .navbar-toggle:hover, .navbar-inverse .navbar-toggle:focus {\n      background-color: #333; }\n    .navbar-inverse .navbar-toggle .icon-bar {\n      background-color: #fff; }\n  .navbar-inverse .navbar-collapse,\n  .navbar-inverse .navbar-form {\n    border-color: #101010; }\n  .navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus {\n    background-color: #080808;\n    color: #fff; }\n  @media (max-width: 767px) {\n    .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n      border-color: #090909; }\n    .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n      background-color: #090909; }\n    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n      color: #777777; }\n      .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n        color: #fff;\n        background-color: transparent; }\n    .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n      color: #fff;\n      background-color: #080808; }\n    .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n      color: #444;\n      background-color: transparent; } }\n  .navbar-inverse .navbar-link {\n    color: #777777; }\n    .navbar-inverse .navbar-link:hover {\n      color: #fff; }\n  .navbar-inverse .btn-link {\n    color: #777777; }\n    .navbar-inverse .btn-link:hover, .navbar-inverse .btn-link:focus {\n      color: #fff; }\n    .navbar-inverse .btn-link[disabled]:hover, .navbar-inverse .btn-link[disabled]:focus,\n    fieldset[disabled] .navbar-inverse .btn-link:hover,\n    fieldset[disabled] .navbar-inverse .btn-link:focus {\n      color: #444; }\n\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px; }\n  .breadcrumb > li {\n    display: inline-block; }\n    .breadcrumb > li + li:before {\n      content: \"/ \";\n      padding: 0 5px;\n      color: #ccc; }\n  .breadcrumb > .active {\n    color: #777777; }\n\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px; }\n  .pagination > li {\n    display: inline; }\n    .pagination > li > a,\n    .pagination > li > span {\n      position: relative;\n      float: left;\n      padding: 6px 12px;\n      line-height: 1.42857;\n      text-decoration: none;\n      color: #0081BA;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      margin-left: -1px; }\n    .pagination > li:first-child > a,\n    .pagination > li:first-child > span {\n      margin-left: 0;\n      border-bottom-left-radius: 4px;\n      border-top-left-radius: 4px; }\n    .pagination > li:last-child > a,\n    .pagination > li:last-child > span {\n      border-bottom-right-radius: 4px;\n      border-top-right-radius: 4px; }\n  .pagination > li > a:hover, .pagination > li > a:focus,\n  .pagination > li > span:hover,\n  .pagination > li > span:focus {\n    color: #005e87;\n    background-color: #d5d5d5;\n    border-color: #ddd; }\n  .pagination > .active > a, .pagination > .active > a:hover, .pagination > .active > a:focus,\n  .pagination > .active > span,\n  .pagination > .active > span:hover,\n  .pagination > .active > span:focus {\n    z-index: 2;\n    color: #fff;\n    background-color: #0081BA;\n    border-color: #0081BA;\n    cursor: default; }\n  .pagination > .disabled > span,\n  .pagination > .disabled > span:hover,\n  .pagination > .disabled > span:focus,\n  .pagination > .disabled > a,\n  .pagination > .disabled > a:hover,\n  .pagination > .disabled > a:focus {\n    color: #777777;\n    background-color: #fff;\n    border-color: #ddd;\n    cursor: not-allowed; }\n\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px; }\n\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-bottom-left-radius: 6px;\n  border-top-left-radius: 6px; }\n\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-bottom-right-radius: 6px;\n  border-top-right-radius: 6px; }\n\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px; }\n\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px; }\n\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px; }\n\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  list-style: none;\n  text-align: center; }\n  .pager:before, .pager:after {\n    content: \" \";\n    display: table; }\n  .pager:after {\n    clear: both; }\n  .pager li {\n    display: inline; }\n    .pager li > a,\n    .pager li > span {\n      display: inline-block;\n      padding: 5px 14px;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      border-radius: 15px; }\n    .pager li > a:hover,\n    .pager li > a:focus {\n      text-decoration: none;\n      background-color: #d5d5d5; }\n  .pager .next > a,\n  .pager .next > span {\n    float: right; }\n  .pager .previous > a,\n  .pager .previous > span {\n    float: left; }\n  .pager .disabled > a,\n  .pager .disabled > a:hover,\n  .pager .disabled > a:focus,\n  .pager .disabled > span {\n    color: #777777;\n    background-color: #fff;\n    cursor: not-allowed; }\n\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em; }\n  .label:empty {\n    display: none; }\n  .btn .label, .icon-nav label .label {\n    position: relative;\n    top: -1px; }\n\na.label:hover, a.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer; }\n\n.label-default {\n  background-color: #777777; }\n  .label-default[href]:hover, .label-default[href]:focus {\n    background-color: #5e5e5e; }\n\n.label-primary {\n  background-color: #0081BA; }\n  .label-primary[href]:hover, .label-primary[href]:focus {\n    background-color: #005e87; }\n\n.label-success {\n  background-color: #4ab767; }\n  .label-success[href]:hover, .label-success[href]:focus {\n    background-color: #3b9352; }\n\n.label-info {\n  background-color: #5bc0de; }\n  .label-info[href]:hover, .label-info[href]:focus {\n    background-color: #31b0d5; }\n\n.label-warning {\n  background-color: #f0ad4e; }\n  .label-warning[href]:hover, .label-warning[href]:focus {\n    background-color: #ec971f; }\n\n.label-danger {\n  background-color: #c0392b; }\n  .label-danger[href]:hover, .label-danger[href]:focus {\n    background-color: #962d22; }\n\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 1;\n  vertical-align: baseline;\n  white-space: nowrap;\n  text-align: center;\n  background-color: #777777;\n  border-radius: 10px; }\n  .badge:empty {\n    display: none; }\n  .btn .badge, .icon-nav label .badge {\n    position: relative;\n    top: -1px; }\n  .btn-xs .badge, .btn-group-xs > .btn .badge, .icon-nav .btn-group-xs > label .badge {\n    top: 0;\n    padding: 1px 5px; }\n  a.list-group-item.active > .badge,\n  .nav-pills > .active > a > .badge {\n    color: #0081BA;\n    background-color: #fff; }\n  .nav-pills > li > a > .badge {\n    margin-left: 3px; }\n\na.badge:hover, a.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer; }\n\n.jumbotron, .paid-on-board {\n  padding: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #d5d5d5; }\n  .jumbotron h1, .paid-on-board h1,\n  .jumbotron .h1, .paid-on-board .h1 {\n    color: inherit; }\n  .jumbotron p, .paid-on-board p {\n    margin-bottom: 15px;\n    font-size: 21px;\n    font-weight: 200; }\n  .jumbotron > hr, .paid-on-board > hr {\n    border-top-color: #bbbbbb; }\n  .container .jumbotron, .container .paid-on-board {\n    border-radius: 6px; }\n  .jumbotron .container, .paid-on-board .container {\n    max-width: 100%; }\n  @media screen and (min-width: 768px) {\n    .jumbotron, .paid-on-board {\n      padding-top: 48px;\n      padding-bottom: 48px; }\n      .container .jumbotron, .container .paid-on-board {\n        padding-left: 60px;\n        padding-right: 60px; }\n      .jumbotron h1, .paid-on-board h1,\n      .jumbotron .h1, .paid-on-board .h1 {\n        font-size: 63px; } }\n\n.thumbnail {\n  display: block;\n  padding: 0;\n  margin-bottom: 20px;\n  line-height: 1.42857;\n  background-color: #F7F7F9;\n  border: 1px solid #ddd;\n  border-radius: 0;\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out; }\n  .thumbnail > img,\n  .thumbnail a > img {\n    display: block;\n    width: 100% \\9;\n    max-width: 100%;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto; }\n  .thumbnail .caption {\n    padding: 9px;\n    color: #020621; }\n\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #0081BA; }\n\n.alert, .support-app .support-time {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px; }\n  .alert h4, .support-app .support-time h4 {\n    margin-top: 0;\n    color: inherit; }\n  .alert .alert-link, .support-app .support-time .alert-link {\n    font-weight: bold; }\n  .alert > p, .support-app .support-time > p,\n  .alert > ul, .support-app .support-time > ul {\n    margin-bottom: 0; }\n  .alert > p + p, .support-app .support-time > p + p {\n    margin-top: 5px; }\n\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px; }\n  .alert-dismissable .close,\n  .alert-dismissible .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit; }\n\n.alert-success {\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  color: #4ab767; }\n  .alert-success hr {\n    border-top-color: #c9e2b3; }\n  .alert-success .alert-link {\n    color: #3b9352; }\n\n.alert-info {\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n  color: #31708f; }\n  .alert-info hr {\n    border-top-color: #a6e1ec; }\n  .alert-info .alert-link {\n    color: #245269; }\n\n.alert-warning {\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  color: #333; }\n  .alert-warning hr {\n    border-top-color: #f7e1b5; }\n  .alert-warning .alert-link {\n    color: #1a1a1a; }\n\n.alert-danger {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #333; }\n  .alert-danger hr {\n    border-top-color: #e4b9c0; }\n  .alert-danger .alert-link {\n    color: #1a1a1a; }\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n\n.progress {\n  overflow: hidden;\n  height: 20px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1); }\n\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #0081BA;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-transition: width 0.6s ease;\n  -o-transition: width 0.6s ease;\n  transition: width 0.6s ease; }\n\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px; }\n\n.progress.active .progress-bar,\n.progress-bar.active {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n  -o-animation: progress-bar-stripes 2s linear infinite;\n  animation: progress-bar-stripes 2s linear infinite; }\n\n.progress-bar[aria-valuenow=\"1\"], .progress-bar[aria-valuenow=\"2\"] {\n  min-width: 30px; }\n\n.progress-bar[aria-valuenow=\"0\"] {\n  color: #777777;\n  min-width: 30px;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none; }\n\n.progress-bar-success {\n  background-color: #4ab767; }\n  .progress-striped .progress-bar-success {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n\n.progress-bar-info {\n  background-color: #5bc0de; }\n  .progress-striped .progress-bar-info {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n\n.progress-bar-warning {\n  background-color: #f0ad4e; }\n  .progress-striped .progress-bar-warning {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n\n.progress-bar-danger {\n  background-color: #c0392b; }\n  .progress-striped .progress-bar-danger {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1; }\n\n.media,\n.media .media {\n  margin-top: 15px; }\n\n.media:first-child {\n  margin-top: 0; }\n\n.media-object {\n  display: block; }\n\n.media-heading {\n  margin: 0 0 5px; }\n\n.media > .pull-left {\n  margin-right: 10px; }\n\n.media > .pull-right {\n  margin-left: 10px; }\n\n.media-list {\n  padding-left: 0;\n  list-style: none; }\n\n.list-group {\n  margin-bottom: 20px;\n  padding-left: 0; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd; }\n  .list-group-item:first-child {\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px; }\n  .list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px; }\n  .list-group-item > .badge {\n    float: right; }\n  .list-group-item > .badge + .badge {\n    margin-right: 5px; }\n\na.list-group-item {\n  color: #555; }\n  a.list-group-item .list-group-item-heading {\n    color: #333; }\n  a.list-group-item:hover, a.list-group-item:focus {\n    text-decoration: none;\n    color: #555;\n    background-color: #f5f5f5; }\n\n.list-group-item.disabled, .list-group-item.disabled:hover, .list-group-item.disabled:focus {\n  background-color: #d5d5d5;\n  color: #777777; }\n  .list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading {\n    color: inherit; }\n  .list-group-item.disabled .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text {\n    color: #777777; }\n\n.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {\n  z-index: 2;\n  color: #5b5b5b;\n  background-color: #428bca;\n  border-color: #428bca; }\n  .list-group-item.active .list-group-item-heading,\n  .list-group-item.active .list-group-item-heading > small,\n  .list-group-item.active .list-group-item-heading > .small, .list-group-item.active:hover .list-group-item-heading,\n  .list-group-item.active:hover .list-group-item-heading > small,\n  .list-group-item.active:hover .list-group-item-heading > .small, .list-group-item.active:focus .list-group-item-heading,\n  .list-group-item.active:focus .list-group-item-heading > small,\n  .list-group-item.active:focus .list-group-item-heading > .small {\n    color: inherit; }\n  .list-group-item.active .list-group-item-text, .list-group-item.active:hover .list-group-item-text, .list-group-item.active:focus .list-group-item-text {\n    color: #e1edf7; }\n\n.list-group-item-success {\n  color: #4ab767;\n  background-color: #dff0d8; }\n\na.list-group-item-success {\n  color: #4ab767; }\n  a.list-group-item-success .list-group-item-heading {\n    color: inherit; }\n  a.list-group-item-success:hover, a.list-group-item-success:focus {\n    color: #4ab767;\n    background-color: #d0e9c6; }\n  a.list-group-item-success.active, a.list-group-item-success.active:hover, a.list-group-item-success.active:focus {\n    color: #fff;\n    background-color: #4ab767;\n    border-color: #4ab767; }\n\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7; }\n\na.list-group-item-info {\n  color: #31708f; }\n  a.list-group-item-info .list-group-item-heading {\n    color: inherit; }\n  a.list-group-item-info:hover, a.list-group-item-info:focus {\n    color: #31708f;\n    background-color: #c4e3f3; }\n  a.list-group-item-info.active, a.list-group-item-info.active:hover, a.list-group-item-info.active:focus {\n    color: #fff;\n    background-color: #31708f;\n    border-color: #31708f; }\n\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3; }\n\na.list-group-item-warning {\n  color: #8a6d3b; }\n  a.list-group-item-warning .list-group-item-heading {\n    color: inherit; }\n  a.list-group-item-warning:hover, a.list-group-item-warning:focus {\n    color: #8a6d3b;\n    background-color: #faf2cc; }\n  a.list-group-item-warning.active, a.list-group-item-warning.active:hover, a.list-group-item-warning.active:focus {\n    color: #fff;\n    background-color: #8a6d3b;\n    border-color: #8a6d3b; }\n\n.list-group-item-danger {\n  color: #c0392b;\n  background-color: #f2dede; }\n\na.list-group-item-danger {\n  color: #c0392b; }\n  a.list-group-item-danger .list-group-item-heading {\n    color: inherit; }\n  a.list-group-item-danger:hover, a.list-group-item-danger:focus {\n    color: #c0392b;\n    background-color: #ebcccc; }\n  a.list-group-item-danger.active, a.list-group-item-danger.active:hover, a.list-group-item-danger.active:focus {\n    color: #fff;\n    background-color: #c0392b;\n    border-color: #c0392b; }\n\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px; }\n\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3; }\n\n.panel, .content-box, .select-subcompany-modal .list-group, .content-box-editable, .card, #appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); }\n\n.panel-body, .content-box-body {\n  padding: 15px; }\n  .panel-body:before, .content-box-body:before, .panel-body:after, .content-box-body:after {\n    content: \" \";\n    display: table; }\n  .panel-body:after, .content-box-body:after {\n    clear: both; }\n\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px; }\n  .panel-heading > .dropdown .dropdown-toggle {\n    color: inherit; }\n\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit; }\n  .panel-title > a {\n    color: inherit; }\n\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px; }\n\n.panel > .list-group, .content-box > .list-group, .select-subcompany-modal .list-group > .list-group, .content-box-editable > .list-group, .card > .list-group, #appLauncherContainer .scrollable-list > .list-group, #appLauncherContainer .template-grid > .list-group {\n  margin-bottom: 0; }\n  .panel > .list-group .list-group-item, .content-box > .list-group .list-group-item, .select-subcompany-modal .list-group > .list-group .list-group-item, .content-box-editable > .list-group .list-group-item, .card > .list-group .list-group-item, #appLauncherContainer .scrollable-list > .list-group .list-group-item, #appLauncherContainer .template-grid > .list-group .list-group-item {\n    border-width: 1px 0;\n    border-radius: 0; }\n  .panel > .list-group:first-child .list-group-item:first-child, .content-box > .list-group:first-child .list-group-item:first-child, .select-subcompany-modal .list-group > .list-group:first-child .list-group-item:first-child, .content-box-editable > .list-group:first-child .list-group-item:first-child, .card > .list-group:first-child .list-group-item:first-child, #appLauncherContainer .scrollable-list > .list-group:first-child .list-group-item:first-child, #appLauncherContainer .template-grid > .list-group:first-child .list-group-item:first-child {\n    border-top: 0;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px; }\n  .panel > .list-group:last-child .list-group-item:last-child, .content-box > .list-group:last-child .list-group-item:last-child, .select-subcompany-modal .list-group > .list-group:last-child .list-group-item:last-child, .content-box-editable > .list-group:last-child .list-group-item:last-child, .card > .list-group:last-child .list-group-item:last-child, #appLauncherContainer .scrollable-list > .list-group:last-child .list-group-item:last-child, #appLauncherContainer .template-grid > .list-group:last-child .list-group-item:last-child {\n    border-bottom: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px; }\n\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0; }\n\n.list-group + .panel-footer {\n  border-top-width: 0; }\n\n.panel > .table, .content-box > .table, .select-subcompany-modal .list-group > .table, .content-box-editable > .table, .card > .table, #appLauncherContainer .scrollable-list > .table, #appLauncherContainer .template-grid > .table, .panel > .table-2, .content-box > .table-2, .select-subcompany-modal .list-group > .table-2, .content-box-editable > .table-2, .card > .table-2, #appLauncherContainer .scrollable-list > .table-2, #appLauncherContainer .template-grid > .table-2,\n.panel > .table-responsive > .table, .content-box > .table-responsive > .table, .select-subcompany-modal .list-group > .table-responsive > .table, .content-box-editable > .table-responsive > .table, .card > .table-responsive > .table, #appLauncherContainer .scrollable-list > .table-responsive > .table, #appLauncherContainer .template-grid > .table-responsive > .table,\n.panel > .table-responsive > .table-2, .content-box > .table-responsive > .table-2, .select-subcompany-modal .list-group > .table-responsive > .table-2, .content-box-editable > .table-responsive > .table-2, .card > .table-responsive > .table-2, #appLauncherContainer .scrollable-list > .table-responsive > .table-2, #appLauncherContainer .template-grid > .table-responsive > .table-2,\n.panel > .panel-collapse > .table, .content-box > .panel-collapse > .table, .select-subcompany-modal .list-group > .panel-collapse > .table, .content-box-editable > .panel-collapse > .table, .card > .panel-collapse > .table, #appLauncherContainer .scrollable-list > .panel-collapse > .table, #appLauncherContainer .template-grid > .panel-collapse > .table,\n.panel > .panel-collapse > .table-2, .content-box > .panel-collapse > .table-2, .select-subcompany-modal .list-group > .panel-collapse > .table-2, .content-box-editable > .panel-collapse > .table-2, .card > .panel-collapse > .table-2, #appLauncherContainer .scrollable-list > .panel-collapse > .table-2, #appLauncherContainer .template-grid > .panel-collapse > .table-2 {\n  margin-bottom: 0; }\n\n.panel > .table:first-child, .content-box > .table:first-child, .select-subcompany-modal .list-group > .table:first-child, .content-box-editable > .table:first-child, .card > .table:first-child, #appLauncherContainer .scrollable-list > .table:first-child, #appLauncherContainer .template-grid > .table:first-child, .panel > .table-2:first-child, .content-box > .table-2:first-child, .select-subcompany-modal .list-group > .table-2:first-child, .content-box-editable > .table-2:first-child, .card > .table-2:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child, #appLauncherContainer .template-grid > .table-2:first-child,\n.panel > .table-responsive:first-child > .table:first-child, .content-box > .table-responsive:first-child > .table:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child, .card > .table-responsive:first-child > .table:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child,\n.panel > .table-responsive:first-child > .table-2:first-child, .content-box > .table-responsive:first-child > .table-2:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child, .card > .table-responsive:first-child > .table-2:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child {\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px; }\n  .panel > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child td:first-child, .card > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child td:first-child, .panel > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child td:first-child,\n  .panel > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child th:first-child, .card > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child th:first-child,\n  .panel > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child th:first-child,\n  .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n  .panel > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child td:first-child,\n  .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n  .panel > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child th:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:first-child {\n    border-top-left-radius: 3px; }\n  .panel > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child td:last-child, .card > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child td:last-child, .panel > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child td:last-child,\n  .panel > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table:first-child > thead:first-child > tr:first-child th:last-child, .card > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table:first-child > thead:first-child > tr:first-child th:last-child,\n  .panel > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-2:first-child > thead:first-child > tr:first-child th:last-child,\n  .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n  .panel > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child td:last-child,\n  .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n  .panel > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-2:first-child > tbody:first-child > tr:first-child th:last-child,\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child td:last-child,\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > thead:first-child > tr:first-child th:last-child,\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child td:last-child,\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n  .panel > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .content-box-editable > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, .card > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:first-child > .table-2:first-child > tbody:first-child > tr:first-child th:last-child {\n    border-top-right-radius: 3px; }\n\n.panel > .table:last-child, .content-box > .table:last-child, .select-subcompany-modal .list-group > .table:last-child, .content-box-editable > .table:last-child, .card > .table:last-child, #appLauncherContainer .scrollable-list > .table:last-child, #appLauncherContainer .template-grid > .table:last-child, .panel > .table-2:last-child, .content-box > .table-2:last-child, .select-subcompany-modal .list-group > .table-2:last-child, .content-box-editable > .table-2:last-child, .card > .table-2:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child, #appLauncherContainer .template-grid > .table-2:last-child,\n.panel > .table-responsive:last-child > .table:last-child, .content-box > .table-responsive:last-child > .table:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child, .card > .table-responsive:last-child > .table:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child,\n.panel > .table-responsive:last-child > .table-2:last-child, .content-box > .table-responsive:last-child > .table-2:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child, .card > .table-responsive:last-child > .table-2:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px; }\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child td:first-child, .panel > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child td:first-child,\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n  .panel > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child th:first-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n  .panel > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n  .panel > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child,\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:first-child,\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:first-child,\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:first-child,\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:first-child {\n    border-bottom-left-radius: 3px; }\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child td:last-child, .panel > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child td:last-child,\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n  .panel > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tbody:last-child > tr:last-child th:last-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n  .panel > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n  .panel > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child td:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tbody:last-child > tr:last-child th:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child td:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n  .panel > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .select-subcompany-modal .list-group > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .content-box-editable > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, .card > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .scrollable-list > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child, #appLauncherContainer .template-grid > .table-responsive:last-child > .table-2:last-child > tfoot:last-child > tr:last-child th:last-child {\n    border-bottom-right-radius: 3px; }\n\n.panel > .panel-body + .table, .content-box > .panel-body + .table, .select-subcompany-modal .list-group > .panel-body + .table, .content-box-editable > .panel-body + .table, .card > .panel-body + .table, #appLauncherContainer .scrollable-list > .panel-body + .table, #appLauncherContainer .template-grid > .panel-body + .table, .panel > .content-box-body + .table, .content-box > .content-box-body + .table, .select-subcompany-modal .list-group > .content-box-body + .table, .content-box-editable > .content-box-body + .table, .card > .content-box-body + .table, #appLauncherContainer .scrollable-list > .content-box-body + .table, #appLauncherContainer .template-grid > .content-box-body + .table, .panel > .panel-body + .table-2, .content-box > .panel-body + .table-2, .select-subcompany-modal .list-group > .panel-body + .table-2, .content-box-editable > .panel-body + .table-2, .card > .panel-body + .table-2, #appLauncherContainer .scrollable-list > .panel-body + .table-2, #appLauncherContainer .template-grid > .panel-body + .table-2, .panel > .content-box-body + .table-2, .content-box > .content-box-body + .table-2, .select-subcompany-modal .list-group > .content-box-body + .table-2, .content-box-editable > .content-box-body + .table-2, .card > .content-box-body + .table-2, #appLauncherContainer .scrollable-list > .content-box-body + .table-2, #appLauncherContainer .template-grid > .content-box-body + .table-2,\n.panel > .panel-body + .table-responsive, .content-box > .panel-body + .table-responsive, .select-subcompany-modal .list-group > .panel-body + .table-responsive, .content-box-editable > .panel-body + .table-responsive, .card > .panel-body + .table-responsive, #appLauncherContainer .scrollable-list > .panel-body + .table-responsive, #appLauncherContainer .template-grid > .panel-body + .table-responsive,\n.panel > .content-box-body + .table-responsive, .content-box > .content-box-body + .table-responsive, .select-subcompany-modal .list-group > .content-box-body + .table-responsive, .content-box-editable > .content-box-body + .table-responsive, .card > .content-box-body + .table-responsive, #appLauncherContainer .scrollable-list > .content-box-body + .table-responsive, #appLauncherContainer .template-grid > .content-box-body + .table-responsive {\n  border-top: 1px solid #F1EEEA; }\n\n.panel > .table > tbody:first-child > tr:first-child th, .content-box > .table > tbody:first-child > tr:first-child th, .select-subcompany-modal .list-group > .table > tbody:first-child > tr:first-child th, .content-box-editable > .table > tbody:first-child > tr:first-child th, .card > .table > tbody:first-child > tr:first-child th, #appLauncherContainer .scrollable-list > .table > tbody:first-child > tr:first-child th, #appLauncherContainer .template-grid > .table > tbody:first-child > tr:first-child th, .panel > .table-2 > tbody:first-child > tr:first-child th, .content-box > .table-2 > tbody:first-child > tr:first-child th, .select-subcompany-modal .list-group > .table-2 > tbody:first-child > tr:first-child th, .content-box-editable > .table-2 > tbody:first-child > tr:first-child th, .card > .table-2 > tbody:first-child > tr:first-child th, #appLauncherContainer .scrollable-list > .table-2 > tbody:first-child > tr:first-child th, #appLauncherContainer .template-grid > .table-2 > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td, .content-box > .table > tbody:first-child > tr:first-child td, .select-subcompany-modal .list-group > .table > tbody:first-child > tr:first-child td, .content-box-editable > .table > tbody:first-child > tr:first-child td, .card > .table > tbody:first-child > tr:first-child td, #appLauncherContainer .scrollable-list > .table > tbody:first-child > tr:first-child td, #appLauncherContainer .template-grid > .table > tbody:first-child > tr:first-child td,\n.panel > .table-2 > tbody:first-child > tr:first-child td, .content-box > .table-2 > tbody:first-child > tr:first-child td, .select-subcompany-modal .list-group > .table-2 > tbody:first-child > tr:first-child td, .content-box-editable > .table-2 > tbody:first-child > tr:first-child td, .card > .table-2 > tbody:first-child > tr:first-child td, #appLauncherContainer .scrollable-list > .table-2 > tbody:first-child > tr:first-child td, #appLauncherContainer .template-grid > .table-2 > tbody:first-child > tr:first-child td {\n  border-top: 0; }\n\n.panel > .table-bordered, .content-box > .table-bordered, .select-subcompany-modal .list-group > .table-bordered, .content-box-editable > .table-bordered, .card > .table-bordered, #appLauncherContainer .scrollable-list > .table-bordered, #appLauncherContainer .template-grid > .table-bordered,\n.panel > .table-responsive > .table-bordered, .content-box > .table-responsive > .table-bordered, .select-subcompany-modal .list-group > .table-responsive > .table-bordered, .content-box-editable > .table-responsive > .table-bordered, .card > .table-responsive > .table-bordered, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered, #appLauncherContainer .template-grid > .table-responsive > .table-bordered {\n  border: 0; }\n  .panel > .table-bordered > thead > tr > th:first-child, .content-box > .table-bordered > thead > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > th:first-child, .content-box-editable > .table-bordered > thead > tr > th:first-child, .card > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-bordered > thead > tr > td:first-child, .content-box > .table-bordered > thead > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > td:first-child, .content-box-editable > .table-bordered > thead > tr > td:first-child, .card > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-bordered > tbody > tr > th:first-child, .content-box > .table-bordered > tbody > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > th:first-child, .content-box-editable > .table-bordered > tbody > tr > th:first-child, .card > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-bordered > tbody > tr > td:first-child, .content-box > .table-bordered > tbody > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > td:first-child, .content-box-editable > .table-bordered > tbody > tr > td:first-child, .card > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-bordered > tfoot > tr > th:first-child, .content-box > .table-bordered > tfoot > tr > th:first-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > th:first-child, .content-box-editable > .table-bordered > tfoot > tr > th:first-child, .card > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-bordered > tfoot > tr > td:first-child, .content-box > .table-bordered > tfoot > tr > td:first-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > td:first-child, .content-box-editable > .table-bordered > tfoot > tr > td:first-child, .card > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:first-child, .content-box > .table-responsive > .table-bordered > thead > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > th:first-child, .card > .table-responsive > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:first-child, .content-box > .table-responsive > .table-bordered > thead > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > td:first-child, .card > .table-responsive > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child, .content-box > .table-responsive > .table-bordered > tbody > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > th:first-child, .card > .table-responsive > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child, .content-box > .table-responsive > .table-bordered > tbody > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > td:first-child, .card > .table-responsive > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .card > .table-responsive > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > th:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > td:first-child, .card > .table-responsive > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > td:first-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0; }\n  .panel > .table-bordered > thead > tr > th:last-child, .content-box > .table-bordered > thead > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > th:last-child, .content-box-editable > .table-bordered > thead > tr > th:last-child, .card > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-bordered > thead > tr > td:last-child, .content-box > .table-bordered > thead > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > thead > tr > td:last-child, .content-box-editable > .table-bordered > thead > tr > td:last-child, .card > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-bordered > tbody > tr > th:last-child, .content-box > .table-bordered > tbody > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > th:last-child, .content-box-editable > .table-bordered > tbody > tr > th:last-child, .card > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-bordered > tbody > tr > td:last-child, .content-box > .table-bordered > tbody > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > tbody > tr > td:last-child, .content-box-editable > .table-bordered > tbody > tr > td:last-child, .card > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-bordered > tfoot > tr > th:last-child, .content-box > .table-bordered > tfoot > tr > th:last-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > th:last-child, .content-box-editable > .table-bordered > tfoot > tr > th:last-child, .card > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-bordered > tfoot > tr > td:last-child, .content-box > .table-bordered > tfoot > tr > td:last-child, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr > td:last-child, .content-box-editable > .table-bordered > tfoot > tr > td:last-child, .card > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:last-child, .content-box > .table-responsive > .table-bordered > thead > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > th:last-child, .card > .table-responsive > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:last-child, .content-box > .table-responsive > .table-bordered > thead > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > thead > tr > td:last-child, .card > .table-responsive > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child, .content-box > .table-responsive > .table-bordered > tbody > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > th:last-child, .card > .table-responsive > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child, .content-box > .table-responsive > .table-bordered > tbody > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > tbody > tr > td:last-child, .card > .table-responsive > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .card > .table-responsive > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > th:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .content-box > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr > td:last-child, .card > .table-responsive > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr > td:last-child, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0; }\n  .panel > .table-bordered > thead > tr:first-child > td, .content-box > .table-bordered > thead > tr:first-child > td, .select-subcompany-modal .list-group > .table-bordered > thead > tr:first-child > td, .content-box-editable > .table-bordered > thead > tr:first-child > td, .card > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .template-grid > .table-bordered > thead > tr:first-child > td,\n  .panel > .table-bordered > thead > tr:first-child > th, .content-box > .table-bordered > thead > tr:first-child > th, .select-subcompany-modal .list-group > .table-bordered > thead > tr:first-child > th, .content-box-editable > .table-bordered > thead > tr:first-child > th, .card > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .template-grid > .table-bordered > thead > tr:first-child > th,\n  .panel > .table-bordered > tbody > tr:first-child > td, .content-box > .table-bordered > tbody > tr:first-child > td, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:first-child > td, .content-box-editable > .table-bordered > tbody > tr:first-child > td, .card > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:first-child > td,\n  .panel > .table-bordered > tbody > tr:first-child > th, .content-box > .table-bordered > tbody > tr:first-child > th, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:first-child > th, .content-box-editable > .table-bordered > tbody > tr:first-child > th, .card > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:first-child > th,\n  .panel > .table-responsive > .table-bordered > thead > tr:first-child > td, .content-box > .table-responsive > .table-bordered > thead > tr:first-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr:first-child > td, .content-box-editable > .table-responsive > .table-bordered > thead > tr:first-child > td, .card > .table-responsive > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr:first-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr:first-child > td,\n  .panel > .table-responsive > .table-bordered > thead > tr:first-child > th, .content-box > .table-responsive > .table-bordered > thead > tr:first-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > thead > tr:first-child > th, .content-box-editable > .table-responsive > .table-bordered > thead > tr:first-child > th, .card > .table-responsive > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > thead > tr:first-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > thead > tr:first-child > th,\n  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > td, .content-box > .table-responsive > .table-bordered > tbody > tr:first-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:first-child > td, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:first-child > td, .card > .table-responsive > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:first-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > th, .content-box > .table-responsive > .table-bordered > tbody > tr:first-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:first-child > th, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:first-child > th, .card > .table-responsive > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:first-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n    border-bottom: 0; }\n  .panel > .table-bordered > tbody > tr:last-child > td, .content-box > .table-bordered > tbody > tr:last-child > td, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:last-child > td, .content-box-editable > .table-bordered > tbody > tr:last-child > td, .card > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:last-child > td,\n  .panel > .table-bordered > tbody > tr:last-child > th, .content-box > .table-bordered > tbody > tr:last-child > th, .select-subcompany-modal .list-group > .table-bordered > tbody > tr:last-child > th, .content-box-editable > .table-bordered > tbody > tr:last-child > th, .card > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .template-grid > .table-bordered > tbody > tr:last-child > th,\n  .panel > .table-bordered > tfoot > tr:last-child > td, .content-box > .table-bordered > tfoot > tr:last-child > td, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr:last-child > td, .content-box-editable > .table-bordered > tfoot > tr:last-child > td, .card > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr:last-child > td,\n  .panel > .table-bordered > tfoot > tr:last-child > th, .content-box > .table-bordered > tfoot > tr:last-child > th, .select-subcompany-modal .list-group > .table-bordered > tfoot > tr:last-child > th, .content-box-editable > .table-bordered > tfoot > tr:last-child > th, .card > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .template-grid > .table-bordered > tfoot > tr:last-child > th,\n  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > td, .content-box > .table-responsive > .table-bordered > tbody > tr:last-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:last-child > td, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:last-child > td, .card > .table-responsive > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:last-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > th, .content-box > .table-responsive > .table-bordered > tbody > tr:last-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tbody > tr:last-child > th, .content-box-editable > .table-responsive > .table-bordered > tbody > tr:last-child > th, .card > .table-responsive > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tbody > tr:last-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .content-box > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .card > .table-responsive > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr:last-child > td, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .content-box > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .select-subcompany-modal .list-group > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .content-box-editable > .table-responsive > .table-bordered > tfoot > tr:last-child > th, .card > .table-responsive > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .scrollable-list > .table-responsive > .table-bordered > tfoot > tr:last-child > th, #appLauncherContainer .template-grid > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n    border-bottom: 0; }\n\n.panel > .table-responsive, .content-box > .table-responsive, .select-subcompany-modal .list-group > .table-responsive, .content-box-editable > .table-responsive, .card > .table-responsive, #appLauncherContainer .scrollable-list > .table-responsive, #appLauncherContainer .template-grid > .table-responsive {\n  border: 0;\n  margin-bottom: 0; }\n\n.panel-group {\n  margin-bottom: 20px; }\n  .panel-group .panel, .panel-group .content-box, .panel-group .select-subcompany-modal .list-group, .select-subcompany-modal .panel-group .list-group, .panel-group .content-box-editable, .panel-group .card, .panel-group #appLauncherContainer .scrollable-list, #appLauncherContainer .panel-group .scrollable-list, .panel-group #appLauncherContainer .template-grid, #appLauncherContainer .panel-group .template-grid {\n    margin-bottom: 0;\n    border-radius: 4px; }\n    .panel-group .panel + .panel, .panel-group .content-box + .panel, .panel-group .select-subcompany-modal .list-group + .panel, .select-subcompany-modal .panel-group .list-group + .panel, .panel-group .content-box-editable + .panel, .panel-group .card + .panel, .panel-group #appLauncherContainer .scrollable-list + .panel, #appLauncherContainer .panel-group .scrollable-list + .panel, .panel-group #appLauncherContainer .template-grid + .panel, #appLauncherContainer .panel-group .template-grid + .panel, .panel-group .panel + .content-box, .panel-group .content-box + .content-box, .panel-group .select-subcompany-modal .list-group + .content-box, .select-subcompany-modal .panel-group .list-group + .content-box, .panel-group .content-box-editable + .content-box, .panel-group .card + .content-box, .panel-group #appLauncherContainer .scrollable-list + .content-box, #appLauncherContainer .panel-group .scrollable-list + .content-box, .panel-group #appLauncherContainer .template-grid + .content-box, #appLauncherContainer .panel-group .template-grid + .content-box, .panel-group .select-subcompany-modal .panel + .list-group, .select-subcompany-modal .panel-group .panel + .list-group, .panel-group .select-subcompany-modal .content-box + .list-group, .select-subcompany-modal .panel-group .content-box + .list-group, .panel-group .select-subcompany-modal .list-group + .list-group, .select-subcompany-modal .panel-group .list-group + .list-group, .panel-group .select-subcompany-modal .content-box-editable + .list-group, .select-subcompany-modal .panel-group .content-box-editable + .list-group, .panel-group .select-subcompany-modal .card + .list-group, .select-subcompany-modal .panel-group .card + .list-group, .panel-group #appLauncherContainer .select-subcompany-modal .scrollable-list + .list-group, .select-subcompany-modal .panel-group #appLauncherContainer .scrollable-list + .list-group, #appLauncherContainer .panel-group .select-subcompany-modal .scrollable-list + .list-group, .select-subcompany-modal #appLauncherContainer .panel-group .scrollable-list + .list-group, .panel-group #appLauncherContainer .select-subcompany-modal .template-grid + .list-group, .select-subcompany-modal .panel-group #appLauncherContainer .template-grid + .list-group, #appLauncherContainer .panel-group .select-subcompany-modal .template-grid + .list-group, .select-subcompany-modal #appLauncherContainer .panel-group .template-grid + .list-group, .panel-group .panel + .content-box-editable, .panel-group .content-box + .content-box-editable, .panel-group .select-subcompany-modal .list-group + .content-box-editable, .select-subcompany-modal .panel-group .list-group + .content-box-editable, .panel-group .content-box-editable + .content-box-editable, .panel-group .card + .content-box-editable, .panel-group #appLauncherContainer .scrollable-list + .content-box-editable, #appLauncherContainer .panel-group .scrollable-list + .content-box-editable, .panel-group #appLauncherContainer .template-grid + .content-box-editable, #appLauncherContainer .panel-group .template-grid + .content-box-editable, .panel-group .panel + .card, .panel-group .content-box + .card, .panel-group .select-subcompany-modal .list-group + .card, .select-subcompany-modal .panel-group .list-group + .card, .panel-group .content-box-editable + .card, .panel-group .card + .card, .panel-group #appLauncherContainer .scrollable-list + .card, #appLauncherContainer .panel-group .scrollable-list + .card, .panel-group #appLauncherContainer .template-grid + .card, #appLauncherContainer .panel-group .template-grid + .card, .panel-group #appLauncherContainer .panel + .scrollable-list, #appLauncherContainer .panel-group .panel + .scrollable-list, .panel-group #appLauncherContainer .content-box + .scrollable-list, #appLauncherContainer .panel-group .content-box + .scrollable-list, .panel-group .select-subcompany-modal #appLauncherContainer .list-group + .scrollable-list, #appLauncherContainer .panel-group .select-subcompany-modal .list-group + .scrollable-list, .select-subcompany-modal .panel-group #appLauncherContainer .list-group + .scrollable-list, #appLauncherContainer .select-subcompany-modal .panel-group .list-group + .scrollable-list, .panel-group #appLauncherContainer .content-box-editable + .scrollable-list, #appLauncherContainer .panel-group .content-box-editable + .scrollable-list, .panel-group #appLauncherContainer .card + .scrollable-list, #appLauncherContainer .panel-group .card + .scrollable-list, .panel-group #appLauncherContainer .scrollable-list + .scrollable-list, #appLauncherContainer .panel-group .scrollable-list + .scrollable-list, .panel-group #appLauncherContainer .template-grid + .scrollable-list, #appLauncherContainer .panel-group .template-grid + .scrollable-list, .panel-group #appLauncherContainer .panel + .template-grid, #appLauncherContainer .panel-group .panel + .template-grid, .panel-group #appLauncherContainer .content-box + .template-grid, #appLauncherContainer .panel-group .content-box + .template-grid, .panel-group .select-subcompany-modal #appLauncherContainer .list-group + .template-grid, #appLauncherContainer .panel-group .select-subcompany-modal .list-group + .template-grid, .select-subcompany-modal .panel-group #appLauncherContainer .list-group + .template-grid, #appLauncherContainer .select-subcompany-modal .panel-group .list-group + .template-grid, .panel-group #appLauncherContainer .content-box-editable + .template-grid, #appLauncherContainer .panel-group .content-box-editable + .template-grid, .panel-group #appLauncherContainer .card + .template-grid, #appLauncherContainer .panel-group .card + .template-grid, .panel-group #appLauncherContainer .scrollable-list + .template-grid, #appLauncherContainer .panel-group .scrollable-list + .template-grid, .panel-group #appLauncherContainer .template-grid + .template-grid, #appLauncherContainer .panel-group .template-grid + .template-grid {\n      margin-top: 5px; }\n  .panel-group .panel-heading {\n    border-bottom: 0; }\n    .panel-group .panel-heading + .panel-collapse > .panel-body, .panel-group .panel-heading + .panel-collapse > .content-box-body {\n      border-top: 1px solid #ddd; }\n  .panel-group .panel-footer {\n    border-top: 0; }\n    .panel-group .panel-footer + .panel-collapse .panel-body, .panel-group .panel-footer + .panel-collapse .content-box-body {\n      border-bottom: 1px solid #ddd; }\n\n.panel-default, .content-box, .select-subcompany-modal .list-group, .content-box-editable, .card, #appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {\n  border-color: #ddd; }\n  .panel-default > .panel-heading, .content-box > .panel-heading, .select-subcompany-modal .list-group > .panel-heading, .content-box-editable > .panel-heading, .card > .panel-heading, #appLauncherContainer .scrollable-list > .panel-heading, #appLauncherContainer .template-grid > .panel-heading {\n    color: #020621;\n    background-color: #fff;\n    border-color: #ddd; }\n    .panel-default > .panel-heading + .panel-collapse > .panel-body, .content-box > .panel-heading + .panel-collapse > .panel-body, .select-subcompany-modal .list-group > .panel-heading + .panel-collapse > .panel-body, .content-box-editable > .panel-heading + .panel-collapse > .panel-body, .card > .panel-heading + .panel-collapse > .panel-body, #appLauncherContainer .scrollable-list > .panel-heading + .panel-collapse > .panel-body, #appLauncherContainer .template-grid > .panel-heading + .panel-collapse > .panel-body, .panel-default > .panel-heading + .panel-collapse > .content-box-body, .content-box > .panel-heading + .panel-collapse > .content-box-body, .select-subcompany-modal .list-group > .panel-heading + .panel-collapse > .content-box-body, .content-box-editable > .panel-heading + .panel-collapse > .content-box-body, .card > .panel-heading + .panel-collapse > .content-box-body, #appLauncherContainer .scrollable-list > .panel-heading + .panel-collapse > .content-box-body, #appLauncherContainer .template-grid > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #ddd; }\n    .panel-default > .panel-heading .badge, .content-box > .panel-heading .badge, .select-subcompany-modal .list-group > .panel-heading .badge, .content-box-editable > .panel-heading .badge, .card > .panel-heading .badge, #appLauncherContainer .scrollable-list > .panel-heading .badge, #appLauncherContainer .template-grid > .panel-heading .badge {\n      color: #fff;\n      background-color: #020621; }\n  .panel-default > .panel-footer + .panel-collapse > .panel-body, .content-box > .panel-footer + .panel-collapse > .panel-body, .select-subcompany-modal .list-group > .panel-footer + .panel-collapse > .panel-body, .content-box-editable > .panel-footer + .panel-collapse > .panel-body, .card > .panel-footer + .panel-collapse > .panel-body, #appLauncherContainer .scrollable-list > .panel-footer + .panel-collapse > .panel-body, #appLauncherContainer .template-grid > .panel-footer + .panel-collapse > .panel-body, .panel-default > .panel-footer + .panel-collapse > .content-box-body, .content-box > .panel-footer + .panel-collapse > .content-box-body, .select-subcompany-modal .list-group > .panel-footer + .panel-collapse > .content-box-body, .content-box-editable > .panel-footer + .panel-collapse > .content-box-body, .card > .panel-footer + .panel-collapse > .content-box-body, #appLauncherContainer .scrollable-list > .panel-footer + .panel-collapse > .content-box-body, #appLauncherContainer .template-grid > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #ddd; }\n\n.panel-primary {\n  border-color: #428bca; }\n  .panel-primary > .panel-heading {\n    color: #fff;\n    background-color: #428bca;\n    border-color: #428bca; }\n    .panel-primary > .panel-heading + .panel-collapse > .panel-body, .panel-primary > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #428bca; }\n    .panel-primary > .panel-heading .badge {\n      color: #428bca;\n      background-color: #fff; }\n  .panel-primary > .panel-footer + .panel-collapse > .panel-body, .panel-primary > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #428bca; }\n\n.panel-success {\n  border-color: #d6e9c6; }\n  .panel-success > .panel-heading {\n    color: #4ab767;\n    background-color: #dff0d8;\n    border-color: #d6e9c6; }\n    .panel-success > .panel-heading + .panel-collapse > .panel-body, .panel-success > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #d6e9c6; }\n    .panel-success > .panel-heading .badge {\n      color: #dff0d8;\n      background-color: #4ab767; }\n  .panel-success > .panel-footer + .panel-collapse > .panel-body, .panel-success > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #d6e9c6; }\n\n.panel-info {\n  border-color: #bce8f1; }\n  .panel-info > .panel-heading {\n    color: #31708f;\n    background-color: #d9edf7;\n    border-color: #bce8f1; }\n    .panel-info > .panel-heading + .panel-collapse > .panel-body, .panel-info > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #bce8f1; }\n    .panel-info > .panel-heading .badge {\n      color: #d9edf7;\n      background-color: #31708f; }\n  .panel-info > .panel-footer + .panel-collapse > .panel-body, .panel-info > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #bce8f1; }\n\n.panel-warning {\n  border-color: #faebcc; }\n  .panel-warning > .panel-heading {\n    color: #8a6d3b;\n    background-color: #fcf8e3;\n    border-color: #faebcc; }\n    .panel-warning > .panel-heading + .panel-collapse > .panel-body, .panel-warning > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #faebcc; }\n    .panel-warning > .panel-heading .badge {\n      color: #fcf8e3;\n      background-color: #8a6d3b; }\n  .panel-warning > .panel-footer + .panel-collapse > .panel-body, .panel-warning > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #faebcc; }\n\n.panel-danger {\n  border-color: #ebccd1; }\n  .panel-danger > .panel-heading {\n    color: #c0392b;\n    background-color: #f2dede;\n    border-color: #ebccd1; }\n    .panel-danger > .panel-heading + .panel-collapse > .panel-body, .panel-danger > .panel-heading + .panel-collapse > .content-box-body {\n      border-top-color: #ebccd1; }\n    .panel-danger > .panel-heading .badge {\n      color: #f2dede;\n      background-color: #c0392b; }\n  .panel-danger > .panel-footer + .panel-collapse > .panel-body, .panel-danger > .panel-footer + .panel-collapse > .content-box-body {\n    border-bottom-color: #ebccd1; }\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden; }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    border: 0; }\n  .embed-responsive.embed-responsive-16by9 {\n    padding-bottom: 56.25%; }\n  .embed-responsive.embed-responsive-4by3 {\n    padding-bottom: 75%; }\n\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05); }\n  .well blockquote {\n    border-color: #ddd;\n    border-color: rgba(0, 0, 0, 0.15); }\n\n.well-lg {\n  padding: 24px;\n  border-radius: 6px; }\n\n.well-sm {\n  padding: 9px;\n  border-radius: 2px; }\n\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.2;\n  filter: alpha(opacity=20); }\n  .close:hover, .close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n    opacity: 0.5;\n    filter: alpha(opacity=50); }\n\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none; }\n\n.modal-open {\n  overflow: hidden; }\n\n.modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  -webkit-overflow-scrolling: touch;\n  outline: 0; }\n  .modal.fade .modal-dialog {\n    -webkit-transform: translate3d(0, -25%, 0);\n    transform: translate3d(0, -25%, 0);\n    -webkit-transition: -webkit-transform 0.3s ease-out;\n    -moz-transition: -moz-transform 0.3s ease-out;\n    -o-transition: -o-transform 0.3s ease-out;\n    transition: transform 0.3s ease-out; }\n  .modal.in .modal-dialog {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px; }\n\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  background-clip: padding-box;\n  outline: 0; }\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #fff; }\n  .modal-backdrop.fade {\n    opacity: 0;\n    filter: alpha(opacity=0); }\n  .modal-backdrop.in {\n    opacity: 0.7;\n    filter: alpha(opacity=70); }\n\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n  min-height: 16.42857px; }\n\n.modal-header .close {\n  margin-top: -2px; }\n\n.modal-title {\n  margin: 0;\n  line-height: 1.42857; }\n\n.modal-body {\n  position: relative;\n  padding: 15px; }\n\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5; }\n  .modal-footer:before, .modal-footer:after {\n    content: \" \";\n    display: table; }\n  .modal-footer:after {\n    clear: both; }\n  .modal-footer .btn + .btn, .modal-footer .icon-nav label + .btn, .icon-nav .modal-footer label + .btn, .modal-footer .icon-nav .btn + label, .icon-nav .modal-footer .btn + label, .modal-footer .icon-nav label + label, .icon-nav .modal-footer label + label {\n    margin-left: 5px;\n    margin-bottom: 0; }\n  .modal-footer .btn-group .btn + .btn, .modal-footer .btn-group .icon-nav label + .btn, .icon-nav .modal-footer .btn-group label + .btn, .modal-footer .btn-group .icon-nav .btn + label, .icon-nav .modal-footer .btn-group .btn + label, .modal-footer .btn-group .icon-nav label + label, .icon-nav .modal-footer .btn-group label + label {\n    margin-left: -1px; }\n  .modal-footer .btn-block + .btn-block {\n    margin-left: 0; }\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 900px;\n    margin: 30px auto; }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }\n  .modal-sm {\n    width: 300px; } }\n\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 1200px; } }\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.4;\n  opacity: 0;\n  filter: alpha(opacity=0); }\n  .tooltip.in {\n    opacity: 0.9;\n    filter: alpha(opacity=90); }\n  .tooltip.top {\n    margin-top: -3px;\n    padding: 5px 0; }\n  .tooltip.right {\n    margin-left: 3px;\n    padding: 0 5px; }\n  .tooltip.bottom {\n    margin-top: 3px;\n    padding: 5px 0; }\n  .tooltip.left {\n    margin-left: -3px;\n    padding: 0 5px; }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #000;\n  border-radius: 4px; }\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid; }\n\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000; }\n\n.tooltip.top-left .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000; }\n\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  right: 5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000; }\n\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000; }\n\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000; }\n\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000; }\n\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000; }\n\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  white-space: normal; }\n  .popover.top {\n    margin-top: -10px; }\n  .popover.right {\n    margin-left: 10px; }\n  .popover.bottom {\n    margin-top: 10px; }\n  .popover.left {\n    margin-left: -10px; }\n\n.popover-title {\n  margin: 0;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 18px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0; }\n\n.popover-content {\n  padding: 9px 14px; }\n\n.popover > .arrow, .popover > .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid; }\n\n.popover > .arrow {\n  border-width: 11px; }\n\n.popover > .arrow:after {\n  border-width: 10px;\n  content: \"\"; }\n\n.popover.top > .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-bottom-width: 0;\n  border-top-color: #999999;\n  border-top-color: rgba(0, 0, 0, 0.25);\n  bottom: -11px; }\n  .popover.top > .arrow:after {\n    content: \" \";\n    bottom: 1px;\n    margin-left: -10px;\n    border-bottom-width: 0;\n    border-top-color: #fff; }\n\n.popover.right > .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-left-width: 0;\n  border-right-color: #999999;\n  border-right-color: rgba(0, 0, 0, 0.25); }\n  .popover.right > .arrow:after {\n    content: \" \";\n    left: 1px;\n    bottom: -10px;\n    border-left-width: 0;\n    border-right-color: #fff; }\n\n.popover.bottom > .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999999;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n  top: -11px; }\n  .popover.bottom > .arrow:after {\n    content: \" \";\n    top: 1px;\n    margin-left: -10px;\n    border-top-width: 0;\n    border-bottom-color: #fff; }\n\n.popover.left > .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999999;\n  border-left-color: rgba(0, 0, 0, 0.25); }\n  .popover.left > .arrow:after {\n    content: \" \";\n    right: 1px;\n    border-right-width: 0;\n    border-left-color: #fff;\n    bottom: -10px; }\n\n.carousel {\n  position: relative; }\n\n.carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%; }\n  .carousel-inner > .item {\n    display: none;\n    position: relative;\n    -webkit-transition: 0.6s ease-in-out left;\n    -o-transition: 0.6s ease-in-out left;\n    transition: 0.6s ease-in-out left; }\n    .carousel-inner > .item > img,\n    .carousel-inner > .item > a > img {\n      display: block;\n      width: 100% \\9;\n      max-width: 100%;\n      height: auto;\n      line-height: 1; }\n  .carousel-inner > .active,\n  .carousel-inner > .next,\n  .carousel-inner > .prev {\n    display: block; }\n  .carousel-inner > .active {\n    left: 0; }\n  .carousel-inner > .next,\n  .carousel-inner > .prev {\n    position: absolute;\n    top: 0;\n    width: 100%; }\n  .carousel-inner > .next {\n    left: 100%; }\n  .carousel-inner > .prev {\n    left: -100%; }\n  .carousel-inner > .next.left,\n  .carousel-inner > .prev.right {\n    left: 0; }\n  .carousel-inner > .active.left {\n    left: -100%; }\n  .carousel-inner > .active.right {\n    left: 100%; }\n\n.carousel-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 15%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6); }\n  .carousel-control.left {\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1); }\n  .carousel-control.right {\n    left: auto;\n    right: 0;\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1); }\n  .carousel-control:hover, .carousel-control:focus {\n    outline: 0;\n    color: #fff;\n    text-decoration: none;\n    opacity: 0.9;\n    filter: alpha(opacity=90); }\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next,\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    z-index: 5;\n    display: inline-block; }\n  .carousel-control .icon-prev,\n  .carousel-control .glyphicon-chevron-left {\n    left: 50%;\n    margin-left: -10px; }\n  .carousel-control .icon-next,\n  .carousel-control .glyphicon-chevron-right {\n    right: 50%;\n    margin-right: -10px; }\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    font-family: serif; }\n  .carousel-control .icon-prev:before {\n    content: '\\2039'; }\n  .carousel-control .icon-next:before {\n    content: '\\203a'; }\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  margin-left: -30%;\n  padding-left: 0;\n  list-style: none;\n  text-align: center; }\n  .carousel-indicators li {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    border: 1px solid #fff;\n    border-radius: 10px;\n    cursor: pointer;\n    background-color: #000 \\9;\n    background-color: transparent; }\n  .carousel-indicators .active {\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    background-color: #fff; }\n\n.carousel-caption {\n  position: absolute;\n  left: 15%;\n  right: 15%;\n  bottom: 20px;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6); }\n  .carousel-caption .btn, .carousel-caption .icon-nav label, .icon-nav .carousel-caption label {\n    text-shadow: none; }\n\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -15px;\n    font-size: 30px; }\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -15px; }\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -15px; }\n  .carousel-caption {\n    left: 20%;\n    right: 20%;\n    padding-bottom: 30px; }\n  .carousel-indicators {\n    bottom: 20px; } }\n\n.clearfix:before, .clearfix:after {\n  content: \" \";\n  display: table; }\n\n.clearfix:after {\n  clear: both; }\n\n.center-block {\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n\n.pull-right {\n  float: right !important; }\n\n.pull-left {\n  float: left !important; }\n\n.hide {\n  display: none !important; }\n\n.show {\n  display: block !important; }\n\n.invisible {\n  visibility: hidden; }\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0; }\n\n.hidden {\n  display: none !important;\n  visibility: hidden !important; }\n\n.affix {\n  position: fixed;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0); }\n\n@-ms-viewport {\n  width: device-width; }\n\n.visible-xs, .visible-sm, .visible-md, .visible-lg {\n  display: none !important; }\n\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important; }\n\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important; }\n  table.visible-xs {\n    display: table; }\n  tr.visible-xs {\n    display: table-row !important; }\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important; } }\n\n@media (max-width: 767px) {\n  .visible-xs-block {\n    display: block !important; } }\n\n@media (max-width: 767px) {\n  .visible-xs-inline {\n    display: inline !important; } }\n\n@media (max-width: 767px) {\n  .visible-xs-inline-block {\n    display: inline-block !important; } }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important; }\n  table.visible-sm {\n    display: table; }\n  tr.visible-sm {\n    display: table-row !important; }\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important; } }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block {\n    display: block !important; } }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline {\n    display: inline !important; } }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block {\n    display: inline-block !important; } }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important; }\n  table.visible-md {\n    display: table; }\n  tr.visible-md {\n    display: table-row !important; }\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important; } }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block {\n    display: block !important; } }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline {\n    display: inline !important; } }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block {\n    display: inline-block !important; } }\n\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important; }\n  table.visible-lg {\n    display: table; }\n  tr.visible-lg {\n    display: table-row !important; }\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important; } }\n\n@media (min-width: 1200px) {\n  .visible-lg-block {\n    display: block !important; } }\n\n@media (min-width: 1200px) {\n  .visible-lg-inline {\n    display: inline !important; } }\n\n@media (min-width: 1200px) {\n  .visible-lg-inline-block {\n    display: inline-block !important; } }\n\n@media (max-width: 767px) {\n  .hidden-xs {\n    display: none !important; } }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm {\n    display: none !important; } }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md {\n    display: none !important; } }\n\n@media (min-width: 1200px) {\n  .hidden-lg {\n    display: none !important; } }\n\n.visible-print {\n  display: none !important; }\n\n@media print {\n  .visible-print {\n    display: block !important; }\n  table.visible-print {\n    display: table; }\n  tr.visible-print {\n    display: table-row !important; }\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important; } }\n\n.visible-print-block {\n  display: none !important; }\n  @media print {\n    .visible-print-block {\n      display: block !important; } }\n\n.visible-print-inline {\n  display: none !important; }\n  @media print {\n    .visible-print-inline {\n      display: inline !important; } }\n\n.visible-print-inline-block {\n  display: none !important; }\n  @media print {\n    .visible-print-inline-block {\n      display: inline-block !important; } }\n\n@media print {\n  .hidden-print {\n    display: none !important; } }\n\n/* FontAwesome\n   ========================================================================== */\n/*!\n *  Font Awesome 4.1.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url(\"../fonts/fontawesome-webfont.eot?v=4.1.0\");\n  src: url(\"../fonts/fontawesome-webfont.eot?#iefix&v=4.1.0\") format(\"embedded-opentype\"), url(\"../fonts/fontawesome-webfont.woff?v=4.1.0\") format(\"woff\"), url(\"../fonts/fontawesome-webfont.ttf?v=4.1.0\") format(\"truetype\"), url(\"../fonts/fontawesome-webfont.svg?v=4.1.0#fontawesomeregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n.fa {\n  display: inline-block;\n  font-family: FontAwesome;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -15%; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-fw {\n  width: 1.28571em;\n  text-align: center; }\n\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14286em;\n  list-style-type: none; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  position: absolute;\n  left: -2.14286em;\n  width: 2.14286em;\n  top: 0.14286em;\n  text-align: center; }\n  .fa-li.fa-lg {\n    left: -1.85714em; }\n\n.fa-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eee;\n  border-radius: .1em; }\n\n.pull-right {\n  float: right; }\n\n.pull-left {\n  float: left; }\n\n.fa.pull-left {\n  margin-right: .3em; }\n\n.fa.pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: spin 2s infinite linear;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear; }\n\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg); }\n  100% {\n    -moz-transform: rotate(359deg); } }\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg); } }\n\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg); }\n  100% {\n    -o-transform: rotate(359deg); } }\n\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n.fa-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1); }\n\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle; }\n\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center; }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\"; }\n\n.fa-music:before {\n  content: \"\"; }\n\n.fa-search:before {\n  content: \"\"; }\n\n.fa-envelope-o:before {\n  content: \"\"; }\n\n.fa-heart:before {\n  content: \"\"; }\n\n.fa-star:before {\n  content: \"\"; }\n\n.fa-star-o:before {\n  content: \"\"; }\n\n.fa-user:before {\n  content: \"\"; }\n\n.fa-film:before {\n  content: \"\"; }\n\n.fa-th-large:before {\n  content: \"\"; }\n\n.fa-th:before {\n  content: \"\"; }\n\n.fa-th-list:before {\n  content: \"\"; }\n\n.fa-check:before {\n  content: \"\"; }\n\n.fa-times:before {\n  content: \"\"; }\n\n.fa-search-plus:before {\n  content: \"\"; }\n\n.fa-search-minus:before {\n  content: \"\"; }\n\n.fa-power-off:before {\n  content: \"\"; }\n\n.fa-signal:before {\n  content: \"\"; }\n\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\"; }\n\n.fa-trash-o:before {\n  content: \"\"; }\n\n.fa-home:before {\n  content: \"\"; }\n\n.fa-file-o:before {\n  content: \"\"; }\n\n.fa-clock-o:before {\n  content: \"\"; }\n\n.fa-road:before {\n  content: \"\"; }\n\n.fa-download:before {\n  content: \"\"; }\n\n.fa-arrow-circle-o-down:before {\n  content: \"\"; }\n\n.fa-arrow-circle-o-up:before {\n  content: \"\"; }\n\n.fa-inbox:before {\n  content: \"\"; }\n\n.fa-play-circle-o:before {\n  content: \"\"; }\n\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\"; }\n\n.fa-refresh:before {\n  content: \"\"; }\n\n.fa-list-alt:before {\n  content: \"\"; }\n\n.fa-lock:before {\n  content: \"\"; }\n\n.fa-flag:before {\n  content: \"\"; }\n\n.fa-headphones:before {\n  content: \"\"; }\n\n.fa-volume-off:before {\n  content: \"\"; }\n\n.fa-volume-down:before {\n  content: \"\"; }\n\n.fa-volume-up:before {\n  content: \"\"; }\n\n.fa-qrcode:before {\n  content: \"\"; }\n\n.fa-barcode:before {\n  content: \"\"; }\n\n.fa-tag:before {\n  content: \"\"; }\n\n.fa-tags:before {\n  content: \"\"; }\n\n.fa-book:before {\n  content: \"\"; }\n\n.fa-bookmark:before {\n  content: \"\"; }\n\n.fa-print:before {\n  content: \"\"; }\n\n.fa-camera:before {\n  content: \"\"; }\n\n.fa-font:before {\n  content: \"\"; }\n\n.fa-bold:before {\n  content: \"\"; }\n\n.fa-italic:before {\n  content: \"\"; }\n\n.fa-text-height:before {\n  content: \"\"; }\n\n.fa-text-width:before {\n  content: \"\"; }\n\n.fa-align-left:before {\n  content: \"\"; }\n\n.fa-align-center:before {\n  content: \"\"; }\n\n.fa-align-right:before {\n  content: \"\"; }\n\n.fa-align-justify:before {\n  content: \"\"; }\n\n.fa-list:before {\n  content: \"\"; }\n\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\"; }\n\n.fa-indent:before {\n  content: \"\"; }\n\n.fa-video-camera:before {\n  content: \"\"; }\n\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\"; }\n\n.fa-pencil:before {\n  content: \"\"; }\n\n.fa-map-marker:before {\n  content: \"\"; }\n\n.fa-adjust:before {\n  content: \"\"; }\n\n.fa-tint:before {\n  content: \"\"; }\n\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\"; }\n\n.fa-share-square-o:before {\n  content: \"\"; }\n\n.fa-check-square-o:before {\n  content: \"\"; }\n\n.fa-arrows:before {\n  content: \"\"; }\n\n.fa-step-backward:before {\n  content: \"\"; }\n\n.fa-fast-backward:before {\n  content: \"\"; }\n\n.fa-backward:before {\n  content: \"\"; }\n\n.fa-play:before {\n  content: \"\"; }\n\n.fa-pause:before {\n  content: \"\"; }\n\n.fa-stop:before {\n  content: \"\"; }\n\n.fa-forward:before {\n  content: \"\"; }\n\n.fa-fast-forward:before {\n  content: \"\"; }\n\n.fa-step-forward:before {\n  content: \"\"; }\n\n.fa-eject:before {\n  content: \"\"; }\n\n.fa-chevron-left:before {\n  content: \"\"; }\n\n.fa-chevron-right:before {\n  content: \"\"; }\n\n.fa-plus-circle:before {\n  content: \"\"; }\n\n.fa-minus-circle:before {\n  content: \"\"; }\n\n.fa-times-circle:before {\n  content: \"\"; }\n\n.fa-check-circle:before {\n  content: \"\"; }\n\n.fa-question-circle:before {\n  content: \"\"; }\n\n.fa-info-circle:before {\n  content: \"\"; }\n\n.fa-crosshairs:before {\n  content: \"\"; }\n\n.fa-times-circle-o:before {\n  content: \"\"; }\n\n.fa-check-circle-o:before {\n  content: \"\"; }\n\n.fa-ban:before {\n  content: \"\"; }\n\n.fa-arrow-left:before {\n  content: \"\"; }\n\n.fa-arrow-right:before {\n  content: \"\"; }\n\n.fa-arrow-up:before {\n  content: \"\"; }\n\n.fa-arrow-down:before {\n  content: \"\"; }\n\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\"; }\n\n.fa-expand:before {\n  content: \"\"; }\n\n.fa-compress:before {\n  content: \"\"; }\n\n.fa-plus:before {\n  content: \"\"; }\n\n.fa-minus:before {\n  content: \"\"; }\n\n.fa-asterisk:before {\n  content: \"\"; }\n\n.fa-exclamation-circle:before {\n  content: \"\"; }\n\n.fa-gift:before {\n  content: \"\"; }\n\n.fa-leaf:before {\n  content: \"\"; }\n\n.fa-fire:before {\n  content: \"\"; }\n\n.fa-eye:before {\n  content: \"\"; }\n\n.fa-eye-slash:before {\n  content: \"\"; }\n\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\"; }\n\n.fa-plane:before {\n  content: \"\"; }\n\n.fa-calendar:before {\n  content: \"\"; }\n\n.fa-random:before {\n  content: \"\"; }\n\n.fa-comment:before {\n  content: \"\"; }\n\n.fa-magnet:before {\n  content: \"\"; }\n\n.fa-chevron-up:before {\n  content: \"\"; }\n\n.fa-chevron-down:before {\n  content: \"\"; }\n\n.fa-retweet:before {\n  content: \"\"; }\n\n.fa-shopping-cart:before {\n  content: \"\"; }\n\n.fa-folder:before {\n  content: \"\"; }\n\n.fa-folder-open:before {\n  content: \"\"; }\n\n.fa-arrows-v:before {\n  content: \"\"; }\n\n.fa-arrows-h:before {\n  content: \"\"; }\n\n.fa-bar-chart-o:before {\n  content: \"\"; }\n\n.fa-twitter-square:before {\n  content: \"\"; }\n\n.fa-facebook-square:before {\n  content: \"\"; }\n\n.fa-camera-retro:before {\n  content: \"\"; }\n\n.fa-key:before {\n  content: \"\"; }\n\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\"; }\n\n.fa-comments:before {\n  content: \"\"; }\n\n.fa-thumbs-o-up:before {\n  content: \"\"; }\n\n.fa-thumbs-o-down:before {\n  content: \"\"; }\n\n.fa-star-half:before {\n  content: \"\"; }\n\n.fa-heart-o:before {\n  content: \"\"; }\n\n.fa-sign-out:before {\n  content: \"\"; }\n\n.fa-linkedin-square:before {\n  content: \"\"; }\n\n.fa-thumb-tack:before {\n  content: \"\"; }\n\n.fa-external-link:before {\n  content: \"\"; }\n\n.fa-sign-in:before {\n  content: \"\"; }\n\n.fa-trophy:before {\n  content: \"\"; }\n\n.fa-github-square:before {\n  content: \"\"; }\n\n.fa-upload:before {\n  content: \"\"; }\n\n.fa-lemon-o:before {\n  content: \"\"; }\n\n.fa-phone:before {\n  content: \"\"; }\n\n.fa-square-o:before {\n  content: \"\"; }\n\n.fa-bookmark-o:before {\n  content: \"\"; }\n\n.fa-phone-square:before {\n  content: \"\"; }\n\n.fa-twitter:before {\n  content: \"\"; }\n\n.fa-facebook:before {\n  content: \"\"; }\n\n.fa-github:before {\n  content: \"\"; }\n\n.fa-unlock:before {\n  content: \"\"; }\n\n.fa-credit-card:before {\n  content: \"\"; }\n\n.fa-rss:before {\n  content: \"\"; }\n\n.fa-hdd-o:before {\n  content: \"\"; }\n\n.fa-bullhorn:before {\n  content: \"\"; }\n\n.fa-bell:before {\n  content: \"\"; }\n\n.fa-certificate:before {\n  content: \"\"; }\n\n.fa-hand-o-right:before {\n  content: \"\"; }\n\n.fa-hand-o-left:before {\n  content: \"\"; }\n\n.fa-hand-o-up:before {\n  content: \"\"; }\n\n.fa-hand-o-down:before {\n  content: \"\"; }\n\n.fa-arrow-circle-left:before {\n  content: \"\"; }\n\n.fa-arrow-circle-right:before {\n  content: \"\"; }\n\n.fa-arrow-circle-up:before {\n  content: \"\"; }\n\n.fa-arrow-circle-down:before {\n  content: \"\"; }\n\n.fa-globe:before {\n  content: \"\"; }\n\n.fa-wrench:before {\n  content: \"\"; }\n\n.fa-tasks:before {\n  content: \"\"; }\n\n.fa-filter:before {\n  content: \"\"; }\n\n.fa-briefcase:before {\n  content: \"\"; }\n\n.fa-arrows-alt:before {\n  content: \"\"; }\n\n.fa-group:before,\n.fa-users:before {\n  content: \"\"; }\n\n.fa-chain:before,\n.fa-link:before {\n  content: \"\"; }\n\n.fa-cloud:before {\n  content: \"\"; }\n\n.fa-flask:before {\n  content: \"\"; }\n\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\"; }\n\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\"; }\n\n.fa-paperclip:before {\n  content: \"\"; }\n\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\"; }\n\n.fa-square:before {\n  content: \"\"; }\n\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\"; }\n\n.fa-list-ul:before {\n  content: \"\"; }\n\n.fa-list-ol:before {\n  content: \"\"; }\n\n.fa-strikethrough:before {\n  content: \"\"; }\n\n.fa-underline:before {\n  content: \"\"; }\n\n.fa-table:before {\n  content: \"\"; }\n\n.fa-magic:before {\n  content: \"\"; }\n\n.fa-truck:before {\n  content: \"\"; }\n\n.fa-pinterest:before {\n  content: \"\"; }\n\n.fa-pinterest-square:before {\n  content: \"\"; }\n\n.fa-google-plus-square:before {\n  content: \"\"; }\n\n.fa-google-plus:before {\n  content: \"\"; }\n\n.fa-money:before {\n  content: \"\"; }\n\n.fa-caret-down:before {\n  content: \"\"; }\n\n.fa-caret-up:before {\n  content: \"\"; }\n\n.fa-caret-left:before {\n  content: \"\"; }\n\n.fa-caret-right:before {\n  content: \"\"; }\n\n.fa-columns:before {\n  content: \"\"; }\n\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\"; }\n\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\"; }\n\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\"; }\n\n.fa-envelope:before {\n  content: \"\"; }\n\n.fa-linkedin:before {\n  content: \"\"; }\n\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\"; }\n\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\"; }\n\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\"; }\n\n.fa-comment-o:before {\n  content: \"\"; }\n\n.fa-comments-o:before {\n  content: \"\"; }\n\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\"; }\n\n.fa-sitemap:before {\n  content: \"\"; }\n\n.fa-umbrella:before {\n  content: \"\"; }\n\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\"; }\n\n.fa-lightbulb-o:before {\n  content: \"\"; }\n\n.fa-exchange:before {\n  content: \"\"; }\n\n.fa-cloud-download:before {\n  content: \"\"; }\n\n.fa-cloud-upload:before {\n  content: \"\"; }\n\n.fa-user-md:before {\n  content: \"\"; }\n\n.fa-stethoscope:before {\n  content: \"\"; }\n\n.fa-suitcase:before {\n  content: \"\"; }\n\n.fa-bell-o:before {\n  content: \"\"; }\n\n.fa-coffee:before {\n  content: \"\"; }\n\n.fa-cutlery:before {\n  content: \"\"; }\n\n.fa-file-text-o:before {\n  content: \"\"; }\n\n.fa-building-o:before {\n  content: \"\"; }\n\n.fa-hospital-o:before {\n  content: \"\"; }\n\n.fa-ambulance:before {\n  content: \"\"; }\n\n.fa-medkit:before {\n  content: \"\"; }\n\n.fa-fighter-jet:before {\n  content: \"\"; }\n\n.fa-beer:before {\n  content: \"\"; }\n\n.fa-h-square:before {\n  content: \"\"; }\n\n.fa-plus-square:before {\n  content: \"\"; }\n\n.fa-angle-double-left:before {\n  content: \"\"; }\n\n.fa-angle-double-right:before {\n  content: \"\"; }\n\n.fa-angle-double-up:before {\n  content: \"\"; }\n\n.fa-angle-double-down:before {\n  content: \"\"; }\n\n.fa-angle-left:before {\n  content: \"\"; }\n\n.fa-angle-right:before {\n  content: \"\"; }\n\n.fa-angle-up:before {\n  content: \"\"; }\n\n.fa-angle-down:before {\n  content: \"\"; }\n\n.fa-desktop:before {\n  content: \"\"; }\n\n.fa-laptop:before {\n  content: \"\"; }\n\n.fa-tablet:before {\n  content: \"\"; }\n\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\"; }\n\n.fa-circle-o:before {\n  content: \"\"; }\n\n.fa-quote-left:before {\n  content: \"\"; }\n\n.fa-quote-right:before {\n  content: \"\"; }\n\n.fa-spinner:before {\n  content: \"\"; }\n\n.fa-circle:before {\n  content: \"\"; }\n\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\"; }\n\n.fa-github-alt:before {\n  content: \"\"; }\n\n.fa-folder-o:before {\n  content: \"\"; }\n\n.fa-folder-open-o:before {\n  content: \"\"; }\n\n.fa-smile-o:before {\n  content: \"\"; }\n\n.fa-frown-o:before {\n  content: \"\"; }\n\n.fa-meh-o:before {\n  content: \"\"; }\n\n.fa-gamepad:before {\n  content: \"\"; }\n\n.fa-keyboard-o:before {\n  content: \"\"; }\n\n.fa-flag-o:before {\n  content: \"\"; }\n\n.fa-flag-checkered:before {\n  content: \"\"; }\n\n.fa-terminal:before {\n  content: \"\"; }\n\n.fa-code:before {\n  content: \"\"; }\n\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\"; }\n\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\"; }\n\n.fa-location-arrow:before {\n  content: \"\"; }\n\n.fa-crop:before {\n  content: \"\"; }\n\n.fa-code-fork:before {\n  content: \"\"; }\n\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\"; }\n\n.fa-question:before {\n  content: \"\"; }\n\n.fa-info:before {\n  content: \"\"; }\n\n.fa-exclamation:before {\n  content: \"\"; }\n\n.fa-superscript:before {\n  content: \"\"; }\n\n.fa-subscript:before {\n  content: \"\"; }\n\n.fa-eraser:before {\n  content: \"\"; }\n\n.fa-puzzle-piece:before {\n  content: \"\"; }\n\n.fa-microphone:before {\n  content: \"\"; }\n\n.fa-microphone-slash:before {\n  content: \"\"; }\n\n.fa-shield:before {\n  content: \"\"; }\n\n.fa-calendar-o:before {\n  content: \"\"; }\n\n.fa-fire-extinguisher:before {\n  content: \"\"; }\n\n.fa-rocket:before {\n  content: \"\"; }\n\n.fa-maxcdn:before {\n  content: \"\"; }\n\n.fa-chevron-circle-left:before {\n  content: \"\"; }\n\n.fa-chevron-circle-right:before {\n  content: \"\"; }\n\n.fa-chevron-circle-up:before {\n  content: \"\"; }\n\n.fa-chevron-circle-down:before {\n  content: \"\"; }\n\n.fa-html5:before {\n  content: \"\"; }\n\n.fa-css3:before {\n  content: \"\"; }\n\n.fa-anchor:before {\n  content: \"\"; }\n\n.fa-unlock-alt:before {\n  content: \"\"; }\n\n.fa-bullseye:before {\n  content: \"\"; }\n\n.fa-ellipsis-h:before {\n  content: \"\"; }\n\n.fa-ellipsis-v:before {\n  content: \"\"; }\n\n.fa-rss-square:before {\n  content: \"\"; }\n\n.fa-play-circle:before {\n  content: \"\"; }\n\n.fa-ticket:before {\n  content: \"\"; }\n\n.fa-minus-square:before {\n  content: \"\"; }\n\n.fa-minus-square-o:before {\n  content: \"\"; }\n\n.fa-level-up:before {\n  content: \"\"; }\n\n.fa-level-down:before {\n  content: \"\"; }\n\n.fa-check-square:before {\n  content: \"\"; }\n\n.fa-pencil-square:before {\n  content: \"\"; }\n\n.fa-external-link-square:before {\n  content: \"\"; }\n\n.fa-share-square:before {\n  content: \"\"; }\n\n.fa-compass:before {\n  content: \"\"; }\n\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\"; }\n\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\"; }\n\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\"; }\n\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\"; }\n\n.fa-gbp:before {\n  content: \"\"; }\n\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\"; }\n\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\"; }\n\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\"; }\n\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\"; }\n\n.fa-won:before,\n.fa-krw:before {\n  content: \"\"; }\n\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\"; }\n\n.fa-file:before {\n  content: \"\"; }\n\n.fa-file-text:before {\n  content: \"\"; }\n\n.fa-sort-alpha-asc:before {\n  content: \"\"; }\n\n.fa-sort-alpha-desc:before {\n  content: \"\"; }\n\n.fa-sort-amount-asc:before {\n  content: \"\"; }\n\n.fa-sort-amount-desc:before {\n  content: \"\"; }\n\n.fa-sort-numeric-asc:before {\n  content: \"\"; }\n\n.fa-sort-numeric-desc:before {\n  content: \"\"; }\n\n.fa-thumbs-up:before {\n  content: \"\"; }\n\n.fa-thumbs-down:before {\n  content: \"\"; }\n\n.fa-youtube-square:before {\n  content: \"\"; }\n\n.fa-youtube:before {\n  content: \"\"; }\n\n.fa-xing:before {\n  content: \"\"; }\n\n.fa-xing-square:before {\n  content: \"\"; }\n\n.fa-youtube-play:before {\n  content: \"\"; }\n\n.fa-dropbox:before {\n  content: \"\"; }\n\n.fa-stack-overflow:before {\n  content: \"\"; }\n\n.fa-instagram:before {\n  content: \"\"; }\n\n.fa-flickr:before {\n  content: \"\"; }\n\n.fa-adn:before {\n  content: \"\"; }\n\n.fa-bitbucket:before {\n  content: \"\"; }\n\n.fa-bitbucket-square:before {\n  content: \"\"; }\n\n.fa-tumblr:before {\n  content: \"\"; }\n\n.fa-tumblr-square:before {\n  content: \"\"; }\n\n.fa-long-arrow-down:before {\n  content: \"\"; }\n\n.fa-long-arrow-up:before {\n  content: \"\"; }\n\n.fa-long-arrow-left:before {\n  content: \"\"; }\n\n.fa-long-arrow-right:before {\n  content: \"\"; }\n\n.fa-apple:before {\n  content: \"\"; }\n\n.fa-windows:before {\n  content: \"\"; }\n\n.fa-android:before {\n  content: \"\"; }\n\n.fa-linux:before {\n  content: \"\"; }\n\n.fa-dribbble:before {\n  content: \"\"; }\n\n.fa-skype:before {\n  content: \"\"; }\n\n.fa-foursquare:before {\n  content: \"\"; }\n\n.fa-trello:before {\n  content: \"\"; }\n\n.fa-female:before {\n  content: \"\"; }\n\n.fa-male:before {\n  content: \"\"; }\n\n.fa-gittip:before {\n  content: \"\"; }\n\n.fa-sun-o:before {\n  content: \"\"; }\n\n.fa-moon-o:before {\n  content: \"\"; }\n\n.fa-archive:before {\n  content: \"\"; }\n\n.fa-bug:before {\n  content: \"\"; }\n\n.fa-vk:before {\n  content: \"\"; }\n\n.fa-weibo:before {\n  content: \"\"; }\n\n.fa-renren:before {\n  content: \"\"; }\n\n.fa-pagelines:before {\n  content: \"\"; }\n\n.fa-stack-exchange:before {\n  content: \"\"; }\n\n.fa-arrow-circle-o-right:before {\n  content: \"\"; }\n\n.fa-arrow-circle-o-left:before {\n  content: \"\"; }\n\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\"; }\n\n.fa-dot-circle-o:before {\n  content: \"\"; }\n\n.fa-wheelchair:before {\n  content: \"\"; }\n\n.fa-vimeo-square:before {\n  content: \"\"; }\n\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\"; }\n\n.fa-plus-square-o:before {\n  content: \"\"; }\n\n.fa-space-shuttle:before {\n  content: \"\"; }\n\n.fa-slack:before {\n  content: \"\"; }\n\n.fa-envelope-square:before {\n  content: \"\"; }\n\n.fa-wordpress:before {\n  content: \"\"; }\n\n.fa-openid:before {\n  content: \"\"; }\n\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\"; }\n\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\"; }\n\n.fa-yahoo:before {\n  content: \"\"; }\n\n.fa-google:before {\n  content: \"\"; }\n\n.fa-reddit:before {\n  content: \"\"; }\n\n.fa-reddit-square:before {\n  content: \"\"; }\n\n.fa-stumbleupon-circle:before {\n  content: \"\"; }\n\n.fa-stumbleupon:before {\n  content: \"\"; }\n\n.fa-delicious:before {\n  content: \"\"; }\n\n.fa-digg:before {\n  content: \"\"; }\n\n.fa-pied-piper-square:before,\n.fa-pied-piper:before {\n  content: \"\"; }\n\n.fa-pied-piper-alt:before {\n  content: \"\"; }\n\n.fa-drupal:before {\n  content: \"\"; }\n\n.fa-joomla:before {\n  content: \"\"; }\n\n.fa-language:before {\n  content: \"\"; }\n\n.fa-fax:before {\n  content: \"\"; }\n\n.fa-building:before {\n  content: \"\"; }\n\n.fa-child:before {\n  content: \"\"; }\n\n.fa-paw:before {\n  content: \"\"; }\n\n.fa-spoon:before {\n  content: \"\"; }\n\n.fa-cube:before {\n  content: \"\"; }\n\n.fa-cubes:before {\n  content: \"\"; }\n\n.fa-behance:before {\n  content: \"\"; }\n\n.fa-behance-square:before {\n  content: \"\"; }\n\n.fa-steam:before {\n  content: \"\"; }\n\n.fa-steam-square:before {\n  content: \"\"; }\n\n.fa-recycle:before {\n  content: \"\"; }\n\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\"; }\n\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\"; }\n\n.fa-tree:before {\n  content: \"\"; }\n\n.fa-spotify:before {\n  content: \"\"; }\n\n.fa-deviantart:before {\n  content: \"\"; }\n\n.fa-soundcloud:before {\n  content: \"\"; }\n\n.fa-database:before {\n  content: \"\"; }\n\n.fa-file-pdf-o:before {\n  content: \"\"; }\n\n.fa-file-word-o:before {\n  content: \"\"; }\n\n.fa-file-excel-o:before {\n  content: \"\"; }\n\n.fa-file-powerpoint-o:before {\n  content: \"\"; }\n\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\"; }\n\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\"; }\n\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\"; }\n\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\"; }\n\n.fa-file-code-o:before {\n  content: \"\"; }\n\n.fa-vine:before {\n  content: \"\"; }\n\n.fa-codepen:before {\n  content: \"\"; }\n\n.fa-jsfiddle:before {\n  content: \"\"; }\n\n.fa-life-bouy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\"; }\n\n.fa-circle-o-notch:before {\n  content: \"\"; }\n\n.fa-ra:before,\n.fa-rebel:before {\n  content: \"\"; }\n\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\"; }\n\n.fa-git-square:before {\n  content: \"\"; }\n\n.fa-git:before {\n  content: \"\"; }\n\n.fa-hacker-news:before {\n  content: \"\"; }\n\n.fa-tencent-weibo:before {\n  content: \"\"; }\n\n.fa-qq:before {\n  content: \"\"; }\n\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\"; }\n\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\"; }\n\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\"; }\n\n.fa-history:before {\n  content: \"\"; }\n\n.fa-circle-thin:before {\n  content: \"\"; }\n\n.fa-header:before {\n  content: \"\"; }\n\n.fa-paragraph:before {\n  content: \"\"; }\n\n.fa-sliders:before {\n  content: \"\"; }\n\n.fa-share-alt:before {\n  content: \"\"; }\n\n.fa-share-alt-square:before {\n  content: \"\"; }\n\n.fa-bomb:before {\n  content: \"\"; }\n\n/* Bootstrap Overwrites\n   ========================================================================== */\n.alert-warning {\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  color: #333; }\n  .alert-warning hr {\n    border-top-color: #f7e1b5; }\n  .alert-warning .alert-link {\n    color: #66512c; }\n\n.alert-danger {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #333; }\n  .alert-danger hr {\n    border-top-color: #e4b9c0; }\n  .alert-danger .alert-link {\n    color: #843534; }\n\n.alert-link {\n  background-color: #F8FFD6;\n  border-color: #E9F19C;\n  color: #020621;\n  display: block; }\n  .alert-link hr {\n    border-top-color: #e4ee86; }\n  .alert-link .alert-link {\n    color: #020621; }\n  .alert-link h2 {\n    margin-top: 0; }\n  .alert-link:hover, .alert-link:active {\n    color: #020621; }\n\n.btn, .icon-nav label {\n  outline: 0;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  -webkit-font-smoothing: subpixel-antialiased; }\n\n.btn-lg, .btn-group-lg > .btn, .icon-nav .btn-group-lg > label {\n  font-size: 16px;\n  font-weight: 400; }\n\n.btn-hg,\n.btn-group-hg > .btn, .icon-nav\n.btn-group-hg > label {\n  padding: 14px 24px;\n  font-size: 18px;\n  line-height: 1.33; }\n\n.btn-default, .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {\n  color: #333;\n  background-color: #e8e8e8;\n  border-color: #CCC; }\n  .btn-default:hover, .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .icon-nav label:hover, .icon-nav .timeline .dropdown-menu li label:hover, .btn-default:focus, .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li .icon-nav label:focus, .icon-nav .timeline .dropdown-menu li label:focus, .btn-default:active, .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .icon-nav label:active, .icon-nav .timeline .dropdown-menu li label:active, .btn-default.active, .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .icon-nav label.active, .icon-nav .timeline .dropdown-menu li label.active,\n  .open > .btn-default.dropdown-toggle, .timeline .dropdown-menu li\n  .open > .dropdown-toggle.btn, .timeline .dropdown-menu li .icon-nav\n  .open > label.dropdown-toggle, .icon-nav .timeline .dropdown-menu li\n  .open > label.dropdown-toggle {\n    color: #333;\n    background-color: #dbdbdb;\n    border-color: #adadad;\n    outline: 0; }\n  .btn-default.disabled, .timeline .dropdown-menu li .disabled.btn, .timeline .dropdown-menu li .icon-nav label.disabled, .icon-nav .timeline .dropdown-menu li label.disabled, .btn-default.disabled:hover, .timeline .dropdown-menu li .disabled.btn:hover, .timeline .dropdown-menu li .icon-nav label.disabled:hover, .icon-nav .timeline .dropdown-menu li label.disabled:hover, .btn-default.disabled:focus, .timeline .dropdown-menu li .disabled.btn:focus, .timeline .dropdown-menu li .icon-nav label.disabled:focus, .icon-nav .timeline .dropdown-menu li label.disabled:focus, .btn-default.disabled:active, .timeline .dropdown-menu li .disabled.btn:active, .timeline .dropdown-menu li .icon-nav label.disabled:active, .icon-nav .timeline .dropdown-menu li label.disabled:active, .btn-default.disabled.active, .timeline .dropdown-menu li .disabled.active.btn, .timeline .dropdown-menu li .icon-nav label.disabled.active, .icon-nav .timeline .dropdown-menu li label.disabled.active, .btn-default[disabled], .timeline .dropdown-menu li [disabled].btn, .timeline .dropdown-menu li .icon-nav label[disabled], .icon-nav .timeline .dropdown-menu li label[disabled], .btn-default[disabled]:hover, .timeline .dropdown-menu li [disabled].btn:hover, .timeline .dropdown-menu li .icon-nav label[disabled]:hover, .icon-nav .timeline .dropdown-menu li label[disabled]:hover, .btn-default[disabled]:focus, .timeline .dropdown-menu li [disabled].btn:focus, .timeline .dropdown-menu li .icon-nav label[disabled]:focus, .icon-nav .timeline .dropdown-menu li label[disabled]:focus, .btn-default[disabled]:active, .timeline .dropdown-menu li [disabled].btn:active, .timeline .dropdown-menu li .icon-nav label[disabled]:active, .icon-nav .timeline .dropdown-menu li label[disabled]:active, .btn-default[disabled].active, .timeline .dropdown-menu li [disabled].active.btn, .timeline .dropdown-menu li .icon-nav label[disabled].active, .icon-nav .timeline .dropdown-menu li label[disabled].active,\n  fieldset[disabled] .btn-default,\n  fieldset[disabled] .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li\n  fieldset[disabled] .btn,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label,\n  fieldset[disabled] .btn-default:hover,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:hover,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:hover,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:hover,\n  fieldset[disabled] .btn-default:focus,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:focus,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:focus,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:focus,\n  fieldset[disabled] .btn-default:active,\n  fieldset[disabled] .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li\n  fieldset[disabled] .btn:active,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label:active,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label:active,\n  fieldset[disabled] .btn-default.active,\n  fieldset[disabled] .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li\n  fieldset[disabled] .active.btn,\n  fieldset[disabled] .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav\n  fieldset[disabled] label.active,\n  fieldset[disabled] .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li\n  fieldset[disabled] label.active {\n    background-color: #e8e8e8;\n    border-color: #d5d5d5; }\n  .btn-default .fa:before, .timeline .dropdown-menu li .btn .fa:before, .timeline .dropdown-menu li .icon-nav label .fa:before, .icon-nav .timeline .dropdown-menu li label .fa:before {\n    color: #4d4d4d; }\n\n.btn-inverse {\n  color: #fff;\n  background-color: #262626;\n  border-color: #555; }\n  .btn-inverse:hover, .btn-inverse:focus, .btn-inverse:active, .btn-inverse.active,\n  .open > .btn-inverse.dropdown-toggle {\n    color: #fff;\n    background-color: #1a1a1a;\n    border-color: #363636;\n    outline: 0; }\n  .btn-inverse.disabled, .btn-inverse.disabled:hover, .btn-inverse.disabled:focus, .btn-inverse.disabled:active, .btn-inverse.disabled.active, .btn-inverse[disabled], .btn-inverse[disabled]:hover, .btn-inverse[disabled]:focus, .btn-inverse[disabled]:active, .btn-inverse[disabled].active,\n  fieldset[disabled] .btn-inverse,\n  fieldset[disabled] .btn-inverse:hover,\n  fieldset[disabled] .btn-inverse:focus,\n  fieldset[disabled] .btn-inverse:active,\n  fieldset[disabled] .btn-inverse.active {\n    background-color: #262626;\n    border-color: #333333; }\n\n.btn-primary {\n  color: #fff;\n  background-color: #4ab767;\n  border-color: #4ab767; }\n  .btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active,\n  .open > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #42a65c;\n    border-color: #388c4e;\n    outline: 0; }\n  .btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled]:active, .btn-primary[disabled].active,\n  fieldset[disabled] .btn-primary,\n  fieldset[disabled] .btn-primary:hover,\n  fieldset[disabled] .btn-primary:focus,\n  fieldset[disabled] .btn-primary:active,\n  fieldset[disabled] .btn-primary.active {\n    background-color: #4ab767;\n    border-color: #5cbe76; }\n\n.btn-google-auth {\n  color: #555;\n  background-color: #fff;\n  border-color: #e8e8e8; }\n  .btn-google-auth:hover, .btn-google-auth:focus, .btn-google-auth:active, .btn-google-auth.active,\n  .open > .btn-google-auth.dropdown-toggle {\n    color: #555;\n    background-color: #f2f2f2;\n    border-color: #c9c9c9;\n    outline: 0; }\n  .btn-google-auth.disabled, .btn-google-auth.disabled:hover, .btn-google-auth.disabled:focus, .btn-google-auth.disabled:active, .btn-google-auth.disabled.active, .btn-google-auth[disabled], .btn-google-auth[disabled]:hover, .btn-google-auth[disabled]:focus, .btn-google-auth[disabled]:active, .btn-google-auth[disabled].active,\n  fieldset[disabled] .btn-google-auth,\n  fieldset[disabled] .btn-google-auth:hover,\n  fieldset[disabled] .btn-google-auth:focus,\n  fieldset[disabled] .btn-google-auth:active,\n  fieldset[disabled] .btn-google-auth.active {\n    background-color: #fff;\n    border-color: #e25d48; }\n\n.btn-white {\n  color: #3b9352;\n  background-color: #fff;\n  border-color: #fff; }\n  .btn-white:hover, .btn-white:focus, .btn-white:active, .btn-white.active,\n  .open > .btn-white.dropdown-toggle {\n    color: #3b9352;\n    background-color: #f2f2f2;\n    border-color: #e0e0e0;\n    outline: 0; }\n  .btn-white.disabled, .btn-white.disabled:hover, .btn-white.disabled:focus, .btn-white.disabled:active, .btn-white.disabled.active, .btn-white[disabled], .btn-white[disabled]:hover, .btn-white[disabled]:focus, .btn-white[disabled]:active, .btn-white[disabled].active,\n  fieldset[disabled] .btn-white,\n  fieldset[disabled] .btn-white:hover,\n  fieldset[disabled] .btn-white:focus,\n  fieldset[disabled] .btn-white:active,\n  fieldset[disabled] .btn-white.active {\n    background-color: #fff;\n    border-color: white; }\n\n.btn-toggle {\n  display: inline; }\n\npre {\n  overflow: auto; }\n\n.dropdown .dropdown-menu {\n  top: 120%;\n  left: auto;\n  right: 0;\n  padding: 0;\n  overflow: hidden; }\n  .dropdown .dropdown-menu > li > a {\n    padding: 8px; }\n  .dropdown .dropdown-menu .divider {\n    height: 1px;\n    margin: 0 0;\n    overflow: hidden;\n    background-color: #e5e5e5; }\n  .dropdown .dropdown-menu ul {\n    list-style: none;\n    margin: 0;\n    padding: 0; }\n\n.dropdown > .dropdown-menu::before,\n.dropdown > .dropdown-menu::after {\n  position: absolute;\n  display: inline-block;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  content: ''; }\n\n.dropdown > .dropdown-menu::before {\n  top: -7px;\n  right: 9px; }\n\n.dropdown > .dropdown-menu::before,\n.dropdown > .dropdown-menu::after {\n  top: -7px;\n  right: 9px; }\n\n.dropdown > .dropdown-menu::after {\n  top: -6px;\n  right: 10px;\n  border-left-width: 6px;\n  border-right-width: 6px;\n  border-bottom-width: 6px;\n  border-bottom-color: #fff; }\n\n.dropdown .dropdown-menu > ul > li > a,\n.dropdown .action-sheet > ul > li > a {\n  color: #4d4d4d;\n  display: block;\n  padding: 10px;\n  margin: 0; }\n\n.dropdown .dropdown-menu > ul > li > a:hover,\n.dropdown .dropdown-menu > ul > li > a:focus {\n  background-color: rgba(150, 150, 150, 0.1);\n  color: #0081BA; }\n\n.dropdown .dropdown-menu > ul > li > a.old-app,\n.dropdown .dropdown-menu > ul > li > a.old-app {\n  background-color: #EEE;\n  margin-right: 0; }\n\n.dropdown .dropdown-menu > ul > li > a.old-app:focus,\n.dropdown .dropdown-menu > ul > li > a.old-app:hover {\n  color: #000;\n  background-color: #DDD; }\n\n.dropdown .dropdown-menu > ul > .active > a,\n.dropdown .dropdown-menu > ul > .active > a:hover,\n.dropdown .dropdown-menu > ul > .active > a:focus {\n  background-color: #357ebd; }\n\n.form-group {\n  margin-bottom: 20px; }\n\n.custom-addon .input-group-addon, .checkbox-addon .input-group-addon, .storage-group .input-group-addon {\n  background: none;\n  padding: 0 10px 0 10px;\n  border: 0;\n  vertical-align: top; }\n\n.custom-addon .form-control, .checkbox-addon .form-control, .storage-group .form-control {\n  border-bottom-right-radius: 4px !important;\n  border-top-right-radius: 4px !important; }\n\n.input-group-addon {\n  border-radius: 4px; }\n\n.form-inline .form-control-static, .navbar-form .form-control-static {\n  display: inline-block; }\n\n.form-control-static {\n  vertical-align: middle;\n  border-radius: 4px;\n  padding: 7px 0; }\n\n.control-label {\n  line-height: 22px;\n  font-weight: 600;\n  color: #444; }\n\n.control-label-secondary {\n  font-weight: 400; }\n\n.input-group > .form-control,\n.input-group > .input-group-addon,\n.input-group > .input-group-btn > .btn, .icon-nav\n.input-group > .input-group-btn > label {\n  height: 34px; }\n\n.label-primary {\n  background-color: #0081BA; }\n  .label-primary[href]:hover, .label-primary[href]:focus {\n    background-color: #3071a9; }\n\n.label-success {\n  background-color: #4ab767; }\n  .label-success[href]:hover, .label-success[href]:focus {\n    background-color: #449d44; }\n\n.label-default {\n  background: #f4f4f4;\n  border: 1px solid #e6e6e6;\n  color: #555; }\n\n.label {\n  font-size: 12px; }\n\n.navbar {\n  position: relative;\n  z-index: 1000;\n  padding: 0;\n  border-radius: 0;\n  border: none;\n  min-height: 0;\n  margin-bottom: 0; }\n  .navbar .navbar-header {\n    display: inline-block; }\n  .navbar .navbar-nav {\n    margin: 0; }\n    .navbar .navbar-nav.navbar-left {\n      float: left; }\n    .navbar .navbar-nav.navbar-right {\n      float: right;\n      display: inline-block; }\n    .navbar .navbar-nav .open .dropdown-menu > li > a:hover, .navbar .navbar-nav .open .dropdown-menu > li > a:focus {\n      color: #0081BA; }\n  .navbar.navbar-default {\n    box-shadow: 0px 2px 10px 0 rgba(22, 22, 22, 0.05); }\n    .navbar.navbar-default .navbar-nav .dropdown .dropdown-menu {\n      border-radius: 4px; }\n    .navbar.navbar-default .navbar-nav > li {\n      display: inline-block;\n      vertical-align: top; }\n    .navbar.navbar-default .navbar-nav > li > a {\n      border-radius: 4px;\n      font-size: 13px; }\n      .navbar.navbar-default .navbar-nav > li > a.selected {\n        color: #444; }\n    .navbar.navbar-default .navbar-nav > .open > a {\n      background: #FFF; }\n  .navbar .navbar-brand {\n    height: 36px;\n    min-width: 36px;\n    margin-top: 8px;\n    padding: 4px 8px; }\n    .navbar .navbar-brand img {\n      height: 100%; }\n\n.navbar {\n  /* Small Devices, Tablets */\n  /* Medium Devices, Desktops */ }\n  @media (max-width: 767px) {\n    .navbar .navbar-nav .open .dropdown-menu {\n      background-color: #FFF;\n      position: absolute;\n      border: 1px solid #CCC; } }\n  @media (min-width: 992px) {\n    .navbar {\n      padding: 2px 0;\n      margin-bottom: 0; }\n      .navbar .navbar-brand {\n        padding-top: 0; } }\n\n.nav-tabs {\n  border-bottom: 1px solid #ddd; }\n  .nav-tabs > li > a {\n    border-radius: 4px 4px 0 0; }\n\n.nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n  border-radius: 4px; }\n\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n    border-radius: 4px 4px 0 0; } }\n\n.panel > .panel-heading, .content-box > .panel-heading, .select-subcompany-modal .list-group > .panel-heading, .content-box-editable > .panel-heading, .card > .panel-heading, #appLauncherContainer .scrollable-list > .panel-heading, #appLauncherContainer .template-grid > .panel-heading {\n  position: relative;\n  background: #f7f7f7;\n  padding: 8px;\n  border: none;\n  border-left: 0; }\n\n/* Deprecate\n   ==========================================================================\n   ==========================================================================\n   ==========================================================================\n   ==========================================================================\n   ========================================================================== */\n.panel-info {\n  border: 1px solid #87daff; }\n  .panel-info > .panel-heading .toolbar {\n    text-align: right;\n    margin-right: 30px;\n    padding: 3px 0; }\n    @media (max-width: 768px) {\n      .panel-info > .panel-heading .toolbar {\n        margin-right: 0;\n        margin-top: 10px; }\n        .panel-info > .panel-heading .toolbar .btn, .panel-info > .panel-heading .toolbar .icon-nav label, .icon-nav .panel-info > .panel-heading .toolbar label {\n          display: block;\n          width: 100%;\n          margin-bottom: 4px; } }\n  .panel-info > .panel-body, .panel-info > .content-box-body {\n    border-left: 3px solid #87daff;\n    background: #d4f2ff;\n    padding: 15px; }\n  .panel-info .table-2 tr > td:last-child {\n    text-align: right; }\n\n.upload-panel {\n  overflow: hidden; }\n  .upload-panel .content-box-body {\n    border-left: 3px solid #d4d4d4; }\n  .upload-panel .content-box-header {\n    background: #f7f7f7;\n    border-left: 3px solid #d4d4d4;\n    padding: 10px 15px;\n    color: #555;\n    cursor: pointer;\n    overflow: hidden; }\n    .upload-panel .content-box-header p {\n      float: left; }\n    @media (max-width: 768px) {\n      .upload-panel .content-box-header p {\n        float: none; }\n      .upload-panel .content-box-header .actions-block {\n        text-align: left; } }\n  .upload-panel p {\n    overflow: hidden;\n    margin: 5px 0 5px 0; }\n    .upload-panel p a {\n      text-transform: capitalize;\n      float: right; }\n  .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: inline-block;\n    vertical-align: top; }\n    @media (max-width: 480px) {\n      .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {\n        width: 120px; } }\n    @media (max-width: 768px) {\n      .upload-panel .ellipsed, .upload-panel .box-list .title, .box-list .upload-panel .title, .upload-panel .box-list p, .box-list .upload-panel p, .upload-panel .box-list .box-list-body, .box-list .upload-panel .box-list-body, .upload-panel .box-list .box-list-aside, .box-list .upload-panel .box-list-aside {\n        width: 180px; } }\n  .upload-panel .actions-block {\n    text-align: right; }\n  .upload-panel .collapse-control {\n    line-height: 28px;\n    padding: 0 15px;\n    margin-right: -15px;\n    float: right; }\n\n@media print {\n  .hidden-print {\n    display: none !important; }\n  .visible-print {\n    display: block !important; }\n  table.visible-print {\n    display: table; }\n  th.visible-print, td.visible-print {\n    display: table-cell !important; }\n  tr.visible-print {\n    display: table-row !important; } }\n\n.tooltip-inner {\n  border-radius: 4px; }\n\n.form-control {\n  box-shadow: none; }\n\n/* ==========================================================================\n   Modals\n   ========================================================================== */\n/**\n * Part of workaround for Bootstrap bug where content shifts when modal\n * is opened.\n *\n * https://github.com/twbs/bootstrap/issues/9855\n\n */\n.modal {\n  z-index: 9999; }\n\n.modal-backdrop.in {\n  z-index: 9001; }\n\n.modal-content {\n  padding: 0;\n  background: #fcfcfc; }\n\n.modal-open {\n  overflow: auto; }\n\n.close {\n  font-size: 14px;\n  margin-top: 0px;\n  height: 55px;\n  width: 55px; }\n\n.modal-header {\n  margin-bottom: 0;\n  background: #f2f2f2;\n  overflow: hidden;\n  border-radius: 4px 4px 0 0; }\n\n.modal-title {\n  font-weight: 500;\n  padding: 15px; }\n\n.modal-title + .header-nav {\n  margin-top: -5px; }\n\n.modal-body {\n  padding: 15px; }\n\n.modal-header, .modal-footer {\n  padding: 0; }\n\n.modal-footer {\n  padding: 0 15px 15px;\n  border: 0;\n  margin-top: 0; }\n  .modal-footer input[type=\"checkbox\"] {\n    float: none; }\n\n.modal-dialog.modal-lg {\n  width: auto; }\n\n/* Media queries\n   ========================================================================== */\n@media (max-width: 480px) {\n  .modal-header .close {\n    padding: 15px; }\n  .modal-footer .btn-fixed-width {\n    width: 96px; } }\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto; }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }\n  .modal-sm {\n    width: 300px; } }\n\n.breadcrumb {\n  font-size: 12px;\n  padding: 0;\n  margin-bottom: 0px;\n  overflow: hidden;\n  white-space: nowrap;\n  background: none; }\n  .breadcrumb > li {\n    vertical-align: top; }\n    .breadcrumb > li a, .breadcrumb > li span {\n      max-width: 100px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: inline-block;\n      vertical-align: top; }\n\n@media only screen and (min-width: 768px) {\n  .breadcrumb {\n    padding: 10px 0;\n    font-size: 16px; }\n    .breadcrumb > li a, .breadcrumb > li span {\n      max-width: 240px; } }\n\n.storage-app .breadcrumb {\n  font-size: 14px;\n  padding: 7px 10px; }\n\n/* Core\n   ========================================================================== */\n/* ==========================================================================\n   Standard tags\n   ========================================================================== */\nhtml {\n  height: 100%;\n  -ms-overflow-style: scrollbar;\n  overflow-y: scroll; }\n\nbody {\n  min-height: 100%;\n  overflow: auto; }\n\nhtml,\nbody {\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%; }\n\n/**\n* Start of workaround for Bootstrap bug where content shifts when modal\n* is opened.\n\n* https://github.com/twbs/bootstrap/issues/9855\n*/\nbody.modal-open {\n  overflow: hidden; }\n\na:focus, button:focus {\n  outline: 0 !important;\n  text-decoration: none !important; }\n\n/* Resets */\nul {\n  list-style: none;\n  padding: 0; }\n\n/* Company Users\n   ========================================================================== */\n.company-users .action-bar {\n  margin-bottom: 10px; }\n  .company-users .action-bar .sort > a {\n    color: #333; }\n  .company-users .action-bar .sort > a:not(:first-child) {\n    margin-left: 15px; }\n\n.company-users .edit {\n  text-align: right; }\n\n/* Payment Methods */\n.payment-methods .list-group-item {\n  padding: 10px 0; }\n\n.payment-methods .expiry {\n  color: #555; }\n\n/* ==========================================================================\n   Forms\n   ========================================================================== */\n/* Input field focus */\ntextarea, input, div, input:focus {\n  outline: none; }\n\n/* Turn off number input spinners in WebKit. */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n/* Close button\n   ========================================================================== */\n.close {\n  opacity: 1; }\n  .close .fa::before, .close .glyphicons::before {\n    color: #555; }\n  .close:hover .fa::before, .close:hover .glyphicons::before {\n    color: #4d4d4d; }\n\n/* Sticky buttons\n   ========================================================================== */\n.sticky-buttons {\n  /* Positioning */\n  z-index: 10;\n  /* Display & Box Model */\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  /* Visual */\n  background-color: #fff; }\n  .sticky-buttons > button {\n    /* Display & Box Model */\n    margin-bottom: 10px; }\n  .sticky-buttons > a[type=\"button\"] {\n    /* Display & Box Model */\n    margin-bottom: 10px; }\n\n/* Toggle buttons (http://www.bootstrap-switch.org/)\n   ========================================================================== */\n.has-switch {\n  /* Visual */\n  border-radius: 8px;\n  border-color: #DDDDDD;\n  /* Display & Box Model */\n  min-width: 120px;\n  margin-top: -1px; }\n  .has-switch > div > label,\n  .has-switch > div > span {\n    /* Display & Box Model */\n    padding-bottom: 7px;\n    padding-top: 7px;\n    /* Visual */\n    font-size: 16px; }\n\n/* ==========================================================================\n   Footer\n   ========================================================================== */\n.footer {\n  /* Display & Box Model */\n  padding-top: 25px;\n  padding-bottom: 25px;\n  border-top: 1px solid 1px solid #ccc;\n  /* Visual */\n  background-color: #fff; }\n\n.social-text {\n  display: inline-block;\n  margin-bottom: 10px; }\n\nul.social {\n  display: inline-block; }\n  ul.social li a {\n    /* Display & Box Model */\n    display: block;\n    width: 24px;\n    height: 24px;\n    /* Visual */\n    text-indent: -9999em;\n    background: url(\"http://s3.amazonaws.com/Common-Test/css/images/social.png\") 0 0 no-repeat; }\n  ul.social li.twit a {\n    background-position: -24px 0; }\n  ul.social li.in a {\n    background-position: -48px 0; }\n  ul.social li.gplus a {\n    background-position: -72px 0; }\n  ul.social li.email a {\n    background-position: -96px 0; }\n\n.button-row {\n  overflow: hidden;\n  margin: 40px 0 40px; }\n\n/* Media queries\n   ========================================================================== */\n@media (min-width: 768px) {\n  .copyright {\n    text-align: right; } }\n\n/* Buttons\n   ========================================================================== */\n.button-badge {\n  margin-right: -20px;\n  float: right;\n  margin-top: -10px;\n  height: 20px;\n  line-height: 20px;\n  padding: 0 7px; }\n\n.btn-remove .fa::before,\n.btn-remove .glyphicons::before {\n  color: #d9534f;\n  font-size: 16px; }\n\n.btn-all {\n  background: #fff;\n  border-color: #fff; }\n  .btn-all .fa, .btn-all .glyphicons {\n    margin-top: -5px; }\n\n.btn-back:hover .fa-back,\n.btn-back:hover .glyphicons-back {\n  background: url(\"//s3.amazonaws.com/rise-common-test/images/glyphicons-back-active.png\") center no-repeat; }\n\n/* Sign In button */\n.btn-sign-in .log_in, .modal-dialog .sign-in .log_in {\n  color: #fff; }\n\n.sign-in, .top-auth-button {\n  background: none;\n  height: 32px;\n  line-height: 32px;\n  padding: 0;\n  border: 0;\n  color: #777;\n  font-weight: 500; }\n  .sign-in:hover, .sign-in:active, .top-auth-button:hover, .top-auth-button:active {\n    text-decoration: none;\n    color: #0081BA; }\n\n.top-auth-button img {\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  margin-left: 3px;\n  vertical-align: top;\n  margin-top: 2px; }\n\n/* SVG CLASSES */\n.btn svg, .icon-nav label svg {\n  width: 20px;\n  height: 20px;\n  vertical-align: top; }\n\n.btn-default svg, .timeline .dropdown-menu li .btn svg, .timeline .dropdown-menu li .icon-nav label svg, .icon-nav .timeline .dropdown-menu li label svg {\n  margin-left: 5px; }\n\n.btn svg path, .icon-nav label svg path {\n  fill: #666; }\n\n/* Horizontal rule\n   ========================================================================== */\n.hr-thick {\n  border-top: 2px solid #cbcbcb; }\n\n.hr-dashed {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-top: 2px dashed #cbcbcb; }\n\n/* Other\n   ========================================================================== */\n.title {\n  margin-top: 10px;\n  margin-bottom: 0; }\n\n.dropdown-title {\n  color: #4d4d4d;\n  font-weight: bold; }\n\n.qty {\n  width: 40px;\n  height: 28px; }\n\n.danger {\n  color: #d9534f; }\n\n.icon-left {\n  margin-right: 10px; }\n\n.icon-right {\n  margin-left: 10px; }\n\n.icon-sm-left {\n  margin-right: 5px; }\n\n.icon-sm-right {\n  margin-left: 5px; }\n\n.list-separator {\n  border-bottom: 1px solid #eee;\n  width: auto; }\n\n.error {\n  font-weight: bold; }\n\n.checkbox-primary > label {\n  font-weight: bold; }\n\n.label-disabled {\n  color: #e6e6e6; }\n\n.add-padding {\n  padding: 10px !important; }\n\n.add-left {\n  margin-left: 10px !important; }\n\n.add-right {\n  margin-right: 10px !important; }\n\n.remove-bottom {\n  margin-bottom: 0 !important; }\n\n.small-bottom {\n  margin-bottom: 3px !important; }\n\n.half-bottom {\n  margin-bottom: 10px !important; }\n\n.add-bottom {\n  margin-bottom: 20px !important; }\n\n.add-bottom-double {\n  margin-bottom: 40px !important; }\n\n.remove-top {\n  margin-top: 0 !important; }\n\n.small-top {\n  margin-top: 3px !important; }\n\n.half-top {\n  margin-top: 10px !important; }\n\n.add-top {\n  margin-top: 20px !important; }\n\n.add-top-double {\n  margin-top: 40px !important; }\n\n.remove-radius {\n  border-radius: 0 !important; }\n\n.remove-margin {\n  margin: 0 !important; }\n\n.remove-padding {\n  padding: 0 !important; }\n\n.btn-google-drive,\n.btn-google-drive:active .btn-google-drive.active {\n  width: 30px;\n  height: 30px;\n  border: none !important;\n  background-repeat: no-repeat;\n  background-color: transparent !important;\n  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive.png);\n  background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive.png\"); }\n  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {\n    .btn-google-drive,\n    .btn-google-drive:active .btn-google-drive.active {\n      background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-drive-2x.png\");\n      -webkit-background-size: 30px 30px; } }\n\n.btn-widget-icon-link,\n.btn-widget-icon-link:active .btn-widget-icon-link.active {\n  width: 30px;\n  height: 30px;\n  border: none !important;\n  background-repeat: no-repeat;\n  background-color: transparent !important;\n  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link.png);\n  background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link.png\"); }\n  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {\n    .btn-widget-icon-link,\n    .btn-widget-icon-link:active .btn-widget-icon-link.active {\n      background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-link-2x.png\");\n      -webkit-background-size: 30px 30px; } }\n\n.btn-widget-icon-storage,\n.btn-widget-icon-storage:active .btn-widget-icon-storage.active {\n  width: 30px;\n  height: 30px;\n  border: none !important;\n  background-repeat: no-repeat;\n  background-color: transparent !important;\n  background-image: url(http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage.png);\n  background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage.png\"); }\n  @media (-webkit-min-device-pixel-ratio: 2), (-moz-min-device-pixel-ratio: 2) {\n    .btn-widget-icon-storage,\n    .btn-widget-icon-storage:active .btn-widget-icon-storage.active {\n      background-image: url(\"http://s3.amazonaws.com/Rise-Images/Icons/widget-icon-storage-2x.png\");\n      -webkit-background-size: 30px 30px; } }\n\n/* STANDARD UTILITIES\nAll utilities have a prefix u_ added to them\n*/\n/* Line Height Utilities\n   ==========================================================================\n   To be used with forms and buttons\n*/\n/* For Normal Sized Buttons and Input Fields */\n.u_lh-normal {\n  line-height: 33px; }\n\n/* Ellipsis Utilities\n   ==========================================================================\n   To be used with forms and buttons\n*/\n.u_ellipsis, .u_ellipsis-md, .u_ellipsis-lg, .navbar-default li.user-profile-dropdown .user-id span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n@media (max-width: 767px) {\n  .u_ellipsis-md {\n    width: 100px; } }\n\n@media (min-width: 768px) {\n  .u_ellipsis-md {\n    max-width: 140px; } }\n\n@media (min-width: 992px) {\n  .u_ellipsis-md {\n    max-width: 180px; } }\n\n@media (min-width: 1200px) {\n  .u_ellipsis-md {\n    max-width: 240px; } }\n\n@media (max-width: 767px) {\n  .u_ellipsis-lg {\n    width: 200px; } }\n\n@media (min-width: 768px) {\n  .u_ellipsis-lg {\n    max-width: 260px; } }\n\n@media (min-width: 992px) {\n  .u_ellipsis-lg {\n    max-width: 320px; } }\n\n@media (min-width: 1200px) {\n  .u_ellipsis-lg {\n    max-width: 340px; } }\n\n/* Styling Utilities\n   ========================================================================== */\n.u_bordered {\n  border: 1px solid #d5d5d5;\n  border-radius: 4px; }\n\n/* Text Utilities\n */\n.u_text-ellipsis, .ellipsis, .editor-playlist .editor-playlist-item .playlist-item-name span, .placeholder-item-name, .display-name span, .display-address span, .playlist-item-reference {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.u_icon-hover > i {\n  opacity: 0; }\n\n.u_icon-hover:hover > i {\n  opacity: 1; }\n\n/*\n==========================================================================\n==========================================================================\n==========================================================================\nDEPRECATE Old Utilities\n   ========================================================================== */\n.nowrap {\n  white-space: nowrap; }\n\n.clickable {\n  cursor: pointer; }\n\n.ahrefdisabled {\n  color: #AAAAAA;\n  cursor: default;\n  pointer-events: none;\n  text-decoration: none; }\n\n.highlighted {\n  background: #FFFFE0;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: inline-block; }\n\n.empty-state .tag {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.radio-vertical-align {\n  display: inline-block; }\n\n.radio-vertical-align input,\n.radio-vertical-align label {\n  display: inline-block;\n  vertical-align: middle; }\n\n.app-navigation svg {\n  width: 24px;\n  height: 24px;\n  background: red; }\n\n.app-navigation path:first-child {\n  fill: #4AB767; }\n\n.app-navigation path:last-child {\n  fill: #2D60AD; }\n\n.file-empty-state path {\n  fill: #969595;\n  opacity: .65; }\n\nsvg:hover path {\n  fill: rgba(0, 0, 0, 0.7); }\n\npath {\n  fill: rgba(0, 0, 0, 0.4); }\n\n.fa.icon-gray:before {\n  color: #BBB; }\n\n.fa.icon-red:before {\n  color: #cf371f; }\n\n.fa.icon-green:before {\n  color: #4ab767; }\n\n.fa.icon-white:before {\n  color: #fff; }\n\n.text-white {\n  color: #FFF; }\n\n.row.sm-gutter, .support-app .ticket-list-table .sm-gutter.title-row, .support-app .ticket-list-table .sm-gutter.ticket {\n  margin-left: -4px;\n  margin-right: -4px; }\n\n.row.sm-gutter [class*='col-']:not(:first-child), .support-app .ticket-list-table .sm-gutter.title-row [class*='col-']:not(:first-child), .support-app .ticket-list-table .sm-gutter.ticket [class*='col-']:not(:first-child),\n.row.sm-gutter [class*='col-']:not(:last-child), .support-app .ticket-list-table .sm-gutter.title-row [class*='col-']:not(:last-child), .support-app .ticket-list-table .sm-gutter.ticket [class*='col-']:not(:last-child) {\n  padding-right: 4px;\n  padding-left: 4px; }\n\n.row.no-gutter, .support-app .ticket-list-table .no-gutter.title-row, .support-app .ticket-list-table .no-gutter.ticket {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n.row.no-gutter [class*='col-']:not(:first-child), .support-app .ticket-list-table .no-gutter.title-row [class*='col-']:not(:first-child), .support-app .ticket-list-table .no-gutter.ticket [class*='col-']:not(:first-child),\n.row.no-gutter [class*='col-']:not(:last-child), .support-app .ticket-list-table .no-gutter.title-row [class*='col-']:not(:last-child), .support-app .ticket-list-table .no-gutter.ticket [class*='col-']:not(:last-child) {\n  padding-right: 0px;\n  padding-left: 0px; }\n\n.padding-large {\n  padding: 30px; }\n\n.padding-large-horizontal {\n  padding-left: 30px;\n  padding-right: 30px; }\n\n.padding-small-vertical {\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n.img-icon {\n  height: 24px;\n  width: 24px;\n  margin-top: -4px;\n  margin-right: -4px;\n  vertical-align: bottom;\n  display: inline-block;\n  margin-left: 5px;\n  background-size: 100%; }\n  .img-icon.img-icon-google-calendar {\n    background-image: url(\"https://s3.amazonaws.com/Rise-Images/Icons/logo_calendar_32px.png\"); }\n\n/* Deprecate\n ==========================================================================\n ==========================================================================\n ==========================================================================\n ==========================================================================\n ========================================================================== */\n@media (max-width: 768px) {\n  .button-row .btn, .button-row .icon-nav label, .icon-nav .button-row label {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px; } }\n\n/* ==========================================================================\n   font awesome\n   ========================================================================== */\n.fa {\n  padding: 0; }\n\n.fa:before {\n  position: relative;\n  margin: 0; }\n\n.fa-white::before {\n  color: #fff; }\n\n.fa-danger::before {\n  color: #d9534f; }\n\n.chevron-right::before {\n  font-size: 16px; }\n\n.fa-back {\n  width: 24px;\n  height: 24px;\n  background: url(\"//s3.amazonaws.com/rise-common-test/images/glyphicons-back.png\") center no-repeat; }\n\n.fa.fa-grip-large {\n  position: relative;\n  left: -11px;\n  top: 20px;\n  color: #ddd; }\n  .fa.fa-grip-large:before {\n    content: \"\\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142\"; }\n\n/* ==========================================================================\n   Glyphicons\n   ========================================================================== */\n.glyphicon-box {\n  /* Display & Box Model */\n  min-width: 60px;\n  padding: 3px 10px;\n  /* Visual */\n  font-size: 23px; }\n\n.glyphicons {\n  padding: 0; }\n\n.glyphicons:before {\n  position: relative;\n  margin: 0; }\n\n.glyphicons::before {\n  color: #555; }\n\n.glyphicon-danger::before {\n  color: #d9534f; }\n\n.chevron-right::before {\n  font-size: 16px; }\n\n.glyphicons-back {\n  width: 24px;\n  height: 24px;\n  background: url(\"//s3.amazonaws.com/rise-common-test/images/glyphicons-back.png\") center no-repeat; }\n\n/* Media queries\n   ========================================================================== */\n@media (min-width: 768px) {\n  .modal-dialog .sign-in {\n    padding: 3px 10px;\n    /* TODO: Make this a variable. */ }\n  .stripe {\n    margin-bottom: 0; } }\n\n/* ==========================================================================\n   Print Media Queries\n   ========================================================================== */\n@media print {\n  /* Remove header when printing. */\n  .navbar {\n    display: none; } }\n\n/* Animation */\n.delayed {\n  -webkit-animation-delay: 1s;\n  animation-delay: 1s; }\n\n.animated, #helpDropdownButton.add-notice {\n  -webkit-animation-duration: 0.7s;\n  animation-duration: 0.7s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both; }\n\n.animated.infinite, .infinite#helpDropdownButton.add-notice {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite; }\n\n.animated.hinge, .hinge#helpDropdownButton.add-notice {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s; }\n\n@-webkit-keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n  40%, 43% {\n    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -30px, 0);\n    transform: translate3d(0, -30px, 0); }\n  70% {\n    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -15px, 0);\n    transform: translate3d(0, -15px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, -4px, 0);\n    transform: translate3d(0, -4px, 0); } }\n\n@keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n  40%, 43% {\n    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -30px, 0);\n    transform: translate3d(0, -30px, 0); }\n  70% {\n    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -15px, 0);\n    transform: translate3d(0, -15px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, -4px, 0);\n    transform: translate3d(0, -4px, 0); } }\n\n.bounce {\n  -webkit-animation-name: bounce;\n  animation-name: bounce;\n  -webkit-transform-origin: center bottom;\n  -ms-transform-origin: center bottom;\n  transform-origin: center bottom; }\n\n@-webkit-keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1; }\n  25%, 75% {\n    opacity: 0; } }\n\n@keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1; }\n  25%, 75% {\n    opacity: 0; } }\n\n.flash {\n  -webkit-animation-name: flash;\n  animation-name: flash; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  50% {\n    -webkit-transform: scale3d(1.05, 1.05, 1.05);\n    transform: scale3d(1.05, 1.05, 1.05); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  50% {\n    -webkit-transform: scale3d(1.05, 1.05, 1.05);\n    transform: scale3d(1.05, 1.05, 1.05); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n.pulse {\n  -webkit-animation-name: pulse;\n  animation-name: pulse; }\n\n@-webkit-keyframes rubberBand {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1); }\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1); }\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1); }\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1); }\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n@keyframes rubberBand {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1); }\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1); }\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1); }\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1); }\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n.rubberBand {\n  -webkit-animation-name: rubberBand;\n  animation-name: rubberBand; }\n\n@-webkit-keyframes shake {\n  0%, 100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0); }\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0); } }\n\n@keyframes shake {\n  0%, 100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0); }\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0); } }\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake; }\n\n@-webkit-keyframes swing {\n  20% {\n    -webkit-transform: rotate3d(0, 0, 1, 15deg);\n    transform: rotate3d(0, 0, 1, 15deg); }\n  40% {\n    -webkit-transform: rotate3d(0, 0, 1, -10deg);\n    transform: rotate3d(0, 0, 1, -10deg); }\n  60% {\n    -webkit-transform: rotate3d(0, 0, 1, 5deg);\n    transform: rotate3d(0, 0, 1, 5deg); }\n  80% {\n    -webkit-transform: rotate3d(0, 0, 1, -5deg);\n    transform: rotate3d(0, 0, 1, -5deg); }\n  100% {\n    -webkit-transform: rotate3d(0, 0, 1, 0deg);\n    transform: rotate3d(0, 0, 1, 0deg); } }\n\n@keyframes swing {\n  20% {\n    -webkit-transform: rotate3d(0, 0, 1, 15deg);\n    transform: rotate3d(0, 0, 1, 15deg); }\n  40% {\n    -webkit-transform: rotate3d(0, 0, 1, -10deg);\n    transform: rotate3d(0, 0, 1, -10deg); }\n  60% {\n    -webkit-transform: rotate3d(0, 0, 1, 5deg);\n    transform: rotate3d(0, 0, 1, 5deg); }\n  80% {\n    -webkit-transform: rotate3d(0, 0, 1, -5deg);\n    transform: rotate3d(0, 0, 1, -5deg); }\n  100% {\n    -webkit-transform: rotate3d(0, 0, 1, 0deg);\n    transform: rotate3d(0, 0, 1, 0deg); } }\n\n.swing {\n  -webkit-transform-origin: top center;\n  -ms-transform-origin: top center;\n  transform-origin: top center;\n  -webkit-animation-name: swing;\n  animation-name: swing; }\n\n@-webkit-keyframes tada {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  10%, 20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg); }\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg); }\n  40%, 60%, 80% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n@keyframes tada {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); }\n  10%, 20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg); }\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg); }\n  40%, 60%, 80% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg); }\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n.tada {\n  -webkit-animation-name: tada;\n  animation-name: tada; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none; }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg); }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg); }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg); }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg); }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none; }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg); }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg); }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg); }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg); }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n.wobble {\n  -webkit-animation-name: wobble;\n  animation-name: wobble; }\n\n@-webkit-keyframes bounceIn {\n  0%, 20%, 40%, 60%, 80%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1); }\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03); }\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n@keyframes bounceIn {\n  0%, 20%, 40%, 60%, 80%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1); }\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03); }\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1); } }\n\n.bounceIn {\n  -webkit-animation-name: bounceIn;\n  animation-name: bounceIn;\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s; }\n\n@-webkit-keyframes bounceInDown {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -3000px, 0);\n    transform: translate3d(0, -3000px, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0); }\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes bounceInDown {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -3000px, 0);\n    transform: translate3d(0, -3000px, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0); }\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n.bounceInDown {\n  -webkit-animation-name: bounceInDown;\n  animation-name: bounceInDown; }\n\n@-webkit-keyframes bounceInLeft {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-3000px, 0, 0);\n    transform: translate3d(-3000px, 0, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0); }\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0); }\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0); }\n  100% {\n    padding: 10px;\n    opacity: 1;\n    height: auto;\n    background: transparent;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes bounceInLeft {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-3000px, 0, 0);\n    transform: translate3d(-3000px, 0, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0); }\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0); }\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n.bounceInLeft {\n  -webkit-animation-name: bounceInLeft;\n  animation-name: bounceInLeft; }\n\n@-webkit-keyframes bounceInRight {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(3000px, 0, 0);\n    transform: translate3d(3000px, 0, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0); }\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0); }\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes bounceInRight {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(3000px, 0, 0);\n    transform: translate3d(3000px, 0, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0); }\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0); }\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0); }\n  100% {\n    -webkit-transform: none;\n    transform: none; } }\n\n.bounceInRight {\n  -webkit-animation-name: bounceInRight;\n  animation-name: bounceInRight; }\n\n@-webkit-keyframes bounceInUp {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0); }\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0); }\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); } }\n\n@keyframes bounceInUp {\n  0%, 60%, 75%, 90%, 100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0); }\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0); }\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0); }\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); } }\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp; }\n\n@-webkit-keyframes bounceOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9); }\n  50%, 55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); } }\n\n@keyframes bounceOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9); }\n  50%, 55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); } }\n\n.bounceOut {\n  -webkit-animation-name: bounceOut;\n  animation-name: bounceOut;\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s; }\n\n@-webkit-keyframes bounceOutDown {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0); }\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); } }\n\n@keyframes bounceOutDown {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0); }\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); } }\n\n.bounceOutDown {\n  -webkit-animation-name: bounceOutDown;\n  animation-name: bounceOutDown; }\n\n@-webkit-keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); } }\n\n@keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); } }\n\n.bounceOutLeft {\n  -webkit-animation-name: bounceOutLeft;\n  animation-name: bounceOutLeft; }\n\n@-webkit-keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); } }\n\n@keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); } }\n\n.bounceOutRight {\n  -webkit-animation-name: bounceOutRight;\n  animation-name: bounceOutRight; }\n\n@-webkit-keyframes bounceOutUp {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0); }\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); } }\n\n@keyframes bounceOutUp {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0); }\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); } }\n\n.bounceOutUp {\n  -webkit-animation-name: bounceOutUp;\n  animation-name: bounceOutUp; }\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn; }\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown; }\n\n@-webkit-keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInDownBig {\n  -webkit-animation-name: fadeInDownBig;\n  animation-name: fadeInDownBig; }\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft; }\n\n@-webkit-keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInLeftBig {\n  -webkit-animation-name: fadeInLeftBig;\n  animation-name: fadeInLeftBig; }\n\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInRight {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight; }\n\n@-webkit-keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInRightBig {\n  -webkit-animation-name: fadeInRightBig;\n  animation-name: fadeInRightBig; }\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp; }\n\n@-webkit-keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.fadeInUpBig {\n  -webkit-animation-name: fadeInUpBig;\n  animation-name: fadeInUpBig; }\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut; }\n\n@-webkit-keyframes fadeOutDown {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); } }\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); } }\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown; }\n\n@-webkit-keyframes fadeOutDownBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); } }\n\n@keyframes fadeOutDownBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0); } }\n\n.fadeOutDownBig {\n  -webkit-animation-name: fadeOutDownBig;\n  animation-name: fadeOutDownBig; }\n\n@-webkit-keyframes fadeOutLeft {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); } }\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); } }\n\n.fadeOutLeft {\n  -webkit-animation-name: fadeOutLeft;\n  animation-name: fadeOutLeft; }\n\n@-webkit-keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); } }\n\n@keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0); } }\n\n.fadeOutLeftBig {\n  -webkit-animation-name: fadeOutLeftBig;\n  animation-name: fadeOutLeftBig; }\n\n@-webkit-keyframes fadeOutRight {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); } }\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); } }\n\n.fadeOutRight {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight; }\n\n@-webkit-keyframes fadeOutRightBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); } }\n\n@keyframes fadeOutRightBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0); } }\n\n.fadeOutRightBig {\n  -webkit-animation-name: fadeOutRightBig;\n  animation-name: fadeOutRightBig; }\n\n@-webkit-keyframes fadeOutUp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); } }\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); } }\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp; }\n\n@-webkit-keyframes fadeOutUpBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); } }\n\n@keyframes fadeOutUpBig {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0); } }\n\n.fadeOutUpBig {\n  -webkit-animation-name: fadeOutUpBig;\n  animation-name: fadeOutUpBig; }\n\n@-webkit-keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  40% {\n    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  50% {\n    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  80% {\n    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; } }\n\n@keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  40% {\n    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  50% {\n    -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  80% {\n    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; } }\n\n.animated.flip, .flip#helpDropdownButton.add-notice {\n  -webkit-backface-visibility: visible;\n  backface-visibility: visible;\n  -webkit-animation-name: flip;\n  animation-name: flip; }\n\n@-webkit-keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in;\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in; }\n  60% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); } }\n\n@keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in;\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in; }\n  60% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); } }\n\n.flipInX {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInX;\n  animation-name: flipInX; }\n\n@-webkit-keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in;\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in; }\n  60% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -5deg); }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); } }\n\n@keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in;\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in; }\n  60% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -5deg); }\n  100% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); } }\n\n.flipInY {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInY;\n  animation-name: flipInY; }\n\n@-webkit-keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); }\n  30% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0; } }\n\n@keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); }\n  30% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0; } }\n\n.flipOutX {\n  -webkit-animation-name: flipOutX;\n  animation-name: flipOutX;\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important; }\n\n@-webkit-keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); }\n  30% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0; } }\n\n@keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px); }\n  30% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0; } }\n\n.flipOutY {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipOutY;\n  animation-name: flipOutY;\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s; }\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0; }\n  60% {\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: skewX(-5deg);\n    transform: skewX(-5deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0; }\n  60% {\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: skewX(-5deg);\n    transform: skewX(-5deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out; }\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    opacity: 1; }\n  100% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0; } }\n\n@keyframes lightSpeedOut {\n  0% {\n    opacity: 1; }\n  100% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0; } }\n\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in; }\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn; }\n\n@-webkit-keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.rotateInDownLeft {\n  -webkit-animation-name: rotateInDownLeft;\n  animation-name: rotateInDownLeft; }\n\n@-webkit-keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.rotateInDownRight {\n  -webkit-animation-name: rotateInDownRight;\n  animation-name: rotateInDownRight; }\n\n@-webkit-keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.rotateInUpLeft {\n  -webkit-animation-name: rotateInUpLeft;\n  animation-name: rotateInUpLeft; }\n\n@-webkit-keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -90deg);\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n@keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -90deg);\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1; } }\n\n.rotateInUpRight {\n  -webkit-animation-name: rotateInUpRight;\n  animation-name: rotateInUpRight; }\n\n@-webkit-keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, 200deg);\n    transform: rotate3d(0, 0, 1, 200deg);\n    opacity: 0; } }\n\n@keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, 200deg);\n    transform: rotate3d(0, 0, 1, 200deg);\n    opacity: 0; } }\n\n.rotateOut {\n  -webkit-animation-name: rotateOut;\n  animation-name: rotateOut; }\n\n@-webkit-keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; } }\n\n@keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 45deg);\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0; } }\n\n.rotateOutDownLeft {\n  -webkit-animation-name: rotateOutDownLeft;\n  animation-name: rotateOutDownLeft; }\n\n@-webkit-keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; } }\n\n@keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; } }\n\n.rotateOutDownRight {\n  -webkit-animation-name: rotateOutDownRight;\n  animation-name: rotateOutDownRight; }\n\n@-webkit-keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; } }\n\n@keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate3d(0, 0, 1, -45deg);\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0; } }\n\n.rotateOutUpLeft {\n  -webkit-animation-name: rotateOutUpLeft;\n  animation-name: rotateOutUpLeft; }\n\n@-webkit-keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 90deg);\n    transform: rotate3d(0, 0, 1, 90deg);\n    opacity: 0; } }\n\n@keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate3d(0, 0, 1, 90deg);\n    transform: rotate3d(0, 0, 1, 90deg);\n    opacity: 0; } }\n\n.rotateOutUpRight {\n  -webkit-animation-name: rotateOutUpRight;\n  animation-name: rotateOutUpRight; }\n\n@-webkit-keyframes hinge {\n  0% {\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  20%, 60% {\n    -webkit-transform: rotate3d(0, 0, 1, 80deg);\n    transform: rotate3d(0, 0, 1, 80deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  40%, 80% {\n    -webkit-transform: rotate3d(0, 0, 1, 60deg);\n    transform: rotate3d(0, 0, 1, 60deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    opacity: 1; }\n  100% {\n    -webkit-transform: translate3d(0, 700px, 0);\n    transform: translate3d(0, 700px, 0);\n    opacity: 0; } }\n\n@keyframes hinge {\n  0% {\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  20%, 60% {\n    -webkit-transform: rotate3d(0, 0, 1, 80deg);\n    transform: rotate3d(0, 0, 1, 80deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  40%, 80% {\n    -webkit-transform: rotate3d(0, 0, 1, 60deg);\n    transform: rotate3d(0, 0, 1, 60deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    opacity: 1; }\n  100% {\n    -webkit-transform: translate3d(0, 700px, 0);\n    transform: translate3d(0, 700px, 0);\n    opacity: 0; } }\n\n.hinge {\n  -webkit-animation-name: hinge;\n  animation-name: hinge; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n.rollIn {\n  -webkit-animation-name: rollIn;\n  animation-name: rollIn; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes rollOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg); } }\n\n@keyframes rollOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg); } }\n\n.rollOut {\n  -webkit-animation-name: rollOut;\n  animation-name: rollOut; }\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  50% {\n    opacity: 1; } }\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  50% {\n    opacity: 1; } }\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn; }\n\n@-webkit-keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomInDown {\n  -webkit-animation-name: zoomInDown;\n  animation-name: zoomInDown; }\n\n@-webkit-keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomInLeft {\n  -webkit-animation-name: zoomInLeft;\n  animation-name: zoomInLeft; }\n\n@-webkit-keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomInRight {\n  -webkit-animation-name: zoomInRight;\n  animation-name: zoomInRight; }\n\n@-webkit-keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomInUp {\n  -webkit-animation-name: zoomInUp;\n  animation-name: zoomInUp; }\n\n@-webkit-keyframes zoomOut {\n  0% {\n    opacity: 1; }\n  50% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  100% {\n    opacity: 0; } }\n\n@keyframes zoomOut {\n  0% {\n    opacity: 1; }\n  50% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3); }\n  100% {\n    opacity: 0; } }\n\n.zoomOut {\n  -webkit-animation-name: zoomOut;\n  animation-name: zoomOut; }\n\n@-webkit-keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomOutDown {\n  -webkit-animation-name: zoomOutDown;\n  animation-name: zoomOutDown; }\n\n@-webkit-keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n    -webkit-transform-origin: left center;\n    transform-origin: left center; } }\n\n@keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n    -webkit-transform-origin: left center;\n    transform-origin: left center; } }\n\n.zoomOutLeft {\n  -webkit-animation-name: zoomOutLeft;\n  animation-name: zoomOutLeft; }\n\n@-webkit-keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n    -webkit-transform-origin: right center;\n    transform-origin: right center; } }\n\n@keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n    -webkit-transform-origin: right center;\n    transform-origin: right center; } }\n\n.zoomOutRight {\n  -webkit-animation-name: zoomOutRight;\n  animation-name: zoomOutRight; }\n\n@-webkit-keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n@keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); } }\n\n.zoomOutUp {\n  -webkit-animation-name: zoomOutUp;\n  animation-name: zoomOutUp; }\n\n@-webkit-keyframes slideInDown {\n  0% {\n    -webkit-transform: translateY(-100%);\n    transform: translateY(-100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes slideInDown {\n  0% {\n    -webkit-transform: translateY(-100%);\n    transform: translateY(-100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n.slideInDown {\n  -webkit-animation-name: slideInDown;\n  animation-name: slideInDown; }\n\n@-webkit-keyframes slideInLeft {\n  0% {\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes slideInLeft {\n  0% {\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n.slideInLeft {\n  -webkit-animation-name: slideInLeft;\n  animation-name: slideInLeft; }\n\n@-webkit-keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight; }\n\n@-webkit-keyframes slideInUp {\n  0% {\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes slideInUp {\n  0% {\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%);\n    visibility: visible; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n.slideInUp {\n  -webkit-animation-name: slideInUp;\n  animation-name: slideInUp; }\n\n@-webkit-keyframes slideOutDown {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%); } }\n\n@keyframes slideOutDown {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%); } }\n\n.slideOutDown {\n  -webkit-animation-name: slideOutDown;\n  animation-name: slideOutDown; }\n\n@-webkit-keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%); } }\n\n@keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%); } }\n\n.slideOutLeft {\n  -webkit-animation-name: slideOutLeft;\n  animation-name: slideOutLeft; }\n\n@-webkit-keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%); } }\n\n@keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%); } }\n\n.slideOutRight {\n  -webkit-animation-name: slideOutRight;\n  animation-name: slideOutRight; }\n\n@-webkit-keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateY(-100%);\n    transform: translateY(-100%); } }\n\n@keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    visibility: hidden;\n    -webkit-transform: translateY(-100%);\n    transform: translateY(-100%); } }\n\n.slideOutUp {\n  -webkit-animation-name: slideOutUp;\n  animation-name: slideOutUp; }\n\n/* Display Layouts\n   ========================================================================== */\n.l_display-screenshot .panel, .l_display-screenshot .content-box, .l_display-screenshot .select-subcompany-modal .list-group, .select-subcompany-modal .l_display-screenshot .list-group, .l_display-screenshot .content-box-editable, .l_display-screenshot .card, .l_display-screenshot #appLauncherContainer .scrollable-list, #appLauncherContainer .l_display-screenshot .scrollable-list, .l_display-screenshot #appLauncherContainer .template-grid, #appLauncherContainer .l_display-screenshot .template-grid {\n  min-height: 300px; }\n\n/* UI-Components\n   ========================================================================== */\n.modal-custom > div {\n  width: auto;\n  display: table; }\n  .modal-custom > div .modal-content p {\n    display: inline-block;\n    white-space: nowrap; }\n  @media (max-width: 480px) {\n    .modal-custom > div {\n      display: block; }\n      .modal-custom > div .modal-content p {\n        white-space: normal; } }\n\n.modal-dialog .sign-in,\n.modal-dialog .sign-in:hover {\n  float: left; }\n  .modal-dialog .sign-in .fa::before, .modal-dialog .sign-in .glyphicons::before,\n  .modal-dialog .sign-in:hover .fa::before,\n  .modal-dialog .sign-in:hover .glyphicons::before {\n    line-height: 30px; }\n\niframe.modal-dialog {\n  border: none;\n  margin: 0;\n  width: 100%;\n  height: calc(100vh - 140px);\n  overflow: hidden; }\n\n.modal-full {\n  max-width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  overflow: hidden; }\n  .modal-full .modal-dialog {\n    max-width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    margin: 0; }\n\n.storage-modal {\n  padding: 15px; }\n\n.product-preview-modal .modal-dialog {\n  width: 70%;\n  margin-top: 42px; }\n\n/* ==========================================================================\n   Alignment\n   ========================================================================== */\n/* Style the component */\n.alignment .dropdown-menu {\n  /* Display & Box Model */\n  min-width: 145px;\n  padding: 5px; }\n\n.btn-alignment {\n  /* Display & Box Model */\n  min-width: 50px; }\n\n/* ==========================================================================\n   Font Picker\n   ========================================================================== */\n.font-picker .modal {\n  margin-top: 40px; }\n\n.font-picker-text {\n  /* Display & Box Model */\n  padding: 15px;\n  /* Visual */\n  text-align: left;\n  background-color: #efefef;\n  border-radius: 8px; }\n\n.font-select-btn {\n  width: 149px;\n  height: 30px;\n  position: relative; }\n  .font-select-btn .bfh-selectbox-option {\n    position: absolute;\n    top: 4.5px;\n    left: 3.5px; }\n  .font-select-btn .selectbox-caret {\n    float: right; }\n\n/* ==========================================================================\n   Font Style\n   ========================================================================== */\na[data-wysihtml5-command=bold],\na[data-wysihtml5-command=italic],\na[data-wysihtml5-command=underline],\na[data-wysihtml5-command=bold]:hover,\na[data-wysihtml5-command=italic]:hover,\na[data-wysihtml5-command=underline]:hover {\n  /* Display & Box Model */\n  min-width: 50px;\n  /* Visual */\n  background-color: #fff;\n  border-color: #ccc; }\n\na[data-wysihtml5-command=bold].active,\na[data-wysihtml5-command=italic].active,\na[data-wysihtml5-command=underline].active {\n  /* Visual */\n  -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);\n  background-color: #d9d9d9;\n  outline: 0; }\n\n/* Font style classes */\n.bold, a[data-wysihtml5-command=bold].btn {\n  font-weight: bold; }\n\n.italic, a[data-wysihtml5-command=italic].btn {\n  font-style: italic; }\n\n.underline, a[data-wysihtml5-command=underline].btn {\n  text-decoration: underline; }\n\n.navbar .navbar-nav > li > a.btn, .navbar .navbar-nav > li > a.company-buttons-icon-mobile {\n  margin-top: 8px;\n  margin-bottom: 0; }\n\n.navbar .navbar-nav > li > a.btn-link:hover, .navbar .navbar-nav > li > a.btn-link:focus, .navbar .navbar-nav > li > a.btn-link:active, .navbar .navbar-nav > li > button.btn-link:hover, .navbar .navbar-nav > li > button.btn-link:focus, .navbar .navbar-nav > li > button.btn-link:active {\n  color: gray; }\n\n.navbar .navbar-brand .fa {\n  padding: 8px; }\n\n.navbar-default li.user-profile-dropdown {\n  padding: 0;\n  text-align: right; }\n  .navbar-default li.user-profile-dropdown > a {\n    padding: 8px;\n    margin-top: 0; }\n  .navbar-default li.user-profile-dropdown .user-id span {\n    display: block;\n    font-size: 13px;\n    line-height: 18px; }\n  .navbar-default li.user-profile-dropdown .user-id .username {\n    line-height: 16px; }\n  .navbar-default li.user-profile-dropdown .profile-pic {\n    margin-left: 8px;\n    margin-top: 4px;\n    border-radius: 4px; }\n    .navbar-default li.user-profile-dropdown .profile-pic img {\n      height: 100%; }\n\n.app-navigation ul > li > a {\n  display: block; }\n  .app-navigation ul > li > a .image {\n    height: 16px;\n    margin-right: 8px;\n    float: left; }\n    .app-navigation ul > li > a .image img {\n      height: 100%; }\n\n/* Small Devices, Tablets */\n@media (max-width: 767px) {\n  li.user-profile-dropdown > a {\n    padding: 2px;\n    margin-top: 8px; }\n  li.user-profile-dropdown .user-id span {\n    max-width: 100px; } }\n\n/* Signup Modal\n   ========================================================================== */\n.signup-modal h1 {\n  font-size: 44px;\n  font-weight: 300;\n  margin-top: 48px; }\n  .signup-modal h1.text-muted {\n    margin-top: 5px;\n    font-size: 16px; }\n\n.signup-offer {\n  margin-top: 48px; }\n  .signup-offer .widgets-offer li {\n    background: #f2f2f2;\n    display: inline-block;\n    width: 85px;\n    height: 85px;\n    vertical-align: top;\n    padding: 5px;\n    border-radius: 4px; }\n    .signup-offer .widgets-offer li img {\n      width: 36px; }\n    .signup-offer .widgets-offer li span {\n      font-size: 12px;\n      font-weight: 500;\n      color: #666;\n      display: block;\n      line-height: 14px;\n      margin-top: 5px; }\n\n.registration-modal label {\n  font-weight: 500;\n  font-size: 15px; }\n  .registration-modal label span {\n    color: #666;\n    font-weight: 400;\n    font-size: 14px;\n    margin-left: 5px; }\n\n.registration-modal .checkbox label {\n  font-size: 14px;\n  color: #666;\n  font-weight: 400; }\n\n.signup-counters {\n  text-align: center;\n  margin-top: 24px;\n  background: #f7f7f7;\n  border-radius: 10px;\n  padding: 10px; }\n  .signup-counters .counter {\n    margin-bottom: 16px; }\n    .signup-counters .counter p {\n      margin: 0;\n      font-weight: 300;\n      font-size: 28px;\n      color: #4ab767; }\n    .signup-counters .counter span {\n      font-size: 12px;\n      display: block;\n      color: #999;\n      font-weight: 500; }\n\n/* Company Selector\n   ========================================================================== */\n.company-search {\n  padding-top: 20px; }\n\n/* Move Company\n   ========================================================================== */\n.move-company label {\n  font-weight: normal; }\n\n.move-company a {\n  line-height: 34px; }\n\n.move-company h3 {\n  font-size: 16px; }\n\n.move-company .to-company {\n  margin-bottom: 20px; }\n\n/* Company Settings\n   ========================================================================== */\n.company-settings .action-link {\n  margin-left: 20px; }\n\n.double-margin {\n  margin-bottom: 40px !important; }\n\n.sub-company-alert.test-company-alert {\n  background-color: #c0392b; }\n\n.sub-company-alert.test-company-alert + .sub-company-alert {\n  margin-top: 0; }\n\n.sub-company-alert {\n  width: 100%;\n  line-height: 20px;\n  bottom: -24px;\n  background-color: #e48f86;\n  color: #000;\n  padding: 0 20px;\n  border-bottom: 1px solid #db695d;\n  text-align: center;\n  display: inline-block; }\n\n.sub-company-alert .link-button {\n  display: inline-block;\n  font-weight: bold; }\n\n.authorization-modal {\n  text-align: center; }\n  .authorization-modal .profile-img {\n    width: 72px;\n    height: 72px;\n    -webkit-border-radius: 72px;\n    -moz-border-radius: 72px;\n    border-radius: 72px; }\n  .authorization-modal p, .authorization-modal .btn, .authorization-modal .icon-nav label, .icon-nav .authorization-modal label {\n    margin-top: 40px; }\n\n.user-profile-dropdown .dropdown-toggle .user-id span {\n  display: block;\n  line-height: 16px;\n  font-size: 13px;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .user-profile-dropdown .dropdown-toggle .user-id span.pending-registration {\n    line-height: 32px;\n    display: none; }\n  @media (max-width: 768px) {\n    .user-profile-dropdown .dropdown-toggle .user-id span {\n      width: 120px; } }\n\n.user-profile-dropdown .dropdown-toggle .user-id strong {\n  font-size: 12px;\n  color: #999; }\n\n.user-profile-dropdown .google-account {\n  margin: 15px;\n  line-height: 32px; }\n\n.dropdown-header {\n  color: #555;\n  padding: 10px; }\n  .dropdown-header.sub-company-header {\n    background: #f8e4e2; }\n  .dropdown-header p {\n    line-height: 18px;\n    margin: 0;\n    font-size: 13px;\n    overflow: hidden; }\n    @media (max-width: 480px) {\n      .dropdown-header p strong {\n        text-overflow: ellipsis;\n        display: block;\n        overflow: hidden;\n        max-width: 260px; }\n      .dropdown-header p a {\n        display: block;\n        margin-top: 5px; }\n      .dropdown-header p .text-muted {\n        display: none; } }\n\n.actions-nav > li > a .label {\n  position: absolute;\n  left: 60%;\n  top: -2px;\n  z-index: 1;\n  padding: 4px 7px;\n  font-size: 50%;\n  vertical-align: middle; }\n\n.actions-nav > li.shopping-cart > a .label {\n  left: 75%; }\n\n.actions-nav .dropdown .company-menu {\n  right: -62px; }\n\n.actions-nav .dropdown .company-menu::before {\n  right: 80px; }\n\n.actions-nav .dropdown .company-menu::after {\n  right: 81px; }\n\n.background-group .content-box, .background-group .select-subcompany-modal .list-group, .select-subcompany-modal .background-group .list-group, .background-group .content-box-editable, .background-group .card, .background-group #appLauncherContainer .scrollable-list, #appLauncherContainer .background-group .scrollable-list, .background-group #appLauncherContainer .template-grid, #appLauncherContainer .background-group .template-grid {\n  height: 34px;\n  overflow: hidden;\n  width: 123px;\n  float: right; }\n\n.background-group .control-label, .settings-group .control-label {\n  line-height: 34px;\n  margin: 0;\n  display: block; }\n\n.background-group span {\n  height: 33px;\n  display: block;\n  border-radius: 4px; }\n\n.color-wheel, .color-wheel:hover {\n  background: url(\"//s3.amazonaws.com/Rise-Images/UI/color_wheel.png\") no-repeat center;\n  padding-left: 15px;\n  padding-right: 15px;\n  border-radius: 0 4px 4px 0 !important;\n  border-left: none; }\n\n.image-placeholder {\n  width: 123px;\n  height: 123px;\n  background: url(\"//s3.amazonaws.com/Rise-Images/UI/transp_bg.png\") repeat;\n  margin-right: 10px;\n  border-radius: 4px;\n  text-align: center;\n  padding-top: 45px;\n  font-size: 32px;\n  border: 1px solid #CCC;\n  line-height: 0px; }\n\n.financial-selector .hero {\n  text-align: center;\n  padding-top: 20px;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  height: 400px; }\n  .financial-selector .hero h1 {\n    color: #FFF;\n    font-size: 24px;\n    margin-bottom: 0;\n    font-weight: 600; }\n  .financial-selector .hero h3 {\n    font-weight: 400;\n    color: #CCC;\n    font-size: 18px; }\n\n.financial-selector.financial-selector--login {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-top: 80px;\n  overflow: hidden;\n  background-color: #666;\n  background-image: url(\"https://s3.amazonaws.com/Rise-Images/financial-selector/stock.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-blend-mode: multiply;\n  background-position: bottom;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s; }\n  .financial-selector.financial-selector--login.is-email-login {\n    background-color: #bcbcbc; }\n\n.financial-selector__container {\n  -webkit-transition: all 0.8s;\n  transition: all 0.8s;\n  position: relative; }\n  .financial-selector__container .panel-email-login {\n    height: 400px; }\n    .financial-selector__container .panel-email-login legend {\n      padding: 10px; }\n  .financial-selector__container.email-login-animation {\n    -webkit-transform: translate(0, -400px); }\n    .financial-selector__container.email-login-animation .hero {\n      opacity: 0; }\n\n@media (min-width: 1200px) {\n  .financial-selector .hero h1 {\n    font-size: 48px; }\n  .financial-selector .hero h3 {\n    font-size: 24px; } }\n\n.drag-handle {\n  background-image: url(\"https://s3.amazonaws.com/Rise-Images/UI/dot-pattern.png\");\n  width: 12px;\n  height: 36px;\n  float: left;\n  margin-right: 10px; }\n\n.bottom-save-block {\n  background-color: #F7F7F9;\n  border-top: 1px solid #d4d4d4;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  padding: 16px 0;\n  z-index: 9999;\n  box-shadow: 0px -4px 10px 0 rgba(22, 22, 22, 0.08); }\n\n.is-hidden, .financial-selector__container .panel-email-login {\n  -webkit-transition: all 0.8s;\n  transition: all 0.8s;\n  opacity: 0; }\n\n.is-visible, .financial-selector__container.email-login-animation .panel-email-login {\n  -webkit-transition: all 0.8s;\n  transition: all 0.8s;\n  opacity: 1; }\n\n/* OLD STYLE */\n.tag-manager .label {\n  display: inline-block;\n  margin: 5px;\n  padding: 8px 9px; }\n\n.tag-manager .tags {\n  margin: 10px 0; }\n\n.collapse-panel.panel-heading a.panel-heading:after {\n  font-family: 'Glyphicons Halflings';\n  content: \"\\e114\";\n  float: left;\n  color: grey; }\n\n.collapse-panel.panel-heading a.panel-heading.collapsed:after {\n  content: \"\\e080\"; }\n\n.collapse-panel .remove-column-button {\n  float: right;\n  padding-top: 3.5px; }\n\n.bfh-fontsizes {\n  height: 30px; }\n\n.font-setting .mce-edit-area {\n  display: none; }\n\n.font-setting .text-container {\n  margin-top: 10px;\n  padding: 15px;\n  text-align: left;\n  background-color: #efefef;\n  border-radius: 8px; }\n\n.refresh-spin {\n  -webkit-animation: spin 2s infinite linear;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear; }\n\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg); }\n  100% {\n    -moz-transform: rotate(359deg); } }\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg); } }\n\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg); }\n  100% {\n    -o-transform: rotate(359deg); } }\n\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n.spinner-backdrop {\n  height: 100%;\n  width: 100%;\n  z-index: 10;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.75); }\n\n.select2-container {\n  width: 100%; }\n\n.select2-container .select2-choice abbr {\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") right top no-repeat; }\n\n.select2-container .select2-choice .select2-arrow b {\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 0 1px; }\n\n.select2-search input {\n  background: #fff url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 100% -22px;\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") no-repeat 100% -22px, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0; }\n\n.select2-search-choice-close {\n  background: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2.png\") right top no-repeat; }\n\n/* Retina-ize icons */\n@media only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (min-resolution: 2dppx) {\n  .select2-search input,\n  .select2-search-choice-close,\n  .select2-container .select2-choice abbr,\n  .select2-container .select2-choice .select2-arrow b {\n    background-image: url(\"http://s3.amazonaws.com/Rise-Images/UI/select2x2.png\") !important; } }\n\n.off-canvas--nav {\n  width: 350px;\n  background-color: #fff;\n  color: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 300px;\n  height: 100%;\n  -webkit-user-drag: none;\n  z-index: 1051;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate3d(-300px, 0, 0);\n  -moz-transform: translate3d(-300px, 0, 0);\n  -ms-transform: translate3d(-300px, 0, 0);\n  -o-transform: translate3d(-300px, 0, 0);\n  transform: translate3d(-300px, 0, 0);\n  -webkit-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -moz-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -ms-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -o-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98); }\n  .off-canvas--nav .off-canvas--nav-close {\n    font-size: 24px;\n    line-height: 40px; }\n  .off-canvas--nav .nav-stacked > li + li {\n    margin-top: 0px; }\n  .off-canvas--nav .nav-stacked > li:first-child {\n    padding: 10px 15px;\n    border-bottom: 1px solid #e5e5e5; }\n  .off-canvas--nav .nav-stacked > li a {\n    border-radius: 0px;\n    font-size: 16px;\n    line-height: 40px; }\n  .off-canvas--nav .nav-stacked > li i {\n    line-height: 40px; }\n\n.off-canvas--nav.is-off-canvas-opened {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2); }\n\n.action-sheet {\n  width: 100%;\n  height: auto;\n  max-height: 75%;\n  background-color: #FFF;\n  position: absolute;\n  left: 0px;\n  bottom: 0px;\n  z-index: 1051;\n  padding: 0;\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate3d(0, 100%, 0);\n  -moz-transform: translate3d(0, 100%, 0);\n  -ms-transform: translate3d(0, 100%, 0);\n  -o-transform: translate3d(0, 100%, 0);\n  transform: translate3d(0, 100%, 0);\n  -webkit-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -moz-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -ms-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  -o-transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98);\n  transition: all 0.3s cubic-bezier(0.16, 0.63, 0.45, 0.98); }\n  .action-sheet.is-action-sheet-opened {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n  .action-sheet ul {\n    padding: 0;\n    margin: 0; }\n  .action-sheet.is-action-sheet-closed {\n    display: none; }\n  .action-sheet .menu-box {\n    width: 50%; }\n  .action-sheet li {\n    list-style: none;\n    display: list-item;\n    margin: 0; }\n    .action-sheet li > a {\n      padding: 8px; }\n    .action-sheet li.system-message {\n      padding-bottom: 10px !important; }\n    .action-sheet li:active {\n      background-color: #d5d5d5; }\n    .action-sheet li a.action {\n      display: block;\n      height: 40px !important;\n      line-height: 40px !important;\n      color: #020621 !important; }\n\nli.dropdown-footer {\n  padding: 8px 8px 0; }\n\nli.dropdown-header {\n  padding: 8px; }\n\n#action-sheet-backdrop.modal-backdrop {\n  display: none;\n  background-color: #000;\n  opacity: 0.5; }\n  #action-sheet-backdrop.modal-backdrop.is-action-sheet-opened {\n    display: block; }\n\n.inverted-well {\n  background-color: #fff;\n  padding: 0 10px;\n  border: 1px solid #e5e5e5; }\n\n.system-message-list {\n  overflow-y: scroll;\n  min-width: 425px; }\n  .system-message-list .system-message {\n    padding: 22px; }\n\n.distribution {\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  width: 100%;\n  background-color: #fff; }\n  .distribution .no-display {\n    margin-left: 20px;\n    font-style: italic; }\n  .distribution .btn-new,\n  .distribution .btn-new:hover,\n  .distribution .btn-new:active {\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    background-color: #dddddd;\n    background-repeat: repeat-x;\n    background-image: -moz-linear-gradient(top, #fff 0%, #dddddd 100%);\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fff), color-stop(100%, #dddddd));\n    background-image: -webkit-linear-gradient(top, #fff 0%, #dddddd 100%);\n    background-image: -ms-linear-gradient(top, #fff 0%, #dddddd 100%);\n    background-image: -o-linear-gradient(top, #fff 0%, #dddddd 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fff', endColorstr='#dddddd',GradientType=0 );\n    background-image: linear-gradient(top, #fff 0%, #dddddd 100%); }\n  .distribution .btn-link {\n    color: #333; }\n    .distribution .btn-link:hover, .distribution .btn-link:active {\n      text-decoration: none !important;\n      color: #333; }\n  .distribution .company {\n    margin-top: 20px; }\n    .distribution .company:first-of-type {\n      margin-top: 40px; }\n    .distribution .company:not(:last-of-type) {\n      border-bottom: 1px solid #ccc; }\n  .distribution .list-unstyled, .distribution .list-inline {\n    padding: 0 20px; }\n    .distribution .list-unstyled span, .distribution .list-inline span {\n      margin-left: 20px;\n      line-height: 30px;\n      color: #aaa;\n      font-style: italic; }\n\n/**\n * Slide Left-Right, and Right-Left, each with the reserve\n * --------------------------------------------------\n * NEW content slides IN from the RIGHT, OLD slides OUT to the LEFT\n * Reverse: NEW content slides IN from the LEFT, OLD slides OUT to the RIGHT\n */\n.distribution-modal-container .modal-content {\n  overflow-x: hidden; }\n\n.slide-left-right {\n  min-width: 100%;\n  min-height: 383px; }\n\n.slide-left-right > .ng-enter, .slide-left-right.ng-enter,\n.slide-left-right > .ng-leave, .slide-left-right.ng-leave,\n.slide-right-left.reverse > .ng-enter,\n.slide-right-left.reverse.ng-enter,\n.slide-right-left.reverse > .ng-leave,\n.slide-right-left.reverse.ng-leave {\n  -webkit-transition: all ease-in-out 250ms;\n  -o-transition: all ease-in-out 250ms;\n  transition: all ease-in-out 250ms;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n\n.slide-left-right > .ng-enter, .slide-left-right.ng-enter,\n.slide-right-left.reverse > .ng-enter,\n.slide-right-left.reverse.ng-enter {\n  /* NEW content placed far RIGHT BEFORE it slides IN from the RIGHT */\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0); }\n\n.slide-left-right > .ng-enter.ng-enter-active, .slide-left-right.ng-enter.ng-enter-active,\n.slide-right-left.reverse > .ng-enter.ng-enter-active,\n.slide-right-left.reverse.ng-enter.ng-enter-active {\n  /* NEW content ACTIVELY sliding IN from the RIGHT */\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0); }\n\n.slide-left-right > .ng-leave.ng-leave-active, .slide-left-right.ng-leave.ng-leave-active,\n.slide-right-left.reverse > .ng-leave.ng-leave-active,\n.slide-right-left.reverse.ng-leave.ng-leave-active {\n  /* OLD content ACTIVELY sliding OUT to the LEFT */\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0); }\n\n.slide-left-right.reverse > .ng-enter, .slide-left-right.reverse.ng-enter, .slide-left-right.reverse > .ng-leave, .slide-left-right.reverse.ng-leave,\n.slide-right-left > .ng-enter,\n.slide-right-left.ng-enter,\n.slide-right-left > .ng-leave,\n.slide-right-left.ng-leave {\n  -webkit-transition: all ease-in-out 250ms;\n  -o-transition: all ease-in-out 250ms;\n  transition: all ease-in-out 250ms;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n\n.slide-left-right.reverse > .ng-enter, .slide-left-right.reverse.ng-enter,\n.slide-right-left > .ng-enter,\n.slide-right-left.ng-enter {\n  /* NEW content placed far LEFT BEFORE it slides IN from the LEFT */\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0); }\n\n.slide-left-right.reverse > .ng-enter.ng-enter-active, .slide-left-right.reverse.ng-enter.ng-enter-active,\n.slide-right-left > .ng-enter.ng-enter-active,\n.slide-right-left.ng-enter.ng-enter-active {\n  /* NEW content ACTIVELY sliding IN from the LEFT */\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0); }\n\n.slide-left-right.reverse > .ng-leave.ng-leave-active, .slide-left-right.reverse.ng-leave.ng-leave-active,\n.slide-right-left > .ng-leave.ng-leave-active,\n.slide-right-left.ng-leave.ng-leave-active {\n  /* OLD content ACTIVELY sliding OUT to the RIGHT */\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0); }\n\n.distribution-modal .list-group {\n  margin-bottom: 40px; }\n\n.distribution-modal .list-group-item {\n  cursor: pointer; }\n\n.distribution-modal .list-group-item-success {\n  background-color: #4ab767;\n  color: #fff;\n  font-weight: bold;\n  border-color: #3b9352;\n  border-bottom: 0; }\n\n.distribution-modal .list-group-company-selected {\n  background-color: #ddd;\n  border-color: #c4c4c4;\n  font-weight: bold; }\n\n.distribution-modal .list-group-company {\n  background-color: #FCFCFC; }\n\n.distribution-modal .list-group-item-secondary {\n  background-color: #F6F6F6;\n  border-top: 0;\n  border-color: #c3c3c3; }\n\n.distribution-modal .list-group-item-danger,\n.distribution-modal .list-group-item-secondary,\n.distribution-modal .list-group-item-success,\n.distribution-modal .fa.fa-chevron-right {\n  line-height: 40px; }\n\n.distribution-modal .list-group-item-danger {\n  background-color: #FFF8F5;\n  border-color: #c3c3c3;\n  border-bottom: 1px solid #c3c3c3;\n  margin-bottom: 0;\n  color: #c0392b; }\n  .distribution-modal .list-group-item-danger .btn, .distribution-modal .list-group-item-danger .icon-nav label, .icon-nav .distribution-modal .list-group-item-danger label {\n    border-radius: 2px;\n    height: 40px; }\n  .distribution-modal .list-group-item-danger .confirm-btn-group {\n    float: right; }\n  @media (max-width: 483px) {\n    .distribution-modal .list-group-item-danger {\n      line-height: 24px;\n      height: 110px; } }\n  @media (min-width: 484px) and (max-width: 580px) {\n    .distribution-modal .list-group-item-danger {\n      line-height: 30px;\n      height: 100px; } }\n  @media (max-width: 580px) {\n    .distribution-modal .list-group-item-danger .confirm-btn-group {\n      display: block;\n      float: left;\n      width: 100%;\n      text-align: center; }\n    .distribution-modal .list-group-item-danger .btn, .distribution-modal .list-group-item-danger .icon-nav label, .icon-nav .distribution-modal .list-group-item-danger label {\n      width: 100px; } }\n\n.app-header {\n  margin-left: -7.5px;\n  margin-right: -7.5px;\n  position: relative;\n  padding-top: 20px;\n  padding-bottom: 20px; }\n  .app-header:before, .app-header:after {\n    content: \" \";\n    display: table; }\n  .app-header:after {\n    clear: both; }\n  .app-header .title-block {\n    position: relative;\n    min-height: 1px;\n    padding-left: 7.5px;\n    padding-right: 7.5px; }\n    @media (min-width: 768px) {\n      .app-header .title-block {\n        float: left;\n        width: 50%; } }\n    .app-header .title-block h1 {\n      display: inline-block;\n      font-weight: 400;\n      line-height: 43px;\n      margin: 0 5px 0 0; }\n  .app-header .global-actions {\n    position: relative;\n    min-height: 1px;\n    padding-left: 7.5px;\n    padding-right: 7.5px;\n    text-align: right; }\n    @media (min-width: 768px) {\n      .app-header .global-actions {\n        float: left;\n        width: 50%; } }\n    .app-header .global-actions .btn, .app-header .global-actions .icon-nav label, .icon-nav .app-header .global-actions label {\n      margin-bottom: 0; }\n    @media (max-width: 768px) {\n      .app-header .global-actions {\n        margin-top: 10px; }\n        .app-header .global-actions .btn, .app-header .global-actions .icon-nav label, .icon-nav .app-header .global-actions label {\n          width: 100%;\n          margin: 0 0 5px;\n          padding: 8px 0; } }\n\n.toolbar {\n  overflow: hidden;\n  text-align: right;\n  margin-top: 10px; }\n\n.icon-nav {\n  color: #555;\n  line-height: 32px; }\n  .icon-nav .btn-link {\n    padding: 0;\n    border-radius: 3px;\n    min-width: 32px;\n    height: 32px;\n    vertical-align: top;\n    color: #4d4d4d; }\n    .icon-nav .btn-link:hover {\n      background: #e6e6e6; }\n    .icon-nav .btn-link:focus {\n      outline: 0; }\n    .icon-nav .btn-link .fa {\n      font-size: 20px;\n      line-height: 32px; }\n      .icon-nav .btn-link .fa:before {\n        color: #4d4d4d; }\n    .icon-nav .btn-link .fa + .fa {\n      margin-left: -4px;\n      margin-top: 6px;\n      font-size: 12px;\n      vertical-align: top; }\n\n.custom-icon {\n  display: inline-block;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle; }\n\n.file-picker {\n  color: #777777;\n  cursor: pointer; }\n  .file-picker:hover .file-picker-icon {\n    background-color: #FFF; }\n  .file-picker .file-picker-icon {\n    width: 32px;\n    height: 32px;\n    background-color: #ddd;\n    border-radius: 16px;\n    line-height: 32px;\n    text-align: center;\n    margin-left: 5px; }\n  .file-picker :disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: .65; }\n\n.empty-state {\n  height: 300px;\n  text-align: center;\n  border: 1px solid #ccc;\n  margin-bottom: 20px;\n  border-radius: 2px;\n  background-color: #fff;\n  color: #aaa; }\n  .empty-state i:before {\n    color: #aaa; }\n\n.file-empty-state {\n  font-size: 16px;\n  padding-bottom: 66px;\n  text-align: center;\n  color: #333; }\n  .file-empty-state .product-graphic {\n    width: 64px;\n    height: 64px;\n    margin-top: 33px;\n    text-align: center; }\n    @media screen and (max-width: 768px) {\n      .file-empty-state .product-graphic {\n        margin-top: 44px; } }\n    .file-empty-state .product-graphic svg-icon {\n      margin-left: 0; }\n      .file-empty-state .product-graphic svg-icon svg {\n        width: 32px;\n        height: 32px; }\n  .file-empty-state .btn .fa-2x, .file-empty-state .icon-nav label .fa-2x, .icon-nav .file-empty-state label .fa-2x {\n    font-size: 22px; }\n  .file-empty-state .fa::before {\n    color: #969595; }\n  .file-empty-state svg {\n    width: 70px;\n    height: 40px;\n    position: relative;\n    top: 19px; }\n    .file-empty-state svg path {\n      fill: #444; }\n\n/* Modal scrollable list\n   ========================================================================== */\n.scrollable-list, .template-grid {\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: calc(100vh - 240px);\n  min-height: 240px; }\n\n.scrollable-list::-webkit-scrollbar, .template-grid::-webkit-scrollbar {\n  -webkit-appearance: none; }\n\n.scrollable-list::-webkit-scrollbar:vertical, .template-grid::-webkit-scrollbar:vertical {\n  width: 11px; }\n\n.scrollable-list::-webkit-scrollbar:horizontal, .template-grid::-webkit-scrollbar:horizontal {\n  height: 11px; }\n\n.scrollable-list::-webkit-scrollbar-thumb, .template-grid::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 2px solid #f2f2f2;\n  /* should match background, can't be transparent */\n  background-color: rgba(50, 50, 50, 0.5); }\n\n.scrollable-list::-webkit-scrollbar-track, .template-grid::-webkit-scrollbar-track {\n  background-color: #f2f2f2;\n  border-radius: 2px; }\n\n/* List-Group\n   ========================================================================== */\n.editor-playlist .editor-playlist-item {\n  overflow: hidden;\n  background: #FFF;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-bottom: 5px;\n  padding: 8px; }\n  .editor-playlist .editor-playlist-item:hover {\n    border: 1px solid #bcbcbc; }\n  .editor-playlist .editor-playlist-item p,\n  .editor-playlist .editor-playlist-item h4 {\n    margin: 0;\n    line-height: 22px; }\n  .editor-playlist .editor-playlist-item .playlist-item-name span {\n    font-weight: 500;\n    display: inline-block;\n    vertical-align: top;\n    max-width: 125px; }\n  .editor-playlist .editor-playlist-item .playlist-item-status {\n    color: red !important;\n    font-weight: 400;\n    cursor: pointer; }\n    .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status .btn, .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status .icon-nav label, .icon-nav .editor-playlist .editor-playlist-item .playlist-item-status .playlist-item-status label {\n      font-size: 10px; }\n\n.editor-playlist .arrows {\n  float: left;\n  width: 24px;\n  margin: 6px; }\n  .editor-playlist .arrows .btn, .editor-playlist .arrows .icon-nav label, .icon-nav .editor-playlist .arrows label {\n    margin: 0; }\n    .editor-playlist .arrows .btn:first-child, .editor-playlist .arrows .icon-nav label:first-child, .icon-nav .editor-playlist .arrows label:first-child {\n      border-radius: 3px 3px 0 0; }\n    .editor-playlist .arrows .btn:last-child, .editor-playlist .arrows .icon-nav label:last-child, .icon-nav .editor-playlist .arrows label:last-child {\n      border-radius: 0 0 3px 3px; }\n\n.editor-playlist .list-grip {\n  float: left;\n  width: 25px;\n  margin-right: 3px;\n  background-color: white;\n  height: 56px;\n  display: inline-block;\n  cursor: move;\n  cursor: -webkit-grabbing; }\n  .editor-playlist .list-grip .btn, .editor-playlist .list-grip .icon-nav label, .icon-nav .editor-playlist .list-grip label {\n    margin: 0; }\n    .editor-playlist .list-grip .btn:first-child, .editor-playlist .list-grip .icon-nav label:first-child, .icon-nav .editor-playlist .list-grip label:first-child {\n      border-radius: 3px 3px 0 0; }\n    .editor-playlist .list-grip .btn:last-child, .editor-playlist .list-grip .icon-nav label:last-child, .icon-nav .editor-playlist .list-grip label:last-child {\n      border-radius: 0 0 3px 3px; }\n\n.editor-playlist .actions {\n  float: right;\n  margin-right: 4px;\n  margin-top: 1px;\n  width: 58px; }\n  .editor-playlist .actions .btn-default, .editor-playlist .actions .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .editor-playlist .actions .btn, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label {\n    display: inline-block;\n    margin-bottom: 3px;\n    margin-top: 3px;\n    width: 27px; }\n    .editor-playlist .actions .btn-default:nth-child(1):hover, .editor-playlist .actions .timeline .dropdown-menu li .btn:nth-child(1):hover, .timeline .dropdown-menu li .editor-playlist .actions .btn:nth-child(1):hover, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label:nth-child(1):hover, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label:nth-child(1):hover, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label:nth-child(1):hover, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label:nth-child(1):hover {\n      margin-right: 4px !important; }\n    .editor-playlist .actions .btn-default:first-child, .editor-playlist .actions .timeline .dropdown-menu li .btn:first-child, .timeline .dropdown-menu li .editor-playlist .actions .btn:first-child, .editor-playlist .actions .timeline .dropdown-menu li .icon-nav label:first-child, .timeline .dropdown-menu li .icon-nav .editor-playlist .actions label:first-child, .editor-playlist .actions .icon-nav .timeline .dropdown-menu li label:first-child, .icon-nav .timeline .dropdown-menu li .editor-playlist .actions label:first-child {\n      display: block;\n      width: 100%;\n      margin-bottom: 1px; }\n\n/* List-Group\n   ========================================================================== */\n.list-group {\n  margin-bottom: 0; }\n\n.list-group-item {\n  background-color: none;\n  border: none;\n  border-bottom: 1px solid #f2f2f2; }\n\n/* Box list\n   ========================================================================== */\n.box-list-container {\n  background-color: #fff;\n  margin-bottom: 20px;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n  overflow: hidden; }\n\n.box-list {\n  color: #333;\n  margin-top: 0;\n  padding: 15px; }\n  .box-list:not(:last-child) {\n    border-bottom: 1px solid #e5e5e5; }\n  .box-list:hover, .box-list:active {\n    background-color: #fafafa; }\n  .box-list .title {\n    margin: 0;\n    line-height: 1.5; }\n  .box-list p {\n    font-size: 85%;\n    line-height: 1.1;\n    margin: 5px 0 0 0; }\n  .box-list .meta {\n    color: #777777; }\n  .box-list .box-list-body {\n    padding-right: 40px; }\n  .box-list .box-list-aside {\n    float: right; }\n\n/* Grid List\n   ========================================================================== */\n.grid-list h4 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 30px;\n  font-size: 16px;\n  margin-bottom: 0;\n  width: 100%; }\n\n.grid-list .grid-list-image {\n  background: #e6e6e6;\n  max-width: 100%;\n  height: 180px;\n  text-align: center;\n  font-size: 0;\n  overflow: hidden;\n  position: relative; }\n  .grid-list .grid-list-image > * {\n    display: inline-block;\n    border: solid 2px #fff; }\n  .grid-list .grid-list-image img {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box; }\n\n.grid-list .content-box, .grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .grid-list .list-group, .grid-list .content-box-editable, .grid-list .card, .grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .grid-list .scrollable-list, .grid-list #appLauncherContainer .template-grid, #appLauncherContainer .grid-list .template-grid {\n  margin: 8px;\n  padding: 8px;\n  border: 1px solid #e6e6e6;\n  -webkit-box-shadow: inset 0 -1px 0 #d5d1cb, 0 1px 4px rgba(113, 108, 102, 0.1), transparent 0 0 0;\n  box-shadow: inset 0 -1px 0 #d5d1cb, 0 1px 4px rgba(113, 108, 102, 0.1), transparent 0 0 0;\n  cursor: pointer;\n  -o-transition: border .2s ease-out;\n  -ms-transition: border .2s ease-out;\n  -moz-transition: border .2s ease-out;\n  -webkit-transition: border .2s ease-out;\n  transition: border .2s ease-out; }\n  .grid-list .content-box .product-pricing, .grid-list .select-subcompany-modal .list-group .product-pricing, .select-subcompany-modal .grid-list .list-group .product-pricing, .grid-list .content-box-editable .product-pricing, .grid-list .card .product-pricing, .grid-list #appLauncherContainer .scrollable-list .product-pricing, #appLauncherContainer .grid-list .scrollable-list .product-pricing, .grid-list #appLauncherContainer .template-grid .product-pricing, #appLauncherContainer .grid-list .template-grid .product-pricing {\n    position: absolute;\n    bottom: 0; }\n    .grid-list .content-box .product-pricing span, .grid-list .select-subcompany-modal .list-group .product-pricing span, .select-subcompany-modal .grid-list .list-group .product-pricing span, .grid-list .content-box-editable .product-pricing span, .grid-list .card .product-pricing span, .grid-list #appLauncherContainer .scrollable-list .product-pricing span, #appLauncherContainer .grid-list .scrollable-list .product-pricing span, .grid-list #appLauncherContainer .template-grid .product-pricing span, #appLauncherContainer .grid-list .template-grid .product-pricing span {\n      color: #3C7BDA;\n      font-weight: bold; }\n  .grid-list .content-box .info, .grid-list .select-subcompany-modal .list-group .info, .select-subcompany-modal .grid-list .list-group .info, .grid-list .content-box-editable .info, .grid-list .card .info, .grid-list #appLauncherContainer .scrollable-list .info, #appLauncherContainer .grid-list .scrollable-list .info, .grid-list #appLauncherContainer .template-grid .info, #appLauncherContainer .grid-list .template-grid .info {\n    position: absolute;\n    float: left;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    background: rgba(122, 122, 182, 0.7) url(\"../../../../img/info-icon.png\") center no-repeat;\n    -o-transition: opacity .2s ease-in;\n    -ms-transition: opacity .2s ease-in;\n    -moz-transition: opacity .2s ease-in;\n    -webkit-transition: opacity .2s ease-in;\n    transition: opacity .2s ease-in; }\n  .grid-list .content-box:hover, .grid-list .select-subcompany-modal .list-group:hover, .select-subcompany-modal .grid-list .list-group:hover, .grid-list .content-box-editable:hover, .grid-list .card:hover, .grid-list #appLauncherContainer .scrollable-list:hover, #appLauncherContainer .grid-list .scrollable-list:hover, .grid-list #appLauncherContainer .template-grid:hover, #appLauncherContainer .grid-list .template-grid:hover {\n    border: 1px solid #8E8E8E;\n    box-shadow: inset 0 -1px 0 #9A9895, 2px 3px 6px rgba(113, 108, 102, 0.3), transparent 0 0 0; }\n    .grid-list .content-box:hover .info, .grid-list .select-subcompany-modal .list-group:hover .info, .select-subcompany-modal .grid-list .list-group:hover .info, .grid-list .content-box-editable:hover .info, .grid-list .card:hover .info, .grid-list #appLauncherContainer .scrollable-list:hover .info, #appLauncherContainer .grid-list .scrollable-list:hover .info, .grid-list #appLauncherContainer .template-grid:hover .info, #appLauncherContainer .grid-list .template-grid:hover .info {\n      opacity: 1; }\n\n@media only screen and (max-width: 992px) {\n  .grid-list .grid-list-image {\n    height: 284px; } }\n\n@media (max-width: 768px) {\n  .grid-list .grid-list-image {\n    height: 300px; }\n  .grid-list h4 {\n    font-size: 14px; }\n  .grid-list .content-box, .grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .grid-list .list-group, .grid-list .content-box-editable, .grid-list .card, .grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .grid-list .scrollable-list, .grid-list #appLauncherContainer .template-grid, #appLauncherContainer .grid-list .template-grid {\n    padding: 5px;\n    margin: 5px; } }\n\n.store.grid-list {\n  /* Small devices  */\n  /* Medium devices  */ }\n  .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {\n    min-height: 323px;\n    position: static; }\n  @media (min-width: 768px) {\n    .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {\n      min-height: 408px; } }\n  @media (min-width: 992px) {\n    .store.grid-list .content-box, .store.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store.grid-list .list-group, .store.grid-list .content-box-editable, .store.grid-list .card, .store.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store.grid-list .scrollable-list, .store.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store.grid-list .template-grid {\n      min-height: 363px; } }\n\n.store-front.grid-list {\n  /* Small devices  */\n  /* Medium devices  */ }\n  @media (min-width: 768px) {\n    .store-front.grid-list .content-box, .store-front.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store-front.grid-list .list-group, .store-front.grid-list .content-box-editable, .store-front.grid-list .card, .store-front.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store-front.grid-list .scrollable-list, .store-front.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store-front.grid-list .template-grid {\n      min-height: 405px; } }\n  @media (min-width: 992px) {\n    .store-front.grid-list .content-box, .store-front.grid-list .select-subcompany-modal .list-group, .select-subcompany-modal .store-front.grid-list .list-group, .store-front.grid-list .content-box-editable, .store-front.grid-list .card, .store-front.grid-list #appLauncherContainer .scrollable-list, #appLauncherContainer .store-front.grid-list .scrollable-list, .store-front.grid-list #appLauncherContainer .template-grid, #appLauncherContainer .store-front.grid-list .template-grid {\n      min-height: 290px; } }\n\n.store.grid-list-text {\n  color: #333; }\n\n/* Standard Table\n   ========================================================================== */\n.table, .table-2 {\n  width: 100%;\n  font-size: 14px; }\n  .table .table-header .table-header__row > .table-header__cell > a, .table-2 .table-header .table-header__row > .table-header__cell > a {\n    color: #020621;\n    display: block; }\n  .table .table-header .table-header__row > .table-header__cell > span, .table-2 .table-header .table-header__row > .table-header__cell > span {\n    display: block; }\n  .table .table-body .table-body__row > .table-body__cell, .table-2 .table-body .table-body__row > .table-body__cell {\n    vertical-align: middle; }\n    .table .table-body .table-body__row > .table-body__cell > a, .table-2 .table-body .table-body__row > .table-body__cell > a {\n      display: block; }\n    .table .table-body .table-body__row > .table-body__cell > span, .table-2 .table-body .table-body__row > .table-body__cell > span {\n      display: inline-block;\n      vertical-align: middle; }\n  .table.table--sortable .table-body .table-body__row > .table-body__cell, .table--sortable.table-2 .table-body .table-body__row > .table-body__cell {\n    cursor: move; }\n  .table.table--sortable .table-body .table-body__row:hover > .table-body__cell, .table--sortable.table-2 .table-body .table-body__row:hover > .table-body__cell {\n    background: #f5f5f5; }\n  .table.table--selector .table-body .table-body__row > .table-body__cell, .table--selector.table-2 .table-body .table-body__row > .table-body__cell {\n    cursor: pointer; }\n    .table.table--selector .table-body .table-body__row > .table-body__cell:first-child i, .table--selector.table-2 .table-body .table-body__row > .table-body__cell:first-child i {\n      margin: 0 4px; }\n  .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell {\n    background: #4ab767;\n    color: #FFF; }\n    .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell a, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell a, .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .text-muted, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .text-muted, .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .text-green, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .text-green {\n      color: #FFF; }\n    .table.table--selector .table-body .table-body__row--is-selected > .table-body__cell .fa:before, .table--selector.table-2 .table-body .table-body__row--is-selected > .table-body__cell .fa:before {\n      color: #FFF; }\n\n/* Table Selector Icon\n   ========================================================================== */\n.selector-icon, .table.table--selector .table-body .table-body__row > .table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row > .table-body__cell:first-child:before {\n  font-family: FontAwesome;\n  font-size: 16px;\n  content: '\\f096';\n  height: 16px;\n  display: inline-block;\n  margin-right: 4px;\n  margin-left: 4px;\n  vertical-align: top; }\n  .selector-icon.selector-icon--selected, .table.table--selector .table-body .table-body__row > .selector-icon--selected.table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row > .selector-icon--selected.table-body__cell:first-child:before, .table.table--selector .table-body .table-body__row--is-selected.table-body__row > .table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row--is-selected.table-body__row > .table-body__cell:first-child:before, .table.table--selector .table-body .table-body__row--is-selected > .selector-icon.table-body__cell:first-child:before, .table--selector.table-2 .table-body .table-body__row--is-selected > .selector-icon.table-body__cell:first-child:before {\n    content: '\\f14a'; }\n\n/* Deprecate\n   ==========================================================================\n   ==========================================================================\n   ==========================================================================\n   ==========================================================================\n   ========================================================================== */\n.table-2 thead tr > th {\n  padding: 8px; }\n\n.table-2 tbody tr:hover {\n  cursor: pointer; }\n  .table-2 tbody tr:hover a {\n    color: #0081BA; }\n\n.table-2 tbody tr > td {\n  padding: 12px 8px; }\n  .table-2 tbody tr > td > a {\n    color: #4d4d4d; }\n    .table-2 tbody tr > td > a:hover {\n      text-decoration: none; }\n\n.table-selector > thead > tr th label {\n  margin: 0; }\n\n.table-selector > thead > tr th input[type=checkbox] {\n  display: none; }\n\n.table-selector > thead > tr th input[type=checkbox] + label:before {\n  font-family: FontAwesome;\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n  color: #d4d4d4;\n  font-size: 16px;\n  width: 16px;\n  text-align: center;\n  content: '\\f096'; }\n\n.table-selector > thead > tr th input[type=checkbox]:checked + label:before {\n  content: '\\f14a'; }\n\n.table-selector > tbody > tr td {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: pointer;\n  vertical-align: middle; }\n  .table-selector > tbody > tr td:first-child:before {\n    font-family: FontAwesome;\n    font-style: normal;\n    margin-right: 10px;\n    display: inline-block;\n    vertical-align: middle;\n    color: #d4d4d4;\n    font-size: 16px;\n    width: 16px;\n    height: 18px;\n    text-align: center; }\n\n.table-selector > tbody > tr.disabled-row {\n  background: #f5f5f5; }\n  .table-selector > tbody > tr.disabled-row td, .table-selector > tbody > tr.disabled-row td a {\n    cursor: not-allowed;\n    color: #999; }\n  .table-selector > tbody > tr.disabled-row:hover a {\n    color: #999; }\n\n.table-selector > tbody > tr.back-btn td:first-child:before {\n  content: '\\f060' !important; }\n\n.table-selector > tbody > tr.no-select-row td:first-child:before {\n  content: '' !important; }\n\n.table-selector > tbody > tr.active {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn; }\n  .table-selector > tbody > tr.active:hover td {\n    background: #5cbe76;\n    color: #FFF; }\n  .table-selector > tbody > tr.active td {\n    background: #5cbe76;\n    color: #FFF; }\n    .table-selector > tbody > tr.active td a {\n      color: #FFF; }\n    .table-selector > tbody > tr.active td .text-muted {\n      color: #FFF; }\n    .table-selector > tbody > tr.active td .folder:before {\n      color: #FFF; }\n    .table-selector > tbody > tr.active td:first-child:before {\n      color: #FFF; }\n\n.table-selector.single-selector > tbody > tr td:first-child:before {\n  content: '\\f096'; }\n\n.table-selector.single-selector > tbody > tr.active td:first-child:before {\n  content: '\\f192'; }\n\n.table-selector.multiple-selector > tbody > tr td:first-child:before {\n  content: '\\f096'; }\n\n.table-selector.multiple-selector > tbody > tr.active td:first-child:before {\n  content: '\\f14a'; }\n\n.table-selector.multiple-selector > tbody > tr.info-row {\n  background-color: #eee; }\n  .table-selector.multiple-selector > tbody > tr.info-row td:first-child:before {\n    content: initial; }\n\n.table-2 > tbody > tr > td:first-child input {\n  display: inline-block; }\n\n.table-2 > tbody > tr > td:first-child span a {\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden; }\n\ntr.blocked-file > td {\n  background: #f7f7f7;\n  cursor: pointer;\n  position: relative; }\n  tr.blocked-file > td .callout {\n    top: 45px;\n    left: 0; }\n\n/* DEPRECATE */\n/* Presentation Selector */\n.presentation-selector {\n  margin-top: 20px;\n  /* Styled the same as navbar-left. */ }\n  .presentation-selector .selector-header {\n    /* Positioning */\n    float: left;\n    /* Display & Box Model */\n    width: 100%;\n    padding: 5px 15px 5px 0;\n    border-bottom: 1px solid #DDDDDD;\n    margin: 0; }\n    .presentation-selector .selector-header li {\n      /* Positioning */\n      float: left;\n      /* Display & Box Model */\n      display: block;\n      margin-left: 5px; }\n    .presentation-selector .selector-header a {\n      /* Display & Box Model */\n      display: block;\n      padding: 3px 10px;\n      border: 1px solid #fff;\n      /* Visual */\n      font-weight: bold;\n      line-height: 32px;\n      color: #555; }\n    .presentation-selector .selector-header a:hover,\n    .presentation-selector .selector-header .active > a,\n    .presentation-selector .selector-header .active > a:hover,\n    .presentation-selector .selector-header .active > a:focus {\n      /* Display & Box Model */\n      border: 1px solid #e6e6e6;\n      /* Visual */\n      color: #0081BA;\n      background-color: #f2f2f2; }\n    .presentation-selector .selector-header .close-button {\n      float: right; }\n    .presentation-selector .selector-header .close {\n      line-height: 32px; }\n  .presentation-selector .search {\n    margin-bottom: 20px; }\n  .presentation-selector .panel-body, .presentation-selector .content-box-body {\n    clear: both; }\n\n.jumbo-card {\n  text-align: center;\n  background-color: transparent;\n  margin-bottom: 20px; }\n  .jumbo-card h1 {\n    font-size: 64px !important; }\n  .jumbo-card .main-link {\n    display: block;\n    color: #020621;\n    width: 50%;\n    height: 60px;\n    line-height: 60px;\n    font-size: 20px;\n    font-weight: bold;\n    cursor: pointer;\n    position: absolute;\n    top: -30px;\n    left: 25%;\n    background-color: #4ab767;\n    color: #fff;\n    border-radius: 6px;\n    box-shadow: inset 0 -4px 0 #42a65c; }\n    .jumbo-card .main-link:hover, .jumbo-card .main-link:active {\n      background-color: #3e9b56;\n      box-shadow: inset 0 -4px 0 #388c4e; }\n    .jumbo-card .main-link:active {\n      box-shadow: none; }\n    @media (max-width: 480px) {\n      .jumbo-card .main-link {\n        width: 75%;\n        left: 12.5%; } }\n  .jumbo-card .body {\n    border-radius: 6px;\n    background-color: #282828;\n    margin-top: 120px;\n    position: relative; }\n    .jumbo-card .body .cover {\n      background-image: url(\"http://placehold.it/1200x400\");\n      background-size: cover;\n      background-position: center;\n      height: 160px;\n      width: 100%;\n      border-top-right-radius: 6px;\n      border-top-left-radius: 6px; }\n    .jumbo-card .body .details {\n      padding: 20px;\n      color: #fff; }\n    .jumbo-card .body .section-link {\n      margin-top: 20px;\n      font-weight: bold;\n      color: #fff;\n      padding: 20px;\n      text-align: center;\n      overflow: hidden;\n      min-height: 176px; }\n      .jumbo-card .body .section-link svg {\n        width: 100%;\n        max-width: 64px; }\n      .jumbo-card .body .section-link:not(:last-of-type) {\n        border-right: 1px solid #454545; }\n      @media (max-width: 992px) {\n        .jumbo-card .body .section-link:not(:last-of-type) {\n          border: none; } }\n\nul.tree,\nul.tree ul {\n  margin: 0;\n  padding: 0; }\n\nul.tree ul {\n  margin-left: 10px;\n  /* indentation */\n  position: relative; }\n\nul.tree ul:before {\n  content: \"\";\n  display: block;\n  width: 0;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  border-left: 1px solid #d4d4d4; }\n\nul.tree li {\n  margin: 0;\n  padding: 0 15px;\n  /* indentation + 2 */\n  line-height: 30px;\n  /* default list item `line-height` */\n  position: relative; }\n  ul.tree li a {\n    color: #444;\n    font-weight: 600;\n    padding: 4px;\n    border-radius: 2px; }\n    ul.tree li a .fa:before {\n      color: #d4d4d4;\n      margin-right: 5px;\n      font-size: 24px;\n      vertical-align: middle; }\n    ul.tree li a:hover {\n      background: #dcf1e2; }\n\nul.tree ul li:before {\n  content: \"\";\n  display: block;\n  width: 10px;\n  /* same with indentation */\n  height: 0;\n  border-top: 1px solid #d4d4d4;\n  position: absolute;\n  top: 15px;\n  left: 0; }\n\nul.tree ul li:last-child:before {\n  background: white;\n  /* same with body background */\n  height: auto;\n  top: 15px;\n  /* (line-height/2) */\n  bottom: 0; }\n\n.folder-tabs {\n  margin-bottom: 10px;\n  font-size: 16px;\n  border-bottom: 1px solid #d4d4d4; }\n  .folder-tabs li {\n    float: left;\n    width: 33.3%;\n    text-align: center; }\n    .folder-tabs li a {\n      border-bottom: 4px solid #FFF; }\n    .folder-tabs li:hover a {\n      border: none;\n      background: none; }\n    .folder-tabs li.active a {\n      border: none;\n      border-bottom: 4px solid #4ab767;\n      color: #444;\n      font-weight: 600; }\n\n.slider-handle {\n  background: #4ab767; }\n\n.slider.slider-vertical .slider-handle.triangle {\n  border-left-color: #4ab767; }\n\n.slider.slider-horizontal .slider-handle.triangle {\n  border-bottom-color: #4ab767; }\n\n.store-status-2 {\n  display: inline-block;\n  border-radius: 3px;\n  background: #FFF;\n  padding: 0;\n  height: 24px; }\n  .store-status-2 .btn, .store-status-2 .icon-nav label, .icon-nav .store-status-2 label {\n    margin: 0;\n    vertical-align: top;\n    height: 24px; }\n  .store-status-2 h3 {\n    margin: 0;\n    padding: 0 8px;\n    font-size: 13px;\n    line-height: 23px;\n    font-weight: normal;\n    vertical-align: top;\n    display: inline-block;\n    color: #555; }\n    .store-status-2 h3 .fa:before {\n      color: #4ab767; }\n    .store-status-2 h3.warning .fa:before {\n      color: #e6bf00; }\n    .store-status-2 h3.expired .fa:before {\n      color: #e6e6e6; }\n    .store-status-2 h3 a {\n      color: #4ab767;\n      font-weight: bold;\n      margin-left: 3px; }\n\n.input-url-addon {\n  display: table-cell;\n  vertical-align: middle;\n  width: 1%;\n  padding: 0 0 0 12px; }\n\n.label-tag {\n  background: #f2f2f2;\n  color: #777;\n  white-space: normal;\n  font-size: 14px;\n  display: inline-block;\n  border: 1px solid #e6e6e6;\n  padding: 2px 5px 2px 5px;\n  line-height: 20px;\n  text-align: left;\n  cursor: pointer;\n  font-weight: 500; }\n  .label-tag:hover {\n    color: #555; }\n  .label-tag .tag-name, .label-tag .tag-value {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top; }\n  .label-tag .tag-name {\n    max-width: 80px;\n    display: inline-block;\n    padding: 0; }\n    .label-tag .tag-name::before {\n      content: ':';\n      float: right;\n      font-weight: bold;\n      font-size: 13px;\n      margin-left: 2px; }\n  .label-tag .tag-value {\n    max-width: 120px;\n    display: inline-block;\n    padding: 0;\n    font-weight: bold;\n    color: #4d4d4d; }\n  @media (max-width: 480px) {\n    .label-tag {\n      font-size: 13px; }\n      .label-tag .tag-name::before {\n        line-height: 18px; } }\n  .label-tag.invalid {\n    background-color: #f2dede;\n    border-color: #ebccd1; }\n\n.tag-selector {\n  padding: 5px;\n  margin-bottom: 10px; }\n  .tag-selector .scrollable-content {\n    white-space: normal; }\n    .tag-selector .scrollable-content .label-tag {\n      display: inline-block;\n      margin-top: 5px;\n      margin-right: 5px; }\n\n.btn-remove {\n  color: #555;\n  padding: 0; }\n\n.content-box-editable {\n  min-height: 34px;\n  padding: 0;\n  position: relative;\n  border: 1px solid #ccc;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .content-box-editable .input-group > .input-group-addon {\n    height: 32px; }\n  .content-box-editable > .edit-icon {\n    position: absolute;\n    top: 6px;\n    right: 8px; }\n  .content-box-editable .label-tag {\n    margin-top: 3px;\n    margin-left: 3px; }\n  .content-box-editable .text-muted, .content-box-editable .text-placeholder {\n    line-height: 24px;\n    margin: 4px 0 0 0;\n    padding: 0 12px;\n    color: #777777;\n    -webkit-font-smoothing: subpixel-antialiased; }\n\n.content-box-filters {\n  background: #fcfcfc;\n  padding: 10px 10px 5px;\n  margin-top: 5px; }\n\n.select-tags {\n  padding: 3px; }\n  .select-tags .label {\n    margin-right: 3px;\n    margin-top: 3px; }\n\n.content-box-disabled {\n  pointer-events: none !important;\n  background: #e6e6e6 !important; }\n\n.timeline .control-label {\n  font-weight: 500; }\n\n.timeline .dropdown-menu {\n  padding: 5px; }\n  .timeline .dropdown-menu li {\n    overflow: hidden;\n    padding: 5px !important; }\n    .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .icon-nav label, .icon-nav .timeline .dropdown-menu li label {\n      margin: 0; }\n  .timeline .dropdown-menu * {\n    outline: 0; }\n    .timeline .dropdown-menu *:focus {\n      outline: 0; }\n  .timeline .dropdown-menu table {\n    border-collapse: separate;\n    border-spacing: 1px; }\n    .timeline .dropdown-menu table thead tr:last-child th {\n      font-weight: 400;\n      padding: 5px 0; }\n    .timeline .dropdown-menu table tbody .btn, .timeline .dropdown-menu table tbody .icon-nav label, .icon-nav .timeline .dropdown-menu table tbody label {\n      border: none;\n      border-radius: 0; }\n\n.recurrence-option .form-control {\n  margin: 0 5px;\n  display: inline-block; }\n\n.recurrence-option .control-label {\n  display: inline-block; }\n\n.recurrence-option fieldset {\n  display: inline-block; }\n\n.recurrence-option select {\n  width: 90px;\n  display: inline-block; }\n\n.recurrence-option .input-short {\n  width: 40px; }\n\n.recurrence-option .text-danger {\n  margin-top: 15px; }\n\n.recurrence-option .timelineWeekdays .control-label {\n  display: block; }\n\n.time-picker .btn-link {\n  padding: 0;\n  line-height: 12px;\n  font-size: 12px; }\n  .time-picker .btn-link span {\n    line-height: normal; }\n\n.time-picker .form-control {\n  margin: 0; }\n\n.time-picker .btn, .time-picker .icon-nav label, .icon-nav .time-picker label {\n  margin-left: 5px; }\n\n.colorpicker-swatch {\n  border: 1px solid #CCC;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 3px;\n  background: url(\"http://192.254.220.36/~rvi/mockups/images/mini-pattern.png\"); }\n\n.colorpicker-swatch span {\n  height: 22px;\n  width: 42px;\n  display: block; }\n\n.btn-colorpicker {\n  padding: 4px 12px 4px 4px; }\n\n.filters {\n  margin-top: 20px;\n  margin-right: 20px;\n  text-align: center; }\n  .filters .btn-default, .filters .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .filters .btn, .filters .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .filters label, .filters .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .filters label {\n    width: 140px !important;\n    margin-top: 7px;\n    border: 0;\n    border-bottom: 3px solid #eaeaea;\n    border-radius: 0;\n    background-color: #FCFCFC;\n    float: none; }\n  .filters .btn-default.active, .filters .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .filters .active.btn, .filters .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav .filters label.active, .filters .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li .filters label.active {\n    color: #3b9351;\n    border-bottom: 3px solid #52cc70;\n    background-color: #FCFCFC;\n    box-shadow: none; }\n  .filters .btn-default:active, .filters .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .filters .btn:active, .filters .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav .filters label:active, .filters .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li .filters label:active,\n  .filters .btn-default:focus,\n  .filters .timeline .dropdown-menu li .btn:focus, .timeline .dropdown-menu li\n  .filters .btn:focus,\n  .filters .timeline .dropdown-menu li .icon-nav label:focus, .timeline .dropdown-menu li .icon-nav\n  .filters label:focus,\n  .filters .icon-nav .timeline .dropdown-menu li label:focus, .icon-nav .timeline .dropdown-menu li\n  .filters label:focus {\n    outline: 0;\n    box-shadow: none; }\n  .filters .btn-default:hover, .filters .timeline .dropdown-menu li .btn:hover, .timeline .dropdown-menu li .filters .btn:hover, .filters .timeline .dropdown-menu li .icon-nav label:hover, .timeline .dropdown-menu li .icon-nav .filters label:hover, .filters .icon-nav .timeline .dropdown-menu li label:hover, .icon-nav .timeline .dropdown-menu li .filters label:hover {\n    background-color: #eee; }\n  .filters.container {\n    text-align: center;\n    padding-left: 0;\n    margin-bottom: 8px;\n    width: 1157px; }\n\n.mobile-filters {\n  display: none; }\n  .mobile-filters .btn, .mobile-filters .icon-nav label, .icon-nav .mobile-filters label {\n    width: 100% !important;\n    margin-top: 10px; }\n\n.store-selector .btn-default, .store-selector .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .store-selector .btn, .store-selector .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .store-selector label, .store-selector .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .store-selector label {\n  width: 100% !important;\n  padding: 20px 0; }\n\n.store-selector .btn-default:active, .store-selector .timeline .dropdown-menu li .btn:active, .timeline .dropdown-menu li .store-selector .btn:active, .store-selector .timeline .dropdown-menu li .icon-nav label:active, .timeline .dropdown-menu li .icon-nav .store-selector label:active, .store-selector .icon-nav .timeline .dropdown-menu li label:active, .icon-nav .timeline .dropdown-menu li .store-selector label:active {\n  box-shadow: none; }\n\n.store-selector .btn-default.active, .store-selector .timeline .dropdown-menu li .active.btn, .timeline .dropdown-menu li .store-selector .active.btn, .store-selector .timeline .dropdown-menu li .icon-nav label.active, .timeline .dropdown-menu li .icon-nav .store-selector label.active, .store-selector .icon-nav .timeline .dropdown-menu li label.active, .icon-nav .timeline .dropdown-menu li .store-selector label.active {\n  color: #3b9351;\n  border: 1px solid #52cc70;\n  box-shadow: none; }\n\n.store-selector .btn-default.active span::before, .store-selector .timeline .dropdown-menu li .active.btn span::before, .timeline .dropdown-menu li .store-selector .active.btn span::before, .store-selector .timeline .dropdown-menu li .icon-nav label.active span::before, .timeline .dropdown-menu li .icon-nav .store-selector label.active span::before, .store-selector .icon-nav .timeline .dropdown-menu li label.active span::before, .icon-nav .timeline .dropdown-menu li .store-selector label.active span::before {\n  width: 20px;\n  height: 20px;\n  margin-right: 6px;\n  content: '✔';\n  background: url(\"\") no-repeat; }\n\n/*MOBILE BREAKPOINTS */\n@media screen and (max-width: 768px) {\n  .filters {\n    display: none; }\n  .mobile-filters {\n    display: block; } }\n\n/*LINE BREAK FIX*/\n@media only screen and (min-width: 768px) and (max-width: 1200px) {\n  .filters .btn-default, .filters .timeline .dropdown-menu li .btn, .timeline .dropdown-menu li .filters .btn, .filters .timeline .dropdown-menu li .icon-nav label, .timeline .dropdown-menu li .icon-nav .filters label, .filters .icon-nav .timeline .dropdown-menu li label, .icon-nav .timeline .dropdown-menu li .filters label {\n    width: 118px !important;\n    padding: 6px 0; } }\n\n/*EXPANDED THE PRODUCT CONTAINER ON TABLET AND BELOW */\n@media only screen and (max-width: 768px) {\n  .product-container {\n    width: 100%; } }\n\n.subscription-status {\n  font-size: 15px;\n  width: 100%;\n  margin-bottom: 11px;\n  padding: 6px 7px;\n  text-align: center; }\n  .subscription-status > span {\n    position: relative;\n    top: 2px; }\n  .subscription-status .btn span, .subscription-status .icon-nav label span, .icon-nav .subscription-status label span {\n    position: relative;\n    top: 0; }\n  .subscription-status.trial {\n    color: green;\n    border: 1px solid #4ab767;\n    background: white; }\n    .subscription-status.trial .btn-white {\n      margin-left: 12px; }\n  .subscription-status.cancelled, .subscription-status.expired, .subscription-status.suspended {\n    color: #d20606;\n    border: 1px solid #d20606;\n    background: white; }\n    .subscription-status.cancelled .btn-white, .subscription-status.expired .btn-white, .subscription-status.suspended .btn-white {\n      margin-left: 12px;\n      color: #d20606;\n      background-color: #fff; }\n\n.file-selector .subscription-status {\n  text-align: left; }\n  .file-selector .subscription-status.trial, .file-selector .subscription-status.cancelled, .file-selector .subscription-status.expired, .file-selector .subscription-status.suspended {\n    border: none; }\n\n.file-selector .clear-selection span {\n  position: absolute;\n  top: 8px;\n  right: 13px;\n  z-index: 3;\n  cursor: pointer;\n  width: 17px;\n  text-align: center;\n  display: block;\n  height: 17px; }\n\n.pt-media-list li {\n  height: 107px;\n  width: 107px;\n  display: inline-block;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  margin-left: 4px;\n  border: 1px solid #ddd;\n  -o-transition: border .2s ease-out;\n  -ms-transition: border .2s ease-out;\n  -moz-transition: border .2s ease-out;\n  -webkit-transition: border .2s ease-out;\n  transition: border .2s ease-out; }\n\n.selected-border {\n  border: 5px solid #4ab767 !important; }\n\n.no-select {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -ms-user-select: none; }\n\n.pt-media-list img {\n  width: 100%;\n  height: 100%; }\n\n.pt-media-list img.disabled {\n  opacity: .4;\n  -webkit-filter: grayscale(1);\n  filter: grayscale(1);\n  cursor: not-allowed; }\n\n.pt-media-list li:hover {\n  border-color: #4ab767; }\n\n.pt-media-list li .checkbox {\n  position: absolute;\n  top: 6px;\n  left: 10px;\n  margin-right: 10px;\n  color: #d4d4d4;\n  font-size: 16px;\n  width: 16px;\n  vertical-align: middle;\n  text-align: center;\n  font-family: FontAwesome;\n  cursor: pointer; }\n\n.pt-media-list li span {\n  position: absolute;\n  bottom: 6px;\n  left: 50%; }\n\n.pt-media-list li.folder,\n.pt-media-list li.placeholder-item {\n  background-color: #fff; }\n\n.pt-media-list li.folder {\n  cursor: pointer; }\n\n.pt-media-list li.folder-extended {\n  width: 329px; }\n  .pt-media-list li.folder-extended span.image-folder-info {\n    top: 21px !important; }\n\n.pt-media-list li.folder img {\n  width: 98px;\n  height: 98px;\n  float: left; }\n\n.pt-media-list li.folder span,\n.pt-media-list li.disabled-item span,\n.pt-media-list li.single-item span,\n.pt-media-list li.placeholder-item span {\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  width: 91px;\n  text-align: center;\n  line-height: 15px;\n  font-size: 14px; }\n  .pt-media-list li.folder span:first-child,\n  .pt-media-list li.disabled-item span:first-child,\n  .pt-media-list li.single-item span:first-child,\n  .pt-media-list li.placeholder-item span:first-child {\n    white-space: pre-wrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    height: 33px;\n    border: 1px solid red; }\n  .pt-media-list li.folder span.ellipsis, .pt-media-list li.folder .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder span, .pt-media-list li.folder span.placeholder-item-name, .pt-media-list li.folder .display-name span, .display-name .pt-media-list li.folder span, .pt-media-list li.folder .display-address span, .display-address .pt-media-list li.folder span, .pt-media-list li.folder span.playlist-item-reference,\n  .pt-media-list li.disabled-item span.ellipsis,\n  .pt-media-list li.disabled-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name\n  .pt-media-list li.disabled-item span,\n  .pt-media-list li.disabled-item span.placeholder-item-name,\n  .pt-media-list li.disabled-item .display-name span, .display-name\n  .pt-media-list li.disabled-item span,\n  .pt-media-list li.disabled-item .display-address span, .display-address\n  .pt-media-list li.disabled-item span,\n  .pt-media-list li.disabled-item span.playlist-item-reference,\n  .pt-media-list li.single-item span.ellipsis,\n  .pt-media-list li.single-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name\n  .pt-media-list li.single-item span,\n  .pt-media-list li.single-item span.placeholder-item-name,\n  .pt-media-list li.single-item .display-name span, .display-name\n  .pt-media-list li.single-item span,\n  .pt-media-list li.single-item .display-address span, .display-address\n  .pt-media-list li.single-item span,\n  .pt-media-list li.single-item span.playlist-item-reference,\n  .pt-media-list li.placeholder-item span.ellipsis,\n  .pt-media-list li.placeholder-item .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name\n  .pt-media-list li.placeholder-item span,\n  .pt-media-list li.placeholder-item span.placeholder-item-name,\n  .pt-media-list li.placeholder-item .display-name span, .display-name\n  .pt-media-list li.placeholder-item span,\n  .pt-media-list li.placeholder-item .display-address span, .display-address\n  .pt-media-list li.placeholder-item span,\n  .pt-media-list li.placeholder-item span.playlist-item-reference {\n    width: 87%;\n    margin-left: 7px;\n    font-size: 11px; }\n\n.pt-media-list li.folder span.ellipsis, .pt-media-list li.folder .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder span, .pt-media-list li.folder span.placeholder-item-name, .pt-media-list li.folder .display-name span, .display-name .pt-media-list li.folder span, .pt-media-list li.folder .display-address span, .display-address .pt-media-list li.folder span, .pt-media-list li.folder span.playlist-item-reference {\n  font-size: 11px; }\n\n.pt-media-list li.folder-extended span.ellipsis, .pt-media-list li.folder-extended .editor-playlist .editor-playlist-item .playlist-item-name span, .editor-playlist .editor-playlist-item .playlist-item-name .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended span.placeholder-item-name, .pt-media-list li.folder-extended .display-name span, .display-name .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended .display-address span, .display-address .pt-media-list li.folder-extended span, .pt-media-list li.folder-extended span.playlist-item-reference {\n  width: 29%; }\n\n.pt-media-list li.folder span.image-folder-info {\n  position: absolute;\n  left: 105px;\n  top: 25px;\n  line-height: 13px;\n  font-size: 11px;\n  width: 170px; }\n\n.pt-media-list li.placeholder-item svg {\n  width: 38px;\n  height: 38px;\n  margin-top: 19px;\n  position: relative;\n  top: 6px; }\n  .pt-media-list li.placeholder-item svg path {\n    fill: #4ab767; }\n\n.pt-media-list li.disabled-item {\n  cursor: not-allowed; }\n  .pt-media-list li.disabled-item svg {\n    width: 38px;\n    height: 38px;\n    margin-top: 19px;\n    position: relative;\n    top: 6px; }\n  .pt-media-list li.disabled-item path {\n    fill: #ddd; }\n\n.pt-media-list li.folder svg {\n  width: 38px;\n  height: 38px;\n  margin-top: 19px;\n  position: relative;\n  top: 6px; }\n  .pt-media-list li.folder svg path {\n    fill: #4ab767; }\n\n.pt-media-list li.folder-extended svg {\n  float: left;\n  margin-left: 30px;\n  top: 3px; }\n\n.btn-upload {\n  background: #f2f2f2;\n  color: #555; }\n\n.btn-upload span {\n  display: block;\n  font-weight: 500;\n  font-size: 16px; }\n\n.btn-upload i {\n  margin-top: 20px;\n  font-size: 28px; }\n\n#storageSelectorModal .btn-group, .storage-app .btn-group {\n  display: inline; }\n\n.google-drive-picker {\n  display: inline-block; }\n  .google-drive-picker img {\n    height: 16px; }\n\n/* -- FLUID GRID STYLES -- */\n.template-grid {\n  padding: 15px 0px 5px 15px;\n  margin-bottom: 5px;\n  border: none;\n  max-height: calc(100vh - 320px); }\n\n.template-grid li {\n  display: inline-block;\n  box-shadow: 0 2px 5px 0 rgba(80, 80, 80, 0.1), 0 2px 10px 0 rgba(80, 80, 80, 0.1);\n  background: #eee;\n  margin-right: 22px;\n  width: 22.5%;\n  padding-top: calc(12.7% + 64px);\n  /* Used instead of height to give elements fluid, width-based height */\n  margin-bottom: 2.5%;\n  position: relative; }\n  .template-grid li > .template-image {\n    display: block;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    text-decoration: none !important; }\n  .template-grid li .show-details {\n    display: none;\n    font-family: FontAwesome;\n    width: 100%;\n    height: calc(100% - 64px);\n    position: absolute;\n    background: rgba(50, 50, 50, 0.8);\n    font-size: 24px;\n    color: #FFF;\n    font-weight: 800;\n    top: 0;\n    z-index: 1000; }\n    .template-grid li .show-details:before {\n      content: '\\f002';\n      display: block;\n      text-align: center;\n      color: #FFF;\n      line-height: 150px; }\n  .template-grid li:hover .show-details {\n    display: block; }\n\n.template-grid:after {\n  content: '';\n  display: inline-block;\n  width: 100%; }\n\n.template-grid .placeholder {\n  padding: 0; }\n\n/* 2 COL */\n@media (max-width: 996px) {\n  .template-grid li {\n    width: 48%;\n    padding-top: calc(26.4% + 64px);\n    margin-bottom: 4%;\n    margin-right: 5px; } }\n\n/* SINGLE COL */\n@media (max-width: 768px) {\n  .template-grid li {\n    width: 100%;\n    padding-top: calc(55.2% + 64px);\n    margin-bottom: 5%;\n    margin-right: 0; } }\n\n.blank-template .template-image {\n  color: #999; }\n\n.blank-template a {\n  color: #4ab767; }\n\n.blank-template p {\n  text-align: center;\n  height: 100%;\n  padding-top: 26%;\n  background: #FFF;\n  font-size: 24px; }\n  .blank-template p span {\n    display: block; }\n\n.blank-template:hover:before {\n  display: none !important; }\n\n.template-info {\n  background: #FFF;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 15px;\n  color: #555;\n  text-align: left; }\n  .template-info h3 {\n    margin: 0 0 8px;\n    font-size: 14px;\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .template-info p {\n    margin: 0;\n    font-size: 12px;\n    color: #999;\n    line-height: 10px; }\n\n.suggest-template {\n  text-align: left; }\n  .suggest-template .template-image {\n    padding: 0 20px;\n    display: block;\n    background: #4ab767;\n    color: #FFF; }\n    .suggest-template .template-image a {\n      color: #FFF; }\n  .suggest-template h3 {\n    margin: 0 0 5px 0;\n    padding-top: 26%;\n    color: #FFF;\n    font-size: 21px; }\n  .suggest-template p {\n    margin: 0; }\n  .suggest-template:hover:before {\n    display: none !important; }\n\n.template-pricing {\n  color: #666;\n  line-height: 30px;\n  margin-bottom: 10px;\n  font-size: 16px; }\n  .template-pricing span {\n    display: inline-block;\n    vertical-align: bottom;\n    font-size: 32px;\n    font-weight: 800;\n    color: #222;\n    margin-right: 4px; }\n\n#intercom-launcher {\n  list-style: none;\n  position: fixed;\n  z-index: 1;\n  right: 0;\n  top: 130px;\n  width: 134px;\n  padding: 8px 5px;\n  border: 3px solid #fff;\n  border-right: none;\n  -moz-border-radius: 10px 0 0 10px;\n  -webkit-border-radius: 10px 0 0 10px;\n  border-radius: 10px 0 0 10px;\n  -moz-box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);\n  -webkit-box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);\n  cursor: pointer; }\n\n#intercom-container .intercom-launcher-button {\n  position: absolute !important;\n  bottom: 7px !important;\n  right: 10px !important;\n  background-color: #79807B !important;\n  border: none !important;\n  box-shadow: none !important;\n  float: right !important; }\n\n#intercom-container .intercom-launcher {\n  position: fixed;\n  bottom: 0 !important;\n  right: 0 !important;\n  background: #79807B !important;\n  top: 40% !important;\n  color: white !important;\n  width: 60px !important;\n  height: 45px !important; }\n\n#intercom-container .intercom-launcher-preview {\n  position: absolute;\n  bottom: 0;\n  right: 67px;\n  max-width: 205px;\n  padding: 10px;\n  color: white;\n  border-radius: 0;\n  background: none;\n  cursor: pointer;\n  width: 205px; }\n\n#intercom-container .intercom-launcher-badge {\n  top: 4px !important;\n  right: 3px !important; }\n\n#intercom-container .intercom-launcher-inactive.intercom-launcher-maximized {\n  opacity: 1 !important;\n  visibility: visible !important; }\n\n#intercom-container .intercom-launcher-inactive {\n  visibility: hidden !important; }\n\n#intercom-container .intercom-launcher-preview:after {\n  background-color: #79807B; }\n\n#intercom-container .intercom-launcher-preview {\n  box-shadow: none; }\n\n#intercom-container .intercom-launcher-preview .intercom-comment-body {\n  line-height: 16px; }\n\n#intercom-container .intercom-launcher-preview {\n  position: absolute;\n  bottom: 2px;\n  right: 60px;\n  max-width: 240px;\n  padding: 8px;\n  color: white;\n  border-radius: 0;\n  background: none;\n  cursor: pointer; }\n\n.editor-playlist .editor-playlist-item {\n  box-shadow: 0 2px 2px rgba(40, 40, 40, 0.1); }\n  .editor-playlist .editor-playlist-item .playlist-item-name span {\n    max-width: 100px; }\n\n.btn-group-justified a span {\n  font-size: 13px;\n  display: block;\n  text-align: center;\n  line-height: 15px; }\n\n.btn-group-justified a svg {\n  height: 33px;\n  width: 30px;\n  margin-right: 2px; }\n  .btn-group-justified a svg path {\n    fill: #333; }\n\n.playlist-item-thumbnail {\n  overflow: hidden;\n  height: 44px;\n  width: 44px;\n  border: 1px solid #bcbcbc;\n  border-radius: 4px;\n  float: left;\n  margin-right: 10px; }\n\n.playlist-item-thumbnail img {\n  width: 100%; }\n\n.playlist-item-duration {\n  color: green; }\n\n.name-container {\n  margin-top: 6px;\n  height: 45px;\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center; }\n  .name-container span {\n    vertical-align: middle; }\n  .name-container p:first-child {\n    cursor: pointer; }\n    .name-container p:first-child span:first-child {\n      width: 16px;\n      height: 16px;\n      display: inline-block; }\n    .name-container p:first-child span:last-child {\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      width: 125px;\n      display: inline-block;\n      line-height: 16px; }\n  .name-container p:last-child {\n    position: relative;\n    top: -7px; }\n  .name-container svg path {\n    fill: #0081BA; }\n  .name-container p span {\n    color: #0081BA; }\n    .name-container p span:hover {\n      text-decoration: underline; }\n\n.ph-playlist {\n  margin-top: 10px; }\n  .ph-playlist .editor-playlist {\n    height: calc(100vh - 360px);\n    max-height: calc(100vh - 250px); }\n    .ph-playlist .editor-playlist .editor-playlist-item {\n      padding: 3px !important; }\n\n.cta-tooltip .tooltip-inner {\n  color: #4ab767;\n  background: #fff;\n  padding: 9px;\n  border: 1px solid #4ab767;\n  font-weight: bold; }\n\n.cta-tooltip .tooltip-arrow {\n  border-bottom-color: #4ab767 !important; }\n\n/* Sections/Views\n   ========================================================================== */\n/* ==========================================================================\n   Widgets\n   ========================================================================== */\n/* Legacy, supporting old widgets */\n.widget-overlay {\n  /* Positioning */\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  /* Visual */\n  background: rgba(255, 255, 255, 0.7); }\n\n/* Legacy, supporting old widgets */\n.widget-wrapper {\n  /* Positioning */\n  z-index: 2;\n  /* Display & Box Model */\n  height: 90%;\n  padding-bottom: 100px;\n  margin: 40px auto 0;\n  overflow: auto; }\n  .widget-wrapper > .modal-header {\n    padding-left: 0;\n    padding-right: 0; }\n\n/* Widget Settings */\n/* Size for Storage Icon */\n.storage-selector-icon {\n  height: 14px; }\n\n/* Storage Input Field*/\n.clear-file:not(:first-child):not(:last-child) {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-left: none; }\n\n.preview-file {\n  padding: 0;\n  padding-left: 10px;\n  background: transparent;\n  border: none; }\n\n/* Storage Subscription Status */\n.storage-status {\n  text-align: left;\n  border: none !important;\n  background-color: transparent !important; }\n\n.widget {\n  height: 100%; }\n  .widget .overlay {\n    /* Positioning */\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    opacity: 0; }\n  .widget .settings {\n    /* Positioning */\n    position: relative;\n    /* Display & Box Model */\n    height: 100%; }\n  .widget .settings-center {\n    /* Positioning */\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    /* Display & Box Model */\n    width: 100%;\n    max-height: 90%;\n    overflow: auto;\n    margin: auto;\n    padding: 15px; }\n  .widget .wrapper {\n    /* Positioning */\n    z-index: 1000;\n    /* Display & Box Model */\n    height: 99%;\n    padding-bottom: 25px;\n    margin: 0 auto;\n    overflow: auto; }\n    .widget .wrapper > .modal-header {\n      padding-left: 0;\n      padding-right: 0; }\n  .widget .section {\n    /* Display & Box Model */\n    padding: 10px;\n    margin-bottom: 30px;\n    /* Visual */\n    border: 1px solid #DDDDDD;\n    border-radius: 6px; }\n    .widget .section > h5:first-of-type {\n      margin-top: -17px;\n      color: #0081BA; }\n\n.date-range * {\n  display: inline-block;\n  margin-right: 4px; }\n\n.date-range .form-control {\n  width: 80px; }\n\n.storage-modal {\n  /* ==========================================================================\n     Buttons\n     ========================================================================== */\n  /* ==========================================================================\n     Uploader\n     ========================================================================== */\n  /* ==========================================================================\n  Thumbnail View\n  ========================================================================== */\n  /**\n   * Single-column layout at mobile resolutions.\n   */\n  /* Clearfix */\n  /* Media queries\n  ========================================================================== */\n  /**\n   * Three-column layout at tablet resolutions.\n   */\n  /**\n   * Six-column layout at desktop resolutions.\n   */ }\n  .storage-modal .scrollable-list, .storage-modal .template-grid {\n    max-height: calc(100vh - 140px); }\n  .storage-modal .selector-header {\n    margin-bottom: 10px;\n    margin-top: 15px;\n    overflow: hidden; }\n    .storage-modal .selector-header p {\n      line-height: 16px;\n      margin: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      display: inline-block;\n      vertical-align: middle; }\n      .storage-modal .selector-header p:first-child {\n        display: block; }\n  .storage-modal .commands {\n    position: relative; }\n  .storage-modal .storage-used-info {\n    font-size: 10px;\n    text-align: right;\n    float: right; }\n  .storage-modal .current-folder-icon .fa::before {\n    color: #4ab767; }\n  .storage-modal #store-modal .overlay {\n    z-index: 2;\n    background-color: #ffffff; }\n  .storage-modal .inline-progress {\n    margin-bottom: 0px; }\n  .storage-modal .inline-cancel {\n    float: right;\n    width: auto;\n    padding-left: 10px;\n    text-align: center;\n    cursor: pointer; }\n  .storage-modal tbody tr:first-child td {\n    border-top: none; }\n  .storage-modal .panel table, .storage-modal .content-box table, .storage-modal .select-subcompany-modal .list-group table, .select-subcompany-modal .storage-modal .list-group table, .storage-modal .content-box-editable table, .storage-modal .card table, .storage-modal #appLauncherContainer .scrollable-list table, #appLauncherContainer .storage-modal .scrollable-list table, .storage-modal #appLauncherContainer .template-grid table, #appLauncherContainer .storage-modal .template-grid table {\n    margin-bottom: 0px !important; }\n  .storage-modal .panel-heading {\n    cursor: pointer; }\n  .storage-modal .thumbnails {\n    display: none;\n    cursor: pointer; }\n  .storage-modal .thumbnails:after {\n    clear: both;\n    display: block;\n    content: \"\"; }\n  .storage-modal .thumbnail {\n    border: none; }\n  .storage-modal .thumbnail .caption {\n    font-size: 12px;\n    text-align: center;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .storage-modal .thumbnail:hover, .storage-modal .thumbnail.active {\n    background-color: #f5f5f5; }\n  .storage-modal .thumbnail.active:hover {\n    background-color: #e8e8e8; }\n  @media (min-width: 768px) {\n    .storage-modal .thumbnail {\n      /* Positioning */\n      float: left;\n      /* Display & Box Model */\n      width: 33.33333%;\n      padding-left: 5px;\n      padding-right: 5px; }\n    .storage-modal .thumbnail:nth-child(3n+1) {\n      clear: left; } }\n  @media (min-width: 992px) {\n    .storage-modal .thumbnail {\n      width: 16.66667%; }\n    .storage-modal .thumbnail:nth-child(3n+1) {\n      clear: none; }\n    .storage-modal .thumbnail:nth-child(6n) {\n      padding-right: 0; }\n    .storage-modal .thumbnail:nth-child(6n+1) {\n      /* Positioning */\n      clear: left;\n      /* Display & Box Model */\n      padding-left: 0; } }\n  .storage-modal .current-folder {\n    line-height: 43px; }\n  .storage-modal .form-group {\n    margin-bottom: 10px; }\n  .storage-modal .non-clickable-file {\n    cursor: default;\n    text-decoration: none; }\n\ntr.blocked-file {\n  position: relative; }\n  tr.blocked-file > td {\n    background: #f7f7f7;\n    cursor: pointer;\n    position: relative; }\n    tr.blocked-file > td .callout {\n      top: 35px;\n      left: 10px; }\n\n.storage-selector-backdrop {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: #e7e7e7;\n  opacity: 0.9; }\n\n.storage-selector-iframe {\n  width: 90%;\n  height: 500px;\n  position: absolute;\n  top: 20%;\n  left: 5%;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.5);\n  border-style: ridge;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 5px;\n  background-color: #f4f4f4; }\n\n.storage-selector-iframe-full {\n  width: 100%;\n  max-height: 100%;\n  position: absolute;\n  border: 0px;\n  padding: 0px 0px 50px;\n  margin-top: 0;\n  overflow: auto; }\n  @media (max-width: 768px) {\n    .storage-selector-iframe-full {\n      position: relative;\n      padding: 0px; } }\n\n.table.filetable td, .filetable.table-2 td {\n  max-width: 200px;\n  /* Customise it accordingly */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n  color: #888; }\n\n.table.filetable .check-col, .filetable.table-2 .check-col, .table-2 .check-col {\n  width: 30px; }\n\n.table.filetable .type-col, .filetable.table-2 .type-col, .table-2 .type-col {\n  width: 130px; }\n\n.table.filetable .filesize-col, .filetable.table-2 .filesize-col, .table-2 .filesize-col {\n  width: 130px; }\n\n.table.filetable .datemod-col, .filetable.table-2 .datemod-col, .table-2 .datemod-col {\n  width: 180px; }\n\n.table.filetable input, .filetable.table-2 input {\n  margin: 0; }\n\n.table.filetable .copy-url, .filetable.table-2 .copy-url {\n  width: 1px; }\n  .table.filetable .copy-url .btn-link, .filetable.table-2 .copy-url .btn-link {\n    padding: 0;\n    font-size: 16px; }\n\n.table.filetable .file-name a, .filetable.table-2 .file-name a {\n  color: #444; }\n  .table.filetable .file-name a .fa::before, .filetable.table-2 .file-name a .fa::before {\n    margin-right: 5px;\n    font-size: 20px;\n    vertical-align: middle;\n    color: #d4d4d4; }\n\n.table.filetable .file-name.folder-type a .fa-folder::before, .filetable.table-2 .file-name.folder-type a .fa-folder::before {\n  color: #4ab767; }\n\n.support-app {\n  /* Ticket List Table (desktop) */\n  /* Media Style Ticket List (mobile) */\n  /* Ticket Details View */\n  /* Comments */\n  /* Post Comment Box */\n  /* Tickets Table Stack View */ }\n  .support-app .support-time {\n    border-top-right-radius: 0px;\n    border-top-left-radius: 0px;\n    border-top-width: 0px;\n    margin-top: -20px;\n    margin-bottom: 40px;\n    text-align: center;\n    color: #555; }\n    .support-app .support-time.alert-warning {\n      border-color: #FAEBCC; }\n    .support-app .support-time.alert-success {\n      border-color: #D6E9C6; }\n    .support-app .support-time .text-danger {\n      color: #c0392b; }\n    .support-app .support-time .divider {\n      margin: 0 5px; }\n  .support-app h2 {\n    margin-top: 0px !important; }\n  .support-app .ticket-description {\n    white-space: pre-line;\n    line-height: 20px; }\n  .support-app .ticket-attachments {\n    margin: 20px 0;\n    line-height: 20px; }\n    .support-app .ticket-attachments a {\n      display: block; }\n  .support-app .ticket-list-table {\n    background-color: #fff;\n    border-radius: 3px;\n    border: 1px solid #ccc;\n    font-weight: bold;\n    margin-bottom: 40px; }\n    .support-app .ticket-list-table .no-tickets {\n      min-height: 200px;\n      text-align: center;\n      line-height: 200px;\n      color: #aaa; }\n    .support-app .ticket-list-table .text-muted {\n      color: #aaa; }\n    .support-app .ticket-list-table .text-success {\n      color: #4ab767; }\n    .support-app .ticket-list-table .text-primary {\n      color: #5bc0de; }\n    .support-app .ticket-list-table .text-danger {\n      color: #c0392b; }\n    .support-app .ticket-list-table .text-warning {\n      color: #f0ad4e; }\n    .support-app .ticket-list-table .title-row {\n      font-size: 12px;\n      margin: 0;\n      border-bottom: 1px solid #ccc;\n      padding: 0;\n      line-height: 40px;\n      font-weight: bold;\n      cursor: pointer;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none; }\n    .support-app .ticket-list-table .ticket {\n      margin: 0;\n      line-height: 66px; }\n      .support-app .ticket-list-table .ticket a {\n        color: #020621; }\n      .support-app .ticket-list-table .ticket:not(:last-child) {\n        border-bottom: 1px solid #eee; }\n      .support-app .ticket-list-table .ticket * {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis; }\n  .support-app .ticket-list-mobile {\n    background-color: #fff;\n    border-radius: 3px;\n    border: 1px solid #ccc;\n    padding: 0 10px; }\n    .support-app .ticket-list-mobile .ticket.media {\n      margin-top: 0;\n      color: #333;\n      cursor: pointer; }\n    .support-app .ticket-list-mobile .ticket .label {\n      width: 60px; }\n    .support-app .ticket-list-mobile .ticket h5 {\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      padding-right: 40px; }\n    .support-app .ticket-list-mobile .ticket .ticket-item {\n      padding: 15px 0; }\n    .support-app .ticket-list-mobile .ticket:not(:last-child) .ticket-item {\n      border-bottom: 1px solid #ccc; }\n  .support-app .ticket {\n    margin-bottom: 40px;\n    width: 100%;\n    height: 66px;\n    position: relative; }\n    .support-app .ticket .status-tag {\n      width: 64px;\n      height: 64px;\n      border-radius: 50%;\n      line-height: 64px;\n      text-align: center;\n      color: #fff;\n      font-weight: bold;\n      margin-right: 10px;\n      background-color: #888; }\n      .support-app .ticket .status-tag.solved {\n        background-color: #5CB85C; }\n      .support-app .ticket .status-tag.open {\n        background-color: #D9534F; }\n      .support-app .ticket .status-tag.pending {\n        background-color: #5BC0DE; }\n      .support-app .ticket .status-tag.new {\n        background-color: #f0ad4e; }\n    .support-app .ticket .ticket-heading h4 {\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      display: block;\n      margin: 0;\n      line-height: 64px;\n      height: 64px; }\n      .support-app .ticket .ticket-heading h4 .ticket-id {\n        margin-right: 4px; }\n      .support-app .ticket .ticket-heading h4 small {\n        display: block; }\n    .support-app .ticket .meta {\n      height: 64px;\n      width: 64px;\n      text-align: right;\n      line-height: 64px; }\n  .support-app .panel-footer {\n    padding: 0;\n    border-top: none; }\n    .support-app .panel-footer .ticket-attachments {\n      margin: 0;\n      padding: 10px;\n      border-top: 1px solid #ddd; }\n  .support-app .panel-body, .support-app .content-box-body {\n    background-color: #eee;\n    border-radius: 4px; }\n    .support-app .panel-body p, .support-app .content-box-body p {\n      margin-bottom: 0; }\n  .support-app .panel-body.rise-vision-support, .support-app .rise-vision-support.content-box-body {\n    background-color: #FFF; }\n  .support-app .chat-head {\n    width: 32px;\n    height: 32px; }\n  .support-app .comments-list {\n    margin-bottom: 200px; }\n    .support-app .comments-list h4 {\n      margin-bottom: 30px; }\n  .support-app .comment {\n    margin-bottom: 10px; }\n  .support-app .comment .user {\n    margin-bottom: 5px; }\n  .support-app .comment-box {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    /* Set the fixed height of the footer here */\n    background-color: #fff; }\n  .support-app .comment-box .ticket-button .dropdown-toggle {\n    color: #FFF;\n    background-color: #45B864;\n    border-color: #3c9f57;\n    border-radius: 0px; }\n  @media (max-width: 768px) {\n    .support-app .table-stack > tbody > tr {\n      display: block;\n      position: relative; }\n    .support-app .table-stack > tbody > tr:hover > td:before {\n      color: #0081BA; }\n    .support-app .table-stack > tbody > tr > td {\n      padding: 5px 10px; }\n      .support-app .table-stack > tbody > tr > td.ticket-subject {\n        padding: 10px 80px 0 10px; }\n      .support-app .table-stack > tbody > tr > td.ticket-id {\n        display: none; }\n      .support-app .table-stack > tbody > tr > td.ticket-status {\n        text-align: right;\n        position: absolute;\n        width: 80px;\n        right: 0;\n        top: 5px; }\n      .support-app .table-stack > tbody > tr > td.ticket-requester {\n        margin-left: 0;\n        padding-left: 0; }\n        .support-app .table-stack > tbody > tr > td.ticket-requester:before {\n          content: attr(data-th) \" \";\n          float: left;\n          margin-right: 5px; }\n      .support-app .table-stack > tbody > tr > td.ticket-date {\n        width: auto;\n        padding-right: 5px; } }\n\n.alerts-app h2 {\n  margin-top: 0px !important; }\n\n.alerts-app .alerts-list {\n  color: #333;\n  margin-top: 0;\n  padding: 0 10px; }\n  .alerts-app .alerts-list:not(:last-child) {\n    border-bottom: 1px solid #e5e5e5; }\n  .alerts-app .alerts-list h5 {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    padding-right: 40px; }\n  .alerts-app .alerts-list .media-body {\n    padding: 15px 0; }\n\n.storage-full .table-2 .folder:before,\n.storage-full .table-2 .file:before,\n.storage-modal .table-2 .folder:before,\n.storage-modal .table-2 .file:before {\n  font-family: FontAwesome; }\n\n.storage-full .table-2 .back-btn .folder:before,\n.storage-modal .table-2 .back-btn .folder:before {\n  content: '\\f07c';\n  color: #4ab767; }\n\n.storage-full .table-2 .folder:before,\n.storage-modal .table-2 .folder:before {\n  content: '\\f07b';\n  color: #4ab767;\n  margin-right: 10px; }\n\n.storage-full .table-2 .file:before,\n.storage-modal .table-2 .file:before {\n  content: '\\f15b';\n  color: #d4d4d4; }\n\n.storage-full .table-2 .sub-folder,\n.storage-modal .table-2 .sub-folder {\n  margin-left: 22px;\n  position: relative; }\n  .storage-full .table-2 .sub-folder:after,\n  .storage-modal .table-2 .sub-folder:after {\n    content: '';\n    width: 15px;\n    height: 6px;\n    display: block;\n    position: absolute;\n    top: 4px;\n    left: -20px;\n    border-bottom: 1px solid #ccc;\n    border-left: 1px solid #ccc; }\n\n.storage-full .notifications,\n.storage-modal .notifications {\n  margin: 0px 5px; }\n\n.storage-full .toolbar,\n.storage-modal .toolbar {\n  margin: 10px 0; }\n\n.storage-full .rotating-text,\n.storage-modal .rotating-text {\n  color: #777;\n  margin-left: 5px; }\n\n.storage-full .scrollable-list, .storage-full .template-grid {\n  padding: 4px;\n  max-height: calc(100vh - 300px);\n  width: 100%; }\n\n#store-modal-frame {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%; }\n\n.paid-on-board {\n  text-align: center;\n  background-color: transparent; }\n  .paid-on-board h1 {\n    font-size: 64px !important; }\n  .paid-on-board .store-link {\n    display: block;\n    color: #020621;\n    width: 50%;\n    font-size: 20px;\n    cursor: pointer;\n    position: absolute;\n    top: -60px;\n    left: 25%; }\n    @media (max-width: 480px) {\n      .paid-on-board .store-link {\n        width: 75%;\n        left: 12.5%;\n        font-size: 12px;\n        top: -40px; } }\n    .paid-on-board .store-link .rate {\n      height: 60px;\n      line-height: 58px;\n      background-color: #fff;\n      border-top-right-radius: 6px;\n      border-top-left-radius: 6px;\n      border-top: 1px solid #ccc;\n      border-left: 1px solid #ccc;\n      border-right: 1px solid #ccc; }\n      @media (max-width: 480px) {\n        .paid-on-board .store-link .rate {\n          height: 40px;\n          line-height: 40px; } }\n    .paid-on-board .store-link .subscribe {\n      height: 60px;\n      line-height: 60px;\n      background-color: #4ab767;\n      color: #fff;\n      border-bottom-right-radius: 6px;\n      border-bottom-left-radius: 6px;\n      box-shadow: inset 0 -4px 0 #42a65c; }\n      @media (max-width: 480px) {\n        .paid-on-board .store-link .subscribe {\n          height: 40px;\n          line-height: 40px; } }\n  .paid-on-board .about {\n    border-radius: 6px;\n    background-color: #424242;\n    margin-top: 120px;\n    position: relative; }\n    .paid-on-board .about .cover {\n      background-image: url(\"/images/support-ob-bg.png\");\n      background-size: cover;\n      background-position: center;\n      height: 160px;\n      width: 100%;\n      border-top-right-radius: 6px;\n      border-top-left-radius: 6px; }\n    .paid-on-board .about .tab-buttons {\n      width: 50%;\n      margin: -20px auto 0 auto;\n      background-color: #fff;\n      line-height: 40px;\n      border-radius: 20px;\n      font-weight: bold;\n      color: #ccc; }\n      @media (max-width: 480px) {\n        .paid-on-board .about .tab-buttons {\n          font-size: 12px;\n          width: 75%; } }\n      .paid-on-board .about .tab-buttons .tab-title {\n        display: inline-block;\n        width: 50%;\n        text-align: center;\n        cursor: pointer; }\n        .paid-on-board .about .tab-buttons .tab-title:last-child {\n          border-left: 1px solid #ccc; }\n        .paid-on-board .about .tab-buttons .tab-title.active {\n          color: #020621; }\n    .paid-on-board .about .details {\n      padding: 40px;\n      color: #fff; }\n      .paid-on-board .about .details p {\n        margin-bottom: 30px; }\n        .paid-on-board .about .details p:last-child {\n          margin-bottom: 0px; }\n      .paid-on-board .about .details .more {\n        color: #4ab767;\n        font-weight: bold;\n        cursor: pointer; }\n\n.workspace {\n  -webkit-transition: all 0.2s;\n  /* Safari 3.1 to 6.0 */\n  transition: all 0.2s;\n  position: relative;\n  background: #d4d4d4; }\n  .workspace .workspace-toolbar {\n    width: calc(100% - 12px);\n    white-space: nowrap;\n    position: absolute;\n    z-index: 100;\n    background-color: rgba(255, 255, 255, 0.9);\n    border-bottom: 1px solid #f2f2f2;\n    border-top: 1px solid #f2f2f2;\n    padding: 8px 10px;\n    -webkit-transition: all .25s;\n    transition: all .25s; }\n    .workspace .workspace-toolbar #previewButton {\n      margin-left: 10px; }\n    .workspace .workspace-toolbar #addPlaceholderButton {\n      width: calc((290px - 20px));\n      margin-right: 10px; }\n    .workspace .workspace-toolbar > h4 {\n      position: absolute;\n      left: 14px;\n      top: -5px; }\n    .workspace .workspace-toolbar .presentation-name {\n      display: inline-block;\n      line-height: 32px;\n      font-size: 18px;\n      font-weight: 400;\n      vertical-align: top;\n      margin: 0;\n      max-width: calc(100% - 700px);\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n      @media (max-width: 768px) {\n        .workspace .workspace-toolbar .presentation-name {\n          max-width: 200px; } }\n    @media (max-width: 768px) {\n      .workspace .workspace-toolbar {\n        width: 100%;\n        overflow: hidden;\n        left: 0;\n        top: 0; } }\n    @media (max-width: 920px) {\n      .workspace .workspace-toolbar #addPlaceholderButton {\n        width: 100%;\n        display: block;\n        float: none;\n        margin: 8px 0; } }\n  .workspace .workspace-sidebar {\n    padding: 8px 0;\n    position: absolute;\n    top: 49px;\n    height: calc(100vh - 140px);\n    width: 290px;\n    overflow: hidden;\n    background-color: #f7f7f7;\n    -webkit-transition: all 0.5s;\n    /* Safari 3.1 to 6.0 */\n    transition: all 0.5s;\n    border-right: 1px solid #e6e6e6; }\n    .workspace .workspace-sidebar .scrollable-list, .workspace .workspace-sidebar .template-grid {\n      min-height: 45px;\n      max-height: calc(100vh - 150px);\n      font-size: 13px; }\n    .workspace .workspace-sidebar #listWithHandle.scrollable-list, .workspace .workspace-sidebar #listWithHandle.template-grid {\n      max-height: calc(100vh - 290px); }\n    .workspace .workspace-sidebar .editor-playlist {\n      border: none; }\n      .workspace .workspace-sidebar .editor-playlist .editor-playlist-item:last-child {\n        margin-bottom: 20px; }\n    @media (max-width: 992px) {\n      .workspace .workspace-sidebar {\n        height: calc(100vh - 185px); } }\n    @media (max-width: 768px) {\n      .workspace .workspace-sidebar {\n        width: 100%;\n        position: relative;\n        z-index: 80;\n        top: 133px; }\n        .workspace .workspace-sidebar .scrollable-list, .workspace .workspace-sidebar .template-grid {\n          max-height: calc(100vh - 420px); } }\n    .workspace .workspace-sidebar h4 {\n      line-height: 33px;\n      margin-bottom: 8px;\n      margin-top: 0; }\n    .workspace .workspace-sidebar .workspace-sidebar-content {\n      width: calc((290px * 2));\n      /* Total width of panels */ }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar .workspace-sidebar-content {\n          width: 100%; } }\n    .workspace .workspace-sidebar .table-playlist-items tbody > tr > td {\n      height: 56px; }\n    .workspace .workspace-sidebar .ph-list,\n    .workspace .workspace-sidebar .ph-properties {\n      width: 290px;\n      padding: 0 10px;\n      -webkit-transition: all 0.5s;\n      /* Safari 3.1 to 6.0 */\n      transition: all 0.5s; }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar .ph-list,\n        .workspace .workspace-sidebar .ph-properties {\n          width: 100vw; } }\n    .workspace .workspace-sidebar .ph-list .editor-playlist {\n      height: calc(100vh - 210px);\n      max-height: calc(100vh - 240px); }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar .ph-list .editor-playlist {\n          margin-right: 0;\n          max-height: calc(100vh - 300px); } }\n    @media (max-width: 768px) {\n      .workspace .workspace-sidebar .ph-settings .scrollable-list, .workspace .workspace-sidebar .ph-settings .template-grid {\n        max-height: calc(100vh - 350px) !important; } }\n    .workspace .workspace-sidebar .ph-properties {\n      float: right;\n      opacity: 0; }\n      .workspace .workspace-sidebar .ph-properties .scrollable-list, .workspace .workspace-sidebar .ph-properties .template-grid {\n        max-height: calc(100vh - 240px); }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar .ph-properties {\n          -webkit-transform: translateX(0);\n          /* Safari */\n          transform: translateX(0);\n          float: none;\n          display: none; }\n          .workspace .workspace-sidebar .ph-properties .scrollable-list, .workspace .workspace-sidebar .ph-properties .template-grid {\n            max-height: calc(100vh - 430px); } }\n    .workspace .workspace-sidebar.show-ph-properties .ph-list {\n      -webkit-transform: translateX(-290px);\n      /* Safari */\n      transform: translateX(-290px); }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar.show-ph-properties .ph-list {\n          -webkit-transform: translateX(0);\n          /* Safari */\n          transform: translateX(0);\n          display: none; } }\n    .workspace .workspace-sidebar.show-ph-properties .ph-properties {\n      opacity: 1;\n      -webkit-transform: translateX(-290px);\n      /* Safari */\n      transform: translateX(-290px); }\n      @media (max-width: 768px) {\n        .workspace .workspace-sidebar.show-ph-properties .ph-properties {\n          -webkit-transform: translateX(0);\n          /* Safari */\n          transform: translateX(0);\n          display: block; } }\n  .workspace .workspace-board {\n    background-color: #FFF;\n    overflow-x: scroll;\n    overflow-y: scroll;\n    height: calc(100vh - 105px);\n    position: relative;\n    z-index: 80;\n    margin-left: 290px;\n    -webkit-transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    /* Safari 3.1 to 6.0 */\n    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); }\n    @media (max-width: 992px) {\n      .workspace .workspace-board {\n        height: calc(100vh - 125px); } }\n    @media (max-width: 768px) {\n      .workspace .workspace-board {\n        position: absolute;\n        top: 55px;\n        left: 0;\n        margin-left: 0;\n        width: 100%;\n        z-index: 40; } }\n  .workspace.hide-sidebar .workspace-toolbar {\n    width: calc(100% - 11px);\n    left: 0;\n    padding-left: 11px; }\n  .workspace.hide-sidebar .workspace-sidebar {\n    -webkit-transform: translateX(-290px);\n    /* Safari */\n    transform: translateX(-290px); }\n  .workspace.hide-sidebar .workspace-board {\n    margin-left: 0; }\n  @media (max-width: 768px) {\n    .workspace.hide-sidebar .workspace-toolbar {\n      width: 100%; }\n    .workspace.hide-sidebar .workspace-sidebar {\n      -webkit-transform: translateX(-100%);\n      /* Safari */\n      transform: translateX(-100%); } }\n\n.active-banner-mode .workspace-board {\n  height: calc(100vh - 125px); }\n\n.active-banner-mode-double .workspace-board {\n  height: calc(100vh - 150px); }\n\n.placeholder-item-name {\n  width: 180px;\n  font-weight: 500;\n  line-height: 24px; }\n  .placeholder-item-name:hover {\n    color: #0081BA; }\n\n@media (max-width: 992px) {\n  .editor-footer .save-status {\n    display: block;\n    width: 100%; }\n  .editor-footer #deleteButton {\n    margin-top: 20px; } }\n\n@media (max-width: 768px) {\n  .editor-footer {\n    position: static;\n    bottom: -66px;\n    z-index: 100; } }\n\n.ph-block {\n  position: absolute;\n  border: 1px solid #fff;\n  cursor: pointer;\n  -webkit-box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0px 0px 56px 0px rgba(0, 0, 0, 0.15); }\n  .ph-block .icon-nav {\n    position: absolute;\n    top: 50%; }\n  .ph-block img {\n    width: 100%; }\n  .ph-block:before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 2px solid rgba(0, 0, 0, 0.5); }\n  .ph-block:after {\n    -webkit-transition: all 1s;\n    /* Safari 3.1 to 6.0 */\n    transition: all 1s;\n    background-color: rgba(20, 20, 20, 0.5);\n    content: 'Edit';\n    color: #FFF;\n    line-height: 40px;\n    text-align: center;\n    height: 40px;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    position: absolute;\n    opacity: 0; }\n  .ph-block:hover {\n    border-color: #4ab767; }\n    .ph-block:hover:after {\n      opacity: 1; }\n  .ph-block .ph-name {\n    position: absolute;\n    left: 3px;\n    top: 3px;\n    z-index: 9999;\n    line-height: 30px;\n    color: #FFF;\n    display: inline-block;\n    padding: 0 10px;\n    border-radius: 5px;\n    font-weight: 600;\n    background: rgba(50, 50, 50, 0.35);\n    text-shadow: -1px -1px 0 #555, 1px -1px 0 #555, -1px 1px 0 #555, 1px 1px 0 #555; }\n  .ph-block.edit-mode {\n    -webkit-box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65);\n    -moz-box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65);\n    box-shadow: 0px 0px 0px 10000px rgba(0, 0, 0, 0.65); }\n    .ph-block.edit-mode:after {\n      opacity: 1;\n      content: 'Editing'; }\n\n.cm-s-twilight.CodeMirror {\n  position: relative;\n  height: 100%;\n  padding-top: 50px; }\n\n.CodeMirror-hscrollbar::-webkit-scrollbar {\n  -webkit-appearance: none; }\n\n.CodeMirror-hscrollbar::-webkit-scrollbar:horizontal {\n  height: 11px; }\n\n.CodeMirror-hscrollbar::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 2px solid #555;\n  /* should match background, can't be transparent */\n  background-color: rgba(30, 30, 30, 0.8); }\n\n.CodeMirror-hscrollbar::-webkit-scrollbar-track {\n  background-color: #555;\n  border-radius: 2px; }\n\n.CodeMirror-vscrollbar::-webkit-scrollbar {\n  -webkit-appearance: none; }\n\n.CodeMirror-vscrollbar::-webkit-scrollbar:vertical {\n  width: 11px; }\n\n.CodeMirror-vscrollbar::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 2px solid #555;\n  /* should match background, can't be transparent */\n  background-color: rgba(30, 30, 30, 0.8); }\n\n.CodeMirror-vscrollbar::-webkit-scrollbar-track {\n  background-color: #555;\n  border-radius: 2px; }\n\n.ph-transform .input-group .form-control {\n  padding-left: 4px;\n  padding-right: 4px; }\n\n.ph-transform .input-group .input-group-addon {\n  padding: 0 4px;\n  font-size: 11px; }\n  .ph-transform .input-group .input-group-addon:first-child {\n    width: 50px; }\n  .ph-transform .input-group .input-group-addon:last-child {\n    font-size: 11px; }\n\n.editor-footer {\n  border-top: 1px solid #CCC;\n  position: relative;\n  background: #FFF; }\n  .editor-footer .footer-content {\n    padding: 8px 0; }\n  @media (max-width: 768px) {\n    .editor-footer {\n      z-index: 100; }\n      .editor-footer .footer-content .btn, .editor-footer .footer-content .icon-nav label, .icon-nav .editor-footer .footer-content label {\n        padding: 5px; }\n        .editor-footer .footer-content .btn .fa, .editor-footer .footer-content .icon-nav label .fa, .icon-nav .editor-footer .footer-content label .fa {\n          margin-left: 2px; } }\n\n.artboard-presentation {\n  position: absolute;\n  width: 80%; }\n  .artboard-presentation .n-resize {\n    position: absolute;\n    top: -3px;\n    left: 0px;\n    width: 100%;\n    height: 5px;\n    cursor: n-resize; }\n  .artboard-presentation .e-resize {\n    position: absolute;\n    top: 0px;\n    left: calc(100% - 2px);\n    width: 5px;\n    height: 100%;\n    cursor: w-resize; }\n  .artboard-presentation .s-resize {\n    position: absolute;\n    top: calc(100% - 2px);\n    left: 0px;\n    width: 100%;\n    height: 5px;\n    cursor: s-resize; }\n  .artboard-presentation .w-resize {\n    position: absolute;\n    top: 0px;\n    left: -3px;\n    width: 5px;\n    height: 100%;\n    cursor: e-resize; }\n  .artboard-presentation .nw-resize {\n    position: absolute;\n    top: -3px;\n    left: -3px;\n    width: 7px;\n    height: 7px;\n    cursor: nw-resize; }\n  .artboard-presentation .ne-resize {\n    position: absolute;\n    top: -3px;\n    left: calc(100% - 4px);\n    width: 7px;\n    height: 7px;\n    cursor: ne-resize; }\n  .artboard-presentation .se-resize {\n    position: absolute;\n    top: calc(100% - 4px);\n    left: calc(100% - 4px);\n    width: 7px;\n    height: 7px;\n    cursor: se-resize; }\n  .artboard-presentation .sw-resize {\n    position: absolute;\n    top: calc(100% - 4px);\n    left: -3px;\n    width: 7px;\n    height: 7px;\n    cursor: sw-resize; }\n\n.html-editor {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 80;\n  background: #FFF;\n  height: 100%;\n  width: 100%;\n  padding-top: 0px; }\n  .html-editor pre {\n    border: 0;\n    background: #222;\n    color: #4ab767;\n    margin: 0;\n    padding-top: 60px;\n    font-size: 14px;\n    -webkit-text-stroke: 0.25px; }\n\n.workspace-sidebar::-webkit-scrollbar,\n.workspace-board::-webkit-scrollbar {\n  -webkit-appearance: none; }\n\n.workspace-sidebar::-webkit-scrollbar:vertical,\n.workspace-board::-webkit-scrollbar:vertical {\n  width: 11px; }\n\n.workspace-sidebar::-webkit-scrollbar:horizontal,\n.workspace-board::-webkit-scrollbar:horizontal {\n  height: 11px; }\n\n.workspace-sidebar::-webkit-scrollbar-thumb,\n.workspace-board::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 2px solid #f2f2f2;\n  /* should match background, can't be transparent */\n  background-color: rgba(50, 50, 50, 0.5); }\n\n.workspace-sidebar::-webkit-scrollbar-track,\n.workspace-board::-webkit-scrollbar-track {\n  background-color: #e6e6e6;\n  border-radius: 2px; }\n\n#artboard {\n  -webkit-box-shadow: 0 0 0 10000px #d4d4d4;\n  -moz-box-shadow: 0 0 0 10000px #d4d4d4;\n  box-shadow: 0 0 0 10000px #d4d4d4;\n  border: 12px solid #d4d4d4;\n  border-top-width: 60px; }\n\n.active-banner {\n  padding-bottom: 0 !important; }\n\n.background-color-picker-input .dropdown-menu:before, .background-color-picker-input .dropdown-menu:after {\n  width: 10px !important; }\n\n.background-color-picker-input .close-colorpicker {\n  display: none !important; }\n\n.workspace-sidebar-content .image-placeholder {\n  width: auto;\n  height: 128px; }\n\n.ph-item-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.2); }\n  .ph-item-icon:before {\n    font-family: FontAwesome;\n    content: '\\f009';\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.4);\n    top: 50%;\n    left: 50%;\n    margin-left: -30px;\n    margin-top: -30px;\n    position: absolute;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    font-size: 30px;\n    color: rgba(255, 255, 255, 0.6); }\n  .ph-item-icon.ph-video-item:before {\n    content: '\\f03d'; }\n\n/* Display Settings\n   ========================================================================== */\n/* Display Status Circle\n   ========================================================================== */\n/* Deprecate\n +   ==========================================================================\n +   ==========================================================================\n +   ==========================================================================\n +   ==========================================================================\n +   ========================================================================== */\n.display-name span {\n  max-width: 240px;\n  display: inline-block;\n  vertical-align: middle; }\n\n.display-address span {\n  max-width: 320px;\n  display: inline-block;\n  vertical-align: middle; }\n\n.offline:before {\n  color: #e74c3c; }\n\n.notinstalled:before {\n  color: #444; }\n\n.online:before {\n  color: #4ab767; }\n\n/* ==========================================================================\n   Store Navigation\n   ========================================================================== */\n.scrollfix {\n  overflow-x: hidden;\n  height: 100%; }\n\n.navbar-store {\n  padding-top: 0;\n  padding-bottom: 0; }\n  .navbar-store .rise-logo {\n    margin-top: 5px; }\n  .navbar-store .navbar-left,\n  .navbar-store .navbar-right {\n    margin-top: 6px; }\n\n.inner-box {\n  position: relative;\n  border: 1px solid #ddd;\n  background: #fff;\n  border-radius: 5px;\n  padding: 22px; }\n  .inner-box.no-padding {\n    padding: 0; }\n\nbody.in-rva-iframe {\n  height: 100%;\n  overflow-x: hidden; }\n  body.in-rva-iframe .navbar-store .store-logo {\n    width: 50px;\n    margin-top: 2px;\n    float: left; }\n  body.in-rva-iframe .navbar-store h1 {\n    margin-top: 7px;\n    margin-left: 12px;\n    margin-bottom: 5px;\n    float: left;\n    color: #333;\n    font-size: 28px; }\n  body.in-rva-iframe .navbar-store .close-iframe {\n    margin: 3px 5px;\n    cursor: pointer; }\n\n.bottom-border {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ccc; }\n\n.print-only {\n  display: none; }\n\n.navbar-right > li > a.shopping-cart-button {\n  font-size: 24px;\n  display: block;\n  margin-left: 0; }\n  .navbar-right > li > a.shopping-cart-button .fa-shopping-cart {\n    line-height: 33px;\n    display: block;\n    padding: 0 10px; }\n\n/* ==========================================================================\n   Products\n   ========================================================================== */\n/* Search Products\n   ========================================================================== */\n.form-product-search {\n  margin-bottom: 0; }\n\n/* ==========================================================================\n   Product Details, Order\n   ========================================================================== */\n.product-info,\n.order-info,\n.subscription-info {\n  /* Display & Box Model */\n  padding: 20px;\n  border: solid 1px #ddd;\n  /* Visual */\n  background: #fff;\n  border-radius: 5px;\n  min-height: 400px;\n  position: relative; }\n  .product-info .info-row,\n  .order-info .info-row,\n  .subscription-info .info-row {\n    margin-top: 20px; }\n  .product-info h3.experimental,\n  .product-info h3.inactive,\n  .order-info h3.experimental,\n  .order-info h3.inactive,\n  .subscription-info h3.experimental,\n  .subscription-info h3.inactive {\n    color: red;\n    margin-bottom: 0px;\n    text-transform: uppercase; }\n  .product-info .qty-message,\n  .order-info .qty-message,\n  .subscription-info .qty-message {\n    font-style: italic; }\n  .product-info .text-red,\n  .order-info .text-red,\n  .subscription-info .text-red {\n    color: red; }\n\n.product-header {\n  margin-bottom: 10px; }\n\n.product-vendor {\n  font-weight: bold; }\n\n.product-trial {\n  color: #45b864; }\n\n.product-expired {\n  color: red; }\n\n.price-disabled {\n  color: #ccc; }\n\n/* Quantity */\n.product-qty li {\n  display: inline-block;\n  margin-right: 8px;\n  line-height: 28px;\n  vertical-align: top; }\n\n/* Cart buttons */\n.cart-buttons {\n  margin-top: 20px; }\n\n.cart-buttons .btn, .cart-buttons .icon-nav label, .icon-nav .cart-buttons label {\n  margin: 5px 0;\n  min-width: 160px; }\n\n.order-cancel-success {\n  font-weight: bold; }\n\n.hr-dashed {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-top: 2px dashed #cbcbcb; }\n\n/* Media queries\n   ========================================================================== */\n@media (min-width: 768px) {\n  .product-info {\n    padding: 40px; }\n  .cart-buttons li {\n    /* Positioning */\n    float: left;\n    /* Display & Box Model */\n    margin-left: 3%; }\n  .cart-buttons li:first-child {\n    margin-left: 0; } }\n\n/* ==========================================================================\n   Product Details\n   ========================================================================== */\n.product-details .grid-container {\n  max-width: 1004px;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 10px;\n  padding-left: 24px; }\n\n.product-details .grid-container:after {\n  display: table;\n  clear: both;\n  content: ''; }\n\n.product-details h3 {\n  margin: 22px 0 11px 0; }\n\n.product-details .product-name {\n  margin-top: 33px; }\n\n.product-details .purchase-form__button button.btn-primary {\n  width: 100%;\n  margin-bottom: 5px; }\n\n.product-details .purchase-form__button button.btn-default, .product-details .purchase-form__button .timeline .dropdown-menu li button.btn, .timeline .dropdown-menu li .product-details .purchase-form__button button.btn {\n  width: 100%;\n  margin-bottom: 5px; }\n\n.product-details .purchase-form__button button.btn-link {\n  font-size: 14px;\n  width: 100%;\n  margin-bottom: 5px; }\n\n.product-details .purchase-form__button button i {\n  margin-right: 5px; }\n\n.product-details .t-heading.-size-xxl {\n  font-size: 51px; }\n\n.product-details .meta-attributes {\n  color: #999; }\n\n.product-details .meta-attributes tr td {\n  font-size: 14px;\n  padding-bottom: 15px;\n  vertical-align: top; }\n\n.product-details .meta-attributes tr:last-child td {\n  padding-bottom: 0; }\n\n.product-details .meta-attributes a {\n  color: #2d60ad; }\n\n.product-details .meta-attributes a:hover {\n  color: #00719b; }\n\n.product-details .meta-attributes__attr-name {\n  font-weight: bold;\n  padding-right: 10px;\n  color: #444; }\n  .product-details .meta-attributes__attr-name a {\n    font-weight: normal; }\n\n.product-details .meta-attributes__attr-tags {\n  position: relative;\n  display: table-cell;\n  overflow: hidden;\n  max-width: 185px;\n  padding-right: 9px; }\n\n.product-details .meta-attributes__attr-tags:before {\n  position: absolute;\n  z-index: 10;\n  top: 1px;\n  right: 0;\n  width: 10%;\n  height: 100%;\n  content: '';\n  background: -webkit-gradient(linear, left top, right top, from(rgba(251, 251, 251, 0)), color-stop(90%, rgba(251, 251, 251, 0.8)), to(#fbfbfb));\n  background: -webkit-linear-gradient(left, rgba(251, 251, 251, 0), rgba(251, 251, 251, 0.8) 90%, #fbfbfb 100%);\n  background: linear-gradient(to right, rgba(251, 251, 251, 0), rgba(251, 251, 251, 0.8) 90%, #fbfbfb 100%); }\n\n.product-details .ie9 .meta-attributes__attr-tags {\n  white-space: normal; }\n\n.product-details .box {\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #e1e8ed;\n  background-color: #fbfbfb; }\n  .product-details .box.no-outline {\n    border: 0; }\n\n.product-details .t-body {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 1em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.product-details .t-price {\n  font-weight: bold;\n  line-height: 1;\n  display: inline-block;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.product-details .t-price::first-letter {\n  font-size: .7em;\n  font-weight: normal;\n  line-height: 1.25em;\n  margin-right: .05em;\n  vertical-align: top; }\n\n@-moz-document url-prefix() {\n  .product-details .t-price::first-letter {\n    float: left; } }\n\n.product-details .t-currency {\n  font-size: 12px;\n  position: relative;\n  top: -27px;\n  left: -8px; }\n\n.product-details .t-unit {\n  font-size: 14px;\n  color: #333; }\n\n@media screen and (max-width: 660px) {\n  .product-details .mobile-filters {\n    position: relative;\n    top: 20px; }\n    .product-details .mobile-filters button i {\n      margin-right: 5px; } }\n\n.owl-item a img {\n  width: 94% !important;\n  height: 332px !important; }\n\n/*\n *  Core Owl Carousel CSS File\n *  v1.3.3\n */\n.owl-carousel {\n  position: relative;\n  display: none;\n  width: 100%; }\n  .owl-carousel .owl-wrapper {\n    position: relative;\n    display: none; }\n    .owl-carousel .owl-wrapper:after {\n      line-height: 0;\n      display: block;\n      visibility: hidden;\n      clear: both;\n      height: 0;\n      content: '.'; }\n  .owl-carousel .owl-wrapper-outer {\n    position: relative;\n    overflow: hidden;\n    width: 94%; }\n    .owl-carousel .owl-wrapper-outer.autoHeight {\n      transition: height 500ms ease-in-out; }\n  .owl-carousel .owl-item {\n    float: left; }\n\n.owl-controls {\n  user-select: none; }\n  .owl-controls .owl-page {\n    cursor: pointer; }\n  .owl-controls .owl-buttons div {\n    cursor: pointer; }\n\n/* fix */\n.owl-carousel .owl-wrapper,\n.owl-carousel .owl-item {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -ms-backface-visibility: hidden; }\n\n/*\n*   Owl Theming\n*/\n.wrapper-with-margin {\n  margin: 0 50px; }\n\n.owl-theme .owl-controls {\n  margin-top: 10px;\n  text-align: center; }\n  .owl-theme .owl-controls .owl-buttons div {\n    font-size: 27px;\n    font-weight: bold;\n    position: absolute;\n    display: inline-block;\n    zoom: 1;\n    margin: -2px;\n    padding: 41px 8px 50px 7px;\n    transition: .5s;\n    opacity: .3;\n    border: 1px solid #f4f4f4;\n    border-radius: 3px;\n    filter: Alpha(Opacity=30); }\n    .owl-theme .owl-controls .owl-buttons div .fa::before {\n      opacity: .6;\n      color: black;\n      filter: Alpha(Opacity=60); }\n    .owl-theme .owl-controls .owl-buttons div:hover {\n      opacity: .6;\n      border: 1px solid #4ab767;\n      filter: Alpha(Opacity=60); }\n  .owl-theme .owl-controls .owl-buttons .owl-prev {\n    top: 111px;\n    left: -37px; }\n  .owl-theme .owl-controls .owl-buttons .owl-next {\n    top: 111px;\n    right: 0; }\n  .owl-theme .owl-controls.clickable .owl-buttons div:hover {\n    text-decoration: none;\n    opacity: 1;\n    filter: Alpha(Opacity=100); }\n  .owl-theme .owl-controls.clickable .owl-page:hover span {\n    opacity: 1;\n    filter: Alpha(Opacity=100); }\n  .owl-theme .owl-controls .owl-page {\n    display: inline-block;\n    zoom: 1;\n    *display: inline; }\n    .owl-theme .owl-controls .owl-page span {\n      display: block;\n      width: 12px;\n      height: 12px;\n      margin: 5px 7px;\n      opacity: .5;\n      border-radius: 20px;\n      background: #869791;\n      filter: Alpha(Opacity=50); }\n      .owl-theme .owl-controls .owl-page span.owl-numbers {\n        font-size: 12px;\n        width: auto;\n        height: auto;\n        padding: 2px 10px;\n        color: white;\n        border-radius: 30px; }\n    .owl-theme .owl-controls .owl-page.active span {\n      opacity: 1;\n      filter: Alpha(Opacity=100); }\n\n.owl-item.loading {\n  min-height: 150px;\n  background: url(AjaxLoader.gif) no-repeat center center; }\n\n#product-slideshow .owl-item {\n  height: 332px !important; }\n  #product-slideshow .owl-item > div {\n    font-size: 32px;\n    margin: 3px;\n    padding: 50px 0;\n    text-align: center;\n    color: white;\n    border: 1px white;\n    background: #42bdc2; }\n    #product-slideshow .owl-item > div img {\n      display: block;\n      width: 100%;\n      height: auto;\n      margin-bottom: 4px;\n      border-radius: 3px; }\n\n@media only screen and (max-width: 624px) {\n  .owl-theme .owl-controls .owl-buttons .owl-next {\n    right: -13px; } }\n\n/*\n* Magnific Popup CSS\n*/\nbutton.mfp-close, button.mfp-arrow {\n  z-index: 1046;\n  display: block;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  border: 0;\n  outline: none;\n  background: transparent;\n  box-shadow: none; }\n\n.mfp-image-holder .mfp-close, .mfp-iframe-holder .mfp-close {\n  right: -6px;\n  width: 100%;\n  padding-right: 6px;\n  text-align: right;\n  color: white; }\n\n.mfp-arrow:before, .mfp-arrow:after, .mfp-arrow .mfp-b, .mfp-arrow .mfp-a {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 0;\n  height: 0;\n  margin-top: 35px;\n  margin-left: 35px;\n  content: '';\n  border: medium inset transparent; }\n\n.mfp-arrow:after, .mfp-arrow .mfp-a {\n  top: 8px;\n  border-top-width: 13px;\n  border-bottom-width: 13px; }\n\n.mfp-arrow:before, .mfp-arrow .mfp-b {\n  opacity: .7;\n  border-top-width: 21px;\n  border-bottom-width: 21px; }\n\n.mfp-bg {\n  position: fixed;\n  z-index: 1042;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  opacity: .8;\n  background: #0b0b0b;\n  filter: alpha(opacity=80); }\n\n.mfp-wrap {\n  position: fixed;\n  z-index: 1043;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  outline: none !important; }\n\n.mfp-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 0 8px;\n  text-align: center; }\n  .mfp-container:before {\n    display: inline-block;\n    height: 100%;\n    content: '';\n    vertical-align: middle; }\n\n.mfp-content {\n  position: relative;\n  z-index: 1045;\n  display: inline-block;\n  margin: 0 auto;\n  text-align: left;\n  vertical-align: middle; }\n\n.mfp-ajax-cur {\n  cursor: progress; }\n\n.mfp-zoom-out-cur {\n  cursor: zoom-out; }\n  .mfp-zoom-out-cur .mfp-image-holder .mfp-close {\n    cursor: zoom-out; }\n\n.mfp-zoom {\n  cursor: pointer;\n  cursor: zoom-in; }\n\n.mfp-close {\n  font-family: Arial, Baskerville, monospace;\n  font-size: 28px;\n  font-style: normal;\n  line-height: 44px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 44px;\n  height: 44px;\n  padding: 0 0 18px 10px;\n  user-select: none;\n  text-align: center;\n  text-decoration: none;\n  opacity: .65;\n  color: white;\n  filter: alpha(opacity=65); }\n  .mfp-close:hover {\n    opacity: 1;\n    filter: alpha(opacity=100); }\n  .mfp-close:focus {\n    opacity: 1;\n    filter: alpha(opacity=100); }\n  .mfp-close:active {\n    top: 1px; }\n\n.mfp-arrow {\n  user-select: none;\n  position: absolute;\n  opacity: 0.65;\n  filter: alpha(opacity=65);\n  margin: 0;\n  top: 50%;\n  margin-top: -55px;\n  padding: 0;\n  width: 90px;\n  height: 110px; }\n  .mfp-arrow:active {\n    margin-top: -54px; }\n  .mfp-arrow:hover {\n    opacity: 1;\n    filter: alpha(opacity=100); }\n  .mfp-arrow:focus {\n    opacity: 1;\n    filter: alpha(opacity=100); }\n\n.mfp-preloader {\n  user-select: none;\n  color: #ccc;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  text-align: center;\n  margin-top: -0.8em;\n  left: 8px;\n  right: 8px;\n  z-index: 1044; }\n  .mfp-preloader a {\n    color: #ccc; }\n    .mfp-preloader a:hover {\n      color: white; }\n\n.mfp-counter {\n  user-select: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #ccc;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap; }\n\n.mfp-hide {\n  display: none !important; }\n\nbutton::-moz-focus-inner {\n  padding: 0;\n  border: 0; }\n\n.mfp-image-holder .mfp-content {\n  max-width: 100%; }\n\n.mfp-iframe-holder {\n  padding-top: 40px;\n  padding-bottom: 40px; }\n  .mfp-iframe-holder .mfp-close {\n    top: -40px; }\n  .mfp-iframe-holder .mfp-content {\n    line-height: 0;\n    width: 100%;\n    max-width: 900px; }\n\n.mfp-arrow-left {\n  left: 0; }\n  .mfp-arrow-left:after {\n    border-right: 17px solid white;\n    margin-left: 31px; }\n  .mfp-arrow-left .mfp-a {\n    border-right: 17px solid white;\n    margin-left: 31px; }\n  .mfp-arrow-left:before {\n    margin-left: 25px;\n    border-right: 27px solid #3f3f3f; }\n  .mfp-arrow-left .mfp-b {\n    margin-left: 25px;\n    border-right: 27px solid #3f3f3f; }\n\n.mfp-arrow-right {\n  right: 0; }\n  .mfp-arrow-right:after {\n    border-left: 17px solid white;\n    margin-left: 39px; }\n  .mfp-arrow-right .mfp-a {\n    border-left: 17px solid white;\n    margin-left: 39px; }\n  .mfp-arrow-right:before {\n    border-left: 27px solid #3f3f3f; }\n  .mfp-arrow-right .mfp-b {\n    border-left: 27px solid #3f3f3f; }\n\n.mfp-iframe-scaler {\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  padding-top: 56.25%; }\n  .mfp-iframe-scaler iframe {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: black; }\n\n.mfp-figure {\n  line-height: 0; }\n  .mfp-figure:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 40px;\n    bottom: 40px;\n    display: block;\n    right: 0;\n    width: auto;\n    height: auto;\n    z-index: -1;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #444; }\n  .mfp-figure small {\n    color: #bdbdbd;\n    display: block;\n    font-size: 12px;\n    line-height: 14px; }\n  .mfp-figure figure {\n    margin: 0; }\n\n.mfp-bottom-bar {\n  margin-top: -36px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  cursor: auto; }\n\n.mfp-title {\n  text-align: left;\n  line-height: 18px;\n  color: #f3f3f3;\n  word-wrap: break-word;\n  padding-right: 36px; }\n\n@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {\n  .mfp-img-mobile .mfp-image-holder {\n    padding-left: 0;\n    padding-right: 0; }\n  .mfp-img-mobile .mfp-figure:after {\n    top: 0;\n    bottom: 0; }\n  .mfp-img-mobile .mfp-figure small {\n    display: inline;\n    margin-left: 5px; }\n  .mfp-img-mobile .mfp-bottom-bar {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 0;\n    margin: 0;\n    top: auto;\n    padding: 3px 5px;\n    position: fixed;\n    box-sizing: border-box; }\n    .mfp-img-mobile .mfp-bottom-bar:empty {\n      padding: 0; }\n  .mfp-img-mobile .mfp-counter {\n    right: 5px;\n    top: 3px; }\n  .mfp-img-mobile .mfp-close {\n    top: 0;\n    right: 0;\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    background: rgba(0, 0, 0, 0.6);\n    position: fixed;\n    text-align: center;\n    padding: 0; }\n  .mfp-img-mobile img.mfp-img {\n    padding: 0; } }\n\n@media all and (max-width: 900px) {\n  .mfp-arrow {\n    transform: scale(0.75); }\n  .mfp-arrow-left {\n    transform-origin: 0; }\n  .mfp-arrow-right {\n    transform-origin: 100%; }\n  .mfp-container {\n    padding-left: 6px;\n    padding-right: 6px; } }\n\n.mfp-ie7 .mfp-img {\n  padding: 0; }\n\n.mfp-ie7 .mfp-bottom-bar {\n  width: 600px;\n  left: 50%;\n  margin-left: -300px;\n  margin-top: 5px;\n  padding-bottom: 5px; }\n\n.mfp-ie7 .mfp-container {\n  padding: 0; }\n\n.mfp-ie7 .mfp-content {\n  padding-top: 44px; }\n\n.mfp-ie7 .mfp-close {\n  top: 0;\n  right: 0;\n  padding-top: 0; }\n\n.mfp-align-top .mfp-container:before {\n  display: none; }\n\n.mfp-inline-holder .mfp-content {\n  width: 100%;\n  cursor: auto; }\n\n.mfp-ajax-holder .mfp-content {\n  width: 100%;\n  cursor: auto; }\n\n.mfp-auto-cursor .mfp-content {\n  cursor: auto; }\n\n.mfp-loading.mfp-figure {\n  display: none; }\n\n.mfp-s-ready .mfp-preloader {\n  display: none; }\n\n.mfp-s-error .mfp-content {\n  display: none; }\n\n.mfp-close-btn-in .mfp-close {\n  color: white; }\n\nimg.mfp-img {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  line-height: 0;\n  box-sizing: border-box;\n  padding: 40px 0;\n  margin: 0 auto; }\n\n.mfp-gallery .mfp-image-holder .mfp-figure {\n  cursor: pointer; }\n\n/*CUSTOM*/\na.mfp-iframe:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 94%;\n  height: 100%;\n  content: '';\n  cursor: pointer;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.2) url(../img/play.svg) no-repeat 54% center;\n  background-size: 40%; }\n\na.mfp-iframe:hover:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 94%;\n  height: 100%;\n  content: '';\n  cursor: pointer;\n  -webkit-animation: zoomIn .4s;\n  -moz-animation: zoomIn .4s;\n  -ms-animation: zoomIn .4s;\n  -o-animation: zoomIn .4s;\n  animation: zoomIn .4s;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.2) url(../img/play.svg) no-repeat 54% center;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards; }\n\n@-webkit-keyframes zoomIn {\n  from {\n    background-size: 40%; }\n  to {\n    background-size: 60%; } }\n\n@-moz-keyframes zoomIn {\n  from {\n    background-size: 40%; }\n  to {\n    background-size: 60%; } }\n\n@-ms-keyframes zoomIn {\n  from {\n    background-size: 40%; }\n  to {\n    background-size: 60%; } }\n\n@-o-keyframes zoomIn {\n  from {\n    background-size: 40%; }\n  to {\n    background-size: 60%; } }\n\n@keyframes zoomIn {\n  from {\n    background-size: 40%; }\n  to {\n    background-size: 60%; } }\n\n/* NailThumb Plugin\n *\n */\n.nailthumb-container {\n  width: auto;\n  height: auto;\n  margin: 0 0 11px;\n  padding: 0px;\n  overflow: hidden;\n  position: relative;\n  text-align: left; }\n\n.nailthumb-container img.nailthumb-image {\n  margin: 0px;\n  padding: 0px;\n  max-width: none;\n  text-align: left;\n  float: left; }\n\n.nailthumb-container span.nailthumb-title {\n  background: none repeat scroll 0 0 rgba(0, 0, 0, 0.5);\n  bottom: 0;\n  color: White;\n  display: block;\n  font-size: 9px;\n  height: 20px;\n  left: 0;\n  margin-top: 2px;\n  line-height: 20px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n  float: left; }\n\n.nailthumb-container span.nailthumb-title .nailthumb-title-scroller {\n  padding-left: 2px; }\n\n.nailthumb-container img {\n  max-width: none;\n  text-align: left; }\n\n@media only screen and (max-width: 992px) {\n  .nailthumb-image {\n    width: 670px !important; } }\n\n@media only screen and (max-width: 768px) {\n  .nailthumb-image {\n    width: 621px !important;\n    height: 416px !important; } }\n\n@media only screen and (max-width: 468px) {\n  .nailthumb-image {\n    width: 294px !important;\n    height: 343px !important; } }\n\n/* ==========================================================================\n   Shopping Cart\n   ========================================================================== */\n/* Bill To & Ship To\n   ========================================================================== */\n.shopping-cart .bill-to,\n.shopping-cart .ship-to {\n  margin-top: 6px;\n  margin-bottom: 0; }\n\n.shopping-cart .cart-empty,\n.shopping-cart .payment-confirmed {\n  margin-top: 6px; }\n\n.shopping-cart .cart-empty-content,\n.shopping-cart .payment-confirmed-content {\n  border-top: 1px solid #CCCCCC;\n  padding: 20px 0px 10px 0px; }\n\n.shopping-cart .address-icons {\n  margin-bottom: 0;\n  margin-top: 4px; }\n  .shopping-cart .address-icons li {\n    /* Positioning */\n    float: left;\n    /* Display & Box Model */\n    margin-left: 5px;\n    margin-top: 1px; }\n    .shopping-cart .address-icons li span {\n      position: relative;\n      top: -3px;\n      margin: 0px 10px; }\n\n.shopping-cart .address {\n  padding: 10px 17px;\n  border-top: 1px solid #cbcbcb;\n  margin-top: 5px;\n  margin-bottom: 3px; }\n\n.shopping-cart .row.title, .shopping-cart .support-app .ticket-list-table .title.title-row, .support-app .ticket-list-table .shopping-cart .title.title-row, .shopping-cart .support-app .ticket-list-table .title.ticket, .support-app .ticket-list-table .shopping-cart .title.ticket {\n  padding: 0 17px; }\n\n.shopping-cart .title {\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.shopping-cart .terms {\n  font-size: 90%; }\n\n.shopping-cart .alert, .shopping-cart .support-app .support-time, .support-app .shopping-cart .support-time {\n  margin: 0;\n  padding: 10px 17px;\n  border-radius: 0;\n  cursor: pointer; }\n\n.shopping-cart .alert.ship-to-restriction, .shopping-cart .support-app .ship-to-restriction.support-time, .support-app .shopping-cart .ship-to-restriction.support-time {\n  margin-top: 0px; }\n  .shopping-cart .alert.ship-to-restriction h5, .shopping-cart .support-app .ship-to-restriction.support-time h5, .support-app .shopping-cart .ship-to-restriction.support-time h5 {\n    margin-top: 0; }\n\n.shopping-cart .subscriptions .btn, .shopping-cart .subscriptions .icon-nav label, .icon-nav .shopping-cart .subscriptions label,\n.shopping-cart .purchases .buttons .btn,\n.shopping-cart .purchases .buttons .icon-nav label, .icon-nav\n.shopping-cart .purchases .buttons label {\n  width: 204px;\n  margin-top: 4px; }\n\n/* Purchases\n   ========================================================================== */\n.product-qty {\n  margin-bottom: 0; }\n\n.subtotals {\n  margin-bottom: 0; }\n  .subtotals tbody tr td {\n    text-align: right; }\n\n.order-total {\n  /* Display & Box Model */\n  display: block;\n  /* Visual */\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 35px;\n  text-align: right; }\n\n.order-currency {\n  /* Display & Box Model */\n  display: block;\n  /* Visual */\n  font-size: 14px;\n  text-align: right; }\n\n/* ==========================================================================\n   Account\n   ========================================================================== */\n.account .title {\n  margin-top: 6px;\n  margin-bottom: 0; }\n\n.account .date {\n  /* Display & Box Model */\n  margin-top: 6px;\n  /* Visual */\n  font-size: 16px;\n  font-style: italic; }\n\n/* ==========================================================================\n   Subscription Confirmation & Purchase Invoice\n   ========================================================================== */\n.subscription-confirmation .header,\n.purchase-invoice .header {\n  margin-bottom: 20px; }\n\n.subscription-confirmation .header-details,\n.purchase-invoice .header-details {\n  margin-top: 20px;\n  text-align: right; }\n\n.subscription-confirmation .title,\n.purchase-invoice .title {\n  font-weight: bold;\n  font-size: 18px; }\n\n.subscription-confirmation .bill-to,\n.subscription-confirmation .ship-to,\n.purchase-invoice .bill-to,\n.purchase-invoice .ship-to {\n  /* Display & Box Model */\n  margin-top: 20px;\n  /* Visual */\n  font-weight: bold; }\n\n.subscription-confirmation .company-address,\n.purchase-invoice .company-address {\n  text-align: center;\n  font-style: italic;\n  font-size: 85%; }\n\n.purchase-invoice .paid,\n.purchase-invoice .overdue,\n.purchase-invoice .status,\n.purchase-invoice .total {\n  font-size: 18px;\n  font-weight: bold; }\n\n.purchase-invoice .paid {\n  color: #4ab767; }\n\n.purchase-invoice .overdue {\n  color: red; }\n\n.purchase-invoice .display-name {\n  padding-left: 10px;\n  font-style: italic; }\n\n.purchase-invoice .product-name {\n  padding-left: 25px; }\n\n.purchase-invoice table.invoice-due-summary {\n  width: 100%;\n  text-align: right; }\n  .purchase-invoice table.invoice-due-summary td {\n    width: 50%; }\n  .purchase-invoice table.invoice-due-summary .currency-code {\n    text-transform: uppercase; }\n  .purchase-invoice table.invoice-due-summary .paid-with-label,\n  .purchase-invoice table.invoice-due-summary .paid-with,\n  .purchase-invoice table.invoice-due-summary .currency-code-label,\n  .purchase-invoice table.invoice-due-summary .currency-code {\n    font-style: italic; }\n\n/* Media queries\n   ========================================================================== */\n@media (min-width: 768px) {\n  .subscription-confirmation,\n  .purchase-invoice {\n    padding-left: 100px;\n    padding-right: 100px; }\n    .subscription-confirmation .header-details,\n    .purchase-invoice .header-details {\n      /* Display & Box Model */\n      margin-top: 0; } }\n\n/* ==========================================================================\n   Address Editor Modal\n   ========================================================================== */\n.address-editor div.checkbox.persist-changes {\n  float: left; }\n\n.address-editor td.addr-label {\n  max-width: 33%;\n  text-align: right;\n  padding-left: 10px; }\n\n.address-editor td.addr-value {\n  padding-left: 10px;\n  font-weight: bold; }\n\n.address-editor p.validation-notice {\n  font-size: 13px;\n  color: #094F76;\n  line-height: 14px; }\n\n.address-editor .alert-info .form-group {\n  margin-bottom: 0; }\n\n.address-editor .alert-info + .row, .address-editor .support-app .ticket-list-table .alert-info + .title-row, .support-app .ticket-list-table .address-editor .alert-info + .title-row, .address-editor .support-app .ticket-list-table .alert-info + .ticket, .support-app .ticket-list-table .address-editor .alert-info + .ticket {\n  margin-right: 5px; }\n\n/* ==========================================================================\n   Custom Classes\n   ========================================================================== */\n.payment-modal-form {\n  min-height: 400px; }\n\n.clear-both {\n  clear: both; }\n\n.checkbox.checkbox-label-left input[type=checkbox] {\n  position: relative;\n  margin-left: 0; }\n\n.checkbox.checkbox-label-left label {\n  padding-left: 0; }\n\n.required-asterisk {\n  color: red; }\n\n.btn.btn-form-control, .icon-nav label.btn-form-control {\n  width: 100%;\n  border-radius: 4px; }\n  .btn.btn-form-control span, .icon-nav label.btn-form-control span {\n    float: left; }\n  .btn.btn-form-control span.caret, .icon-nav label.btn-form-control span.caret {\n    float: right;\n    margin-top: 8px; }\n\n.drop-down-menu-full-width {\n  width: 100%; }\n  .drop-down-menu-full-width li {\n    text-align: left; }\n\n.no-js-backdrop {\n  background-color: #FFFFFF;\n  height: 100%;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 100000;\n  position: absolute; }\n  .no-js-backdrop .no-js-message {\n    margin: 20px 0; }\n\n.pointer {\n  cursor: pointer; }\n\n.page-banner {\n  margin-bottom: 0px; }\n\n.alert-default {\n  background-color: #f4f4f4;\n  border: 1px solid #CCC; }\n\n.img-preloader {\n  width: 94% !important;\n  height: 332px !important;\n  background-color: #DDD;\n  background: url(\"../img/loader.gif\") no-repeat center center; }\n\n.item-description {\n  margin-top: 22px; }\n\n.store-icon,\n.icon-medium {\n  width: 50px;\n  height: 50px;\n  overflow: hidden;\n  border-radius: 10px;\n  background: #555; }\n  .store-icon img,\n  .icon-medium img {\n    width: 100%; }\n\n.checkout-icon {\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  border-radius: 10px;\n  float: left; }\n  .checkout-icon img {\n    width: 100%; }\n\n.store-block {\n  border-bottom: 1px solid #e6e6e6;\n  padding: 0 15px;\n  margin: 0 -15px 20px; }\n  .store-block .store-icon {\n    float: left;\n    margin-right: 10px; }\n  .store-block .description {\n    margin-top: 5px; }\n    .store-block .description p {\n      margin: 0;\n      line-height: 20px;\n      display: block; }\n      @media (max-width: 768px) {\n        .store-block .description p {\n          text-overflow: ellipsis;\n          width: 180px;\n          overflow: hidden; } }\n\n.modal-header .store-block {\n  margin: 0 0 10px;\n  border-bottom: 0;\n  height: 40px; }\n  .modal-header .store-block .store-icon {\n    height: 40px;\n    width: 40px; }\n  .modal-header .store-block .description {\n    margin: 0; }\n    @media (max-width: 480px) {\n      .modal-header .store-block .description p {\n        text-overflow: ellipsis;\n        width: 100px;\n        white-space: nowrap;\n        overflow: hidden; } }\n\n.tax-notice {\n  font-size: 11px; }\n\n.table-2 .store-block {\n  margin-top: 0;\n  border: none; }\n  .table-2 .store-block .store-icon {\n    width: 40px;\n    height: 40px; }\n\n.text-green {\n  color: #4AB767; }\n\n.text-error {\n  color: #cf371f; }\n\n.help-links {\n  line-height: 20px; }\n  .help-links span,\n  .help-links a {\n    display: inline-block; }\n  @media (max-width: 768px) {\n    .help-links {\n      display: block;\n      float: none !important;\n      width: 100%;\n      text-align: left;\n      line-height: normal;\n      margin-bottom: 10px; } }\n\n.cards-wrap {\n  display: table;\n  width: 100%;\n  border-collapse: separate; }\n  .cards-wrap .card {\n    vertical-align: top;\n    display: table-cell;\n    width: 50%; }\n    .cards-wrap .card.card-price {\n      width: 31%; }\n  .cards-wrap .divider {\n    width: 1%;\n    display: table-cell; }\n  @media (max-width: 768px) {\n    .cards-wrap {\n      display: block; }\n      .cards-wrap .card {\n        display: block;\n        width: auto; }\n        .cards-wrap .card.card-price {\n          width: auto; }\n      .cards-wrap .divider {\n        display: none; } }\n\n.card {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.23); }\n  .card .card-body {\n    padding: 15px; }\n  .card .card-footer {\n    padding: 0 15px 15px; }\n\n.card-price h3 {\n  margin: 0 0 10px;\n  font-weight: 500; }\n\n.card-price p {\n  color: #777; }\n\n.callout {\n  padding: 15px;\n  border-radius: 3px;\n  width: 100%;\n  z-index: 8000;\n  position: absolute;\n  left: 0;\n  color: #444;\n  opacity: .9;\n  -webkit-box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75);\n  box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.75); }\n  .callout.callout-green {\n    background: #e3f7e8;\n    border: 1px solid #47b767; }\n    .callout.callout-green .arrow:before {\n      border-bottom: 10px solid #e3f7e8; }\n    .callout.callout-green .arrow:after {\n      border-bottom: 12px solid #47b767; }\n  .callout.callout-red {\n    background: #ffece8;\n    border: 1px solid red; }\n    .callout.callout-red .arrow:before {\n      border-bottom: 10px solid #ffece8; }\n    .callout.callout-red .arrow:after {\n      border-bottom: 12px solid #cf371f; }\n  .callout .arrow {\n    width: 40px;\n    position: absolute;\n    display: block;\n    top: 0; }\n  .callout .arrow:before {\n    position: absolute;\n    top: -10px;\n    right: 10px;\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    z-index: 2; }\n  .callout .arrow:after {\n    position: absolute;\n    top: -12px;\n    right: 8px;\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 12px solid transparent;\n    border-right: 12px solid transparent;\n    z-index: 1; }\n\n.callout-green {\n  color: #47b767;\n  font-weight: bold;\n  max-width: 280px;\n  text-align: center;\n  font-size: 24px;\n  right: 0;\n  left: auto; }\n\n.checkout-logos {\n  height: 75px;\n  text-align: left; }\n  .checkout-logos .stripe img {\n    height: 26px;\n    margin-top: 3px; }\n  .checkout-logos .seals img {\n    height: 70px; }\n  @media (max-width: 320px) {\n    .checkout-logos .seals img {\n      height: 50px; }\n    .checkout-logos .stripe img {\n      height: 18px; } }\n\n.table-checkout tbody > tr > td {\n  margin-right: 0; }\n  .table-checkout tbody > tr > td.checkout-detail {\n    font-weight: bold; }\n  .table-checkout tbody > tr > td.checkout-item {\n    color: #555; }\n  .table-checkout tbody > tr > td.checkout-qty input {\n    width: 33px;\n    padding: 0;\n    text-align: center;\n    display: inline-block; }\n  .table-checkout tbody > tr > td.checkout-qty button {\n    padding: 0;\n    font-size: 12px; }\n  .table-checkout tbody > tr > td.checkout-coupon label {\n    padding-right: 10px; }\n  .table-checkout tbody > tr > td.checkout-coupon .form-group {\n    margin: 0; }\n  .table-checkout tbody > tr > td.checkout-coupon input {\n    width: 165px;\n    display: inline-block; }\n  .table-checkout tbody > tr > td.checkout-coupon button {\n    width: 70px; }\n  .table-checkout tbody > tr > td .control-label {\n    color: #777; }\n\n@media (max-width: 768px) {\n  .table-checkout tbody tr > td {\n    font-size: 13px; }\n    .table-checkout tbody tr > td:before {\n      content: attr(data-td) \" \";\n      font-weight: bold; }\n    .table-checkout tbody tr > td.checkout-item {\n      width: 70%; }\n      .table-checkout tbody tr > td.checkout-item p {\n        width: 120px;\n        overflow: hidden;\n        white-space: nowrap; }\n    .table-checkout tbody tr > td.checkout-qty {\n      width: 30%;\n      text-align: right;\n      padding-left: 0; }\n    .table-checkout tbody tr > td.checkout-total {\n      text-align: right;\n      width: 30%;\n      float: right; }\n    .table-checkout tbody tr > td.checkout-value {\n      text-align: right;\n      width: 30%; }\n    .table-checkout tbody tr > td.checkout-detail {\n      text-align: right;\n      width: 70%;\n      font-weight: bold; }\n    .table-checkout tbody tr > td.checkout-plan {\n      width: 50%;\n      text-align: right; }\n    .table-checkout tbody tr > td.checkout-price {\n      width: 20%; }\n    .table-checkout tbody tr > td.checkout-coupon {\n      display: block; }\n      .table-checkout tbody tr > td.checkout-coupon .form-group {\n        margin-bottom: 5px; }\n      .table-checkout tbody tr > td.checkout-coupon input {\n        display: inline-block;\n        float: left;\n        width: 70%; }\n      .table-checkout tbody tr > td.checkout-coupon button {\n        display: inline-block; }\n      .table-checkout tbody tr > td.checkout-coupon label {\n        display: block;\n        margin: 0;\n        text-align: left; } }\n  @media (max-width: 768px) and (max-width: 320px) {\n    .table-checkout tbody tr > td.checkout-item {\n      width: 80%;\n      padding-right: 0; }\n      .table-checkout tbody tr > td.checkout-item p {\n        width: 100px;\n        overflow: hidden;\n        white-space: nowrap; }\n    .table-checkout tbody tr > td.checkout-qty {\n      width: 20%; }\n      .table-checkout tbody tr > td.checkout-qty button {\n        width: 32px; }\n    .table-checkout tbody tr > td.checkout-coupon button {\n      width: 60px; } }\n\n.product-graphic {\n  width: 96px;\n  height: 96px;\n  margin: 30px auto 0; }\n\n.product-intro {\n  text-align: center;\n  max-width: 600px;\n  margin: 30px auto 30px; }\n  .product-intro h1 {\n    font-weight: 500;\n    margin-bottom: 15px; }\n  .product-intro strong {\n    font-weight: 500; }\n  .product-intro .lead, .product-intro .post h2 + p, .post .product-intro h2 + p {\n    font-size: 18px;\n    margin-bottom: 8px; }\n  .product-intro .text-muted {\n    margin-top: 30px; }\n  .product-intro .btn, .product-intro .icon-nav label, .icon-nav .product-intro label {\n    margin-top: 30px; }\n\n.storage-modal .product-graphic {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto; }\n\n.storage-modal .product-intro {\n  margin: 0 auto; }\n\n.storage-modal .text-muted {\n  margin-top: 5px; }\n\n.modal-dialog {\n  max-width: 1140px;\n  margin: 10px auto; }\n\n.modal-content {\n  margin: 0 10px; }\n\n.table-2 .store-block {\n  margin-bottom: 0; }\n\n.table-2 .description {\n  margin-top: 0; }\n\n.total-row {\n  padding: 10px;\n  border-bottom: 1px solid #e6e6e6;\n  text-align: right; }\n  .total-row.rowEnter {\n    padding: 0 10px;\n    opacity: 0;\n    height: 0;\n    background: #cf371f; }\n  .total-row .total {\n    width: 200px;\n    margin-right: 10px;\n    display: inline-block; }\n  .total-row .total-value {\n    display: inline-block;\n    width: 100px; }\n\n.couponEntry {\n  margin: 0 10px; }\n  .couponEntry .alert, .couponEntry .support-app .support-time, .support-app .couponEntry .support-time {\n    margin-bottom: 10px;\n    padding: 5px 15px;\n    text-align: center; }\n    .couponEntry .alert span, .couponEntry .support-app .support-time span, .support-app .couponEntry .support-time span {\n      display: inline; }\n  .couponEntry input {\n    display: inline-block;\n    width: 150px; }\n\n.couponStart .col-md-12 {\n  text-align: right; }\n\n.page-header.blog-header {\n  padding-top: 48px; }\n\n.article {\n  margin-bottom: 48px; }\n  .article .headline {\n    margin-top: 16px;\n    margin-bottom: 8px; }\n    .article .headline a {\n      color: #4d4d4d; }\n  .article .metadata {\n    margin-bottom: 32px; }\n  .article .read-time {\n    float: right; }\n  .article .article-label {\n    margin-top: 0;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 32px;\n    background-color: #5cbe76;\n    color: #FFF;\n    padding: 0 10px;\n    display: inline-block; }\n  .article .article-content p {\n    line-height: 1.9; }\n  .article .article-content img {\n    max-width: 100%;\n    height: auto;\n    margin: 32px 0; }\n  .article .image {\n    max-height: 300px;\n    border-radius: 6px 6px 6px 0;\n    margin-top: 16px;\n    overflow: hidden; }\n    .article .image img {\n      width: 100%; }\n  .article .comment-count {\n    display: block;\n    line-height: 34px; }\n  .article .blog-footer {\n    overflow: hidden;\n    margin-top: 32px; }\n  .article .blog-icons {\n    border: 1px solid #CCC;\n    display: block;\n    border-radius: 20px;\n    padding: 0 10px; }\n    .article .blog-icons .btn, .article .blog-icons .icon-nav label, .icon-nav .article .blog-icons label {\n      font-size: 16px;\n      padding: 4px;\n      opacity: 0.7; }\n      .article .blog-icons .btn:hover, .article .blog-icons .icon-nav label:hover, .icon-nav .article .blog-icons label:hover {\n        opacity: 1; }\n      .article .blog-icons .btn span, .article .blog-icons .icon-nav label span, .icon-nav .article .blog-icons label span {\n        margin: 0 10px; }\n      .article .blog-icons .btn .fa, .article .blog-icons .icon-nav label .fa, .icon-nav .article .blog-icons label .fa {\n        width: 20px; }\n  .article .tags li {\n    display: inline-block;\n    vertical-align: top; }\n    .article .tags li a {\n      color: #555;\n      background-color: #e6e6e6;\n      padding: 2px 8px;\n      font-size: 13px;\n      border-radius: 10px; }\n\n.blog-sidebar {\n  -webkit-transition: all 0.1s;\n  /* Safari 3.1 to 6.0 */\n  transition: all 0.1s; }\n  .blog-sidebar .content-box, .blog-sidebar .select-subcompany-modal .list-group, .select-subcompany-modal .blog-sidebar .list-group, .blog-sidebar .content-box-editable, .blog-sidebar .card, .blog-sidebar #appLauncherContainer .scrollable-list, #appLauncherContainer .blog-sidebar .scrollable-list, .blog-sidebar #appLauncherContainer .template-grid, #appLauncherContainer .blog-sidebar .template-grid {\n    padding: 32px; }\n\n.subscribed-thanks {\n  font-weight: 600;\n  -webkit-animation-delay: .75s;\n  animation-delay: .75s; }\n\n.header-search {\n  max-width: 200px; }\n\n.playlist-item-reference {\n  max-width: 320px;\n  line-height: 24px; }\n\n#appLauncherContainer h3 {\n  margin-top: 0;\n  line-height: 30px;\n  display: block; }\n  #appLauncherContainer h3 a {\n    color: #444; }\n    #appLauncherContainer h3 a:hover {\n      color: #0081BA; }\n\n#appLauncherContainer .scrollable-list, #appLauncherContainer .template-grid {\n  padding: 0;\n  height: auto; }\n\n#appLauncherContainer .list {\n  height: calc(100vh - 290px);\n  margin-top: 1px; }\n  #appLauncherContainer .list.help-active {\n    height: calc(100vh - 977px); }\n  @media (max-width: 768px) {\n    #appLauncherContainer .list {\n      height: auto; } }\n  #appLauncherContainer .list .list-item {\n    border-bottom: 1px solid #f2f2f2;\n    padding: 4px 12px; }\n    #appLauncherContainer .list .list-item h4 {\n      font-weight: 500;\n      font-size: 14px;\n      color: #555;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      width: 260px; }\n      @media (max-width: 992px) {\n        #appLauncherContainer .list .list-item h4 {\n          width: 180px; } }\n    #appLauncherContainer .list .list-item:last-child {\n      border-bottom: none; }\n    #appLauncherContainer .list .list-item:hover h4 {\n      color: #0081BA; }\n\n.launcher-background {\n  position: absolute;\n  z-index: 40;\n  top: 0;\n  left: 0;\n  background: #FFF;\n  border-bottom: 1px solid #e4e4e4;\n  height: 400px;\n  width: 100%;\n  background-size: cover; }\n\n.video-box {\n  border: 1px solid #e6e6e6;\n  background: #FFF;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.13); }\n  .video-box > img:first-child {\n    width: 100%; }\n\n.create-presentation-cta {\n  position: relative;\n  z-index: 100;\n  margin-top: 48px;\n  margin-bottom: 40px;\n  padding: 76px 40px;\n  background: #FFF;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.13); }\n  .create-presentation-cta h1 {\n    font-size: 42px;\n    margin-top: 0; }\n  .create-presentation-cta h3 {\n    font-weight: 300;\n    margin-bottom: 16px 0 32px; }\n    .create-presentation-cta h3 span {\n      font-weight: 500; }\n  .create-presentation-cta img {\n    max-width: 700px;\n    margin: 0 auto;\n    width: 100%; }\n  .create-presentation-cta .btn, .create-presentation-cta .icon-nav label, .icon-nav .create-presentation-cta label {\n    font-size: 24px;\n    font-weight: 300; }\n\n.priority-trial-cta {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 999;\n  border-radius: 4px 0 0 0;\n  background-color: #dcf1e2;\n  color: #2c6f3e; }\n  .priority-trial-cta .content-box-body {\n    padding: 18px; }\n  .priority-trial-cta h3 {\n    margin-top: 0;\n    margin-bottom: 4px;\n    margin-left: 120px; }\n  .priority-trial-cta p {\n    font-size: 16px;\n    margin-bottom: 16px;\n    margin-left: 120px; }\n  .priority-trial-cta img {\n    width: 90px;\n    padding: 16px 10px 10px 10px; }\n  .priority-trial-cta .btn, .priority-trial-cta .icon-nav label, .icon-nav .priority-trial-cta label {\n    display: block;\n    margin-left: 120px; }\n\n#helpDropdownButton.add-notice {\n  -webkit-animation-iteration-count: 3;\n  animation-iteration-count: 3;\n  -webkit-animation-name: pulse;\n  animation-name: pulse;\n  -webkit-animation-delay: 1s;\n  animation-delay: 1s; }\n\n.apps-launcher {\n  text-align: center;\n  font-size: 18px; }\n  .apps-launcher .apps-launcher-tour {\n    padding: 64px 32px; }\n    .apps-launcher .apps-launcher-tour .content-box, .apps-launcher .apps-launcher-tour .select-subcompany-modal .list-group, .select-subcompany-modal .apps-launcher .apps-launcher-tour .list-group, .apps-launcher .apps-launcher-tour .content-box-editable, .apps-launcher .apps-launcher-tour .card, .apps-launcher .apps-launcher-tour #appLauncherContainer .scrollable-list, #appLauncherContainer .apps-launcher .apps-launcher-tour .scrollable-list, .apps-launcher .apps-launcher-tour #appLauncherContainer .template-grid, #appLauncherContainer .apps-launcher .apps-launcher-tour .template-grid {\n      overflow: hidden;\n      margin: 2px;\n      -webkit-box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1);\n      -moz-box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1);\n      box-shadow: 0 1px 4px rgba(50, 50, 50, 0.1); }\n    .apps-launcher .apps-launcher-tour .headline h2 {\n      font-weight: 300;\n      font-size: 36px; }\n    .apps-launcher .apps-launcher-tour .image {\n      background: #E9FFED;\n      padding: 16px 48px; }\n      .apps-launcher .apps-launcher-tour .image img {\n        margin: 0 auto; }\n\n.app-launcher {\n  line-height: 1.6; }\n\n.app-launcher-header {\n  padding: 48px 0; }\n  .app-launcher-header h1 {\n    margin: 0; }\n\n.app-launcher-block {\n  padding: 0; }\n  .app-launcher-block .btn-primary {\n    width: 200px; }\n  .app-launcher-block .app-launcher-block-header h2 {\n    display: inline-block;\n    margin-right: 10px;\n    margin-top: 8px; }\n\n.template-filters {\n  text-align: center;\n  padding: 10px 0; }\n  .template-filters ul > li {\n    display: inline-block; }\n    .template-filters ul > li span {\n      padding: 4px 10px;\n      display: block;\n      color: #666;\n      cursor: pointer;\n      border-radius: 3px;\n      text-transform: uppercase;\n      font-size: 13px; }\n      .template-filters ul > li span:hover {\n        color: #0081BA; }\n    .template-filters ul > li.active span {\n      font-weight: 800;\n      background: #e6e6e6; }\n    .template-filters ul > li.more-templates span {\n      font-weight: 800; }\n\n.app-launcher-login {\n  padding-top: 64px;\n  background: url(\"https://s3.amazonaws.com/Rise-Images/UI/triangles.svg\");\n  background-size: cover;\n  height: 100vh; }\n  .app-launcher-login h1 {\n    margin-top: 0; }\n  .app-launcher-login .content-box, .app-launcher-login .select-subcompany-modal .list-group, .select-subcompany-modal .app-launcher-login .list-group, .app-launcher-login .content-box-editable, .app-launcher-login .card, .app-launcher-login #appLauncherContainer .scrollable-list, #appLauncherContainer .app-launcher-login .scrollable-list, .app-launcher-login #appLauncherContainer .template-grid, #appLauncherContainer .app-launcher-login .template-grid {\n    padding: 32px; }\n  .app-launcher-login .rise-logo {\n    text-align: center;\n    border-right: 1px solid #CCC;\n    padding: 110px 0; }\n    .app-launcher-login .rise-logo img {\n      width: 150px; }\n    @media (max-width: 768px) {\n      .app-launcher-login .rise-logo {\n        border-right: none;\n        text-align: left;\n        padding: 0; }\n        .app-launcher-login .rise-logo img {\n          width: 100px; } }\n\n.post {\n  line-height: 1.6;\n  padding-bottom: 120px;\n  font-size: 15px; }\n  .post .post-title {\n    margin-bottom: 32px;\n    margin-top: 0;\n    font-weight: 300;\n    font-size: 44px; }\n  .post p {\n    margin-bottom: 16px; }\n    .post p + h3 {\n      margin-top: 32px; }\n  .post h2 + p {\n    padding-bottom: 24px;\n    border-bottom: 1px solid #f2f2f2; }\n  .post h4 {\n    margin-bottom: 8px;\n    font-size: 15px;\n    font-weight: 800;\n    color: #333; }\n\n.entries p:first-child {\n  padding: 10px;\n  border-radius: 4px; }\n\n.entries article {\n  padding: 0; }\n\n.entries a {\n  display: block;\n  padding: 8px;\n  border-bottom: 1px solid #d4d4d4; }\n  .entries a:hover {\n    background: #f5f5f5; }\n    .entries a:hover h4 {\n      color: #0081BA; }\n  .entries a h4 {\n    color: #555; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
